/* tslint:disable */
/* eslint-disable */
/**
 * DimensionX Game API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AbstractSpawner
 */
export interface AbstractSpawner {
    /**
     * 
     * @type {string}
     * @memberof AbstractSpawner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AbstractSpawner
     */
    'position': string | null;
    /**
     * 
     * @type {number}
     * @memberof AbstractSpawner
     */
    'dimension': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AbstractSpawner
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof AbstractSpawner
     */
    'campaign': string;
}
/**
 * 
 * @export
 * @interface ActionCycle
 */
export interface ActionCycle {
    /**
     * 
     * @type {number}
     * @memberof ActionCycle
     */
    'id': number;
    /**
     * Cycle number in the campaign
     * @type {number}
     * @memberof ActionCycle
     */
    'number': number;
    /**
     * 
     * @type {string}
     * @memberof ActionCycle
     */
    'campaign': string;
}
/**
 * 
 * @export
 * @interface ActionLogDiceRollResult
 */
export interface ActionLogDiceRollResult {
    /**
     * 
     * @type {number}
     * @memberof ActionLogDiceRollResult
     */
    'dice_side': number;
    /**
     * 
     * @type {OutcomeEnum}
     * @memberof ActionLogDiceRollResult
     */
    'outcome': OutcomeEnum;
}


/**
 * Trimmed skill payload for action-log entries (no description).
 * @export
 * @interface ActionLogSkill
 */
export interface ActionLogSkill {
    /**
     * 
     * @type {number}
     * @memberof ActionLogSkill
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ActionLogSkill
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ActionLogSkill
     */
    'grade'?: number;
    /**
     * 
     * @type {SkillTypeEnum}
     * @memberof ActionLogSkill
     */
    'type'?: SkillTypeEnum;
    /**
     * 
     * @type {UseEnum}
     * @memberof ActionLogSkill
     */
    'use'?: UseEnum;
    /**
     * A list of Impact objects describing what the skill does.
     * @type {any}
     * @memberof ActionLogSkill
     */
    'impact'?: any;
    /**
     * A list of Cost objects describing what the skill costs to use.
     * @type {any}
     * @memberof ActionLogSkill
     */
    'cost'?: any;
    /**
     * A list of AssignableEffect objects the skill can inflict.
     * @type {any}
     * @memberof ActionLogSkill
     */
    'effect'?: any;
    /**
     * Special type of the skill  * `ACTION` - ACTION * `TELEPORT` - TELEPORT * `TELEPORT_TO_CHARACTER` - TELEPORT_TO_CHARACTER * `TELEPORT_TO_SAFE_ZONE` - TELEPORT_TO_SAFE_ZONE * `RESET_STATS` - RESET_STATS * `FLOW_ACCUMULATION` - FLOW_ACCUMULATION
     * @type {SpecialEnum}
     * @memberof ActionLogSkill
     */
    'special'?: SpecialEnum;
    /**
     * 
     * @type {string}
     * @memberof ActionLogSkill
     */
    'icon'?: string | null;
    /**
     * If true, the skill will be performed immediately
     * @type {boolean}
     * @memberof ActionLogSkill
     */
    'immediate'?: boolean;
    /**
     * Minimum range in cells from caster to target
     * @type {number}
     * @memberof ActionLogSkill
     */
    'min_range'?: number;
    /**
     * Maximum range in cells from caster to target
     * @type {number}
     * @memberof ActionLogSkill
     */
    'max_range'?: number;
    /**
     * Spray pattern configuration: spray (2D matrix), passthrough (bool), shadow (bool), multidimensional (bool), rotatable (bool)
     * @type {any}
     * @memberof ActionLogSkill
     */
    'spray_config'?: any;
    /**
     * Number of charges (independent spray pattern applications) per use
     * @type {number}
     * @memberof ActionLogSkill
     */
    'charge_count'?: number;
    /**
     * 
     * @type {any}
     * @memberof ActionLogSkill
     */
    'allowed_phases'?: any;
    /**
     * 
     * @type {string}
     * @memberof ActionLogSkill
     */
    'school'?: string | null;
}


/**
 * Either the link\'s token, or the pair a human can type.
 * @export
 * @interface ActivationConfirmRequest
 */
export interface ActivationConfirmRequest {
    /**
     * 
     * @type {string}
     * @memberof ActivationConfirmRequest
     */
    'token'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivationConfirmRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivationConfirmRequest
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface ActivationMessage
 */
export interface ActivationMessage {
    /**
     * 
     * @type {string}
     * @memberof ActivationMessage
     */
    'detail': string;
}
/**
 * 
 * @export
 * @interface ActivationResendRequest
 */
export interface ActivationResendRequest {
    /**
     * 
     * @type {string}
     * @memberof ActivationResendRequest
     */
    'email': string;
}
/**
 * The activation doubles as a login, so it answers with a token pair.
 * @export
 * @interface ActivationResult
 */
export interface ActivationResult {
    /**
     * 
     * @type {string}
     * @memberof ActivationResult
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof ActivationResult
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ActivationResult
     */
    'access': string;
    /**
     * 
     * @type {string}
     * @memberof ActivationResult
     */
    'refresh': string;
}
/**
 * 
 * @export
 * @interface ActiveEffect
 */
export interface ActiveEffect {
    /**
     * 
     * @type {string}
     * @memberof ActiveEffect
     */
    'id': string;
    /**
     * 
     * @type {Effect}
     * @memberof ActiveEffect
     */
    'effect': Effect;
    /**
     * 
     * @type {number}
     * @memberof ActiveEffect
     */
    'cycle_left': number;
    /**
     * 
     * @type {number}
     * @memberof ActiveEffect
     */
    'ends_in'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ActiveEffect
     */
    'duration'?: number;
    /**
     * 
     * @type {any}
     * @memberof ActiveEffect
     */
    'impact'?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof ActiveEffect
     */
    'active'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ActiveEffect
     */
    '_data'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ActiveEffect
     */
    'target': string;
}
/**
 * 
 * @export
 * @interface ActiveShield
 */
export interface ActiveShield {
    /**
     * 
     * @type {string}
     * @memberof ActiveShield
     */
    'id': string;
    /**
     * 
     * @type {Shield}
     * @memberof ActiveShield
     */
    'shield': Shield;
    /**
     * 
     * @type {number}
     * @memberof ActiveShield
     */
    'level': number;
    /**
     * 
     * @type {number}
     * @memberof ActiveShield
     */
    'efficiency': number;
    /**
     * 
     * @type {number}
     * @memberof ActiveShield
     */
    'cycles_left'?: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveShield
     */
    'health'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActiveShield
     */
    'target': string;
}
/**
 * * `establishment` - establishment * `preparation` - preparation * `action` - action
 * @export
 * @enum {string}
 */

export const AllowedPhasesEnum = {
    Establishment: 'establishment',
    Preparation: 'preparation',
    Action: 'action'
} as const;

export type AllowedPhasesEnum = typeof AllowedPhasesEnum[keyof typeof AllowedPhasesEnum];


/**
 * Request serializer for skill progression analysis.  Analyzes how a skill\'s impacts scale as a primary stat increases from 0 to max_value, with three baseline scenarios (minimum/median/maximum) for other stats.
 * @export
 * @interface AnalyzeProgressionRequestRequest
 */
export interface AnalyzeProgressionRequestRequest {
    /**
     * The skill ID to analyze
     * @type {number}
     * @memberof AnalyzeProgressionRequestRequest
     */
    'skill_id': number;
    /**
     * The stat to vary across the range (e.g., \'Flow Manipulation\')  * `Physical Strength` - Physical Strength * `Mental Strength` - Mental Strength * `Flow Resonance` - Flow Resonance * `Concentration` - Concentration * `Flow Manipulation` - Flow Manipulation * `Flow Connection` - Flow Connection * `Knowledge` - Knowledge * `Speed` - Speed * `Luck` - Luck * `Charisma` - Charisma
     * @type {CharacterStatEnum}
     * @memberof AnalyzeProgressionRequestRequest
     */
    'primary_stat': CharacterStatEnum;
    /**
     * Minimum stat value for progression (default: 0)
     * @type {number}
     * @memberof AnalyzeProgressionRequestRequest
     */
    'min_value'?: number;
    /**
     * Maximum stat value for progression (default: 150)
     * @type {number}
     * @memberof AnalyzeProgressionRequestRequest
     */
    'max_value'?: number;
    /**
     * Step size for stat increments (default: 5)
     * @type {number}
     * @memberof AnalyzeProgressionRequestRequest
     */
    'step'?: number;
    /**
     * Baseline value for other stats in minimum curve (default: 10)
     * @type {number}
     * @memberof AnalyzeProgressionRequestRequest
     */
    'baseline_minimum'?: number;
    /**
     * Baseline value for other stats in median curve (default: 50)
     * @type {number}
     * @memberof AnalyzeProgressionRequestRequest
     */
    'baseline_median'?: number;
    /**
     * Baseline value for other stats in maximum curve (default: 100)
     * @type {number}
     * @memberof AnalyzeProgressionRequestRequest
     */
    'baseline_maximum'?: number;
}


/**
 * Response serializer for skill progression analysis.  Returns skill information and progression data points showing how impacts scale across the stat range with three baseline curves.
 * @export
 * @interface AnalyzeProgressionResponse
 */
export interface AnalyzeProgressionResponse {
    /**
     * Basic information about the analyzed skill
     * @type {SkillInfo}
     * @memberof AnalyzeProgressionResponse
     */
    'skill': SkillInfo;
    /**
     * The stat that was varied in the analysis
     * @type {string}
     * @memberof AnalyzeProgressionResponse
     */
    'primary_stat': string;
    /**
     * Array of data points showing impact progression across stat range
     * @type {Array<ProgressionDataPoint>}
     * @memberof AnalyzeProgressionResponse
     */
    'progression': Array<ProgressionDataPoint>;
}
/**
 * One archetype across its whole climb.
 * @export
 * @interface ArchetypeProfile
 */
export interface ArchetypeProfile {
    /**
     * 
     * @type {ArchetypeSummary}
     * @memberof ArchetypeProfile
     */
    'archetype': ArchetypeSummary;
    /**
     * 
     * @type {Array<GradeProfile>}
     * @memberof ArchetypeProfile
     */
    'grades': Array<GradeProfile>;
}
/**
 * Archetype count by role.
 * @export
 * @interface ArchetypeRoles
 */
export interface ArchetypeRoles {
    /**
     * 
     * @type {Array<RoleDistribution>}
     * @memberof ArchetypeRoles
     */
    'roles': Array<RoleDistribution>;
    /**
     * 
     * @type {number}
     * @memberof ArchetypeRoles
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface ArchetypeSummary
 */
export interface ArchetypeSummary {
    /**
     * 
     * @type {string}
     * @memberof ArchetypeSummary
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ArchetypeSummary
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ArchetypeSummary
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ArchetypeSummary
     */
    'icon': string | null;
    /**
     * 
     * @type {string}
     * @memberof ArchetypeSummary
     */
    'path': string | null;
    /**
     * 
     * @type {MetatypeEnum}
     * @memberof ArchetypeSummary
     */
    'metatype': MetatypeEnum;
    /**
     * 
     * @type {Role266Enum}
     * @memberof ArchetypeSummary
     */
    'role': Role266Enum;
    /**
     * 
     * @type {RunnerUpEnum}
     * @memberof ArchetypeSummary
     */
    'runner_up': RunnerUpEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArchetypeSummary
     */
    'is_hybrid': boolean;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ArchetypeSummary
     */
    'weights': { [key: string]: number; };
    /**
     * 
     * @type {Array<SchoolSlot>}
     * @memberof ArchetypeSummary
     */
    'schools': Array<SchoolSlot>;
    /**
     * 
     * @type {number}
     * @memberof ArchetypeSummary
     */
    'starting_stats_total': number;
    /**
     * 
     * @type {number}
     * @memberof ArchetypeSummary
     */
    'peak_stats_total': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ArchetypeSummary
     */
    'warnings': Array<string>;
}


/**
 * 
 * @export
 * @interface Area
 */
export interface Area {
    /**
     * 
     * @type {string}
     * @memberof Area
     */
    'id': string;
    /**
     * 
     * @type {Array<SubLocation>}
     * @memberof Area
     */
    'sub_locations': Array<SubLocation>;
    /**
     * 
     * @type {string}
     * @memberof Area
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Area
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Area
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Area
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Area
     */
    'image'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Area
     */
    'area': number;
    /**
     * 
     * @type {boolean}
     * @memberof Area
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Area
     */
    'city': string;
    /**
     * Default battle map template for fights in this area
     * @type {string}
     * @memberof Area
     */
    'battle_map_template'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Area
     */
    'border_with'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Art
 */
export interface Art {
    /**
     * 
     * @type {string}
     * @memberof Art
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Art
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Art
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Art
     */
    'image': string;
}
/**
 * Serializer for AssignableEffect DTO.
 * @export
 * @interface AssignableEffect
 */
export interface AssignableEffect {
    /**
     * 
     * @type {EffectEnum}
     * @memberof AssignableEffect
     */
    'name': EffectEnum;
    /**
     * 
     * @type {Impact}
     * @memberof AssignableEffect
     */
    'impact'?: Impact | null;
    /**
     * 
     * @type {number}
     * @memberof AssignableEffect
     */
    'base_chance': number;
    /**
     * 
     * @type {Modifier}
     * @memberof AssignableEffect
     */
    'duration_modifier': Modifier;
    /**
     * 
     * @type {Array<Modifier>}
     * @memberof AssignableEffect
     */
    'stat_modifiers': Array<Modifier>;
}


/**
 * Serializer for assignable effects.
 * @export
 * @interface AssignableEffectRequest
 */
export interface AssignableEffectRequest {
    /**
     * 
     * @type {EffectEnum}
     * @memberof AssignableEffectRequest
     */
    'name': EffectEnum;
    /**
     * 
     * @type {ImpactRequest}
     * @memberof AssignableEffectRequest
     */
    'impact'?: ImpactRequest | null;
    /**
     * 
     * @type {number}
     * @memberof AssignableEffectRequest
     */
    'base_chance': number;
    /**
     * 
     * @type {ModifierRequest}
     * @memberof AssignableEffectRequest
     */
    'duration_modifier': ModifierRequest;
    /**
     * 
     * @type {Array<ModifierRequest>}
     * @memberof AssignableEffectRequest
     */
    'stat_modifiers'?: Array<ModifierRequest>;
}


/**
 * 
 * @export
 * @interface Attribute
 */
export interface Attribute {
    /**
     * 
     * @type {AttributesEnum}
     * @memberof Attribute
     */
    'name': AttributesEnum;
    /**
     * 
     * @type {number}
     * @memberof Attribute
     */
    'current': number;
    /**
     * 
     * @type {number}
     * @memberof Attribute
     */
    'max': number;
}


/**
 * * `Health` - Health * `Energy` - Energy * `Action Points` - Action Points
 * @export
 * @enum {string}
 */

export const AttributesEnum = {
    Health: 'Health',
    Energy: 'Energy',
    ActionPoints: 'Action Points'
} as const;

export type AttributesEnum = typeof AttributesEnum[keyof typeof AttributesEnum];


/**
 * 
 * @export
 * @interface AvatarPresetSchool
 */
export interface AvatarPresetSchool {
    /**
     * 
     * @type {string}
     * @memberof AvatarPresetSchool
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AvatarPresetSchool
     */
    'name': string;
}
/**
 * What the compared grade looks like across the whole roster.  The band is what makes a single row readable: a build with a ``turns_to_fall`` of two is only alarming once you know the roster median is five.
 * @export
 * @interface BalanceBand
 */
export interface BalanceBand {
    /**
     * 
     * @type {number}
     * @memberof BalanceBand
     */
    'grade': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof BalanceBand
     */
    'metatype_counts': { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof BalanceBand
     */
    'median_single_target_dpt': number;
    /**
     * 
     * @type {number}
     * @memberof BalanceBand
     */
    'median_turns_to_fall': number | null;
    /**
     * 
     * @type {number}
     * @memberof BalanceBand
     */
    'median_hp': number;
    /**
     * 
     * @type {number}
     * @memberof BalanceBand
     */
    'off_curve_skills': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof BalanceBand
     */
    'findings': Array<string>;
}
/**
 * Every dial the rating model turns, published so the page can show them.
 * @export
 * @interface BalanceModel
 */
export interface BalanceModel {
    /**
     * 
     * @type {Array<CoefficientDoc>}
     * @memberof BalanceModel
     */
    'coefficients': Array<CoefficientDoc>;
}
/**
 * One archetype at the compared grade — a row of the balance table.
 * @export
 * @interface BalanceRow
 */
export interface BalanceRow {
    /**
     * 
     * @type {ArchetypeSummary}
     * @memberof BalanceRow
     */
    'archetype': ArchetypeSummary;
    /**
     * 
     * @type {GradeProfile}
     * @memberof BalanceRow
     */
    'profile': GradeProfile;
}
/**
 * The workbench\'s main view: every archetype at one grade, plus the band.
 * @export
 * @interface BalanceTable
 */
export interface BalanceTable {
    /**
     * 
     * @type {BalanceBand}
     * @memberof BalanceTable
     */
    'band': BalanceBand;
    /**
     * 
     * @type {Array<BalanceRow>}
     * @memberof BalanceTable
     */
    'rows': Array<BalanceRow>;
}
/**
 * 
 * @export
 * @interface Bargain
 */
export interface Bargain {
    /**
     * 
     * @type {string}
     * @memberof Bargain
     */
    'id': string;
    /**
     * 
     * @type {Array<OfferedItem>}
     * @memberof Bargain
     */
    'side_a_offered_items': Array<OfferedItem>;
    /**
     * 
     * @type {Array<OfferedItem>}
     * @memberof Bargain
     */
    'side_b_offered_items': Array<OfferedItem>;
    /**
     * 
     * @type {boolean}
     * @memberof Bargain
     */
    'side_a_accepted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Bargain
     */
    'side_b_accepted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Bargain
     */
    'cancelled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Bargain
     */
    'completed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Bargain
     */
    'side_a'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Bargain
     */
    'side_b'?: string | null;
}
/**
 * Serializer for BaseSkill DTO.
 * @export
 * @interface BaseSkill
 */
export interface BaseSkill {
    /**
     * 
     * @type {string}
     * @memberof BaseSkill
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BaseSkill
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof BaseSkill
     */
    'school': string;
    /**
     * 
     * @type {SkillTypeEnum}
     * @memberof BaseSkill
     */
    'type': SkillTypeEnum;
    /**
     * 
     * @type {UseEnum}
     * @memberof BaseSkill
     */
    'use'?: UseEnum;
    /**
     * 
     * @type {number}
     * @memberof BaseSkill
     */
    'grade': number;
    /**
     * 
     * @type {Array<SkillCost>}
     * @memberof BaseSkill
     */
    'cost': Array<SkillCost>;
    /**
     * 
     * @type {Array<AssignableEffect>}
     * @memberof BaseSkill
     */
    'effect': Array<AssignableEffect>;
    /**
     * 
     * @type {Array<Impact>}
     * @memberof BaseSkill
     */
    'impact': Array<Impact>;
    /**
     * 
     * @type {Array<AllowedPhasesEnum>}
     * @memberof BaseSkill
     */
    'allowed_phases': Array<AllowedPhasesEnum>;
}


/**
 * * `Passive` - Passive * `Aggressive` - Aggressive * `Friendly` - Friendly
 * @export
 * @enum {string}
 */

export const BehaviorEnum = {
    Passive: 'Passive',
    Aggressive: 'Aggressive',
    Friendly: 'Friendly'
} as const;

export type BehaviorEnum = typeof BehaviorEnum[keyof typeof BehaviorEnum];


/**
 * 
 * @export
 * @interface Bio
 */
export interface Bio {
    /**
     * 
     * @type {number}
     * @memberof Bio
     */
    'age': number;
    /**
     * 
     * @type {GenderEnum}
     * @memberof Bio
     */
    'gender': GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof Bio
     */
    'appearance': string;
    /**
     * 
     * @type {string}
     * @memberof Bio
     */
    'background': string;
    /**
     * 
     * @type {string}
     * @memberof Bio
     */
    'avatar'?: string | null;
}


/**
 * 
 * @export
 * @interface BiographyPendingPortrait
 */
export interface BiographyPendingPortrait {
    /**
     * 
     * @type {string}
     * @memberof BiographyPendingPortrait
     */
    'id': string;
    /**
     * 
     * @type {PublicationStatusEnum}
     * @memberof BiographyPendingPortrait
     */
    'status': PublicationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BiographyPendingPortrait
     */
    'preview_url': string;
    /**
     * 
     * @type {string}
     * @memberof BiographyPendingPortrait
     */
    'submitted_at': string | null;
}


/**
 * 
 * @export
 * @interface BiographyPortraitRejection
 */
export interface BiographyPortraitRejection {
    /**
     * 
     * @type {string}
     * @memberof BiographyPortraitRejection
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BiographyPortraitRejection
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof BiographyPortraitRejection
     */
    'decided_at': string | null;
}
/**
 * 
 * @export
 * @interface BiographyPortraitState
 */
export interface BiographyPortraitState {
    /**
     * 
     * @type {boolean}
     * @memberof BiographyPortraitState
     */
    'is_default': boolean;
    /**
     * 
     * @type {BiographyPendingPortrait}
     * @memberof BiographyPortraitState
     */
    'pending_request': BiographyPendingPortrait | null;
    /**
     * 
     * @type {BiographyPortraitRejection}
     * @memberof BiographyPortraitState
     */
    'last_rejection': BiographyPortraitRejection | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BlankEnum = {
    Empty: ''
} as const;

export type BlankEnum = typeof BlankEnum[keyof typeof BlankEnum];


/**
 * Serializer for book artifacts with download URL.
 * @export
 * @interface BookArtifact
 */
export interface BookArtifact {
    /**
     * 
     * @type {string}
     * @memberof BookArtifact
     */
    'id': string;
    /**
     * File format name (e.g., \'PDF\', \'EPUB\', \'DOCX\', \'TXT\', \'MD\')
     * @type {string}
     * @memberof BookArtifact
     */
    'format_name': string;
    /**
     * Language code (e.g., \'en\', \'uk\')
     * @type {string}
     * @memberof BookArtifact
     */
    'language'?: string;
    /**
     * The actual file to download
     * @type {string}
     * @memberof BookArtifact
     */
    'file': string;
    /**
     * 
     * @type {string}
     * @memberof BookArtifact
     */
    'download_url': string;
    /**
     * File size in bytes (auto-calculated on save)
     * @type {number}
     * @memberof BookArtifact
     */
    'file_size'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BookArtifact
     */
    'file_size_display': string;
    /**
     * Display order for this format
     * @type {number}
     * @memberof BookArtifact
     */
    'order'?: number;
}
/**
 * Serializer for book detail view with nested artifacts.
 * @export
 * @interface BookDetail
 */
export interface BookDetail {
    /**
     * 
     * @type {string}
     * @memberof BookDetail
     */
    'id': string;
    /**
     * Book title (base English content)
     * @type {string}
     * @memberof BookDetail
     */
    'title': string;
    /**
     * Book description (base English content)
     * @type {string}
     * @memberof BookDetail
     */
    'description': string;
    /**
     * Key for frontend i18n translation lookup (e.g., \'travelers_path\')
     * @type {string}
     * @memberof BookDetail
     */
    'i18n_key': string;
    /**
     * Publication date of the book
     * @type {string}
     * @memberof BookDetail
     */
    'published_date'?: string | null;
    /**
     * Cover image for the book
     * @type {string}
     * @memberof BookDetail
     */
    'cover_image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookDetail
     */
    'cover_url': string;
    /**
     * List of tags/categories for the book
     * @type {any}
     * @memberof BookDetail
     */
    'tags'?: any;
    /**
     * 
     * @type {Array<BookArtifact>}
     * @memberof BookDetail
     */
    'artifacts': Array<BookArtifact>;
    /**
     * Display order (lower numbers appear first)
     * @type {number}
     * @memberof BookDetail
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof BookDetail
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookDetail
     */
    'updated_at': string;
}
/**
 * Serializer for book list view (grid display).
 * @export
 * @interface BookList
 */
export interface BookList {
    /**
     * 
     * @type {string}
     * @memberof BookList
     */
    'id': string;
    /**
     * Book title (base English content)
     * @type {string}
     * @memberof BookList
     */
    'title': string;
    /**
     * Book description (base English content)
     * @type {string}
     * @memberof BookList
     */
    'description': string;
    /**
     * Key for frontend i18n translation lookup (e.g., \'travelers_path\')
     * @type {string}
     * @memberof BookList
     */
    'i18n_key': string;
    /**
     * Publication date of the book
     * @type {string}
     * @memberof BookList
     */
    'published_date'?: string | null;
    /**
     * Cover image for the book
     * @type {string}
     * @memberof BookList
     */
    'cover_image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookList
     */
    'cover_url': string;
    /**
     * List of tags/categories for the book
     * @type {any}
     * @memberof BookList
     */
    'tags'?: any;
    /**
     * 
     * @type {string}
     * @memberof BookList
     */
    'artifact_count': string;
    /**
     * 
     * @type {Array<BookArtifact>}
     * @memberof BookList
     */
    'artifacts': Array<BookArtifact>;
    /**
     * Display order (lower numbers appear first)
     * @type {number}
     * @memberof BookList
     */
    'order'?: number;
}
/**
 * Request serializer for skill impact calculation simulation.  Accepts custom stat values, impact definitions, and optional effects to simulate skill impact calculations.
 * @export
 * @interface CalculateImpactRequestRequest
 */
export interface CalculateImpactRequestRequest {
    /**
     * List of stat values to use for calculations. Example: [{\"name\": \"Physical Strength\", \"value\": 50}, {\"name\": \"Flow Manipulation\", \"value\": 30}]
     * @type {Array<StatInputRequest>}
     * @memberof CalculateImpactRequestRequest
     */
    'stats': Array<StatInputRequest>;
    /**
     * List of impact definitions to calculate. Each impact includes kind, type, and formula.
     * @type {Array<ImpactRequest>}
     * @memberof CalculateImpactRequestRequest
     */
    'impacts': Array<ImpactRequest>;
    /**
     * Optional list of effects (for future enhancement)
     * @type {Array<AssignableEffectRequest>}
     * @memberof CalculateImpactRequestRequest
     */
    'effects'?: Array<AssignableEffectRequest>;
    /**
     * Whether to include detailed efficiency breakdown in the response
     * @type {boolean}
     * @memberof CalculateImpactRequestRequest
     */
    'include_breakdown'?: boolean;
}
/**
 * Response serializer for skill impact calculation simulation.  Returns calculated impacts with detailed breakdowns, totals, requirement checks, and any warnings.
 * @export
 * @interface CalculateImpactResponse
 */
export interface CalculateImpactResponse {
    /**
     * List of calculated impacts with detailed breakdowns
     * @type {Array<CalculatedImpactDetail>}
     * @memberof CalculateImpactResponse
     */
    'impacts': Array<CalculatedImpactDetail>;
    /**
     * Sum of all damage impacts
     * @type {number}
     * @memberof CalculateImpactResponse
     */
    'total_damage': number;
    /**
     * Sum of all healing impacts
     * @type {number}
     * @memberof CalculateImpactResponse
     */
    'total_healing': number;
    /**
     * Whether all stat requirements are met (character has at least required values)
     * @type {boolean}
     * @memberof CalculateImpactResponse
     */
    'requirements_met': boolean;
    /**
     * List of warnings or errors encountered during calculation
     * @type {Array<string>}
     * @memberof CalculateImpactResponse
     */
    'warnings': Array<string>;
}
/**
 * Serializer for a single calculated impact with detailed breakdown.  Includes the final calculated value, base value, and efficiency breakdown for each contributing stat.
 * @export
 * @interface CalculatedImpactDetail
 */
export interface CalculatedImpactDetail {
    /**
     * The type of impact (e.g., Damage, Heal, Shield)  * `None` - None * `Knock out` - Knock out * `Damage` - Damage * `Heal` - Heal * `Shield` - Shield * `Buff` - Buff * `Debuff` - Debuff * `Stun` - Stun * `Sleep` - Sleep * `Confusion` - Confusion * `Paralysis` - Paralysis * `Fear` - Fear * `Freeze` - Freeze * `Burn` - Burn * `Poison` - Poison * `Slow` - Slow * `Haste` - Haste * `Blind` - Blind * `Silence` - Silence * `Bleed` - Bleed * `Disarm` - Disarm * `Root` - Root * `Energy Decrease` - Energy Decrease * `Energy Drain` - Energy Drain * `Energy Gift` - Energy Gift * `Stat Drain` - Stat Drain * `Reflect` - Reflect * `Absorb` - Absorb * `Dodge` - Dodge * `Resist` - Resist * `Immunity` - Immunity * `Regeneration` - Regeneration * `Lifesteal` - Lifesteal * `Summon` - Summon
     * @type {ImpactTypeEnum}
     * @memberof CalculatedImpactDetail
     */
    'kind': ImpactTypeEnum;
    /**
     * The violation type (e.g., Physical, Heat, Cold, Mental)  * `Physical` - Physical * `Mental` - Mental * `Energy` - Energy * `Heat` - Heat * `Cold` - Cold * `Light` - Light * `Darkness` - Darkness * `None` - None
     * @type {ImpactViolationTypeEnum}
     * @memberof CalculatedImpactDetail
     */
    'violation': ImpactViolationTypeEnum;
    /**
     * The final calculated impact value (base * minimum efficiency)
     * @type {number}
     * @memberof CalculatedImpactDetail
     */
    'value': number;
    /**
     * The base value from the formula before efficiency scaling
     * @type {number}
     * @memberof CalculatedImpactDetail
     */
    'base_value': number;
    /**
     * Detailed breakdown of efficiency calculation for each required stat
     * @type {Array<EfficiencyBreakdown>}
     * @memberof CalculatedImpactDetail
     */
    'efficiency_breakdown': Array<EfficiencyBreakdown>;
}


/**
 * 
 * @export
 * @interface Campaign
 */
export interface Campaign {
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CampaignBasicsUpdate
 */
export interface CampaignBasicsUpdate {
    /**
     * 
     * @type {string}
     * @memberof CampaignBasicsUpdate
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignBasicsUpdate
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CampaignBasicsUpdateRequest
 */
export interface CampaignBasicsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignBasicsUpdateRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignBasicsUpdateRequest
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CampaignBuilderState
 */
export interface CampaignBuilderState {
    /**
     * 
     * @type {string}
     * @memberof CampaignBuilderState
     */
    'step': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CampaignBuilderState
     */
    'meta': { [key: string]: any; };
}
/**
 * * `campaign` - Campaign * `map` - Map * `npcs` - NPCs * `objectives` - Objectives * `summary` - Summary
 * @export
 * @enum {string}
 */

export const CampaignBuilderStepEnum = {
    Campaign: 'campaign',
    Map: 'map',
    Npcs: 'npcs',
    Objectives: 'objectives',
    Summary: 'summary'
} as const;

export type CampaignBuilderStepEnum = typeof CampaignBuilderStepEnum[keyof typeof CampaignBuilderStepEnum];


/**
 * 
 * @export
 * @interface CampaignCreate
 */
export interface CampaignCreate {
    /**
     * 
     * @type {string}
     * @memberof CampaignCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignCreate
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CampaignCreateRequest
 */
export interface CampaignCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignCreateRequest
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CampaignDetail
 */
export interface CampaignDetail {
    /**
     * 
     * @type {string}
     * @memberof CampaignDetail
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDetail
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDetail
     */
    'description': string;
    /**
     * 
     * @type {CampaignStatusEnum}
     * @memberof CampaignDetail
     */
    'status': CampaignStatusEnum;
    /**
     * Which builder screen this draft was last left on.  * `campaign` - Campaign * `map` - Map * `npcs` - NPCs * `objectives` - Objectives * `summary` - Summary
     * @type {CampaignBuilderStepEnum}
     * @memberof CampaignDetail
     */
    'builder_step': CampaignBuilderStepEnum;
    /**
     * Per-step completion flags for the builder pipeline.
     * @type {any}
     * @memberof CampaignDetail
     */
    'builder_meta': any;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignDetail
     */
    'is_active': boolean;
    /**
     * Indicates if this campaign is set for auto-play.
     * @type {boolean}
     * @memberof CampaignDetail
     */
    'auto_play'?: boolean;
    /**
     * Indicates if this is the default campaign for new clients.
     * @type {boolean}
     * @memberof CampaignDetail
     */
    'default'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CampaignDetail
     */
    'background_image': string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignDetail
     */
    'start_position': string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignDetail
     */
    'story': string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignDetail
     */
    'published_at': string | null;
    /**
     * 
     * @type {Array<ClientBrief>}
     * @memberof CampaignDetail
     */
    'masters': Array<ClientBrief>;
    /**
     * 
     * @type {Array<ClientBrief>}
     * @memberof CampaignDetail
     */
    'players': Array<ClientBrief>;
    /**
     * 
     * @type {string}
     * @memberof CampaignDetail
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDetail
     */
    'updated_at': string;
}


/**
 * 
 * @export
 * @interface CampaignDetailRequest
 */
export interface CampaignDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignDetailRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDetailRequest
     */
    'description': string;
    /**
     * Indicates if this campaign is set for auto-play.
     * @type {boolean}
     * @memberof CampaignDetailRequest
     */
    'auto_play'?: boolean;
    /**
     * Indicates if this is the default campaign for new clients.
     * @type {boolean}
     * @memberof CampaignDetailRequest
     */
    'default'?: boolean;
}
/**
 * 
 * @export
 * @interface CampaignList
 */
export interface CampaignList {
    /**
     * 
     * @type {string}
     * @memberof CampaignList
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignList
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignList
     */
    'description': string;
    /**
     * 
     * @type {CampaignStatusEnum}
     * @memberof CampaignList
     */
    'status': CampaignStatusEnum;
    /**
     * Which builder screen this draft was last left on.  * `campaign` - Campaign * `map` - Map * `npcs` - NPCs * `objectives` - Objectives * `summary` - Summary
     * @type {CampaignBuilderStepEnum}
     * @memberof CampaignList
     */
    'builder_step': CampaignBuilderStepEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignList
     */
    'is_active': boolean;
    /**
     * Indicates if this campaign is set for auto-play.
     * @type {boolean}
     * @memberof CampaignList
     */
    'auto_play': boolean;
    /**
     * 
     * @type {string}
     * @memberof CampaignList
     */
    'background_image': string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignList
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignList
     */
    'updated_at': string;
}


/**
 * 
 * @export
 * @interface CampaignMemberAddRequest
 */
export interface CampaignMemberAddRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignMemberAddRequest
     */
    'client_id': string;
    /**
     * 
     * @type {CampaignMemberAddRoleEnum}
     * @memberof CampaignMemberAddRequest
     */
    'role': CampaignMemberAddRoleEnum;
}


/**
 * * `master` - master * `player` - player
 * @export
 * @enum {string}
 */

export const CampaignMemberAddRoleEnum = {
    Master: 'master',
    Player: 'player'
} as const;

export type CampaignMemberAddRoleEnum = typeof CampaignMemberAddRoleEnum[keyof typeof CampaignMemberAddRoleEnum];


/**
 * 
 * @export
 * @interface CampaignNPC
 */
export interface CampaignNPC {
    /**
     * 
     * @type {string}
     * @memberof CampaignNPC
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignNPC
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignNPC
     */
    'npc': boolean;
    /**
     * 
     * @type {BehaviorEnum}
     * @memberof CampaignNPC
     */
    'behavior': BehaviorEnum;
    /**
     * 
     * @type {string}
     * @memberof CampaignNPC
     */
    'template': string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignNPC
     */
    'position': string | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignNPC
     */
    'dimension': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignNPC
     */
    'is_active': boolean;
}


/**
 * 
 * @export
 * @interface CampaignNPCPlaceRequest
 */
export interface CampaignNPCPlaceRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignNPCPlaceRequest
     */
    'position_id': string;
    /**
     * 
     * @type {number}
     * @memberof CampaignNPCPlaceRequest
     */
    'dimension_id'?: number | null;
}
/**
 * 
 * @export
 * @interface CampaignObjective
 */
export interface CampaignObjective {
    /**
     * 
     * @type {string}
     * @memberof CampaignObjective
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignObjective
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignObjective
     */
    'description': string;
    /**
     * Order of the quest within the chapter
     * @type {number}
     * @memberof CampaignObjective
     */
    'order': number;
    /**
     * 
     * @type {string}
     * @memberof CampaignObjective
     */
    'chapter': string;
}
/**
 * 
 * @export
 * @interface CampaignPositionCreateRequest
 */
export interface CampaignPositionCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignPositionCreateRequest
     */
    'sub_location_id': string;
    /**
     * 
     * @type {number}
     * @memberof CampaignPositionCreateRequest
     */
    'grid_x': number;
    /**
     * 
     * @type {number}
     * @memberof CampaignPositionCreateRequest
     */
    'grid_y': number;
    /**
     * 
     * @type {number}
     * @memberof CampaignPositionCreateRequest
     */
    'grid_z'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignPositionCreateRequest
     */
    'labels'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CampaignRequest
 */
export interface CampaignRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CampaignStartPositionRequest
 */
export interface CampaignStartPositionRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignStartPositionRequest
     */
    'position_id': string;
}
/**
 * * `draft` - Draft * `published` - Published
 * @export
 * @enum {string}
 */

export const CampaignStatusEnum = {
    Draft: 'draft',
    Published: 'published'
} as const;

export type CampaignStatusEnum = typeof CampaignStatusEnum[keyof typeof CampaignStatusEnum];


/**
 * 
 * @export
 * @interface CampaignSummary
 */
export interface CampaignSummary {
    /**
     * 
     * @type {string}
     * @memberof CampaignSummary
     */
    'campaign_id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignSummary
     */
    'name': string;
    /**
     * 
     * @type {CampaignStatusEnum}
     * @memberof CampaignSummary
     */
    'status': CampaignStatusEnum;
    /**
     * 
     * @type {CampaignBuilderStepEnum}
     * @memberof CampaignSummary
     */
    'builder_step': CampaignBuilderStepEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignSummary
     */
    'has_start_position': boolean;
    /**
     * 
     * @type {number}
     * @memberof CampaignSummary
     */
    'master_count': number;
    /**
     * 
     * @type {number}
     * @memberof CampaignSummary
     */
    'player_count': number;
    /**
     * 
     * @type {number}
     * @memberof CampaignSummary
     */
    'npc_count': number;
    /**
     * 
     * @type {number}
     * @memberof CampaignSummary
     */
    'quest_count': number;
    /**
     * 
     * @type {number}
     * @memberof CampaignSummary
     */
    'objective_count': number;
    /**
     * 
     * @type {number}
     * @memberof CampaignSummary
     */
    'tactical_map_count': number;
}


/**
 * 
 * @export
 * @interface CampaignTacticalMapAssignRequest
 */
export interface CampaignTacticalMapAssignRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignTacticalMapAssignRequest
     */
    'position_id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignTacticalMapAssignRequest
     */
    'template_id'?: string | null;
}
/**
 * 
 * @export
 * @interface CardDetail
 */
export interface CardDetail {
    /**
     * 
     * @type {string}
     * @memberof CardDetail
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardDetail
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CardDetail
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDetail
     */
    'lore_text'?: string;
    /**
     * 
     * @type {CardTypeEnum}
     * @memberof CardDetail
     */
    'card_type'?: CardTypeEnum;
    /**
     * 
     * @type {ElementEnum}
     * @memberof CardDetail
     */
    'element'?: ElementEnum;
    /**
     * 
     * @type {RarityEnum}
     * @memberof CardDetail
     */
    'rarity'?: RarityEnum;
    /**
     * 
     * @type {FactionEnum}
     * @memberof CardDetail
     */
    'faction'?: FactionEnum;
    /**
     * 
     * @type {number}
     * @memberof CardDetail
     */
    'power'?: number;
    /**
     * 
     * @type {number}
     * @memberof CardDetail
     */
    'defense'?: number;
    /**
     * 
     * @type {number}
     * @memberof CardDetail
     */
    'flow_cost'?: number;
    /**
     * 
     * @type {Array<SynergyTag>}
     * @memberof CardDetail
     */
    'synergy_tags': Array<SynergyTag>;
    /**
     * Placeholder color when no image is set
     * @type {string}
     * @memberof CardDetail
     */
    'placeholder_color'?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDetail
     */
    'image'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CardDetail
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CardDetail
     */
    'total_value': number;
    /**
     * DX skill this card was generated from
     * @type {number}
     * @memberof CardDetail
     */
    'source_skill'?: number | null;
    /**
     * DX character template this card was generated from
     * @type {string}
     * @memberof CardDetail
     */
    'source_character_template'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardDetail
     */
    'created_at': string;
}


/**
 * 
 * @export
 * @interface CardList
 */
export interface CardList {
    /**
     * 
     * @type {string}
     * @memberof CardList
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardList
     */
    'name': string;
    /**
     * 
     * @type {CardTypeEnum}
     * @memberof CardList
     */
    'card_type'?: CardTypeEnum;
    /**
     * 
     * @type {ElementEnum}
     * @memberof CardList
     */
    'element'?: ElementEnum;
    /**
     * 
     * @type {RarityEnum}
     * @memberof CardList
     */
    'rarity'?: RarityEnum;
    /**
     * 
     * @type {FactionEnum}
     * @memberof CardList
     */
    'faction'?: FactionEnum;
    /**
     * 
     * @type {number}
     * @memberof CardList
     */
    'power'?: number;
    /**
     * 
     * @type {number}
     * @memberof CardList
     */
    'defense'?: number;
    /**
     * 
     * @type {number}
     * @memberof CardList
     */
    'flow_cost'?: number;
    /**
     * 
     * @type {Array<SynergyTag>}
     * @memberof CardList
     */
    'synergy_tags': Array<SynergyTag>;
    /**
     * Placeholder color when no image is set
     * @type {string}
     * @memberof CardList
     */
    'placeholder_color'?: string;
    /**
     * 
     * @type {string}
     * @memberof CardList
     */
    'image'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CardList
     */
    'is_active'?: boolean;
}


/**
 * 
 * @export
 * @interface CardListRequest
 */
export interface CardListRequest {
    /**
     * 
     * @type {string}
     * @memberof CardListRequest
     */
    'name': string;
    /**
     * 
     * @type {CardTypeEnum}
     * @memberof CardListRequest
     */
    'card_type'?: CardTypeEnum;
    /**
     * 
     * @type {ElementEnum}
     * @memberof CardListRequest
     */
    'element'?: ElementEnum;
    /**
     * 
     * @type {RarityEnum}
     * @memberof CardListRequest
     */
    'rarity'?: RarityEnum;
    /**
     * 
     * @type {FactionEnum}
     * @memberof CardListRequest
     */
    'faction'?: FactionEnum;
    /**
     * 
     * @type {number}
     * @memberof CardListRequest
     */
    'power'?: number;
    /**
     * 
     * @type {number}
     * @memberof CardListRequest
     */
    'defense'?: number;
    /**
     * 
     * @type {number}
     * @memberof CardListRequest
     */
    'flow_cost'?: number;
    /**
     * Placeholder color when no image is set
     * @type {string}
     * @memberof CardListRequest
     */
    'placeholder_color'?: string;
    /**
     * 
     * @type {File}
     * @memberof CardListRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {boolean}
     * @memberof CardListRequest
     */
    'is_active'?: boolean;
}


/**
 * * `spell` - spell * `implant` - implant * `hack` - hack * `artifact` - artifact * `creature` - creature * `hybrid` - hybrid
 * @export
 * @enum {string}
 */

export const CardTypeEnum = {
    Spell: 'spell',
    Implant: 'implant',
    Hack: 'hack',
    Artifact: 'artifact',
    Creature: 'creature',
    Hybrid: 'hybrid'
} as const;

export type CardTypeEnum = typeof CardTypeEnum[keyof typeof CardTypeEnum];


/**
 * * `events` - Events * `rules` - Rules * `lore` - Lore * `stories` - Stories * `guides` - Guides * `items` - Items * `characters` - Characters * `locations` - Locations * `places` - Places * `factions` - Factions * `creatures` - Creatures * `skills` - Skills * `spells` - Spells * `abilities` - Abilities * `other` - Other
 * @export
 * @enum {string}
 */

export const CategoriesEnum = {
    Events: 'events',
    Rules: 'rules',
    Lore: 'lore',
    Stories: 'stories',
    Guides: 'guides',
    Items: 'items',
    Characters: 'characters',
    Locations: 'locations',
    Places: 'places',
    Factions: 'factions',
    Creatures: 'creatures',
    Skills: 'skills',
    Spells: 'spells',
    Abilities: 'abilities',
    Other: 'other'
} as const;

export type CategoriesEnum = typeof CategoriesEnum[keyof typeof CategoriesEnum];


/**
 * * `dungeon` - Dungeon * `wilderness` - Wilderness * `urban` - Urban * `indoor` - Indoor * `arena` - Arena * `ship` - Ship/Vehicle * `planar` - Planar/Dimensional * `custom` - Custom
 * @export
 * @enum {string}
 */

export const CategoryEnum = {
    Dungeon: 'dungeon',
    Wilderness: 'wilderness',
    Urban: 'urban',
    Indoor: 'indoor',
    Arena: 'arena',
    Ship: 'ship',
    Planar: 'planar',
    Custom: 'custom'
} as const;

export type CategoryEnum = typeof CategoryEnum[keyof typeof CategoryEnum];


/**
 * Schema for grid cells with passability and terrain information.
 * @export
 * @interface Cell
 */
export interface Cell {
    /**
     * Column index (0-based)
     * @type {number}
     * @memberof Cell
     */
    'x': number;
    /**
     * Row index (0-based)
     * @type {number}
     * @memberof Cell
     */
    'y': number;
    /**
     * Layer ID (0-9)
     * @type {number}
     * @memberof Cell
     */
    'layer'?: number;
    /**
     * Terrain type (grass, road, dirt, sand, swamp, water, lava, snow, rock, forest, mountain, void)
     * @type {string}
     * @memberof Cell
     */
    'terrain'?: string | null;
    /**
     * Whether units can enter this cell
     * @type {boolean}
     * @memberof Cell
     */
    'passable'?: boolean;
}
/**
 * Event fired when a new challenge is created for a character.
 * @export
 * @interface ChallengeCreatedEvent
 */
export interface ChallengeCreatedEvent {
    /**
     * 
     * @type {string}
     * @memberof ChallengeCreatedEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeCreatedEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChallengeCreatedEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof ChallengeCreatedEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsChallengeCreatedEventData}
     * @memberof ChallengeCreatedEvent
     */
    'data': WsChallengeCreatedEventData;
}


/**
 * 
 * @export
 * @interface ChallengeGeneric
 */
export interface ChallengeGeneric {
    /**
     * 
     * @type {string}
     * @memberof ChallengeGeneric
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeGeneric
     */
    'difficulty'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChallengeGeneric
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChallengeGeneric
     */
    'dice_sides'?: number;
    /**
     * 
     * @type {DiceRollResult}
     * @memberof ChallengeGeneric
     */
    'outcome': DiceRollResult;
    /**
     * 
     * @type {CharacterStatEnum}
     * @memberof ChallengeGeneric
     */
    'stat'?: CharacterStatEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeGeneric
     */
    'advantage'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeGeneric
     */
    'disadvantage'?: boolean;
    /**
     * 
     * @type {Array<ChallengeModifier>}
     * @memberof ChallengeGeneric
     */
    'modifiers': Array<ChallengeModifier>;
}


/**
 * 
 * @export
 * @interface ChallengeModifier
 */
export interface ChallengeModifier {
    /**
     * 
     * @type {string}
     * @memberof ChallengeModifier
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeModifier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeModifier
     */
    'icon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChallengeModifier
     */
    'value': number;
}
/**
 * * `fault` - Fault * `signal` - Signal * `idea` - Idea
 * @export
 * @enum {string}
 */

export const ChannelEnum = {
    Fault: 'fault',
    Signal: 'signal',
    Idea: 'idea'
} as const;

export type ChannelEnum = typeof ChannelEnum[keyof typeof ChannelEnum];


/**
 * Serializer for Chapter model.
 * @export
 * @interface Chapter
 */
export interface Chapter {
    /**
     * 
     * @type {string}
     * @memberof Chapter
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Chapter
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Chapter
     */
    'description': string;
    /**
     * Optional URL to an image representing the chapter
     * @type {string}
     * @memberof Chapter
     */
    'image'?: string | null;
    /**
     * Order of the chapter within the story
     * @type {number}
     * @memberof Chapter
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof Chapter
     */
    'story': string;
    /**
     * 
     * @type {Array<Quest>}
     * @memberof Chapter
     */
    'quests': Array<Quest>;
}
/**
 * Serializer for Chapter model.
 * @export
 * @interface ChapterRequest
 */
export interface ChapterRequest {
    /**
     * 
     * @type {string}
     * @memberof ChapterRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ChapterRequest
     */
    'description': string;
    /**
     * Optional URL to an image representing the chapter
     * @type {File}
     * @memberof ChapterRequest
     */
    'image'?: File | null;
    /**
     * Order of the chapter within the story
     * @type {number}
     * @memberof ChapterRequest
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChapterRequest
     */
    'story': string;
}
/**
 * 
 * @export
 * @interface CharacterAction
 */
export interface CharacterAction {
    /**
     * 
     * @type {string}
     * @memberof CharacterAction
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterAction
     */
    'initiator': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterAction
     */
    'targets'?: Array<string>;
    /**
     * 
     * @type {CharacterActionTypeEnum}
     * @memberof CharacterAction
     */
    'action_type'?: CharacterActionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CharacterAction
     */
    'skill'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof CharacterAction
     */
    'data'?: any;
    /**
     * 
     * @type {string}
     * @memberof CharacterAction
     */
    'position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CharacterAction
     */
    'item'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CharacterAction
     */
    'performed': boolean;
}


/**
 * 
 * @export
 * @interface CharacterActionLog
 */
export interface CharacterActionLog {
    /**
     * 
     * @type {string}
     * @memberof CharacterActionLog
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterActionLog
     */
    'initiator': string;
    /**
     * 
     * @type {CharacterActionTypeEnum}
     * @memberof CharacterActionLog
     */
    'action_type'?: CharacterActionTypeEnum;
    /**
     * 
     * @type {ActionLogSkill}
     * @memberof CharacterActionLog
     */
    'skill': ActionLogSkill;
    /**
     * 
     * @type {any}
     * @memberof CharacterActionLog
     */
    'data'?: any;
    /**
     * 
     * @type {Array<CharacterLogActionImpact>}
     * @memberof CharacterActionLog
     */
    'impacts': Array<CharacterLogActionImpact>;
    /**
     * 
     * @type {ActionCycle}
     * @memberof CharacterActionLog
     */
    'cycle': ActionCycle;
    /**
     * 
     * @type {boolean}
     * @memberof CharacterActionLog
     */
    'performed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CharacterActionLog
     */
    'accepted'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterActionLog
     */
    'targets': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CharacterActionLog
     */
    'order'?: number;
    /**
     * 
     * @type {Phase347Enum}
     * @memberof CharacterActionLog
     */
    'phase'?: Phase347Enum;
}


/**
 * 
 * @export
 * @interface CharacterActionRequest
 */
export interface CharacterActionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterActionRequest
     */
    'targets'?: Array<string>;
    /**
     * 
     * @type {CharacterActionTypeEnum}
     * @memberof CharacterActionRequest
     */
    'action_type'?: CharacterActionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CharacterActionRequest
     */
    'skill'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof CharacterActionRequest
     */
    'data'?: any;
    /**
     * 
     * @type {string}
     * @memberof CharacterActionRequest
     */
    'position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CharacterActionRequest
     */
    'item'?: string | null;
}


/**
 * * `USE_SKILL` - USE_SKILL * `USE_ITEM` - USE_ITEM * `DIMENSION_SHIFT` - DIMENSION_SHIFT * `CHANGE_POSITION` - CHANGE_POSITION * `START_DIALOGUE` - START_DIALOGUE * `MAKE_DUEL_INVITATION` - MAKE_DUEL_INVITATION * `ACCEPT_DUEL_INVITATION` - ACCEPT_DUEL_INVITATION * `REJECT_DUEL_INVITATION` - REJECT_DUEL_INVITATION * `START_FIGHT` - START_FIGHT * `MOVE` - MOVE * `TACTICAL_MOVE` - TACTICAL_MOVE * `BREAKTHROUGH` - BREAKTHROUGH * `DICE_ROLL` - DICE_ROLL * `BARGAIN` - BARGAIN * `ANOMALY` - ANOMALY * `GOD_INTERVENTION` - GOD_INTERVENTION * `LONG_REST` - LONG_REST * `BACK_TO_SAFE_ZONE` - BACK_TO_SAFE_ZONE * `INSPECT` - INSPECT * `SNATCH_ITEM` - SNATCH_ITEM * `OPEN_CHEST` - OPEN_CHEST * `PICK_UP_ITEM` - PICK_UP_ITEM
 * @export
 * @enum {string}
 */

export const CharacterActionTypeEnum = {
    UseSkill: 'USE_SKILL',
    UseItem: 'USE_ITEM',
    DimensionShift: 'DIMENSION_SHIFT',
    ChangePosition: 'CHANGE_POSITION',
    StartDialogue: 'START_DIALOGUE',
    MakeDuelInvitation: 'MAKE_DUEL_INVITATION',
    AcceptDuelInvitation: 'ACCEPT_DUEL_INVITATION',
    RejectDuelInvitation: 'REJECT_DUEL_INVITATION',
    StartFight: 'START_FIGHT',
    Move: 'MOVE',
    TacticalMove: 'TACTICAL_MOVE',
    Breakthrough: 'BREAKTHROUGH',
    DiceRoll: 'DICE_ROLL',
    Bargain: 'BARGAIN',
    Anomaly: 'ANOMALY',
    GodIntervention: 'GOD_INTERVENTION',
    LongRest: 'LONG_REST',
    BackToSafeZone: 'BACK_TO_SAFE_ZONE',
    Inspect: 'INSPECT',
    SnatchItem: 'SNATCH_ITEM',
    OpenChest: 'OPEN_CHEST',
    PickUpItem: 'PICK_UP_ITEM'
} as const;

export type CharacterActionTypeEnum = typeof CharacterActionTypeEnum[keyof typeof CharacterActionTypeEnum];


/**
 * 
 * @export
 * @interface CharacterAvatar
 */
export interface CharacterAvatar {
    /**
     * 
     * @type {string}
     * @memberof CharacterAvatar
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterAvatar
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterAvatar
     */
    'avatar': string | null;
}
/**
 * 
 * @export
 * @interface CharacterAvatarPreset
 */
export interface CharacterAvatarPreset {
    /**
     * 
     * @type {string}
     * @memberof CharacterAvatarPreset
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterAvatarPreset
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterAvatarPreset
     */
    'image': string;
    /**
     * 
     * @type {AvatarPresetSchool}
     * @memberof CharacterAvatarPreset
     */
    'school': AvatarPresetSchool | null;
    /**
     * 
     * @type {number}
     * @memberof CharacterAvatarPreset
     */
    'sort_order'?: number;
}
/**
 * 
 * @export
 * @interface CharacterBioDraft
 */
export interface CharacterBioDraft {
    /**
     * 
     * @type {number}
     * @memberof CharacterBioDraft
     */
    'age': number;
    /**
     * 
     * @type {GenderEnum}
     * @memberof CharacterBioDraft
     */
    'gender': GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof CharacterBioDraft
     */
    'appearance': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterBioDraft
     */
    'background': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterBioDraft
     */
    'avatar_preset'?: string | null;
}


/**
 * 
 * @export
 * @interface CharacterBioDraftRequest
 */
export interface CharacterBioDraftRequest {
    /**
     * 
     * @type {number}
     * @memberof CharacterBioDraftRequest
     */
    'age': number;
    /**
     * 
     * @type {GenderEnum}
     * @memberof CharacterBioDraftRequest
     */
    'gender': GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof CharacterBioDraftRequest
     */
    'appearance': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterBioDraftRequest
     */
    'background': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterBioDraftRequest
     */
    'avatar_preset'?: string | null;
}


/**
 * The owner\'s private, live in-game biography.  Explicit field list on purpose: ``OpenaiCharacterBioSerializer`` is ``fields = \"__all__\"`` and would expose the FK id and any future column.
 * @export
 * @interface CharacterBiographyDetail
 */
export interface CharacterBiographyDetail {
    /**
     * 
     * @type {string}
     * @memberof CharacterBiographyDetail
     */
    'character_id': string;
    /**
     * 
     * @type {number}
     * @memberof CharacterBiographyDetail
     */
    'age': number;
    /**
     * 
     * @type {GenderEnum}
     * @memberof CharacterBiographyDetail
     */
    'gender': GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof CharacterBiographyDetail
     */
    'background'?: string;
    /**
     * 
     * @type {string}
     * @memberof CharacterBiographyDetail
     */
    'appearance'?: string;
    /**
     * 
     * @type {string}
     * @memberof CharacterBiographyDetail
     */
    'avatar': string | null;
    /**
     * 
     * @type {BiographyPortraitState}
     * @memberof CharacterBiographyDetail
     */
    'portrait': BiographyPortraitState;
}


/**
 * 
 * @export
 * @interface CharacterCurrency
 */
export interface CharacterCurrency {
    /**
     * 
     * @type {string}
     * @memberof CharacterCurrency
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterCurrency
     */
    'character': string;
    /**
     * 
     * @type {CurrencyToken}
     * @memberof CharacterCurrency
     */
    'currency': CurrencyToken;
    /**
     * 
     * @type {number}
     * @memberof CharacterCurrency
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface CharacterDiceRollResult
 */
export interface CharacterDiceRollResult {
    /**
     * 
     * @type {number}
     * @memberof CharacterDiceRollResult
     */
    'dice_side': number;
}
/**
 * 
 * @export
 * @interface CharacterExample1GameEvent
 */
export interface CharacterExample1GameEvent {
    /**
     * 
     * @type {string}
     * @memberof CharacterExample1GameEvent
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CharacterExample1GameEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof CharacterExample1GameEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof CharacterExample1GameEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsCharacterExample1GameEventData}
     * @memberof CharacterExample1GameEvent
     */
    'data': WsCharacterExample1GameEventData;
}


/**
 * 
 * @export
 * @interface CharacterExample1GameEventData
 */
export interface CharacterExample1GameEventData {
    /**
     * 
     * @type {string}
     * @memberof CharacterExample1GameEventData
     */
    'field1': string;
}
/**
 * 
 * @export
 * @interface CharacterExample2GameEvent
 */
export interface CharacterExample2GameEvent {
    /**
     * 
     * @type {string}
     * @memberof CharacterExample2GameEvent
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CharacterExample2GameEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof CharacterExample2GameEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof CharacterExample2GameEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsCharacterExample2GameEventData}
     * @memberof CharacterExample2GameEvent
     */
    'data': WsCharacterExample2GameEventData;
}


/**
 * 
 * @export
 * @interface CharacterExample2GameEventData
 */
export interface CharacterExample2GameEventData {
    /**
     * 
     * @type {string}
     * @memberof CharacterExample2GameEventData
     */
    'field2': string;
}
/**
 * 
 * @export
 * @interface CharacterGenericData
 */
export interface CharacterGenericData {
    /**
     * 
     * @type {string}
     * @memberof CharacterGenericData
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterGenericData
     */
    'tags': Array<string>;
    /**
     * 
     * @type {CharacterBioDraft}
     * @memberof CharacterGenericData
     */
    'bio': CharacterBioDraft;
    /**
     * 
     * @type {number}
     * @memberof CharacterGenericData
     */
    'rank': number;
    /**
     * 
     * @type {string}
     * @memberof CharacterGenericData
     */
    'path': string;
    /**
     * 
     * @type {Array<CharacterStat>}
     * @memberof CharacterGenericData
     */
    'stats': Array<CharacterStat>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterGenericData
     */
    'modificators': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterGenericData
     */
    'items': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterGenericData
     */
    'schools': Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CharacterGenericData
     */
    'spells': Array<number>;
}
/**
 * 
 * @export
 * @interface CharacterGenericDataRequest
 */
export interface CharacterGenericDataRequest {
    /**
     * 
     * @type {string}
     * @memberof CharacterGenericDataRequest
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterGenericDataRequest
     */
    'tags': Array<string>;
    /**
     * 
     * @type {CharacterBioDraftRequest}
     * @memberof CharacterGenericDataRequest
     */
    'bio': CharacterBioDraftRequest;
    /**
     * 
     * @type {number}
     * @memberof CharacterGenericDataRequest
     */
    'rank': number;
    /**
     * 
     * @type {string}
     * @memberof CharacterGenericDataRequest
     */
    'path': string;
    /**
     * 
     * @type {Array<CharacterStatRequest>}
     * @memberof CharacterGenericDataRequest
     */
    'stats': Array<CharacterStatRequest>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterGenericDataRequest
     */
    'modificators': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterGenericDataRequest
     */
    'items': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterGenericDataRequest
     */
    'schools': Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CharacterGenericDataRequest
     */
    'spells': Array<number>;
}
/**
 * 
 * @export
 * @interface CharacterInfo
 */
export interface CharacterInfo {
    /**
     * 
     * @type {string}
     * @memberof CharacterInfo
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CharacterInfo
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CharacterInfo
     */
    'rank_grade': number;
    /**
     * 
     * @type {Array<Attribute>}
     * @memberof CharacterInfo
     */
    'attributes': Array<Attribute>;
    /**
     * 
     * @type {number}
     * @memberof CharacterInfo
     */
    'dimension': number;
    /**
     * 
     * @type {string}
     * @memberof CharacterInfo
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterInfo
     */
    'fight': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CharacterInfo
     */
    'game_master_mode': boolean;
}
/**
 * 
 * @export
 * @interface CharacterItem
 */
export interface CharacterItem {
    /**
     * 
     * @type {string}
     * @memberof CharacterItem
     */
    'id': string;
    /**
     * 
     * @type {WorldItem}
     * @memberof CharacterItem
     */
    'world_item': WorldItem;
    /**
     * 
     * @type {string}
     * @memberof CharacterItem
     */
    'character': string;
}
/**
 * 
 * @export
 * @interface CharacterJoinFightEvent
 */
export interface CharacterJoinFightEvent {
    /**
     * 
     * @type {string}
     * @memberof CharacterJoinFightEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CharacterJoinFightEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof CharacterJoinFightEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof CharacterJoinFightEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsCharacterJoinFightEventData}
     * @memberof CharacterJoinFightEvent
     */
    'data': WsCharacterJoinFightEventData;
}


/**
 * 
 * @export
 * @interface CharacterLeaveFightEvent
 */
export interface CharacterLeaveFightEvent {
    /**
     * 
     * @type {string}
     * @memberof CharacterLeaveFightEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CharacterLeaveFightEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof CharacterLeaveFightEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof CharacterLeaveFightEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsCharacterLeaveFightEventData}
     * @memberof CharacterLeaveFightEvent
     */
    'data': WsCharacterLeaveFightEventData;
}


/**
 * 
 * @export
 * @interface CharacterLogActionImpact
 */
export interface CharacterLogActionImpact {
    /**
     * 
     * @type {string}
     * @memberof CharacterLogActionImpact
     */
    'id': string;
    /**
     * 
     * @type {ActionLogDiceRollResult}
     * @memberof CharacterLogActionImpact
     */
    'dice_roll_result': ActionLogDiceRollResult;
    /**
     * 
     * @type {ImpactTypeEnum}
     * @memberof CharacterLogActionImpact
     */
    'type': ImpactTypeEnum;
    /**
     * 
     * @type {ImpactViolationTypeEnum}
     * @memberof CharacterLogActionImpact
     */
    'violation': ImpactViolationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CharacterLogActionImpact
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof CharacterLogActionImpact
     */
    'charge_index': number | null;
    /**
     * 
     * @type {string}
     * @memberof CharacterLogActionImpact
     */
    'target': string;
}


/**
 * Everything an image generator needs to draw the character.
 * @export
 * @interface CharacterMissingAvatar
 */
export interface CharacterMissingAvatar {
    /**
     * 
     * @type {string}
     * @memberof CharacterMissingAvatar
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterMissingAvatar
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CharacterMissingAvatar
     */
    'npc': boolean;
    /**
     * 
     * @type {number}
     * @memberof CharacterMissingAvatar
     */
    'age': number;
    /**
     * 
     * @type {string}
     * @memberof CharacterMissingAvatar
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterMissingAvatar
     */
    'appearance': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterMissingAvatar
     */
    'background': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterMissingAvatar
     */
    'rank': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterMissingAvatar
     */
    'organization': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterMissingAvatar
     */
    'campaign': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterMissingAvatar
     */
    'campaign_name': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterMissingAvatar
     */
    'current_avatar': string | null;
    /**
     * 
     * @type {string}
     * @memberof CharacterMissingAvatar
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface CharacterModificator
 */
export interface CharacterModificator {
    /**
     * 
     * @type {string}
     * @memberof CharacterModificator
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterModificator
     */
    'character': string;
    /**
     * 
     * @type {Modificator}
     * @memberof CharacterModificator
     */
    'modificator': Modificator;
}
/**
 * 
 * @export
 * @interface CharacterNewTurnGameEvent
 */
export interface CharacterNewTurnGameEvent {
    /**
     * 
     * @type {string}
     * @memberof CharacterNewTurnGameEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CharacterNewTurnGameEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof CharacterNewTurnGameEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof CharacterNewTurnGameEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsCharacterNewTurnGameEventData}
     * @memberof CharacterNewTurnGameEvent
     */
    'data': WsCharacterNewTurnGameEventData;
}


/**
 * 
 * @export
 * @interface CharacterOnPosition
 */
export interface CharacterOnPosition {
    /**
     * 
     * @type {string}
     * @memberof CharacterOnPosition
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterOnPosition
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CharacterOnPosition
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CharacterOnPosition
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CharacterOnPosition
     */
    'npc'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CharacterOnPosition
     */
    'alive': boolean;
    /**
     * 
     * @type {TacticalPosition}
     * @memberof CharacterOnPosition
     */
    'tactical_position': TacticalPosition;
    /**
     * 
     * @type {ScreenEnum}
     * @memberof CharacterOnPosition
     */
    'screen'?: ScreenEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CharacterOnPosition
     */
    'game_master_mode': boolean;
}


/**
 * 
 * @export
 * @interface CharacterPath
 */
export interface CharacterPath {
    /**
     * 
     * @type {string}
     * @memberof CharacterPath
     */
    'path'?: string | null;
}
/**
 * 
 * @export
 * @interface CharacterPathRequest
 */
export interface CharacterPathRequest {
    /**
     * 
     * @type {string}
     * @memberof CharacterPathRequest
     */
    'path'?: string | null;
}
/**
 * 
 * @export
 * @interface CharacterPendingJoinFightEvent
 */
export interface CharacterPendingJoinFightEvent {
    /**
     * 
     * @type {string}
     * @memberof CharacterPendingJoinFightEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CharacterPendingJoinFightEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof CharacterPendingJoinFightEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof CharacterPendingJoinFightEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsCharacterPendingJoinFightEventData}
     * @memberof CharacterPendingJoinFightEvent
     */
    'data': WsCharacterPendingJoinFightEventData;
}


/**
 * 
 * @export
 * @interface CharacterPublicationOpenRequest
 */
export interface CharacterPublicationOpenRequest {
    /**
     * 
     * @type {string}
     * @memberof CharacterPublicationOpenRequest
     */
    'id': string;
    /**
     * 
     * @type {PublicationStatusEnum}
     * @memberof CharacterPublicationOpenRequest
     */
    'status': PublicationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CharacterPublicationOpenRequest
     */
    'submitted_at': string | null;
}


/**
 * 
 * @export
 * @interface CharacterPublicationSummary
 */
export interface CharacterPublicationSummary {
    /**
     * 
     * @type {boolean}
     * @memberof CharacterPublicationSummary
     */
    'is_public': boolean;
    /**
     * 
     * @type {string}
     * @memberof CharacterPublicationSummary
     */
    'public_url_id': string | null;
    /**
     * 
     * @type {CharacterPublicationOpenRequest}
     * @memberof CharacterPublicationSummary
     */
    'open_request': CharacterPublicationOpenRequest | null;
}
/**
 * 
 * @export
 * @interface CharacterStat
 */
export interface CharacterStat {
    /**
     * 
     * @type {string}
     * @memberof CharacterStat
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CharacterStat
     */
    'value': number;
}
/**
 * Stat definition (name + description), not a character\'s stat value.
 * @export
 * @interface CharacterStatDefinition
 */
export interface CharacterStatDefinition {
    /**
     * 
     * @type {string}
     * @memberof CharacterStatDefinition
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterStatDefinition
     */
    'description': string;
}
/**
 * * `Physical Strength` - Physical Strength * `Mental Strength` - Mental Strength * `Flow Resonance` - Flow Resonance * `Concentration` - Concentration * `Flow Manipulation` - Flow Manipulation * `Flow Connection` - Flow Connection * `Knowledge` - Knowledge * `Speed` - Speed * `Luck` - Luck * `Charisma` - Charisma
 * @export
 * @enum {string}
 */

export const CharacterStatEnum = {
    PhysicalStrength: 'Physical Strength',
    MentalStrength: 'Mental Strength',
    FlowResonance: 'Flow Resonance',
    Concentration: 'Concentration',
    FlowManipulation: 'Flow Manipulation',
    FlowConnection: 'Flow Connection',
    Knowledge: 'Knowledge',
    Speed: 'Speed',
    Luck: 'Luck',
    Charisma: 'Charisma'
} as const;

export type CharacterStatEnum = typeof CharacterStatEnum[keyof typeof CharacterStatEnum];


/**
 * 
 * @export
 * @interface CharacterStatRequest
 */
export interface CharacterStatRequest {
    /**
     * 
     * @type {string}
     * @memberof CharacterStatRequest
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CharacterStatRequest
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface CharacterStats
 */
export interface CharacterStats {
    /**
     * 
     * @type {Array<Stat>}
     * @memberof CharacterStats
     */
    'stats': Array<Stat>;
}
/**
 * 
 * @export
 * @interface CharacterTemplate
 */
export interface CharacterTemplate {
    /**
     * 
     * @type {string}
     * @memberof CharacterTemplate
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterTemplate
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {Bio}
     * @memberof CharacterTemplate
     */
    'bio': Bio;
    /**
     * 
     * @type {number}
     * @memberof CharacterTemplate
     */
    'rank': number;
    /**
     * 
     * @type {string}
     * @memberof CharacterTemplate
     */
    'path': string | null;
    /**
     * 
     * @type {Array<Stat>}
     * @memberof CharacterTemplate
     */
    'stats'?: Array<Stat>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterTemplate
     */
    'modificators'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterTemplate
     */
    'items'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterTemplate
     */
    'schools'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CharacterTemplate
     */
    'spells'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CharacterTemplateFull
 */
export interface CharacterTemplateFull {
    /**
     * 
     * @type {string}
     * @memberof CharacterTemplateFull
     */
    'id'?: string | null;
    /**
     * 
     * @type {CharacterTemplate}
     * @memberof CharacterTemplateFull
     */
    'data': CharacterTemplate;
    /**
     * 
     * @type {CharacterTemplateValidation}
     * @memberof CharacterTemplateFull
     */
    'validation': CharacterTemplateValidation;
}
/**
 * Serializer for CharacterTemplate model.  This serializer provides the necessary data for listing character templates, including template name, id, behavior, organization, avatar, grade, and path.
 * @export
 * @interface CharacterTemplateGameMaster
 */
export interface CharacterTemplateGameMaster {
    /**
     * 
     * @type {string}
     * @memberof CharacterTemplateGameMaster
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterTemplateGameMaster
     */
    'name': string;
    /**
     * 
     * @type {BehaviorEnum}
     * @memberof CharacterTemplateGameMaster
     */
    'behavior': BehaviorEnum;
    /**
     * Footprint NPCs from this template hold on the tactical grid: standard 1x1, medium 2x2, superior 3x3  * `standard` - standard * `medium` - medium * `superior` - superior
     * @type {TacticalSizeEnum}
     * @memberof CharacterTemplateGameMaster
     */
    'tactical_size': TacticalSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof CharacterTemplateGameMaster
     */
    'organization': string | null;
    /**
     * 
     * @type {string}
     * @memberof CharacterTemplateGameMaster
     */
    'organization_name': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterTemplateGameMaster
     */
    'avatar': string;
    /**
     * 
     * @type {string}
     * @memberof CharacterTemplateGameMaster
     */
    'grade': string;
    /**
     * 
     * @type {ThePath}
     * @memberof CharacterTemplateGameMaster
     */
    'path': ThePath;
}


/**
 * 
 * @export
 * @interface CharacterTemplateValidation
 */
export interface CharacterTemplateValidation {
    /**
     * 
     * @type {number}
     * @memberof CharacterTemplateValidation
     */
    'max_stats_points_count': number;
    /**
     * 
     * @type {number}
     * @memberof CharacterTemplateValidation
     */
    'max_modificators_count': number;
    /**
     * 
     * @type {number}
     * @memberof CharacterTemplateValidation
     */
    'max_items_count': number;
    /**
     * 
     * @type {number}
     * @memberof CharacterTemplateValidation
     */
    'max_spells_count': number;
    /**
     * 
     * @type {number}
     * @memberof CharacterTemplateValidation
     */
    'max_rank_grade': number;
    /**
     * 
     * @type {number}
     * @memberof CharacterTemplateValidation
     */
    'max_schools_count': number;
}
/**
 * A chest and everything it is offering.
 * @export
 * @interface Chest
 */
export interface Chest {
    /**
     * 
     * @type {string}
     * @memberof Chest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Chest
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Chest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {Array<ChestItem>}
     * @memberof Chest
     */
    'items': Array<ChestItem>;
    /**
     * 
     * @type {number}
     * @memberof Chest
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof Chest
     */
    'y': number;
}
/**
 * One item as it appears in a chest\'s manifest.
 * @export
 * @interface ChestItem
 */
export interface ChestItem {
    /**
     * 
     * @type {string}
     * @memberof ChestItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ChestItem
     */
    'world_item_id': string;
    /**
     * 
     * @type {string}
     * @memberof ChestItem
     */
    'item_id': string;
    /**
     * 
     * @type {string}
     * @memberof ChestItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ChestItem
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ChestItem
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof ChestItem
     */
    'weight': number;
    /**
     * 
     * @type {number}
     * @memberof ChestItem
     */
    'base_price': number;
    /**
     * 
     * @type {number}
     * @memberof ChestItem
     */
    'charges_left': number;
    /**
     * Absolute, not the storage\'s own relative path.  The client is served from a different origin than the media, so a bare `/media/...` resolves against the frontend and 404s — a chest full of broken images. Every other serializer that emits an image builds the absolute URI for the same reason.
     * @type {string}
     * @memberof ChestItem
     */
    'icon': string | null;
}
/**
 * 
 * @export
 * @interface City
 */
export interface City {
    /**
     * 
     * @type {string}
     * @memberof City
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof City
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof City
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof City
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof City
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof City
     */
    'image'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof City
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof City
     */
    'map_x'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof City
     */
    'map_y'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof City
     */
    'country': string;
    /**
     * Default battle map template for fights in this city
     * @type {string}
     * @memberof City
     */
    'battle_map_template'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof City
     */
    'border_with'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ClientBrief
 */
export interface ClientBrief {
    /**
     * 
     * @type {string}
     * @memberof ClientBrief
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ClientBrief
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ClientBrief
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientBrief
     */
    'last_name': string;
}
/**
 * One tunable coefficient, so the page can explain its own arithmetic.
 * @export
 * @interface CoefficientDoc
 */
export interface CoefficientDoc {
    /**
     * 
     * @type {string}
     * @memberof CoefficientDoc
     */
    'key': string;
    /**
     * 
     * @type {number}
     * @memberof CoefficientDoc
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof CoefficientDoc
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof CoefficientDoc
     */
    'explanation': string;
}
/**
 * 
 * @export
 * @interface ComparePerHit
 */
export interface ComparePerHit {
    /**
     * 
     * @type {number}
     * @memberof ComparePerHit
     */
    'resolved': number;
    /**
     * 
     * @type {number}
     * @memberof ComparePerHit
     */
    'landed': number;
    /**
     * 
     * @type {number}
     * @memberof ComparePerHit
     */
    'expected': number;
}
/**
 * Several skills against **one** body, which is how retuning is done.  Same subject shape as the workbench, the round simulation and the sweep — a table whose rows were resolved against different casters compares nothing.
 * @export
 * @interface CompareRequestRequest
 */
export interface CompareRequestRequest {
    /**
     * Unused here; send `skill_ids`. Accepted so a workbench payload can be reused verbatim.
     * @type {number}
     * @memberof CompareRequestRequest
     */
    'skill_id'?: number;
    /**
     * 
     * @type {WorkbenchCasterRequest}
     * @memberof CompareRequestRequest
     */
    'caster'?: WorkbenchCasterRequest;
    /**
     * Resolve against an etalon or a real character instead of a typed stat line. Takes precedence over `caster`.
     * @type {SubjectRefRequest}
     * @memberof CompareRequestRequest
     */
    'subject'?: SubjectRefRequest;
    /**
     * 
     * @type {WorkbenchTargetRequest}
     * @memberof CompareRequestRequest
     */
    'target'?: WorkbenchTargetRequest;
    /**
     * 
     * @type {WorkbenchSkillOverrideRequest}
     * @memberof CompareRequestRequest
     */
    'overrides'?: WorkbenchSkillOverrideRequest;
    /**
     * Side of the preview grid. The workbench itself always asks for 20 and pans a 10x10 viewport over it; smaller sizes remain legal for a saved link from before the fixed board existed.
     * @type {number}
     * @memberof CompareRequestRequest
     */
    'grid_size'?: number;
    /**
     * One aim per charge. Defaults to the caster\'s own cell.
     * @type {Array<WorkbenchAimRequest>}
     * @memberof CompareRequestRequest
     */
    'aims'?: Array<WorkbenchAimRequest>;
    /**
     * The skills to place side by side, in the order given.
     * @type {Array<number>}
     * @memberof CompareRequestRequest
     */
    'skill_ids': Array<number>;
    /**
     * The health the rounds-to-kill column is measured against.
     * @type {number}
     * @memberof CompareRequestRequest
     */
    'target_health'?: number;
    /**
     * How many rounds that column may take before it gives up.
     * @type {number}
     * @memberof CompareRequestRequest
     */
    'horizon'?: number;
}
/**
 * 
 * @export
 * @interface CompareResponse
 */
export interface CompareResponse {
    /**
     * 
     * @type {SubjectSummary}
     * @memberof CompareResponse
     */
    'subject': SubjectSummary;
    /**
     * 
     * @type {number}
     * @memberof CompareResponse
     */
    'target_health': number;
    /**
     * 
     * @type {number}
     * @memberof CompareResponse
     */
    'horizon': number;
    /**
     * 
     * @type {Array<CompareRow>}
     * @memberof CompareResponse
     */
    'rows': Array<CompareRow>;
}
/**
 * 
 * @export
 * @interface CompareRoundsToTarget
 */
export interface CompareRoundsToTarget {
    /**
     * 
     * @type {number}
     * @memberof CompareRoundsToTarget
     */
    'target_health': number;
    /**
     * 
     * @type {number}
     * @memberof CompareRoundsToTarget
     */
    'horizon': number;
    /**
     * 
     * @type {number}
     * @memberof CompareRoundsToTarget
     */
    'per_cell': number | null;
    /**
     * 
     * @type {number}
     * @memberof CompareRoundsToTarget
     */
    'per_pattern': number | null;
    /**
     * 
     * @type {number}
     * @memberof CompareRoundsToTarget
     */
    'uses': number;
    /**
     * The sustained rate over the horizon — uses divided by rounds. Lower than the burst whenever a reservoir has to be refilled.
     * @type {number}
     * @memberof CompareRoundsToTarget
     */
    'uses_per_round': number;
    /**
     * 
     * @type {number}
     * @memberof CompareRoundsToTarget
     */
    'fire_rounds': number;
    /**
     * 
     * @type {number}
     * @memberof CompareRoundsToTarget
     */
    'accumulate_rounds': number;
    /**
     * 
     * @type {number}
     * @memberof CompareRoundsToTarget
     */
    'total_impact': number;
}
/**
 * One skill\'s row: the composite to sort by, the named figures to judge by.
 * @export
 * @interface CompareRow
 */
export interface CompareRow {
    /**
     * 
     * @type {WorkbenchSkill}
     * @memberof CompareRow
     */
    'skill': WorkbenchSkill;
    /**
     * 
     * @type {number}
     * @memberof CompareRow
     */
    'dx_skill_power': number;
    /**
     * 
     * @type {WorkbenchPower}
     * @memberof CompareRow
     */
    'power': WorkbenchPower;
    /**
     * 
     * @type {ComparePerHit}
     * @memberof CompareRow
     */
    'per_hit': ComparePerHit;
    /**
     * 
     * @type {WorkbenchCadence}
     * @memberof CompareRow
     */
    'cadence': WorkbenchCadence;
    /**
     * 
     * @type {number}
     * @memberof CompareRow
     */
    'total_landed': number;
    /**
     * 
     * @type {number}
     * @memberof CompareRow
     */
    'total_expected': number;
    /**
     * 
     * @type {CompareRoundsToTarget}
     * @memberof CompareRow
     */
    'rounds_to_target': CompareRoundsToTarget;
    /**
     * True when the row\'s magnitudes are a sum across impact kinds that are not interchangeable. Flag it in the table.
     * @type {boolean}
     * @memberof CompareRow
     */
    'mixed_kinds': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompareRow
     */
    'kinds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompareRow
     */
    'warnings': Array<string>;
}
/**
 * Serializer for Condition model.
 * @export
 * @interface Condition
 */
export interface Condition {
    /**
     * 
     * @type {string}
     * @memberof Condition
     */
    'id': string;
    /**
     * 
     * @type {ConditionTypeEnum}
     * @memberof Condition
     */
    'type'?: ConditionTypeEnum;
    /**
     * 
     * @type {Array<Trigger>}
     * @memberof Condition
     */
    'triggers': Array<Trigger>;
}


/**
 * Serializer for Condition model.
 * @export
 * @interface ConditionRequest
 */
export interface ConditionRequest {
    /**
     * 
     * @type {ConditionTypeEnum}
     * @memberof ConditionRequest
     */
    'type'?: ConditionTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConditionRequest
     */
    'trigger_ids'?: Array<string>;
}


/**
 * * `all` - All * `any` - Any * `none` - None
 * @export
 * @enum {string}
 */

export const ConditionTypeEnum = {
    All: 'all',
    Any: 'any',
    None: 'none'
} as const;

export type ConditionTypeEnum = typeof ConditionTypeEnum[keyof typeof ConditionTypeEnum];


/**
 * \"client\": \"435f309f-32f4-485d-9b88-6c2daca71555\", \"transport\": \"websocket\", \"protocol\": \"json\", \"encoding\": \"json\", \"name\": \"js\"
 * @export
 * @interface ConnectRequest
 */
export interface ConnectRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectRequest
     */
    'client': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectRequest
     */
    'transport': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectRequest
     */
    'protocol': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectRequest
     */
    'encoding': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface Coordinate
 */
export interface Coordinate {
    /**
     * 
     * @type {number}
     * @memberof Coordinate
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof Coordinate
     */
    'y': number;
    /**
     * 
     * @type {number}
     * @memberof Coordinate
     */
    'z': number;
}
/**
 * Serializer for skill costs.
 * @export
 * @interface CostRequest
 */
export interface CostRequest {
    /**
     * 
     * @type {AttributesEnum}
     * @memberof CostRequest
     */
    'kind': AttributesEnum;
    /**
     * 
     * @type {number}
     * @memberof CostRequest
     */
    'value': number;
}


/**
 * Serializer for creating an NPC from a template.  This serializer validates the data needed to create an NPC from a template, including the template ID and position ID.
 * @export
 * @interface CreateNPCFromTemplate
 */
export interface CreateNPCFromTemplate {
    /**
     * 
     * @type {string}
     * @memberof CreateNPCFromTemplate
     */
    'template_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateNPCFromTemplate
     */
    'position_id': string;
}
/**
 * Serializer for creating an NPC from a template.  This serializer validates the data needed to create an NPC from a template, including the template ID and position ID.
 * @export
 * @interface CreateNPCFromTemplateRequest
 */
export interface CreateNPCFromTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateNPCFromTemplateRequest
     */
    'template_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateNPCFromTemplateRequest
     */
    'position_id': string;
}
/**
 * 
 * @export
 * @interface CurrencyToken
 */
export interface CurrencyToken {
    /**
     * 
     * @type {string}
     * @memberof CurrencyToken
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CurrencyToken
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CurrencyToken
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CurrencyToken
     */
    'icon'?: string | null;
}
/**
 * 
 * @export
 * @interface CurrencyTokenRequest
 */
export interface CurrencyTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof CurrencyTokenRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CurrencyTokenRequest
     */
    'description': string;
    /**
     * 
     * @type {File}
     * @memberof CurrencyTokenRequest
     */
    'icon'?: File | null;
}
/**
 * 
 * @export
 * @interface CurrentClientInfo
 */
export interface CurrentClientInfo {
    /**
     * 
     * @type {string}
     * @memberof CurrentClientInfo
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CurrentClientInfo
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CurrentClientInfo
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentClientInfo
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentClientInfo
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof CurrentClientInfo
     */
    'avatar': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentClientInfo
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {OpenAICampaign}
     * @memberof CurrentClientInfo
     */
    'current_campaign': OpenAICampaign;
    /**
     * 
     * @type {OpenaiCharacter}
     * @memberof CurrentClientInfo
     */
    'main_character': OpenaiCharacter;
    /**
     * 
     * @type {Array<OpenAICampaign>}
     * @memberof CurrentClientInfo
     */
    'play_campaigns': Array<OpenAICampaign>;
    /**
     * 
     * @type {Array<OpenAICampaign>}
     * @memberof CurrentClientInfo
     */
    'master_campaigns': Array<OpenAICampaign>;
    /**
     * 
     * @type {Array<OpenaiCharacter>}
     * @memberof CurrentClientInfo
     */
    'owned_characters': Array<OpenaiCharacter>;
}
/**
 * 
 * @export
 * @interface CurveCheck
 */
export interface CurveCheck {
    /**
     * 
     * @type {number}
     * @memberof CurveCheck
     */
    'base': number | null;
    /**
     * 
     * @type {number}
     * @memberof CurveCheck
     */
    'deviation': number | null;
    /**
     * 
     * @type {number}
     * @memberof CurveCheck
     */
    'action_points': number | null;
    /**
     * 
     * @type {number}
     * @memberof CurveCheck
     */
    'energy': number | null;
    /**
     * 
     * @type {number}
     * @memberof CurveCheck
     */
    'max_range': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CurveCheck
     */
    'findings': Array<string>;
}
/**
 * Custom JWT serializer that adds game master related claims to the token.
 * @export
 * @interface CustomTokenObtainPairRequest
 */
export interface CustomTokenObtainPairRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomTokenObtainPairRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CustomTokenObtainPairRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface CycleAdvanceRequestRequest
 */
export interface CycleAdvanceRequestRequest {
    /**
     * Campaign to advance. Defaults to the caller\'s current campaign, then to the only active one.
     * @type {string}
     * @memberof CycleAdvanceRequestRequest
     */
    'campaign_id'?: string | null;
    /**
     * Advance this many phases. Mutually exclusive with cycles.
     * @type {number}
     * @memberof CycleAdvanceRequestRequest
     */
    'phases'?: number;
    /**
     * Advance this many whole cycles. Mutually exclusive with phases.
     * @type {number}
     * @memberof CycleAdvanceRequestRequest
     */
    'cycles'?: number;
}
/**
 * 
 * @export
 * @interface CycleAdvanceResponse
 */
export interface CycleAdvanceResponse {
    /**
     * Campaign that was advanced
     * @type {string}
     * @memberof CycleAdvanceResponse
     */
    'campaign_id': string;
    /**
     * Where the clock stood before
     * @type {CyclePoint}
     * @memberof CycleAdvanceResponse
     */
    'advanced_from': CyclePoint;
    /**
     * Where the clock stands now
     * @type {CyclePoint}
     * @memberof CycleAdvanceResponse
     */
    'advanced_to': CyclePoint;
    /**
     * One entry per phase or cycle stepped, in order
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CycleAdvanceResponse
     */
    'steps': Array<{ [key: string]: any; }>;
}
/**
 * 
 * @export
 * @interface CyclePoint
 */
export interface CyclePoint {
    /**
     * Cycle number
     * @type {number}
     * @memberof CyclePoint
     */
    'cycle': number;
    /**
     * Cycle phase
     * @type {string}
     * @memberof CyclePoint
     */
    'phase': string;
}
/**
 * 
 * @export
 * @interface CycleState
 */
export interface CycleState {
    /**
     * Campaign the clock belongs to
     * @type {string}
     * @memberof CycleState
     */
    'campaign_id': string;
    /**
     * Current cycle number
     * @type {number}
     * @memberof CycleState
     */
    'cycle': number;
    /**
     * Current cycle phase
     * @type {string}
     * @memberof CycleState
     */
    'phase': string;
    /**
     * Whether auto_cycle_player is permitted to drive the world (settings.AUTO_CYCLE_ENABLED). False means the clock only moves when a GM, a command or a script steps it.
     * @type {boolean}
     * @memberof CycleState
     */
    'auto_play_enabled': boolean;
}
/**
 * 
 * @export
 * @interface Data
 */
export interface Data {
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'field1': string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'field2': string;
}
/**
 * Serializer for DateTimeInfo objects
 * @export
 * @interface DateTimeInfo
 */
export interface DateTimeInfo {
    /**
     * 
     * @type {string}
     * @memberof DateTimeInfo
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeInfo
     */
    'active_glow'?: boolean;
    /**
     * Number of sol\'s since the start of the calendar
     * @type {number}
     * @memberof DateTimeInfo
     */
    'sol'?: number;
    /**
     * Number of solar years since the start of the calendar
     * @type {number}
     * @memberof DateTimeInfo
     */
    'solar_year'?: number;
}
/**
 * Serializer for DateTimeInfo objects
 * @export
 * @interface DateTimeInfoRequest
 */
export interface DateTimeInfoRequest {
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeInfoRequest
     */
    'active_glow'?: boolean;
    /**
     * Number of sol\'s since the start of the calendar
     * @type {number}
     * @memberof DateTimeInfoRequest
     */
    'sol'?: number;
    /**
     * Number of solar years since the start of the calendar
     * @type {number}
     * @memberof DateTimeInfoRequest
     */
    'solar_year'?: number;
}
/**
 * 
 * @export
 * @interface Deck
 */
export interface Deck {
    /**
     * 
     * @type {string}
     * @memberof Deck
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Deck
     */
    'name'?: string;
    /**
     * The deck used for matchmaking
     * @type {boolean}
     * @memberof Deck
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {Array<DeckCard>}
     * @memberof Deck
     */
    'deck_cards': Array<DeckCard>;
    /**
     * 
     * @type {number}
     * @memberof Deck
     */
    'card_count': number;
}
/**
 * 
 * @export
 * @interface DeckCard
 */
export interface DeckCard {
    /**
     * 
     * @type {string}
     * @memberof DeckCard
     */
    'id': string;
    /**
     * 
     * @type {CardList}
     * @memberof DeckCard
     */
    'card': CardList;
    /**
     * 
     * @type {number}
     * @memberof DeckCard
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface DeckCardRequest
 */
export interface DeckCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DeckCardRequest
     */
    'card_id': string;
    /**
     * 
     * @type {number}
     * @memberof DeckCardRequest
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface DeckRequest
 */
export interface DeckRequest {
    /**
     * 
     * @type {string}
     * @memberof DeckRequest
     */
    'name'?: string;
    /**
     * The deck used for matchmaking
     * @type {boolean}
     * @memberof DeckRequest
     */
    'is_active'?: boolean;
}
/**
 * Shape compatibility for the currently deployed clients. Sourced from the approved snapshot, not from the live biography. Removed alongside 0055.
 * @export
 * @interface DeprecatedPublicBiography
 */
export interface DeprecatedPublicBiography {
    /**
     * 
     * @type {string}
     * @memberof DeprecatedPublicBiography
     */
    'background': string;
    /**
     * 
     * @type {string}
     * @memberof DeprecatedPublicBiography
     */
    'appearance': string;
    /**
     * 
     * @type {string}
     * @memberof DeprecatedPublicBiography
     */
    'avatar': string | null;
}
/**
 * 
 * @export
 * @interface DetailStat
 */
export interface DetailStat {
    /**
     * 
     * @type {string}
     * @memberof DetailStat
     */
    'id': string;
    /**
     * 
     * @type {Array<CharacterDiceRollResult>}
     * @memberof DetailStat
     */
    'dice_rolls': Array<CharacterDiceRollResult>;
    /**
     * 
     * @type {number}
     * @memberof DetailStat
     */
    'value': number;
    /**
     * 
     * @type {CharacterStatEnum}
     * @memberof DetailStat
     */
    'name'?: CharacterStatEnum;
    /**
     * 
     * @type {number}
     * @memberof DetailStat
     */
    'additional_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof DetailStat
     */
    'base_value'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetailStat
     */
    'character': string;
}


/**
 * 
 * @export
 * @interface DetailedBargain
 */
export interface DetailedBargain {
    /**
     * 
     * @type {string}
     * @memberof DetailedBargain
     */
    'id': string;
    /**
     * 
     * @type {Array<DetailedOfferedItem>}
     * @memberof DetailedBargain
     */
    'side_a_offered_items': Array<DetailedOfferedItem>;
    /**
     * 
     * @type {Array<DetailedOfferedItem>}
     * @memberof DetailedBargain
     */
    'side_b_offered_items': Array<DetailedOfferedItem>;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedBargain
     */
    'side_a_accepted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedBargain
     */
    'side_b_accepted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedBargain
     */
    'cancelled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedBargain
     */
    'completed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailedBargain
     */
    'side_a'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedBargain
     */
    'side_b'?: string | null;
}
/**
 * 
 * @export
 * @interface DetailedLongRestOffer
 */
export interface DetailedLongRestOffer {
    /**
     * 
     * @type {string}
     * @memberof DetailedLongRestOffer
     */
    'id': string;
    /**
     * 
     * @type {Array<DetailedLongRestProvision>}
     * @memberof DetailedLongRestOffer
     */
    'provisions': Array<DetailedLongRestProvision>;
    /**
     * 
     * @type {number}
     * @memberof DetailedLongRestOffer
     */
    'total_nutrition': number;
    /**
     * 
     * @type {StateF1eEnum}
     * @memberof DetailedLongRestOffer
     */
    'state'?: StateF1eEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailedLongRestOffer
     */
    'character': string;
    /**
     * 
     * @type {string}
     * @memberof DetailedLongRestOffer
     */
    'position'?: string | null;
}


/**
 * 
 * @export
 * @interface DetailedLongRestProvision
 */
export interface DetailedLongRestProvision {
    /**
     * 
     * @type {string}
     * @memberof DetailedLongRestProvision
     */
    'id': string;
    /**
     * 
     * @type {Nested}
     * @memberof DetailedLongRestProvision
     */
    'offer': Nested;
    /**
     * 
     * @type {Nested}
     * @memberof DetailedLongRestProvision
     */
    'world_item': Nested;
}
/**
 * 
 * @export
 * @interface DetailedOfferedItem
 */
export interface DetailedOfferedItem {
    /**
     * 
     * @type {string}
     * @memberof DetailedOfferedItem
     */
    'id': string;
    /**
     * 
     * @type {Nested}
     * @memberof DetailedOfferedItem
     */
    'item': Nested;
    /**
     * 
     * @type {Nested}
     * @memberof DetailedOfferedItem
     */
    'bargain': Nested;
}
/**
 * Serializer for detailed Rank information.  Includes all relevant fields from the Rank model to provide comprehensive information about a character\'s rank.
 * @export
 * @interface DetailedRank
 */
export interface DetailedRank {
    /**
     * 
     * @type {string}
     * @memberof DetailedRank
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailedRank
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof DetailedRank
     */
    'grade': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedRank
     */
    'grade_rank': number;
    /**
     * 
     * @type {string}
     * @memberof DetailedRank
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof DetailedRank
     */
    'experience_needed': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedRank
     */
    'additional_stat_points': number;
}
/**
 * 
 * @export
 * @interface DeterministicReading
 */
export interface DeterministicReading {
    /**
     * 
     * @type {Array<SimulateRoundEntry>}
     * @memberof DeterministicReading
     */
    'rounds': Array<SimulateRoundEntry>;
    /**
     * 
     * @type {number}
     * @memberof DeterministicReading
     */
    'uses': number;
    /**
     * 
     * @type {number}
     * @memberof DeterministicReading
     */
    'fire_rounds': number;
    /**
     * 
     * @type {number}
     * @memberof DeterministicReading
     */
    'accumulate_rounds': number;
    /**
     * 
     * @type {number}
     * @memberof DeterministicReading
     */
    'uses_per_round': number;
    /**
     * 
     * @type {number}
     * @memberof DeterministicReading
     */
    'total_impact': number;
    /**
     * 
     * @type {number}
     * @memberof DeterministicReading
     */
    'total_impact_per_cell': number;
    /**
     * 
     * @type {RoundsToTarget}
     * @memberof DeterministicReading
     */
    'rounds_to_target': RoundsToTarget;
    /**
     * 
     * @type {number}
     * @memberof DeterministicReading
     */
    'knocked_out_at': number | null;
}
/**
 * The outcome of a d20 roll.  Advantage and disadvantage roll a pair of dice, so `rolls` carries every die that was thrown while `dice_side`/`outcome` carry the one that counts.
 * @export
 * @interface DiceRollResponse
 */
export interface DiceRollResponse {
    /**
     * The die that decided the roll
     * @type {number}
     * @memberof DiceRollResponse
     */
    'dice_side': number;
    /**
     * Outcome of the deciding die
     * @type {string}
     * @memberof DiceRollResponse
     */
    'outcome': string;
    /**
     * Every die thrown, in the order they were rolled
     * @type {Array<ActionLogDiceRollResult>}
     * @memberof DiceRollResponse
     */
    'rolls': Array<ActionLogDiceRollResult>;
    /**
     * Rolled a pair and kept the better die
     * @type {boolean}
     * @memberof DiceRollResponse
     */
    'advantage': boolean;
    /**
     * Rolled a pair and kept the worse die
     * @type {boolean}
     * @memberof DiceRollResponse
     */
    'disadvantage': boolean;
}
/**
 * 
 * @export
 * @interface DiceRollResult
 */
export interface DiceRollResult {
    /**
     * 
     * @type {number}
     * @memberof DiceRollResult
     */
    'dice_side': number;
    /**
     * 
     * @type {number}
     * @memberof DiceRollResult
     */
    'multiplier': number | null;
    /**
     * 
     * @type {OutcomeEnum}
     * @memberof DiceRollResult
     */
    'outcome': OutcomeEnum;
}


/**
 * * `easy` - Easy (CR 1-5) * `medium` - Medium (CR 6-10) * `hard` - Hard (CR 11-15) * `deadly` - Deadly (CR 16+) * `custom` - Custom
 * @export
 * @enum {string}
 */

export const DifficultyRatingEnum = {
    Easy: 'easy',
    Medium: 'medium',
    Hard: 'hard',
    Deadly: 'deadly',
    Custom: 'custom'
} as const;

export type DifficultyRatingEnum = typeof DifficultyRatingEnum[keyof typeof DifficultyRatingEnum];


/**
 * 
 * @export
 * @interface Dimension
 */
export interface Dimension {
    /**
     * 
     * @type {number}
     * @memberof Dimension
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Dimension
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Dimension
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof Dimension
     */
    'speed': number;
    /**
     * 
     * @type {number}
     * @memberof Dimension
     */
    'energy': number;
    /**
     * 
     * @type {number}
     * @memberof Dimension
     */
    'shift_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof Dimension
     */
    'grade'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Dimension
     */
    'is_active'?: boolean;
}
/**
 * * `North-West` - North-West * `North` - North * `North-East` - North-East * `East` - East * `West` - West * `South-West` - South-West * `South` - South * `South-East` - South-East * `Up` - Up * `Down` - Down
 * @export
 * @enum {string}
 */

export const DirectionEnum = {
    NorthWest: 'North-West',
    North: 'North',
    NorthEast: 'North-East',
    East: 'East',
    West: 'West',
    SouthWest: 'South-West',
    South: 'South',
    SouthEast: 'South-East',
    Up: 'Up',
    Down: 'Down'
} as const;

export type DirectionEnum = typeof DirectionEnum[keyof typeof DirectionEnum];


/**
 * Serializer for Document objects
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'content': string;
    /**
     * 
     * @type {Array<CategoriesEnum>}
     * @memberof Document
     */
    'categories'?: Array<CategoriesEnum>;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'image'?: string | null;
}
/**
 * Serializer for Document objects
 * @export
 * @interface DocumentRequest
 */
export interface DocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof DocumentRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentRequest
     */
    'content': string;
    /**
     * 
     * @type {Array<CategoriesEnum>}
     * @memberof DocumentRequest
     */
    'categories'?: Array<CategoriesEnum>;
    /**
     * 
     * @type {File}
     * @memberof DocumentRequest
     */
    'image'?: File | null;
}
/**
 * Schema for movement edges between grid cells.
 * @export
 * @interface Edge
 */
export interface Edge {
    /**
     * Source cell X coordinate
     * @type {number}
     * @memberof Edge
     */
    'from_x': number;
    /**
     * Source cell Y coordinate
     * @type {number}
     * @memberof Edge
     */
    'from_y': number;
    /**
     * Target cell X coordinate
     * @type {number}
     * @memberof Edge
     */
    'to_x': number;
    /**
     * Target cell Y coordinate
     * @type {number}
     * @memberof Edge
     */
    'to_y': number;
    /**
     * Layer index (for multi-level maps)
     * @type {number}
     * @memberof Edge
     */
    'layer'?: number;
    /**
     * Direction of movement (north, south, east, west, northEast, etc.)
     * @type {string}
     * @memberof Edge
     */
    'direction'?: string | null;
    /**
     * Whether the edge is blocked/impassable
     * @type {boolean}
     * @memberof Edge
     */
    'blocked'?: boolean;
    /**
     * Additional movement cost for this edge
     * @type {number}
     * @memberof Edge
     */
    'cost'?: number | null;
    /**
     * Edge description or special properties
     * @type {string}
     * @memberof Edge
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface Effect
 */
export interface Effect {
    /**
     * 
     * @type {EffectEnum}
     * @memberof Effect
     */
    'id'?: EffectEnum;
    /**
     * 
     * @type {string}
     * @memberof Effect
     */
    'icon'?: string | null;
    /**
     * What the effect does, shown to players and the game master.
     * @type {string}
     * @memberof Effect
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Effect
     */
    'permanent'?: boolean;
    /**
     * Whether the bearer wants this effect. Decides what a long rest cleanses; ``permanent`` decides whether it can be cleansed at all.  * `positive` - positive * `negative` - negative * `neutral` - neutral
     * @type {PolarityEnum}
     * @memberof Effect
     */
    'polarity'?: PolarityEnum;
    /**
     * 
     * @type {number}
     * @memberof Effect
     */
    'ends_in'?: number | null;
}


/**
 * * `Knocked out` - Knocked out * `Coma` - Coma * `None` - None * `Burning` - Burning * `Poisoned` - Poisoned * `Sleeping` - Sleeping * `Confused` - Confused * `Paralyzed` - Paralyzed * `Fear` - Fear * `Slowness` - Slowness * `Cold` - Cold * `Cursed` - Cursed * `Blindness` - Blindness * `Haste` - Haste * `Regeneration` - Regeneration * `Blessed` - Blessed * `Arcane Surge` - Arcane Surge * `Marked` - Marked * `Bleeding` - Bleeding * `Weakened` - Weakened * `Enervated` - Enervated * `Dazzled` - Dazzled * `Exhausted` - Exhausted * `InchFromDeath` - InchFromDeath * `ComaShock` - ComaShock * `WellRested` - WellRested
 * @export
 * @enum {string}
 */

export const EffectEnum = {
    KnockedOut: 'Knocked out',
    Coma: 'Coma',
    None: 'None',
    Burning: 'Burning',
    Poisoned: 'Poisoned',
    Sleeping: 'Sleeping',
    Confused: 'Confused',
    Paralyzed: 'Paralyzed',
    Fear: 'Fear',
    Slowness: 'Slowness',
    Cold: 'Cold',
    Cursed: 'Cursed',
    Blindness: 'Blindness',
    Haste: 'Haste',
    Regeneration: 'Regeneration',
    Blessed: 'Blessed',
    ArcaneSurge: 'Arcane Surge',
    Marked: 'Marked',
    Bleeding: 'Bleeding',
    Weakened: 'Weakened',
    Enervated: 'Enervated',
    Dazzled: 'Dazzled',
    Exhausted: 'Exhausted',
    InchFromDeath: 'InchFromDeath',
    ComaShock: 'ComaShock',
    WellRested: 'WellRested'
} as const;

export type EffectEnum = typeof EffectEnum[keyof typeof EffectEnum];


/**
 * Serializer for EffectReward model.
 * @export
 * @interface EffectReward
 */
export interface EffectReward {
    /**
     * 
     * @type {string}
     * @memberof EffectReward
     */
    'id': string;
    /**
     * 
     * @type {EffectEnum}
     * @memberof EffectReward
     */
    'effect': EffectEnum;
    /**
     * Duration of the effect in turns
     * @type {number}
     * @memberof EffectReward
     */
    'duration'?: number;
    /**
     * 
     * @type {string}
     * @memberof EffectReward
     */
    'reward'?: string | null;
}


/**
 * Serializer for EffectReward model.
 * @export
 * @interface EffectRewardRequest
 */
export interface EffectRewardRequest {
    /**
     * 
     * @type {EffectEnum}
     * @memberof EffectRewardRequest
     */
    'effect': EffectEnum;
    /**
     * Duration of the effect in turns
     * @type {number}
     * @memberof EffectRewardRequest
     */
    'duration'?: number;
    /**
     * 
     * @type {string}
     * @memberof EffectRewardRequest
     */
    'reward'?: string | null;
}


/**
 * Serializer for detailed efficiency calculation breakdown.  Shows how each stat contributes to the final impact value, including ratio calculations and capping information.
 * @export
 * @interface EfficiencyBreakdown
 */
export interface EfficiencyBreakdown {
    /**
     * Name of the stat being evaluated
     * @type {string}
     * @memberof EfficiencyBreakdown
     */
    'stat_name': string;
    /**
     * The character\'s value for this stat
     * @type {number}
     * @memberof EfficiencyBreakdown
     */
    'character_value': number;
    /**
     * The skill\'s required value for this stat
     * @type {number}
     * @memberof EfficiencyBreakdown
     */
    'required_value': number;
    /**
     * The ratio of character_value / required_value
     * @type {number}
     * @memberof EfficiencyBreakdown
     */
    'ratio': number;
    /**
     * The scaling factor applied to this stat
     * @type {number}
     * @memberof EfficiencyBreakdown
     */
    'scaling_factor': number;
    /**
     * The calculated efficiency for this stat (before multiplying with base value)
     * @type {number}
     * @memberof EfficiencyBreakdown
     */
    'calculated_efficiency': number;
    /**
     * Whether the efficiency was capped at the maximum allowed value
     * @type {boolean}
     * @memberof EfficiencyBreakdown
     */
    'capped_at_max': boolean;
    /**
     * Whether the efficiency was capped at the minimum allowed value
     * @type {boolean}
     * @memberof EfficiencyBreakdown
     */
    'capped_at_min': boolean;
}
/**
 * * `fire` - fire * `water` - water * `energy` - energy * `physical` - physical * `psychic` - psychic * `dark` - dark * `heal` - heal
 * @export
 * @enum {string}
 */

export const ElementEnum = {
    Fire: 'fire',
    Water: 'water',
    Energy: 'energy',
    Physical: 'physical',
    Psychic: 'psychic',
    Dark: 'dark',
    Heal: 'heal'
} as const;

export type ElementEnum = typeof ElementEnum[keyof typeof ElementEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const EventCategory = {
    Character: 'character',
    Location: 'location',
    Fight: 'fight',
    Game: 'game',
    World: 'world'
} as const;

export type EventCategory = typeof EventCategory[keyof typeof EventCategory];


/**
 * * `chosen_ones` - chosen_ones * `enhanced_machines` - enhanced_machines * `era_clan` - era_clan * `neutral` - neutral
 * @export
 * @enum {string}
 */

export const FactionEnum = {
    ChosenOnes: 'chosen_ones',
    EnhancedMachines: 'enhanced_machines',
    EraClan: 'era_clan',
    Neutral: 'neutral'
} as const;

export type FactionEnum = typeof FactionEnum[keyof typeof FactionEnum];


/**
 * What the console sends, and what it gets back.  The client chooses only the channel, the message and the screen it was written on; who sent it, where from and how it fared are the server\'s to say.
 * @export
 * @interface Feedback
 */
export interface Feedback {
    /**
     * 
     * @type {string}
     * @memberof Feedback
     */
    'id': string;
    /**
     * 
     * @type {ChannelEnum}
     * @memberof Feedback
     */
    'channel'?: ChannelEnum;
    /**
     * 
     * @type {string}
     * @memberof Feedback
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof Feedback
     */
    'route'?: string;
    /**
     * 
     * @type {FeedbackStatusEnum}
     * @memberof Feedback
     */
    'status': FeedbackStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Feedback
     */
    'created_at': string;
}


/**
 * What the console sends, and what it gets back.  The client chooses only the channel, the message and the screen it was written on; who sent it, where from and how it fared are the server\'s to say.
 * @export
 * @interface FeedbackRequest
 */
export interface FeedbackRequest {
    /**
     * 
     * @type {ChannelEnum}
     * @memberof FeedbackRequest
     */
    'channel'?: ChannelEnum;
    /**
     * 
     * @type {string}
     * @memberof FeedbackRequest
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackRequest
     */
    'route'?: string;
}


/**
 * * `new` - New * `triaged` - Triaged * `closed` - Closed
 * @export
 * @enum {string}
 */

export const FeedbackStatusEnum = {
    New: 'new',
    Triaged: 'triaged',
    Closed: 'closed'
} as const;

export type FeedbackStatusEnum = typeof FeedbackStatusEnum[keyof typeof FeedbackStatusEnum];


/**
 * Pick an already-existing side while pending. See ``FightSideChoiceService.choose_existing``.
 * @export
 * @interface FightChooseSideRequest
 */
export interface FightChooseSideRequest {
    /**
     * 
     * @type {string}
     * @memberof FightChooseSideRequest
     */
    'side_id': string;
}
/**
 * Create a new side and pick it in one call. ``name`` defaults to the caller\'s organization, or ``\"<name> and allies\"`` if they have none — see ``FightSideChoiceService.create_and_choose`` and ``default_side_name(character, allies_suffix=True)``.
 * @export
 * @interface FightCreateSideRequest
 */
export interface FightCreateSideRequest {
    /**
     * 
     * @type {string}
     * @memberof FightCreateSideRequest
     */
    'name'?: string;
}
/**
 * Mirrors ``FightDeathSaveProgressDTO`` — a downed character\'s tally.
 * @export
 * @interface FightDeathSaveProgress
 */
export interface FightDeathSaveProgress {
    /**
     * 
     * @type {number}
     * @memberof FightDeathSaveProgress
     */
    'failures': number;
    /**
     * 
     * @type {number}
     * @memberof FightDeathSaveProgress
     */
    'successes': number;
    /**
     * 
     * @type {boolean}
     * @memberof FightDeathSaveProgress
     */
    'pending': boolean;
}
/**
 * The observed ``(round, phase)`` the client is ending a turn against.  Both are required. Ending a turn \"against whatever the fight is on now\" is exactly the race this endpoint exists to detect: the client must say what it believed, so the server can answer 409 when it believed wrong.
 * @export
 * @interface FightEndTurnRequest
 */
export interface FightEndTurnRequest {
    /**
     * 
     * @type {number}
     * @memberof FightEndTurnRequest
     */
    'round': number;
    /**
     * 
     * @type {Phase347Enum}
     * @memberof FightEndTurnRequest
     */
    'phase': Phase347Enum;
}


/**
 * Somebody asked for the fight to be over, or took it back.  Position-scoped like ``fight_turn_ended``: everyone watching needs the tally, not only the voter, or the last holdout never learns they are the one being waited for.
 * @export
 * @interface FightEndVoteEvent
 */
export interface FightEndVoteEvent {
    /**
     * 
     * @type {string}
     * @memberof FightEndVoteEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FightEndVoteEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof FightEndVoteEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof FightEndVoteEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsFightEndVoteEventData}
     * @memberof FightEndVoteEvent
     */
    'data': WsFightEndVoteEventData;
}


/**
 * Request body for the end-fight vote. ``agree=False`` withdraws one.
 * @export
 * @interface FightEndVoteRequest
 */
export interface FightEndVoteRequest {
    /**
     * 
     * @type {boolean}
     * @memberof FightEndVoteRequest
     */
    'agree'?: boolean;
}
/**
 * Mirrors ``FightEndVoteDTO`` — the tally after the vote was recorded.
 * @export
 * @interface FightEndVoteResult
 */
export interface FightEndVoteResult {
    /**
     * 
     * @type {string}
     * @memberof FightEndVoteResult
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof FightEndVoteResult
     */
    'character_id': string;
    /**
     * 
     * @type {number}
     * @memberof FightEndVoteResult
     */
    'round': number;
    /**
     * 
     * @type {boolean}
     * @memberof FightEndVoteResult
     */
    'agreed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FightEndVoteResult
     */
    'applied': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FightEndVoteResult
     */
    'eligible': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FightEndVoteResult
     */
    'voted': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof FightEndVoteResult
     */
    'voted_count': number;
    /**
     * 
     * @type {number}
     * @memberof FightEndVoteResult
     */
    'required_count': number;
    /**
     * 
     * @type {boolean}
     * @memberof FightEndVoteResult
     */
    'passed': boolean;
    /**
     * 
     * @type {FightState}
     * @memberof FightEndVoteResult
     */
    'state': FightState;
}
/**
 * 
 * @export
 * @interface FightEndedEvent
 */
export interface FightEndedEvent {
    /**
     * 
     * @type {string}
     * @memberof FightEndedEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FightEndedEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof FightEndedEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof FightEndedEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsFightEndedEventData}
     * @memberof FightEndedEvent
     */
    'data': WsFightEndedEventData;
}


/**
 * 
 * @export
 * @interface FightGeneric
 */
export interface FightGeneric {
    /**
     * 
     * @type {string}
     * @memberof FightGeneric
     */
    'id': string;
    /**
     * 
     * @type {Array<Fighter>}
     * @memberof FightGeneric
     */
    'joined': Array<Fighter>;
    /**
     * 
     * @type {Array<Fighter>}
     * @memberof FightGeneric
     */
    'pending_join': Array<Fighter>;
    /**
     * 
     * @type {Fighter}
     * @memberof FightGeneric
     */
    'attacker': Fighter;
    /**
     * 
     * @type {Fighter}
     * @memberof FightGeneric
     */
    'defender': Fighter;
    /**
     * 
     * @type {string}
     * @memberof FightGeneric
     */
    'position_name': string;
    /**
     * 
     * @type {string}
     * @memberof FightGeneric
     */
    'location_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof FightGeneric
     */
    'duel'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FightGeneric
     */
    'training'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FightGeneric
     */
    'current_round'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FightGeneric
     */
    'open'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FightGeneric
     */
    'sealed'?: boolean;
    /**
     * 
     * @type {Phase347Enum}
     * @memberof FightGeneric
     */
    'phase'?: Phase347Enum;
    /**
     * 
     * @type {string}
     * @memberof FightGeneric
     */
    'phase_started_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FightGeneric
     */
    'phase_deadline_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FightGeneric
     */
    'phase_timeout_seconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof FightGeneric
     */
    'round_started_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FightGeneric
     */
    'inactive_rounds'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FightGeneric
     */
    'round_activity'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FightGeneric
     */
    'inactivity_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof FightGeneric
     */
    'max_rounds'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FightGeneric
     */
    'snapshot'?: any;
    /**
     * 
     * @type {string}
     * @memberof FightGeneric
     */
    'worker_lease_until'?: string | null;
    /**
     * 
     * @type {FightGenericOutcome}
     * @memberof FightGeneric
     */
    'outcome'?: FightGenericOutcome | null;
    /**
     * 
     * @type {string}
     * @memberof FightGeneric
     */
    'ended_at_ts'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FightGeneric
     */
    'campaign': string;
    /**
     * 
     * @type {string}
     * @memberof FightGeneric
     */
    'position': string;
    /**
     * 
     * @type {string}
     * @memberof FightGeneric
     */
    'winner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FightGeneric
     */
    'winner_side'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FightGeneric
     */
    'created'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FightGeneric
     */
    'ended_at'?: number | null;
}


/**
 * @type FightGenericOutcome
 * @export
 */
export type FightGenericOutcome = BlankEnum | OutcomeCc4Enum;

/**
 * Read-only projection of a challenge. Answering one is an ordinary ``MAKE``/``ACCEPT``/``REJECT_DUEL_INVITATION`` character action — this serializer exists so a client (or a GM) can see what is pending without guessing from the action log.
 * @export
 * @interface FightInvitation
 */
export interface FightInvitation {
    /**
     * 
     * @type {string}
     * @memberof FightInvitation
     */
    'id': string;
    /**
     * 
     * @type {Fighter}
     * @memberof FightInvitation
     */
    'inviter': Fighter;
    /**
     * 
     * @type {Fighter}
     * @memberof FightInvitation
     */
    'invitee': Fighter;
    /**
     * 
     * @type {boolean}
     * @memberof FightInvitation
     */
    'duel': boolean;
    /**
     * 
     * @type {FightInvitationStateEnum}
     * @memberof FightInvitation
     */
    'state': FightInvitationStateEnum;
    /**
     * 
     * @type {string}
     * @memberof FightInvitation
     */
    'expires_at': string;
    /**
     * 
     * @type {string}
     * @memberof FightInvitation
     */
    'fight': string | null;
    /**
     * 
     * @type {string}
     * @memberof FightInvitation
     */
    'created_at': string;
}


/**
 * 
 * @export
 * @interface FightInvitationAnsweredEvent
 */
export interface FightInvitationAnsweredEvent {
    /**
     * 
     * @type {string}
     * @memberof FightInvitationAnsweredEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FightInvitationAnsweredEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof FightInvitationAnsweredEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof FightInvitationAnsweredEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsFightInvitationAnsweredEventData}
     * @memberof FightInvitationAnsweredEvent
     */
    'data': WsFightInvitationAnsweredEventData;
}


/**
 * 
 * @export
 * @interface FightInvitationReceivedEvent
 */
export interface FightInvitationReceivedEvent {
    /**
     * 
     * @type {string}
     * @memberof FightInvitationReceivedEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FightInvitationReceivedEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof FightInvitationReceivedEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof FightInvitationReceivedEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsFightInvitationReceivedEventData}
     * @memberof FightInvitationReceivedEvent
     */
    'data': WsFightInvitationReceivedEventData;
}


/**
 * * `pending` - pending * `accepted` - accepted * `rejected` - rejected * `expired` - expired
 * @export
 * @enum {string}
 */

export const FightInvitationStateEnum = {
    Pending: 'pending',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Expired: 'expired'
} as const;

export type FightInvitationStateEnum = typeof FightInvitationStateEnum[keyof typeof FightInvitationStateEnum];


/**
 * Mirrors ``FightParticipantDTO``. Read-only: the clock projects it.
 * @export
 * @interface FightParticipant
 */
export interface FightParticipant {
    /**
     * 
     * @type {string}
     * @memberof FightParticipant
     */
    'character_id': string;
    /**
     * 
     * @type {string}
     * @memberof FightParticipant
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof FightParticipant
     */
    'npc': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FightParticipant
     */
    'alive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FightParticipant
     */
    'ended_turn': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FightParticipant
     */
    'standing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FightParticipant
     */
    'comatose': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FightParticipant
     */
    'end_vote': boolean;
    /**
     * 
     * @type {FightDeathSaveProgress}
     * @memberof FightParticipant
     */
    'death_save': FightDeathSaveProgress;
    /**
     * 
     * @type {string}
     * @memberof FightParticipant
     */
    'side_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof FightParticipant
     */
    'power': number;
    /**
     * 
     * @type {number}
     * @memberof FightParticipant
     */
    'downed_damage': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FightParticipant
     */
    'breakthrough_used': boolean;
}
/**
 * 
 * @export
 * @interface FightParticipantSideChangedEvent
 */
export interface FightParticipantSideChangedEvent {
    /**
     * 
     * @type {string}
     * @memberof FightParticipantSideChangedEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FightParticipantSideChangedEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof FightParticipantSideChangedEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof FightParticipantSideChangedEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsFightParticipantSideChangedEventData}
     * @memberof FightParticipantSideChangedEvent
     */
    'data': WsFightParticipantSideChangedEventData;
}


/**
 * 
 * @export
 * @interface FightRoundAdvancedEvent
 */
export interface FightRoundAdvancedEvent {
    /**
     * 
     * @type {string}
     * @memberof FightRoundAdvancedEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FightRoundAdvancedEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof FightRoundAdvancedEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof FightRoundAdvancedEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsFightRoundAdvancedEventData}
     * @memberof FightRoundAdvancedEvent
     */
    'data': WsFightRoundAdvancedEventData;
}


/**
 * Mirrors ``FightSideDTO`` — the donut/side-rail shape. Read-only: the clock projects it from ``apps.game.services.fight.side_summary``.
 * @export
 * @interface FightSide
 */
export interface FightSide {
    /**
     * 
     * @type {string}
     * @memberof FightSide
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof FightSide
     */
    'slot': number;
    /**
     * 
     * @type {string}
     * @memberof FightSide
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FightSide
     */
    'organization_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof FightSide
     */
    'lead_character_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof FightSide
     */
    'member_count': number;
    /**
     * 
     * @type {number}
     * @memberof FightSide
     */
    'power': number;
    /**
     * 
     * @type {number}
     * @memberof FightSide
     */
    'power_share': number;
}
/**
 * 
 * @export
 * @interface FightSideCreatedEvent
 */
export interface FightSideCreatedEvent {
    /**
     * 
     * @type {string}
     * @memberof FightSideCreatedEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FightSideCreatedEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof FightSideCreatedEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof FightSideCreatedEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsFightSideCreatedEventData}
     * @memberof FightSideCreatedEvent
     */
    'data': WsFightSideCreatedEventData;
}


/**
 * 
 * @export
 * @interface FightSideUpdatedEvent
 */
export interface FightSideUpdatedEvent {
    /**
     * 
     * @type {string}
     * @memberof FightSideUpdatedEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FightSideUpdatedEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof FightSideUpdatedEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof FightSideUpdatedEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsFightSideUpdatedEventData}
     * @memberof FightSideUpdatedEvent
     */
    'data': WsFightSideUpdatedEventData;
}


/**
 * 
 * @export
 * @interface FightStartedEvent
 */
export interface FightStartedEvent {
    /**
     * 
     * @type {string}
     * @memberof FightStartedEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FightStartedEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof FightStartedEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof FightStartedEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsFightStartedEventData}
     * @memberof FightStartedEvent
     */
    'data': WsFightStartedEventData;
}


/**
 * Mirrors ``FightStateDTO`` for the OpenAPI contract.  ``phase_ends_at`` is an absolute instant and ``server_time`` is the clock it was measured against. The client subtracts the two once to learn its skew and never reads its own wall clock again (NFR-UX-1). There is deliberately no \"seconds remaining\" field — it would be stale before it reached the browser.
 * @export
 * @interface FightState
 */
export interface FightState {
    /**
     * 
     * @type {string}
     * @memberof FightState
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof FightState
     */
    'campaign_id': string;
    /**
     * 
     * @type {string}
     * @memberof FightState
     */
    'position_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof FightState
     */
    'duel': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FightState
     */
    'training': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FightState
     */
    'sealed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FightState
     */
    'open': boolean;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'round': number;
    /**
     * 
     * @type {string}
     * @memberof FightState
     */
    'phase': string;
    /**
     * 
     * @type {string}
     * @memberof FightState
     */
    'phase_started_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof FightState
     */
    'phase_ends_at': string | null;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'phase_timeout_seconds': number;
    /**
     * 
     * @type {string}
     * @memberof FightState
     */
    'server_time': string;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'inactive_rounds': number;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'inactivity_limit': number;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'max_rounds': number | null;
    /**
     * 
     * @type {string}
     * @memberof FightState
     */
    'outcome': string | null;
    /**
     * 
     * @type {string}
     * @memberof FightState
     */
    'winner_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof FightState
     */
    'ended_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof FightState
     */
    'tactical_map': string | null;
    /**
     * 
     * @type {Array<FightParticipant>}
     * @memberof FightState
     */
    'participants': Array<FightParticipant>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FightState
     */
    'ended_turns': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'ended_turn_count': number;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'participant_count': number;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'end_vote_round': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof FightState
     */
    'end_vote_eligible': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FightState
     */
    'end_votes': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'end_vote_count': number;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'end_vote_required': number;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'death_save_difficulty': number;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'death_save_failures_to_coma': number;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'death_save_successes_to_recover': number;
    /**
     * 
     * @type {Array<FightSide>}
     * @memberof FightState
     */
    'sides': Array<FightSide>;
    /**
     * 
     * @type {string}
     * @memberof FightState
     */
    'round_started_at': string | null;
    /**
     * 
     * @type {number}
     * @memberof FightState
     */
    'round_duration_seconds': number;
    /**
     * 
     * @type {string}
     * @memberof FightState
     */
    'winner_side_id': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FightState
     */
    'may_choose_side': boolean;
}
/**
 * 
 * @export
 * @interface FightTurnActionResultGameEvent
 */
export interface FightTurnActionResultGameEvent {
    /**
     * 
     * @type {string}
     * @memberof FightTurnActionResultGameEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FightTurnActionResultGameEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof FightTurnActionResultGameEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof FightTurnActionResultGameEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsTurnActionResultGameEventData}
     * @memberof FightTurnActionResultGameEvent
     */
    'data': WsTurnActionResultGameEventData;
}


/**
 * 
 * @export
 * @interface FightTurnEndedEvent
 */
export interface FightTurnEndedEvent {
    /**
     * 
     * @type {string}
     * @memberof FightTurnEndedEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FightTurnEndedEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof FightTurnEndedEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof FightTurnEndedEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsFightTurnEndedEventData}
     * @memberof FightTurnEndedEvent
     */
    'data': WsFightTurnEndedEventData;
}


/**
 * Mirrors ``FightTurnResultDTO``.
 * @export
 * @interface FightTurnResult
 */
export interface FightTurnResult {
    /**
     * 
     * @type {string}
     * @memberof FightTurnResult
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof FightTurnResult
     */
    'character_id': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FightTurnResult
     */
    'applied': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FightTurnResult
     */
    'automatic': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FightTurnResult
     */
    'advanced': boolean;
    /**
     * 
     * @type {number}
     * @memberof FightTurnResult
     */
    'observed_round': number;
    /**
     * 
     * @type {string}
     * @memberof FightTurnResult
     */
    'observed_phase': string;
    /**
     * 
     * @type {FightState}
     * @memberof FightTurnResult
     */
    'state': FightState;
}
/**
 * What one pass of the fight clock actually did.  The same counters ``FightWorkerService.tick`` returns, named rather than handed over as an opaque dict — a GM pressing \"advance\" needs to be able to tell \"nothing was owing\" from \"a fight closed\".
 * @export
 * @interface FightWorkerTickCounts
 */
export interface FightWorkerTickCounts {
    /**
     * Fights claimed and looked at
     * @type {number}
     * @memberof FightWorkerTickCounts
     */
    'examined': number;
    /**
     * Fights whose clock had never been started
     * @type {number}
     * @memberof FightWorkerTickCounts
     */
    'rescued': number;
    /**
     * Phases advanced
     * @type {number}
     * @memberof FightWorkerTickCounts
     */
    'advanced': number;
    /**
     * Turns ended on a participant\'s behalf
     * @type {number}
     * @memberof FightWorkerTickCounts
     */
    'auto_ended': number;
    /**
     * Fights closed (inactivity or round limit)
     * @type {number}
     * @memberof FightWorkerTickCounts
     */
    'closed': number;
    /**
     * Advances refused because the phase had already moved on
     * @type {number}
     * @memberof FightWorkerTickCounts
     */
    'conflicts': number;
    /**
     * Fights left alone (throttled, leased elsewhere, or not sealed)
     * @type {number}
     * @memberof FightWorkerTickCounts
     */
    'skipped': number;
    /**
     * Fights that raised
     * @type {number}
     * @memberof FightWorkerTickCounts
     */
    'errors': number;
    /**
     * Overdue duel invitations expired (whole-tick only)
     * @type {number}
     * @memberof FightWorkerTickCounts
     */
    'invitations_expired'?: number;
}
/**
 * 
 * @export
 * @interface Fighter
 */
export interface Fighter {
    /**
     * 
     * @type {string}
     * @memberof Fighter
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Fighter
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Fighter
     */
    'path_name': string;
    /**
     * 
     * @type {string}
     * @memberof Fighter
     */
    'rank_name': string;
    /**
     * 
     * @type {string}
     * @memberof Fighter
     */
    'avatar': string;
    /**
     * 
     * @type {boolean}
     * @memberof Fighter
     */
    'alive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Fighter
     */
    'game_master_mode': boolean;
}
/**
 * Serializer for Formula DTO.
 * @export
 * @interface Formula
 */
export interface Formula {
    /**
     * 
     * @type {number}
     * @memberof Formula
     */
    'base': number;
    /**
     * 
     * @type {Array<StatRequirement>}
     * @memberof Formula
     */
    'requires': Array<StatRequirement>;
    /**
     * 
     * @type {Array<Scaling>}
     * @memberof Formula
     */
    'scaling': Array<Scaling>;
    /**
     * 
     * @type {number}
     * @memberof Formula
     */
    'max_efficiency'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Formula
     */
    'min_efficiency'?: number | null;
}
/**
 * Serializer for formula calculations.
 * @export
 * @interface FormulaRequest
 */
export interface FormulaRequest {
    /**
     * 
     * @type {number}
     * @memberof FormulaRequest
     */
    'base': number;
    /**
     * 
     * @type {Array<StatRequirementRequest>}
     * @memberof FormulaRequest
     */
    'requires'?: Array<StatRequirementRequest>;
    /**
     * 
     * @type {Array<ScalingRequest>}
     * @memberof FormulaRequest
     */
    'scaling'?: Array<ScalingRequest>;
    /**
     * 
     * @type {number}
     * @memberof FormulaRequest
     */
    'max_efficiency'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormulaRequest
     */
    'min_efficiency'?: number | null;
}
/**
 * Mirrors the `FullCharacterInfo` DTO carried by the `character_changed` event.
 * @export
 * @interface FullCharacterInfo
 */
export interface FullCharacterInfo {
    /**
     * 
     * @type {string}
     * @memberof FullCharacterInfo
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FullCharacterInfo
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof FullCharacterInfo
     */
    'rank_grade': number;
    /**
     * 
     * @type {Array<Attribute>}
     * @memberof FullCharacterInfo
     */
    'attributes': Array<Attribute>;
    /**
     * 
     * @type {number}
     * @memberof FullCharacterInfo
     */
    'dimension': number;
    /**
     * 
     * @type {string}
     * @memberof FullCharacterInfo
     */
    'position': string | null;
    /**
     * 
     * @type {Coordinate}
     * @memberof FullCharacterInfo
     */
    'coordinates': Coordinate | null;
    /**
     * 
     * @type {string}
     * @memberof FullCharacterInfo
     */
    'fight': string | null;
    /**
     * 
     * @type {string}
     * @memberof FullCharacterInfo
     */
    'screen': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FullCharacterInfo
     */
    'game_master_mode': boolean;
}
/**
 * Serializer for available character list
 * @export
 * @interface GMAvailableCharacter
 */
export interface GMAvailableCharacter {
    /**
     * 
     * @type {string}
     * @memberof GMAvailableCharacter
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GMAvailableCharacter
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GMAvailableCharacter
     */
    'avatar': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GMAvailableCharacter
     */
    'is_npc': boolean;
    /**
     * 
     * @type {string}
     * @memberof GMAvailableCharacter
     */
    'position_id': string;
    /**
     * 
     * @type {string}
     * @memberof GMAvailableCharacter
     */
    'campaign_id': string;
    /**
     * 
     * @type {number}
     * @memberof GMAvailableCharacter
     */
    'health_current': number;
    /**
     * 
     * @type {number}
     * @memberof GMAvailableCharacter
     */
    'health_max': number;
    /**
     * 
     * @type {number}
     * @memberof GMAvailableCharacter
     */
    'energy_current': number;
    /**
     * 
     * @type {number}
     * @memberof GMAvailableCharacter
     */
    'energy_max': number;
}
/**
 * Serializer for character switch request
 * @export
 * @interface GMCharacterSwitchRequestRequest
 */
export interface GMCharacterSwitchRequestRequest {
    /**
     * ID of the character to switch to
     * @type {string}
     * @memberof GMCharacterSwitchRequestRequest
     */
    'character_id': string;
}
/**
 * Serializer for character switch response
 * @export
 * @interface GMCharacterSwitchResponse
 */
export interface GMCharacterSwitchResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GMCharacterSwitchResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof GMCharacterSwitchResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof GMCharacterSwitchResponse
     */
    'character_id': string;
    /**
     * 
     * @type {string}
     * @memberof GMCharacterSwitchResponse
     */
    'character_name': string;
}
/**
 * 
 * @export
 * @interface GameCycle
 */
export interface GameCycle {
    /**
     * 
     * @type {number}
     * @memberof GameCycle
     */
    'id': number;
    /**
     * 
     * @type {boolean}
     * @memberof GameCycle
     */
    'is_current': boolean;
    /**
     * 
     * @type {string}
     * @memberof GameCycle
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof GameCycle
     */
    'updated_at': string;
    /**
     * Cycle number in the campaign
     * @type {number}
     * @memberof GameCycle
     */
    'number': number;
    /**
     * 
     * @type {string}
     * @memberof GameCycle
     */
    'phase': string;
    /**
     * 
     * @type {string}
     * @memberof GameCycle
     */
    'campaign': string;
}
/**
 * 
 * @export
 * @interface GameEventRequest
 */
export interface GameEventRequest {
    /**
     * 
     * @type {string}
     * @memberof GameEventRequest
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GameEventRequest
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof GameEventRequest
     */
    'id'?: string;
    /**
     * 
     * @type {EventCategory}
     * @memberof GameEventRequest
     */
    'category'?: EventCategory;
    /**
     * 
     * @type {Data}
     * @memberof GameEventRequest
     */
    'data': Data;
}


/**
 * 
 * @export
 * @interface GameMasterChallengeResponse
 */
export interface GameMasterChallengeResponse {
    /**
     * 
     * @type {string}
     * @memberof GameMasterChallengeResponse
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof GameMasterChallengeResponse
     */
    'difficulty': number;
    /**
     * 
     * @type {string}
     * @memberof GameMasterChallengeResponse
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterChallengeResponse
     */
    'dice_sides': number;
    /**
     * 
     * @type {Nested}
     * @memberof GameMasterChallengeResponse
     */
    'outcome': Nested;
    /**
     * 
     * @type {CharacterStatEnum}
     * @memberof GameMasterChallengeResponse
     */
    'stat': CharacterStatEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterChallengeResponse
     */
    'advantage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterChallengeResponse
     */
    'disadvantage': boolean;
    /**
     * 
     * @type {Array<Nested>}
     * @memberof GameMasterChallengeResponse
     */
    'modifiers': Array<Nested>;
    /**
     * 
     * @type {Nested}
     * @memberof GameMasterChallengeResponse
     */
    'target': Nested;
}


/**
 * 
 * @export
 * @interface GameMasterCharacterAction
 */
export interface GameMasterCharacterAction {
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterAction
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterAction
     */
    'initiator': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GameMasterCharacterAction
     */
    'targets'?: Array<string>;
    /**
     * 
     * @type {CharacterActionTypeEnum}
     * @memberof GameMasterCharacterAction
     */
    'action_type'?: CharacterActionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterAction
     */
    'skill'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof GameMasterCharacterAction
     */
    'data'?: any;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterAction
     */
    'position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterAction
     */
    'item'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterCharacterAction
     */
    'performed'?: boolean;
}


/**
 * 
 * @export
 * @interface GameMasterCharacterActionLog
 */
export interface GameMasterCharacterActionLog {
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterActionLog
     */
    'id': string;
    /**
     * 
     * @type {Nested}
     * @memberof GameMasterCharacterActionLog
     */
    'initiator': Nested;
    /**
     * 
     * @type {Array<Nested>}
     * @memberof GameMasterCharacterActionLog
     */
    'targets': Array<Nested>;
    /**
     * 
     * @type {CharacterActionTypeEnum}
     * @memberof GameMasterCharacterActionLog
     */
    'action_type'?: CharacterActionTypeEnum;
    /**
     * 
     * @type {Skill}
     * @memberof GameMasterCharacterActionLog
     */
    'skill': Skill;
    /**
     * 
     * @type {any}
     * @memberof GameMasterCharacterActionLog
     */
    'data'?: any;
    /**
     * 
     * @type {Nested}
     * @memberof GameMasterCharacterActionLog
     */
    'position': Nested;
    /**
     * 
     * @type {Array<GameMasterCharacterLogActionImpact>}
     * @memberof GameMasterCharacterActionLog
     */
    'impacts': Array<GameMasterCharacterLogActionImpact>;
    /**
     * 
     * @type {Nested}
     * @memberof GameMasterCharacterActionLog
     */
    'cycle': Nested;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterCharacterActionLog
     */
    'accepted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterCharacterActionLog
     */
    'performed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterActionLog
     */
    'order'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterCharacterActionLog
     */
    'immediate'?: boolean;
}


/**
 * 
 * @export
 * @interface GameMasterCharacterActionLogRequest
 */
export interface GameMasterCharacterActionLogRequest {
    /**
     * 
     * @type {CharacterActionTypeEnum}
     * @memberof GameMasterCharacterActionLogRequest
     */
    'action_type'?: CharacterActionTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof GameMasterCharacterActionLogRequest
     */
    'data'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterCharacterActionLogRequest
     */
    'accepted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterCharacterActionLogRequest
     */
    'performed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterActionLogRequest
     */
    'order'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterCharacterActionLogRequest
     */
    'immediate'?: boolean;
}


/**
 * 
 * @export
 * @interface GameMasterCharacterActionRequest
 */
export interface GameMasterCharacterActionRequest {
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterActionRequest
     */
    'initiator': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GameMasterCharacterActionRequest
     */
    'targets'?: Array<string>;
    /**
     * 
     * @type {CharacterActionTypeEnum}
     * @memberof GameMasterCharacterActionRequest
     */
    'action_type'?: CharacterActionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterActionRequest
     */
    'skill'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof GameMasterCharacterActionRequest
     */
    'data'?: any;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterActionRequest
     */
    'position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterActionRequest
     */
    'item'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterCharacterActionRequest
     */
    'performed'?: boolean;
}


/**
 * Serializer for Game Master character information.  This serializer provides all the necessary data for rendering a GameMasterCharacterCard component.  Included data: 1. Shields: Using ActiveShieldSerializer to include shields related to the character. 2. Attributes: Using AttributeSerializer to include character attributes. 3. Active Effects: Using ActiveEffectSerializer to include active effects on the character. 4. Items: Using CharacterItemSerializer to include character\'s equipped items. 5. Currency: Using CharacterCurrencySerializer to include character\'s currency information. 6. Biography: Using OpenaiCharacterBioSerializer to include character\'s biographical information    (age, gender, background, appearance, avatar). 7. Path: Using ThePathSerializer to include character\'s path information (name, description, icon). 8. Rank: Using DetailedRankSerializer to include detailed rank information    (grade, grade_rank, description, experience_needed, etc.).  Character Card Layout Description for Frontend Developers: --------------------------------------------------------  The GameMasterCharacterCard is a vertically oriented card with the following layout:  1. Top Section:    - Character avatar (large, centered, from biography.avatar)    - Character name (prominent, below avatar)    - Character biographical details (age, gender from biography)    - Character rank and path information (below name)      * Rank displayed with grade, grade_rank, and name      * Path displayed with name and icon    - Other basic character info like organization, tags, etc.    - Left side overlay: Active shields displayed as vertical bars or icons      * Each shield shows its type, level, and efficiency      * Visual indicator of shield health/status    - Right side overlay: Active effects displayed as icons with tooltips      * Each effect shows its type and remaining cycles      * Visual indicator for permanent vs temporary effects  2. Middle Section:    - Character background and appearance information (from biography)      * Background displayed as a collapsible text section      * Appearance displayed as a collapsible text section  3. Bottom Section:    - Character attributes displayed as horizontal bars      * Each attribute shows name, current value, and max value      * Color-coded bars for different attribute types  4. External Sections:    - Bottom panel main: Inventory items displayed as a grid      * Each item shows its icon, name, type, and quantity      * Items grouped by type if possible    - Bottom panel bottom: Currency information      * Each currency type with icon and amount      * Totals and conversions if applicable  Responsive Design Considerations: - On smaller screens, the layout should adjust to maintain readability - Consider collapsible sections for detailed information - Ensure tooltips are accessible on touch devices  Interaction Guidelines: - Hover on shields, effects, or items should show detailed information in alt like tooltips - Consider item selection for further actions (e.g., emmit event to upper components) - Provide visual feedback for interactive elements
 * @export
 * @interface GameMasterCharacterInfo
 */
export interface GameMasterCharacterInfo {
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterInfo
     */
    'id': string;
    /**
     * 
     * @type {Array<Attribute>}
     * @memberof GameMasterCharacterInfo
     */
    'attributes': Array<Attribute>;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterCharacterInfo
     */
    'game_master_mode': boolean;
    /**
     * 
     * @type {Array<ActiveShield>}
     * @memberof GameMasterCharacterInfo
     */
    'shields': Array<ActiveShield>;
    /**
     * 
     * @type {Array<ActiveEffect>}
     * @memberof GameMasterCharacterInfo
     */
    'effects': Array<ActiveEffect>;
    /**
     * 
     * @type {Array<CharacterItem>}
     * @memberof GameMasterCharacterInfo
     */
    'equipped_items': Array<CharacterItem>;
    /**
     * 
     * @type {Array<CharacterCurrency>}
     * @memberof GameMasterCharacterInfo
     */
    'tokens': Array<CharacterCurrency>;
    /**
     * 
     * @type {OpenaiCharacterBio}
     * @memberof GameMasterCharacterInfo
     */
    'biography': OpenaiCharacterBio;
    /**
     * 
     * @type {ThePath}
     * @memberof GameMasterCharacterInfo
     */
    'path': ThePath;
    /**
     * 
     * @type {DetailedRank}
     * @memberof GameMasterCharacterInfo
     */
    'rank': DetailedRank;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterCharacterInfo
     */
    'is_active'?: boolean;
    /**
     * Footprint on the tactical grid: standard 1x1, medium 2x2, superior 3x3, anchored at the object\'s north-west cell  * `standard` - standard * `medium` - medium * `superior` - superior
     * @type {TacticalSizeEnum}
     * @memberof GameMasterCharacterInfo
     */
    'tactical_size'?: TacticalSizeEnum;
    /**
     * 
     * @type {ScreenEnum}
     * @memberof GameMasterCharacterInfo
     */
    'screen'?: ScreenEnum;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterInfo
     */
    'name': string;
    /**
     * 
     * @type {any}
     * @memberof GameMasterCharacterInfo
     */
    'tags'?: any;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterInfo
     */
    'experience'?: number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterInfo
     */
    'current_health_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterInfo
     */
    'current_energy_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterInfo
     */
    'current_active_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterInfo
     */
    'school_slots'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterCharacterInfo
     */
    'npc'?: boolean;
    /**
     * 
     * @type {BehaviorEnum}
     * @memberof GameMasterCharacterInfo
     */
    'behavior'?: BehaviorEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterCharacterInfo
     */
    'resetting_base_stats'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterInfo
     */
    'coma_scars'?: number;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterInfo
     */
    'last_action_at'?: string;
    /**
     * 
     * @type {State57dEnum}
     * @memberof GameMasterCharacterInfo
     */
    'state'?: State57dEnum;
    /**
     * 
     * @type {GameMasterCharacterInfoStateReason}
     * @memberof GameMasterCharacterInfo
     */
    'state_reason'?: GameMasterCharacterInfoStateReason;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterInfo
     */
    'polymorphic_ctype': number | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterInfo
     */
    'position'?: string | null;
    /**
     * current area position tabletop map contains of string in format x,y coordinates the layer/dimension always took from the self.dimension
     * @type {string}
     * @memberof GameMasterCharacterInfo
     */
    'tactical_position'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterInfo
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterInfo
     */
    'campaign': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterInfo
     */
    'owner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterInfo
     */
    'organization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterInfo
     */
    'place_of_birth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterInfo
     */
    'template'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterInfo
     */
    'last_safe_position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterInfo
     */
    'fight'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterInfo
     */
    'challenge'?: string | null;
}


/**
 * @type GameMasterCharacterInfoStateReason
 * @export
 */
export type GameMasterCharacterInfoStateReason = BlankEnum | StateReasonEnum;

/**
 * 
 * @export
 * @interface GameMasterCharacterLogActionImpact
 */
export interface GameMasterCharacterLogActionImpact {
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterLogActionImpact
     */
    'id': string;
    /**
     * 
     * @type {ImpactTypeEnum}
     * @memberof GameMasterCharacterLogActionImpact
     */
    'type': ImpactTypeEnum;
    /**
     * 
     * @type {ImpactViolationTypeEnum}
     * @memberof GameMasterCharacterLogActionImpact
     */
    'violation': ImpactViolationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterLogActionImpact
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterLogActionImpact
     */
    'charge_index': number | null;
    /**
     * 
     * @type {Nested}
     * @memberof GameMasterCharacterLogActionImpact
     */
    'target': Nested;
    /**
     * 
     * @type {Nested}
     * @memberof GameMasterCharacterLogActionImpact
     */
    'dice_roll_result': Nested;
}


/**
 * 
 * @export
 * @interface GameMasterCharacterLogActionImpactRequest
 */
export interface GameMasterCharacterLogActionImpactRequest {
    /**
     * 
     * @type {ImpactTypeEnum}
     * @memberof GameMasterCharacterLogActionImpactRequest
     */
    'type': ImpactTypeEnum;
    /**
     * 
     * @type {ImpactViolationTypeEnum}
     * @memberof GameMasterCharacterLogActionImpactRequest
     */
    'violation': ImpactViolationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterLogActionImpactRequest
     */
    'size': number;
}


/**
 * Serialize character stats for Game Master.
 * @export
 * @interface GameMasterCharacterStat
 */
export interface GameMasterCharacterStat {
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterStat
     */
    'id': string;
    /**
     * 
     * @type {CharacterStatEnum}
     * @memberof GameMasterCharacterStat
     */
    'name'?: CharacterStatEnum;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterStat
     */
    'additional_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterCharacterStat
     */
    'base_value'?: number;
}


/**
 * Serializer for character stats card. Used in GameMasterCharacterCard component.  This serializer provides a compact view of character stats, suitable for displaying in a character stats card component.
 * @export
 * @interface GameMasterCharacterStatsCard
 */
export interface GameMasterCharacterStatsCard {
    /**
     * 
     * @type {string}
     * @memberof GameMasterCharacterStatsCard
     */
    'id': string;
    /**
     * 
     * @type {Array<GameMasterCharacterStat>}
     * @memberof GameMasterCharacterStatsCard
     */
    'stats': Array<GameMasterCharacterStat>;
}
/**
 * Serializer for GameMaster challenge creation requests.  This serializer handles the data needed to create a challenge for a character, including target selection, dice configuration, difficulty, and modifiers.
 * @export
 * @interface GameMasterCreateChallengeRequest
 */
export interface GameMasterCreateChallengeRequest {
    /**
     * The character who will face this challenge
     * @type {string}
     * @memberof GameMasterCreateChallengeRequest
     */
    'target_character': string;
    /**
     * Difficulty Class (DC) for the challenge
     * @type {number}
     * @memberof GameMasterCreateChallengeRequest
     */
    'difficulty': number;
    /**
     * Number of sides on the dice (default: 20)
     * @type {number}
     * @memberof GameMasterCreateChallengeRequest
     */
    'dice_sides'?: number;
    /**
     * Character stat to use for the challenge  * `Physical Strength` - Physical Strength * `Mental Strength` - Mental Strength * `Flow Resonance` - Flow Resonance * `Concentration` - Concentration * `Flow Manipulation` - Flow Manipulation * `Flow Connection` - Flow Connection * `Knowledge` - Knowledge * `Speed` - Speed * `Luck` - Luck * `Charisma` - Charisma
     * @type {CharacterStatEnum}
     * @memberof GameMasterCreateChallengeRequest
     */
    'stat'?: CharacterStatEnum;
    /**
     * Whether the character has advantage on this challenge
     * @type {boolean}
     * @memberof GameMasterCreateChallengeRequest
     */
    'advantage'?: boolean;
    /**
     * Whether the character has disadvantage on this challenge
     * @type {boolean}
     * @memberof GameMasterCreateChallengeRequest
     */
    'disadvantage'?: boolean;
    /**
     * Optional description of the challenge
     * @type {string}
     * @memberof GameMasterCreateChallengeRequest
     */
    'description'?: string;
    /**
     * List of modifiers to apply to the challenge
     * @type {Array<string>}
     * @memberof GameMasterCreateChallengeRequest
     */
    'modifiers'?: Array<string>;
}


/**
 * Serializer for GameMaster fight management. Extends the base fight serializer with additional fields for GM use.
 * @export
 * @interface GameMasterFight
 */
export interface GameMasterFight {
    /**
     * 
     * @type {string}
     * @memberof GameMasterFight
     */
    'id': string;
    /**
     * 
     * @type {Array<Fighter>}
     * @memberof GameMasterFight
     */
    'joined': Array<Fighter>;
    /**
     * 
     * @type {Array<Fighter>}
     * @memberof GameMasterFight
     */
    'pending_join': Array<Fighter>;
    /**
     * 
     * @type {Fighter}
     * @memberof GameMasterFight
     */
    'attacker': Fighter;
    /**
     * 
     * @type {Fighter}
     * @memberof GameMasterFight
     */
    'defender': Fighter;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFight
     */
    'position_name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFight
     */
    'location_name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFight
     */
    'campaign_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterFight
     */
    'duel'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterFight
     */
    'training'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GameMasterFight
     */
    'current_round'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterFight
     */
    'open'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterFight
     */
    'sealed'?: boolean;
    /**
     * 
     * @type {Phase347Enum}
     * @memberof GameMasterFight
     */
    'phase'?: Phase347Enum;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFight
     */
    'phase_started_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFight
     */
    'phase_deadline_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterFight
     */
    'phase_timeout_seconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFight
     */
    'round_started_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterFight
     */
    'inactive_rounds'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterFight
     */
    'round_activity'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GameMasterFight
     */
    'inactivity_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterFight
     */
    'max_rounds'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof GameMasterFight
     */
    'snapshot'?: any;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFight
     */
    'worker_lease_until'?: string | null;
    /**
     * 
     * @type {FightGenericOutcome}
     * @memberof GameMasterFight
     */
    'outcome'?: FightGenericOutcome | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFight
     */
    'ended_at_ts'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFight
     */
    'campaign': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFight
     */
    'position': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFight
     */
    'winner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFight
     */
    'winner_side'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterFight
     */
    'created'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterFight
     */
    'ended_at'?: number | null;
}


/**
 * Response for the GM\'s manual fight-clock levers.  ``round``/``phase``/``open`` are present only for a single-fight advance, where \"where did it land\" is the answer the caller wants; a whole-tick spans many fights and has no single answer to give.
 * @export
 * @interface GameMasterFightClockResult
 */
export interface GameMasterFightClockResult {
    /**
     * What the pass did
     * @type {FightWorkerTickCounts}
     * @memberof GameMasterFightClockResult
     */
    'fights': FightWorkerTickCounts;
    /**
     * The fight\'s round after the advance
     * @type {number}
     * @memberof GameMasterFightClockResult
     */
    'round'?: number;
    /**
     * The fight\'s phase after the advance
     * @type {string}
     * @memberof GameMasterFightClockResult
     */
    'phase'?: string;
    /**
     * Whether the fight is still open
     * @type {boolean}
     * @memberof GameMasterFightClockResult
     */
    'open'?: boolean;
}
/**
 * Input for moving a participant to a different side of the same fight; ``character_id`` is read from the URL, never the body.
 * @export
 * @interface GameMasterFightParticipantMove
 */
export interface GameMasterFightParticipantMove {
    /**
     * 
     * @type {string}
     * @memberof GameMasterFightParticipantMove
     */
    'character_id': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFightParticipantMove
     */
    'side_id': string;
}
/**
 * Input for moving a participant to a different side of the same fight; ``character_id`` is read from the URL, never the body.
 * @export
 * @interface GameMasterFightParticipantMoveRequest
 */
export interface GameMasterFightParticipantMoveRequest {
    /**
     * 
     * @type {string}
     * @memberof GameMasterFightParticipantMoveRequest
     */
    'side_id': string;
}
/**
 * The donut/side-rail shape, computed once by ``apps.game.services.fight.side_summary.summarize`` and reused here so the API response and the WebSocket event never disagree.  Only ``name`` is writable — creation takes it, rename takes it, and everything else here is server-derived.
 * @export
 * @interface GameMasterFightSide
 */
export interface GameMasterFightSide {
    /**
     * 
     * @type {string}
     * @memberof GameMasterFightSide
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFightSide
     */
    'fight': string;
    /**
     * 
     * @type {number}
     * @memberof GameMasterFightSide
     */
    'slot': number;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFightSide
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterFightSide
     */
    'organization': string | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterFightSide
     */
    'member_count': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterFightSide
     */
    'power': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterFightSide
     */
    'power_share': number;
}
/**
 * The donut/side-rail shape, computed once by ``apps.game.services.fight.side_summary.summarize`` and reused here so the API response and the WebSocket event never disagree.  Only ``name`` is writable — creation takes it, rename takes it, and everything else here is server-derived.
 * @export
 * @interface GameMasterFightSideRequest
 */
export interface GameMasterFightSideRequest {
    /**
     * 
     * @type {string}
     * @memberof GameMasterFightSideRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GameMasterItem
 */
export interface GameMasterItem {
    /**
     * 
     * @type {string}
     * @memberof GameMasterItem
     */
    'id': string;
    /**
     * 
     * @type {BaseSkill}
     * @memberof GameMasterItem
     */
    'skill': BaseSkill;
    /**
     * 
     * @type {AssignableEffect}
     * @memberof GameMasterItem
     */
    'effect': AssignableEffect;
    /**
     * 
     * @type {string}
     * @memberof GameMasterItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterItem
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterItem
     */
    'icon'?: string | null;
    /**
     * 
     * @type {ItemTypeEnum}
     * @memberof GameMasterItem
     */
    'type'?: ItemTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GameMasterItem
     */
    'charges'?: number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterItem
     */
    'weight'?: number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterItem
     */
    'visibility'?: number;
    /**
     * Meaningful only on FOOD-type items.
     * @type {number}
     * @memberof GameMasterItem
     */
    'nutrition'?: number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterItem
     */
    'base_price'?: number;
    /**
     * 
     * @type {any}
     * @memberof GameMasterItem
     */
    'allowed_phases'?: any;
}


/**
 * Serializer for PositionConnection model.
 * @export
 * @interface GameMasterPositionConnection
 */
export interface GameMasterPositionConnection {
    /**
     * 
     * @type {number}
     * @memberof GameMasterPositionConnection
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionConnection
     */
    'position_from': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionConnection
     */
    'position_to': string;
    /**
     * 
     * @type {Position}
     * @memberof GameMasterPositionConnection
     */
    'position_from_details': Position;
    /**
     * 
     * @type {Position}
     * @memberof GameMasterPositionConnection
     */
    'position_to_details': Position;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterPositionConnection
     */
    'locked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterPositionConnection
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterPositionConnection
     */
    'is_public'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionConnection
     */
    'is_vertical': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionConnection
     */
    'is_horizontal': string;
    /**
     * 
     * @type {any}
     * @memberof GameMasterPositionConnection
     */
    'config'?: any | null;
}
/**
 * Serializer for PositionConnection model.
 * @export
 * @interface GameMasterPositionConnectionRequest
 */
export interface GameMasterPositionConnectionRequest {
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionConnectionRequest
     */
    'position_from': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionConnectionRequest
     */
    'position_to': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterPositionConnectionRequest
     */
    'locked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterPositionConnectionRequest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterPositionConnectionRequest
     */
    'is_public'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof GameMasterPositionConnectionRequest
     */
    'config'?: any | null;
}
/**
 * The labels a game master can pick rather than type.
 * @export
 * @interface GameMasterPositionLabelCatalog
 */
export interface GameMasterPositionLabelCatalog {
    /**
     * 
     * @type {Array<GameMasterPositionLabelDefinition>}
     * @memberof GameMasterPositionLabelCatalog
     */
    'kinds': Array<GameMasterPositionLabelDefinition>;
    /**
     * 
     * @type {Array<GameMasterPositionLabelDefinition>}
     * @memberof GameMasterPositionLabelCatalog
     */
    'markers': Array<GameMasterPositionLabelDefinition>;
}
/**
 * A disagreement between labels that the engine would resolve silently.
 * @export
 * @interface GameMasterPositionLabelConflict
 */
export interface GameMasterPositionLabelConflict {
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelConflict
     */
    'code': string;
    /**
     * 
     * @type {SeverityEnum}
     * @memberof GameMasterPositionLabelConflict
     */
    'severity': SeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelConflict
     */
    'message': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GameMasterPositionLabelConflict
     */
    'values': Array<string>;
}


/**
 * One entry of the predefined label vocabulary.
 * @export
 * @interface GameMasterPositionLabelDefinition
 */
export interface GameMasterPositionLabelDefinition {
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelDefinition
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelDefinition
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelDefinition
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof GameMasterPositionLabelDefinition
     */
    'slot': number;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelDefinition
     */
    'icon': string;
}
/**
 * Replace a position\'s labels slot by slot.
 * @export
 * @interface GameMasterPositionLabelSetRequest
 */
export interface GameMasterPositionLabelSetRequest {
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelSetRequest
     */
    'kind'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelSetRequest
     */
    'marker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelSetRequest
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GameMasterPositionLabelSetRequest
     */
    'tags'?: Array<string>;
}
/**
 * A position\'s labels, read into their slots, with conflicts named.
 * @export
 * @interface GameMasterPositionLabelState
 */
export interface GameMasterPositionLabelState {
    /**
     * 
     * @type {Array<string>}
     * @memberof GameMasterPositionLabelState
     */
    'labels': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelState
     */
    'kind': string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelState
     */
    'marker': string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelState
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GameMasterPositionLabelState
     */
    'tags': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelState
     */
    'icon': string;
    /**
     * 
     * @type {Array<GameMasterPositionLabelConflict>}
     * @memberof GameMasterPositionLabelState
     */
    'conflicts': Array<GameMasterPositionLabelConflict>;
}
/**
 * Add or remove a single label by value.
 * @export
 * @interface GameMasterPositionLabelWriteRequest
 */
export interface GameMasterPositionLabelWriteRequest {
    /**
     * 
     * @type {string}
     * @memberof GameMasterPositionLabelWriteRequest
     */
    'value': string;
}
/**
 * Serializer for SubLocation model.
 * @export
 * @interface GameMasterSubLocation
 */
export interface GameMasterSubLocation {
    /**
     * 
     * @type {string}
     * @memberof GameMasterSubLocation
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterSubLocation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterSubLocation
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterSubLocation
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterSubLocation
     */
    'location': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterSubLocation
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GameMasterSubLocation
     */
    'map_x'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterSubLocation
     */
    'map_y'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterSubLocation
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterSubLocation
     */
    'updated_at': string;
}
/**
 * Serializer for SubLocation model.
 * @export
 * @interface GameMasterSubLocationRequest
 */
export interface GameMasterSubLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof GameMasterSubLocationRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterSubLocationRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterSubLocationRequest
     */
    'location': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterSubLocationRequest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GameMasterSubLocationRequest
     */
    'map_x'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterSubLocationRequest
     */
    'map_y'?: number | null;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface GameMasterWorldArea
 */
export interface GameMasterWorldArea {
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldArea
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldArea
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldArea
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldArea
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldArea
     */
    'city': string;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldArea
     */
    'area': number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldArea
     */
    'is_active'?: boolean;
    /**
     * Default battle map template for fights in this area
     * @type {string}
     * @memberof GameMasterWorldArea
     */
    'battle_map_template'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldArea
     */
    'scope': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldArea
     */
    'is_shared': boolean;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface GameMasterWorldAreaRequest
 */
export interface GameMasterWorldAreaRequest {
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldAreaRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldAreaRequest
     */
    'description': string;
    /**
     * 
     * @type {File}
     * @memberof GameMasterWorldAreaRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldAreaRequest
     */
    'city': string;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldAreaRequest
     */
    'area': number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldAreaRequest
     */
    'is_active'?: boolean;
    /**
     * Default battle map template for fights in this area
     * @type {string}
     * @memberof GameMasterWorldAreaRequest
     */
    'battle_map_template'?: string | null;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface GameMasterWorldCity
 */
export interface GameMasterWorldCity {
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCity
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCity
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCity
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCity
     */
    'country': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldCity
     */
    'is_active'?: boolean;
    /**
     * Default battle map template for fights in this city
     * @type {string}
     * @memberof GameMasterWorldCity
     */
    'battle_map_template'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldCity
     */
    'map_x'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldCity
     */
    'map_y'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCity
     */
    'scope': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldCity
     */
    'is_shared': boolean;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface GameMasterWorldCityRequest
 */
export interface GameMasterWorldCityRequest {
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCityRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCityRequest
     */
    'description': string;
    /**
     * 
     * @type {File}
     * @memberof GameMasterWorldCityRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCityRequest
     */
    'country': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldCityRequest
     */
    'is_active'?: boolean;
    /**
     * Default battle map template for fights in this city
     * @type {string}
     * @memberof GameMasterWorldCityRequest
     */
    'battle_map_template'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldCityRequest
     */
    'map_x'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldCityRequest
     */
    'map_y'?: number | null;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface GameMasterWorldContinent
 */
export interface GameMasterWorldContinent {
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldContinent
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldContinent
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldContinent
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldContinent
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldContinent
     */
    'planet': string;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldContinent
     */
    'area': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldContinent
     */
    'population': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldContinent
     */
    'number_of_countries': number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldContinent
     */
    'is_active'?: boolean;
    /**
     * Default battle map template for fights in this continent
     * @type {string}
     * @memberof GameMasterWorldContinent
     */
    'battle_map_template'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldContinent
     */
    'scope': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldContinent
     */
    'is_shared': boolean;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface GameMasterWorldContinentRequest
 */
export interface GameMasterWorldContinentRequest {
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldContinentRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldContinentRequest
     */
    'description': string;
    /**
     * 
     * @type {File}
     * @memberof GameMasterWorldContinentRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldContinentRequest
     */
    'planet': string;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldContinentRequest
     */
    'area': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldContinentRequest
     */
    'population': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldContinentRequest
     */
    'number_of_countries': number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldContinentRequest
     */
    'is_active'?: boolean;
    /**
     * Default battle map template for fights in this continent
     * @type {string}
     * @memberof GameMasterWorldContinentRequest
     */
    'battle_map_template'?: string | null;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface GameMasterWorldCountry
 */
export interface GameMasterWorldCountry {
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCountry
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCountry
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCountry
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCountry
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCountry
     */
    'continent': string;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldCountry
     */
    'area': number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldCountry
     */
    'is_active'?: boolean;
    /**
     * Default battle map template for fights in this country
     * @type {string}
     * @memberof GameMasterWorldCountry
     */
    'battle_map_template'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCountry
     */
    'scope': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldCountry
     */
    'is_shared': boolean;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface GameMasterWorldCountryRequest
 */
export interface GameMasterWorldCountryRequest {
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCountryRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCountryRequest
     */
    'description': string;
    /**
     * 
     * @type {File}
     * @memberof GameMasterWorldCountryRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldCountryRequest
     */
    'continent': string;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldCountryRequest
     */
    'area': number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldCountryRequest
     */
    'is_active'?: boolean;
    /**
     * Default battle map template for fights in this country
     * @type {string}
     * @memberof GameMasterWorldCountryRequest
     */
    'battle_map_template'?: string | null;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface GameMasterWorldDimension
 */
export interface GameMasterWorldDimension {
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldDimension
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldDimension
     */
    'speed': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldDimension
     */
    'energy': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldDimension
     */
    'shift_cost': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldDimension
     */
    'grade': number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldDimension
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldDimension
     */
    'scope': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldDimension
     */
    'is_shared': boolean;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface GameMasterWorldLocation
 */
export interface GameMasterWorldLocation {
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldLocation
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldLocation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldLocation
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldLocation
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldLocation
     */
    'area': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldLocation
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldLocation
     */
    'is_public'?: boolean;
    /**
     * Default battle map template for fights in this location
     * @type {string}
     * @memberof GameMasterWorldLocation
     */
    'battle_map_template'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldLocation
     */
    'scope': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldLocation
     */
    'is_shared': boolean;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface GameMasterWorldLocationRequest
 */
export interface GameMasterWorldLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldLocationRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldLocationRequest
     */
    'description': string;
    /**
     * 
     * @type {File}
     * @memberof GameMasterWorldLocationRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldLocationRequest
     */
    'area': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldLocationRequest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldLocationRequest
     */
    'is_public'?: boolean;
    /**
     * Default battle map template for fights in this location
     * @type {string}
     * @memberof GameMasterWorldLocationRequest
     */
    'battle_map_template'?: string | null;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface GameMasterWorldPlanet
 */
export interface GameMasterWorldPlanet {
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldPlanet
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldPlanet
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldPlanet
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldPlanet
     */
    'image'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldPlanet
     */
    'distance_from_star': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldPlanet
     */
    'diameter': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldPlanet
     */
    'mass': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldPlanet
     */
    'gravity': number;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldPlanet
     */
    'atmosphere': string;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldPlanet
     */
    'temperature': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldPlanet
     */
    'number_of_moons': number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldPlanet
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldPlanet
     */
    'scope': string;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldPlanet
     */
    'is_shared': boolean;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface GameMasterWorldPlanetRequest
 */
export interface GameMasterWorldPlanetRequest {
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldPlanetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldPlanetRequest
     */
    'description': string;
    /**
     * 
     * @type {File}
     * @memberof GameMasterWorldPlanetRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldPlanetRequest
     */
    'distance_from_star': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldPlanetRequest
     */
    'diameter': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldPlanetRequest
     */
    'mass': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldPlanetRequest
     */
    'gravity': number;
    /**
     * 
     * @type {string}
     * @memberof GameMasterWorldPlanetRequest
     */
    'atmosphere': string;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldPlanetRequest
     */
    'temperature': number;
    /**
     * 
     * @type {number}
     * @memberof GameMasterWorldPlanetRequest
     */
    'number_of_moons': number;
    /**
     * 
     * @type {boolean}
     * @memberof GameMasterWorldPlanetRequest
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface GameObject
 */
export interface GameObject {
    /**
     * 
     * @type {string}
     * @memberof GameObject
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GameObject
     */
    'position'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GameObject
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GameObject
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GameObject
     */
    'campaign': string;
    /**
     * 
     * @type {string}
     * @memberof GameObject
     */
    'object_type': string;
    /**
     * 
     * @type {string}
     * @memberof GameObject
     */
    'real_instance': string;
}
/**
 * 
 * @export
 * @interface GameObjectRequest
 */
export interface GameObjectRequest {
    /**
     * 
     * @type {string}
     * @memberof GameObjectRequest
     */
    'position'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GameObjectRequest
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GameObjectRequest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GameObjectRequest
     */
    'campaign': string;
}
/**
 * Event fired when a GameObject is spawned onto a tactical map.  This event is published whenever a GameObject (Character, Item, etc.) is assigned a tactical_position on a tactical map grid.
 * @export
 * @interface GameObjectSpawnedEvent
 */
export interface GameObjectSpawnedEvent {
    /**
     * 
     * @type {string}
     * @memberof GameObjectSpawnedEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GameObjectSpawnedEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof GameObjectSpawnedEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof GameObjectSpawnedEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsGameObjectSpawnedEventData}
     * @memberof GameObjectSpawnedEvent
     */
    'data': WsGameObjectSpawnedEventData;
}


/**
 * Event fired when a GameObject changes its tactical position.  This event is published whenever a GameObject (Character, Item, etc.) changes its tactical_position on a tactical map grid. This includes: - Initial spawning onto the grid - Movement during tactical phase - Position synchronization - Fight-based spawning  This is a world-level event that can be consumed by any interested parties to track GameObject movements across the tactical grid.
 * @export
 * @interface GameObjectTacticalPositionChangedEvent
 */
export interface GameObjectTacticalPositionChangedEvent {
    /**
     * 
     * @type {string}
     * @memberof GameObjectTacticalPositionChangedEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GameObjectTacticalPositionChangedEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof GameObjectTacticalPositionChangedEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof GameObjectTacticalPositionChangedEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsGameObjectTacticalPositionChangedData}
     * @memberof GameObjectTacticalPositionChangedEvent
     */
    'data': WsGameObjectTacticalPositionChangedData;
}


/**
 * 
 * @export
 * @interface GameObjectType
 */
export interface GameObjectType {
    /**
     * 
     * @type {string}
     * @memberof GameObjectType
     */
    'model': string;
    /**
     * 
     * @type {string}
     * @memberof GameObjectType
     */
    'app_label': string;
    /**
     * 
     * @type {string}
     * @memberof GameObjectType
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GamemasterImpersonationImpersonateCreate400Response
 */
export interface GamemasterImpersonationImpersonateCreate400Response {
    /**
     * 
     * @type {string}
     * @memberof GamemasterImpersonationImpersonateCreate400Response
     */
    'detail'?: string;
}
/**
 * * `Male` - Male * `Female` - Female * `Other` - Other
 * @export
 * @enum {string}
 */

export const GenderEnum = {
    Male: 'Male',
    Female: 'Female',
    Other: 'Other'
} as const;

export type GenderEnum = typeof GenderEnum[keyof typeof GenderEnum];


/**
 * 
 * @export
 * @interface GenericPosition
 */
export interface GenericPosition {
    /**
     * 
     * @type {string}
     * @memberof GenericPosition
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof GenericPosition
     */
    'grid_x'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericPosition
     */
    'grid_y'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericPosition
     */
    'grid_z'?: number;
    /**
     * 
     * @type {string}
     * @memberof GenericPosition
     */
    'sub_location': string;
    /**
     * 
     * @type {TacticalMap}
     * @memberof GenericPosition
     */
    'tactical_map': TacticalMap | null;
}
/**
 * 
 * @export
 * @interface GenericPositionId
 */
export interface GenericPositionId {
    /**
     * 
     * @type {string}
     * @memberof GenericPositionId
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface GenericPositionIdRequest
 */
export interface GenericPositionIdRequest {
    /**
     * 
     * @type {string}
     * @memberof GenericPositionIdRequest
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface GenericSpawner
 */
export interface GenericSpawner {
    /**
     * 
     * @type {string}
     * @memberof GenericSpawner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GenericSpawner
     */
    'position': string | null;
    /**
     * 
     * @type {number}
     * @memberof GenericSpawner
     */
    'dimension': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GenericSpawner
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericSpawner
     */
    'campaign': string;
    /**
     * 
     * @type {GameObjectType}
     * @memberof GenericSpawner
     */
    'object_type': GameObjectType;
    /**
     * 
     * @type {OneOf}
     * @memberof GenericSpawner
     */
    'real_instance': OneOf;
    /**
     * 
     * @type {number}
     * @memberof GenericSpawner
     */
    'spawn_limit': number;
    /**
     * 
     * @type {number}
     * @memberof GenericSpawner
     */
    'respawn_cycles': number;
    /**
     * Cycle number when the next spawn should occur
     * @type {number}
     * @memberof GenericSpawner
     */
    'next_spawn_cycle_number': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GenericSpawner
     */
    'spawned_entities': Array<string>;
}
/**
 * Serializer for God Intervention actions.  This serializer is used for the god_intervention endpoint in GameMasterCharacterViewSet. It validates the data needed to create a GodIntervention object.
 * @export
 * @interface GodIntervention
 */
export interface GodIntervention {
    /**
     * 
     * @type {GodInterventionTypeEnum}
     * @memberof GodIntervention
     */
    'type': GodInterventionTypeEnum;
    /**
     * 
     * @type {GodInterventionSizeEnum}
     * @memberof GodIntervention
     */
    'size': GodInterventionSizeEnum;
    /**
     * 
     * @type {Array<AttributesEnum>}
     * @memberof GodIntervention
     */
    'attributes': Array<AttributesEnum>;
}


/**
 * Serializer for God Intervention actions.  This serializer is used for the god_intervention endpoint in GameMasterCharacterViewSet. It validates the data needed to create a GodIntervention object.
 * @export
 * @interface GodInterventionRequest
 */
export interface GodInterventionRequest {
    /**
     * 
     * @type {GodInterventionTypeEnum}
     * @memberof GodInterventionRequest
     */
    'type': GodInterventionTypeEnum;
    /**
     * 
     * @type {GodInterventionSizeEnum}
     * @memberof GodInterventionRequest
     */
    'size': GodInterventionSizeEnum;
    /**
     * 
     * @type {Array<AttributesEnum>}
     * @memberof GodInterventionRequest
     */
    'attributes': Array<AttributesEnum>;
}


/**
 * * `Small` - Small * `Medium` - Medium * `Large` - Large * `God` - God
 * @export
 * @enum {string}
 */

export const GodInterventionSizeEnum = {
    Small: 'Small',
    Medium: 'Medium',
    Large: 'Large',
    God: 'God'
} as const;

export type GodInterventionSizeEnum = typeof GodInterventionSizeEnum[keyof typeof GodInterventionSizeEnum];


/**
 * * `Blessing` - Blessing * `Curse` - Curse
 * @export
 * @enum {string}
 */

export const GodInterventionTypeEnum = {
    Blessing: 'Blessing',
    Curse: 'Curse'
} as const;

export type GodInterventionTypeEnum = typeof GodInterventionTypeEnum[keyof typeof GodInterventionTypeEnum];


/**
 * 
 * @export
 * @interface GradeProfile
 */
export interface GradeProfile {
    /**
     * 
     * @type {number}
     * @memberof GradeProfile
     */
    'grade': number;
    /**
     * 
     * @type {string}
     * @memberof GradeProfile
     */
    'rank_name': string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof GradeProfile
     */
    'stats': { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof GradeProfile
     */
    'total_stats': number;
    /**
     * 
     * @type {ResourcePool}
     * @memberof GradeProfile
     */
    'resources': ResourcePool;
    /**
     * 
     * @type {MetatypeVerdict}
     * @memberof GradeProfile
     */
    'verdict': MetatypeVerdict;
    /**
     * 
     * @type {Array<SchoolSlot>}
     * @memberof GradeProfile
     */
    'schools': Array<SchoolSlot>;
    /**
     * 
     * @type {Array<SkillRating>}
     * @memberof GradeProfile
     */
    'skills': Array<SkillRating>;
    /**
     * 
     * @type {GradeRollup}
     * @memberof GradeProfile
     */
    'rollup': GradeRollup;
}
/**
 * 
 * @export
 * @interface GradeRollup
 */
export interface GradeRollup {
    /**
     * 
     * @type {number}
     * @memberof GradeRollup
     */
    'burst_power': number;
    /**
     * 
     * @type {string}
     * @memberof GradeRollup
     */
    'burst_skill': string | null;
    /**
     * 
     * @type {number}
     * @memberof GradeRollup
     */
    'damage_per_turn': number;
    /**
     * 
     * @type {number}
     * @memberof GradeRollup
     */
    'single_target_dpt': number;
    /**
     * 
     * @type {number}
     * @memberof GradeRollup
     */
    'healing_per_turn': number;
    /**
     * 
     * @type {number}
     * @memberof GradeRollup
     */
    'mitigation_per_turn': number;
    /**
     * 
     * @type {number}
     * @memberof GradeRollup
     */
    'engagement_reach': number;
    /**
     * 
     * @type {number}
     * @memberof GradeRollup
     */
    'effective_targets': number;
    /**
     * 
     * @type {number}
     * @memberof GradeRollup
     */
    'sustain_turns': number | null;
    /**
     * 
     * @type {number}
     * @memberof GradeRollup
     */
    'health_per_turn': number;
    /**
     * 
     * @type {number}
     * @memberof GradeRollup
     */
    'best_power_per_ap': number;
    /**
     * 
     * @type {number}
     * @memberof GradeRollup
     */
    'turns_to_fall': number | null;
    /**
     * 
     * @type {number}
     * @memberof GradeRollup
     */
    'turns_to_fall_vs_field': number | null;
    /**
     * 
     * @type {number}
     * @memberof GradeRollup
     */
    'off_curve_count': number;
}
/**
 * 
 * @export
 * @interface GridCell
 */
export interface GridCell {
    /**
     * 
     * @type {string}
     * @memberof GridCell
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof GridCell
     */
    'row': number;
    /**
     * 
     * @type {number}
     * @memberof GridCell
     */
    'col': number;
    /**
     * 
     * @type {string}
     * @memberof GridCell
     */
    'card': string;
    /**
     * 
     * @type {string}
     * @memberof GridCell
     */
    'card_name': string;
    /**
     * 
     * @type {number}
     * @memberof GridCell
     */
    'card_power': number;
    /**
     * 
     * @type {number}
     * @memberof GridCell
     */
    'card_defense': number;
    /**
     * 
     * @type {string}
     * @memberof GridCell
     */
    'owner': string;
    /**
     * 
     * @type {number}
     * @memberof GridCell
     */
    'placed_round': number;
    /**
     * 
     * @type {number}
     * @memberof GridCell
     */
    'synergy_bonus': number;
}
/**
 * Schema for grid configuration settings.
 * @export
 * @interface GridSettings
 */
export interface GridSettings {
    /**
     * Number of grid columns
     * @type {number}
     * @memberof GridSettings
     */
    'columns': number;
    /**
     * Number of grid rows
     * @type {number}
     * @memberof GridSettings
     */
    'rows': number;
    /**
     * Grid cell width in pixels
     * @type {number}
     * @memberof GridSettings
     */
    'cell_width': number;
    /**
     * Grid cell height in pixels
     * @type {number}
     * @memberof GridSettings
     */
    'cell_height': number;
    /**
     * Corner offset adjustments for grid alignment
     * @type {any}
     * @memberof GridSettings
     */
    'corner_offsets'?: any | null;
    /**
     * Reference image width in pixels
     * @type {number}
     * @memberof GridSettings
     */
    'reference_width'?: number | null;
    /**
     * Reference image height in pixels
     * @type {number}
     * @memberof GridSettings
     */
    'reference_height'?: number | null;
}
/**
 * Serializer for Impact DTO.
 * @export
 * @interface Impact
 */
export interface Impact {
    /**
     * 
     * @type {ImpactTypeEnum}
     * @memberof Impact
     */
    'kind': ImpactTypeEnum;
    /**
     * 
     * @type {ImpactViolationTypeEnum}
     * @memberof Impact
     */
    'type': ImpactViolationTypeEnum;
    /**
     * 
     * @type {Formula}
     * @memberof Impact
     */
    'formula': Formula;
}


/**
 * 
 * @export
 * @interface ImpactPerUse
 */
export interface ImpactPerUse {
    /**
     * 
     * @type {number}
     * @memberof ImpactPerUse
     */
    'per_cell': number;
    /**
     * 
     * @type {number}
     * @memberof ImpactPerUse
     */
    'per_pattern': number;
}
/**
 * Serializer for skill impacts.
 * @export
 * @interface ImpactRequest
 */
export interface ImpactRequest {
    /**
     * 
     * @type {ImpactTypeEnum}
     * @memberof ImpactRequest
     */
    'kind': ImpactTypeEnum;
    /**
     * 
     * @type {ImpactViolationTypeEnum}
     * @memberof ImpactRequest
     */
    'type': ImpactViolationTypeEnum;
    /**
     * 
     * @type {FormulaRequest}
     * @memberof ImpactRequest
     */
    'formula': FormulaRequest;
}


/**
 * * `None` - None * `Knock out` - Knock out * `Damage` - Damage * `Heal` - Heal * `Shield` - Shield * `Buff` - Buff * `Debuff` - Debuff * `Stun` - Stun * `Sleep` - Sleep * `Confusion` - Confusion * `Paralysis` - Paralysis * `Fear` - Fear * `Freeze` - Freeze * `Burn` - Burn * `Poison` - Poison * `Slow` - Slow * `Haste` - Haste * `Blind` - Blind * `Silence` - Silence * `Bleed` - Bleed * `Disarm` - Disarm * `Root` - Root * `Energy Decrease` - Energy Decrease * `Energy Drain` - Energy Drain * `Energy Gift` - Energy Gift * `Stat Drain` - Stat Drain * `Reflect` - Reflect * `Absorb` - Absorb * `Dodge` - Dodge * `Resist` - Resist * `Immunity` - Immunity * `Regeneration` - Regeneration * `Lifesteal` - Lifesteal * `Summon` - Summon
 * @export
 * @enum {string}
 */

export const ImpactTypeEnum = {
    None: 'None',
    KnockOut: 'Knock out',
    Damage: 'Damage',
    Heal: 'Heal',
    Shield: 'Shield',
    Buff: 'Buff',
    Debuff: 'Debuff',
    Stun: 'Stun',
    Sleep: 'Sleep',
    Confusion: 'Confusion',
    Paralysis: 'Paralysis',
    Fear: 'Fear',
    Freeze: 'Freeze',
    Burn: 'Burn',
    Poison: 'Poison',
    Slow: 'Slow',
    Haste: 'Haste',
    Blind: 'Blind',
    Silence: 'Silence',
    Bleed: 'Bleed',
    Disarm: 'Disarm',
    Root: 'Root',
    EnergyDecrease: 'Energy Decrease',
    EnergyDrain: 'Energy Drain',
    EnergyGift: 'Energy Gift',
    StatDrain: 'Stat Drain',
    Reflect: 'Reflect',
    Absorb: 'Absorb',
    Dodge: 'Dodge',
    Resist: 'Resist',
    Immunity: 'Immunity',
    Regeneration: 'Regeneration',
    Lifesteal: 'Lifesteal',
    Summon: 'Summon'
} as const;

export type ImpactTypeEnum = typeof ImpactTypeEnum[keyof typeof ImpactTypeEnum];


/**
 * * `Physical` - Physical * `Mental` - Mental * `Energy` - Energy * `Heat` - Heat * `Cold` - Cold * `Light` - Light * `Darkness` - Darkness * `None` - None
 * @export
 * @enum {string}
 */

export const ImpactViolationTypeEnum = {
    Physical: 'Physical',
    Mental: 'Mental',
    Energy: 'Energy',
    Heat: 'Heat',
    Cold: 'Cold',
    Light: 'Light',
    Darkness: 'Darkness',
    None: 'None'
} as const;

export type ImpactViolationTypeEnum = typeof ImpactViolationTypeEnum[keyof typeof ImpactViolationTypeEnum];


/**
 * Serializer for the impersonation request.
 * @export
 * @interface ImpersonationRequestRequest
 */
export interface ImpersonationRequestRequest {
    /**
     * UUID of the character to impersonate
     * @type {string}
     * @memberof ImpersonationRequestRequest
     */
    'character_id': string;
}
/**
 * Serializer for the impersonation response.
 * @export
 * @interface ImpersonationResponse
 */
export interface ImpersonationResponse {
    /**
     * JWT refresh token for the impersonated user
     * @type {string}
     * @memberof ImpersonationResponse
     */
    'refresh': string;
    /**
     * JWT access token for the impersonated user
     * @type {string}
     * @memberof ImpersonationResponse
     */
    'access': string;
}
/**
 * 
 * @export
 * @interface Item
 */
export interface Item {
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'icon'?: string | null;
    /**
     * 
     * @type {ItemTypeEnum}
     * @memberof Item
     */
    'type'?: ItemTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Item
     */
    'charges'?: number;
    /**
     * 
     * @type {number}
     * @memberof Item
     */
    'weight'?: number;
    /**
     * 
     * @type {number}
     * @memberof Item
     */
    'visibility'?: number;
    /**
     * Meaningful only on FOOD-type items.
     * @type {number}
     * @memberof Item
     */
    'nutrition'?: number;
    /**
     * 
     * @type {number}
     * @memberof Item
     */
    'base_price'?: number;
    /**
     * 
     * @type {any}
     * @memberof Item
     */
    'allowed_phases'?: any;
    /**
     * 
     * @type {Nested}
     * @memberof Item
     */
    'skill': Nested;
    /**
     * 
     * @type {Nested}
     * @memberof Item
     */
    'effect': Nested;
}


/**
 * 
 * @export
 * @interface ItemRequest
 */
export interface ItemRequest {
    /**
     * 
     * @type {string}
     * @memberof ItemRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ItemRequest
     */
    'description'?: string;
    /**
     * 
     * @type {File}
     * @memberof ItemRequest
     */
    'icon'?: File | null;
    /**
     * 
     * @type {ItemTypeEnum}
     * @memberof ItemRequest
     */
    'type'?: ItemTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ItemRequest
     */
    'charges'?: number;
    /**
     * 
     * @type {number}
     * @memberof ItemRequest
     */
    'weight'?: number;
    /**
     * 
     * @type {number}
     * @memberof ItemRequest
     */
    'visibility'?: number;
    /**
     * Meaningful only on FOOD-type items.
     * @type {number}
     * @memberof ItemRequest
     */
    'nutrition'?: number;
    /**
     * 
     * @type {number}
     * @memberof ItemRequest
     */
    'base_price'?: number;
    /**
     * 
     * @type {any}
     * @memberof ItemRequest
     */
    'allowed_phases'?: any;
}


/**
 * Serializer for ItemReward model.
 * @export
 * @interface ItemReward
 */
export interface ItemReward {
    /**
     * 
     * @type {string}
     * @memberof ItemReward
     */
    'id': string;
    /**
     * Amount of items to reward
     * @type {number}
     * @memberof ItemReward
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemReward
     */
    'item': string;
    /**
     * 
     * @type {string}
     * @memberof ItemReward
     */
    'reward'?: string | null;
}
/**
 * Serializer for ItemReward model.
 * @export
 * @interface ItemRewardRequest
 */
export interface ItemRewardRequest {
    /**
     * Amount of items to reward
     * @type {number}
     * @memberof ItemRewardRequest
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemRewardRequest
     */
    'item': string;
    /**
     * 
     * @type {string}
     * @memberof ItemRewardRequest
     */
    'reward'?: string | null;
}
/**
 * * `weapon` - weapon * `armor` - armor * `artifact` - artifact * `amulet` - amulet * `material` - material * `quest` - quest * `misc` - misc * `food` - food * `rune` - rune
 * @export
 * @enum {string}
 */

export const ItemTypeEnum = {
    Weapon: 'weapon',
    Armor: 'armor',
    Artifact: 'artifact',
    Amulet: 'amulet',
    Material: 'material',
    Quest: 'quest',
    Misc: 'misc',
    Food: 'food',
    Rune: 'rune'
} as const;

export type ItemTypeEnum = typeof ItemTypeEnum[keyof typeof ItemTypeEnum];


/**
 * 
 * @export
 * @interface JoinedFightEvent
 */
export interface JoinedFightEvent {
    /**
     * 
     * @type {string}
     * @memberof JoinedFightEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof JoinedFightEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof JoinedFightEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof JoinedFightEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsJoinedFightEventData}
     * @memberof JoinedFightEvent
     */
    'data': WsJoinedFightEventData;
}


/**
 * 
 * @export
 * @interface Leaderboard
 */
export interface Leaderboard {
    /**
     * 
     * @type {string}
     * @memberof Leaderboard
     */
    'player': string;
    /**
     * 
     * @type {string}
     * @memberof Leaderboard
     */
    'player_name': string;
    /**
     * 
     * @type {number}
     * @memberof Leaderboard
     */
    'elo': number;
    /**
     * 
     * @type {number}
     * @memberof Leaderboard
     */
    'wins': number;
    /**
     * 
     * @type {number}
     * @memberof Leaderboard
     */
    'losses': number;
    /**
     * 
     * @type {number}
     * @memberof Leaderboard
     */
    'draws': number;
    /**
     * 
     * @type {number}
     * @memberof Leaderboard
     */
    'best_win_streak': number;
    /**
     * 
     * @type {number}
     * @memberof Leaderboard
     */
    'total_matches': number;
}
/**
 * 
 * @export
 * @interface LearnedSchool
 */
export interface LearnedSchool {
    /**
     * 
     * @type {string}
     * @memberof LearnedSchool
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LearnedSchool
     */
    'character': string;
    /**
     * 
     * @type {string}
     * @memberof LearnedSchool
     */
    'school': string;
}
/**
 * 
 * @export
 * @interface LearnedSchoolRequest
 */
export interface LearnedSchoolRequest {
    /**
     * 
     * @type {string}
     * @memberof LearnedSchoolRequest
     */
    'school': string;
}
/**
 * 
 * @export
 * @interface LearnedSkill
 */
export interface LearnedSkill {
    /**
     * 
     * @type {string}
     * @memberof LearnedSkill
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LearnedSkill
     */
    'character': string;
    /**
     * 
     * @type {OpenaiSkill}
     * @memberof LearnedSkill
     */
    'skill': OpenaiSkill;
}
/**
 * 
 * @export
 * @interface LearnedSkillRequest
 */
export interface LearnedSkillRequest {
    /**
     * 
     * @type {OpenaiSkillRequest}
     * @memberof LearnedSkillRequest
     */
    'skill': OpenaiSkillRequest;
}
/**
 * 
 * @export
 * @interface LeftFightEvent
 */
export interface LeftFightEvent {
    /**
     * 
     * @type {string}
     * @memberof LeftFightEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof LeftFightEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof LeftFightEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof LeftFightEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsLeftFightEventData}
     * @memberof LeftFightEvent
     */
    'data': WsLeftFightEventData;
}


/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'image'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Location
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Location
     */
    'is_public'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'area': string;
    /**
     * Default battle map template for fights in this location
     * @type {string}
     * @memberof Location
     */
    'battle_map_template'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Location
     */
    'border_with'?: Array<string>;
}
/**
 * 
 * @export
 * @interface LongRestOffer
 */
export interface LongRestOffer {
    /**
     * 
     * @type {string}
     * @memberof LongRestOffer
     */
    'id': string;
    /**
     * 
     * @type {Array<LongRestProvision>}
     * @memberof LongRestOffer
     */
    'provisions': Array<LongRestProvision>;
    /**
     * 
     * @type {number}
     * @memberof LongRestOffer
     */
    'total_nutrition': number;
    /**
     * 
     * @type {StateF1eEnum}
     * @memberof LongRestOffer
     */
    'state'?: StateF1eEnum;
    /**
     * 
     * @type {string}
     * @memberof LongRestOffer
     */
    'character': string;
    /**
     * 
     * @type {string}
     * @memberof LongRestOffer
     */
    'position'?: string | null;
}


/**
 * 
 * @export
 * @interface LongRestProvision
 */
export interface LongRestProvision {
    /**
     * 
     * @type {string}
     * @memberof LongRestProvision
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LongRestProvision
     */
    'offer': string;
    /**
     * 
     * @type {string}
     * @memberof LongRestProvision
     */
    'world_item': string;
}
/**
 * 
 * @export
 * @interface LongRestProvisionRequest
 */
export interface LongRestProvisionRequest {
    /**
     * 
     * @type {string}
     * @memberof LongRestProvisionRequest
     */
    'world_item': string;
}
/**
 * 
 * @export
 * @interface MapPosition
 */
export interface MapPosition {
    /**
     * 
     * @type {GenericPosition}
     * @memberof MapPosition
     */
    'position': GenericPosition;
    /**
     * 
     * @type {boolean}
     * @memberof MapPosition
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof MapPosition
     */
    'labels'?: any | null;
}
/**
 * 
 * @export
 * @interface MapPositionMutableRequest
 */
export interface MapPositionMutableRequest {
    /**
     * 
     * @type {string}
     * @memberof MapPositionMutableRequest
     */
    'position_id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MapPositionMutableRequest
     */
    'labels'?: Array<string>;
}
/**
 * Response serializer for the map endpoint.
 * @export
 * @interface MapResponse
 */
export interface MapResponse {
    /**
     * 
     * @type {Array<Position>}
     * @memberof MapResponse
     */
    'positions': Array<Position>;
    /**
     * 
     * @type {Array<GameMasterPositionConnection>}
     * @memberof MapResponse
     */
    'connections': Array<GameMasterPositionConnection>;
}
/**
 * 
 * @export
 * @interface Match
 */
export interface Match {
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    'player_one': string;
    /**
     * Null if opponent is a bot
     * @type {string}
     * @memberof Match
     */
    'player_two': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Match
     */
    'is_bot_opponent': boolean;
    /**
     * 
     * @type {MatchStatusEnum}
     * @memberof Match
     */
    'status': MatchStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof Match
     */
    'current_round': number;
    /**
     * 
     * @type {number}
     * @memberof Match
     */
    'max_rounds': number;
    /**
     * 
     * @type {number}
     * @memberof Match
     */
    'player_one_flow': number;
    /**
     * 
     * @type {number}
     * @memberof Match
     */
    'player_two_flow': number;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    'winner': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Match
     */
    'is_draw': boolean;
    /**
     * 
     * @type {Array<MatchRound>}
     * @memberof Match
     */
    'rounds': Array<MatchRound>;
    /**
     * 
     * @type {Array<GridCell>}
     * @memberof Match
     */
    'grid_cells': Array<GridCell>;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    'created_at': string;
}


/**
 * 
 * @export
 * @interface MatchRound
 */
export interface MatchRound {
    /**
     * 
     * @type {string}
     * @memberof MatchRound
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof MatchRound
     */
    'round_number': number;
    /**
     * 
     * @type {MatchRoundPhaseEnum}
     * @memberof MatchRound
     */
    'phase': MatchRoundPhaseEnum;
    /**
     * 
     * @type {number}
     * @memberof MatchRound
     */
    'player_one_dice_roll': number | null;
    /**
     * 
     * @type {number}
     * @memberof MatchRound
     */
    'player_two_dice_roll': number | null;
    /**
     * Dimensional event data for this round
     * @type {any}
     * @memberof MatchRound
     */
    'event_data': any;
}


/**
 * * `draw` - draw * `mulligan` - mulligan * `selection` - selection * `event` - event * `clash` - clash * `resolution` - resolution * `claiming` - claiming
 * @export
 * @enum {string}
 */

export const MatchRoundPhaseEnum = {
    Draw: 'draw',
    Mulligan: 'mulligan',
    Selection: 'selection',
    Event: 'event',
    Clash: 'clash',
    Resolution: 'resolution',
    Claiming: 'claiming'
} as const;

export type MatchRoundPhaseEnum = typeof MatchRoundPhaseEnum[keyof typeof MatchRoundPhaseEnum];


/**
 * * `waiting` - waiting * `in_progress` - in_progress * `card_stealing` - card_stealing * `completed` - completed * `cancelled` - cancelled
 * @export
 * @enum {string}
 */

export const MatchStatusEnum = {
    Waiting: 'waiting',
    InProgress: 'in_progress',
    CardStealing: 'card_stealing',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;

export type MatchStatusEnum = typeof MatchStatusEnum[keyof typeof MatchStatusEnum];


/**
 * 
 * @export
 * @interface MatchmakingEntry
 */
export interface MatchmakingEntry {
    /**
     * 
     * @type {string}
     * @memberof MatchmakingEntry
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MatchmakingEntry
     */
    'player': string;
    /**
     * 
     * @type {MatchmakingEntryStatusEnum}
     * @memberof MatchmakingEntry
     */
    'status': MatchmakingEntryStatusEnum;
    /**
     * Player\'s ELO at time of queuing
     * @type {number}
     * @memberof MatchmakingEntry
     */
    'elo_at_queue': number;
    /**
     * 
     * @type {string}
     * @memberof MatchmakingEntry
     */
    'match': string | null;
    /**
     * 
     * @type {string}
     * @memberof MatchmakingEntry
     */
    'created_at': string;
}


/**
 * * `queued` - queued * `matched` - matched * `cancelled` - cancelled * `expired` - expired
 * @export
 * @enum {string}
 */

export const MatchmakingEntryStatusEnum = {
    Queued: 'queued',
    Matched: 'matched',
    Cancelled: 'cancelled',
    Expired: 'expired'
} as const;

export type MatchmakingEntryStatusEnum = typeof MatchmakingEntryStatusEnum[keyof typeof MatchmakingEntryStatusEnum];


/**
 * * `Attacker` - Attacker * `Defender` - Defender * `Healer` - Healer * `Buffer` - Buffer * `Debuffer` - Debuffer
 * @export
 * @enum {string}
 */

export const MetatypeEnum = {
    Attacker: 'Attacker',
    Defender: 'Defender',
    Healer: 'Healer',
    Buffer: 'Buffer',
    Debuffer: 'Debuffer'
} as const;

export type MetatypeEnum = typeof MetatypeEnum[keyof typeof MetatypeEnum];


/**
 * 
 * @export
 * @interface MetatypeVerdict
 */
export interface MetatypeVerdict {
    /**
     * 
     * @type {MetatypeEnum}
     * @memberof MetatypeVerdict
     */
    'metatype': MetatypeEnum;
    /**
     * 
     * @type {Role266Enum}
     * @memberof MetatypeVerdict
     */
    'role': Role266Enum;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof MetatypeVerdict
     */
    'weights': { [key: string]: number; };
    /**
     * 
     * @type {RunnerUpEnum}
     * @memberof MetatypeVerdict
     */
    'runner_up': RunnerUpEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof MetatypeVerdict
     */
    'is_hybrid': boolean;
}


/**
 * 
 * @export
 * @interface MiniMap
 */
export interface MiniMap {
    /**
     * 
     * @type {string}
     * @memberof MiniMap
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MiniMap
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MiniMap
     */
    'organization': string;
    /**
     * 
     * @type {boolean}
     * @memberof MiniMap
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MiniMap
     */
    'positions': string;
    /**
     * 
     * @type {string}
     * @memberof MiniMap
     */
    'connections': string;
    /**
     * 
     * @type {string}
     * @memberof MiniMap
     */
    'characters': string;
    /**
     * The position of the current user\'s character on the map.
     * @type {string}
     * @memberof MiniMap
     */
    'current_position': string;
}
/**
 * 
 * @export
 * @interface ModelMap
 */
export interface ModelMap {
    /**
     * 
     * @type {string}
     * @memberof ModelMap
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ModelMap
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ModelMap
     */
    'organization': string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelMap
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelMap
     */
    'positions': string;
    /**
     * 
     * @type {string}
     * @memberof ModelMap
     */
    'connections': string;
    /**
     * 
     * @type {string}
     * @memberof ModelMap
     */
    'characters': string;
    /**
     * The position of the current user\'s character on the map.
     * @type {string}
     * @memberof ModelMap
     */
    'current_position': string;
}
/**
 * 
 * @export
 * @interface ModerationQueueItem
 */
export interface ModerationQueueItem {
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'character': string;
    /**
     * 
     * @type {PublicationStatusEnum}
     * @memberof ModerationQueueItem
     */
    'status': PublicationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'proposed_name': string;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'proposed_background': string;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'proposed_appearance': string;
    /**
     * 
     * @type {PublicationImage}
     * @memberof ModerationQueueItem
     */
    'proposed_big_avatar': PublicationImage;
    /**
     * 
     * @type {PublicationImage}
     * @memberof ModerationQueueItem
     */
    'proposed_small_avatar': PublicationImage;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'proposed_tiktok_link': string;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'proposed_youtube_link': string;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'proposed_instagram_link': string;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'submitted_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'decided_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'rejection_reason': string;
    /**
     * 
     * @type {boolean}
     * @memberof ModerationQueueItem
     */
    'auto_approved': boolean;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'character_name': string;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'owner_email': string;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'campaign_id': string;
    /**
     * 
     * @type {string}
     * @memberof ModerationQueueItem
     */
    'admin_url': string;
    /**
     * 
     * @type {PublicationDiff}
     * @memberof ModerationQueueItem
     */
    'diff': PublicationDiff;
}


/**
 * 
 * @export
 * @interface Modificator
 */
export interface Modificator {
    /**
     * 
     * @type {string}
     * @memberof Modificator
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Modificator
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Modificator
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Modificator
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Modificator
     */
    'stat_changes': string;
}
/**
 * 
 * @export
 * @interface ModificatorRequest
 */
export interface ModificatorRequest {
    /**
     * 
     * @type {string}
     * @memberof ModificatorRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ModificatorRequest
     */
    'description': string;
    /**
     * 
     * @type {File}
     * @memberof ModificatorRequest
     */
    'icon'?: File | null;
    /**
     * 
     * @type {Array<StatModificatorRequest>}
     * @memberof ModificatorRequest
     */
    'stat_modificators': Array<StatModificatorRequest>;
}
/**
 * Serializer for Modifier DTO.
 * @export
 * @interface Modifier
 */
export interface Modifier {
    /**
     * 
     * @type {string}
     * @memberof Modifier
     */
    'label': string;
    /**
     * 
     * @type {Formula}
     * @memberof Modifier
     */
    'formula': Formula;
}
/**
 * Serializer for effect modifiers.
 * @export
 * @interface ModifierRequest
 */
export interface ModifierRequest {
    /**
     * 
     * @type {string}
     * @memberof ModifierRequest
     */
    'label': string;
    /**
     * 
     * @type {FormulaRequest}
     * @memberof ModifierRequest
     */
    'formula': FormulaRequest;
}
/**
 * 
 * @export
 * @interface MonteCarloBandEntry
 */
export interface MonteCarloBandEntry {
    /**
     * 
     * @type {number}
     * @memberof MonteCarloBandEntry
     */
    'round': number;
    /**
     * 
     * @type {number}
     * @memberof MonteCarloBandEntry
     */
    'p10': number;
    /**
     * 
     * @type {number}
     * @memberof MonteCarloBandEntry
     */
    'p50': number;
    /**
     * 
     * @type {number}
     * @memberof MonteCarloBandEntry
     */
    'p90': number;
    /**
     * 
     * @type {number}
     * @memberof MonteCarloBandEntry
     */
    'mean': number;
}
/**
 * 
 * @export
 * @interface MonteCarloReading
 */
export interface MonteCarloReading {
    /**
     * 
     * @type {number}
     * @memberof MonteCarloReading
     */
    'runs': number;
    /**
     * 
     * @type {number}
     * @memberof MonteCarloReading
     */
    'seed': number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MonteCarloReading
     */
    'percentiles': Array<number>;
    /**
     * 
     * @type {Array<MonteCarloBandEntry>}
     * @memberof MonteCarloReading
     */
    'band': Array<MonteCarloBandEntry>;
    /**
     * 
     * @type {number}
     * @memberof MonteCarloReading
     */
    'mean_total': number;
    /**
     * 
     * @type {number}
     * @memberof MonteCarloReading
     */
    'min_total': number;
    /**
     * 
     * @type {number}
     * @memberof MonteCarloReading
     */
    'max_total': number;
    /**
     * 
     * @type {number}
     * @memberof MonteCarloReading
     */
    'deterministic_total': number;
    /**
     * 
     * @type {number}
     * @memberof MonteCarloReading
     */
    'relative_error': number | null;
    /**
     * Per-cell and per-pattern percentile bands, null where no run reached the target inside the horizon.
     * @type {any}
     * @memberof MonteCarloReading
     */
    'rounds_to_target': any;
}
/**
 * Serializer for NPCSpawner model for Game Master API.  This serializer provides complete functionality for creating and managing NPC spawners with position, campaign, character template, and spawn settings.
 * @export
 * @interface NPCGenericSpawner
 */
export interface NPCGenericSpawner {
    /**
     * 
     * @type {string}
     * @memberof NPCGenericSpawner
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof NPCGenericSpawner
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NPCGenericSpawner
     */
    'spawn_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof NPCGenericSpawner
     */
    'respawn_cycles'?: number;
    /**
     * 
     * @type {string}
     * @memberof NPCGenericSpawner
     */
    'character_template': string;
    /**
     * Cycle number when the next spawn should occur
     * @type {number}
     * @memberof NPCGenericSpawner
     */
    'next_spawn_cycle_number': number;
    /**
     * 
     * @type {number}
     * @memberof NPCGenericSpawner
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NPCGenericSpawner
     */
    'position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NPCGenericSpawner
     */
    'campaign': string;
    /**
     * 
     * @type {Array<SpawnedEntity>}
     * @memberof NPCGenericSpawner
     */
    'spawned_entities': Array<SpawnedEntity>;
}
/**
 * Serializer for NPCSpawner model for Game Master API.  This serializer provides complete functionality for creating and managing NPC spawners with position, campaign, character template, and spawn settings.
 * @export
 * @interface NPCGenericSpawnerRequest
 */
export interface NPCGenericSpawnerRequest {
    /**
     * 
     * @type {boolean}
     * @memberof NPCGenericSpawnerRequest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NPCGenericSpawnerRequest
     */
    'spawn_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof NPCGenericSpawnerRequest
     */
    'respawn_cycles'?: number;
    /**
     * 
     * @type {string}
     * @memberof NPCGenericSpawnerRequest
     */
    'character_template': string;
    /**
     * 
     * @type {number}
     * @memberof NPCGenericSpawnerRequest
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NPCGenericSpawnerRequest
     */
    'position'?: string | null;
}
/**
 * 
 * @export
 * @interface NPCSpawnerCreate
 */
export interface NPCSpawnerCreate {
    /**
     * 
     * @type {number}
     * @memberof NPCSpawnerCreate
     */
    'spawn_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof NPCSpawnerCreate
     */
    'respawn_cycles'?: number;
    /**
     * 
     * @type {string}
     * @memberof NPCSpawnerCreate
     */
    'character_template': string;
    /**
     * 
     * @type {number}
     * @memberof NPCSpawnerCreate
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NPCSpawnerCreate
     */
    'position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NPCSpawnerCreate
     */
    'campaign': string;
    /**
     * 
     * @type {boolean}
     * @memberof NPCSpawnerCreate
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof NPCSpawnerCreate
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface NPCSpawnerCreateRequest
 */
export interface NPCSpawnerCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof NPCSpawnerCreateRequest
     */
    'spawn_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof NPCSpawnerCreateRequest
     */
    'respawn_cycles'?: number;
    /**
     * 
     * @type {string}
     * @memberof NPCSpawnerCreateRequest
     */
    'character_template': string;
    /**
     * 
     * @type {number}
     * @memberof NPCSpawnerCreateRequest
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NPCSpawnerCreateRequest
     */
    'position'?: string | null;
}
/**
 * 
 * @export
 * @interface NPCSpawnerList
 */
export interface NPCSpawnerList {
    /**
     * 
     * @type {string}
     * @memberof NPCSpawnerList
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof NPCSpawnerList
     */
    'is_active': boolean;
    /**
     * 
     * @type {number}
     * @memberof NPCSpawnerList
     */
    'spawn_limit': number;
    /**
     * 
     * @type {number}
     * @memberof NPCSpawnerList
     */
    'respawn_cycles': number;
    /**
     * 
     * @type {string}
     * @memberof NPCSpawnerList
     */
    'character_template': string;
    /**
     * Cycle number when the next spawn should occur
     * @type {number}
     * @memberof NPCSpawnerList
     */
    'next_spawn_cycle_number': number;
    /**
     * 
     * @type {number}
     * @memberof NPCSpawnerList
     */
    'dimension': number | null;
    /**
     * 
     * @type {string}
     * @memberof NPCSpawnerList
     */
    'position': string | null;
    /**
     * 
     * @type {string}
     * @memberof NPCSpawnerList
     */
    'campaign': string;
}
/**
 * 
 * @export
 * @interface NPCSpawnerMinimalPreview
 */
export interface NPCSpawnerMinimalPreview {
    /**
     * 
     * @type {string}
     * @memberof NPCSpawnerMinimalPreview
     */
    'character_template': string;
}
/**
 * 
 * @export
 * @interface Nested
 */
export interface Nested {
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'updated_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof Nested
     */
    'is_active'?: boolean;
    /**
     * Footprint on the tactical grid: standard 1x1, medium 2x2, superior 3x3, anchored at the object\'s north-west cell  * `standard` - standard * `medium` - medium * `superior` - superior
     * @type {TacticalSizeEnum}
     * @memberof Nested
     */
    'tactical_size'?: TacticalSizeEnum;
    /**
     * 
     * @type {ScreenEnum}
     * @memberof Nested
     */
    'screen'?: ScreenEnum;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'name': string;
    /**
     * 
     * @type {any}
     * @memberof Nested
     */
    'tags'?: any;
    /**
     * 
     * @type {number}
     * @memberof Nested
     */
    'experience'?: number;
    /**
     * 
     * @type {number}
     * @memberof Nested
     */
    'current_health_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof Nested
     */
    'current_energy_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof Nested
     */
    'current_active_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof Nested
     */
    'school_slots'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Nested
     */
    'npc'?: boolean;
    /**
     * 
     * @type {BehaviorEnum}
     * @memberof Nested
     */
    'behavior'?: BehaviorEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Nested
     */
    'resetting_base_stats'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Nested
     */
    'game_master_mode'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Nested
     */
    'coma_scars'?: number;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'last_action_at'?: string;
    /**
     * 
     * @type {State57dEnum}
     * @memberof Nested
     */
    'state'?: State57dEnum;
    /**
     * 
     * @type {GameMasterCharacterInfoStateReason}
     * @memberof Nested
     */
    'state_reason'?: GameMasterCharacterInfoStateReason;
    /**
     * 
     * @type {number}
     * @memberof Nested
     */
    'polymorphic_ctype': number | null;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'position'?: string | null;
    /**
     * current area position tabletop map contains of string in format x,y coordinates the layer/dimension always took from the self.dimension
     * @type {string}
     * @memberof Nested
     */
    'tactical_position'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Nested
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'campaign': string;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'owner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'organization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'rank'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'place_of_birth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'template'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'last_safe_position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'fight'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Nested
     */
    'challenge'?: string | null;
}


/**
 * 
 * @export
 * @interface NestedRequest
 */
export interface NestedRequest {
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'created_at'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NestedRequest
     */
    'is_active'?: boolean;
    /**
     * Footprint on the tactical grid: standard 1x1, medium 2x2, superior 3x3, anchored at the object\'s north-west cell  * `standard` - standard * `medium` - medium * `superior` - superior
     * @type {TacticalSizeEnum}
     * @memberof NestedRequest
     */
    'tactical_size'?: TacticalSizeEnum;
    /**
     * 
     * @type {ScreenEnum}
     * @memberof NestedRequest
     */
    'screen'?: ScreenEnum;
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'name': string;
    /**
     * 
     * @type {any}
     * @memberof NestedRequest
     */
    'tags'?: any;
    /**
     * 
     * @type {number}
     * @memberof NestedRequest
     */
    'experience'?: number;
    /**
     * 
     * @type {number}
     * @memberof NestedRequest
     */
    'current_health_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof NestedRequest
     */
    'current_energy_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof NestedRequest
     */
    'current_active_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof NestedRequest
     */
    'school_slots'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NestedRequest
     */
    'npc'?: boolean;
    /**
     * 
     * @type {BehaviorEnum}
     * @memberof NestedRequest
     */
    'behavior'?: BehaviorEnum;
    /**
     * 
     * @type {boolean}
     * @memberof NestedRequest
     */
    'resetting_base_stats'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NestedRequest
     */
    'game_master_mode'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NestedRequest
     */
    'coma_scars'?: number;
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'last_action_at'?: string;
    /**
     * 
     * @type {State57dEnum}
     * @memberof NestedRequest
     */
    'state'?: State57dEnum;
    /**
     * 
     * @type {GameMasterCharacterInfoStateReason}
     * @memberof NestedRequest
     */
    'state_reason'?: GameMasterCharacterInfoStateReason;
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'position'?: string | null;
    /**
     * current area position tabletop map contains of string in format x,y coordinates the layer/dimension always took from the self.dimension
     * @type {string}
     * @memberof NestedRequest
     */
    'tactical_position'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NestedRequest
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'campaign': string;
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'owner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'organization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'rank'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'place_of_birth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'template'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'last_safe_position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'fight'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NestedRequest
     */
    'challenge'?: string | null;
}


/**
 * 
 * @export
 * @interface NewCoordinatesRequest
 */
export interface NewCoordinatesRequest {
    /**
     * 
     * @type {number}
     * @memberof NewCoordinatesRequest
     */
    'grid_x': number;
    /**
     * 
     * @type {number}
     * @memberof NewCoordinatesRequest
     */
    'grid_y': number;
    /**
     * 
     * @type {number}
     * @memberof NewCoordinatesRequest
     */
    'grid_z': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewCoordinatesRequest
     */
    'labels'?: Array<string>;
}
/**
 * Serializer for Note model.
 * @export
 * @interface Note
 */
export interface Note {
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    'quest': string;
    /**
     * Optional URL to an image representing the note
     * @type {string}
     * @memberof Note
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    'content': string;
    /**
     * Order of the note within the quest
     * @type {number}
     * @memberof Note
     */
    'order'?: number;
}
/**
 * Serializer for Note model.
 * @export
 * @interface NoteRequest
 */
export interface NoteRequest {
    /**
     * 
     * @type {string}
     * @memberof NoteRequest
     */
    'quest': string;
    /**
     * Optional URL to an image representing the note
     * @type {File}
     * @memberof NoteRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof NoteRequest
     */
    'content': string;
    /**
     * Order of the note within the quest
     * @type {number}
     * @memberof NoteRequest
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NullEnum = {
    Null: 'null'
} as const;

export type NullEnum = typeof NullEnum[keyof typeof NullEnum];


/**
 * 
 * @export
 * @interface OfferedItem
 */
export interface OfferedItem {
    /**
     * 
     * @type {string}
     * @memberof OfferedItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OfferedItem
     */
    'item': string;
    /**
     * 
     * @type {string}
     * @memberof OfferedItem
     */
    'bargain': string;
}
/**
 * 
 * @export
 * @interface OfferedItemRequest
 */
export interface OfferedItemRequest {
    /**
     * 
     * @type {string}
     * @memberof OfferedItemRequest
     */
    'item': string;
}
/**
 * @type OneOf
 * @export
 */
export type OneOf = { object_type_model: 'AbstractSpawner' } & AbstractSpawner | { object_type_model: 'NPCSpawnerMinimalPreview' } & NPCSpawnerMinimalPreview | { object_type_model: 'PopulationScaledNPCSpawnerMinimalPreview' } & PopulationScaledNPCSpawnerMinimalPreview;

/**
 * 
 * @export
 * @interface OpenAICampaign
 */
export interface OpenAICampaign {
    /**
     * 
     * @type {string}
     * @memberof OpenAICampaign
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OpenAICampaign
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OpenAICampaign
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof OpenAICampaign
     */
    'is_active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OpenAICampaign
     */
    'is_completed': boolean;
    /**
     * 
     * @type {string}
     * @memberof OpenAICampaign
     */
    'background_image'?: string | null;
}
/**
 * 
 * @export
 * @interface OpenAIClientManagement
 */
export interface OpenAIClientManagement {
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagement
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagement
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagement
     */
    'last_login'?: string | null;
    /**
     * Designates that this user has all permissions without explicitly assigning them.
     * @type {boolean}
     * @memberof OpenAIClientManagement
     */
    'is_superuser'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagement
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagement
     */
    'updated_at': string;
    /**
     * 
     * @type {ProviderEnum}
     * @memberof OpenAIClientManagement
     */
    'provider': ProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagement
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagement
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagement
     */
    'last_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OpenAIClientManagement
     */
    'is_active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OpenAIClientManagement
     */
    'email_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagement
     */
    'email_verified_at'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OpenAIClientManagement
     */
    'is_staff': boolean;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagement
     */
    'date_joined': string;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagement
     */
    'current_campaign'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagement
     */
    'main_character'?: string | null;
    /**
     * The groups this user belongs to. A user will get all permissions granted to each of their groups.
     * @type {Array<number>}
     * @memberof OpenAIClientManagement
     */
    'groups'?: Array<number>;
    /**
     * Specific permissions for this user.
     * @type {Array<number>}
     * @memberof OpenAIClientManagement
     */
    'user_permissions'?: Array<number>;
}


/**
 * 
 * @export
 * @interface OpenAIClientManagementRequest
 */
export interface OpenAIClientManagementRequest {
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagementRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagementRequest
     */
    'last_login'?: string | null;
    /**
     * Designates that this user has all permissions without explicitly assigning them.
     * @type {boolean}
     * @memberof OpenAIClientManagementRequest
     */
    'is_superuser'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagementRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagementRequest
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagementRequest
     */
    'last_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OpenAIClientManagementRequest
     */
    'email_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagementRequest
     */
    'email_verified_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagementRequest
     */
    'current_campaign'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenAIClientManagementRequest
     */
    'main_character'?: string | null;
    /**
     * The groups this user belongs to. A user will get all permissions granted to each of their groups.
     * @type {Array<number>}
     * @memberof OpenAIClientManagementRequest
     */
    'groups'?: Array<number>;
    /**
     * Specific permissions for this user.
     * @type {Array<number>}
     * @memberof OpenAIClientManagementRequest
     */
    'user_permissions'?: Array<number>;
}
/**
 * 
 * @export
 * @interface OpenaiCharacter
 */
export interface OpenaiCharacter {
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacter
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacter
     */
    'name': string;
    /**
     * 
     * @type {OpenaiCharacterBio}
     * @memberof OpenaiCharacter
     */
    'biography': OpenaiCharacterBio;
    /**
     * 
     * @type {boolean}
     * @memberof OpenaiCharacter
     */
    'npc'?: boolean;
    /**
     * 
     * @type {Rank}
     * @memberof OpenaiCharacter
     */
    'rank': Rank;
    /**
     * 
     * @type {ThePath}
     * @memberof OpenaiCharacter
     */
    'path': ThePath;
    /**
     * 
     * @type {number}
     * @memberof OpenaiCharacter
     */
    'experience'?: number;
    /**
     * 
     * @type {any}
     * @memberof OpenaiCharacter
     */
    'tags'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof OpenaiCharacter
     */
    'resetting_base_stats'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OpenaiCharacter
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {Campaign}
     * @memberof OpenaiCharacter
     */
    'campaign': Campaign;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacter
     */
    'fight'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacter
     */
    'challenge'?: string | null;
    /**
     * 
     * @type {Organization}
     * @memberof OpenaiCharacter
     */
    'organization': Organization | null;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacter
     */
    'position_id': string | null;
    /**
     * 
     * @type {TacticalPosition}
     * @memberof OpenaiCharacter
     */
    'tactical_position': TacticalPosition;
    /**
     * 
     * @type {ScreenEnum}
     * @memberof OpenaiCharacter
     */
    'screen'?: ScreenEnum;
    /**
     * 
     * @type {CharacterPublicationSummary}
     * @memberof OpenaiCharacter
     */
    'publication': CharacterPublicationSummary;
    /**
     * 
     * @type {boolean}
     * @memberof OpenaiCharacter
     */
    'in_duel': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OpenaiCharacter
     */
    'in_fight': boolean;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacter
     */
    'fight_id': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OpenaiCharacter
     */
    'game_master_mode': boolean;
}


/**
 * 
 * @export
 * @interface OpenaiCharacterBio
 */
export interface OpenaiCharacterBio {
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterBio
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterBio
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterBio
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof OpenaiCharacterBio
     */
    'age': number;
    /**
     * 
     * @type {GenderEnum}
     * @memberof OpenaiCharacterBio
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterBio
     */
    'background'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterBio
     */
    'appearance'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterBio
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterBio
     */
    'character': string;
}


/**
 * 
 * @export
 * @interface OpenaiCharacterBioRequest
 */
export interface OpenaiCharacterBioRequest {
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterBioRequest
     */
    'created_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof OpenaiCharacterBioRequest
     */
    'age': number;
    /**
     * 
     * @type {GenderEnum}
     * @memberof OpenaiCharacterBioRequest
     */
    'gender'?: GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterBioRequest
     */
    'background'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterBioRequest
     */
    'appearance'?: string;
    /**
     * 
     * @type {File}
     * @memberof OpenaiCharacterBioRequest
     */
    'avatar'?: File;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterBioRequest
     */
    'character': string;
}


/**
 * 
 * @export
 * @interface OpenaiCharacterRequest
 */
export interface OpenaiCharacterRequest {
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterRequest
     */
    'name': string;
    /**
     * 
     * @type {OpenaiCharacterBioRequest}
     * @memberof OpenaiCharacterRequest
     */
    'biography': OpenaiCharacterBioRequest;
    /**
     * 
     * @type {boolean}
     * @memberof OpenaiCharacterRequest
     */
    'npc'?: boolean;
    /**
     * 
     * @type {RankRequest}
     * @memberof OpenaiCharacterRequest
     */
    'rank': RankRequest;
    /**
     * 
     * @type {ThePathRequest}
     * @memberof OpenaiCharacterRequest
     */
    'path': ThePathRequest;
    /**
     * 
     * @type {number}
     * @memberof OpenaiCharacterRequest
     */
    'experience'?: number;
    /**
     * 
     * @type {any}
     * @memberof OpenaiCharacterRequest
     */
    'tags'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof OpenaiCharacterRequest
     */
    'resetting_base_stats'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OpenaiCharacterRequest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {CampaignRequest}
     * @memberof OpenaiCharacterRequest
     */
    'campaign': CampaignRequest;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterRequest
     */
    'fight'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterRequest
     */
    'challenge'?: string | null;
    /**
     * 
     * @type {OrganizationRequest}
     * @memberof OpenaiCharacterRequest
     */
    'organization': OrganizationRequest | null;
    /**
     * 
     * @type {string}
     * @memberof OpenaiCharacterRequest
     */
    'position_id': string | null;
    /**
     * 
     * @type {ScreenEnum}
     * @memberof OpenaiCharacterRequest
     */
    'screen'?: ScreenEnum;
}


/**
 * 
 * @export
 * @interface OpenaiPath
 */
export interface OpenaiPath {
    /**
     * 
     * @type {string}
     * @memberof OpenaiPath
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiPath
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiPath
     */
    'updated_at': string;
    /**
     * 
     * @type {TheChosenPathEnum}
     * @memberof OpenaiPath
     */
    'name'?: TheChosenPathEnum;
    /**
     * 
     * @type {string}
     * @memberof OpenaiPath
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiPath
     */
    'icon'?: string | null;
}


/**
 * 
 * @export
 * @interface OpenaiPathWithSchools
 */
export interface OpenaiPathWithSchools {
    /**
     * 
     * @type {string}
     * @memberof OpenaiPathWithSchools
     */
    'id': string;
    /**
     * 
     * @type {Array<OpenaiSchool>}
     * @memberof OpenaiPathWithSchools
     */
    'schools': Array<OpenaiSchool>;
    /**
     * 
     * @type {string}
     * @memberof OpenaiPathWithSchools
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiPathWithSchools
     */
    'updated_at': string;
    /**
     * 
     * @type {TheChosenPathEnum}
     * @memberof OpenaiPathWithSchools
     */
    'name'?: TheChosenPathEnum;
    /**
     * 
     * @type {string}
     * @memberof OpenaiPathWithSchools
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiPathWithSchools
     */
    'icon'?: string | null;
}


/**
 * 
 * @export
 * @interface OpenaiSchool
 */
export interface OpenaiSchool {
    /**
     * 
     * @type {string}
     * @memberof OpenaiSchool
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSchool
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSchool
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSchool
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSchool
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSchool
     */
    'icon'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OpenaiSchool
     */
    'is_base'?: boolean;
    /**
     * If true, only game masters can create skills in this school
     * @type {boolean}
     * @memberof OpenaiSchool
     */
    'game_master_only'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OpenaiSchool
     */
    'path'?: Array<string>;
}
/**
 * 
 * @export
 * @interface OpenaiSkill
 */
export interface OpenaiSkill {
    /**
     * 
     * @type {number}
     * @memberof OpenaiSkill
     */
    'id': number;
    /**
     * Minimum range in cells from caster to target (0-10)
     * @type {number}
     * @memberof OpenaiSkill
     */
    'min_range'?: number;
    /**
     * Maximum range in cells from caster to target (0-10)
     * @type {number}
     * @memberof OpenaiSkill
     */
    'max_range'?: number;
    /**
     * 
     * @type {SprayConfig}
     * @memberof OpenaiSkill
     */
    'spray_config'?: SprayConfig | null;
    /**
     * Number of charges (independent applications) per use
     * @type {number}
     * @memberof OpenaiSkill
     */
    'charge_count'?: number;
    /**
     * True when the skill is cast on its user and needs no target chosen: the client applies it to the caster directly.
     * @type {boolean}
     * @memberof OpenaiSkill
     */
    'self_target': boolean;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSkill
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSkill
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSkill
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof OpenaiSkill
     */
    'grade'?: number;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSkill
     */
    'description': string;
    /**
     * 
     * @type {SkillTypeEnum}
     * @memberof OpenaiSkill
     */
    'type'?: SkillTypeEnum;
    /**
     * 
     * @type {UseEnum}
     * @memberof OpenaiSkill
     */
    'use'?: UseEnum;
    /**
     * A list of Impact objects describing what the skill does.
     * @type {any}
     * @memberof OpenaiSkill
     */
    'impact'?: any;
    /**
     * A list of Cost objects describing what the skill costs to use.
     * @type {any}
     * @memberof OpenaiSkill
     */
    'cost'?: any;
    /**
     * A list of AssignableEffect objects the skill can inflict.
     * @type {any}
     * @memberof OpenaiSkill
     */
    'effect'?: any;
    /**
     * Special type of the skill  * `ACTION` - ACTION * `TELEPORT` - TELEPORT * `TELEPORT_TO_CHARACTER` - TELEPORT_TO_CHARACTER * `TELEPORT_TO_SAFE_ZONE` - TELEPORT_TO_SAFE_ZONE * `RESET_STATS` - RESET_STATS * `FLOW_ACCUMULATION` - FLOW_ACCUMULATION
     * @type {SpecialEnum}
     * @memberof OpenaiSkill
     */
    'special'?: SpecialEnum;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSkill
     */
    'icon'?: string | null;
    /**
     * If true, the skill will be performed immediately
     * @type {boolean}
     * @memberof OpenaiSkill
     */
    'immediate'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof OpenaiSkill
     */
    'allowed_phases'?: any;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSkill
     */
    'school': string | null;
}


/**
 * 
 * @export
 * @interface OpenaiSkillRequest
 */
export interface OpenaiSkillRequest {
    /**
     * Minimum range in cells from caster to target (0-10)
     * @type {number}
     * @memberof OpenaiSkillRequest
     */
    'min_range'?: number;
    /**
     * Maximum range in cells from caster to target (0-10)
     * @type {number}
     * @memberof OpenaiSkillRequest
     */
    'max_range'?: number;
    /**
     * 
     * @type {SprayConfigRequest}
     * @memberof OpenaiSkillRequest
     */
    'spray_config'?: SprayConfigRequest | null;
    /**
     * Number of charges (independent applications) per use
     * @type {number}
     * @memberof OpenaiSkillRequest
     */
    'charge_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSkillRequest
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSkillRequest
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof OpenaiSkillRequest
     */
    'grade'?: number;
    /**
     * 
     * @type {string}
     * @memberof OpenaiSkillRequest
     */
    'description': string;
    /**
     * 
     * @type {SkillTypeEnum}
     * @memberof OpenaiSkillRequest
     */
    'type'?: SkillTypeEnum;
    /**
     * 
     * @type {UseEnum}
     * @memberof OpenaiSkillRequest
     */
    'use'?: UseEnum;
    /**
     * A list of Impact objects describing what the skill does.
     * @type {any}
     * @memberof OpenaiSkillRequest
     */
    'impact'?: any;
    /**
     * A list of Cost objects describing what the skill costs to use.
     * @type {any}
     * @memberof OpenaiSkillRequest
     */
    'cost'?: any;
    /**
     * A list of AssignableEffect objects the skill can inflict.
     * @type {any}
     * @memberof OpenaiSkillRequest
     */
    'effect'?: any;
    /**
     * Special type of the skill  * `ACTION` - ACTION * `TELEPORT` - TELEPORT * `TELEPORT_TO_CHARACTER` - TELEPORT_TO_CHARACTER * `TELEPORT_TO_SAFE_ZONE` - TELEPORT_TO_SAFE_ZONE * `RESET_STATS` - RESET_STATS * `FLOW_ACCUMULATION` - FLOW_ACCUMULATION
     * @type {SpecialEnum}
     * @memberof OpenaiSkillRequest
     */
    'special'?: SpecialEnum;
    /**
     * 
     * @type {File}
     * @memberof OpenaiSkillRequest
     */
    'icon'?: File | null;
    /**
     * If true, the skill will be performed immediately
     * @type {boolean}
     * @memberof OpenaiSkillRequest
     */
    'immediate'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof OpenaiSkillRequest
     */
    'allowed_phases'?: any;
}


/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrganizationRequest
 */
export interface OrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRequest
     */
    'name': string;
}
/**
 * * `victory` - victory * `draw` - draw * `forfeit` - forfeit * `inactivity` - inactivity * `max_rounds` - max_rounds * `stopped` - stopped * `agreed` - agreed
 * @export
 * @enum {string}
 */

export const OutcomeCc4Enum = {
    Victory: 'victory',
    Draw: 'draw',
    Forfeit: 'forfeit',
    Inactivity: 'inactivity',
    MaxRounds: 'max_rounds',
    Stopped: 'stopped',
    Agreed: 'agreed'
} as const;

export type OutcomeCc4Enum = typeof OutcomeCc4Enum[keyof typeof OutcomeCc4Enum];


/**
 * * `Critical Fail` - Critical Fail * `Critical Success` - Critical Success * `Bad Luck` - Bad Luck * `Base Value` - Base Value * `Good Luck` - Good Luck
 * @export
 * @enum {string}
 */

export const OutcomeEnum = {
    CriticalFail: 'Critical Fail',
    CriticalSuccess: 'Critical Success',
    BadLuck: 'Bad Luck',
    BaseValue: 'Base Value',
    GoodLuck: 'Good Luck'
} as const;

export type OutcomeEnum = typeof OutcomeEnum[keyof typeof OutcomeEnum];


/**
 * 
 * @export
 * @interface PaginatedCharacterActionLogList
 */
export interface PaginatedCharacterActionLogList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCharacterActionLogList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCharacterActionLogList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCharacterActionLogList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<CharacterActionLog>}
     * @memberof PaginatedCharacterActionLogList
     */
    'results': Array<CharacterActionLog>;
}
/**
 * 
 * @export
 * @interface PaginatedCharacterMissingAvatarList
 */
export interface PaginatedCharacterMissingAvatarList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCharacterMissingAvatarList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCharacterMissingAvatarList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCharacterMissingAvatarList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<CharacterMissingAvatar>}
     * @memberof PaginatedCharacterMissingAvatarList
     */
    'results': Array<CharacterMissingAvatar>;
}
/**
 * 
 * @export
 * @interface PaginatedCharacterTemplateGameMasterList
 */
export interface PaginatedCharacterTemplateGameMasterList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCharacterTemplateGameMasterList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCharacterTemplateGameMasterList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCharacterTemplateGameMasterList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<CharacterTemplateGameMaster>}
     * @memberof PaginatedCharacterTemplateGameMasterList
     */
    'results': Array<CharacterTemplateGameMaster>;
}
/**
 * 
 * @export
 * @interface PaginatedDocumentList
 */
export interface PaginatedDocumentList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedDocumentList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDocumentList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDocumentList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Document>}
     * @memberof PaginatedDocumentList
     */
    'results': Array<Document>;
}
/**
 * 
 * @export
 * @interface PaginatedGameMasterCharacterActionLogList
 */
export interface PaginatedGameMasterCharacterActionLogList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedGameMasterCharacterActionLogList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedGameMasterCharacterActionLogList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedGameMasterCharacterActionLogList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<GameMasterCharacterActionLog>}
     * @memberof PaginatedGameMasterCharacterActionLogList
     */
    'results': Array<GameMasterCharacterActionLog>;
}
/**
 * 
 * @export
 * @interface PaginatedLearnedSkillList
 */
export interface PaginatedLearnedSkillList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedLearnedSkillList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLearnedSkillList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLearnedSkillList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<LearnedSkill>}
     * @memberof PaginatedLearnedSkillList
     */
    'results': Array<LearnedSkill>;
}
/**
 * 
 * @export
 * @interface PaginatedModerationQueueItemList
 */
export interface PaginatedModerationQueueItemList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedModerationQueueItemList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedModerationQueueItemList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedModerationQueueItemList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ModerationQueueItem>}
     * @memberof PaginatedModerationQueueItemList
     */
    'results': Array<ModerationQueueItem>;
}
/**
 * 
 * @export
 * @interface PaginatedPortraitQueueItemList
 */
export interface PaginatedPortraitQueueItemList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPortraitQueueItemList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPortraitQueueItemList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPortraitQueueItemList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<PortraitQueueItem>}
     * @memberof PaginatedPortraitQueueItemList
     */
    'results': Array<PortraitQueueItem>;
}
/**
 * 
 * @export
 * @interface PaginatedPortraitRequestList
 */
export interface PaginatedPortraitRequestList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPortraitRequestList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPortraitRequestList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPortraitRequestList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<PortraitRequest>}
     * @memberof PaginatedPortraitRequestList
     */
    'results': Array<PortraitRequest>;
}
/**
 * 
 * @export
 * @interface PaginatedPublicPublishedCharacterList
 */
export interface PaginatedPublicPublishedCharacterList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPublicPublishedCharacterList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPublicPublishedCharacterList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPublicPublishedCharacterList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<PublicPublishedCharacter>}
     * @memberof PaginatedPublicPublishedCharacterList
     */
    'results': Array<PublicPublishedCharacter>;
}
/**
 * 
 * @export
 * @interface PaginatedPublicationRequestList
 */
export interface PaginatedPublicationRequestList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPublicationRequestList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPublicationRequestList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPublicationRequestList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<PublicationRequest>}
     * @memberof PaginatedPublicationRequestList
     */
    'results': Array<PublicationRequest>;
}
/**
 * 
 * @export
 * @interface PaginatedTimeLineEventList
 */
export interface PaginatedTimeLineEventList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTimeLineEventList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTimeLineEventList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTimeLineEventList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<TimeLineEvent>}
     * @memberof PaginatedTimeLineEventList
     */
    'results': Array<TimeLineEvent>;
}
/**
 * 
 * @export
 * @interface PatchedCampaignBasicsUpdateRequest
 */
export interface PatchedCampaignBasicsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedCampaignBasicsUpdateRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCampaignBasicsUpdateRequest
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface PatchedCampaignBuilderStateUpdateRequest
 */
export interface PatchedCampaignBuilderStateUpdateRequest {
    /**
     * 
     * @type {CampaignBuilderStepEnum}
     * @memberof PatchedCampaignBuilderStateUpdateRequest
     */
    'step'?: CampaignBuilderStepEnum;
    /**
     * Marks the given step complete in builder_meta.  * `campaign` - Campaign * `map` - Map * `npcs` - NPCs * `objectives` - Objectives * `summary` - Summary
     * @type {CampaignBuilderStepEnum}
     * @memberof PatchedCampaignBuilderStateUpdateRequest
     */
    'mark_complete'?: CampaignBuilderStepEnum;
}


/**
 * 
 * @export
 * @interface PatchedCampaignNPCUpdateRequest
 */
export interface PatchedCampaignNPCUpdateRequest {
    /**
     * 
     * @type {BehaviorEnum}
     * @memberof PatchedCampaignNPCUpdateRequest
     */
    'behavior'?: BehaviorEnum;
}


/**
 * Serializer for Chapter model.
 * @export
 * @interface PatchedChapterRequest
 */
export interface PatchedChapterRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedChapterRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedChapterRequest
     */
    'description'?: string;
    /**
     * Optional URL to an image representing the chapter
     * @type {File}
     * @memberof PatchedChapterRequest
     */
    'image'?: File | null;
    /**
     * Order of the chapter within the story
     * @type {number}
     * @memberof PatchedChapterRequest
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedChapterRequest
     */
    'story'?: string;
}
/**
 * The owner\'s private, live in-game biography.  Explicit field list on purpose: ``OpenaiCharacterBioSerializer`` is ``fields = \"__all__\"`` and would expose the FK id and any future column.
 * @export
 * @interface PatchedCharacterBiographyDetailRequest
 */
export interface PatchedCharacterBiographyDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedCharacterBiographyDetailRequest
     */
    'background'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCharacterBiographyDetailRequest
     */
    'appearance'?: string;
}
/**
 * Serializer for signing a character with Flow, or unsigning it.
 * @export
 * @interface PatchedCharacterGameMasterModeRequest
 */
export interface PatchedCharacterGameMasterModeRequest {
    /**
     * True signs the character with Flow, False releases it
     * @type {boolean}
     * @memberof PatchedCharacterGameMasterModeRequest
     */
    'enabled'?: boolean;
}
/**
 * Serializer for changing the footprint a character holds on the grid.
 * @export
 * @interface PatchedCharacterTacticalSizeRequest
 */
export interface PatchedCharacterTacticalSizeRequest {
    /**
     * \'standard\' 1x1, \'medium\' 2x2, \'superior\' 3x3  * `standard` - standard * `medium` - medium * `superior` - superior
     * @type {TacticalSizeEnum}
     * @memberof PatchedCharacterTacticalSizeRequest
     */
    'tactical_size'?: TacticalSizeEnum;
}


/**
 * Serializer for Condition model.
 * @export
 * @interface PatchedConditionRequest
 */
export interface PatchedConditionRequest {
    /**
     * 
     * @type {ConditionTypeEnum}
     * @memberof PatchedConditionRequest
     */
    'type'?: ConditionTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchedConditionRequest
     */
    'trigger_ids'?: Array<string>;
}


/**
 * 
 * @export
 * @interface PatchedCurrencyTokenRequest
 */
export interface PatchedCurrencyTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedCurrencyTokenRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCurrencyTokenRequest
     */
    'description'?: string;
    /**
     * 
     * @type {File}
     * @memberof PatchedCurrencyTokenRequest
     */
    'icon'?: File | null;
}
/**
 * 
 * @export
 * @interface PatchedDeckRequest
 */
export interface PatchedDeckRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedDeckRequest
     */
    'name'?: string;
    /**
     * The deck used for matchmaking
     * @type {boolean}
     * @memberof PatchedDeckRequest
     */
    'is_active'?: boolean;
}
/**
 * Serializer for Document objects
 * @export
 * @interface PatchedDocumentRequest
 */
export interface PatchedDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedDocumentRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedDocumentRequest
     */
    'content'?: string;
    /**
     * 
     * @type {Array<CategoriesEnum>}
     * @memberof PatchedDocumentRequest
     */
    'categories'?: Array<CategoriesEnum>;
    /**
     * 
     * @type {File}
     * @memberof PatchedDocumentRequest
     */
    'image'?: File | null;
}
/**
 * Serializer for EffectReward model.
 * @export
 * @interface PatchedEffectRewardRequest
 */
export interface PatchedEffectRewardRequest {
    /**
     * 
     * @type {EffectEnum}
     * @memberof PatchedEffectRewardRequest
     */
    'effect'?: EffectEnum;
    /**
     * Duration of the effect in turns
     * @type {number}
     * @memberof PatchedEffectRewardRequest
     */
    'duration'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedEffectRewardRequest
     */
    'reward'?: string | null;
}


/**
 * 
 * @export
 * @interface PatchedGameMasterCharacterActionLogRequest
 */
export interface PatchedGameMasterCharacterActionLogRequest {
    /**
     * 
     * @type {CharacterActionTypeEnum}
     * @memberof PatchedGameMasterCharacterActionLogRequest
     */
    'action_type'?: CharacterActionTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof PatchedGameMasterCharacterActionLogRequest
     */
    'data'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterCharacterActionLogRequest
     */
    'accepted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterCharacterActionLogRequest
     */
    'performed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterCharacterActionLogRequest
     */
    'order'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterCharacterActionLogRequest
     */
    'immediate'?: boolean;
}


/**
 * Input for moving a participant to a different side of the same fight; ``character_id`` is read from the URL, never the body.
 * @export
 * @interface PatchedGameMasterFightParticipantMoveRequest
 */
export interface PatchedGameMasterFightParticipantMoveRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterFightParticipantMoveRequest
     */
    'side_id'?: string;
}
/**
 * The donut/side-rail shape, computed once by ``apps.game.services.fight.side_summary.summarize`` and reused here so the API response and the WebSocket event never disagree.  Only ``name`` is writable — creation takes it, rename takes it, and everything else here is server-derived.
 * @export
 * @interface PatchedGameMasterFightSideRequest
 */
export interface PatchedGameMasterFightSideRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterFightSideRequest
     */
    'name'?: string;
}
/**
 * Serializer for PositionConnection model.
 * @export
 * @interface PatchedGameMasterPositionConnectionRequest
 */
export interface PatchedGameMasterPositionConnectionRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterPositionConnectionRequest
     */
    'position_from'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterPositionConnectionRequest
     */
    'position_to'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterPositionConnectionRequest
     */
    'locked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterPositionConnectionRequest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterPositionConnectionRequest
     */
    'is_public'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof PatchedGameMasterPositionConnectionRequest
     */
    'config'?: any | null;
}
/**
 * Serializer for SubLocation model.
 * @export
 * @interface PatchedGameMasterSubLocationRequest
 */
export interface PatchedGameMasterSubLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterSubLocationRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterSubLocationRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterSubLocationRequest
     */
    'location'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterSubLocationRequest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterSubLocationRequest
     */
    'map_x'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterSubLocationRequest
     */
    'map_y'?: number | null;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface PatchedGameMasterWorldAreaRequest
 */
export interface PatchedGameMasterWorldAreaRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldAreaRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldAreaRequest
     */
    'description'?: string;
    /**
     * 
     * @type {File}
     * @memberof PatchedGameMasterWorldAreaRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldAreaRequest
     */
    'city'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterWorldAreaRequest
     */
    'area'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterWorldAreaRequest
     */
    'is_active'?: boolean;
    /**
     * Default battle map template for fights in this area
     * @type {string}
     * @memberof PatchedGameMasterWorldAreaRequest
     */
    'battle_map_template'?: string | null;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface PatchedGameMasterWorldCityRequest
 */
export interface PatchedGameMasterWorldCityRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldCityRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldCityRequest
     */
    'description'?: string;
    /**
     * 
     * @type {File}
     * @memberof PatchedGameMasterWorldCityRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldCityRequest
     */
    'country'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterWorldCityRequest
     */
    'is_active'?: boolean;
    /**
     * Default battle map template for fights in this city
     * @type {string}
     * @memberof PatchedGameMasterWorldCityRequest
     */
    'battle_map_template'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterWorldCityRequest
     */
    'map_x'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterWorldCityRequest
     */
    'map_y'?: number | null;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface PatchedGameMasterWorldContinentRequest
 */
export interface PatchedGameMasterWorldContinentRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldContinentRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldContinentRequest
     */
    'description'?: string;
    /**
     * 
     * @type {File}
     * @memberof PatchedGameMasterWorldContinentRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldContinentRequest
     */
    'planet'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterWorldContinentRequest
     */
    'area'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterWorldContinentRequest
     */
    'population'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterWorldContinentRequest
     */
    'number_of_countries'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterWorldContinentRequest
     */
    'is_active'?: boolean;
    /**
     * Default battle map template for fights in this continent
     * @type {string}
     * @memberof PatchedGameMasterWorldContinentRequest
     */
    'battle_map_template'?: string | null;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface PatchedGameMasterWorldCountryRequest
 */
export interface PatchedGameMasterWorldCountryRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldCountryRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldCountryRequest
     */
    'description'?: string;
    /**
     * 
     * @type {File}
     * @memberof PatchedGameMasterWorldCountryRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldCountryRequest
     */
    'continent'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterWorldCountryRequest
     */
    'area'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterWorldCountryRequest
     */
    'is_active'?: boolean;
    /**
     * Default battle map template for fights in this country
     * @type {string}
     * @memberof PatchedGameMasterWorldCountryRequest
     */
    'battle_map_template'?: string | null;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface PatchedGameMasterWorldLocationRequest
 */
export interface PatchedGameMasterWorldLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldLocationRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldLocationRequest
     */
    'description'?: string;
    /**
     * 
     * @type {File}
     * @memberof PatchedGameMasterWorldLocationRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldLocationRequest
     */
    'area'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterWorldLocationRequest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterWorldLocationRequest
     */
    'is_public'?: boolean;
    /**
     * Default battle map template for fights in this location
     * @type {string}
     * @memberof PatchedGameMasterWorldLocationRequest
     */
    'battle_map_template'?: string | null;
}
/**
 * Every model here carries `game_tags = SANDBOX` and is shared across every campaign. `scope`/`is_shared` are read-only so the builder UI can warn a GM that creating or editing one of these rows changes the world every campaign sees, not just their own.
 * @export
 * @interface PatchedGameMasterWorldPlanetRequest
 */
export interface PatchedGameMasterWorldPlanetRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldPlanetRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldPlanetRequest
     */
    'description'?: string;
    /**
     * 
     * @type {File}
     * @memberof PatchedGameMasterWorldPlanetRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterWorldPlanetRequest
     */
    'distance_from_star'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterWorldPlanetRequest
     */
    'diameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterWorldPlanetRequest
     */
    'mass'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterWorldPlanetRequest
     */
    'gravity'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameMasterWorldPlanetRequest
     */
    'atmosphere'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterWorldPlanetRequest
     */
    'temperature'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameMasterWorldPlanetRequest
     */
    'number_of_moons'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameMasterWorldPlanetRequest
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchedGameObjectRequest
 */
export interface PatchedGameObjectRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedGameObjectRequest
     */
    'position'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedGameObjectRequest
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedGameObjectRequest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedGameObjectRequest
     */
    'campaign'?: string;
}
/**
 * Serializer for ItemReward model.
 * @export
 * @interface PatchedItemRewardRequest
 */
export interface PatchedItemRewardRequest {
    /**
     * Amount of items to reward
     * @type {number}
     * @memberof PatchedItemRewardRequest
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedItemRewardRequest
     */
    'item'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedItemRewardRequest
     */
    'reward'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchedModificatorRequest
 */
export interface PatchedModificatorRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedModificatorRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedModificatorRequest
     */
    'description'?: string;
    /**
     * 
     * @type {File}
     * @memberof PatchedModificatorRequest
     */
    'icon'?: File | null;
    /**
     * 
     * @type {Array<StatModificatorRequest>}
     * @memberof PatchedModificatorRequest
     */
    'stat_modificators'?: Array<StatModificatorRequest>;
}
/**
 * Serializer for changing NPC behavior.
 * @export
 * @interface PatchedNPCBehaviorRequest
 */
export interface PatchedNPCBehaviorRequest {
    /**
     * 
     * @type {BehaviorEnum}
     * @memberof PatchedNPCBehaviorRequest
     */
    'behavior'?: BehaviorEnum;
}


/**
 * Serializer for NPCSpawner model for Game Master API.  This serializer provides complete functionality for creating and managing NPC spawners with position, campaign, character template, and spawn settings.
 * @export
 * @interface PatchedNPCGenericSpawnerRequest
 */
export interface PatchedNPCGenericSpawnerRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchedNPCGenericSpawnerRequest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedNPCGenericSpawnerRequest
     */
    'spawn_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedNPCGenericSpawnerRequest
     */
    'respawn_cycles'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedNPCGenericSpawnerRequest
     */
    'character_template'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedNPCGenericSpawnerRequest
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedNPCGenericSpawnerRequest
     */
    'position'?: string | null;
}
/**
 * Serializer for Note model.
 * @export
 * @interface PatchedNoteRequest
 */
export interface PatchedNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedNoteRequest
     */
    'quest'?: string;
    /**
     * Optional URL to an image representing the note
     * @type {File}
     * @memberof PatchedNoteRequest
     */
    'image'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedNoteRequest
     */
    'content'?: string;
    /**
     * Order of the note within the quest
     * @type {number}
     * @memberof PatchedNoteRequest
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @interface PatchedOpenAIClientManagementRequest
 */
export interface PatchedOpenAIClientManagementRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedOpenAIClientManagementRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOpenAIClientManagementRequest
     */
    'last_login'?: string | null;
    /**
     * Designates that this user has all permissions without explicitly assigning them.
     * @type {boolean}
     * @memberof PatchedOpenAIClientManagementRequest
     */
    'is_superuser'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedOpenAIClientManagementRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOpenAIClientManagementRequest
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOpenAIClientManagementRequest
     */
    'last_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedOpenAIClientManagementRequest
     */
    'email_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedOpenAIClientManagementRequest
     */
    'email_verified_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedOpenAIClientManagementRequest
     */
    'current_campaign'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedOpenAIClientManagementRequest
     */
    'main_character'?: string | null;
    /**
     * The groups this user belongs to. A user will get all permissions granted to each of their groups.
     * @type {Array<number>}
     * @memberof PatchedOpenAIClientManagementRequest
     */
    'groups'?: Array<number>;
    /**
     * Specific permissions for this user.
     * @type {Array<number>}
     * @memberof PatchedOpenAIClientManagementRequest
     */
    'user_permissions'?: Array<number>;
}
/**
 * Serializer for PopulationScaledNPCSpawner model for Game Master API.
 * @export
 * @interface PatchedPopulationScaledNPCGenericSpawnerRequest
 */
export interface PatchedPopulationScaledNPCGenericSpawnerRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchedPopulationScaledNPCGenericSpawnerRequest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedPopulationScaledNPCGenericSpawnerRequest
     */
    'spawn_limit'?: number;
    /**
     * Target NPC count = ceil(ratio x counted characters at the position)
     * @type {string}
     * @memberof PatchedPopulationScaledNPCGenericSpawnerRequest
     */
    'ratio'?: string;
    /**
     * Cycles to wait after a fight closes before spawning again
     * @type {number}
     * @memberof PatchedPopulationScaledNPCGenericSpawnerRequest
     */
    'relax_cycles'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedPopulationScaledNPCGenericSpawnerRequest
     */
    'character_template'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedPopulationScaledNPCGenericSpawnerRequest
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedPopulationScaledNPCGenericSpawnerRequest
     */
    'position'?: string | null;
}
/**
 * Serializer for Position model.
 * @export
 * @interface PatchedPositionRequest
 */
export interface PatchedPositionRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedPositionRequest
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedPositionRequest
     */
    'grid_x'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedPositionRequest
     */
    'grid_y'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedPositionRequest
     */
    'grid_z'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedPositionRequest
     */
    'sub_location'?: string;
    /**
     * 
     * @type {any}
     * @memberof PatchedPositionRequest
     */
    'labels'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedPositionRequest
     */
    'is_safe'?: boolean;
    /**
     * 
     * @type {File}
     * @memberof PatchedPositionRequest
     */
    'image'?: File | null;
}
/**
 * 
 * @export
 * @interface PatchedPublicationDraftUpdateRequest
 */
export interface PatchedPublicationDraftUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedPublicationDraftUpdateRequest
     */
    'proposed_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPublicationDraftUpdateRequest
     */
    'proposed_background'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPublicationDraftUpdateRequest
     */
    'proposed_appearance'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPublicationDraftUpdateRequest
     */
    'proposed_tiktok_link'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPublicationDraftUpdateRequest
     */
    'proposed_youtube_link'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPublicationDraftUpdateRequest
     */
    'proposed_instagram_link'?: string;
}
/**
 * Serializer for Quest model.
 * @export
 * @interface PatchedQuestRequest
 */
export interface PatchedQuestRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedQuestRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedQuestRequest
     */
    'description'?: string;
    /**
     * Optional URL to an image representing the quest
     * @type {File}
     * @memberof PatchedQuestRequest
     */
    'image'?: File | null;
    /**
     * Time limit in cycles (1 cycle = 1 turn)
     * @type {number}
     * @memberof PatchedQuestRequest
     */
    'cycle_limit'?: number | null;
    /**
     * Order of the quest within the chapter
     * @type {number}
     * @memberof PatchedQuestRequest
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedQuestRequest
     */
    'chapter'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchedQuestRequest
     */
    'starter_ids'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchedQuestRequest
     */
    'objective_ids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PatchedQuestRequest
     */
    'success_reward_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedQuestRequest
     */
    'failure_reward_id'?: string | null;
}
/**
 * Serializer for Reward model.
 * @export
 * @interface PatchedRewardRequest
 */
export interface PatchedRewardRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedRewardRequest
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedRewardRequest
     */
    'experience'?: number;
}
/**
 * Serializer for Story model.
 * @export
 * @interface PatchedStoryRequest
 */
export interface PatchedStoryRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedStoryRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedStoryRequest
     */
    'description'?: string;
    /**
     * List of tags for the story
     * @type {any}
     * @memberof PatchedStoryRequest
     */
    'tags'?: any;
    /**
     * Optional URL to an image representing the story
     * @type {File}
     * @memberof PatchedStoryRequest
     */
    'image'?: File | null;
    /**
     * Default to false, need review by the Owner
     * @type {boolean}
     * @memberof PatchedStoryRequest
     */
    'canonical'?: boolean;
}
/**
 * Serializer for creating templates via API (without file upload)
 * @export
 * @interface PatchedTacticalMapTemplateCreateRequest
 */
export interface PatchedTacticalMapTemplateCreateRequest {
    /**
     * Name of the tactical map template
     * @type {string}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'name'?: string;
    /**
     * Description of the map, its purpose, and features
     * @type {string}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'description'?: string;
    /**
     * Map creator/author name
     * @type {string}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'author'?: string;
    /**
     * PNG background image for the tactical map
     * @type {File}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'background_image'?: File;
    /**
     * Challenge rating / difficulty level  * `easy` - Easy (CR 1-5) * `medium` - Medium (CR 6-10) * `hard` - Hard (CR 11-15) * `deadly` - Deadly (CR 16+) * `custom` - Custom
     * @type {DifficultyRatingEnum}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'difficulty_rating'?: DifficultyRatingEnum;
    /**
     * Map category for organization  * `dungeon` - Dungeon * `wilderness` - Wilderness * `urban` - Urban * `indoor` - Indoor * `arena` - Arena * `ship` - Ship/Vehicle * `planar` - Planar/Dimensional * `custom` - Custom
     * @type {CategoryEnum}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'category'?: CategoryEnum;
    /**
     * List of string tags for filtering/searching
     * @type {any}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'tags'?: any;
    /**
     * Number of grid columns
     * @type {number}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'grid_columns'?: number;
    /**
     * Number of grid rows
     * @type {number}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'grid_rows'?: number;
    /**
     * Grid cell width in pixels
     * @type {number}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'cell_width'?: number;
    /**
     * Grid cell height in pixels
     * @type {number}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'cell_height'?: number;
    /**
     * Minimum recommended players
     * @type {number}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'recommended_player_count_min'?: number;
    /**
     * Maximum recommended players
     * @type {number}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'recommended_player_count_max'?: number;
    /**
     * Full map data in frontend format (version 2.0 structure)
     * @type {any}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'map_data'?: any;
    /**
     * Map data format version
     * @type {string}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'format_version'?: string;
    /**
     * Template version number (incremented on updates)
     * @type {number}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'template_version'?: number;
    /**
     * Official/canonical template (vs user-created)
     * @type {boolean}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'canonical'?: boolean;
    /**
     * Published and available for use
     * @type {boolean}
     * @memberof PatchedTacticalMapTemplateCreateRequest
     */
    'published'?: boolean;
}


/**
 * Serializer for TokenReward model.
 * @export
 * @interface PatchedTokenRewardRequest
 */
export interface PatchedTokenRewardRequest {
    /**
     * Amount of tokens to reward
     * @type {number}
     * @memberof PatchedTokenRewardRequest
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedTokenRewardRequest
     */
    'token'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTokenRewardRequest
     */
    'reward'?: string | null;
}
/**
 * Serializer for Trigger model.
 * @export
 * @interface PatchedTriggerRequest
 */
export interface PatchedTriggerRequest {
    /**
     * 
     * @type {TriggerTypeEnum}
     * @memberof PatchedTriggerRequest
     */
    'type'?: TriggerTypeEnum;
    /**
     * Description of the trigger
     * @type {string}
     * @memberof PatchedTriggerRequest
     */
    'description'?: string;
    /**
     * Concreate - Item, Character, Anomaly
     * @type {string}
     * @memberof PatchedTriggerRequest
     */
    'game_object'?: string | null;
    /**
     * Position in the game world
     * @type {string}
     * @memberof PatchedTriggerRequest
     */
    'position'?: string | null;
    /**
     * Optional limit trigger to a specific location
     * @type {string}
     * @memberof PatchedTriggerRequest
     */
    'location'?: string | null;
    /**
     * All NPCs that been created from this template will have this trigger
     * @type {string}
     * @memberof PatchedTriggerRequest
     */
    'npc'?: string | null;
    /**
     * Optional skill that is required to trigger the action
     * @type {number}
     * @memberof PatchedTriggerRequest
     */
    'skill'?: number | null;
    /**
     * Optional item that is required to trigger the action
     * @type {string}
     * @memberof PatchedTriggerRequest
     */
    'item'?: string | null;
}


/**
 * 
 * @export
 * @interface PatchedWorldItemRequest
 */
export interface PatchedWorldItemRequest {
    /**
     * 
     * @type {ItemRequest}
     * @memberof PatchedWorldItemRequest
     */
    'item'?: ItemRequest;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedWorldItemRequest
     */
    'is_active'?: boolean;
    /**
     * Footprint on the tactical grid: standard 1x1, medium 2x2, superior 3x3, anchored at the object\'s north-west cell  * `standard` - standard * `medium` - medium * `superior` - superior
     * @type {TacticalSizeEnum}
     * @memberof PatchedWorldItemRequest
     */
    'tactical_size'?: TacticalSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchedWorldItemRequest
     */
    'charges_left'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedWorldItemRequest
     */
    'visibility'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedWorldItemRequest
     */
    'position'?: string | null;
    /**
     * current area position tabletop map contains of string in format x,y coordinates the layer/dimension always took from the self.dimension
     * @type {string}
     * @memberof PatchedWorldItemRequest
     */
    'tactical_position'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedWorldItemRequest
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedWorldItemRequest
     */
    'campaign'?: string;
}


/**
 * 
 * @export
 * @interface PendingJoinFightEvent
 */
export interface PendingJoinFightEvent {
    /**
     * 
     * @type {string}
     * @memberof PendingJoinFightEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PendingJoinFightEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof PendingJoinFightEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof PendingJoinFightEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsPendingJoinFightEventData}
     * @memberof PendingJoinFightEvent
     */
    'data': WsPendingJoinFightEventData;
}


/**
 * * `establishment` - establishment * `preparation` - preparation * `action` - action
 * @export
 * @enum {string}
 */

export const Phase347Enum = {
    Establishment: 'establishment',
    Preparation: 'preparation',
    Action: 'action'
} as const;

export type Phase347Enum = typeof Phase347Enum[keyof typeof Phase347Enum];


/**
 * Tactical map serializer for player view - filters GM data with fog of war.  This serializer provides a player-safe view of tactical maps by: - Filtering out GM-specific data (gm_notes, spawner data) - Applying fog of war to limit visible GameObjects - Providing background image URLs, grid settings, and edges
 * @export
 * @interface PlayerTacticalMap
 */
export interface PlayerTacticalMap {
    /**
     * 
     * @type {string}
     * @memberof PlayerTacticalMap
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PlayerTacticalMap
     */
    'template_name': string;
    /**
     * 
     * @type {string}
     * @memberof PlayerTacticalMap
     */
    'template_id': string;
    /**
     * 
     * @type {number}
     * @memberof PlayerTacticalMap
     */
    'template_version': number;
    /**
     * 
     * @type {boolean}
     * @memberof PlayerTacticalMap
     */
    'has_scene': boolean;
    /**
     * 
     * @type {string}
     * @memberof PlayerTacticalMap
     */
    'difficulty': string;
    /**
     * 
     * @type {string}
     * @memberof PlayerTacticalMap
     */
    'category': string;
    /**
     * Return absolute URL for background image.
     * @type {string}
     * @memberof PlayerTacticalMap
     */
    'background_image_url': string;
    /**
     * 
     * @type {GridSettings}
     * @memberof PlayerTacticalMap
     */
    'grid_settings': GridSettings;
    /**
     * Array of spawned game objects on the map. Only includes objects visible through fog of war. Each object includes its polymorphic type from Django.
     * @type {Array<SpawnedObject>}
     * @memberof PlayerTacticalMap
     */
    'spawned_objects': Array<SpawnedObject>;
    /**
     * Array of movement edges between grid cells. Represents the movement graph for pathfinding.
     * @type {Array<Edge>}
     * @memberof PlayerTacticalMap
     */
    'edges': Array<Edge>;
    /**
     * Array of cells with terrain and passability information. Only includes cells with explicit data (default is passable grass).
     * @type {Array<Cell>}
     * @memberof PlayerTacticalMap
     */
    'cells': Array<Cell>;
    /**
     * 
     * @type {Vision}
     * @memberof PlayerTacticalMap
     */
    'vision': Vision;
}
/**
 * * `positive` - positive * `negative` - negative * `neutral` - neutral
 * @export
 * @enum {string}
 */

export const PolarityEnum = {
    Positive: 'positive',
    Negative: 'negative',
    Neutral: 'neutral'
} as const;

export type PolarityEnum = typeof PolarityEnum[keyof typeof PolarityEnum];


/**
 * Serializer for PopulationScaledNPCSpawner model for Game Master API.
 * @export
 * @interface PopulationScaledNPCGenericSpawner
 */
export interface PopulationScaledNPCGenericSpawner {
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCGenericSpawner
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof PopulationScaledNPCGenericSpawner
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PopulationScaledNPCGenericSpawner
     */
    'spawn_limit'?: number;
    /**
     * Target NPC count = ceil(ratio x counted characters at the position)
     * @type {string}
     * @memberof PopulationScaledNPCGenericSpawner
     */
    'ratio'?: string;
    /**
     * Cycles to wait after a fight closes before spawning again
     * @type {number}
     * @memberof PopulationScaledNPCGenericSpawner
     */
    'relax_cycles'?: number;
    /**
     * 
     * @type {number}
     * @memberof PopulationScaledNPCGenericSpawner
     */
    'relax_until_cycle_number': number;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCGenericSpawner
     */
    'last_closed_fight': string | null;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCGenericSpawner
     */
    'character_template': string;
    /**
     * Cycle number when the next spawn should occur
     * @type {number}
     * @memberof PopulationScaledNPCGenericSpawner
     */
    'next_spawn_cycle_number': number;
    /**
     * 
     * @type {number}
     * @memberof PopulationScaledNPCGenericSpawner
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCGenericSpawner
     */
    'position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCGenericSpawner
     */
    'campaign': string;
    /**
     * 
     * @type {Array<SpawnedEntity>}
     * @memberof PopulationScaledNPCGenericSpawner
     */
    'spawned_entities': Array<SpawnedEntity>;
}
/**
 * Serializer for PopulationScaledNPCSpawner model for Game Master API.
 * @export
 * @interface PopulationScaledNPCGenericSpawnerRequest
 */
export interface PopulationScaledNPCGenericSpawnerRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PopulationScaledNPCGenericSpawnerRequest
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PopulationScaledNPCGenericSpawnerRequest
     */
    'spawn_limit'?: number;
    /**
     * Target NPC count = ceil(ratio x counted characters at the position)
     * @type {string}
     * @memberof PopulationScaledNPCGenericSpawnerRequest
     */
    'ratio'?: string;
    /**
     * Cycles to wait after a fight closes before spawning again
     * @type {number}
     * @memberof PopulationScaledNPCGenericSpawnerRequest
     */
    'relax_cycles'?: number;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCGenericSpawnerRequest
     */
    'character_template': string;
    /**
     * 
     * @type {number}
     * @memberof PopulationScaledNPCGenericSpawnerRequest
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCGenericSpawnerRequest
     */
    'position'?: string | null;
}
/**
 * 
 * @export
 * @interface PopulationScaledNPCSpawnerCreate
 */
export interface PopulationScaledNPCSpawnerCreate {
    /**
     * 
     * @type {number}
     * @memberof PopulationScaledNPCSpawnerCreate
     */
    'spawn_limit'?: number;
    /**
     * Target NPC count = ceil(ratio x counted characters at the position)
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerCreate
     */
    'ratio'?: string;
    /**
     * Cycles to wait after a fight closes before spawning again
     * @type {number}
     * @memberof PopulationScaledNPCSpawnerCreate
     */
    'relax_cycles'?: number;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerCreate
     */
    'character_template': string;
    /**
     * 
     * @type {number}
     * @memberof PopulationScaledNPCSpawnerCreate
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerCreate
     */
    'position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerCreate
     */
    'campaign': string;
    /**
     * 
     * @type {boolean}
     * @memberof PopulationScaledNPCSpawnerCreate
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerCreate
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PopulationScaledNPCSpawnerCreateRequest
 */
export interface PopulationScaledNPCSpawnerCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof PopulationScaledNPCSpawnerCreateRequest
     */
    'spawn_limit'?: number;
    /**
     * Target NPC count = ceil(ratio x counted characters at the position)
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerCreateRequest
     */
    'ratio'?: string;
    /**
     * Cycles to wait after a fight closes before spawning again
     * @type {number}
     * @memberof PopulationScaledNPCSpawnerCreateRequest
     */
    'relax_cycles'?: number;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerCreateRequest
     */
    'character_template': string;
    /**
     * 
     * @type {number}
     * @memberof PopulationScaledNPCSpawnerCreateRequest
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerCreateRequest
     */
    'position'?: string | null;
}
/**
 * 
 * @export
 * @interface PopulationScaledNPCSpawnerList
 */
export interface PopulationScaledNPCSpawnerList {
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerList
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof PopulationScaledNPCSpawnerList
     */
    'is_active': boolean;
    /**
     * 
     * @type {number}
     * @memberof PopulationScaledNPCSpawnerList
     */
    'spawn_limit': number;
    /**
     * Target NPC count = ceil(ratio x counted characters at the position)
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerList
     */
    'ratio': string;
    /**
     * Cycles to wait after a fight closes before spawning again
     * @type {number}
     * @memberof PopulationScaledNPCSpawnerList
     */
    'relax_cycles': number;
    /**
     * 
     * @type {number}
     * @memberof PopulationScaledNPCSpawnerList
     */
    'relax_until_cycle_number': number;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerList
     */
    'character_template': string;
    /**
     * Cycle number when the next spawn should occur
     * @type {number}
     * @memberof PopulationScaledNPCSpawnerList
     */
    'next_spawn_cycle_number': number;
    /**
     * 
     * @type {number}
     * @memberof PopulationScaledNPCSpawnerList
     */
    'dimension': number | null;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerList
     */
    'position': string | null;
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerList
     */
    'campaign': string;
}
/**
 * 
 * @export
 * @interface PopulationScaledNPCSpawnerMinimalPreview
 */
export interface PopulationScaledNPCSpawnerMinimalPreview {
    /**
     * 
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerMinimalPreview
     */
    'character_template': string;
    /**
     * Target NPC count = ceil(ratio x counted characters at the position)
     * @type {string}
     * @memberof PopulationScaledNPCSpawnerMinimalPreview
     */
    'ratio': string;
    /**
     * Cycles to wait after a fight closes before spawning again
     * @type {number}
     * @memberof PopulationScaledNPCSpawnerMinimalPreview
     */
    'relax_cycles': number;
}
/**
 * 
 * @export
 * @interface PortraitImage
 */
export interface PortraitImage {
    /**
     * 
     * @type {boolean}
     * @memberof PortraitImage
     */
    'uploaded': boolean;
    /**
     * 
     * @type {string}
     * @memberof PortraitImage
     */
    'preview_url': string | null;
    /**
     * 
     * @type {number}
     * @memberof PortraitImage
     */
    'width': number | null;
    /**
     * 
     * @type {number}
     * @memberof PortraitImage
     */
    'height': number | null;
    /**
     * 
     * @type {number}
     * @memberof PortraitImage
     */
    'byte_size': number | null;
}
/**
 * 
 * @export
 * @interface PortraitQueueItem
 */
export interface PortraitQueueItem {
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'character': string;
    /**
     * 
     * @type {PublicationStatusEnum}
     * @memberof PortraitQueueItem
     */
    'status': PublicationStatusEnum;
    /**
     * 
     * @type {PortraitImage}
     * @memberof PortraitQueueItem
     */
    'proposed_avatar': PortraitImage;
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'current_avatar_url': string | null;
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'supersedes': string | null;
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'submitted_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'decided_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'rejection_reason': string;
    /**
     * 
     * @type {boolean}
     * @memberof PortraitQueueItem
     */
    'auto_approved': boolean;
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'character_name': string;
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'owner_email': string;
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'campaign_id': string;
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'admin_url': string;
    /**
     * 
     * @type {string}
     * @memberof PortraitQueueItem
     */
    'preview_url': string | null;
}


/**
 * 
 * @export
 * @interface PortraitRequest
 */
export interface PortraitRequest {
    /**
     * 
     * @type {string}
     * @memberof PortraitRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PortraitRequest
     */
    'character': string;
    /**
     * 
     * @type {PublicationStatusEnum}
     * @memberof PortraitRequest
     */
    'status': PublicationStatusEnum;
    /**
     * 
     * @type {PortraitImage}
     * @memberof PortraitRequest
     */
    'proposed_avatar': PortraitImage;
    /**
     * 
     * @type {string}
     * @memberof PortraitRequest
     */
    'current_avatar_url': string | null;
    /**
     * 
     * @type {string}
     * @memberof PortraitRequest
     */
    'supersedes': string | null;
    /**
     * 
     * @type {string}
     * @memberof PortraitRequest
     */
    'submitted_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof PortraitRequest
     */
    'decided_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof PortraitRequest
     */
    'rejection_reason': string;
    /**
     * 
     * @type {boolean}
     * @memberof PortraitRequest
     */
    'auto_approved': boolean;
    /**
     * 
     * @type {string}
     * @memberof PortraitRequest
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PortraitRequest
     */
    'updated_at': string;
}


/**
 * Serializer for Position model.
 * @export
 * @interface Position
 */
export interface Position {
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    'grid_x'?: number;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    'grid_y'?: number;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    'grid_z'?: number;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'sub_location': string;
    /**
     * 
     * @type {GameMasterSubLocation}
     * @memberof Position
     */
    'sub_location_details': GameMasterSubLocation;
    /**
     * 
     * @type {any}
     * @memberof Position
     */
    'labels'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof Position
     */
    'is_safe'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'coordinates': string;
}
/**
 * 
 * @export
 * @interface PositionBrief
 */
export interface PositionBrief {
    /**
     * 
     * @type {string}
     * @memberof PositionBrief
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof PositionBrief
     */
    'grid_x': number;
    /**
     * 
     * @type {number}
     * @memberof PositionBrief
     */
    'grid_y': number;
    /**
     * 
     * @type {number}
     * @memberof PositionBrief
     */
    'grid_z': number;
    /**
     * 
     * @type {string}
     * @memberof PositionBrief
     */
    'sub_location': string;
    /**
     * 
     * @type {boolean}
     * @memberof PositionBrief
     */
    'is_safe': boolean;
}
/**
 * 
 * @export
 * @interface PositionConnection
 */
export interface PositionConnection {
    /**
     * 
     * @type {string}
     * @memberof PositionConnection
     */
    'to_position': string;
    /**
     * 
     * @type {boolean}
     * @memberof PositionConnection
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PositionConnection
     */
    'is_public'?: boolean;
    /**
     * 
     * @type {DirectionEnum}
     * @memberof PositionConnection
     */
    'direction': DirectionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PositionConnection
     */
    'is_locked': boolean;
    /**
     * 
     * @type {PositionRelationConfiguration}
     * @memberof PositionConnection
     */
    'config': PositionRelationConfiguration;
}


/**
 * Serializer for creating a connection between two positions.
 * @export
 * @interface PositionConnectionCreateRequest
 */
export interface PositionConnectionCreateRequest {
    /**
     * Source position UUID - identifies the starting point of the connection
     * @type {string}
     * @memberof PositionConnectionCreateRequest
     */
    'position_from': string;
    /**
     * Target position UUID - identifies the ending point of the connection
     * @type {string}
     * @memberof PositionConnectionCreateRequest
     */
    'position_to': string;
    /**
     * Controls whether players can traverse this connection
     * @type {boolean}
     * @memberof PositionConnectionCreateRequest
     */
    'locked'?: boolean;
    /**
     * Determines if the connection is currently usable in the game
     * @type {boolean}
     * @memberof PositionConnectionCreateRequest
     */
    'is_active'?: boolean;
    /**
     * Indicates if the connection is visible to all players
     * @type {boolean}
     * @memberof PositionConnectionCreateRequest
     */
    'is_public'?: boolean;
}
/**
 * Serializer for PositionConnectionRequirement objects.
 * @export
 * @interface PositionConnectionRequirement
 */
export interface PositionConnectionRequirement {
    /**
     * 
     * @type {string}
     * @memberof PositionConnectionRequirement
     */
    'item_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionConnectionRequirement
     */
    'skill_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionConnectionRequirement
     */
    'character_id'?: string | null;
}
/**
 * Serializer for PositionConnectionRequirement objects.
 * @export
 * @interface PositionConnectionRequirementRequest
 */
export interface PositionConnectionRequirementRequest {
    /**
     * 
     * @type {string}
     * @memberof PositionConnectionRequirementRequest
     */
    'item_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionConnectionRequirementRequest
     */
    'skill_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionConnectionRequirementRequest
     */
    'character_id'?: string | null;
}
/**
 * Serializer for moving a position to new coordinates.
 * @export
 * @interface PositionMoveRequest
 */
export interface PositionMoveRequest {
    /**
     * New X coordinate
     * @type {number}
     * @memberof PositionMoveRequest
     */
    'grid_x': number;
    /**
     * New Y coordinate
     * @type {number}
     * @memberof PositionMoveRequest
     */
    'grid_y': number;
    /**
     * New Z coordinate
     * @type {number}
     * @memberof PositionMoveRequest
     */
    'grid_z': number;
}
/**
 * Serializer for PositionConnectionConfig objects.
 * @export
 * @interface PositionRelationConfiguration
 */
export interface PositionRelationConfiguration {
    /**
     * 
     * @type {Array<PositionConnectionRequirement>}
     * @memberof PositionRelationConfiguration
     */
    'requirements'?: Array<PositionConnectionRequirement>;
}
/**
 * Serializer for PositionConnectionConfig objects.
 * @export
 * @interface PositionRelationConfigurationRequest
 */
export interface PositionRelationConfigurationRequest {
    /**
     * 
     * @type {Array<PositionConnectionRequirementRequest>}
     * @memberof PositionRelationConfigurationRequest
     */
    'requirements'?: Array<PositionConnectionRequirementRequest>;
}
/**
 * Serializer for Position model.
 * @export
 * @interface PositionRequest
 */
export interface PositionRequest {
    /**
     * 
     * @type {string}
     * @memberof PositionRequest
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionRequest
     */
    'grid_x'?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionRequest
     */
    'grid_y'?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionRequest
     */
    'grid_z'?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionRequest
     */
    'sub_location': string;
    /**
     * 
     * @type {any}
     * @memberof PositionRequest
     */
    'labels'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof PositionRequest
     */
    'is_safe'?: boolean;
    /**
     * 
     * @type {File}
     * @memberof PositionRequest
     */
    'image'?: File | null;
}
/**
 * Every dial the composite turns, so the number can be checked by hand.  Published for the same reason the archetype rating model publishes its own: a balance figure nobody can reproduce is a figure nobody can argue with, and a rebalance is an argument.
 * @export
 * @interface PowerModel
 */
export interface PowerModel {
    /**
     * The composite, written out in the terms below.
     * @type {string}
     * @memberof PowerModel
     */
    'formula': string;
    /**
     * Each term of the formula, named and explained.
     * @type {Array<{ [key: string]: any; }>}
     * @memberof PowerModel
     */
    'terms': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<CoefficientDoc>}
     * @memberof PowerModel
     */
    'coefficients': Array<CoefficientDoc>;
    /**
     * What the composite is for, and what it is not.
     * @type {string}
     * @memberof PowerModel
     */
    'note': string;
}
/**
 * Serializer for a single data point in the progression analysis.
 * @export
 * @interface ProgressionDataPoint
 */
export interface ProgressionDataPoint {
    /**
     * The value of the primary stat at this point
     * @type {number}
     * @memberof ProgressionDataPoint
     */
    'stat_value': number;
    /**
     * Impacts calculated with other stats at minimum baseline
     * @type {Array<CalculatedImpactDetail>}
     * @memberof ProgressionDataPoint
     */
    'minimum_curve': Array<CalculatedImpactDetail>;
    /**
     * Impacts calculated with other stats at median baseline
     * @type {Array<CalculatedImpactDetail>}
     * @memberof ProgressionDataPoint
     */
    'median_curve': Array<CalculatedImpactDetail>;
    /**
     * Impacts calculated with other stats at maximum baseline
     * @type {Array<CalculatedImpactDetail>}
     * @memberof ProgressionDataPoint
     */
    'maximum_curve': Array<CalculatedImpactDetail>;
}
/**
 * * `openai` - OpenAI * `google` - Google * `local` - Local
 * @export
 * @enum {string}
 */

export const ProviderEnum = {
    Openai: 'openai',
    Google: 'google',
    Local: 'local'
} as const;

export type ProviderEnum = typeof ProviderEnum[keyof typeof ProviderEnum];


/**
 * The anonymous public gallery payload.  Reads the approved snapshot only. It deliberately does NOT nest ``OpenaiCharacterBioSerializer`` — that serializer is ``fields = \"__all__\"`` and joining the live biography is the leak this whole feature closes.
 * @export
 * @interface PublicPublishedCharacter
 */
export interface PublicPublishedCharacter {
    /**
     * 
     * @type {string}
     * @memberof PublicPublishedCharacter
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PublicPublishedCharacter
     */
    'character_name': string;
    /**
     * 
     * @type {string}
     * @memberof PublicPublishedCharacter
     */
    'background': string;
    /**
     * 
     * @type {string}
     * @memberof PublicPublishedCharacter
     */
    'appearance': string;
    /**
     * 
     * @type {string}
     * @memberof PublicPublishedCharacter
     */
    'big_avatar': string;
    /**
     * 
     * @type {string}
     * @memberof PublicPublishedCharacter
     */
    'small_avatar': string;
    /**
     * 
     * @type {string}
     * @memberof PublicPublishedCharacter
     */
    'tiktok_link': string;
    /**
     * 
     * @type {string}
     * @memberof PublicPublishedCharacter
     */
    'youtube_link': string;
    /**
     * 
     * @type {string}
     * @memberof PublicPublishedCharacter
     */
    'instagram_link': string;
    /**
     * 
     * @type {string}
     * @memberof PublicPublishedCharacter
     */
    'published_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicPublishedCharacter
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PublicPublishedCharacter
     */
    'updated_at': string;
    /**
     * 
     * @type {DeprecatedPublicBiography}
     * @memberof PublicPublishedCharacter
     */
    'biography': DeprecatedPublicBiography;
}
/**
 * 
 * @export
 * @interface PublicationDiff
 */
export interface PublicationDiff {
    /**
     * 
     * @type {PublicationDiffEntry}
     * @memberof PublicationDiff
     */
    'name': PublicationDiffEntry;
    /**
     * 
     * @type {PublicationDiffEntry}
     * @memberof PublicationDiff
     */
    'background': PublicationDiffEntry;
    /**
     * 
     * @type {PublicationDiffEntry}
     * @memberof PublicationDiff
     */
    'appearance': PublicationDiffEntry;
    /**
     * 
     * @type {PublicationDiffEntry}
     * @memberof PublicationDiff
     */
    'tiktok_link': PublicationDiffEntry;
    /**
     * 
     * @type {PublicationDiffEntry}
     * @memberof PublicationDiff
     */
    'youtube_link': PublicationDiffEntry;
    /**
     * 
     * @type {PublicationDiffEntry}
     * @memberof PublicationDiff
     */
    'instagram_link': PublicationDiffEntry;
    /**
     * 
     * @type {PublicationDiffEntry}
     * @memberof PublicationDiff
     */
    'big_avatar': PublicationDiffEntry;
    /**
     * 
     * @type {PublicationDiffEntry}
     * @memberof PublicationDiff
     */
    'small_avatar': PublicationDiffEntry;
}
/**
 * 
 * @export
 * @interface PublicationDiffEntry
 */
export interface PublicationDiffEntry {
    /**
     * 
     * @type {string}
     * @memberof PublicationDiffEntry
     */
    'current': string;
    /**
     * 
     * @type {string}
     * @memberof PublicationDiffEntry
     */
    'proposed': string;
    /**
     * 
     * @type {boolean}
     * @memberof PublicationDiffEntry
     */
    'changed': boolean;
}
/**
 * Pending images are described, never linked. The stored path lives on private storage whose ``.url`` raises by design.
 * @export
 * @interface PublicationImage
 */
export interface PublicationImage {
    /**
     * 
     * @type {boolean}
     * @memberof PublicationImage
     */
    'uploaded': boolean;
    /**
     * 
     * @type {string}
     * @memberof PublicationImage
     */
    'preview_url': string | null;
}
/**
 * * `big_avatar` - big_avatar * `small_avatar` - small_avatar
 * @export
 * @enum {string}
 */

export const PublicationImageUploadKindEnum = {
    BigAvatar: 'big_avatar',
    SmallAvatar: 'small_avatar'
} as const;

export type PublicationImageUploadKindEnum = typeof PublicationImageUploadKindEnum[keyof typeof PublicationImageUploadKindEnum];


/**
 * 
 * @export
 * @interface PublicationOpenRequest
 */
export interface PublicationOpenRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicationOpenRequest
     */
    'character': string;
}
/**
 * 
 * @export
 * @interface PublicationRequest
 */
export interface PublicationRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicationRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PublicationRequest
     */
    'character': string;
    /**
     * 
     * @type {PublicationStatusEnum}
     * @memberof PublicationRequest
     */
    'status': PublicationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PublicationRequest
     */
    'proposed_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicationRequest
     */
    'proposed_background'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicationRequest
     */
    'proposed_appearance'?: string;
    /**
     * 
     * @type {PublicationImage}
     * @memberof PublicationRequest
     */
    'proposed_big_avatar': PublicationImage;
    /**
     * 
     * @type {PublicationImage}
     * @memberof PublicationRequest
     */
    'proposed_small_avatar': PublicationImage;
    /**
     * 
     * @type {string}
     * @memberof PublicationRequest
     */
    'proposed_tiktok_link'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicationRequest
     */
    'proposed_youtube_link'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicationRequest
     */
    'proposed_instagram_link'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicationRequest
     */
    'submitted_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicationRequest
     */
    'decided_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicationRequest
     */
    'rejection_reason': string;
    /**
     * 
     * @type {boolean}
     * @memberof PublicationRequest
     */
    'auto_approved': boolean;
    /**
     * 
     * @type {string}
     * @memberof PublicationRequest
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PublicationRequest
     */
    'updated_at': string;
}


/**
 * * `draft` - draft * `pending` - pending * `approved` - approved * `rejected` - rejected * `withdrawn` - withdrawn * `superseded` - superseded
 * @export
 * @enum {string}
 */

export const PublicationStatusEnum = {
    Draft: 'draft',
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected',
    Withdrawn: 'withdrawn',
    Superseded: 'superseded'
} as const;

export type PublicationStatusEnum = typeof PublicationStatusEnum[keyof typeof PublicationStatusEnum];


/**
 * 
 * @export
 * @interface PublishIssue
 */
export interface PublishIssue {
    /**
     * 
     * @type {string}
     * @memberof PublishIssue
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof PublishIssue
     */
    'severity': string;
    /**
     * 
     * @type {string}
     * @memberof PublishIssue
     */
    'step': string;
    /**
     * 
     * @type {string}
     * @memberof PublishIssue
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof PublishIssue
     */
    'object_id'?: string | null;
}
/**
 * 
 * @export
 * @interface PublishReport
 */
export interface PublishReport {
    /**
     * 
     * @type {boolean}
     * @memberof PublishReport
     */
    'is_publishable': boolean;
    /**
     * 
     * @type {Array<PublishIssue>}
     * @memberof PublishReport
     */
    'issues': Array<PublishIssue>;
}
/**
 * Serializer for Quest model.
 * @export
 * @interface Quest
 */
export interface Quest {
    /**
     * 
     * @type {string}
     * @memberof Quest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Quest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Quest
     */
    'description': string;
    /**
     * 
     * @type {Array<Condition>}
     * @memberof Quest
     */
    'starters': Array<Condition>;
    /**
     * 
     * @type {Array<Condition>}
     * @memberof Quest
     */
    'objectives': Array<Condition>;
    /**
     * 
     * @type {Reward}
     * @memberof Quest
     */
    'on_success': Reward;
    /**
     * 
     * @type {Reward}
     * @memberof Quest
     */
    'on_failure': Reward;
    /**
     * Optional URL to an image representing the quest
     * @type {string}
     * @memberof Quest
     */
    'image'?: string | null;
    /**
     * Time limit in cycles (1 cycle = 1 turn)
     * @type {number}
     * @memberof Quest
     */
    'cycle_limit'?: number | null;
    /**
     * Order of the quest within the chapter
     * @type {number}
     * @memberof Quest
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof Quest
     */
    'chapter': string;
    /**
     * 
     * @type {Array<Note>}
     * @memberof Quest
     */
    'notes': Array<Note>;
}
/**
 * Serializer for Quest model.
 * @export
 * @interface QuestRequest
 */
export interface QuestRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof QuestRequest
     */
    'description': string;
    /**
     * Optional URL to an image representing the quest
     * @type {File}
     * @memberof QuestRequest
     */
    'image'?: File | null;
    /**
     * Time limit in cycles (1 cycle = 1 turn)
     * @type {number}
     * @memberof QuestRequest
     */
    'cycle_limit'?: number | null;
    /**
     * Order of the quest within the chapter
     * @type {number}
     * @memberof QuestRequest
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof QuestRequest
     */
    'chapter': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestRequest
     */
    'starter_ids'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestRequest
     */
    'objective_ids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof QuestRequest
     */
    'success_reward_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestRequest
     */
    'failure_reward_id'?: string | null;
}
/**
 * 
 * @export
 * @interface Rank
 */
export interface Rank {
    /**
     * 
     * @type {string}
     * @memberof Rank
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Rank
     */
    'grade'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rank
     */
    'grade_rank'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rank
     */
    'experience_needed'?: number;
}
/**
 * 
 * @export
 * @interface RankRequest
 */
export interface RankRequest {
    /**
     * 
     * @type {string}
     * @memberof RankRequest
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof RankRequest
     */
    'grade'?: number;
    /**
     * 
     * @type {number}
     * @memberof RankRequest
     */
    'grade_rank'?: number;
    /**
     * 
     * @type {number}
     * @memberof RankRequest
     */
    'experience_needed'?: number;
}
/**
 * * `common` - common * `uncommon` - uncommon * `rare` - rare * `epic` - epic * `legendary` - legendary
 * @export
 * @enum {string}
 */

export const RarityEnum = {
    Common: 'common',
    Uncommon: 'uncommon',
    Rare: 'rare',
    Epic: 'epic',
    Legendary: 'legendary'
} as const;

export type RarityEnum = typeof RarityEnum[keyof typeof RarityEnum];


/**
 * 
 * @export
 * @interface RegisterImpactAction
 */
export interface RegisterImpactAction {
    /**
     * 
     * @type {string}
     * @memberof RegisterImpactAction
     */
    'initiator': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterImpactAction
     */
    'target': string;
    /**
     * 
     * @type {ImpactTypeEnum}
     * @memberof RegisterImpactAction
     */
    'impact_type': ImpactTypeEnum;
    /**
     * 
     * @type {ImpactViolationTypeEnum}
     * @memberof RegisterImpactAction
     */
    'impact_violation': ImpactViolationTypeEnum;
}


/**
 * 
 * @export
 * @interface RegisterImpactActionRequest
 */
export interface RegisterImpactActionRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterImpactActionRequest
     */
    'initiator': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterImpactActionRequest
     */
    'target': string;
    /**
     * 
     * @type {ImpactTypeEnum}
     * @memberof RegisterImpactActionRequest
     */
    'impact_type': ImpactTypeEnum;
    /**
     * 
     * @type {ImpactViolationTypeEnum}
     * @memberof RegisterImpactActionRequest
     */
    'impact_violation': ImpactViolationTypeEnum;
}


/**
 * 
 * @export
 * @interface RegistrationForm
 */
export interface RegistrationForm {
    /**
     * 
     * @type {string}
     * @memberof RegistrationForm
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationForm
     */
    'last_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RegistrationForm
     */
    'activation_required': boolean;
}
/**
 * 
 * @export
 * @interface RegistrationFormRequest
 */
export interface RegistrationFormRequest {
    /**
     * 
     * @type {string}
     * @memberof RegistrationFormRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationFormRequest
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationFormRequest
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationFormRequest
     */
    'password': string;
}
/**
 * * `self` - self * `ally` - ally * `enemy` - enemy * `neutral` - neutral
 * @export
 * @enum {string}
 */

export const RelationEnum = {
    Self: 'self',
    Ally: 'ally',
    Enemy: 'enemy',
    Neutral: 'neutral'
} as const;

export type RelationEnum = typeof RelationEnum[keyof typeof RelationEnum];


/**
 * 
 * @export
 * @interface ResourcePool
 */
export interface ResourcePool {
    /**
     * 
     * @type {number}
     * @memberof ResourcePool
     */
    'hp': number;
    /**
     * 
     * @type {number}
     * @memberof ResourcePool
     */
    'energy': number;
    /**
     * 
     * @type {number}
     * @memberof ResourcePool
     */
    'ap': number;
}
/**
 * Serializer for Reward model.
 * @export
 * @interface Reward
 */
export interface Reward {
    /**
     * 
     * @type {string}
     * @memberof Reward
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Reward
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof Reward
     */
    'experience'?: number;
    /**
     * 
     * @type {Array<TokenReward>}
     * @memberof Reward
     */
    'tokens': Array<TokenReward>;
    /**
     * 
     * @type {Array<ItemReward>}
     * @memberof Reward
     */
    'items': Array<ItemReward>;
    /**
     * 
     * @type {Array<EffectReward>}
     * @memberof Reward
     */
    'effects': Array<EffectReward>;
}
/**
 * Serializer for Reward model.
 * @export
 * @interface RewardRequest
 */
export interface RewardRequest {
    /**
     * 
     * @type {string}
     * @memberof RewardRequest
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof RewardRequest
     */
    'experience'?: number;
}
/**
 * * `Offensive` - Offensive * `Defensive` - Defensive * `Support` - Support * `Controller` - Controller * `Hybrid` - Hybrid
 * @export
 * @enum {string}
 */

export const Role266Enum = {
    Offensive: 'Offensive',
    Defensive: 'Defensive',
    Support: 'Support',
    Controller: 'Controller',
    Hybrid: 'Hybrid'
} as const;

export type Role266Enum = typeof Role266Enum[keyof typeof Role266Enum];


/**
 * Role distribution summary.
 * @export
 * @interface RoleDistribution
 */
export interface RoleDistribution {
    /**
     * 
     * @type {string}
     * @memberof RoleDistribution
     */
    'role': string;
    /**
     * 
     * @type {number}
     * @memberof RoleDistribution
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface RoundsToTarget
 */
export interface RoundsToTarget {
    /**
     * 
     * @type {number}
     * @memberof RoundsToTarget
     */
    'per_cell': number | null;
    /**
     * 
     * @type {number}
     * @memberof RoundsToTarget
     */
    'per_pattern': number | null;
}
/**
 * * `Attacker` - Attacker * `Defender` - Defender * `Healer` - Healer * `Buffer` - Buffer * `Debuffer` - Debuffer
 * @export
 * @enum {string}
 */

export const RunnerUpEnum = {
    Attacker: 'Attacker',
    Defender: 'Defender',
    Healer: 'Healer',
    Buffer: 'Buffer',
    Debuffer: 'Debuffer'
} as const;

export type RunnerUpEnum = typeof RunnerUpEnum[keyof typeof RunnerUpEnum];


/**
 * Serializer for Scaling DTO.
 * @export
 * @interface Scaling
 */
export interface Scaling {
    /**
     * 
     * @type {string}
     * @memberof Scaling
     */
    'stat': string;
    /**
     * 
     * @type {number}
     * @memberof Scaling
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface ScalingImpact
 */
export interface ScalingImpact {
    /**
     * 
     * @type {string}
     * @memberof ScalingImpact
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof ScalingImpact
     */
    'violation': string;
    /**
     * 
     * @type {number}
     * @memberof ScalingImpact
     */
    'base': number;
    /**
     * 
     * @type {number}
     * @memberof ScalingImpact
     */
    'resolved': number;
    /**
     * 
     * @type {number}
     * @memberof ScalingImpact
     */
    'efficiency': number;
    /**
     * 
     * @type {string}
     * @memberof ScalingImpact
     */
    'capped_by': string | null;
    /**
     * 
     * @type {number}
     * @memberof ScalingImpact
     */
    'expected': number;
}
/**
 * 
 * @export
 * @interface ScalingPoint
 */
export interface ScalingPoint {
    /**
     * 
     * @type {number}
     * @memberof ScalingPoint
     */
    'stat_value': number;
    /**
     * 
     * @type {Array<ScalingImpact>}
     * @memberof ScalingPoint
     */
    'impacts': Array<ScalingImpact>;
    /**
     * 
     * @type {number}
     * @memberof ScalingPoint
     */
    'per_hit': number;
    /**
     * 
     * @type {number}
     * @memberof ScalingPoint
     */
    'per_cell': number;
    /**
     * 
     * @type {number}
     * @memberof ScalingPoint
     */
    'total': number;
}
/**
 * Serializer for scaling values in formulas.
 * @export
 * @interface ScalingRequest
 */
export interface ScalingRequest {
    /**
     * 
     * @type {string}
     * @memberof ScalingRequest
     */
    'stat': string;
    /**
     * 
     * @type {number}
     * @memberof ScalingRequest
     */
    'value': number;
}
/**
 * Everything needed to resolve one stored skill against one body.  Shared by every endpoint that reports on a skill — the workbench, the round simulation and the attribute sweep — so the three cannot disagree about what the caster was. A reading attributed to the wrong body is worse than no reading.
 * @export
 * @interface ScalingRequestRequest
 */
export interface ScalingRequestRequest {
    /**
     * The stored skill to resolve.
     * @type {number}
     * @memberof ScalingRequestRequest
     */
    'skill_id': number;
    /**
     * 
     * @type {WorkbenchCasterRequest}
     * @memberof ScalingRequestRequest
     */
    'caster'?: WorkbenchCasterRequest;
    /**
     * Resolve against an etalon or a real character instead of a typed stat line. Takes precedence over `caster`.
     * @type {SubjectRefRequest}
     * @memberof ScalingRequestRequest
     */
    'subject'?: SubjectRefRequest;
    /**
     * 
     * @type {WorkbenchTargetRequest}
     * @memberof ScalingRequestRequest
     */
    'target'?: WorkbenchTargetRequest;
    /**
     * 
     * @type {WorkbenchSkillOverrideRequest}
     * @memberof ScalingRequestRequest
     */
    'overrides'?: WorkbenchSkillOverrideRequest;
    /**
     * Side of the preview grid. The workbench itself always asks for 20 and pans a 10x10 viewport over it; smaller sizes remain legal for a saved link from before the fixed board existed.
     * @type {number}
     * @memberof ScalingRequestRequest
     */
    'grid_size'?: number;
    /**
     * One aim per charge. Defaults to the caster\'s own cell.
     * @type {Array<WorkbenchAimRequest>}
     * @memberof ScalingRequestRequest
     */
    'aims'?: Array<WorkbenchAimRequest>;
    /**
     * Attributes to sweep. Defaults to the stats the skill\'s own formulas require or scale on — the rest are flat lines.
     * @type {Array<CharacterStatEnum>}
     * @memberof ScalingRequestRequest
     */
    'stats'?: Array<CharacterStatEnum>;
    /**
     * 
     * @type {number}
     * @memberof ScalingRequestRequest
     */
    'start'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScalingRequestRequest
     */
    'stop'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScalingRequestRequest
     */
    'step'?: number;
}
/**
 * 
 * @export
 * @interface ScalingResponse
 */
export interface ScalingResponse {
    /**
     * 
     * @type {WorkbenchSkill}
     * @memberof ScalingResponse
     */
    'skill': WorkbenchSkill;
    /**
     * 
     * @type {SubjectSummary}
     * @memberof ScalingResponse
     */
    'subject': SubjectSummary;
    /**
     * 
     * @type {number}
     * @memberof ScalingResponse
     */
    'start': number;
    /**
     * 
     * @type {number}
     * @memberof ScalingResponse
     */
    'stop': number;
    /**
     * 
     * @type {number}
     * @memberof ScalingResponse
     */
    'step': number;
    /**
     * 
     * @type {Array<ScalingSeries>}
     * @memberof ScalingResponse
     */
    'series': Array<ScalingSeries>;
}
/**
 * 
 * @export
 * @interface ScalingSeries
 */
export interface ScalingSeries {
    /**
     * 
     * @type {string}
     * @memberof ScalingSeries
     */
    'stat': string;
    /**
     * 
     * @type {Array<ScalingPoint>}
     * @memberof ScalingSeries
     */
    'points': Array<ScalingPoint>;
}
/**
 * 
 * @export
 * @interface SchoolSlot
 */
export interface SchoolSlot {
    /**
     * 
     * @type {number}
     * @memberof SchoolSlot
     */
    'grade': number;
    /**
     * 
     * @type {string}
     * @memberof SchoolSlot
     */
    'tier': string;
    /**
     * 
     * @type {string}
     * @memberof SchoolSlot
     */
    'school_id': string;
    /**
     * 
     * @type {string}
     * @memberof SchoolSlot
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SchoolSlot
     */
    'icon': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SchoolSlot
     */
    'paths': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SchoolSlot
     */
    'is_open': boolean;
    /**
     * 
     * @type {number}
     * @memberof SchoolSlot
     */
    'skills_open': number;
    /**
     * 
     * @type {number}
     * @memberof SchoolSlot
     */
    'skills_total': number;
    /**
     * 
     * @type {boolean}
     * @memberof SchoolSlot
     */
    'path_conflict': boolean;
}
/**
 * * `default` - default * `tactical` - tactical * `join_fight` - join_fight * `dice` - dice * `dialogue` - dialogue * `world` - world
 * @export
 * @enum {string}
 */

export const ScreenEnum = {
    Default: 'default',
    Tactical: 'tactical',
    JoinFight: 'join_fight',
    Dice: 'dice',
    Dialogue: 'dialogue',
    World: 'world'
} as const;

export type ScreenEnum = typeof ScreenEnum[keyof typeof ScreenEnum];


/**
 * Event emitted when a character\'s screen mode changes.  Screen modes: - DEFAULT: Normal exploration mode - TACTICAL: Grid-based tactical combat mode - DICE: Dice rolling mode - DIALOGUE: NPC conversation mode - WORLD: World map mode  This event is sent to the character-specific WebSocket channel (world::character::{id}) to update the frontend UI accordingly.
 * @export
 * @interface ScreenModeChangedEvent
 */
export interface ScreenModeChangedEvent {
    /**
     * 
     * @type {string}
     * @memberof ScreenModeChangedEvent
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ScreenModeChangedEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScreenModeChangedEvent
     */
    'id'?: string;
    /**
     * 
     * @type {WsEventCategory}
     * @memberof ScreenModeChangedEvent
     */
    'category'?: WsEventCategory;
    /**
     * 
     * @type {WsScreenModeChangedEventData}
     * @memberof ScreenModeChangedEvent
     */
    'data': WsScreenModeChangedEventData;
}


/**
 * * `error` - error * `warning` - warning * `info` - info
 * @export
 * @enum {string}
 */

export const SeverityEnum = {
    Error: 'error',
    Warning: 'warning',
    Info: 'info'
} as const;

export type SeverityEnum = typeof SeverityEnum[keyof typeof SeverityEnum];


/**
 * 
 * @export
 * @interface Shield
 */
export interface Shield {
    /**
     * 
     * @type {ImpactViolationTypeEnum}
     * @memberof Shield
     */
    'id'?: ImpactViolationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Shield
     */
    'icon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Shield
     */
    'base_efficiency'?: number;
}


/**
 * 
 * @export
 * @interface SimulateRoundEntry
 */
export interface SimulateRoundEntry {
    /**
     * 
     * @type {number}
     * @memberof SimulateRoundEntry
     */
    'round': number;
    /**
     * `fire` or `accumulate`.
     * @type {string}
     * @memberof SimulateRoundEntry
     */
    'action': string;
    /**
     * 
     * @type {number}
     * @memberof SimulateRoundEntry
     */
    'casts': number;
    /**
     * 
     * @type {number}
     * @memberof SimulateRoundEntry
     */
    'action_points_spent': number;
    /**
     * 
     * @type {number}
     * @memberof SimulateRoundEntry
     */
    'energy': number;
    /**
     * 
     * @type {number}
     * @memberof SimulateRoundEntry
     */
    'health': number;
    /**
     * 
     * @type {number}
     * @memberof SimulateRoundEntry
     */
    'impact': number;
    /**
     * 
     * @type {number}
     * @memberof SimulateRoundEntry
     */
    'impact_per_cell': number;
    /**
     * 
     * @type {number}
     * @memberof SimulateRoundEntry
     */
    'cumulative': number;
    /**
     * 
     * @type {number}
     * @memberof SimulateRoundEntry
     */
    'cumulative_per_cell': number;
}
/**
 * 
 * @export
 * @interface SimulateRoundsCost
 */
export interface SimulateRoundsCost {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SimulateRoundsCost
     */
    'cost': { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SimulateRoundsCost
     */
    'pools': { [key: string]: number; };
    /**
     * 
     * @type {boolean}
     * @memberof SimulateRoundsCost
     */
    'action_points_refill_each_round': boolean;
    /**
     * 
     * @type {number}
     * @memberof SimulateRoundsCost
     */
    'energy_per_accumulate_round': number;
    /**
     * 
     * @type {boolean}
     * @memberof SimulateRoundsCost
     */
    'health_regenerates': boolean;
}
/**
 * The same subject the workbench takes, plus the horizon and the sampler.
 * @export
 * @interface SimulateRoundsRequestRequest
 */
export interface SimulateRoundsRequestRequest {
    /**
     * The stored skill to resolve.
     * @type {number}
     * @memberof SimulateRoundsRequestRequest
     */
    'skill_id': number;
    /**
     * 
     * @type {WorkbenchCasterRequest}
     * @memberof SimulateRoundsRequestRequest
     */
    'caster'?: WorkbenchCasterRequest;
    /**
     * Resolve against an etalon or a real character instead of a typed stat line. Takes precedence over `caster`.
     * @type {SubjectRefRequest}
     * @memberof SimulateRoundsRequestRequest
     */
    'subject'?: SubjectRefRequest;
    /**
     * 
     * @type {WorkbenchTargetRequest}
     * @memberof SimulateRoundsRequestRequest
     */
    'target'?: WorkbenchTargetRequest;
    /**
     * 
     * @type {WorkbenchSkillOverrideRequest}
     * @memberof SimulateRoundsRequestRequest
     */
    'overrides'?: WorkbenchSkillOverrideRequest;
    /**
     * Side of the preview grid. The workbench itself always asks for 20 and pans a 10x10 viewport over it; smaller sizes remain legal for a saved link from before the fixed board existed.
     * @type {number}
     * @memberof SimulateRoundsRequestRequest
     */
    'grid_size'?: number;
    /**
     * One aim per charge. Defaults to the caster\'s own cell.
     * @type {Array<WorkbenchAimRequest>}
     * @memberof SimulateRoundsRequestRequest
     */
    'aims'?: Array<WorkbenchAimRequest>;
    /**
     * How many rounds to model. A hundred is the balance question.
     * @type {number}
     * @memberof SimulateRoundsRequestRequest
     */
    'rounds'?: number;
    /**
     * The health a time-to-kill figure is measured against.
     * @type {number}
     * @memberof SimulateRoundsRequestRequest
     */
    'target_health'?: number;
    /**
     * Sampled runs behind the deterministic line. Zero returns the deterministic curve alone.
     * @type {number}
     * @memberof SimulateRoundsRequestRequest
     */
    'monte_carlo_runs'?: number;
    /**
     * Fixes the sampler, so a band is reproducible. Null rolls freely.
     * @type {number}
     * @memberof SimulateRoundsRequestRequest
     */
    'seed'?: number | null;
}
/**
 * 
 * @export
 * @interface SimulateRoundsResponse
 */
export interface SimulateRoundsResponse {
    /**
     * 
     * @type {WorkbenchSkill}
     * @memberof SimulateRoundsResponse
     */
    'skill': WorkbenchSkill;
    /**
     * 
     * @type {SubjectSummary}
     * @memberof SimulateRoundsResponse
     */
    'subject': SubjectSummary;
    /**
     * 
     * @type {number}
     * @memberof SimulateRoundsResponse
     */
    'horizon': number;
    /**
     * 
     * @type {number}
     * @memberof SimulateRoundsResponse
     */
    'target_health': number;
    /**
     * 
     * @type {number}
     * @memberof SimulateRoundsResponse
     */
    'luck_mean': number;
    /**
     * 
     * @type {SimulateRoundsCost}
     * @memberof SimulateRoundsResponse
     */
    'economy': SimulateRoundsCost;
    /**
     * 
     * @type {ImpactPerUse}
     * @memberof SimulateRoundsResponse
     */
    'impact_per_use': ImpactPerUse;
    /**
     * 
     * @type {DeterministicReading}
     * @memberof SimulateRoundsResponse
     */
    'deterministic': DeterministicReading;
    /**
     * 
     * @type {MonteCarloReading}
     * @memberof SimulateRoundsResponse
     */
    'monte_carlo': MonteCarloReading | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimulateRoundsResponse
     */
    'warnings': Array<string>;
}
/**
 * * `standard` - standard * `medium` - medium * `superior` - superior
 * @export
 * @enum {string}
 */

export const Size29fEnum = {
    Standard: 'standard',
    Medium: 'medium',
    Superior: 'superior'
} as const;

export type Size29fEnum = typeof Size29fEnum[keyof typeof Size29fEnum];


/**
 * 
 * @export
 * @interface Skill
 */
export interface Skill {
    /**
     * 
     * @type {number}
     * @memberof Skill
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Skill
     */
    'grade'?: number;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    'description': string;
    /**
     * 
     * @type {SkillTypeEnum}
     * @memberof Skill
     */
    'type'?: SkillTypeEnum;
    /**
     * 
     * @type {UseEnum}
     * @memberof Skill
     */
    'use'?: UseEnum;
    /**
     * A list of Impact objects describing what the skill does.
     * @type {any}
     * @memberof Skill
     */
    'impact'?: any;
    /**
     * A list of Cost objects describing what the skill costs to use.
     * @type {any}
     * @memberof Skill
     */
    'cost'?: any;
    /**
     * A list of AssignableEffect objects the skill can inflict.
     * @type {any}
     * @memberof Skill
     */
    'effect'?: any;
    /**
     * Special type of the skill  * `ACTION` - ACTION * `TELEPORT` - TELEPORT * `TELEPORT_TO_CHARACTER` - TELEPORT_TO_CHARACTER * `TELEPORT_TO_SAFE_ZONE` - TELEPORT_TO_SAFE_ZONE * `RESET_STATS` - RESET_STATS * `FLOW_ACCUMULATION` - FLOW_ACCUMULATION
     * @type {SpecialEnum}
     * @memberof Skill
     */
    'special'?: SpecialEnum;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    'icon'?: string | null;
    /**
     * If true, the skill will be performed immediately
     * @type {boolean}
     * @memberof Skill
     */
    'immediate'?: boolean;
    /**
     * Minimum range in cells from caster to target
     * @type {number}
     * @memberof Skill
     */
    'min_range'?: number;
    /**
     * Maximum range in cells from caster to target
     * @type {number}
     * @memberof Skill
     */
    'max_range'?: number;
    /**
     * Spray pattern configuration: spray (2D matrix), passthrough (bool), shadow (bool), multidimensional (bool), rotatable (bool)
     * @type {any}
     * @memberof Skill
     */
    'spray_config'?: any;
    /**
     * Number of charges (independent spray pattern applications) per use
     * @type {number}
     * @memberof Skill
     */
    'charge_count'?: number;
    /**
     * 
     * @type {any}
     * @memberof Skill
     */
    'allowed_phases'?: any;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    'school'?: string | null;
}


/**
 * Every term that turned magnitude into power, kept separable.
 * @export
 * @interface SkillCoefficients
 */
export interface SkillCoefficients {
    /**
     * 
     * @type {number}
     * @memberof SkillCoefficients
     */
    'magnitude': number;
    /**
     * 
     * @type {number}
     * @memberof SkillCoefficients
     */
    'effect_value': number;
    /**
     * 
     * @type {number}
     * @memberof SkillCoefficients
     */
    'cells': number;
    /**
     * 
     * @type {number}
     * @memberof SkillCoefficients
     */
    'charges': number;
    /**
     * 
     * @type {number}
     * @memberof SkillCoefficients
     */
    'area_factor': number;
    /**
     * 
     * @type {number}
     * @memberof SkillCoefficients
     */
    'charge_factor': number;
    /**
     * 
     * @type {number}
     * @memberof SkillCoefficients
     */
    'effective_targets': number;
    /**
     * 
     * @type {number}
     * @memberof SkillCoefficients
     */
    'approach_ap': number;
    /**
     * 
     * @type {number}
     * @memberof SkillCoefficients
     */
    'effective_ap': number;
}
/**
 * 
 * @export
 * @interface SkillCost
 */
export interface SkillCost {
    /**
     * 
     * @type {number}
     * @memberof SkillCost
     */
    'action_points': number;
    /**
     * 
     * @type {number}
     * @memberof SkillCost
     */
    'energy': number;
    /**
     * 
     * @type {number}
     * @memberof SkillCost
     */
    'health': number;
}
/**
 * Serializer for creating a new skill. This serializer validates the input data for creating a skill with all nested structures.
 * @export
 * @interface SkillCreateRequest
 */
export interface SkillCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof SkillCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SkillCreateRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof SkillCreateRequest
     */
    'school'?: string;
    /**
     * 
     * @type {SkillTypeEnum}
     * @memberof SkillCreateRequest
     */
    'type': SkillTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SkillCreateRequest
     */
    'grade': number;
    /**
     * 
     * @type {Array<CostRequest>}
     * @memberof SkillCreateRequest
     */
    'cost'?: Array<CostRequest>;
    /**
     * 
     * @type {Array<AssignableEffectRequest>}
     * @memberof SkillCreateRequest
     */
    'effect'?: Array<AssignableEffectRequest>;
    /**
     * 
     * @type {Array<ImpactRequest>}
     * @memberof SkillCreateRequest
     */
    'impact'?: Array<ImpactRequest>;
    /**
     * 
     * @type {Array<AllowedPhasesEnum>}
     * @memberof SkillCreateRequest
     */
    'allowed_phases'?: Array<AllowedPhasesEnum>;
}


/**
 * Basic skill information for progression response.
 * @export
 * @interface SkillInfo
 */
export interface SkillInfo {
    /**
     * 
     * @type {number}
     * @memberof SkillInfo
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SkillInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SkillInfo
     */
    'school_name': string;
    /**
     * 
     * @type {string}
     * @memberof SkillInfo
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof SkillInfo
     */
    'grade': number;
}
/**
 * 
 * @export
 * @interface SkillRating
 */
export interface SkillRating {
    /**
     * 
     * @type {number}
     * @memberof SkillRating
     */
    'skill_id': number;
    /**
     * 
     * @type {string}
     * @memberof SkillRating
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SkillRating
     */
    'school': string | null;
    /**
     * 
     * @type {string}
     * @memberof SkillRating
     */
    'path': string | null;
    /**
     * 
     * @type {SkillTypeEnum}
     * @memberof SkillRating
     */
    'skill_type': SkillTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SkillRating
     */
    'grade': number;
    /**
     * 
     * @type {string}
     * @memberof SkillRating
     */
    'icon': string | null;
    /**
     * 
     * @type {string}
     * @memberof SkillRating
     */
    'description': string;
    /**
     * 
     * @type {ImpactViolationTypeEnum}
     * @memberof SkillRating
     */
    'violation': ImpactViolationTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SkillRating
     */
    'domain': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SkillRating
     */
    'is_beneficial': boolean;
    /**
     * 
     * @type {number}
     * @memberof SkillRating
     */
    'min_range': number;
    /**
     * 
     * @type {number}
     * @memberof SkillRating
     */
    'max_range': number;
    /**
     * 
     * @type {SkillCost}
     * @memberof SkillRating
     */
    'cost': SkillCost;
    /**
     * 
     * @type {SkillCoefficients}
     * @memberof SkillRating
     */
    'coefficients': SkillCoefficients;
    /**
     * 
     * @type {number}
     * @memberof SkillRating
     */
    'power': number;
    /**
     * 
     * @type {number}
     * @memberof SkillRating
     */
    'power_single_target': number;
    /**
     * 
     * @type {number}
     * @memberof SkillRating
     */
    'power_per_ap': number;
    /**
     * 
     * @type {number}
     * @memberof SkillRating
     */
    'power_per_energy': number;
    /**
     * 
     * @type {number}
     * @memberof SkillRating
     */
    'casts_per_turn': number;
    /**
     * 
     * @type {number}
     * @memberof SkillRating
     */
    'power_per_turn': number;
    /**
     * 
     * @type {number}
     * @memberof SkillRating
     */
    'sustain_turns': number | null;
    /**
     * 
     * @type {CurveCheck}
     * @memberof SkillRating
     */
    'curve': CurveCheck | null;
}


/**
 * 
 * @export
 * @interface SkillRequest
 */
export interface SkillRequest {
    /**
     * 
     * @type {string}
     * @memberof SkillRequest
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SkillRequest
     */
    'grade'?: number;
    /**
     * 
     * @type {string}
     * @memberof SkillRequest
     */
    'description': string;
    /**
     * 
     * @type {SkillTypeEnum}
     * @memberof SkillRequest
     */
    'type'?: SkillTypeEnum;
    /**
     * 
     * @type {UseEnum}
     * @memberof SkillRequest
     */
    'use'?: UseEnum;
    /**
     * A list of Impact objects describing what the skill does.
     * @type {any}
     * @memberof SkillRequest
     */
    'impact'?: any;
    /**
     * A list of Cost objects describing what the skill costs to use.
     * @type {any}
     * @memberof SkillRequest
     */
    'cost'?: any;
    /**
     * A list of AssignableEffect objects the skill can inflict.
     * @type {any}
     * @memberof SkillRequest
     */
    'effect'?: any;
    /**
     * Special type of the skill  * `ACTION` - ACTION * `TELEPORT` - TELEPORT * `TELEPORT_TO_CHARACTER` - TELEPORT_TO_CHARACTER * `TELEPORT_TO_SAFE_ZONE` - TELEPORT_TO_SAFE_ZONE * `RESET_STATS` - RESET_STATS * `FLOW_ACCUMULATION` - FLOW_ACCUMULATION
     * @type {SpecialEnum}
     * @memberof SkillRequest
     */
    'special'?: SpecialEnum;
    /**
     * 
     * @type {File}
     * @memberof SkillRequest
     */
    'icon'?: File | null;
    /**
     * If true, the skill will be performed immediately
     * @type {boolean}
     * @memberof SkillRequest
     */
    'immediate'?: boolean;
    /**
     * Minimum range in cells from caster to target
     * @type {number}
     * @memberof SkillRequest
     */
    'min_range'?: number;
    /**
     * Maximum range in cells from caster to target
     * @type {number}
     * @memberof SkillRequest
     */
    'max_range'?: number;
    /**
     * Spray pattern configuration: spray (2D matrix), passthrough (bool), shadow (bool), multidimensional (bool), rotatable (bool)
     * @type {any}
     * @memberof SkillRequest
     */
    'spray_config'?: any;
    /**
     * Number of charges (independent spray pattern applications) per use
     * @type {number}
     * @memberof SkillRequest
     */
    'charge_count'?: number;
    /**
     * 
     * @type {any}
     * @memberof SkillRequest
     */
    'allowed_phases'?: any;
    /**
     * 
     * @type {string}
     * @memberof SkillRequest
     */
    'school'?: string | null;
}


/**
 * * `attack` - attack * `defense` - defense * `heal` - heal * `buff` - buff * `debuff` - debuff * `utility` - utility * `special` - special * `summon` - summon
 * @export
 * @enum {string}
 */

export const SkillTypeEnum = {
    Attack: 'attack',
    Defense: 'defense',
    Heal: 'heal',
    Buff: 'buff',
    Debuff: 'debuff',
    Utility: 'utility',
    Special: 'special',
    Summon: 'summon'
} as const;

export type SkillTypeEnum = typeof SkillTypeEnum[keyof typeof SkillTypeEnum];


/**
 * Serializer for spawning an item in the game world. Accepts either a character ID or a position ID, or both.
 * @export
 * @interface SpawnItemRequest
 */
export interface SpawnItemRequest {
    /**
     * UUID of the character to assign the item to. If provided, the item will be added to the character\'s inventory.
     * @type {string}
     * @memberof SpawnItemRequest
     */
    'to_character_id'?: string | null;
    /**
     * UUID of the position to place the item at. If provided without to_character_id, the item will be placed at this position.
     * @type {string}
     * @memberof SpawnItemRequest
     */
    'to_position_id'?: string | null;
    /**
     * Grid X of the cell to drop the item on. Requires tactical_y and a position that has a tactical map; the item then lies on the floor and can be picked up.
     * @type {number}
     * @memberof SpawnItemRequest
     */
    'tactical_x'?: number | null;
    /**
     * Grid Y of the cell to drop the item on. Requires tactical_x.
     * @type {number}
     * @memberof SpawnItemRequest
     */
    'tactical_y'?: number | null;
}
/**
 * 
 * @export
 * @interface SpawnedEntity
 */
export interface SpawnedEntity {
    /**
     * 
     * @type {string}
     * @memberof SpawnedEntity
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SpawnedEntity
     */
    'game_object': string;
}
/**
 * Schema for spawned game objects on the tactical map.  Each object includes its Django polymorphic type attribute, allowing clients to differentiate between different GameObject types (Character, NPC, etc.).
 * @export
 * @interface SpawnedObject
 */
export interface SpawnedObject {
    /**
     * Unique identifier of the game object
     * @type {string}
     * @memberof SpawnedObject
     */
    'id': string;
    /**
     * Django polymorphic type from ContentType model (e.g., \'character\', \'npc\', \'gameobject\'). Use this to determine how to render/handle the object on the client side.
     * @type {string}
     * @memberof SpawnedObject
     */
    'type': string;
    /**
     * X coordinate of the object\'s north-west cell on the grid
     * @type {number}
     * @memberof SpawnedObject
     */
    'x': number;
    /**
     * Y coordinate of the object\'s north-west cell on the grid
     * @type {number}
     * @memberof SpawnedObject
     */
    'y': number;
    /**
     * Footprint class of the object: \'standard\' 1x1, \'medium\' 2x2, \'superior\' 3x3.  * `standard` - standard * `medium` - medium * `superior` - superior
     * @type {Size29fEnum}
     * @memberof SpawnedObject
     */
    'size': Size29fEnum;
    /**
     * Side of the square block of cells the object holds, derived from size (1, 2 or 3). The block extends east and south from (x, y), so clients should draw the token centred on (x + span/2, y + span/2).
     * @type {number}
     * @memberof SpawnedObject
     */
    'span': number;
    /**
     * Name of the game object
     * @type {string}
     * @memberof SpawnedObject
     */
    'name'?: string | null;
    /**
     * Avatar image URL
     * @type {string}
     * @memberof SpawnedObject
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {RelationEnum}
     * @memberof SpawnedObject
     */
    'relation'?: RelationEnum | null;
    /**
     * Whether this object is a character signed with Flow — a game master\'s instrument. Clients mark such tokens for every player.
     * @type {boolean}
     * @memberof SpawnedObject
     */
    'game_master_mode': boolean;
}


/**
 * Serializer for SpecialAction with properly typed spray_config.
 * @export
 * @interface SpecialAction
 */
export interface SpecialAction {
    /**
     * 
     * @type {SpecialActionActionTypeEnum}
     * @memberof SpecialAction
     */
    'action_type': SpecialActionActionTypeEnum;
    /**
     * True when the action is taken on oneself and needs no target chosen: the client applies it to the caster directly.
     * @type {boolean}
     * @memberof SpecialAction
     */
    'self_target': boolean;
    /**
     * 
     * @type {string}
     * @memberof SpecialAction
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpecialAction
     */
    'description': string;
    /**
     * If true, the action will be performed immediately
     * @type {boolean}
     * @memberof SpecialAction
     */
    'immediate'?: boolean;
    /**
     * If true, the action will spend all remaining action points
     * @type {boolean}
     * @memberof SpecialAction
     */
    'final'?: boolean;
    /**
     * Icon for the special action
     * @type {string}
     * @memberof SpecialAction
     */
    'icon'?: string | null;
    /**
     * 
     * @type {Array<SpecialActionCost>}
     * @memberof SpecialAction
     */
    'cost'?: Array<SpecialActionCost>;
    /**
     * Minimum range in cells from caster to target (0-10)
     * @type {number}
     * @memberof SpecialAction
     */
    'min_range'?: number;
    /**
     * Maximum range in cells from caster to target (0-10)
     * @type {number}
     * @memberof SpecialAction
     */
    'max_range'?: number;
    /**
     * 
     * @type {SprayConfig}
     * @memberof SpecialAction
     */
    'spray_config'?: SprayConfig | null;
    /**
     * Number of charges (independent applications) per use
     * @type {number}
     * @memberof SpecialAction
     */
    'charge_count'?: number;
    /**
     * Cycle phases the action may be taken in. An empty list means any phase. The available list is already filtered by the current phase; this is here so the client can say why.
     * @type {Array<string>}
     * @memberof SpecialAction
     */
    'allowed_phases'?: Array<string>;
}


/**
 * * `INSPECT` - INSPECT * `SNATCH_ITEM` - SNATCH_ITEM * `BARGAIN` - BARGAIN * `OPEN_CHEST` - OPEN_CHEST * `LONG_REST` - LONG_REST * `BACK_TO_SAFE_ZONE` - BACK_TO_SAFE_ZONE * `BREAKTHROUGH` - BREAKTHROUGH
 * @export
 * @enum {string}
 */

export const SpecialActionActionTypeEnum = {
    Inspect: 'INSPECT',
    SnatchItem: 'SNATCH_ITEM',
    Bargain: 'BARGAIN',
    OpenChest: 'OPEN_CHEST',
    LongRest: 'LONG_REST',
    BackToSafeZone: 'BACK_TO_SAFE_ZONE',
    Breakthrough: 'BREAKTHROUGH'
} as const;

export type SpecialActionActionTypeEnum = typeof SpecialActionActionTypeEnum[keyof typeof SpecialActionActionTypeEnum];


/**
 * One entry of ``SpecialAction.cost``, as the ``Cost`` DTO stores it.  Named apart from ``core.serializers.dto.SkillCostSerializer`` deliberately: both would be emitted into the OpenAPI schema as a component called ``SkillCost``, and `apps/gamemaster/api/serializers/balance.py` already owns that name with a completely different shape. Colliding would silently rewrite the balance client.
 * @export
 * @interface SpecialActionCost
 */
export interface SpecialActionCost {
    /**
     * 
     * @type {AttributesEnum}
     * @memberof SpecialActionCost
     */
    'kind': AttributesEnum;
    /**
     * 
     * @type {number}
     * @memberof SpecialActionCost
     */
    'value': number;
}


/**
 * * `ACTION` - ACTION * `TELEPORT` - TELEPORT * `TELEPORT_TO_CHARACTER` - TELEPORT_TO_CHARACTER * `TELEPORT_TO_SAFE_ZONE` - TELEPORT_TO_SAFE_ZONE * `RESET_STATS` - RESET_STATS * `FLOW_ACCUMULATION` - FLOW_ACCUMULATION
 * @export
 * @enum {string}
 */

export const SpecialEnum = {
    Action: 'ACTION',
    Teleport: 'TELEPORT',
    TeleportToCharacter: 'TELEPORT_TO_CHARACTER',
    TeleportToSafeZone: 'TELEPORT_TO_SAFE_ZONE',
    ResetStats: 'RESET_STATS',
    FlowAccumulation: 'FLOW_ACCUMULATION'
} as const;

export type SpecialEnum = typeof SpecialEnum[keyof typeof SpecialEnum];


/**
 * Serializer for spray pattern configuration.
 * @export
 * @interface SprayConfig
 */
export interface SprayConfig {
    /**
     * 2D matrix representing spray pattern: \"0\" = not affected, \"1\" = affected, \"x\" = pivot/target point (affected), \"o\" = pivot/target point (NOT affected - exclusion)
     * @type {Array<Array<string>>}
     * @memberof SprayConfig
     */
    'spray'?: Array<Array<string>> | null;
    /**
     * Whether the spray passes through obstacles
     * @type {boolean}
     * @memberof SprayConfig
     */
    'passthrough'?: boolean;
    /**
     * Whether to show shadow/preview of affected cells
     * @type {boolean}
     * @memberof SprayConfig
     */
    'shadow'?: boolean;
    /**
     * Whether the spray affects multiple dimensions
     * @type {boolean}
     * @memberof SprayConfig
     */
    'multidimensional'?: boolean;
    /**
     * Whether the spray pattern can be rotated
     * @type {boolean}
     * @memberof SprayConfig
     */
    'rotatable'?: boolean;
}
/**
 * Serializer for spray pattern configuration.
 * @export
 * @interface SprayConfigRequest
 */
export interface SprayConfigRequest {
    /**
     * 2D matrix representing spray pattern: \"0\" = not affected, \"1\" = affected, \"x\" = pivot/target point (affected), \"o\" = pivot/target point (NOT affected - exclusion)
     * @type {Array<Array<string>>}
     * @memberof SprayConfigRequest
     */
    'spray'?: Array<Array<string>> | null;
    /**
     * Whether the spray passes through obstacles
     * @type {boolean}
     * @memberof SprayConfigRequest
     */
    'passthrough'?: boolean;
    /**
     * Whether to show shadow/preview of affected cells
     * @type {boolean}
     * @memberof SprayConfigRequest
     */
    'shadow'?: boolean;
    /**
     * Whether the spray affects multiple dimensions
     * @type {boolean}
     * @memberof SprayConfigRequest
     */
    'multidimensional'?: boolean;
    /**
     * Whether the spray pattern can be rotated
     * @type {boolean}
     * @memberof SprayConfigRequest
     */
    'rotatable'?: boolean;
}
/**
 * 
 * @export
 * @interface Stat
 */
export interface Stat {
    /**
     * 
     * @type {string}
     * @memberof Stat
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Stat
     */
    'value': number;
}
/**
 * Serializer for custom stat input values.  Used to provide arbitrary stat values for impact simulation without requiring an actual character instance.
 * @export
 * @interface StatInputRequest
 */
export interface StatInputRequest {
    /**
     * The stat name (e.g., \'Physical Strength\', \'Flow Manipulation\')  * `Physical Strength` - Physical Strength * `Mental Strength` - Mental Strength * `Flow Resonance` - Flow Resonance * `Concentration` - Concentration * `Flow Manipulation` - Flow Manipulation * `Flow Connection` - Flow Connection * `Knowledge` - Knowledge * `Speed` - Speed * `Luck` - Luck * `Charisma` - Charisma
     * @type {CharacterStatEnum}
     * @memberof StatInputRequest
     */
    'name': CharacterStatEnum;
    /**
     * The stat value to use in calculations
     * @type {number}
     * @memberof StatInputRequest
     */
    'value': number;
}


/**
 * 
 * @export
 * @interface StatModificator
 */
export interface StatModificator {
    /**
     * 
     * @type {string}
     * @memberof StatModificator
     */
    'id': string;
    /**
     * 
     * @type {CharacterStatEnum}
     * @memberof StatModificator
     */
    'stat'?: CharacterStatEnum;
    /**
     * 
     * @type {number}
     * @memberof StatModificator
     */
    'value'?: number;
}


/**
 * 
 * @export
 * @interface StatModificatorRequest
 */
export interface StatModificatorRequest {
    /**
     * 
     * @type {CharacterStatEnum}
     * @memberof StatModificatorRequest
     */
    'stat'?: CharacterStatEnum;
    /**
     * 
     * @type {number}
     * @memberof StatModificatorRequest
     */
    'value'?: number;
}


/**
 * 
 * @export
 * @interface StatObject
 */
export interface StatObject {
    /**
     * 
     * @type {CharacterStatEnum}
     * @memberof StatObject
     */
    'id': CharacterStatEnum;
    /**
     * 
     * @type {string}
     * @memberof StatObject
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StatObject
     */
    'description'?: string | null;
}


/**
 * Serializer for StatRequirement DTO.
 * @export
 * @interface StatRequirement
 */
export interface StatRequirement {
    /**
     * 
     * @type {CharacterStatEnum}
     * @memberof StatRequirement
     */
    'stat': CharacterStatEnum;
    /**
     * 
     * @type {number}
     * @memberof StatRequirement
     */
    'value': number;
}


/**
 * Serializer for stat requirements in formulas.
 * @export
 * @interface StatRequirementRequest
 */
export interface StatRequirementRequest {
    /**
     * 
     * @type {CharacterStatEnum}
     * @memberof StatRequirementRequest
     */
    'stat': CharacterStatEnum;
    /**
     * 
     * @type {number}
     * @memberof StatRequirementRequest
     */
    'value': number;
}


/**
 * * `exploring` - exploring * `in_event` - in_event * `offline` - offline
 * @export
 * @enum {string}
 */

export const State57dEnum = {
    Exploring: 'exploring',
    InEvent: 'in_event',
    Offline: 'offline'
} as const;

export type State57dEnum = typeof State57dEnum[keyof typeof State57dEnum];


/**
 * * `open` - Open * `consumed` - Consumed * `cancelled` - Cancelled
 * @export
 * @enum {string}
 */

export const StateF1eEnum = {
    Open: 'open',
    Consumed: 'consumed',
    Cancelled: 'cancelled'
} as const;

export type StateF1eEnum = typeof StateF1eEnum[keyof typeof StateF1eEnum];


/**
 * * `` -  * `fight` - fight * `quest` - quest
 * @export
 * @enum {string}
 */

export const StateReasonEnum = {
    Fight: 'fight',
    Quest: 'quest'
} as const;

export type StateReasonEnum = typeof StateReasonEnum[keyof typeof StateReasonEnum];


/**
 * Serializer for the stop_all_fights action. Optionally accepts filters and a reason for stopping fights.
 * @export
 * @interface StopAllFights
 */
export interface StopAllFights {
    /**
     * Only stop fights at this position
     * @type {number}
     * @memberof StopAllFights
     */
    'position_id'?: number;
    /**
     * Only stop fights involving this character
     * @type {number}
     * @memberof StopAllFights
     */
    'character_id'?: number;
    /**
     * Reason for stopping the fights
     * @type {string}
     * @memberof StopAllFights
     */
    'reason'?: string;
}
/**
 * Serializer for the stop_all_fights action. Optionally accepts filters and a reason for stopping fights.
 * @export
 * @interface StopAllFightsRequest
 */
export interface StopAllFightsRequest {
    /**
     * Only stop fights at this position
     * @type {number}
     * @memberof StopAllFightsRequest
     */
    'position_id'?: number;
    /**
     * Only stop fights involving this character
     * @type {number}
     * @memberof StopAllFightsRequest
     */
    'character_id'?: number;
    /**
     * Reason for stopping the fights
     * @type {string}
     * @memberof StopAllFightsRequest
     */
    'reason'?: string;
}
/**
 * Response serializer for the stop_all_fights action.
 * @export
 * @interface StopAllFightsResponse
 */
export interface StopAllFightsResponse {
    /**
     * Whether the operation was successful
     * @type {boolean}
     * @memberof StopAllFightsResponse
     */
    'success': boolean;
    /**
     * Status message
     * @type {string}
     * @memberof StopAllFightsResponse
     */
    'message': string;
    /**
     * Total number of active fights found
     * @type {number}
     * @memberof StopAllFightsResponse
     */
    'total_fights': number;
    /**
     * Number of fights successfully stopped
     * @type {number}
     * @memberof StopAllFightsResponse
     */
    'stopped_count': number;
    /**
     * Number of fights that failed to stop
     * @type {number}
     * @memberof StopAllFightsResponse
     */
    'failed_count': number;
    /**
     * List of fight IDs that were stopped
     * @type {Array<number>}
     * @memberof StopAllFightsResponse
     */
    'stopped_fight_ids': Array<number>;
}
/**
 * Serializer for the stop_fight action. Optionally accepts a reason for stopping the fight.
 * @export
 * @interface StopFightRequest
 */
export interface StopFightRequest {
    /**
     * Reason for stopping the fight
     * @type {string}
     * @memberof StopFightRequest
     */
    'reason'?: string;
}
/**
 * Response serializer for the stop_fight action.
 * @export
 * @interface StopFightResponse
 */
export interface StopFightResponse {
    /**
     * Whether the fight was successfully stopped
     * @type {boolean}
     * @memberof StopFightResponse
     */
    'success': boolean;
    /**
     * Status message
     * @type {string}
     * @memberof StopFightResponse
     */
    'message': string;
    /**
     * ID of the stopped fight
     * @type {number}
     * @memberof StopFightResponse
     */
    'fight_id': number;
}
/**
 * Serializer for Story model.
 * @export
 * @interface Story
 */
export interface Story {
    /**
     * 
     * @type {string}
     * @memberof Story
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Story
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Story
     */
    'description': string;
    /**
     * List of tags for the story
     * @type {any}
     * @memberof Story
     */
    'tags'?: any;
    /**
     * Optional URL to an image representing the story
     * @type {string}
     * @memberof Story
     */
    'image'?: string | null;
    /**
     * Default to false, need review by the Owner
     * @type {boolean}
     * @memberof Story
     */
    'canonical'?: boolean;
    /**
     * 
     * @type {Array<Chapter>}
     * @memberof Story
     */
    'chapters': Array<Chapter>;
}
/**
 * Detailed serializer for Story model with nested chapters and quests.
 * @export
 * @interface StoryDetail
 */
export interface StoryDetail {
    /**
     * 
     * @type {string}
     * @memberof StoryDetail
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StoryDetail
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof StoryDetail
     */
    'description': string;
    /**
     * List of tags for the story
     * @type {any}
     * @memberof StoryDetail
     */
    'tags'?: any;
    /**
     * Optional URL to an image representing the story
     * @type {string}
     * @memberof StoryDetail
     */
    'image'?: string | null;
    /**
     * Default to false, need review by the Owner
     * @type {boolean}
     * @memberof StoryDetail
     */
    'canonical'?: boolean;
    /**
     * 
     * @type {Array<Chapter>}
     * @memberof StoryDetail
     */
    'chapters': Array<Chapter>;
}
/**
 * Serializer for Story model.
 * @export
 * @interface StoryRequest
 */
export interface StoryRequest {
    /**
     * 
     * @type {string}
     * @memberof StoryRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof StoryRequest
     */
    'description': string;
    /**
     * List of tags for the story
     * @type {any}
     * @memberof StoryRequest
     */
    'tags'?: any;
    /**
     * Optional URL to an image representing the story
     * @type {File}
     * @memberof StoryRequest
     */
    'image'?: File | null;
    /**
     * Default to false, need review by the Owner
     * @type {boolean}
     * @memberof StoryRequest
     */
    'canonical'?: boolean;
}
/**
 * 
 * @export
 * @interface SubLocation
 */
export interface SubLocation {
    /**
     * 
     * @type {string}
     * @memberof SubLocation
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SubLocation
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubLocation
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof SubLocation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SubLocation
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof SubLocation
     */
    'image'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubLocation
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubLocation
     */
    'map_x'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubLocation
     */
    'map_y'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubLocation
     */
    'location': string;
    /**
     * Default battle map template for fights in this sublocation
     * @type {string}
     * @memberof SubLocation
     */
    'battle_map_template'?: string | null;
}
/**
 * A subject with what it has been taught.
 * @export
 * @interface SubjectDetail
 */
export interface SubjectDetail {
    /**
     * 
     * @type {string}
     * @memberof SubjectDetail
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof SubjectDetail
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectDetail
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SubjectDetail
     */
    'path': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectDetail
     */
    'is_etalon': boolean;
    /**
     * 
     * @type {string}
     * @memberof SubjectDetail
     */
    'campaign_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectDetail
     */
    'campaign_name': string | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectDetail
     */
    'rank_grade': number | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SubjectDetail
     */
    'stats': { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SubjectDetail
     */
    'pools': { [key: string]: number; };
    /**
     * 
     * @type {Array<string>}
     * @memberof SubjectDetail
     */
    'warnings': Array<string>;
    /**
     * 
     * @type {Array<SubjectSchool>}
     * @memberof SubjectDetail
     */
    'schools': Array<SubjectSchool>;
    /**
     * 
     * @type {Array<SubjectSkill>}
     * @memberof SubjectDetail
     */
    'skills': Array<SubjectSkill>;
}
/**
 * * `etalon` - etalon * `character` - character * `statline` - statline
 * @export
 * @enum {string}
 */

export const SubjectRefKindEnum = {
    Etalon: 'etalon',
    Character: 'character',
    Statline: 'statline'
} as const;

export type SubjectRefKindEnum = typeof SubjectRefKindEnum[keyof typeof SubjectRefKindEnum];


/**
 * How a request names its subject.
 * @export
 * @interface SubjectRefRequest
 */
export interface SubjectRefRequest {
    /**
     * `etalon` and `character` address a row; `statline` carries its own numbers.  * `etalon` - etalon * `character` - character * `statline` - statline
     * @type {SubjectRefKindEnum}
     * @memberof SubjectRefRequest
     */
    'kind'?: SubjectRefKindEnum;
    /**
     * The character\'s id, or an etalon\'s id or name. Defaults to the Path of John etalon when `kind` is `etalon`.
     * @type {string}
     * @memberof SubjectRefRequest
     */
    'id'?: string | null;
    /**
     * `statline` only: stat name to value.
     * @type {{ [key: string]: number; }}
     * @memberof SubjectRefRequest
     */
    'stats'?: { [key: string]: number; };
    /**
     * `statline` only.
     * @type {string}
     * @memberof SubjectRefRequest
     */
    'path'?: string | null;
    /**
     * `statline` only.
     * @type {number}
     * @memberof SubjectRefRequest
     */
    'health_override'?: number | null;
    /**
     * `statline` only.
     * @type {number}
     * @memberof SubjectRefRequest
     */
    'dimension_speed'?: number;
}


/**
 * 
 * @export
 * @interface SubjectRoster
 */
export interface SubjectRoster {
    /**
     * 
     * @type {string}
     * @memberof SubjectRoster
     */
    'default_subject_id': string | null;
    /**
     * 
     * @type {Array<SubjectSummary>}
     * @memberof SubjectRoster
     */
    'etalons': Array<SubjectSummary>;
    /**
     * 
     * @type {Array<SubjectSummary>}
     * @memberof SubjectRoster
     */
    'characters': Array<SubjectSummary>;
}
/**
 * 
 * @export
 * @interface SubjectSchool
 */
export interface SubjectSchool {
    /**
     * 
     * @type {string}
     * @memberof SubjectSchool
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SubjectSchool
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectSchool
     */
    'is_base': boolean;
}
/**
 * 
 * @export
 * @interface SubjectSchoolMutationRequest
 */
export interface SubjectSchoolMutationRequest {
    /**
     * The school to add or remove.
     * @type {string}
     * @memberof SubjectSchoolMutationRequest
     */
    'school_id': string;
}
/**
 * 
 * @export
 * @interface SubjectSkill
 */
export interface SubjectSkill {
    /**
     * 
     * @type {number}
     * @memberof SubjectSkill
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SubjectSkill
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SubjectSkill
     */
    'grade': number;
    /**
     * 
     * @type {string}
     * @memberof SubjectSkill
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof SubjectSkill
     */
    'school': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectSkill
     */
    'is_base': boolean;
}
/**
 * 
 * @export
 * @interface SubjectSkillMutationRequest
 */
export interface SubjectSkillMutationRequest {
    /**
     * The skill to add or remove.
     * @type {number}
     * @memberof SubjectSkillMutationRequest
     */
    'skill_id': number;
}
/**
 * What a subject is, as every endpoint reports it.
 * @export
 * @interface SubjectSummary
 */
export interface SubjectSummary {
    /**
     * 
     * @type {string}
     * @memberof SubjectSummary
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof SubjectSummary
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectSummary
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SubjectSummary
     */
    'path': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectSummary
     */
    'is_etalon': boolean;
    /**
     * 
     * @type {string}
     * @memberof SubjectSummary
     */
    'campaign_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectSummary
     */
    'campaign_name': string | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectSummary
     */
    'rank_grade': number | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SubjectSummary
     */
    'stats': { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SubjectSummary
     */
    'pools': { [key: string]: number; };
    /**
     * 
     * @type {Array<string>}
     * @memberof SubjectSummary
     */
    'warnings': Array<string>;
}
/**
 * 
 * @export
 * @interface SubscribeRequest
 */
export interface SubscribeRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscribeRequest
     */
    'channel': string;
}
/**
 * 
 * @export
 * @interface SwipeBaseStatRequest
 */
export interface SwipeBaseStatRequest {
    /**
     * The first result of the base stat generation.
     * @type {string}
     * @memberof SwipeBaseStatRequest
     */
    'from_stat': string;
    /**
     * The second result of the base stat generation.
     * @type {string}
     * @memberof SwipeBaseStatRequest
     */
    'to_stat': string;
}
/**
 * 
 * @export
 * @interface SynergyTag
 */
export interface SynergyTag {
    /**
     * 
     * @type {string}
     * @memberof SynergyTag
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SynergyTag
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SynergyTag
     */
    'description'?: string;
    /**
     * Hex color for UI display
     * @type {string}
     * @memberof SynergyTag
     */
    'color_hex'?: string;
}
/**
 * 
 * @export
 * @interface SynergyTagRequest
 */
export interface SynergyTagRequest {
    /**
     * 
     * @type {string}
     * @memberof SynergyTagRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SynergyTagRequest
     */
    'description'?: string;
    /**
     * Hex color for UI display
     * @type {string}
     * @memberof SynergyTagRequest
     */
    'color_hex'?: string;
}
/**
 * Serializer for TacticalCharacterInfo Pydantic model.  Provides tactical combat information for a character including movement capabilities, vision range, and current position.
 * @export
 * @interface TacticalCharacterInfo
 */
export interface TacticalCharacterInfo {
    /**
     * Unique identifier of the character
     * @type {string}
     * @memberof TacticalCharacterInfo
     */
    'character_id': string;
    /**
     * Maximum movement range in grid cells (calculated from max AP)
     * @type {number}
     * @memberof TacticalCharacterInfo
     */
    'movement_range': number;
    /**
     * Remaining movement range in grid cells (calculated from current AP)
     * @type {number}
     * @memberof TacticalCharacterInfo
     */
    'movement_remaining': number;
    /**
     * Vision range in grid cells for fog of war calculations
     * @type {number}
     * @memberof TacticalCharacterInfo
     */
    'vision_range': number;
    /**
     * Whether the character is blind. Blind characters see nothing but still move and attack normally.
     * @type {boolean}
     * @memberof TacticalCharacterInfo
     */
    'blinded': boolean;
    /**
     * Whether the character is signed with Flow. A signed character moves without cost or route, so the movement fields above do not bound it.
     * @type {boolean}
     * @memberof TacticalCharacterInfo
     */
    'game_master_mode': boolean;
    /**
     * Current X coordinate of the character\'s north-west cell
     * @type {number}
     * @memberof TacticalCharacterInfo
     */
    'x': number;
    /**
     * Current Y coordinate of the character\'s north-west cell
     * @type {number}
     * @memberof TacticalCharacterInfo
     */
    'y': number;
    /**
     * Footprint class: \'standard\' 1x1, \'medium\' 2x2, \'superior\' 3x3  * `standard` - standard * `medium` - medium * `superior` - superior
     * @type {Size29fEnum}
     * @memberof TacticalCharacterInfo
     */
    'size': Size29fEnum;
    /**
     * Side of the square block of cells the character holds (1, 2 or 3), extending east and south from (x, y)
     * @type {number}
     * @memberof TacticalCharacterInfo
     */
    'span': number;
}


/**
 * 
 * @export
 * @interface TacticalMap
 */
export interface TacticalMap {
    /**
     * 
     * @type {string}
     * @memberof TacticalMap
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TacticalMap
     */
    'position'?: string | null;
    /**
     * Template used for this map. Should be automatically resolved through world hierarchy by TacticalMapFactory service.
     * @type {string}
     * @memberof TacticalMap
     */
    'template'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TacticalMap
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface TacticalMapResult
 */
export interface TacticalMapResult {
    /**
     * 
     * @type {string}
     * @memberof TacticalMapResult
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TacticalMapResult
     */
    'position': string | null;
    /**
     * Template used for this map. Should be automatically resolved through world hierarchy by TacticalMapFactory service.
     * @type {string}
     * @memberof TacticalMapResult
     */
    'template': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TacticalMapResult
     */
    'is_active': boolean;
}
/**
 * Serializer for creating templates via API (without file upload)
 * @export
 * @interface TacticalMapTemplateCreate
 */
export interface TacticalMapTemplateCreate {
    /**
     * 
     * @type {string}
     * @memberof TacticalMapTemplateCreate
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TacticalMapTemplateCreate
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof TacticalMapTemplateCreate
     */
    'updated_at': string;
    /**
     * Name of the tactical map template
     * @type {string}
     * @memberof TacticalMapTemplateCreate
     */
    'name': string;
    /**
     * Description of the map, its purpose, and features
     * @type {string}
     * @memberof TacticalMapTemplateCreate
     */
    'description'?: string;
    /**
     * Map creator/author name
     * @type {string}
     * @memberof TacticalMapTemplateCreate
     */
    'author'?: string;
    /**
     * PNG background image for the tactical map
     * @type {string}
     * @memberof TacticalMapTemplateCreate
     */
    'background_image': string;
    /**
     * Challenge rating / difficulty level  * `easy` - Easy (CR 1-5) * `medium` - Medium (CR 6-10) * `hard` - Hard (CR 11-15) * `deadly` - Deadly (CR 16+) * `custom` - Custom
     * @type {DifficultyRatingEnum}
     * @memberof TacticalMapTemplateCreate
     */
    'difficulty_rating'?: DifficultyRatingEnum;
    /**
     * Map category for organization  * `dungeon` - Dungeon * `wilderness` - Wilderness * `urban` - Urban * `indoor` - Indoor * `arena` - Arena * `ship` - Ship/Vehicle * `planar` - Planar/Dimensional * `custom` - Custom
     * @type {CategoryEnum}
     * @memberof TacticalMapTemplateCreate
     */
    'category'?: CategoryEnum;
    /**
     * List of string tags for filtering/searching
     * @type {any}
     * @memberof TacticalMapTemplateCreate
     */
    'tags'?: any;
    /**
     * Number of grid columns
     * @type {number}
     * @memberof TacticalMapTemplateCreate
     */
    'grid_columns': number;
    /**
     * Number of grid rows
     * @type {number}
     * @memberof TacticalMapTemplateCreate
     */
    'grid_rows': number;
    /**
     * Grid cell width in pixels
     * @type {number}
     * @memberof TacticalMapTemplateCreate
     */
    'cell_width'?: number;
    /**
     * Grid cell height in pixels
     * @type {number}
     * @memberof TacticalMapTemplateCreate
     */
    'cell_height'?: number;
    /**
     * Minimum recommended players
     * @type {number}
     * @memberof TacticalMapTemplateCreate
     */
    'recommended_player_count_min'?: number;
    /**
     * Maximum recommended players
     * @type {number}
     * @memberof TacticalMapTemplateCreate
     */
    'recommended_player_count_max'?: number;
    /**
     * Full map data in frontend format (version 2.0 structure)
     * @type {any}
     * @memberof TacticalMapTemplateCreate
     */
    'map_data': any;
    /**
     * Map data format version
     * @type {string}
     * @memberof TacticalMapTemplateCreate
     */
    'format_version'?: string;
    /**
     * Template version number (incremented on updates)
     * @type {number}
     * @memberof TacticalMapTemplateCreate
     */
    'template_version'?: number;
    /**
     * Official/canonical template (vs user-created)
     * @type {boolean}
     * @memberof TacticalMapTemplateCreate
     */
    'canonical'?: boolean;
    /**
     * Published and available for use
     * @type {boolean}
     * @memberof TacticalMapTemplateCreate
     */
    'published'?: boolean;
}


/**
 * Serializer for creating templates via API (without file upload)
 * @export
 * @interface TacticalMapTemplateCreateRequest
 */
export interface TacticalMapTemplateCreateRequest {
    /**
     * Name of the tactical map template
     * @type {string}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'name': string;
    /**
     * Description of the map, its purpose, and features
     * @type {string}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'description'?: string;
    /**
     * Map creator/author name
     * @type {string}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'author'?: string;
    /**
     * PNG background image for the tactical map
     * @type {File}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'background_image': File;
    /**
     * Challenge rating / difficulty level  * `easy` - Easy (CR 1-5) * `medium` - Medium (CR 6-10) * `hard` - Hard (CR 11-15) * `deadly` - Deadly (CR 16+) * `custom` - Custom
     * @type {DifficultyRatingEnum}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'difficulty_rating'?: DifficultyRatingEnum;
    /**
     * Map category for organization  * `dungeon` - Dungeon * `wilderness` - Wilderness * `urban` - Urban * `indoor` - Indoor * `arena` - Arena * `ship` - Ship/Vehicle * `planar` - Planar/Dimensional * `custom` - Custom
     * @type {CategoryEnum}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'category'?: CategoryEnum;
    /**
     * List of string tags for filtering/searching
     * @type {any}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'tags'?: any;
    /**
     * Number of grid columns
     * @type {number}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'grid_columns': number;
    /**
     * Number of grid rows
     * @type {number}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'grid_rows': number;
    /**
     * Grid cell width in pixels
     * @type {number}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'cell_width'?: number;
    /**
     * Grid cell height in pixels
     * @type {number}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'cell_height'?: number;
    /**
     * Minimum recommended players
     * @type {number}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'recommended_player_count_min'?: number;
    /**
     * Maximum recommended players
     * @type {number}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'recommended_player_count_max'?: number;
    /**
     * Full map data in frontend format (version 2.0 structure)
     * @type {any}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'map_data': any;
    /**
     * Map data format version
     * @type {string}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'format_version'?: string;
    /**
     * Template version number (incremented on updates)
     * @type {number}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'template_version'?: number;
    /**
     * Official/canonical template (vs user-created)
     * @type {boolean}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'canonical'?: boolean;
    /**
     * Published and available for use
     * @type {boolean}
     * @memberof TacticalMapTemplateCreateRequest
     */
    'published'?: boolean;
}


/**
 * Full serializer including map_data
 * @export
 * @interface TacticalMapTemplateDetail
 */
export interface TacticalMapTemplateDetail {
    /**
     * 
     * @type {string}
     * @memberof TacticalMapTemplateDetail
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TacticalMapTemplateDetail
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof TacticalMapTemplateDetail
     */
    'updated_at': string;
    /**
     * Name of the tactical map template
     * @type {string}
     * @memberof TacticalMapTemplateDetail
     */
    'name': string;
    /**
     * Description of the map, its purpose, and features
     * @type {string}
     * @memberof TacticalMapTemplateDetail
     */
    'description'?: string;
    /**
     * Map creator/author name
     * @type {string}
     * @memberof TacticalMapTemplateDetail
     */
    'author'?: string;
    /**
     * PNG background image for the tactical map
     * @type {string}
     * @memberof TacticalMapTemplateDetail
     */
    'background_image': string;
    /**
     * Auto-generated thumbnail preview (200x200px)
     * @type {string}
     * @memberof TacticalMapTemplateDetail
     */
    'thumbnail': string | null;
    /**
     * Challenge rating / difficulty level  * `easy` - Easy (CR 1-5) * `medium` - Medium (CR 6-10) * `hard` - Hard (CR 11-15) * `deadly` - Deadly (CR 16+) * `custom` - Custom
     * @type {DifficultyRatingEnum}
     * @memberof TacticalMapTemplateDetail
     */
    'difficulty_rating'?: DifficultyRatingEnum;
    /**
     * Map category for organization  * `dungeon` - Dungeon * `wilderness` - Wilderness * `urban` - Urban * `indoor` - Indoor * `arena` - Arena * `ship` - Ship/Vehicle * `planar` - Planar/Dimensional * `custom` - Custom
     * @type {CategoryEnum}
     * @memberof TacticalMapTemplateDetail
     */
    'category'?: CategoryEnum;
    /**
     * List of string tags for filtering/searching
     * @type {any}
     * @memberof TacticalMapTemplateDetail
     */
    'tags'?: any;
    /**
     * Number of grid columns
     * @type {number}
     * @memberof TacticalMapTemplateDetail
     */
    'grid_columns': number;
    /**
     * Number of grid rows
     * @type {number}
     * @memberof TacticalMapTemplateDetail
     */
    'grid_rows': number;
    /**
     * Grid cell width in pixels
     * @type {number}
     * @memberof TacticalMapTemplateDetail
     */
    'cell_width'?: number;
    /**
     * Grid cell height in pixels
     * @type {number}
     * @memberof TacticalMapTemplateDetail
     */
    'cell_height'?: number;
    /**
     * Minimum recommended players
     * @type {number}
     * @memberof TacticalMapTemplateDetail
     */
    'recommended_player_count_min'?: number;
    /**
     * Maximum recommended players
     * @type {number}
     * @memberof TacticalMapTemplateDetail
     */
    'recommended_player_count_max'?: number;
    /**
     * Full map data in frontend format (version 2.0 structure)
     * @type {any}
     * @memberof TacticalMapTemplateDetail
     */
    'map_data': any;
    /**
     * Map data format version
     * @type {string}
     * @memberof TacticalMapTemplateDetail
     */
    'format_version'?: string;
    /**
     * Template version number (incremented on updates)
     * @type {number}
     * @memberof TacticalMapTemplateDetail
     */
    'template_version'?: number;
    /**
     * Official/canonical template (vs user-created)
     * @type {boolean}
     * @memberof TacticalMapTemplateDetail
     */
    'canonical'?: boolean;
    /**
     * Published and available for use
     * @type {boolean}
     * @memberof TacticalMapTemplateDetail
     */
    'published'?: boolean;
}


/**
 * Lightweight serializer for list views
 * @export
 * @interface TacticalMapTemplateList
 */
export interface TacticalMapTemplateList {
    /**
     * 
     * @type {string}
     * @memberof TacticalMapTemplateList
     */
    'id': string;
    /**
     * Name of the tactical map template
     * @type {string}
     * @memberof TacticalMapTemplateList
     */
    'name': string;
    /**
     * Description of the map, its purpose, and features
     * @type {string}
     * @memberof TacticalMapTemplateList
     */
    'description'?: string;
    /**
     * Map creator/author name
     * @type {string}
     * @memberof TacticalMapTemplateList
     */
    'author'?: string;
    /**
     * Auto-generated thumbnail preview (200x200px)
     * @type {string}
     * @memberof TacticalMapTemplateList
     */
    'thumbnail'?: string | null;
    /**
     * Challenge rating / difficulty level  * `easy` - Easy (CR 1-5) * `medium` - Medium (CR 6-10) * `hard` - Hard (CR 11-15) * `deadly` - Deadly (CR 16+) * `custom` - Custom
     * @type {DifficultyRatingEnum}
     * @memberof TacticalMapTemplateList
     */
    'difficulty_rating'?: DifficultyRatingEnum;
    /**
     * Map category for organization  * `dungeon` - Dungeon * `wilderness` - Wilderness * `urban` - Urban * `indoor` - Indoor * `arena` - Arena * `ship` - Ship/Vehicle * `planar` - Planar/Dimensional * `custom` - Custom
     * @type {CategoryEnum}
     * @memberof TacticalMapTemplateList
     */
    'category'?: CategoryEnum;
    /**
     * List of string tags for filtering/searching
     * @type {any}
     * @memberof TacticalMapTemplateList
     */
    'tags'?: any;
    /**
     * Number of grid columns
     * @type {number}
     * @memberof TacticalMapTemplateList
     */
    'grid_columns': number;
    /**
     * Number of grid rows
     * @type {number}
     * @memberof TacticalMapTemplateList
     */
    'grid_rows': number;
    /**
     * Minimum recommended players
     * @type {number}
     * @memberof TacticalMapTemplateList
     */
    'recommended_player_count_min'?: number;
    /**
     * Maximum recommended players
     * @type {number}
     * @memberof TacticalMapTemplateList
     */
    'recommended_player_count_max'?: number;
    /**
     * Map data format version
     * @type {string}
     * @memberof TacticalMapTemplateList
     */
    'format_version'?: string;
    /**
     * Template version number (incremented on updates)
     * @type {number}
     * @memberof TacticalMapTemplateList
     */
    'template_version'?: number;
    /**
     * Published and available for use
     * @type {boolean}
     * @memberof TacticalMapTemplateList
     */
    'published'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TacticalMapTemplateList
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof TacticalMapTemplateList
     */
    'updated_at': string;
}


/**
 * 
 * @export
 * @interface TacticalPosition
 */
export interface TacticalPosition {
    /**
     * 
     * @type {string}
     * @memberof TacticalPosition
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TacticalPosition
     */
    'position': string;
    /**
     * 
     * @type {number}
     * @memberof TacticalPosition
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof TacticalPosition
     */
    'y': number;
}
/**
 * 
 * @export
 * @interface TacticalPositionRequest
 */
export interface TacticalPositionRequest {
    /**
     * 
     * @type {number}
     * @memberof TacticalPositionRequest
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof TacticalPositionRequest
     */
    'y': number;
}
/**
 * 
 * @export
 * @interface TacticalScene3D
 */
export interface TacticalScene3D {
    /**
     * 
     * @type {string}
     * @memberof TacticalScene3D
     */
    'template_id': string;
    /**
     * 
     * @type {number}
     * @memberof TacticalScene3D
     */
    'template_version': number;
    /**
     * 
     * @type {string}
     * @memberof TacticalScene3D
     */
    'format_version': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TacticalScene3D
     */
    'grid': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TacticalScene3D
     */
    'scene': { [key: string]: any; };
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof TacticalScene3D
     */
    'props': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof TacticalScene3D
     */
    'lights': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof TacticalScene3D
     */
    'effect_regions': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof TacticalScene3D
     */
    'blocks': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof TacticalScene3D
     */
    'wall_overrides': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {TacticalSceneCells}
     * @memberof TacticalScene3D
     */
    'cells': TacticalSceneCells;
}
/**
 * 
 * @export
 * @interface TacticalSceneCells
 */
export interface TacticalSceneCells {
    /**
     * 
     * @type {Array<number>}
     * @memberof TacticalSceneCells
     */
    'x': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof TacticalSceneCells
     */
    'y': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof TacticalSceneCells
     */
    'elevation': Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TacticalSceneCells
     */
    'material': Array<string>;
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof TacticalSceneCells
     */
    'overlays': Array<Array<string>>;
}
/**
 * * `standard` - standard * `medium` - medium * `superior` - superior
 * @export
 * @enum {string}
 */

export const TacticalSizeEnum = {
    Standard: 'standard',
    Medium: 'medium',
    Superior: 'superior'
} as const;

export type TacticalSizeEnum = typeof TacticalSizeEnum[keyof typeof TacticalSizeEnum];


/**
 * 
 * @export
 * @interface TakeChestItemRequest
 */
export interface TakeChestItemRequest {
    /**
     * The WorldItem to move from the chest into the character\'s inventory
     * @type {string}
     * @memberof TakeChestItemRequest
     */
    'world_item_id': string;
}
/**
 * References an existing position by coordinates only.
 * @export
 * @interface TeleportCoordinates
 */
export interface TeleportCoordinates {
    /**
     * 
     * @type {number}
     * @memberof TeleportCoordinates
     */
    'grid_x': number;
    /**
     * 
     * @type {number}
     * @memberof TeleportCoordinates
     */
    'grid_y': number;
    /**
     * 
     * @type {number}
     * @memberof TeleportCoordinates
     */
    'grid_z': number;
}
/**
 * References an existing position by coordinates only.
 * @export
 * @interface TeleportCoordinatesRequest
 */
export interface TeleportCoordinatesRequest {
    /**
     * 
     * @type {number}
     * @memberof TeleportCoordinatesRequest
     */
    'grid_x': number;
    /**
     * 
     * @type {number}
     * @memberof TeleportCoordinatesRequest
     */
    'grid_y': number;
    /**
     * 
     * @type {number}
     * @memberof TeleportCoordinatesRequest
     */
    'grid_z': number;
}
/**
 * References an existing position by ID only.
 * @export
 * @interface TeleportPosition
 */
export interface TeleportPosition {
    /**
     * 
     * @type {string}
     * @memberof TeleportPosition
     */
    'id': string;
}
/**
 * References an existing position by ID only.
 * @export
 * @interface TeleportPositionRequest
 */
export interface TeleportPositionRequest {
    /**
     * 
     * @type {string}
     * @memberof TeleportPositionRequest
     */
    'id': string;
}
/**
 * * `Path of John` - Path of John * `Path of JSon` - Path of JSon * `Not Chosen` - Not Chosen
 * @export
 * @enum {string}
 */

export const TheChosenPathEnum = {
    PathOfJohn: 'Path of John',
    PathOfJSon: 'Path of JSon',
    NotChosen: 'Not Chosen'
} as const;

export type TheChosenPathEnum = typeof TheChosenPathEnum[keyof typeof TheChosenPathEnum];


/**
 * 
 * @export
 * @interface ThePath
 */
export interface ThePath {
    /**
     * 
     * @type {TheChosenPathEnum}
     * @memberof ThePath
     */
    'name'?: TheChosenPathEnum;
    /**
     * 
     * @type {string}
     * @memberof ThePath
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ThePath
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ThePath
     */
    'id': string;
}


/**
 * 
 * @export
 * @interface ThePathRequest
 */
export interface ThePathRequest {
    /**
     * 
     * @type {TheChosenPathEnum}
     * @memberof ThePathRequest
     */
    'name'?: TheChosenPathEnum;
    /**
     * 
     * @type {string}
     * @memberof ThePathRequest
     */
    'description': string;
    /**
     * 
     * @type {File}
     * @memberof ThePathRequest
     */
    'icon'?: File | null;
}


/**
 * Serializer for TimeLineEvent objects with nested representations
 * @export
 * @interface TimeLineEvent
 */
export interface TimeLineEvent {
    /**
     * 
     * @type {string}
     * @memberof TimeLineEvent
     */
    'id': string;
    /**
     * 
     * @type {Document}
     * @memberof TimeLineEvent
     */
    'document': Document;
    /**
     * 
     * @type {DateTimeInfo}
     * @memberof TimeLineEvent
     */
    'date_time': DateTimeInfo;
}
/**
 * Serializer for importing TimeLineEvent with nested Document and DateTimeInfo. This serializer handles get_or_create logic for Document and DateTimeInfo.
 * @export
 * @interface TimeLineEventImportRequest
 */
export interface TimeLineEventImportRequest {
    /**
     * 
     * @type {DocumentRequest}
     * @memberof TimeLineEventImportRequest
     */
    'document': DocumentRequest;
    /**
     * 
     * @type {DateTimeInfoRequest}
     * @memberof TimeLineEventImportRequest
     */
    'date_time': DateTimeInfoRequest;
}
/**
 * 
 * @export
 * @interface TokenRefresh
 */
export interface TokenRefresh {
    /**
     * 
     * @type {string}
     * @memberof TokenRefresh
     */
    'access': string;
}
/**
 * 
 * @export
 * @interface TokenRefreshRequest
 */
export interface TokenRefreshRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenRefreshRequest
     */
    'refresh': string;
}
/**
 * Serializer for TokenReward model.
 * @export
 * @interface TokenReward
 */
export interface TokenReward {
    /**
     * 
     * @type {string}
     * @memberof TokenReward
     */
    'id': string;
    /**
     * Amount of tokens to reward
     * @type {number}
     * @memberof TokenReward
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof TokenReward
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof TokenReward
     */
    'reward'?: string | null;
}
/**
 * Serializer for TokenReward model.
 * @export
 * @interface TokenRewardRequest
 */
export interface TokenRewardRequest {
    /**
     * Amount of tokens to reward
     * @type {number}
     * @memberof TokenRewardRequest
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof TokenRewardRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof TokenRewardRequest
     */
    'reward'?: string | null;
}
/**
 * 
 * @export
 * @interface TokenVerifyRequest
 */
export interface TokenVerifyRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenVerifyRequest
     */
    'token': string;
}
/**
 * A training as its owner sees it: the identities involved plus the live clock of the fight, so a resume needs one round trip rather than two.
 * @export
 * @interface TrainingSession
 */
export interface TrainingSession {
    /**
     * 
     * @type {string}
     * @memberof TrainingSession
     */
    'id': string;
    /**
     * 
     * @type {Fighter}
     * @memberof TrainingSession
     */
    'source_character': Fighter;
    /**
     * 
     * @type {Fighter}
     * @memberof TrainingSession
     */
    'clone': Fighter;
    /**
     * 
     * @type {Fighter}
     * @memberof TrainingSession
     */
    'dummy': Fighter;
    /**
     * 
     * @type {string}
     * @memberof TrainingSession
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof TrainingSession
     */
    'created_at': string;
    /**
     * 
     * @type {FightState}
     * @memberof TrainingSession
     */
    'state': FightState;
}
/**
 * Which of the caller\'s own characters to train.  Omitted means the character the client is already playing, which is what the in-game entry point sends. The dashboard trains a character it is not currently playing, so it names one; the view proves ownership before the service ever sees it.
 * @export
 * @interface TrainingStartRequestRequest
 */
export interface TrainingStartRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof TrainingStartRequestRequest
     */
    'character'?: string | null;
}
/**
 * 
 * @export
 * @interface TransitionImage
 */
export interface TransitionImage {
    /**
     * 
     * @type {string}
     * @memberof TransitionImage
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TransitionImage
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof TransitionImage
     */
    'image': string;
    /**
     * 
     * @type {number}
     * @memberof TransitionImage
     */
    'order'?: number;
}
/**
 * Serializer for Trigger model.
 * @export
 * @interface Trigger
 */
export interface Trigger {
    /**
     * 
     * @type {string}
     * @memberof Trigger
     */
    'id': string;
    /**
     * 
     * @type {TriggerTypeEnum}
     * @memberof Trigger
     */
    'type': TriggerTypeEnum;
    /**
     * Description of the trigger
     * @type {string}
     * @memberof Trigger
     */
    'description': string;
    /**
     * Concreate - Item, Character, Anomaly
     * @type {string}
     * @memberof Trigger
     */
    'game_object'?: string | null;
    /**
     * Position in the game world
     * @type {string}
     * @memberof Trigger
     */
    'position'?: string | null;
    /**
     * Optional limit trigger to a specific location
     * @type {string}
     * @memberof Trigger
     */
    'location'?: string | null;
    /**
     * All NPCs that been created from this template will have this trigger
     * @type {string}
     * @memberof Trigger
     */
    'npc'?: string | null;
    /**
     * Optional skill that is required to trigger the action
     * @type {number}
     * @memberof Trigger
     */
    'skill'?: number | null;
    /**
     * Optional item that is required to trigger the action
     * @type {string}
     * @memberof Trigger
     */
    'item'?: string | null;
}


/**
 * Serializer for Trigger model.
 * @export
 * @interface TriggerRequest
 */
export interface TriggerRequest {
    /**
     * 
     * @type {TriggerTypeEnum}
     * @memberof TriggerRequest
     */
    'type': TriggerTypeEnum;
    /**
     * Description of the trigger
     * @type {string}
     * @memberof TriggerRequest
     */
    'description': string;
    /**
     * Concreate - Item, Character, Anomaly
     * @type {string}
     * @memberof TriggerRequest
     */
    'game_object'?: string | null;
    /**
     * Position in the game world
     * @type {string}
     * @memberof TriggerRequest
     */
    'position'?: string | null;
    /**
     * Optional limit trigger to a specific location
     * @type {string}
     * @memberof TriggerRequest
     */
    'location'?: string | null;
    /**
     * All NPCs that been created from this template will have this trigger
     * @type {string}
     * @memberof TriggerRequest
     */
    'npc'?: string | null;
    /**
     * Optional skill that is required to trigger the action
     * @type {number}
     * @memberof TriggerRequest
     */
    'skill'?: number | null;
    /**
     * Optional item that is required to trigger the action
     * @type {string}
     * @memberof TriggerRequest
     */
    'item'?: string | null;
}


/**
 * * `search` - search * `kill` - kill * `interaction` - interaction * `position` - position * `useItem` - useItem * `useSkill` - useSkill * `custom` - custom
 * @export
 * @enum {string}
 */

export const TriggerTypeEnum = {
    Search: 'search',
    Kill: 'kill',
    Interaction: 'interaction',
    Position: 'position',
    UseItem: 'useItem',
    UseSkill: 'useSkill',
    Custom: 'custom'
} as const;

export type TriggerTypeEnum = typeof TriggerTypeEnum[keyof typeof TriggerTypeEnum];


/**
 * Persist a tuned skill. Every field optional; absent means unchanged.
 * @export
 * @interface TuneSkillRequestRequest
 */
export interface TuneSkillRequestRequest {
    /**
     * 
     * @type {number}
     * @memberof TuneSkillRequestRequest
     */
    'skill_id': number;
    /**
     * 
     * @type {string}
     * @memberof TuneSkillRequestRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof TuneSkillRequestRequest
     */
    'grade'?: number;
    /**
     * 
     * @type {string}
     * @memberof TuneSkillRequestRequest
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TuneSkillRequestRequest
     */
    'min_range'?: number;
    /**
     * 
     * @type {number}
     * @memberof TuneSkillRequestRequest
     */
    'max_range'?: number;
    /**
     * 
     * @type {number}
     * @memberof TuneSkillRequestRequest
     */
    'charge_count'?: number;
    /**
     * 
     * @type {any}
     * @memberof TuneSkillRequestRequest
     */
    'spray_config'?: any;
    /**
     * 
     * @type {any}
     * @memberof TuneSkillRequestRequest
     */
    'impact'?: any;
    /**
     * 
     * @type {any}
     * @memberof TuneSkillRequestRequest
     */
    'cost'?: any;
    /**
     * 
     * @type {any}
     * @memberof TuneSkillRequestRequest
     */
    'effect'?: any;
}
/**
 * * `self` - self * `any` - any
 * @export
 * @enum {string}
 */

export const UseEnum = {
    Self: 'self',
    Any: 'any'
} as const;

export type UseEnum = typeof UseEnum[keyof typeof UseEnum];


/**
 * 
 * @export
 * @interface ViolationObject
 */
export interface ViolationObject {
    /**
     * 
     * @type {ImpactViolationTypeEnum}
     * @memberof ViolationObject
     */
    'id': ImpactViolationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ViolationObject
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViolationObject
     */
    'description'?: string | null;
}


/**
 * Fog of war state for the requesting character.
 * @export
 * @interface Vision
 */
export interface Vision {
    /**
     * The requesting character\'s own sight radius in grid cells
     * @type {number}
     * @memberof Vision
     */
    'range': number;
    /**
     * Whether the requesting character is blind. Blind characters can still move and attack.
     * @type {boolean}
     * @memberof Vision
     */
    'blinded': boolean;
    /**
     * Every character whose sight the requesting character shares, themself included.
     * @type {Array<VisionSource>}
     * @memberof Vision
     */
    'sources': Array<VisionSource>;
    /**
     * [x, y] pairs the party can currently see. Everything else is under fog.
     * @type {Array<Array<number>>}
     * @memberof Vision
     */
    'visible_cells': Array<Array<number>>;
}
/**
 * One pair of eyes contributing to the player\'s view of the board.
 * @export
 * @interface VisionSource
 */
export interface VisionSource {
    /**
     * Character the sight belongs to
     * @type {string}
     * @memberof VisionSource
     */
    'character_id': string;
    /**
     * Character name
     * @type {string}
     * @memberof VisionSource
     */
    'name': string;
    /**
     * X coordinate the sight is cast from
     * @type {number}
     * @memberof VisionSource
     */
    'x': number;
    /**
     * Y coordinate the sight is cast from
     * @type {number}
     * @memberof VisionSource
     */
    'y': number;
    /**
     * Sight radius in grid cells
     * @type {number}
     * @memberof VisionSource
     */
    'range': number;
    /**
     * Whether this character is blind and contributes no sight
     * @type {boolean}
     * @memberof VisionSource
     */
    'blinded': boolean;
}
/**
 * Where one charge places the pattern.
 * @export
 * @interface WorkbenchAimRequest
 */
export interface WorkbenchAimRequest {
    /**
     * 
     * @type {number}
     * @memberof WorkbenchAimRequest
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchAimRequest
     */
    'y': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchAimRequest
     */
    'rotation'?: number;
}
/**
 * How often this body actually fires the skill, and what stops it.  Not the composite\'s ``uses_per_turn``, which is fixed to the reference turn so skills stay comparable. These are the selected subject\'s own numbers, and a bigger turn changes them without changing the skill\'s price.
 * @export
 * @interface WorkbenchCadence
 */
export interface WorkbenchCadence {
    /**
     * Uses the turn affords. Action points refill at the top of every round, so this is a rate — true again next round.
     * @type {number}
     * @memberof WorkbenchCadence
     */
    'casts_per_turn': number;
    /**
     * Uses available on the opening turn from full pools: the per-turn figure, cut down by the reserve when the reserve is smaller.
     * @type {number}
     * @memberof WorkbenchCadence
     */
    'casts_from_full': number;
    /**
     * The resource holding the opening turn back, or null when the skill charges no action points and the per-turn figure is therefore the free-skill convention rather than a division.
     * @type {string}
     * @memberof WorkbenchCadence
     */
    'bound_by': string | null;
    /**
     * A whole-fight ceiling, not a rate: energy and health are restored by no clock, so this many uses exist in total. Null when the skill charges neither.
     * @type {number}
     * @memberof WorkbenchCadence
     */
    'reserve_casts': number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkbenchCadence
     */
    'reserve_bound_by': string | null;
    /**
     * False when the skill charges no action points, in which case the per-turn figure is a stated convention of one rather than a division.
     * @type {boolean}
     * @memberof WorkbenchCadence
     */
    'action_points_metered': boolean;
    /**
     * True when the skill charges nothing at all.
     * @type {boolean}
     * @memberof WorkbenchCadence
     */
    'unmetered': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbenchCadence
     */
    'affordable': boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkbenchCadence
     */
    'note': string;
}
/**
 * The body casting the skill, as numbers rather than a row.
 * @export
 * @interface WorkbenchCasterRequest
 */
export interface WorkbenchCasterRequest {
    /**
     * Stat name to value, e.g. {\'Physical Strength\': 14}.
     * @type {{ [key: string]: number; }}
     * @memberof WorkbenchCasterRequest
     */
    'stats': { [key: string]: number; };
    /**
     * The caster\'s Path. Sets the health, energy and action-point multipliers.
     * @type {string}
     * @memberof WorkbenchCasterRequest
     */
    'path'?: string | null;
    /**
     * Override the derived health pool.
     * @type {number}
     * @memberof WorkbenchCasterRequest
     */
    'health_override'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchCasterRequest
     */
    'dimension_speed'?: number;
}
/**
 * 
 * @export
 * @interface WorkbenchCell
 */
export interface WorkbenchCell {
    /**
     * 
     * @type {number}
     * @memberof WorkbenchCell
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchCell
     */
    'y': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchCell
     */
    'hits': number;
}
/**
 * 
 * @export
 * @interface WorkbenchCharge
 */
export interface WorkbenchCharge {
    /**
     * 
     * @type {number}
     * @memberof WorkbenchCharge
     */
    'charge': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof WorkbenchCharge
     */
    'anchor': { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof WorkbenchCharge
     */
    'rotation': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchCharge
     */
    'distance': number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbenchCharge
     */
    'in_range': boolean;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof WorkbenchCharge
     */
    'cells': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchCharge
     */
    'cells_on_grid': number;
}
/**
 * 
 * @export
 * @interface WorkbenchCostCharge
 */
export interface WorkbenchCostCharge {
    /**
     * 
     * @type {string}
     * @memberof WorkbenchCostCharge
     */
    'kind': string;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchCostCharge
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchCostCharge
     */
    'pool': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbenchCostCharge
     */
    'affordable': boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchCostCharge
     */
    'share_of_pool': number | null;
}
/**
 * 
 * @export
 * @interface WorkbenchCosts
 */
export interface WorkbenchCosts {
    /**
     * 
     * @type {Array<WorkbenchCostCharge>}
     * @memberof WorkbenchCosts
     */
    'charges': Array<WorkbenchCostCharge>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof WorkbenchCosts
     */
    'pools': { [key: string]: number; };
    /**
     * 
     * @type {WorkbenchCadence}
     * @memberof WorkbenchCosts
     */
    'cadence': WorkbenchCadence;
}
/**
 * 
 * @export
 * @interface WorkbenchDistribution
 */
export interface WorkbenchDistribution {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof WorkbenchDistribution
     */
    'per_hit': { [key: string]: any; };
    /**
     * 
     * @type {Array<WorkbenchPerCell>}
     * @memberof WorkbenchDistribution
     */
    'per_cell': Array<WorkbenchPerCell>;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchDistribution
     */
    'total_landed': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchDistribution
     */
    'total_expected': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof WorkbenchDistribution
     */
    'by_kind': { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface WorkbenchEffect
 */
export interface WorkbenchEffect {
    /**
     * 
     * @type {string}
     * @memberof WorkbenchEffect
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchEffect
     */
    'chance': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchEffect
     */
    'duration': number;
    /**
     * 
     * @type {any}
     * @memberof WorkbenchEffect
     */
    'stat_modifiers': any;
    /**
     * 
     * @type {any}
     * @memberof WorkbenchEffect
     */
    'periodic': any | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbenchEffect
     */
    'inert': boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkbenchEffect
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkbenchEffect
     */
    'notes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface WorkbenchGeometry
 */
export interface WorkbenchGeometry {
    /**
     * 
     * @type {number}
     * @memberof WorkbenchGeometry
     */
    'size': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof WorkbenchGeometry
     */
    'caster': { [key: string]: number; };
    /**
     * 
     * @type {any}
     * @memberof WorkbenchGeometry
     */
    'pattern': any;
    /**
     * 
     * @type {any}
     * @memberof WorkbenchGeometry
     */
    'pattern_flags': any;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchGeometry
     */
    'charge_count': number;
    /**
     * 
     * @type {Array<WorkbenchCharge>}
     * @memberof WorkbenchGeometry
     */
    'per_charge': Array<WorkbenchCharge>;
    /**
     * 
     * @type {Array<WorkbenchCell>}
     * @memberof WorkbenchGeometry
     */
    'cells': Array<WorkbenchCell>;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchGeometry
     */
    'distinct_cells': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchGeometry
     */
    'total_hits': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchGeometry
     */
    'min_range': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchGeometry
     */
    'max_range': number;
}
/**
 * 
 * @export
 * @interface WorkbenchImpact
 */
export interface WorkbenchImpact {
    /**
     * 
     * @type {string}
     * @memberof WorkbenchImpact
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof WorkbenchImpact
     */
    'violation': string;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchImpact
     */
    'base': number;
    /**
     * 
     * @type {Array<WorkbenchTerm>}
     * @memberof WorkbenchImpact
     */
    'terms': Array<WorkbenchTerm>;
    /**
     * 
     * @type {string}
     * @memberof WorkbenchImpact
     */
    'capped_by': string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchImpact
     */
    'efficiency': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchImpact
     */
    'formula_value': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchImpact
     */
    'resolved': number;
    /**
     * 
     * @type {Array<WorkbenchLuckEntry>}
     * @memberof WorkbenchImpact
     */
    'luck_band': Array<WorkbenchLuckEntry>;
    /**
     * 
     * @type {any}
     * @memberof WorkbenchImpact
     */
    'shielded': any;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchImpact
     */
    'landed': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchImpact
     */
    'expected': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchImpact
     */
    'expected_unwarded': number;
}
/**
 * 
 * @export
 * @interface WorkbenchLuckEntry
 */
export interface WorkbenchLuckEntry {
    /**
     * 
     * @type {string}
     * @memberof WorkbenchLuckEntry
     */
    'outcome': string;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchLuckEntry
     */
    'multiplier': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchLuckEntry
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface WorkbenchPerCell
 */
export interface WorkbenchPerCell {
    /**
     * 
     * @type {number}
     * @memberof WorkbenchPerCell
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchPerCell
     */
    'y': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchPerCell
     */
    'hits': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchPerCell
     */
    'landed': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchPerCell
     */
    'expected': number;
}
/**
 * 
 * @export
 * @interface WorkbenchPower
 */
export interface WorkbenchPower {
    /**
     * The one comparable number, additional to the named figures below and not a replacement for any of them.
     * @type {number}
     * @memberof WorkbenchPower
     */
    'dx_skill_power': number;
    /**
     * Every term the composite was built from, so it can be reproduced by hand against `power-model/`.
     * @type {any}
     * @memberof WorkbenchPower
     */
    'dx_skill_power_terms': any;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchPower
     */
    'power_per_cell': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchPower
     */
    'area_multiple': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchPower
     */
    'power_per_area': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchPower
     */
    'luck_min': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchPower
     */
    'luck_avg': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchPower
     */
    'luck_max': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchPower
     */
    'cost_efficiency': number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbenchPower
     */
    'mixed_kinds': boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkbenchPower
     */
    'note': string;
}
/**
 * The full chain for one skill against one body.
 * @export
 * @interface WorkbenchRequestRequest
 */
export interface WorkbenchRequestRequest {
    /**
     * The stored skill to resolve.
     * @type {number}
     * @memberof WorkbenchRequestRequest
     */
    'skill_id': number;
    /**
     * 
     * @type {WorkbenchCasterRequest}
     * @memberof WorkbenchRequestRequest
     */
    'caster'?: WorkbenchCasterRequest;
    /**
     * Resolve against an etalon or a real character instead of a typed stat line. Takes precedence over `caster`.
     * @type {SubjectRefRequest}
     * @memberof WorkbenchRequestRequest
     */
    'subject'?: SubjectRefRequest;
    /**
     * 
     * @type {WorkbenchTargetRequest}
     * @memberof WorkbenchRequestRequest
     */
    'target'?: WorkbenchTargetRequest;
    /**
     * 
     * @type {WorkbenchSkillOverrideRequest}
     * @memberof WorkbenchRequestRequest
     */
    'overrides'?: WorkbenchSkillOverrideRequest;
    /**
     * Side of the preview grid. The workbench itself always asks for 20 and pans a 10x10 viewport over it; smaller sizes remain legal for a saved link from before the fixed board existed.
     * @type {number}
     * @memberof WorkbenchRequestRequest
     */
    'grid_size'?: number;
    /**
     * One aim per charge. Defaults to the caster\'s own cell.
     * @type {Array<WorkbenchAimRequest>}
     * @memberof WorkbenchRequestRequest
     */
    'aims'?: Array<WorkbenchAimRequest>;
}
/**
 * 
 * @export
 * @interface WorkbenchRequirement
 */
export interface WorkbenchRequirement {
    /**
     * 
     * @type {string}
     * @memberof WorkbenchRequirement
     */
    'stat': string;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchRequirement
     */
    'required': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchRequirement
     */
    'actual': number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbenchRequirement
     */
    'met': boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchRequirement
     */
    'deficit': number;
}
/**
 * 
 * @export
 * @interface WorkbenchResponse
 */
export interface WorkbenchResponse {
    /**
     * 
     * @type {WorkbenchSkill}
     * @memberof WorkbenchResponse
     */
    'skill': WorkbenchSkill;
    /**
     * 
     * @type {Array<WorkbenchRequirement>}
     * @memberof WorkbenchResponse
     */
    'requirements': Array<WorkbenchRequirement>;
    /**
     * 
     * @type {WorkbenchCosts}
     * @memberof WorkbenchResponse
     */
    'costs': WorkbenchCosts;
    /**
     * 
     * @type {Array<WorkbenchImpact>}
     * @memberof WorkbenchResponse
     */
    'impacts': Array<WorkbenchImpact>;
    /**
     * 
     * @type {Array<WorkbenchEffect>}
     * @memberof WorkbenchResponse
     */
    'effects': Array<WorkbenchEffect>;
    /**
     * 
     * @type {WorkbenchGeometry}
     * @memberof WorkbenchResponse
     */
    'geometry': WorkbenchGeometry;
    /**
     * 
     * @type {WorkbenchDistribution}
     * @memberof WorkbenchResponse
     */
    'distribution': WorkbenchDistribution;
    /**
     * 
     * @type {WorkbenchPower}
     * @memberof WorkbenchResponse
     */
    'power': WorkbenchPower;
    /**
     * Who this was resolved against — echoed so a reading can be attributed to a body rather than to whatever the caller last sent.
     * @type {SubjectSummary}
     * @memberof WorkbenchResponse
     */
    'subject': SubjectSummary;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkbenchResponse
     */
    'warnings': Array<string>;
}
/**
 * 
 * @export
 * @interface WorkbenchSkill
 */
export interface WorkbenchSkill {
    /**
     * 
     * @type {number}
     * @memberof WorkbenchSkill
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof WorkbenchSkill
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchSkill
     */
    'grade': number;
    /**
     * 
     * @type {string}
     * @memberof WorkbenchSkill
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof WorkbenchSkill
     */
    'special': string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbenchSkill
     */
    'immediate': boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchSkill
     */
    'min_range': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchSkill
     */
    'max_range': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchSkill
     */
    'charge_count': number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbenchSkill
     */
    'self_target': boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkbenchSkill
     */
    'school': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbenchSkill
     */
    'heals_by_negation': boolean;
}
/**
 * What a save wrote back, echoed from the row rather than the request.  Read off the model so the response shows what was actually stored — a payload normalised on the way in is what the tuner needs to see, not the payload they sent.
 * @export
 * @interface WorkbenchSkillFields
 */
export interface WorkbenchSkillFields {
    /**
     * 
     * @type {number}
     * @memberof WorkbenchSkillFields
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof WorkbenchSkillFields
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchSkillFields
     */
    'grade'?: number;
    /**
     * 
     * @type {SkillTypeEnum}
     * @memberof WorkbenchSkillFields
     */
    'type'?: SkillTypeEnum;
    /**
     * Minimum range in cells from caster to target
     * @type {number}
     * @memberof WorkbenchSkillFields
     */
    'min_range'?: number;
    /**
     * Maximum range in cells from caster to target
     * @type {number}
     * @memberof WorkbenchSkillFields
     */
    'max_range'?: number;
    /**
     * Number of charges (independent spray pattern applications) per use
     * @type {number}
     * @memberof WorkbenchSkillFields
     */
    'charge_count'?: number;
    /**
     * Spray pattern configuration: spray (2D matrix), passthrough (bool), shadow (bool), multidimensional (bool), rotatable (bool)
     * @type {any}
     * @memberof WorkbenchSkillFields
     */
    'spray_config'?: any;
    /**
     * A list of Impact objects describing what the skill does.
     * @type {any}
     * @memberof WorkbenchSkillFields
     */
    'impact'?: any;
    /**
     * A list of Cost objects describing what the skill costs to use.
     * @type {any}
     * @memberof WorkbenchSkillFields
     */
    'cost'?: any;
    /**
     * A list of AssignableEffect objects the skill can inflict.
     * @type {any}
     * @memberof WorkbenchSkillFields
     */
    'effect'?: any;
}


/**
 * Fields the workbench may change before resolving, without saving.  Every field is optional: what is absent is read from the stored skill. This is what makes the page a workbench rather than a viewer — a tuner changes a number, sees the whole chain move, and only then decides whether to keep it.
 * @export
 * @interface WorkbenchSkillOverrideRequest
 */
export interface WorkbenchSkillOverrideRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkbenchSkillOverrideRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchSkillOverrideRequest
     */
    'grade'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkbenchSkillOverrideRequest
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchSkillOverrideRequest
     */
    'min_range'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchSkillOverrideRequest
     */
    'max_range'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchSkillOverrideRequest
     */
    'charge_count'?: number;
    /**
     * 
     * @type {any}
     * @memberof WorkbenchSkillOverrideRequest
     */
    'spray_config'?: any;
    /**
     * 
     * @type {any}
     * @memberof WorkbenchSkillOverrideRequest
     */
    'impact'?: any;
    /**
     * 
     * @type {any}
     * @memberof WorkbenchSkillOverrideRequest
     */
    'cost'?: any;
    /**
     * 
     * @type {any}
     * @memberof WorkbenchSkillOverrideRequest
     */
    'effect'?: any;
}
/**
 * The body the blow is measured against. Neutral unless described.
 * @export
 * @interface WorkbenchTargetRequest
 */
export interface WorkbenchTargetRequest {
    /**
     * The ward\'s violation type. A ward matching the blow, or an untyped one, absorbs in full; any other absorbs at the mismatch rate.
     * @type {string}
     * @memberof WorkbenchTargetRequest
     */
    'shield_violation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchTargetRequest
     */
    'shield_efficiency'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchTargetRequest
     */
    'shield_health'?: number;
}
/**
 * 
 * @export
 * @interface WorkbenchTerm
 */
export interface WorkbenchTerm {
    /**
     * 
     * @type {string}
     * @memberof WorkbenchTerm
     */
    'stat': string;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchTerm
     */
    'threshold': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchTerm
     */
    'scaling_factor': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchTerm
     */
    'stat_value': number;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchTerm
     */
    'ratio': number | null;
    /**
     * 
     * @type {number}
     * @memberof WorkbenchTerm
     */
    'efficiency': number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbenchTerm
     */
    'capped_at_max': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbenchTerm
     */
    'capped_at_min': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbenchTerm
     */
    'gated': boolean;
}
/**
 * 
 * @export
 * @interface WorldItem
 */
export interface WorldItem {
    /**
     * 
     * @type {string}
     * @memberof WorldItem
     */
    'id': string;
    /**
     * 
     * @type {Item}
     * @memberof WorldItem
     */
    'item': Item;
    /**
     * 
     * @type {boolean}
     * @memberof WorldItem
     */
    'is_active'?: boolean;
    /**
     * Footprint on the tactical grid: standard 1x1, medium 2x2, superior 3x3, anchored at the object\'s north-west cell  * `standard` - standard * `medium` - medium * `superior` - superior
     * @type {TacticalSizeEnum}
     * @memberof WorldItem
     */
    'tactical_size'?: TacticalSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof WorldItem
     */
    'charges_left'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorldItem
     */
    'visibility'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorldItem
     */
    'position'?: string | null;
    /**
     * current area position tabletop map contains of string in format x,y coordinates the layer/dimension always took from the self.dimension
     * @type {string}
     * @memberof WorldItem
     */
    'tactical_position'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorldItem
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorldItem
     */
    'campaign': string;
}


/**
 * 
 * @export
 * @interface WorldItemRequest
 */
export interface WorldItemRequest {
    /**
     * 
     * @type {ItemRequest}
     * @memberof WorldItemRequest
     */
    'item': ItemRequest;
    /**
     * 
     * @type {boolean}
     * @memberof WorldItemRequest
     */
    'is_active'?: boolean;
    /**
     * Footprint on the tactical grid: standard 1x1, medium 2x2, superior 3x3, anchored at the object\'s north-west cell  * `standard` - standard * `medium` - medium * `superior` - superior
     * @type {TacticalSizeEnum}
     * @memberof WorldItemRequest
     */
    'tactical_size'?: TacticalSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof WorldItemRequest
     */
    'charges_left'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorldItemRequest
     */
    'visibility'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorldItemRequest
     */
    'position'?: string | null;
    /**
     * current area position tabletop map contains of string in format x,y coordinates the layer/dimension always took from the self.dimension
     * @type {string}
     * @memberof WorldItemRequest
     */
    'tactical_position'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorldItemRequest
     */
    'dimension'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorldItemRequest
     */
    'campaign': string;
}


/**
 * 
 * @export
 * @interface WorldPosition
 */
export interface WorldPosition {
    /**
     * 
     * @type {string}
     * @memberof WorldPosition
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof WorldPosition
     */
    'grid_x'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorldPosition
     */
    'grid_y'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorldPosition
     */
    'grid_z'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorldPosition
     */
    'sub_location': string;
    /**
     * 
     * @type {string}
     * @memberof WorldPosition
     */
    'location': string;
    /**
     * 
     * @type {any}
     * @memberof WorldPosition
     */
    'labels'?: any;
    /**
     * 
     * @type {Array<Array<PositionConnection>>}
     * @memberof WorldPosition
     */
    'connections': Array<Array<PositionConnection>>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorldPosition
     */
    'characters': Array<string>;
    /**
     * 
     * @type {Array<CharacterOnPosition>}
     * @memberof WorldPosition
     */
    'characters_on_position': Array<CharacterOnPosition>;
    /**
     * 
     * @type {string}
     * @memberof WorldPosition
     */
    'image': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorldPosition
     */
    'is_safe'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorldPosition
     */
    'anomalies': Array<string>;
    /**
     * 
     * @type {TacticalMap}
     * @memberof WorldPosition
     */
    'tactical_map': TacticalMap | null;
}
/**
 * 
 * @export
 * @interface WsActionImpactModel
 */
export interface WsActionImpactModel {
    /**
     * 
     * @type {WsImpactType}
     * @memberof WsActionImpactModel
     */
    'type': WsImpactType;
    /**
     * 
     * @type {WsImpactViolationType}
     * @memberof WsActionImpactModel
     */
    'violation': WsImpactViolationType;
    /**
     * 
     * @type {number}
     * @memberof WsActionImpactModel
     */
    'size': number;
    /**
     * 
     * @type {WsDiceRollResult}
     * @memberof WsActionImpactModel
     */
    'dice_roll_result': WsDiceRollResult;
}


/**
 * 
 * @export
 * @interface WsActionModel
 */
export interface WsActionModel {
    /**
     * 
     * @type {WsCharacterActionType}
     * @memberof WsActionModel
     */
    'action_type': WsCharacterActionType;
    /**
     * 
     * @type {string}
     * @memberof WsActionModel
     */
    'initiator_id': string;
    /**
     * 
     * @type {number}
     * @memberof WsActionModel
     */
    'skill_id': number | null;
    /**
     * 
     * @type {string}
     * @memberof WsActionModel
     */
    'target_dimension_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof WsActionModel
     */
    'target_location_id': string | null;
}


/**
 * 
 * @export
 * @interface WsAttributeHolder
 */
export interface WsAttributeHolder {
    /**
     * 
     * @type {WsAttributeType}
     * @memberof WsAttributeHolder
     */
    'name': WsAttributeType;
    /**
     * 
     * @type {number}
     * @memberof WsAttributeHolder
     */
    'current': number | null;
    /**
     * 
     * @type {number}
     * @memberof WsAttributeHolder
     */
    'max': number | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const WsAttributeType = {
    Health: 'Health',
    Energy: 'Energy',
    ActionPoints: 'Action Points'
} as const;

export type WsAttributeType = typeof WsAttributeType[keyof typeof WsAttributeType];


/**
 * Data for challenge created event with full typing coverage.
 * @export
 * @interface WsChallengeCreatedEventData
 */
export interface WsChallengeCreatedEventData {
    /**
     * 
     * @type {string}
     * @memberof WsChallengeCreatedEventData
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WsChallengeCreatedEventData
     */
    'character_id': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WsCharacterActionType = {
    UseSkill: 'USE_SKILL',
    UseItem: 'USE_ITEM',
    DimensionShift: 'DIMENSION_SHIFT',
    ChangePosition: 'CHANGE_POSITION',
    StartDialogue: 'START_DIALOGUE',
    MakeDuelInvitation: 'MAKE_DUEL_INVITATION',
    AcceptDuelInvitation: 'ACCEPT_DUEL_INVITATION',
    RejectDuelInvitation: 'REJECT_DUEL_INVITATION',
    StartFight: 'START_FIGHT',
    Move: 'MOVE',
    TacticalMove: 'TACTICAL_MOVE',
    Breakthrough: 'BREAKTHROUGH',
    DiceRoll: 'DICE_ROLL',
    Bargain: 'BARGAIN',
    Anomaly: 'ANOMALY',
    GodIntervention: 'GOD_INTERVENTION',
    LongRest: 'LONG_REST',
    BackToSafeZone: 'BACK_TO_SAFE_ZONE',
    Inspect: 'INSPECT',
    SnatchItem: 'SNATCH_ITEM',
    OpenChest: 'OPEN_CHEST',
    PickUpItem: 'PICK_UP_ITEM'
} as const;

export type WsCharacterActionType = typeof WsCharacterActionType[keyof typeof WsCharacterActionType];


/**
 * 
 * @export
 * @interface WsCharacterExample1GameEventData
 */
export interface WsCharacterExample1GameEventData {
    /**
     * 
     * @type {string}
     * @memberof WsCharacterExample1GameEventData
     */
    'field1': string;
}
/**
 * 
 * @export
 * @interface WsCharacterExample2GameEventData
 */
export interface WsCharacterExample2GameEventData {
    /**
     * 
     * @type {string}
     * @memberof WsCharacterExample2GameEventData
     */
    'field2': string;
}
/**
 * 
 * @export
 * @interface WsCharacterJoinFightEventData
 */
export interface WsCharacterJoinFightEventData {
    /**
     * 
     * @type {string}
     * @memberof WsCharacterJoinFightEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsCharacterJoinFightEventData
     */
    'character_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsCharacterJoinFightEventData
     */
    'position_id': string;
}
/**
 * 
 * @export
 * @interface WsCharacterLeaveFightEventData
 */
export interface WsCharacterLeaveFightEventData {
    /**
     * 
     * @type {string}
     * @memberof WsCharacterLeaveFightEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsCharacterLeaveFightEventData
     */
    'character_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsCharacterLeaveFightEventData
     */
    'position_id': string;
}
/**
 * 
 * @export
 * @interface WsCharacterNewTurnGameEventData
 */
export interface WsCharacterNewTurnGameEventData {
    /**
     * 
     * @type {WsCurrentTurn}
     * @memberof WsCharacterNewTurnGameEventData
     */
    'current_turn': WsCurrentTurn;
    /**
     * 
     * @type {WsFullCharacterInfo}
     * @memberof WsCharacterNewTurnGameEventData
     */
    'character_info': WsFullCharacterInfo;
}
/**
 * 
 * @export
 * @interface WsCharacterPendingJoinFightEventData
 */
export interface WsCharacterPendingJoinFightEventData {
    /**
     * 
     * @type {string}
     * @memberof WsCharacterPendingJoinFightEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsCharacterPendingJoinFightEventData
     */
    'character_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsCharacterPendingJoinFightEventData
     */
    'position_id': string;
}
/**
 * 
 * @export
 * @interface WsCoordinate
 */
export interface WsCoordinate {
    /**
     * 
     * @type {number}
     * @memberof WsCoordinate
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof WsCoordinate
     */
    'y': number;
    /**
     * 
     * @type {number}
     * @memberof WsCoordinate
     */
    'z': number;
}
/**
 * 
 * @export
 * @interface WsCurrentTurn
 */
export interface WsCurrentTurn {
    /**
     * 
     * @type {string}
     * @memberof WsCurrentTurn
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WsCurrentTurn
     */
    'started_at': string;
    /**
     * 
     * @type {number}
     * @memberof WsCurrentTurn
     */
    'duration': number;
}
/**
 * 
 * @export
 * @interface WsDiceRollResult
 */
export interface WsDiceRollResult {
    /**
     * 
     * @type {number}
     * @memberof WsDiceRollResult
     */
    'dice_side': number;
    /**
     * 
     * @type {number}
     * @memberof WsDiceRollResult
     */
    'multiplier': number | null;
    /**
     * 
     * @type {WsRollOutcome}
     * @memberof WsDiceRollResult
     */
    'outcome': WsRollOutcome;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const WsEventCategory = {
    Character: 'character',
    Location: 'location',
    Fight: 'fight',
    Game: 'game',
    World: 'world'
} as const;

export type WsEventCategory = typeof WsEventCategory[keyof typeof WsEventCategory];


/**
 * 
 * @export
 * @interface WsFightEndVoteEventData
 */
export interface WsFightEndVoteEventData {
    /**
     * 
     * @type {string}
     * @memberof WsFightEndVoteEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightEndVoteEventData
     */
    'position_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightEndVoteEventData
     */
    'character_id': string;
    /**
     * 
     * @type {number}
     * @memberof WsFightEndVoteEventData
     */
    'round': number;
    /**
     * 
     * @type {boolean}
     * @memberof WsFightEndVoteEventData
     */
    'agreed': boolean;
    /**
     * 
     * @type {number}
     * @memberof WsFightEndVoteEventData
     */
    'voted_count': number;
    /**
     * 
     * @type {number}
     * @memberof WsFightEndVoteEventData
     */
    'required_count': number;
    /**
     * 
     * @type {boolean}
     * @memberof WsFightEndVoteEventData
     */
    'passed': boolean;
}
/**
 * 
 * @export
 * @interface WsFightEndedEventData
 */
export interface WsFightEndedEventData {
    /**
     * 
     * @type {string}
     * @memberof WsFightEndedEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightEndedEventData
     */
    'position_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightEndedEventData
     */
    'outcome'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WsFightEndedEventData
     */
    'winner_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WsFightEndedEventData
     */
    'winner_side_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WsFightEndedEventData
     */
    'cycle_id'?: number | null;
}
/**
 * 
 * @export
 * @interface WsFightInvitationAnsweredEventData
 */
export interface WsFightInvitationAnsweredEventData {
    /**
     * 
     * @type {string}
     * @memberof WsFightInvitationAnsweredEventData
     */
    'invitation_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightInvitationAnsweredEventData
     */
    'inviter_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightInvitationAnsweredEventData
     */
    'invitee_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof WsFightInvitationAnsweredEventData
     */
    'accepted': boolean;
    /**
     * 
     * @type {string}
     * @memberof WsFightInvitationAnsweredEventData
     */
    'fight_id'?: string | null;
}
/**
 * 
 * @export
 * @interface WsFightInvitationReceivedEventData
 */
export interface WsFightInvitationReceivedEventData {
    /**
     * 
     * @type {string}
     * @memberof WsFightInvitationReceivedEventData
     */
    'invitation_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightInvitationReceivedEventData
     */
    'inviter_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightInvitationReceivedEventData
     */
    'invitee_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightInvitationReceivedEventData
     */
    'expires_at': string;
}
/**
 * 
 * @export
 * @interface WsFightParticipantSideChangedEventData
 */
export interface WsFightParticipantSideChangedEventData {
    /**
     * 
     * @type {string}
     * @memberof WsFightParticipantSideChangedEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightParticipantSideChangedEventData
     */
    'character_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightParticipantSideChangedEventData
     */
    'from_side_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WsFightParticipantSideChangedEventData
     */
    'to_side_id'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WsFightParticipantSideChangedEventData
     */
    'by_game_master'?: boolean;
}
/**
 * 
 * @export
 * @interface WsFightRoundAdvancedEventData
 */
export interface WsFightRoundAdvancedEventData {
    /**
     * 
     * @type {string}
     * @memberof WsFightRoundAdvancedEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightRoundAdvancedEventData
     */
    'character_id': string;
    /**
     * 
     * @type {number}
     * @memberof WsFightRoundAdvancedEventData
     */
    'round': number;
    /**
     * 
     * @type {string}
     * @memberof WsFightRoundAdvancedEventData
     */
    'phase': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightRoundAdvancedEventData
     */
    'phase_started_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WsFightRoundAdvancedEventData
     */
    'phase_ends_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WsFightRoundAdvancedEventData
     */
    'phase_timeout_seconds': number;
    /**
     * 
     * @type {string}
     * @memberof WsFightRoundAdvancedEventData
     */
    'server_time': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightRoundAdvancedEventData
     */
    'tactical_map'?: string | null;
}
/**
 * 
 * @export
 * @interface WsFightSideCreatedEventData
 */
export interface WsFightSideCreatedEventData {
    /**
     * 
     * @type {string}
     * @memberof WsFightSideCreatedEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {WsFightSideEventData}
     * @memberof WsFightSideCreatedEventData
     */
    'side': WsFightSideEventData;
}
/**
 * The donut/side-rail shape — see ``apps.game.services.fight.side_summary``, the one place that computes it.
 * @export
 * @interface WsFightSideEventData
 */
export interface WsFightSideEventData {
    /**
     * 
     * @type {string}
     * @memberof WsFightSideEventData
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof WsFightSideEventData
     */
    'slot': number;
    /**
     * 
     * @type {string}
     * @memberof WsFightSideEventData
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightSideEventData
     */
    'organization_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WsFightSideEventData
     */
    'lead_character_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WsFightSideEventData
     */
    'member_count': number;
    /**
     * 
     * @type {number}
     * @memberof WsFightSideEventData
     */
    'power': number;
    /**
     * 
     * @type {number}
     * @memberof WsFightSideEventData
     */
    'power_share': number;
}
/**
 * 
 * @export
 * @interface WsFightSideUpdatedEventData
 */
export interface WsFightSideUpdatedEventData {
    /**
     * 
     * @type {string}
     * @memberof WsFightSideUpdatedEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {WsFightSideEventData}
     * @memberof WsFightSideUpdatedEventData
     */
    'side': WsFightSideEventData;
}
/**
 * 
 * @export
 * @interface WsFightStartedEventData
 */
export interface WsFightStartedEventData {
    /**
     * 
     * @type {string}
     * @memberof WsFightStartedEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightStartedEventData
     */
    'position_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightStartedEventData
     */
    'attacker_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightStartedEventData
     */
    'defender_id': string;
}
/**
 * 
 * @export
 * @interface WsFightTurnEndedEventData
 */
export interface WsFightTurnEndedEventData {
    /**
     * 
     * @type {string}
     * @memberof WsFightTurnEndedEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightTurnEndedEventData
     */
    'position_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFightTurnEndedEventData
     */
    'character_id': string;
    /**
     * 
     * @type {number}
     * @memberof WsFightTurnEndedEventData
     */
    'round': number;
    /**
     * 
     * @type {string}
     * @memberof WsFightTurnEndedEventData
     */
    'phase': string;
    /**
     * 
     * @type {boolean}
     * @memberof WsFightTurnEndedEventData
     */
    'automatic': boolean;
    /**
     * 
     * @type {number}
     * @memberof WsFightTurnEndedEventData
     */
    'ended_turn_count': number;
    /**
     * 
     * @type {number}
     * @memberof WsFightTurnEndedEventData
     */
    'participant_count': number;
    /**
     * 
     * @type {boolean}
     * @memberof WsFightTurnEndedEventData
     */
    'advanced': boolean;
    /**
     * 
     * @type {string}
     * @memberof WsFightTurnEndedEventData
     */
    'phase_ends_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WsFightTurnEndedEventData
     */
    'server_time'?: string | null;
}
/**
 * 
 * @export
 * @interface WsFullCharacterInfo
 */
export interface WsFullCharacterInfo {
    /**
     * 
     * @type {string}
     * @memberof WsFullCharacterInfo
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WsFullCharacterInfo
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof WsFullCharacterInfo
     */
    'rank_grade': number;
    /**
     * 
     * @type {Array<WsAttributeHolder>}
     * @memberof WsFullCharacterInfo
     */
    'attributes': Array<WsAttributeHolder>;
    /**
     * 
     * @type {number}
     * @memberof WsFullCharacterInfo
     */
    'dimension': number;
    /**
     * 
     * @type {string}
     * @memberof WsFullCharacterInfo
     */
    'position': string | null;
    /**
     * 
     * @type {WsCoordinate}
     * @memberof WsFullCharacterInfo
     */
    'coordinates': WsCoordinate | null;
    /**
     * 
     * @type {string}
     * @memberof WsFullCharacterInfo
     */
    'fight': string | null;
    /**
     * 
     * @type {string}
     * @memberof WsFullCharacterInfo
     */
    'screen'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WsFullCharacterInfo
     */
    'game_master_mode'?: boolean;
}
/**
 * Data for GameObject spawned event
 * @export
 * @interface WsGameObjectSpawnedEventData
 */
export interface WsGameObjectSpawnedEventData {
    /**
     * 
     * @type {string}
     * @memberof WsGameObjectSpawnedEventData
     */
    'game_object_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsGameObjectSpawnedEventData
     */
    'position_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsGameObjectSpawnedEventData
     */
    'tactical_position_id': string;
    /**
     * 
     * @type {number}
     * @memberof WsGameObjectSpawnedEventData
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof WsGameObjectSpawnedEventData
     */
    'y': number;
}
/**
 * Data for GameObject tactical position change events.  Fired whenever any GameObject (character, item, etc.) changes its tactical position taken from djangoPolymorphic
 * @export
 * @interface WsGameObjectTacticalPositionChangedData
 */
export interface WsGameObjectTacticalPositionChangedData {
    /**
     * 
     * @type {string}
     * @memberof WsGameObjectTacticalPositionChangedData
     */
    'game_object_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsGameObjectTacticalPositionChangedData
     */
    'game_object_type': string;
    /**
     * 
     * @type {string}
     * @memberof WsGameObjectTacticalPositionChangedData
     */
    'position_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WsGameObjectTacticalPositionChangedData
     */
    'tactical_map_id': string;
    /**
     * 
     * @type {number}
     * @memberof WsGameObjectTacticalPositionChangedData
     */
    'destination_x': number;
    /**
     * 
     * @type {number}
     * @memberof WsGameObjectTacticalPositionChangedData
     */
    'destination_y': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WsImpactType = {
    None: 'None',
    KnockOut: 'Knock out',
    Damage: 'Damage',
    Heal: 'Heal',
    Shield: 'Shield',
    Buff: 'Buff',
    Debuff: 'Debuff',
    Stun: 'Stun',
    Sleep: 'Sleep',
    Confusion: 'Confusion',
    Paralysis: 'Paralysis',
    Fear: 'Fear',
    Freeze: 'Freeze',
    Burn: 'Burn',
    Poison: 'Poison',
    Slow: 'Slow',
    Haste: 'Haste',
    Blind: 'Blind',
    Silence: 'Silence',
    Bleed: 'Bleed',
    Disarm: 'Disarm',
    Root: 'Root',
    EnergyDecrease: 'Energy Decrease',
    EnergyDrain: 'Energy Drain',
    EnergyGift: 'Energy Gift',
    StatDrain: 'Stat Drain',
    Reflect: 'Reflect',
    Absorb: 'Absorb',
    Dodge: 'Dodge',
    Resist: 'Resist',
    Immunity: 'Immunity',
    Regeneration: 'Regeneration',
    Lifesteal: 'Lifesteal',
    Summon: 'Summon'
} as const;

export type WsImpactType = typeof WsImpactType[keyof typeof WsImpactType];


/**
 * 
 * @export
 * @enum {string}
 */

export const WsImpactViolationType = {
    Physical: 'Physical',
    Mental: 'Mental',
    Energy: 'Energy',
    Heat: 'Heat',
    Cold: 'Cold',
    Light: 'Light',
    Darkness: 'Darkness',
    None: 'None'
} as const;

export type WsImpactViolationType = typeof WsImpactViolationType[keyof typeof WsImpactViolationType];


/**
 * 
 * @export
 * @interface WsJoinedFightEventData
 */
export interface WsJoinedFightEventData {
    /**
     * 
     * @type {string}
     * @memberof WsJoinedFightEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsJoinedFightEventData
     */
    'character_id': string;
}
/**
 * 
 * @export
 * @interface WsLeftFightEventData
 */
export interface WsLeftFightEventData {
    /**
     * 
     * @type {string}
     * @memberof WsLeftFightEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsLeftFightEventData
     */
    'character_id': string;
}
/**
 * 
 * @export
 * @interface WsPendingJoinFightEventData
 */
export interface WsPendingJoinFightEventData {
    /**
     * 
     * @type {string}
     * @memberof WsPendingJoinFightEventData
     */
    'fight_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsPendingJoinFightEventData
     */
    'character_id': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WsRollOutcome = {
    CriticalFail: 'Critical Fail',
    CriticalSuccess: 'Critical Success',
    BadLuck: 'Bad Luck',
    BaseValue: 'Base Value',
    GoodLuck: 'Good Luck'
} as const;

export type WsRollOutcome = typeof WsRollOutcome[keyof typeof WsRollOutcome];


/**
 * Data for screen mode change events.
 * @export
 * @interface WsScreenModeChangedEventData
 */
export interface WsScreenModeChangedEventData {
    /**
     * 
     * @type {string}
     * @memberof WsScreenModeChangedEventData
     */
    'character_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsScreenModeChangedEventData
     */
    'old_mode': string;
    /**
     * 
     * @type {string}
     * @memberof WsScreenModeChangedEventData
     */
    'new_mode': string;
    /**
     * 
     * @type {string}
     * @memberof WsScreenModeChangedEventData
     */
    'fight_id'?: string | null;
}
/**
 * 
 * @export
 * @interface WsTurnActionResultGameEventData
 */
export interface WsTurnActionResultGameEventData {
    /**
     * 
     * @type {string}
     * @memberof WsTurnActionResultGameEventData
     */
    'turn_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsTurnActionResultGameEventData
     */
    'initiator_id': string;
    /**
     * 
     * @type {string}
     * @memberof WsTurnActionResultGameEventData
     */
    'target_id': string;
    /**
     * 
     * @type {WsActionModel}
     * @memberof WsTurnActionResultGameEventData
     */
    'action': WsActionModel;
    /**
     * 
     * @type {WsActionImpactModel}
     * @memberof WsTurnActionResultGameEventData
     */
    'impact': WsActionImpactModel;
}

/**
 * ActionApi - axios parameter creator
 * @export
 */
export const ActionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Answer the player with the refusal, when there is one.  The pipeline logs a refused action and moves on — right for a queue drained on behalf of many actors, wrong for the one player waiting on this request, who was handed a 201 for an action the engine had already thrown away. The client duly reported success and the game did nothing, with the reason visible only in the server log. A ``GameException`` carries its own status code and a message written to be read, so raising it after the record has committed is the whole answer. Nothing was charged for it: acceptance refuses before it commits a resource.
         * @param {CharacterActionRequest} [characterActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionCreate: async (characterActionRequest?: CharacterActionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/action/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(characterActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionCurrentCycleRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/action/current_cycle/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GameMasterCharacterActionLogRequest} [gameMasterCharacterActionLogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmCreate: async (gameMasterCharacterActionLogRequest?: GameMasterCharacterActionLogRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/action/gm/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterCharacterActionLogRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character action.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('actionGmDestroy', 'id', id)
            const localVarPath = `/api/action/gm/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [fight] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmList: async (fight?: string, limit?: number, offset?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/action/gm/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fight !== undefined) {
                localVarQueryParameter['fight'] = fight;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character action.
         * @param {PatchedGameMasterCharacterActionLogRequest} [patchedGameMasterCharacterActionLogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmPartialUpdate: async (id: string, patchedGameMasterCharacterActionLogRequest?: PatchedGameMasterCharacterActionLogRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('actionGmPartialUpdate', 'id', id)
            const localVarPath = `/api/action/gm/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGameMasterCharacterActionLogRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GameMasterCharacterActionRequest} gameMasterCharacterActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmRegisterCharacterActionCreate: async (gameMasterCharacterActionRequest: GameMasterCharacterActionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameMasterCharacterActionRequest' is not null or undefined
            assertParamExists('actionGmRegisterCharacterActionCreate', 'gameMasterCharacterActionRequest', gameMasterCharacterActionRequest)
            const localVarPath = `/api/action/gm/register_character_action/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterCharacterActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterImpactActionRequest} registerImpactActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmRegisterImpactCreate: async (registerImpactActionRequest: RegisterImpactActionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerImpactActionRequest' is not null or undefined
            assertParamExists('actionGmRegisterImpactCreate', 'registerImpactActionRequest', registerImpactActionRequest)
            const localVarPath = `/api/action/gm/register_impact/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerImpactActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character action.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('actionGmRetrieve', 'id', id)
            const localVarPath = `/api/action/gm/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character action.
         * @param {GameMasterCharacterActionLogRequest} [gameMasterCharacterActionLogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmUpdate: async (id: string, gameMasterCharacterActionLogRequest?: GameMasterCharacterActionLogRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('actionGmUpdate', 'id', id)
            const localVarPath = `/api/action/gm/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterCharacterActionLogRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionLogList: async (limit?: number, offset?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/action/log/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionNextCycleCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/action/next_cycle/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Roll dice endpoint that creates a dice roll action, executes it immediately, and returns the dice outcome result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionRollD20DiceCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/action/roll_d20_dice/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionScheduledActionsRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/action/scheduled_actions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionSpecialAvailableRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/action/special/available/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionSpecialList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/action/special/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {SpecialActionActionTypeEnum} actionType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionSpecialRetrieve: async (actionType: SpecialActionActionTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionType' is not null or undefined
            assertParamExists('actionSpecialRetrieve', 'actionType', actionType)
            const localVarPath = `/api/action/special/{action_type}/`
                .replace(`{${"action_type"}}`, encodeURIComponent(String(actionType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActionApi - functional programming interface
 * @export
 */
export const ActionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActionApiAxiosParamCreator(configuration)
    return {
        /**
         * Answer the player with the refusal, when there is one.  The pipeline logs a refused action and moves on — right for a queue drained on behalf of many actors, wrong for the one player waiting on this request, who was handed a 201 for an action the engine had already thrown away. The client duly reported success and the game did nothing, with the reason visible only in the server log. A ``GameException`` carries its own status code and a message written to be read, so raising it after the record has committed is the whole answer. Nothing was charged for it: acceptance refuses before it commits a resource.
         * @param {CharacterActionRequest} [characterActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionCreate(characterActionRequest?: CharacterActionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionCreate(characterActionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionCurrentCycleRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameCycle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionCurrentCycleRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionCurrentCycleRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GameMasterCharacterActionLogRequest} [gameMasterCharacterActionLogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionGmCreate(gameMasterCharacterActionLogRequest?: GameMasterCharacterActionLogRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterCharacterActionLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionGmCreate(gameMasterCharacterActionLogRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionGmCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character action.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionGmDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionGmDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionGmDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [fight] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionGmList(fight?: string, limit?: number, offset?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedGameMasterCharacterActionLogList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionGmList(fight, limit, offset, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionGmList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character action.
         * @param {PatchedGameMasterCharacterActionLogRequest} [patchedGameMasterCharacterActionLogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionGmPartialUpdate(id: string, patchedGameMasterCharacterActionLogRequest?: PatchedGameMasterCharacterActionLogRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterCharacterActionLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionGmPartialUpdate(id, patchedGameMasterCharacterActionLogRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionGmPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GameMasterCharacterActionRequest} gameMasterCharacterActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionGmRegisterCharacterActionCreate(gameMasterCharacterActionRequest: GameMasterCharacterActionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterCharacterAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionGmRegisterCharacterActionCreate(gameMasterCharacterActionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionGmRegisterCharacterActionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegisterImpactActionRequest} registerImpactActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionGmRegisterImpactCreate(registerImpactActionRequest: RegisterImpactActionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterImpactAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionGmRegisterImpactCreate(registerImpactActionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionGmRegisterImpactCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character action.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionGmRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterCharacterActionLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionGmRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionGmRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character action.
         * @param {GameMasterCharacterActionLogRequest} [gameMasterCharacterActionLogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionGmUpdate(id: string, gameMasterCharacterActionLogRequest?: GameMasterCharacterActionLogRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterCharacterActionLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionGmUpdate(id, gameMasterCharacterActionLogRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionGmUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionLogList(limit?: number, offset?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCharacterActionLogList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionLogList(limit, offset, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionLogList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionNextCycleCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameCycle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionNextCycleCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionNextCycleCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Roll dice endpoint that creates a dice roll action, executes it immediately, and returns the dice outcome result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionRollD20DiceCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiceRollResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionRollD20DiceCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionRollD20DiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionScheduledActionsRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionScheduledActionsRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionScheduledActionsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionSpecialAvailableRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecialAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionSpecialAvailableRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionSpecialAvailableRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionSpecialList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SpecialAction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionSpecialList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionSpecialList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {SpecialActionActionTypeEnum} actionType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionSpecialRetrieve(actionType: SpecialActionActionTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecialAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionSpecialRetrieve(actionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionApi.actionSpecialRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActionApi - factory interface
 * @export
 */
export const ActionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActionApiFp(configuration)
    return {
        /**
         * Answer the player with the refusal, when there is one.  The pipeline logs a refused action and moves on — right for a queue drained on behalf of many actors, wrong for the one player waiting on this request, who was handed a 201 for an action the engine had already thrown away. The client duly reported success and the game did nothing, with the reason visible only in the server log. A ``GameException`` carries its own status code and a message written to be read, so raising it after the record has committed is the whole answer. Nothing was charged for it: acceptance refuses before it commits a resource.
         * @param {CharacterActionRequest} [characterActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionCreate(characterActionRequest?: CharacterActionRequest, options?: any): AxiosPromise<CharacterAction> {
            return localVarFp.actionCreate(characterActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionCurrentCycleRetrieve(options?: any): AxiosPromise<GameCycle> {
            return localVarFp.actionCurrentCycleRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GameMasterCharacterActionLogRequest} [gameMasterCharacterActionLogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmCreate(gameMasterCharacterActionLogRequest?: GameMasterCharacterActionLogRequest, options?: any): AxiosPromise<GameMasterCharacterActionLog> {
            return localVarFp.actionGmCreate(gameMasterCharacterActionLogRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character action.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.actionGmDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [fight] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmList(fight?: string, limit?: number, offset?: number, search?: string, options?: any): AxiosPromise<PaginatedGameMasterCharacterActionLogList> {
            return localVarFp.actionGmList(fight, limit, offset, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character action.
         * @param {PatchedGameMasterCharacterActionLogRequest} [patchedGameMasterCharacterActionLogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmPartialUpdate(id: string, patchedGameMasterCharacterActionLogRequest?: PatchedGameMasterCharacterActionLogRequest, options?: any): AxiosPromise<GameMasterCharacterActionLog> {
            return localVarFp.actionGmPartialUpdate(id, patchedGameMasterCharacterActionLogRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GameMasterCharacterActionRequest} gameMasterCharacterActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmRegisterCharacterActionCreate(gameMasterCharacterActionRequest: GameMasterCharacterActionRequest, options?: any): AxiosPromise<GameMasterCharacterAction> {
            return localVarFp.actionGmRegisterCharacterActionCreate(gameMasterCharacterActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterImpactActionRequest} registerImpactActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmRegisterImpactCreate(registerImpactActionRequest: RegisterImpactActionRequest, options?: any): AxiosPromise<RegisterImpactAction> {
            return localVarFp.actionGmRegisterImpactCreate(registerImpactActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character action.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmRetrieve(id: string, options?: any): AxiosPromise<GameMasterCharacterActionLog> {
            return localVarFp.actionGmRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character action.
         * @param {GameMasterCharacterActionLogRequest} [gameMasterCharacterActionLogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionGmUpdate(id: string, gameMasterCharacterActionLogRequest?: GameMasterCharacterActionLogRequest, options?: any): AxiosPromise<GameMasterCharacterActionLog> {
            return localVarFp.actionGmUpdate(id, gameMasterCharacterActionLogRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionLogList(limit?: number, offset?: number, search?: string, options?: any): AxiosPromise<PaginatedCharacterActionLogList> {
            return localVarFp.actionLogList(limit, offset, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionNextCycleCreate(options?: any): AxiosPromise<GameCycle> {
            return localVarFp.actionNextCycleCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * Roll dice endpoint that creates a dice roll action, executes it immediately, and returns the dice outcome result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionRollD20DiceCreate(options?: any): AxiosPromise<DiceRollResponse> {
            return localVarFp.actionRollD20DiceCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionScheduledActionsRetrieve(options?: any): AxiosPromise<CharacterAction> {
            return localVarFp.actionScheduledActionsRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionSpecialAvailableRetrieve(options?: any): AxiosPromise<SpecialAction> {
            return localVarFp.actionSpecialAvailableRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionSpecialList(options?: any): AxiosPromise<Array<SpecialAction>> {
            return localVarFp.actionSpecialList(options).then((request) => request(axios, basePath));
        },
        /**
         * Simple mixin that filters queryset by user\'s campaign
         * @param {SpecialActionActionTypeEnum} actionType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionSpecialRetrieve(actionType: SpecialActionActionTypeEnum, options?: any): AxiosPromise<SpecialAction> {
            return localVarFp.actionSpecialRetrieve(actionType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActionApi - object-oriented interface
 * @export
 * @class ActionApi
 * @extends {BaseAPI}
 */
export class ActionApi extends BaseAPI {
    /**
     * Answer the player with the refusal, when there is one.  The pipeline logs a refused action and moves on — right for a queue drained on behalf of many actors, wrong for the one player waiting on this request, who was handed a 201 for an action the engine had already thrown away. The client duly reported success and the game did nothing, with the reason visible only in the server log. A ``GameException`` carries its own status code and a message written to be read, so raising it after the record has committed is the whole answer. Nothing was charged for it: acceptance refuses before it commits a resource.
     * @param {CharacterActionRequest} [characterActionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionCreate(characterActionRequest?: CharacterActionRequest, options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionCreate(characterActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Simple mixin that filters queryset by user\'s campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionCurrentCycleRetrieve(options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionCurrentCycleRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GameMasterCharacterActionLogRequest} [gameMasterCharacterActionLogRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionGmCreate(gameMasterCharacterActionLogRequest?: GameMasterCharacterActionLogRequest, options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionGmCreate(gameMasterCharacterActionLogRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character action.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionGmDestroy(id: string, options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionGmDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [fight] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionGmList(fight?: string, limit?: number, offset?: number, search?: string, options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionGmList(fight, limit, offset, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character action.
     * @param {PatchedGameMasterCharacterActionLogRequest} [patchedGameMasterCharacterActionLogRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionGmPartialUpdate(id: string, patchedGameMasterCharacterActionLogRequest?: PatchedGameMasterCharacterActionLogRequest, options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionGmPartialUpdate(id, patchedGameMasterCharacterActionLogRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GameMasterCharacterActionRequest} gameMasterCharacterActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionGmRegisterCharacterActionCreate(gameMasterCharacterActionRequest: GameMasterCharacterActionRequest, options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionGmRegisterCharacterActionCreate(gameMasterCharacterActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterImpactActionRequest} registerImpactActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionGmRegisterImpactCreate(registerImpactActionRequest: RegisterImpactActionRequest, options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionGmRegisterImpactCreate(registerImpactActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character action.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionGmRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionGmRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character action.
     * @param {GameMasterCharacterActionLogRequest} [gameMasterCharacterActionLogRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionGmUpdate(id: string, gameMasterCharacterActionLogRequest?: GameMasterCharacterActionLogRequest, options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionGmUpdate(id, gameMasterCharacterActionLogRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Simple mixin that filters queryset by user\'s campaign
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionLogList(limit?: number, offset?: number, search?: string, options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionLogList(limit, offset, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Simple mixin that filters queryset by user\'s campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionNextCycleCreate(options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionNextCycleCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Roll dice endpoint that creates a dice roll action, executes it immediately, and returns the dice outcome result.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionRollD20DiceCreate(options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionRollD20DiceCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Simple mixin that filters queryset by user\'s campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionScheduledActionsRetrieve(options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionScheduledActionsRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Simple mixin that filters queryset by user\'s campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionSpecialAvailableRetrieve(options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionSpecialAvailableRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Simple mixin that filters queryset by user\'s campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionSpecialList(options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionSpecialList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Simple mixin that filters queryset by user\'s campaign
     * @param {SpecialActionActionTypeEnum} actionType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionApi
     */
    public actionSpecialRetrieve(actionType: SpecialActionActionTypeEnum, options?: RawAxiosRequestConfig) {
        return ActionApiFp(this.configuration).actionSpecialRetrieve(actionType, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdaptersApi - axios parameter creator
 * @export
 */
export const AdaptersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ConnectRequest} connectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adaptersCentrifugoConnectCreate: async (connectRequest: ConnectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectRequest' is not null or undefined
            assertParamExists('adaptersCentrifugoConnectCreate', 'connectRequest', connectRequest)
            const localVarPath = `/api/adapters/centrifugo/connect/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GameEventRequest} gameEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adaptersCentrifugoPublishCreate: async (gameEventRequest: GameEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameEventRequest' is not null or undefined
            assertParamExists('adaptersCentrifugoPublishCreate', 'gameEventRequest', gameEventRequest)
            const localVarPath = `/api/adapters/centrifugo/publish/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubscribeRequest} subscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adaptersCentrifugoSubscribeCreate: async (subscribeRequest: SubscribeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscribeRequest' is not null or undefined
            assertParamExists('adaptersCentrifugoSubscribeCreate', 'subscribeRequest', subscribeRequest)
            const localVarPath = `/api/adapters/centrifugo/subscribe/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdaptersApi - functional programming interface
 * @export
 */
export const AdaptersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdaptersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ConnectRequest} connectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adaptersCentrifugoConnectCreate(connectRequest: ConnectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adaptersCentrifugoConnectCreate(connectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdaptersApi.adaptersCentrifugoConnectCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GameEventRequest} gameEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adaptersCentrifugoPublishCreate(gameEventRequest: GameEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adaptersCentrifugoPublishCreate(gameEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdaptersApi.adaptersCentrifugoPublishCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SubscribeRequest} subscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adaptersCentrifugoSubscribeCreate(subscribeRequest: SubscribeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adaptersCentrifugoSubscribeCreate(subscribeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdaptersApi.adaptersCentrifugoSubscribeCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdaptersApi - factory interface
 * @export
 */
export const AdaptersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdaptersApiFp(configuration)
    return {
        /**
         * 
         * @param {ConnectRequest} connectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adaptersCentrifugoConnectCreate(connectRequest: ConnectRequest, options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.adaptersCentrifugoConnectCreate(connectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GameEventRequest} gameEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adaptersCentrifugoPublishCreate(gameEventRequest: GameEventRequest, options?: any): AxiosPromise<void> {
            return localVarFp.adaptersCentrifugoPublishCreate(gameEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscribeRequest} subscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adaptersCentrifugoSubscribeCreate(subscribeRequest: SubscribeRequest, options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.adaptersCentrifugoSubscribeCreate(subscribeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdaptersApi - object-oriented interface
 * @export
 * @class AdaptersApi
 * @extends {BaseAPI}
 */
export class AdaptersApi extends BaseAPI {
    /**
     * 
     * @param {ConnectRequest} connectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdaptersApi
     */
    public adaptersCentrifugoConnectCreate(connectRequest: ConnectRequest, options?: RawAxiosRequestConfig) {
        return AdaptersApiFp(this.configuration).adaptersCentrifugoConnectCreate(connectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GameEventRequest} gameEventRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdaptersApi
     */
    public adaptersCentrifugoPublishCreate(gameEventRequest: GameEventRequest, options?: RawAxiosRequestConfig) {
        return AdaptersApiFp(this.configuration).adaptersCentrifugoPublishCreate(gameEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscribeRequest} subscribeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdaptersApi
     */
    public adaptersCentrifugoSubscribeCreate(subscribeRequest: SubscribeRequest, options?: RawAxiosRequestConfig) {
        return AdaptersApiFp(this.configuration).adaptersCentrifugoSubscribeCreate(subscribeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
         * @param {CustomTokenObtainPairRequest} customTokenObtainPairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authJwtTokenCreate: async (customTokenObtainPairRequest: CustomTokenObtainPairRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customTokenObtainPairRequest' is not null or undefined
            assertParamExists('authJwtTokenCreate', 'customTokenObtainPairRequest', customTokenObtainPairRequest)
            const localVarPath = `/auth/jwt/token/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customTokenObtainPairRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authJwtTokenRefreshCreate: async (tokenRefreshRequest: TokenRefreshRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenRefreshRequest' is not null or undefined
            assertParamExists('authJwtTokenRefreshCreate', 'tokenRefreshRequest', tokenRefreshRequest)
            const localVarPath = `/auth/jwt/token/refresh/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRefreshRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
         * @param {TokenVerifyRequest} tokenVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authJwtTokenVerifyCreate: async (tokenVerifyRequest: TokenVerifyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenVerifyRequest' is not null or undefined
            assertParamExists('authJwtTokenVerifyCreate', 'tokenVerifyRequest', tokenVerifyRequest)
            const localVarPath = `/auth/jwt/token/verify/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenVerifyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
         * @param {CustomTokenObtainPairRequest} customTokenObtainPairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authJwtTokenCreate(customTokenObtainPairRequest: CustomTokenObtainPairRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authJwtTokenCreate(customTokenObtainPairRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authJwtTokenCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authJwtTokenRefreshCreate(tokenRefreshRequest: TokenRefreshRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenRefresh>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authJwtTokenRefreshCreate(tokenRefreshRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authJwtTokenRefreshCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
         * @param {TokenVerifyRequest} tokenVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authJwtTokenVerifyCreate(tokenVerifyRequest: TokenVerifyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authJwtTokenVerifyCreate(tokenVerifyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authJwtTokenVerifyCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
         * @param {CustomTokenObtainPairRequest} customTokenObtainPairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authJwtTokenCreate(customTokenObtainPairRequest: CustomTokenObtainPairRequest, options?: any): AxiosPromise<void> {
            return localVarFp.authJwtTokenCreate(customTokenObtainPairRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authJwtTokenRefreshCreate(tokenRefreshRequest: TokenRefreshRequest, options?: any): AxiosPromise<TokenRefresh> {
            return localVarFp.authJwtTokenRefreshCreate(tokenRefreshRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
         * @param {TokenVerifyRequest} tokenVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authJwtTokenVerifyCreate(tokenVerifyRequest: TokenVerifyRequest, options?: any): AxiosPromise<void> {
            return localVarFp.authJwtTokenVerifyCreate(tokenVerifyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     * @param {CustomTokenObtainPairRequest} customTokenObtainPairRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authJwtTokenCreate(customTokenObtainPairRequest: CustomTokenObtainPairRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authJwtTokenCreate(customTokenObtainPairRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     * @param {TokenRefreshRequest} tokenRefreshRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authJwtTokenRefreshCreate(tokenRefreshRequest: TokenRefreshRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authJwtTokenRefreshCreate(tokenRefreshRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
     * @param {TokenVerifyRequest} tokenVerifyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authJwtTokenVerifyCreate(tokenVerifyRequest: TokenVerifyRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authJwtTokenVerifyCreate(tokenVerifyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BargainApi - axios parameter creator
 * @export
 */
export const BargainApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id A UUID string identifying this bargain.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsAcceptCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bargainOpenBargainsAcceptCreate', 'id', id)
            const localVarPath = `/api/bargain/open_bargains/{id}/accept/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nested viewset for adding and removing items from a bargain
         * @param {string} bargainPk 
         * @param {OfferedItemRequest} offeredItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsItemsCreate: async (bargainPk: string, offeredItemRequest: OfferedItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bargainPk' is not null or undefined
            assertParamExists('bargainOpenBargainsItemsCreate', 'bargainPk', bargainPk)
            // verify required parameter 'offeredItemRequest' is not null or undefined
            assertParamExists('bargainOpenBargainsItemsCreate', 'offeredItemRequest', offeredItemRequest)
            const localVarPath = `/api/bargain/open_bargains/{bargain_pk}/items/`
                .replace(`{${"bargain_pk"}}`, encodeURIComponent(String(bargainPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offeredItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nested viewset for adding and removing items from a bargain
         * @param {string} bargainPk 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsItemsDestroy: async (bargainPk: string, itemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bargainPk' is not null or undefined
            assertParamExists('bargainOpenBargainsItemsDestroy', 'bargainPk', bargainPk)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('bargainOpenBargainsItemsDestroy', 'itemId', itemId)
            const localVarPath = `/api/bargain/open_bargains/{bargain_pk}/items/{item_id}/`
                .replace(`{${"bargain_pk"}}`, encodeURIComponent(String(bargainPk)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nested viewset for adding and removing items from a bargain
         * @param {string} bargainPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsItemsList: async (bargainPk: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bargainPk' is not null or undefined
            assertParamExists('bargainOpenBargainsItemsList', 'bargainPk', bargainPk)
            const localVarPath = `/api/bargain/open_bargains/{bargain_pk}/items/`
                .replace(`{${"bargain_pk"}}`, encodeURIComponent(String(bargainPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bargain/open_bargains/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this bargain.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsRejectCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bargainOpenBargainsRejectCreate', 'id', id)
            const localVarPath = `/api/bargain/open_bargains/{id}/reject/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this bargain.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bargainOpenBargainsRetrieve', 'id', id)
            const localVarPath = `/api/bargain/open_bargains/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BargainApi - functional programming interface
 * @export
 */
export const BargainApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BargainApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id A UUID string identifying this bargain.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bargainOpenBargainsAcceptCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Bargain>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bargainOpenBargainsAcceptCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BargainApi.bargainOpenBargainsAcceptCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nested viewset for adding and removing items from a bargain
         * @param {string} bargainPk 
         * @param {OfferedItemRequest} offeredItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bargainOpenBargainsItemsCreate(bargainPk: string, offeredItemRequest: OfferedItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferedItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bargainOpenBargainsItemsCreate(bargainPk, offeredItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BargainApi.bargainOpenBargainsItemsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nested viewset for adding and removing items from a bargain
         * @param {string} bargainPk 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bargainOpenBargainsItemsDestroy(bargainPk: string, itemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bargainOpenBargainsItemsDestroy(bargainPk, itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BargainApi.bargainOpenBargainsItemsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nested viewset for adding and removing items from a bargain
         * @param {string} bargainPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bargainOpenBargainsItemsList(bargainPk: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OfferedItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bargainOpenBargainsItemsList(bargainPk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BargainApi.bargainOpenBargainsItemsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bargainOpenBargainsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Bargain>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bargainOpenBargainsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BargainApi.bargainOpenBargainsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this bargain.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bargainOpenBargainsRejectCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Bargain>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bargainOpenBargainsRejectCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BargainApi.bargainOpenBargainsRejectCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this bargain.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bargainOpenBargainsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailedBargain>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bargainOpenBargainsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BargainApi.bargainOpenBargainsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BargainApi - factory interface
 * @export
 */
export const BargainApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BargainApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id A UUID string identifying this bargain.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsAcceptCreate(id: string, options?: any): AxiosPromise<Bargain> {
            return localVarFp.bargainOpenBargainsAcceptCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Nested viewset for adding and removing items from a bargain
         * @param {string} bargainPk 
         * @param {OfferedItemRequest} offeredItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsItemsCreate(bargainPk: string, offeredItemRequest: OfferedItemRequest, options?: any): AxiosPromise<OfferedItem> {
            return localVarFp.bargainOpenBargainsItemsCreate(bargainPk, offeredItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Nested viewset for adding and removing items from a bargain
         * @param {string} bargainPk 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsItemsDestroy(bargainPk: string, itemId: string, options?: any): AxiosPromise<void> {
            return localVarFp.bargainOpenBargainsItemsDestroy(bargainPk, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Nested viewset for adding and removing items from a bargain
         * @param {string} bargainPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsItemsList(bargainPk: string, options?: any): AxiosPromise<Array<OfferedItem>> {
            return localVarFp.bargainOpenBargainsItemsList(bargainPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsList(options?: any): AxiosPromise<Array<Bargain>> {
            return localVarFp.bargainOpenBargainsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this bargain.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsRejectCreate(id: string, options?: any): AxiosPromise<Bargain> {
            return localVarFp.bargainOpenBargainsRejectCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this bargain.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bargainOpenBargainsRetrieve(id: string, options?: any): AxiosPromise<DetailedBargain> {
            return localVarFp.bargainOpenBargainsRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BargainApi - object-oriented interface
 * @export
 * @class BargainApi
 * @extends {BaseAPI}
 */
export class BargainApi extends BaseAPI {
    /**
     * 
     * @param {string} id A UUID string identifying this bargain.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BargainApi
     */
    public bargainOpenBargainsAcceptCreate(id: string, options?: RawAxiosRequestConfig) {
        return BargainApiFp(this.configuration).bargainOpenBargainsAcceptCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nested viewset for adding and removing items from a bargain
     * @param {string} bargainPk 
     * @param {OfferedItemRequest} offeredItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BargainApi
     */
    public bargainOpenBargainsItemsCreate(bargainPk: string, offeredItemRequest: OfferedItemRequest, options?: RawAxiosRequestConfig) {
        return BargainApiFp(this.configuration).bargainOpenBargainsItemsCreate(bargainPk, offeredItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nested viewset for adding and removing items from a bargain
     * @param {string} bargainPk 
     * @param {string} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BargainApi
     */
    public bargainOpenBargainsItemsDestroy(bargainPk: string, itemId: string, options?: RawAxiosRequestConfig) {
        return BargainApiFp(this.configuration).bargainOpenBargainsItemsDestroy(bargainPk, itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nested viewset for adding and removing items from a bargain
     * @param {string} bargainPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BargainApi
     */
    public bargainOpenBargainsItemsList(bargainPk: string, options?: RawAxiosRequestConfig) {
        return BargainApiFp(this.configuration).bargainOpenBargainsItemsList(bargainPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BargainApi
     */
    public bargainOpenBargainsList(options?: RawAxiosRequestConfig) {
        return BargainApiFp(this.configuration).bargainOpenBargainsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this bargain.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BargainApi
     */
    public bargainOpenBargainsRejectCreate(id: string, options?: RawAxiosRequestConfig) {
        return BargainApiFp(this.configuration).bargainOpenBargainsRejectCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this bargain.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BargainApi
     */
    public bargainOpenBargainsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return BargainApiFp(this.configuration).bargainOpenBargainsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BooksApi - axios parameter creator
 * @export
 */
export const BooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Download a specific artifact file for a book.  URL: /api/books/books/{book_id}/artifacts/{artifact_id}/download/
         * @param {string} artifactId 
         * @param {string} id A UUID string identifying this Book.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        booksBooksArtifactsDownloadRetrieve: async (artifactId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artifactId' is not null or undefined
            assertParamExists('booksBooksArtifactsDownloadRetrieve', 'artifactId', artifactId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('booksBooksArtifactsDownloadRetrieve', 'id', id)
            const localVarPath = `/api/books/books/{id}/artifacts/{artifact_id}/download/`
                .replace(`{${"artifact_id"}}`, encodeURIComponent(String(artifactId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for publicly accessible books. Provides list and retrieve endpoints with downloadable artifacts.
         * @param {string} [i18nKey] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [publishedDate] 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        booksBooksList: async (i18nKey?: string, ordering?: string, publishedDate?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/books/books/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (i18nKey !== undefined) {
                localVarQueryParameter['i18n_key'] = i18nKey;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (publishedDate !== undefined) {
                localVarQueryParameter['published_date'] = (publishedDate as any instanceof Date) ?
                    (publishedDate as any).toISOString().substring(0,10) :
                    publishedDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for publicly accessible books. Provides list and retrieve endpoints with downloadable artifacts.
         * @param {string} id A UUID string identifying this Book.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        booksBooksRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('booksBooksRetrieve', 'id', id)
            const localVarPath = `/api/books/books/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BooksApi - functional programming interface
 * @export
 */
export const BooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BooksApiAxiosParamCreator(configuration)
    return {
        /**
         * Download a specific artifact file for a book.  URL: /api/books/books/{book_id}/artifacts/{artifact_id}/download/
         * @param {string} artifactId 
         * @param {string} id A UUID string identifying this Book.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async booksBooksArtifactsDownloadRetrieve(artifactId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.booksBooksArtifactsDownloadRetrieve(artifactId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BooksApi.booksBooksArtifactsDownloadRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for publicly accessible books. Provides list and retrieve endpoints with downloadable artifacts.
         * @param {string} [i18nKey] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [publishedDate] 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async booksBooksList(i18nKey?: string, ordering?: string, publishedDate?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.booksBooksList(i18nKey, ordering, publishedDate, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BooksApi.booksBooksList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for publicly accessible books. Provides list and retrieve endpoints with downloadable artifacts.
         * @param {string} id A UUID string identifying this Book.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async booksBooksRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.booksBooksRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BooksApi.booksBooksRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BooksApi - factory interface
 * @export
 */
export const BooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BooksApiFp(configuration)
    return {
        /**
         * Download a specific artifact file for a book.  URL: /api/books/books/{book_id}/artifacts/{artifact_id}/download/
         * @param {string} artifactId 
         * @param {string} id A UUID string identifying this Book.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        booksBooksArtifactsDownloadRetrieve(artifactId: string, id: string, options?: any): AxiosPromise<BookList> {
            return localVarFp.booksBooksArtifactsDownloadRetrieve(artifactId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for publicly accessible books. Provides list and retrieve endpoints with downloadable artifacts.
         * @param {string} [i18nKey] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [publishedDate] 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        booksBooksList(i18nKey?: string, ordering?: string, publishedDate?: string, search?: string, options?: any): AxiosPromise<Array<BookList>> {
            return localVarFp.booksBooksList(i18nKey, ordering, publishedDate, search, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for publicly accessible books. Provides list and retrieve endpoints with downloadable artifacts.
         * @param {string} id A UUID string identifying this Book.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        booksBooksRetrieve(id: string, options?: any): AxiosPromise<BookDetail> {
            return localVarFp.booksBooksRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BooksApi - object-oriented interface
 * @export
 * @class BooksApi
 * @extends {BaseAPI}
 */
export class BooksApi extends BaseAPI {
    /**
     * Download a specific artifact file for a book.  URL: /api/books/books/{book_id}/artifacts/{artifact_id}/download/
     * @param {string} artifactId 
     * @param {string} id A UUID string identifying this Book.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BooksApi
     */
    public booksBooksArtifactsDownloadRetrieve(artifactId: string, id: string, options?: RawAxiosRequestConfig) {
        return BooksApiFp(this.configuration).booksBooksArtifactsDownloadRetrieve(artifactId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for publicly accessible books. Provides list and retrieve endpoints with downloadable artifacts.
     * @param {string} [i18nKey] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [publishedDate] 
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BooksApi
     */
    public booksBooksList(i18nKey?: string, ordering?: string, publishedDate?: string, search?: string, options?: RawAxiosRequestConfig) {
        return BooksApiFp(this.configuration).booksBooksList(i18nKey, ordering, publishedDate, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for publicly accessible books. Provides list and retrieve endpoints with downloadable artifacts.
     * @param {string} id A UUID string identifying this Book.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BooksApi
     */
    public booksBooksRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return BooksApiFp(this.configuration).booksBooksRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CardgameApi - axios parameter creator
 * @export
 */
export const CardgameApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CardListRequest} cardListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameCardsGenerateCreate: async (cardListRequest: CardListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardListRequest' is not null or undefined
            assertParamExists('cardgameCardsGenerateCreate', 'cardListRequest', cardListRequest)
            const localVarPath = `/api/cardgame/cards/generate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CardTypeEnum} [cardType] * &#x60;spell&#x60; - spell * &#x60;implant&#x60; - implant * &#x60;hack&#x60; - hack * &#x60;artifact&#x60; - artifact * &#x60;creature&#x60; - creature * &#x60;hybrid&#x60; - hybrid
         * @param {FactionEnum} [faction] * &#x60;chosen_ones&#x60; - chosen_ones * &#x60;enhanced_machines&#x60; - enhanced_machines * &#x60;era_clan&#x60; - era_clan * &#x60;neutral&#x60; - neutral
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {RarityEnum} [rarity] * &#x60;common&#x60; - common * &#x60;uncommon&#x60; - uncommon * &#x60;rare&#x60; - rare * &#x60;epic&#x60; - epic * &#x60;legendary&#x60; - legendary
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameCardsList: async (cardType?: CardTypeEnum, faction?: FactionEnum, ordering?: string, rarity?: RarityEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cardgame/cards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cardType !== undefined) {
                localVarQueryParameter['card_type'] = cardType;
            }

            if (faction !== undefined) {
                localVarQueryParameter['faction'] = faction;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (rarity !== undefined) {
                localVarQueryParameter['rarity'] = rarity;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this card.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameCardsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameCardsRetrieve', 'id', id)
            const localVarPath = `/api/cardgame/cards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeckRequest} [deckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameDeckCreate: async (deckRequest?: DeckRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cardgame/deck/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deckRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameDeckDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameDeckDestroy', 'id', id)
            const localVarPath = `/api/cardgame/deck/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameDeckList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cardgame/deck/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PatchedDeckRequest} [patchedDeckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameDeckPartialUpdate: async (id: string, patchedDeckRequest?: PatchedDeckRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameDeckPartialUpdate', 'id', id)
            const localVarPath = `/api/cardgame/deck/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedDeckRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameDeckRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameDeckRetrieve', 'id', id)
            const localVarPath = `/api/cardgame/deck/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {DeckRequest} [deckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameDeckUpdate: async (id: string, deckRequest?: DeckRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameDeckUpdate', 'id', id)
            const localVarPath = `/api/cardgame/deck/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deckRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameLeaderboardList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cardgame/leaderboard/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchDrawCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameMatchDrawCreate', 'id', id)
            const localVarPath = `/api/cardgame/match/{id}/draw/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchEventCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameMatchEventCreate', 'id', id)
            const localVarPath = `/api/cardgame/match/{id}/event/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchFinishCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameMatchFinishCreate', 'id', id)
            const localVarPath = `/api/cardgame/match/{id}/finish/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cardgame/match/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchMulliganCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameMatchMulliganCreate', 'id', id)
            const localVarPath = `/api/cardgame/match/{id}/mulligan/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchPlaceCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameMatchPlaceCreate', 'id', id)
            const localVarPath = `/api/cardgame/match/{id}/place/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameMatchRetrieve', 'id', id)
            const localVarPath = `/api/cardgame/match/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchRollCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameMatchRollCreate', 'id', id)
            const localVarPath = `/api/cardgame/match/{id}/roll/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchSelectCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameMatchSelectCreate', 'id', id)
            const localVarPath = `/api/cardgame/match/{id}/select/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchStartCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameMatchStartCreate', 'id', id)
            const localVarPath = `/api/cardgame/match/{id}/start/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchStateRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameMatchStateRetrieve', 'id', id)
            const localVarPath = `/api/cardgame/match/{id}/state/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchStealCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardgameMatchStealCreate', 'id', id)
            const localVarPath = `/api/cardgame/match/{id}/steal/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchmakingCancelCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cardgame/matchmaking/cancel/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchmakingQueueCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cardgame/matchmaking/queue/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchmakingRatingRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cardgame/matchmaking/rating/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchmakingStatusCheckRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cardgame/matchmaking/status_check/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardgameApi - functional programming interface
 * @export
 */
export const CardgameApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CardgameApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CardListRequest} cardListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameCardsGenerateCreate(cardListRequest: CardListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameCardsGenerateCreate(cardListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameCardsGenerateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CardTypeEnum} [cardType] * &#x60;spell&#x60; - spell * &#x60;implant&#x60; - implant * &#x60;hack&#x60; - hack * &#x60;artifact&#x60; - artifact * &#x60;creature&#x60; - creature * &#x60;hybrid&#x60; - hybrid
         * @param {FactionEnum} [faction] * &#x60;chosen_ones&#x60; - chosen_ones * &#x60;enhanced_machines&#x60; - enhanced_machines * &#x60;era_clan&#x60; - era_clan * &#x60;neutral&#x60; - neutral
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {RarityEnum} [rarity] * &#x60;common&#x60; - common * &#x60;uncommon&#x60; - uncommon * &#x60;rare&#x60; - rare * &#x60;epic&#x60; - epic * &#x60;legendary&#x60; - legendary
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameCardsList(cardType?: CardTypeEnum, faction?: FactionEnum, ordering?: string, rarity?: RarityEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CardList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameCardsList(cardType, faction, ordering, rarity, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameCardsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this card.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameCardsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameCardsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameCardsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeckRequest} [deckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameDeckCreate(deckRequest?: DeckRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Deck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameDeckCreate(deckRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameDeckCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameDeckDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameDeckDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameDeckDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameDeckList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Deck>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameDeckList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameDeckList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {PatchedDeckRequest} [patchedDeckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameDeckPartialUpdate(id: string, patchedDeckRequest?: PatchedDeckRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Deck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameDeckPartialUpdate(id, patchedDeckRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameDeckPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameDeckRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Deck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameDeckRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameDeckRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {DeckRequest} [deckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameDeckUpdate(id: string, deckRequest?: DeckRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Deck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameDeckUpdate(id, deckRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameDeckUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameLeaderboardList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Leaderboard>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameLeaderboardList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameLeaderboardList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchDrawCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Match>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchDrawCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchDrawCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchEventCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Match>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchEventCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchEventCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchFinishCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Match>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchFinishCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchFinishCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Match>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchMulliganCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Match>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchMulliganCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchMulliganCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchPlaceCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Match>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchPlaceCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchPlaceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Match>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchRollCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Match>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchRollCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchRollCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchSelectCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Match>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchSelectCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchSelectCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchStartCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Match>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchStartCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchStartCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchStateRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Match>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchStateRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchStateRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchStealCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Match>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchStealCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchStealCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchmakingCancelCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchmakingEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchmakingCancelCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchmakingCancelCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchmakingQueueCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchmakingEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchmakingQueueCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchmakingQueueCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchmakingRatingRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchmakingEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchmakingRatingRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchmakingRatingRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardgameMatchmakingStatusCheckRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchmakingEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardgameMatchmakingStatusCheckRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardgameApi.cardgameMatchmakingStatusCheckRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CardgameApi - factory interface
 * @export
 */
export const CardgameApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CardgameApiFp(configuration)
    return {
        /**
         * 
         * @param {CardListRequest} cardListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameCardsGenerateCreate(cardListRequest: CardListRequest, options?: any): AxiosPromise<CardList> {
            return localVarFp.cardgameCardsGenerateCreate(cardListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CardTypeEnum} [cardType] * &#x60;spell&#x60; - spell * &#x60;implant&#x60; - implant * &#x60;hack&#x60; - hack * &#x60;artifact&#x60; - artifact * &#x60;creature&#x60; - creature * &#x60;hybrid&#x60; - hybrid
         * @param {FactionEnum} [faction] * &#x60;chosen_ones&#x60; - chosen_ones * &#x60;enhanced_machines&#x60; - enhanced_machines * &#x60;era_clan&#x60; - era_clan * &#x60;neutral&#x60; - neutral
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {RarityEnum} [rarity] * &#x60;common&#x60; - common * &#x60;uncommon&#x60; - uncommon * &#x60;rare&#x60; - rare * &#x60;epic&#x60; - epic * &#x60;legendary&#x60; - legendary
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameCardsList(cardType?: CardTypeEnum, faction?: FactionEnum, ordering?: string, rarity?: RarityEnum, search?: string, options?: any): AxiosPromise<Array<CardList>> {
            return localVarFp.cardgameCardsList(cardType, faction, ordering, rarity, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this card.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameCardsRetrieve(id: string, options?: any): AxiosPromise<CardDetail> {
            return localVarFp.cardgameCardsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeckRequest} [deckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameDeckCreate(deckRequest?: DeckRequest, options?: any): AxiosPromise<Deck> {
            return localVarFp.cardgameDeckCreate(deckRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameDeckDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.cardgameDeckDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameDeckList(options?: any): AxiosPromise<Array<Deck>> {
            return localVarFp.cardgameDeckList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PatchedDeckRequest} [patchedDeckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameDeckPartialUpdate(id: string, patchedDeckRequest?: PatchedDeckRequest, options?: any): AxiosPromise<Deck> {
            return localVarFp.cardgameDeckPartialUpdate(id, patchedDeckRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameDeckRetrieve(id: string, options?: any): AxiosPromise<Deck> {
            return localVarFp.cardgameDeckRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {DeckRequest} [deckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameDeckUpdate(id: string, deckRequest?: DeckRequest, options?: any): AxiosPromise<Deck> {
            return localVarFp.cardgameDeckUpdate(id, deckRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameLeaderboardList(options?: any): AxiosPromise<Array<Leaderboard>> {
            return localVarFp.cardgameLeaderboardList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchDrawCreate(id: string, options?: any): AxiosPromise<Match> {
            return localVarFp.cardgameMatchDrawCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchEventCreate(id: string, options?: any): AxiosPromise<Match> {
            return localVarFp.cardgameMatchEventCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchFinishCreate(id: string, options?: any): AxiosPromise<Match> {
            return localVarFp.cardgameMatchFinishCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchList(options?: any): AxiosPromise<Array<Match>> {
            return localVarFp.cardgameMatchList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchMulliganCreate(id: string, options?: any): AxiosPromise<Match> {
            return localVarFp.cardgameMatchMulliganCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchPlaceCreate(id: string, options?: any): AxiosPromise<Match> {
            return localVarFp.cardgameMatchPlaceCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchRetrieve(id: string, options?: any): AxiosPromise<Match> {
            return localVarFp.cardgameMatchRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchRollCreate(id: string, options?: any): AxiosPromise<Match> {
            return localVarFp.cardgameMatchRollCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchSelectCreate(id: string, options?: any): AxiosPromise<Match> {
            return localVarFp.cardgameMatchSelectCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchStartCreate(id: string, options?: any): AxiosPromise<Match> {
            return localVarFp.cardgameMatchStartCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchStateRetrieve(id: string, options?: any): AxiosPromise<Match> {
            return localVarFp.cardgameMatchStateRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchStealCreate(id: string, options?: any): AxiosPromise<Match> {
            return localVarFp.cardgameMatchStealCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchmakingCancelCreate(options?: any): AxiosPromise<MatchmakingEntry> {
            return localVarFp.cardgameMatchmakingCancelCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchmakingQueueCreate(options?: any): AxiosPromise<MatchmakingEntry> {
            return localVarFp.cardgameMatchmakingQueueCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchmakingRatingRetrieve(options?: any): AxiosPromise<MatchmakingEntry> {
            return localVarFp.cardgameMatchmakingRatingRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardgameMatchmakingStatusCheckRetrieve(options?: any): AxiosPromise<MatchmakingEntry> {
            return localVarFp.cardgameMatchmakingStatusCheckRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CardgameApi - object-oriented interface
 * @export
 * @class CardgameApi
 * @extends {BaseAPI}
 */
export class CardgameApi extends BaseAPI {
    /**
     * 
     * @param {CardListRequest} cardListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameCardsGenerateCreate(cardListRequest: CardListRequest, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameCardsGenerateCreate(cardListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CardTypeEnum} [cardType] * &#x60;spell&#x60; - spell * &#x60;implant&#x60; - implant * &#x60;hack&#x60; - hack * &#x60;artifact&#x60; - artifact * &#x60;creature&#x60; - creature * &#x60;hybrid&#x60; - hybrid
     * @param {FactionEnum} [faction] * &#x60;chosen_ones&#x60; - chosen_ones * &#x60;enhanced_machines&#x60; - enhanced_machines * &#x60;era_clan&#x60; - era_clan * &#x60;neutral&#x60; - neutral
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {RarityEnum} [rarity] * &#x60;common&#x60; - common * &#x60;uncommon&#x60; - uncommon * &#x60;rare&#x60; - rare * &#x60;epic&#x60; - epic * &#x60;legendary&#x60; - legendary
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameCardsList(cardType?: CardTypeEnum, faction?: FactionEnum, ordering?: string, rarity?: RarityEnum, search?: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameCardsList(cardType, faction, ordering, rarity, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this card.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameCardsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameCardsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeckRequest} [deckRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameDeckCreate(deckRequest?: DeckRequest, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameDeckCreate(deckRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameDeckDestroy(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameDeckDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameDeckList(options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameDeckList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {PatchedDeckRequest} [patchedDeckRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameDeckPartialUpdate(id: string, patchedDeckRequest?: PatchedDeckRequest, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameDeckPartialUpdate(id, patchedDeckRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameDeckRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameDeckRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {DeckRequest} [deckRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameDeckUpdate(id: string, deckRequest?: DeckRequest, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameDeckUpdate(id, deckRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameLeaderboardList(options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameLeaderboardList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchDrawCreate(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchDrawCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchEventCreate(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchEventCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchFinishCreate(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchFinishCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchList(options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchMulliganCreate(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchMulliganCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchPlaceCreate(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchPlaceCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchRollCreate(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchRollCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchSelectCreate(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchSelectCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchStartCreate(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchStartCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchStateRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchStateRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchStealCreate(id: string, options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchStealCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchmakingCancelCreate(options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchmakingCancelCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchmakingQueueCreate(options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchmakingQueueCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchmakingRatingRetrieve(options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchmakingRatingRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardgameApi
     */
    public cardgameMatchmakingStatusCheckRetrieve(options?: RawAxiosRequestConfig) {
        return CardgameApiFp(this.configuration).cardgameMatchmakingStatusCheckRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CharacterApi - axios parameter creator
 * @export
 */
export const CharacterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id A UUID string identifying this character avatar preset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterAvatarPresetsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterAvatarPresetsRetrieve', 'id', id)
            const localVarPath = `/api/character/avatar-presets/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The owner\'s private, live in-game biography. Never touches public data.
         * @param {string} characterId 
         * @param {PatchedCharacterBiographyDetailRequest} [patchedCharacterBiographyDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterBiographyPartialUpdate: async (characterId: string, patchedCharacterBiographyDetailRequest?: PatchedCharacterBiographyDetailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'characterId' is not null or undefined
            assertParamExists('characterBiographyPartialUpdate', 'characterId', characterId)
            const localVarPath = `/api/character/biography/{character_id}/`
                .replace(`{${"character_id"}}`, encodeURIComponent(String(characterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCharacterBiographyDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The owner\'s private, live in-game biography. Never touches public data.
         * @param {string} characterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterBiographyRetrieve: async (characterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'characterId' is not null or undefined
            assertParamExists('characterBiographyRetrieve', 'characterId', characterId)
            const localVarPath = `/api/character/biography/{character_id}/`
                .replace(`{${"character_id"}}`, encodeURIComponent(String(characterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterGmCharacterInfoRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterGmCharacterInfoRetrieve', 'id', id)
            const localVarPath = `/api/character/gm/{id}/character_info/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Character info for every character matching the filters, in one read. Gives a client the state it would otherwise only learn from the next `character_changed` event.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterGmCharacterInfosList: async (npc?: boolean, position?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/gm/character_infos/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (npc !== undefined) {
                localVarQueryParameter['npc'] = npc;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterGmList: async (npc?: boolean, position?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/gm/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (npc !== undefined) {
                localVarQueryParameter['npc'] = npc;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterGmRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterGmRetrieve', 'id', id)
            const localVarPath = `/api/character/gm/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the user\'s current main character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedCurrentCharacterRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/owned/current_character/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Active effects on one owned character.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedEffectsList: async (id: string, npc?: boolean, position?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterOwnedEffectsList', 'id', id)
            const localVarPath = `/api/character/owned/{id}/effects/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (npc !== undefined) {
                localVarQueryParameter['npc'] = npc;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The inventory of one owned character.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedItemsList: async (id: string, npc?: boolean, position?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterOwnedItemsList', 'id', id)
            const localVarPath = `/api/character/owned/{id}/items/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (npc !== undefined) {
                localVarQueryParameter['npc'] = npc;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for managing characters in the client application. Provides read-only access to character data.  1. **get_queryset**: Returns the queryset of characters for the authenticated user. 2. **we se all active and non active characters**: Filters characters based on the user\'s main character\'s position and campaign. 3. **no npc characters are allowed**: Ensures that only characters related to the user\'s main character\'s campaign are returned. 4. **select character** allows client to choose a character to play with.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedList: async (npc?: boolean, position?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/owned/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (npc !== undefined) {
                localVarQueryParameter['npc'] = npc;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for managing characters in the client application. Provides read-only access to character data.  1. **get_queryset**: Returns the queryset of characters for the authenticated user. 2. **we se all active and non active characters**: Filters characters based on the user\'s main character\'s position and campaign. 3. **no npc characters are allowed**: Ensures that only characters related to the user\'s main character\'s campaign are returned. 4. **select character** allows client to choose a character to play with.
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterOwnedRetrieve', 'id', id)
            const localVarPath = `/api/character/owned/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Schools this character has learned, base ones included.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedSchoolsList: async (id: string, npc?: boolean, position?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterOwnedSchoolsList', 'id', id)
            const localVarPath = `/api/character/owned/{id}/schools/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (npc !== undefined) {
                localVarQueryParameter['npc'] = npc;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Select a character as the user\'s main character.
         * @param {string} id A UUID string identifying this character.
         * @param {OpenaiCharacterRequest} openaiCharacterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedSelectCharacterCreate: async (id: string, openaiCharacterRequest: OpenaiCharacterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterOwnedSelectCharacterCreate', 'id', id)
            // verify required parameter 'openaiCharacterRequest' is not null or undefined
            assertParamExists('characterOwnedSelectCharacterCreate', 'openaiCharacterRequest', openaiCharacterRequest)
            const localVarPath = `/api/character/owned/{id}/select_character/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(openaiCharacterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Skills this character has learned, base ones included.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedSkillsList: async (id: string, npc?: boolean, position?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterOwnedSkillsList', 'id', id)
            const localVarPath = `/api/character/owned/{id}/skills/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (npc !== undefined) {
                localVarQueryParameter['npc'] = npc;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Every stat of one owned character, active or not.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedStatsList: async (id: string, npc?: boolean, position?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterOwnedStatsList', 'id', id)
            const localVarPath = `/api/character/owned/{id}/stats/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (npc !== undefined) {
                localVarQueryParameter['npc'] = npc;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerCharacterDetailsRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/player/character_details/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerCharacterInfoRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/player/character_info/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerCharacterStatsRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/player/character_stats/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerCharacterTemplateRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/player/character_template/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CharacterPathRequest} [characterPathRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerChosePathCreate: async (characterPathRequest?: CharacterPathRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/player/chose_path/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(characterPathRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * End the character\'s turn by spending all action points.
         * @param {OpenaiCharacterRequest} openaiCharacterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerEndTurnCreate: async (openaiCharacterRequest: OpenaiCharacterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'openaiCharacterRequest' is not null or undefined
            assertParamExists('characterPlayerEndTurnCreate', 'openaiCharacterRequest', openaiCharacterRequest)
            const localVarPath = `/api/character/player/end_turn/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(openaiCharacterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new character for the user.
         * @param {CharacterGenericDataRequest} characterGenericDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerImportCharacterCreate: async (characterGenericDataRequest: CharacterGenericDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'characterGenericDataRequest' is not null or undefined
            assertParamExists('characterPlayerImportCharacterCreate', 'characterGenericDataRequest', characterGenericDataRequest)
            const localVarPath = `/api/character/player/import_character/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(characterGenericDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [npc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerList: async (npc?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/player/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (npc !== undefined) {
                localVarQueryParameter['npc'] = npc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterPlayerRetrieve', 'id', id)
            const localVarPath = `/api/character/player/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {string} character 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPortraitCreate: async (character: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'character' is not null or undefined
            assertParamExists('characterPortraitCreate', 'character', character)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('characterPortraitCreate', 'file', file)
            const localVarPath = `/api/character/portrait/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (character !== undefined) { 
                localVarFormParams.append('character', character as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPortraitList: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/portrait/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {string} id A UUID string identifying this character portrait request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPortraitMediaRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterPortraitMediaRetrieve', 'id', id)
            const localVarPath = `/api/character/portrait/{id}/media/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {string} id A UUID string identifying this character portrait request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPortraitRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterPortraitRetrieve', 'id', id)
            const localVarPath = `/api/character/portrait/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {string} id A UUID string identifying this character portrait request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPortraitWithdrawCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterPortraitWithdrawCreate', 'id', id)
            const localVarPath = `/api/character/portrait/{id}/withdraw/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PublicationOpenRequest} publicationOpenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationCreate: async (publicationOpenRequest: PublicationOpenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicationOpenRequest' is not null or undefined
            assertParamExists('characterPublicationCreate', 'publicationOpenRequest', publicationOpenRequest)
            const localVarPath = `/api/character/publication/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publicationOpenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {PublicationImageUploadKindEnum} kind 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationImageCreate: async (id: string, kind: PublicationImageUploadKindEnum, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterPublicationImageCreate', 'id', id)
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('characterPublicationImageCreate', 'kind', kind)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('characterPublicationImageCreate', 'file', file)
            const localVarPath = `/api/character/publication/{id}/image/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (kind !== undefined) { 
                localVarFormParams.append('kind', kind as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationList: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/publication/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {string} kind 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationMediaRetrieve: async (id: string, kind: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterPublicationMediaRetrieve', 'id', id)
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('characterPublicationMediaRetrieve', 'kind', kind)
            const localVarPath = `/api/character/publication/{id}/media/{kind}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"kind"}}`, encodeURIComponent(String(kind)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {PatchedPublicationDraftUpdateRequest} [patchedPublicationDraftUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationPartialUpdate: async (id: string, patchedPublicationDraftUpdateRequest?: PatchedPublicationDraftUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterPublicationPartialUpdate', 'id', id)
            const localVarPath = `/api/character/publication/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedPublicationDraftUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterPublicationRetrieve', 'id', id)
            const localVarPath = `/api/character/publication/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationSubmitCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterPublicationSubmitCreate', 'id', id)
            const localVarPath = `/api/character/publication/{id}/submit/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationWithdrawCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterPublicationWithdrawCreate', 'id', id)
            const localVarPath = `/api/character/publication/{id}/withdraw/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterStatsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/stats/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterStatsResetBaseStatsCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/stats/reset_base_stats/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this stat.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterStatsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterStatsRetrieve', 'id', id)
            const localVarPath = `/api/character/stats/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SwipeBaseStatRequest} swipeBaseStatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterStatsSwipeBaseStatCreate: async (swipeBaseStatRequest: SwipeBaseStatRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'swipeBaseStatRequest' is not null or undefined
            assertParamExists('characterStatsSwipeBaseStatCreate', 'swipeBaseStatRequest', swipeBaseStatRequest)
            const localVarPath = `/api/character/stats/swipe_base_stat/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swipeBaseStatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CharacterApi - functional programming interface
 * @export
 */
export const CharacterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CharacterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id A UUID string identifying this character avatar preset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterAvatarPresetsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterAvatarPreset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterAvatarPresetsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterAvatarPresetsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The owner\'s private, live in-game biography. Never touches public data.
         * @param {string} characterId 
         * @param {PatchedCharacterBiographyDetailRequest} [patchedCharacterBiographyDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterBiographyPartialUpdate(characterId: string, patchedCharacterBiographyDetailRequest?: PatchedCharacterBiographyDetailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterBiographyDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterBiographyPartialUpdate(characterId, patchedCharacterBiographyDetailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterBiographyPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The owner\'s private, live in-game biography. Never touches public data.
         * @param {string} characterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterBiographyRetrieve(characterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterBiographyDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterBiographyRetrieve(characterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterBiographyRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterGmCharacterInfoRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterGmCharacterInfoRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterGmCharacterInfoRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Character info for every character matching the filters, in one read. Gives a client the state it would otherwise only learn from the next `character_changed` event.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterGmCharacterInfosList(npc?: boolean, position?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FullCharacterInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterGmCharacterInfosList(npc, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterGmCharacterInfosList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterGmList(npc?: boolean, position?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpenaiCharacter>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterGmList(npc, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterGmList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterGmRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiCharacter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterGmRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterGmRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the user\'s current main character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterOwnedCurrentCharacterRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiCharacter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterOwnedCurrentCharacterRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterOwnedCurrentCharacterRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Active effects on one owned character.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterOwnedEffectsList(id: string, npc?: boolean, position?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActiveEffect>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterOwnedEffectsList(id, npc, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterOwnedEffectsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The inventory of one owned character.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterOwnedItemsList(id: string, npc?: boolean, position?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CharacterItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterOwnedItemsList(id, npc, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterOwnedItemsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for managing characters in the client application. Provides read-only access to character data.  1. **get_queryset**: Returns the queryset of characters for the authenticated user. 2. **we se all active and non active characters**: Filters characters based on the user\'s main character\'s position and campaign. 3. **no npc characters are allowed**: Ensures that only characters related to the user\'s main character\'s campaign are returned. 4. **select character** allows client to choose a character to play with.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterOwnedList(npc?: boolean, position?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpenaiCharacter>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterOwnedList(npc, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterOwnedList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for managing characters in the client application. Provides read-only access to character data.  1. **get_queryset**: Returns the queryset of characters for the authenticated user. 2. **we se all active and non active characters**: Filters characters based on the user\'s main character\'s position and campaign. 3. **no npc characters are allowed**: Ensures that only characters related to the user\'s main character\'s campaign are returned. 4. **select character** allows client to choose a character to play with.
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterOwnedRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiCharacter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterOwnedRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterOwnedRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Schools this character has learned, base ones included.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterOwnedSchoolsList(id: string, npc?: boolean, position?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LearnedSchool>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterOwnedSchoolsList(id, npc, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterOwnedSchoolsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Select a character as the user\'s main character.
         * @param {string} id A UUID string identifying this character.
         * @param {OpenaiCharacterRequest} openaiCharacterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterOwnedSelectCharacterCreate(id: string, openaiCharacterRequest: OpenaiCharacterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiCharacter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterOwnedSelectCharacterCreate(id, openaiCharacterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterOwnedSelectCharacterCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Skills this character has learned, base ones included.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterOwnedSkillsList(id: string, npc?: boolean, position?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LearnedSkill>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterOwnedSkillsList(id, npc, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterOwnedSkillsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Every stat of one owned character, active or not.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterOwnedStatsList(id: string, npc?: boolean, position?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DetailStat>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterOwnedStatsList(id, npc, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterOwnedStatsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPlayerCharacterDetailsRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiCharacter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPlayerCharacterDetailsRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPlayerCharacterDetailsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPlayerCharacterInfoRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPlayerCharacterInfoRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPlayerCharacterInfoRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPlayerCharacterStatsRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPlayerCharacterStatsRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPlayerCharacterStatsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPlayerCharacterTemplateRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterTemplateFull>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPlayerCharacterTemplateRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPlayerCharacterTemplateRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CharacterPathRequest} [characterPathRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPlayerChosePathCreate(characterPathRequest?: CharacterPathRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterPath>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPlayerChosePathCreate(characterPathRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPlayerChosePathCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * End the character\'s turn by spending all action points.
         * @param {OpenaiCharacterRequest} openaiCharacterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPlayerEndTurnCreate(openaiCharacterRequest: OpenaiCharacterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiCharacter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPlayerEndTurnCreate(openaiCharacterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPlayerEndTurnCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new character for the user.
         * @param {CharacterGenericDataRequest} characterGenericDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPlayerImportCharacterCreate(characterGenericDataRequest: CharacterGenericDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterGenericData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPlayerImportCharacterCreate(characterGenericDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPlayerImportCharacterCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [npc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPlayerList(npc?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpenaiCharacter>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPlayerList(npc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPlayerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPlayerRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiCharacter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPlayerRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPlayerRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {string} character 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPortraitCreate(character: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortraitRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPortraitCreate(character, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPortraitCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPortraitList(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPortraitRequestList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPortraitList(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPortraitList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {string} id A UUID string identifying this character portrait request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPortraitMediaRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPortraitMediaRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPortraitMediaRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {string} id A UUID string identifying this character portrait request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPortraitRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortraitRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPortraitRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPortraitRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {string} id A UUID string identifying this character portrait request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPortraitWithdrawCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortraitRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPortraitWithdrawCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPortraitWithdrawCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PublicationOpenRequest} publicationOpenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPublicationCreate(publicationOpenRequest: PublicationOpenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicationRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPublicationCreate(publicationOpenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPublicationCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {PublicationImageUploadKindEnum} kind 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPublicationImageCreate(id: string, kind: PublicationImageUploadKindEnum, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicationRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPublicationImageCreate(id, kind, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPublicationImageCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPublicationList(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPublicationRequestList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPublicationList(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPublicationList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {string} kind 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPublicationMediaRetrieve(id: string, kind: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPublicationMediaRetrieve(id, kind, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPublicationMediaRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {PatchedPublicationDraftUpdateRequest} [patchedPublicationDraftUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPublicationPartialUpdate(id: string, patchedPublicationDraftUpdateRequest?: PatchedPublicationDraftUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicationRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPublicationPartialUpdate(id, patchedPublicationDraftUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPublicationPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPublicationRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicationRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPublicationRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPublicationRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPublicationSubmitCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicationRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPublicationSubmitCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPublicationSubmitCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPublicationWithdrawCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicationRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPublicationWithdrawCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterPublicationWithdrawCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterStatsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DetailStat>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterStatsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterStatsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterStatsResetBaseStatsCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DetailStat>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterStatsResetBaseStatsCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterStatsResetBaseStatsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this stat.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterStatsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailStat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterStatsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterStatsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SwipeBaseStatRequest} swipeBaseStatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterStatsSwipeBaseStatCreate(swipeBaseStatRequest: SwipeBaseStatRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailStat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterStatsSwipeBaseStatCreate(swipeBaseStatRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacterApi.characterStatsSwipeBaseStatCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CharacterApi - factory interface
 * @export
 */
export const CharacterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CharacterApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id A UUID string identifying this character avatar preset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterAvatarPresetsRetrieve(id: string, options?: any): AxiosPromise<CharacterAvatarPreset> {
            return localVarFp.characterAvatarPresetsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The owner\'s private, live in-game biography. Never touches public data.
         * @param {string} characterId 
         * @param {PatchedCharacterBiographyDetailRequest} [patchedCharacterBiographyDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterBiographyPartialUpdate(characterId: string, patchedCharacterBiographyDetailRequest?: PatchedCharacterBiographyDetailRequest, options?: any): AxiosPromise<CharacterBiographyDetail> {
            return localVarFp.characterBiographyPartialUpdate(characterId, patchedCharacterBiographyDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The owner\'s private, live in-game biography. Never touches public data.
         * @param {string} characterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterBiographyRetrieve(characterId: string, options?: any): AxiosPromise<CharacterBiographyDetail> {
            return localVarFp.characterBiographyRetrieve(characterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterGmCharacterInfoRetrieve(id: string, options?: any): AxiosPromise<CharacterInfo> {
            return localVarFp.characterGmCharacterInfoRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Character info for every character matching the filters, in one read. Gives a client the state it would otherwise only learn from the next `character_changed` event.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterGmCharacterInfosList(npc?: boolean, position?: string, options?: any): AxiosPromise<Array<FullCharacterInfo>> {
            return localVarFp.characterGmCharacterInfosList(npc, position, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterGmList(npc?: boolean, position?: string, options?: any): AxiosPromise<Array<OpenaiCharacter>> {
            return localVarFp.characterGmList(npc, position, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterGmRetrieve(id: string, options?: any): AxiosPromise<OpenaiCharacter> {
            return localVarFp.characterGmRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the user\'s current main character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedCurrentCharacterRetrieve(options?: any): AxiosPromise<OpenaiCharacter> {
            return localVarFp.characterOwnedCurrentCharacterRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Active effects on one owned character.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedEffectsList(id: string, npc?: boolean, position?: string, options?: any): AxiosPromise<Array<ActiveEffect>> {
            return localVarFp.characterOwnedEffectsList(id, npc, position, options).then((request) => request(axios, basePath));
        },
        /**
         * The inventory of one owned character.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedItemsList(id: string, npc?: boolean, position?: string, options?: any): AxiosPromise<Array<CharacterItem>> {
            return localVarFp.characterOwnedItemsList(id, npc, position, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for managing characters in the client application. Provides read-only access to character data.  1. **get_queryset**: Returns the queryset of characters for the authenticated user. 2. **we se all active and non active characters**: Filters characters based on the user\'s main character\'s position and campaign. 3. **no npc characters are allowed**: Ensures that only characters related to the user\'s main character\'s campaign are returned. 4. **select character** allows client to choose a character to play with.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedList(npc?: boolean, position?: string, options?: any): AxiosPromise<Array<OpenaiCharacter>> {
            return localVarFp.characterOwnedList(npc, position, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for managing characters in the client application. Provides read-only access to character data.  1. **get_queryset**: Returns the queryset of characters for the authenticated user. 2. **we se all active and non active characters**: Filters characters based on the user\'s main character\'s position and campaign. 3. **no npc characters are allowed**: Ensures that only characters related to the user\'s main character\'s campaign are returned. 4. **select character** allows client to choose a character to play with.
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedRetrieve(id: string, options?: any): AxiosPromise<OpenaiCharacter> {
            return localVarFp.characterOwnedRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Schools this character has learned, base ones included.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedSchoolsList(id: string, npc?: boolean, position?: string, options?: any): AxiosPromise<Array<LearnedSchool>> {
            return localVarFp.characterOwnedSchoolsList(id, npc, position, options).then((request) => request(axios, basePath));
        },
        /**
         * Select a character as the user\'s main character.
         * @param {string} id A UUID string identifying this character.
         * @param {OpenaiCharacterRequest} openaiCharacterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedSelectCharacterCreate(id: string, openaiCharacterRequest: OpenaiCharacterRequest, options?: any): AxiosPromise<OpenaiCharacter> {
            return localVarFp.characterOwnedSelectCharacterCreate(id, openaiCharacterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Skills this character has learned, base ones included.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedSkillsList(id: string, npc?: boolean, position?: string, options?: any): AxiosPromise<Array<LearnedSkill>> {
            return localVarFp.characterOwnedSkillsList(id, npc, position, options).then((request) => request(axios, basePath));
        },
        /**
         * Every stat of one owned character, active or not.
         * @param {string} id A UUID string identifying this character.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterOwnedStatsList(id: string, npc?: boolean, position?: string, options?: any): AxiosPromise<Array<DetailStat>> {
            return localVarFp.characterOwnedStatsList(id, npc, position, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerCharacterDetailsRetrieve(options?: any): AxiosPromise<OpenaiCharacter> {
            return localVarFp.characterPlayerCharacterDetailsRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerCharacterInfoRetrieve(options?: any): AxiosPromise<CharacterInfo> {
            return localVarFp.characterPlayerCharacterInfoRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerCharacterStatsRetrieve(options?: any): AxiosPromise<CharacterStats> {
            return localVarFp.characterPlayerCharacterStatsRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerCharacterTemplateRetrieve(options?: any): AxiosPromise<CharacterTemplateFull> {
            return localVarFp.characterPlayerCharacterTemplateRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CharacterPathRequest} [characterPathRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerChosePathCreate(characterPathRequest?: CharacterPathRequest, options?: any): AxiosPromise<CharacterPath> {
            return localVarFp.characterPlayerChosePathCreate(characterPathRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * End the character\'s turn by spending all action points.
         * @param {OpenaiCharacterRequest} openaiCharacterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerEndTurnCreate(openaiCharacterRequest: OpenaiCharacterRequest, options?: any): AxiosPromise<OpenaiCharacter> {
            return localVarFp.characterPlayerEndTurnCreate(openaiCharacterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new character for the user.
         * @param {CharacterGenericDataRequest} characterGenericDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerImportCharacterCreate(characterGenericDataRequest: CharacterGenericDataRequest, options?: any): AxiosPromise<CharacterGenericData> {
            return localVarFp.characterPlayerImportCharacterCreate(characterGenericDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [npc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerList(npc?: boolean, options?: any): AxiosPromise<Array<OpenaiCharacter>> {
            return localVarFp.characterPlayerList(npc, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPlayerRetrieve(id: string, options?: any): AxiosPromise<OpenaiCharacter> {
            return localVarFp.characterPlayerRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {string} character 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPortraitCreate(character: string, file: File, options?: any): AxiosPromise<PortraitRequest> {
            return localVarFp.characterPortraitCreate(character, file, options).then((request) => request(axios, basePath));
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPortraitList(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedPortraitRequestList> {
            return localVarFp.characterPortraitList(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {string} id A UUID string identifying this character portrait request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPortraitMediaRetrieve(id: string, options?: any): AxiosPromise<File> {
            return localVarFp.characterPortraitMediaRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {string} id A UUID string identifying this character portrait request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPortraitRetrieve(id: string, options?: any): AxiosPromise<PortraitRequest> {
            return localVarFp.characterPortraitRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
         * @param {string} id A UUID string identifying this character portrait request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPortraitWithdrawCreate(id: string, options?: any): AxiosPromise<PortraitRequest> {
            return localVarFp.characterPortraitWithdrawCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PublicationOpenRequest} publicationOpenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationCreate(publicationOpenRequest: PublicationOpenRequest, options?: any): AxiosPromise<PublicationRequest> {
            return localVarFp.characterPublicationCreate(publicationOpenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {PublicationImageUploadKindEnum} kind 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationImageCreate(id: string, kind: PublicationImageUploadKindEnum, file: File, options?: any): AxiosPromise<PublicationRequest> {
            return localVarFp.characterPublicationImageCreate(id, kind, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationList(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedPublicationRequestList> {
            return localVarFp.characterPublicationList(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {string} kind 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationMediaRetrieve(id: string, kind: string, options?: any): AxiosPromise<File> {
            return localVarFp.characterPublicationMediaRetrieve(id, kind, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {PatchedPublicationDraftUpdateRequest} [patchedPublicationDraftUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationPartialUpdate(id: string, patchedPublicationDraftUpdateRequest?: PatchedPublicationDraftUpdateRequest, options?: any): AxiosPromise<PublicationRequest> {
            return localVarFp.characterPublicationPartialUpdate(id, patchedPublicationDraftUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationRetrieve(id: string, options?: any): AxiosPromise<PublicationRequest> {
            return localVarFp.characterPublicationRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationSubmitCreate(id: string, options?: any): AxiosPromise<PublicationRequest> {
            return localVarFp.characterPublicationSubmitCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character publication request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublicationWithdrawCreate(id: string, options?: any): AxiosPromise<PublicationRequest> {
            return localVarFp.characterPublicationWithdrawCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterStatsList(options?: any): AxiosPromise<Array<DetailStat>> {
            return localVarFp.characterStatsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterStatsResetBaseStatsCreate(options?: any): AxiosPromise<Array<DetailStat>> {
            return localVarFp.characterStatsResetBaseStatsCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this stat.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterStatsRetrieve(id: string, options?: any): AxiosPromise<DetailStat> {
            return localVarFp.characterStatsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SwipeBaseStatRequest} swipeBaseStatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterStatsSwipeBaseStatCreate(swipeBaseStatRequest: SwipeBaseStatRequest, options?: any): AxiosPromise<DetailStat> {
            return localVarFp.characterStatsSwipeBaseStatCreate(swipeBaseStatRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CharacterApi - object-oriented interface
 * @export
 * @class CharacterApi
 * @extends {BaseAPI}
 */
export class CharacterApi extends BaseAPI {
    /**
     * 
     * @param {string} id A UUID string identifying this character avatar preset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterAvatarPresetsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterAvatarPresetsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The owner\'s private, live in-game biography. Never touches public data.
     * @param {string} characterId 
     * @param {PatchedCharacterBiographyDetailRequest} [patchedCharacterBiographyDetailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterBiographyPartialUpdate(characterId: string, patchedCharacterBiographyDetailRequest?: PatchedCharacterBiographyDetailRequest, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterBiographyPartialUpdate(characterId, patchedCharacterBiographyDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The owner\'s private, live in-game biography. Never touches public data.
     * @param {string} characterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterBiographyRetrieve(characterId: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterBiographyRetrieve(characterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterGmCharacterInfoRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterGmCharacterInfoRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Character info for every character matching the filters, in one read. Gives a client the state it would otherwise only learn from the next `character_changed` event.
     * @param {boolean} [npc] 
     * @param {string} [position] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterGmCharacterInfosList(npc?: boolean, position?: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterGmCharacterInfosList(npc, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [npc] 
     * @param {string} [position] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterGmList(npc?: boolean, position?: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterGmList(npc, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterGmRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterGmRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the user\'s current main character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterOwnedCurrentCharacterRetrieve(options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterOwnedCurrentCharacterRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Active effects on one owned character.
     * @param {string} id A UUID string identifying this character.
     * @param {boolean} [npc] 
     * @param {string} [position] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterOwnedEffectsList(id: string, npc?: boolean, position?: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterOwnedEffectsList(id, npc, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The inventory of one owned character.
     * @param {string} id A UUID string identifying this character.
     * @param {boolean} [npc] 
     * @param {string} [position] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterOwnedItemsList(id: string, npc?: boolean, position?: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterOwnedItemsList(id, npc, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for managing characters in the client application. Provides read-only access to character data.  1. **get_queryset**: Returns the queryset of characters for the authenticated user. 2. **we se all active and non active characters**: Filters characters based on the user\'s main character\'s position and campaign. 3. **no npc characters are allowed**: Ensures that only characters related to the user\'s main character\'s campaign are returned. 4. **select character** allows client to choose a character to play with.
     * @param {boolean} [npc] 
     * @param {string} [position] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterOwnedList(npc?: boolean, position?: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterOwnedList(npc, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for managing characters in the client application. Provides read-only access to character data.  1. **get_queryset**: Returns the queryset of characters for the authenticated user. 2. **we se all active and non active characters**: Filters characters based on the user\'s main character\'s position and campaign. 3. **no npc characters are allowed**: Ensures that only characters related to the user\'s main character\'s campaign are returned. 4. **select character** allows client to choose a character to play with.
     * @param {string} id A UUID string identifying this character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterOwnedRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterOwnedRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Schools this character has learned, base ones included.
     * @param {string} id A UUID string identifying this character.
     * @param {boolean} [npc] 
     * @param {string} [position] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterOwnedSchoolsList(id: string, npc?: boolean, position?: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterOwnedSchoolsList(id, npc, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Select a character as the user\'s main character.
     * @param {string} id A UUID string identifying this character.
     * @param {OpenaiCharacterRequest} openaiCharacterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterOwnedSelectCharacterCreate(id: string, openaiCharacterRequest: OpenaiCharacterRequest, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterOwnedSelectCharacterCreate(id, openaiCharacterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Skills this character has learned, base ones included.
     * @param {string} id A UUID string identifying this character.
     * @param {boolean} [npc] 
     * @param {string} [position] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterOwnedSkillsList(id: string, npc?: boolean, position?: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterOwnedSkillsList(id, npc, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Every stat of one owned character, active or not.
     * @param {string} id A UUID string identifying this character.
     * @param {boolean} [npc] 
     * @param {string} [position] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterOwnedStatsList(id: string, npc?: boolean, position?: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterOwnedStatsList(id, npc, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPlayerCharacterDetailsRetrieve(options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPlayerCharacterDetailsRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPlayerCharacterInfoRetrieve(options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPlayerCharacterInfoRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPlayerCharacterStatsRetrieve(options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPlayerCharacterStatsRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPlayerCharacterTemplateRetrieve(options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPlayerCharacterTemplateRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CharacterPathRequest} [characterPathRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPlayerChosePathCreate(characterPathRequest?: CharacterPathRequest, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPlayerChosePathCreate(characterPathRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * End the character\'s turn by spending all action points.
     * @param {OpenaiCharacterRequest} openaiCharacterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPlayerEndTurnCreate(openaiCharacterRequest: OpenaiCharacterRequest, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPlayerEndTurnCreate(openaiCharacterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new character for the user.
     * @param {CharacterGenericDataRequest} characterGenericDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPlayerImportCharacterCreate(characterGenericDataRequest: CharacterGenericDataRequest, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPlayerImportCharacterCreate(characterGenericDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [npc] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPlayerList(npc?: boolean, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPlayerList(npc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPlayerRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPlayerRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
     * @param {string} character 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPortraitCreate(character: string, file: File, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPortraitCreate(character, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPortraitList(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPortraitList(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
     * @param {string} id A UUID string identifying this character portrait request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPortraitMediaRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPortraitMediaRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
     * @param {string} id A UUID string identifying this character portrait request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPortraitRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPortraitRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The in-game portrait. A sibling of ``publication``, never nested under it: a portrait submission does not belong to a publication request and must be reachable for a character that has none.
     * @param {string} id A UUID string identifying this character portrait request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPortraitWithdrawCreate(id: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPortraitWithdrawCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PublicationOpenRequest} publicationOpenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPublicationCreate(publicationOpenRequest: PublicationOpenRequest, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPublicationCreate(publicationOpenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character publication request.
     * @param {PublicationImageUploadKindEnum} kind 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPublicationImageCreate(id: string, kind: PublicationImageUploadKindEnum, file: File, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPublicationImageCreate(id, kind, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPublicationList(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPublicationList(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character publication request.
     * @param {string} kind 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPublicationMediaRetrieve(id: string, kind: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPublicationMediaRetrieve(id, kind, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character publication request.
     * @param {PatchedPublicationDraftUpdateRequest} [patchedPublicationDraftUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPublicationPartialUpdate(id: string, patchedPublicationDraftUpdateRequest?: PatchedPublicationDraftUpdateRequest, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPublicationPartialUpdate(id, patchedPublicationDraftUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character publication request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPublicationRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPublicationRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character publication request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPublicationSubmitCreate(id: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPublicationSubmitCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character publication request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterPublicationWithdrawCreate(id: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterPublicationWithdrawCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterStatsList(options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterStatsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterStatsResetBaseStatsCreate(options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterStatsResetBaseStatsCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this stat.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterStatsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterStatsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SwipeBaseStatRequest} swipeBaseStatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacterApi
     */
    public characterStatsSwipeBaseStatCreate(swipeBaseStatRequest: SwipeBaseStatRequest, options?: RawAxiosRequestConfig) {
        return CharacterApiFp(this.configuration).characterStatsSwipeBaseStatCreate(swipeBaseStatRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CharactersAvatarPresetsApi - axios parameter creator
 * @export
 */
export const CharactersAvatarPresetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the active preset avatars matching the given path and gender, ordered for display. Both `path` and `gender` are required; an unrecognised or missing pair returns an empty list.
         * @summary List avatar presets for a path and gender
         * @param {string} gender GenderEnum value
         * @param {string} path ThePath UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterAvatarPresetsList: async (gender: string, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gender' is not null or undefined
            assertParamExists('characterAvatarPresetsList', 'gender', gender)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('characterAvatarPresetsList', 'path', path)
            const localVarPath = `/api/character/avatar-presets/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CharactersAvatarPresetsApi - functional programming interface
 * @export
 */
export const CharactersAvatarPresetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CharactersAvatarPresetsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the active preset avatars matching the given path and gender, ordered for display. Both `path` and `gender` are required; an unrecognised or missing pair returns an empty list.
         * @summary List avatar presets for a path and gender
         * @param {string} gender GenderEnum value
         * @param {string} path ThePath UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterAvatarPresetsList(gender: string, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CharacterAvatarPreset>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterAvatarPresetsList(gender, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharactersAvatarPresetsApi.characterAvatarPresetsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CharactersAvatarPresetsApi - factory interface
 * @export
 */
export const CharactersAvatarPresetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CharactersAvatarPresetsApiFp(configuration)
    return {
        /**
         * Returns the active preset avatars matching the given path and gender, ordered for display. Both `path` and `gender` are required; an unrecognised or missing pair returns an empty list.
         * @summary List avatar presets for a path and gender
         * @param {string} gender GenderEnum value
         * @param {string} path ThePath UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterAvatarPresetsList(gender: string, path: string, options?: any): AxiosPromise<Array<CharacterAvatarPreset>> {
            return localVarFp.characterAvatarPresetsList(gender, path, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CharactersAvatarPresetsApi - object-oriented interface
 * @export
 * @class CharactersAvatarPresetsApi
 * @extends {BaseAPI}
 */
export class CharactersAvatarPresetsApi extends BaseAPI {
    /**
     * Returns the active preset avatars matching the given path and gender, ordered for display. Both `path` and `gender` are required; an unrecognised or missing pair returns an empty list.
     * @summary List avatar presets for a path and gender
     * @param {string} gender GenderEnum value
     * @param {string} path ThePath UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharactersAvatarPresetsApi
     */
    public characterAvatarPresetsList(gender: string, path: string, options?: RawAxiosRequestConfig) {
        return CharactersAvatarPresetsApiFp(this.configuration).characterAvatarPresetsList(gender, path, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CharactersPublishedApi - axios parameter creator
 * @export
 */
export const CharactersPublishedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a paginated list of all published characters. No authentication required. Public endpoint.
         * @summary List all published characters
         * @param {string} [campaign] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublishedList: async (campaign?: string, ordering?: string, page?: number, pageSize?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/character/published/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (campaign !== undefined) {
                localVarQueryParameter['campaign'] = campaign;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed information about a specific published character by its ID. No authentication required. Public endpoint.
         * @summary Retrieve a published character
         * @param {string} id A UUID string identifying this published character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublishedRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('characterPublishedRetrieve', 'id', id)
            const localVarPath = `/api/character/published/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CharactersPublishedApi - functional programming interface
 * @export
 */
export const CharactersPublishedApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CharactersPublishedApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a paginated list of all published characters. No authentication required. Public endpoint.
         * @summary List all published characters
         * @param {string} [campaign] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPublishedList(campaign?: string, ordering?: string, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPublicPublishedCharacterList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPublishedList(campaign, ordering, page, pageSize, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharactersPublishedApi.characterPublishedList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed information about a specific published character by its ID. No authentication required. Public endpoint.
         * @summary Retrieve a published character
         * @param {string} id A UUID string identifying this published character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async characterPublishedRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicPublishedCharacter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.characterPublishedRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharactersPublishedApi.characterPublishedRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CharactersPublishedApi - factory interface
 * @export
 */
export const CharactersPublishedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CharactersPublishedApiFp(configuration)
    return {
        /**
         * Retrieve a paginated list of all published characters. No authentication required. Public endpoint.
         * @summary List all published characters
         * @param {string} [campaign] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublishedList(campaign?: string, ordering?: string, page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<PaginatedPublicPublishedCharacterList> {
            return localVarFp.characterPublishedList(campaign, ordering, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed information about a specific published character by its ID. No authentication required. Public endpoint.
         * @summary Retrieve a published character
         * @param {string} id A UUID string identifying this published character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        characterPublishedRetrieve(id: string, options?: any): AxiosPromise<PublicPublishedCharacter> {
            return localVarFp.characterPublishedRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CharactersPublishedApi - object-oriented interface
 * @export
 * @class CharactersPublishedApi
 * @extends {BaseAPI}
 */
export class CharactersPublishedApi extends BaseAPI {
    /**
     * Retrieve a paginated list of all published characters. No authentication required. Public endpoint.
     * @summary List all published characters
     * @param {string} [campaign] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharactersPublishedApi
     */
    public characterPublishedList(campaign?: string, ordering?: string, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig) {
        return CharactersPublishedApiFp(this.configuration).characterPublishedList(campaign, ordering, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed information about a specific published character by its ID. No authentication required. Public endpoint.
     * @summary Retrieve a published character
     * @param {string} id A UUID string identifying this published character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharactersPublishedApi
     */
    public characterPublishedRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CharactersPublishedApiFp(this.configuration).characterPublishedRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChestApi - axios parameter creator
 * @export
 */
export const ChestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chestChestsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/chest/chests/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
         * @param {string} id A UUID string identifying this chest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chestChestsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chestChestsRetrieve', 'id', id)
            const localVarPath = `/api/chest/chests/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
         * @summary Take everything out of a chest
         * @param {string} id A UUID string identifying this chest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chestChestsTakeAllCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chestChestsTakeAllCreate', 'id', id)
            const localVarPath = `/api/chest/chests/{id}/take-all/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
         * @summary Take one item out of a chest
         * @param {string} id A UUID string identifying this chest.
         * @param {TakeChestItemRequest} takeChestItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chestChestsTakeCreate: async (id: string, takeChestItemRequest: TakeChestItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chestChestsTakeCreate', 'id', id)
            // verify required parameter 'takeChestItemRequest' is not null or undefined
            assertParamExists('chestChestsTakeCreate', 'takeChestItemRequest', takeChestItemRequest)
            const localVarPath = `/api/chest/chests/{id}/take/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(takeChestItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChestApi - functional programming interface
 * @export
 */
export const ChestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChestApiAxiosParamCreator(configuration)
    return {
        /**
         * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chestChestsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Chest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chestChestsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChestApi.chestChestsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
         * @param {string} id A UUID string identifying this chest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chestChestsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Chest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chestChestsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChestApi.chestChestsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
         * @summary Take everything out of a chest
         * @param {string} id A UUID string identifying this chest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chestChestsTakeAllCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Chest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chestChestsTakeAllCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChestApi.chestChestsTakeAllCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
         * @summary Take one item out of a chest
         * @param {string} id A UUID string identifying this chest.
         * @param {TakeChestItemRequest} takeChestItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chestChestsTakeCreate(id: string, takeChestItemRequest: TakeChestItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Chest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chestChestsTakeCreate(id, takeChestItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChestApi.chestChestsTakeCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChestApi - factory interface
 * @export
 */
export const ChestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChestApiFp(configuration)
    return {
        /**
         * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chestChestsList(options?: any): AxiosPromise<Array<Chest>> {
            return localVarFp.chestChestsList(options).then((request) => request(axios, basePath));
        },
        /**
         * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
         * @param {string} id A UUID string identifying this chest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chestChestsRetrieve(id: string, options?: any): AxiosPromise<Chest> {
            return localVarFp.chestChestsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
         * @summary Take everything out of a chest
         * @param {string} id A UUID string identifying this chest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chestChestsTakeAllCreate(id: string, options?: any): AxiosPromise<Chest> {
            return localVarFp.chestChestsTakeAllCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
         * @summary Take one item out of a chest
         * @param {string} id A UUID string identifying this chest.
         * @param {TakeChestItemRequest} takeChestItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chestChestsTakeCreate(id: string, takeChestItemRequest: TakeChestItemRequest, options?: any): AxiosPromise<Chest> {
            return localVarFp.chestChestsTakeCreate(id, takeChestItemRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChestApi - object-oriented interface
 * @export
 * @class ChestApi
 * @extends {BaseAPI}
 */
export class ChestApi extends BaseAPI {
    /**
     * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChestApi
     */
    public chestChestsList(options?: RawAxiosRequestConfig) {
        return ChestApiFp(this.configuration).chestChestsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
     * @param {string} id A UUID string identifying this chest.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChestApi
     */
    public chestChestsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return ChestApiFp(this.configuration).chestChestsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
     * @summary Take everything out of a chest
     * @param {string} id A UUID string identifying this chest.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChestApi
     */
    public chestChestsTakeAllCreate(id: string, options?: RawAxiosRequestConfig) {
        return ChestApiFp(this.configuration).chestChestsTakeAllCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Player-facing chest endpoints.  Opening a chest is an ACTION (OPEN_CHEST) and goes through the action pipeline, because it costs AP. Reading and emptying an already-reachable chest costs nothing, which is why it lives here as plain REST.
     * @summary Take one item out of a chest
     * @param {string} id A UUID string identifying this chest.
     * @param {TakeChestItemRequest} takeChestItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChestApi
     */
    public chestChestsTakeCreate(id: string, takeChestItemRequest: TakeChestItemRequest, options?: RawAxiosRequestConfig) {
        return ChestApiFp(this.configuration).chestChestsTakeCreate(id, takeChestItemRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientApi - axios parameter creator
 * @export
 */
export const ClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get information about the current user\'s account.  This provides users with information about their account before deletion.  Returns:     200: Account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientAccountAccountInfoRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/account/account-info/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the authenticated user\'s account and all associated data.  This endpoint permanently deletes: - User account - All associated characters - All associated game data - User preferences and settings  This action is irreversible.  Returns:     204: Account successfully deleted     400: Error during deletion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientAccountDeleteAccountDestroy: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/account/delete-account/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redeem a link token or a typed code, then log the visitor in.
         * @param {ActivationConfirmRequest} [activationConfirmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientActivationConfirmCreate: async (activationConfirmRequest?: ActivationConfirmRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/activation/confirm/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activationConfirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mail a fresh link. Always answers 200 — see RESEND_ACK.
         * @param {ActivationResendRequest} activationResendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientActivationResendCreate: async (activationResendRequest: ActivationResendRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activationResendRequest' is not null or undefined
            assertParamExists('clientActivationResendCreate', 'activationResendRequest', activationResendRequest)
            const localVarPath = `/api/client/activation/resend/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activationResendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Google OAuth login endpoint that handles Google ID token verification, user creation/authentication, and JWT token generation with cookie setting.  Accepts either field name for the Google credential: - \"id_token\": the Google ID token (backend canonical name) - \"credential\": alternate name used by Google Identity Services - \"token\": alternate name for convenience  Returns JWT tokens and sets dx_backend_token cookie for seamless integration with existing authentication system.  Account linking: if a user with the same email already exists (e.g. registered with email/password), their account is linked to Google without overwriting the original provider or password. They can continue to log in with either method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientAuthGoogleLoginCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/auth/google/login/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the Google OAuth URL for frontend to redirect users to. This is optional - frontend can construct this URL directly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientAuthGoogleUrlCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/auth/google/url/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current campaign for the client.  Returns the current campaign ID and its details. If no current campaign is set, the current_campaign field will be null.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCampaignsCurrentCampaignRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/campaigns/current_campaign/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all campaigns for the current client (both as player and as master). Returns only active campaigns.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCampaignsListCampaignsRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/campaigns/list_campaigns/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set the current campaign for the client.  The campaign must be active and the client must be either a player or a master in the campaign.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCampaignsSetCurrentCampaignCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clientCampaignsSetCurrentCampaignCreate', 'id', id)
            const localVarPath = `/api/client/campaigns/{id}/set_current_campaign/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OpenAIClientManagementRequest} openAIClientManagementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreate: async (openAIClientManagementRequest: OpenAIClientManagementRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'openAIClientManagementRequest' is not null or undefined
            assertParamExists('clientCreate', 'openAIClientManagementRequest', openAIClientManagementRequest)
            const localVarPath = `/api/client/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(openAIClientManagementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the basic information of the current authenticated client. This enpoint used by game client to get current client information It contains information about: is_active, current_campaign, main_character, play_campaigns, master_campaigns, owned_characters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCurrentInfoRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/current/info/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clientDestroy', 'id', id)
            const localVarPath = `/api/client/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this client.
         * @param {PatchedOpenAIClientManagementRequest} [patchedOpenAIClientManagementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientPartialUpdate: async (id: string, patchedOpenAIClientManagementRequest?: PatchedOpenAIClientManagementRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clientPartialUpdate', 'id', id)
            const localVarPath = `/api/client/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedOpenAIClientManagementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegistrationFormRequest} registrationFormRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientRegisterLocalClientCreate: async (registrationFormRequest: RegistrationFormRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationFormRequest' is not null or undefined
            assertParamExists('clientRegisterLocalClientCreate', 'registrationFormRequest', registrationFormRequest)
            const localVarPath = `/api/client/register_local_client/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registrationFormRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clientRetrieve', 'id', id)
            const localVarPath = `/api/client/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this client.
         * @param {OpenAIClientManagementRequest} openAIClientManagementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientUpdate: async (id: string, openAIClientManagementRequest: OpenAIClientManagementRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clientUpdate', 'id', id)
            // verify required parameter 'openAIClientManagementRequest' is not null or undefined
            assertParamExists('clientUpdate', 'openAIClientManagementRequest', openAIClientManagementRequest)
            const localVarPath = `/api/client/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(openAIClientManagementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientApi - functional programming interface
 * @export
 */
export const ClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientApiAxiosParamCreator(configuration)
    return {
        /**
         * Get information about the current user\'s account.  This provides users with information about their account before deletion.  Returns:     200: Account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientAccountAccountInfoRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientAccountAccountInfoRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientAccountAccountInfoRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete the authenticated user\'s account and all associated data.  This endpoint permanently deletes: - User account - All associated characters - All associated game data - User preferences and settings  This action is irreversible.  Returns:     204: Account successfully deleted     400: Error during deletion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientAccountDeleteAccountDestroy(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientAccountDeleteAccountDestroy(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientAccountDeleteAccountDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redeem a link token or a typed code, then log the visitor in.
         * @param {ActivationConfirmRequest} [activationConfirmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientActivationConfirmCreate(activationConfirmRequest?: ActivationConfirmRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientActivationConfirmCreate(activationConfirmRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientActivationConfirmCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mail a fresh link. Always answers 200 — see RESEND_ACK.
         * @param {ActivationResendRequest} activationResendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientActivationResendCreate(activationResendRequest: ActivationResendRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivationMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientActivationResendCreate(activationResendRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientActivationResendCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Google OAuth login endpoint that handles Google ID token verification, user creation/authentication, and JWT token generation with cookie setting.  Accepts either field name for the Google credential: - \"id_token\": the Google ID token (backend canonical name) - \"credential\": alternate name used by Google Identity Services - \"token\": alternate name for convenience  Returns JWT tokens and sets dx_backend_token cookie for seamless integration with existing authentication system.  Account linking: if a user with the same email already exists (e.g. registered with email/password), their account is linked to Google without overwriting the original provider or password. They can continue to log in with either method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientAuthGoogleLoginCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientAuthGoogleLoginCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientAuthGoogleLoginCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the Google OAuth URL for frontend to redirect users to. This is optional - frontend can construct this URL directly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientAuthGoogleUrlCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientAuthGoogleUrlCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientAuthGoogleUrlCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the current campaign for the client.  Returns the current campaign ID and its details. If no current campaign is set, the current_campaign field will be null.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientCampaignsCurrentCampaignRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenAICampaign>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientCampaignsCurrentCampaignRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientCampaignsCurrentCampaignRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all campaigns for the current client (both as player and as master). Returns only active campaigns.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientCampaignsListCampaignsRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenAICampaign>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientCampaignsListCampaignsRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientCampaignsListCampaignsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set the current campaign for the client.  The campaign must be active and the client must be either a player or a master in the campaign.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientCampaignsSetCurrentCampaignCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientCampaignsSetCurrentCampaignCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientCampaignsSetCurrentCampaignCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OpenAIClientManagementRequest} openAIClientManagementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientCreate(openAIClientManagementRequest: OpenAIClientManagementRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenAIClientManagement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientCreate(openAIClientManagementRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the basic information of the current authenticated client. This enpoint used by game client to get current client information It contains information about: is_active, current_campaign, main_character, play_campaigns, master_campaigns, owned_characters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientCurrentInfoRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentClientInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientCurrentInfoRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientCurrentInfoRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpenAIClientManagement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this client.
         * @param {PatchedOpenAIClientManagementRequest} [patchedOpenAIClientManagementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientPartialUpdate(id: string, patchedOpenAIClientManagementRequest?: PatchedOpenAIClientManagementRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenAIClientManagement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientPartialUpdate(id, patchedOpenAIClientManagementRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegistrationFormRequest} registrationFormRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientRegisterLocalClientCreate(registrationFormRequest: RegistrationFormRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistrationForm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientRegisterLocalClientCreate(registrationFormRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientRegisterLocalClientCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenAIClientManagement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this client.
         * @param {OpenAIClientManagementRequest} openAIClientManagementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientUpdate(id: string, openAIClientManagementRequest: OpenAIClientManagementRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenAIClientManagement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientUpdate(id, openAIClientManagementRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientApi - factory interface
 * @export
 */
export const ClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientApiFp(configuration)
    return {
        /**
         * Get information about the current user\'s account.  This provides users with information about their account before deletion.  Returns:     200: Account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientAccountAccountInfoRetrieve(options?: any): AxiosPromise<void> {
            return localVarFp.clientAccountAccountInfoRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the authenticated user\'s account and all associated data.  This endpoint permanently deletes: - User account - All associated characters - All associated game data - User preferences and settings  This action is irreversible.  Returns:     204: Account successfully deleted     400: Error during deletion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientAccountDeleteAccountDestroy(options?: any): AxiosPromise<void> {
            return localVarFp.clientAccountDeleteAccountDestroy(options).then((request) => request(axios, basePath));
        },
        /**
         * Redeem a link token or a typed code, then log the visitor in.
         * @param {ActivationConfirmRequest} [activationConfirmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientActivationConfirmCreate(activationConfirmRequest?: ActivationConfirmRequest, options?: any): AxiosPromise<ActivationResult> {
            return localVarFp.clientActivationConfirmCreate(activationConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Mail a fresh link. Always answers 200 — see RESEND_ACK.
         * @param {ActivationResendRequest} activationResendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientActivationResendCreate(activationResendRequest: ActivationResendRequest, options?: any): AxiosPromise<ActivationMessage> {
            return localVarFp.clientActivationResendCreate(activationResendRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Google OAuth login endpoint that handles Google ID token verification, user creation/authentication, and JWT token generation with cookie setting.  Accepts either field name for the Google credential: - \"id_token\": the Google ID token (backend canonical name) - \"credential\": alternate name used by Google Identity Services - \"token\": alternate name for convenience  Returns JWT tokens and sets dx_backend_token cookie for seamless integration with existing authentication system.  Account linking: if a user with the same email already exists (e.g. registered with email/password), their account is linked to Google without overwriting the original provider or password. They can continue to log in with either method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientAuthGoogleLoginCreate(options?: any): AxiosPromise<void> {
            return localVarFp.clientAuthGoogleLoginCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the Google OAuth URL for frontend to redirect users to. This is optional - frontend can construct this URL directly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientAuthGoogleUrlCreate(options?: any): AxiosPromise<void> {
            return localVarFp.clientAuthGoogleUrlCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current campaign for the client.  Returns the current campaign ID and its details. If no current campaign is set, the current_campaign field will be null.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCampaignsCurrentCampaignRetrieve(options?: any): AxiosPromise<OpenAICampaign> {
            return localVarFp.clientCampaignsCurrentCampaignRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * List all campaigns for the current client (both as player and as master). Returns only active campaigns.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCampaignsListCampaignsRetrieve(options?: any): AxiosPromise<OpenAICampaign> {
            return localVarFp.clientCampaignsListCampaignsRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Set the current campaign for the client.  The campaign must be active and the client must be either a player or a master in the campaign.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCampaignsSetCurrentCampaignCreate(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.clientCampaignsSetCurrentCampaignCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpenAIClientManagementRequest} openAIClientManagementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreate(openAIClientManagementRequest: OpenAIClientManagementRequest, options?: any): AxiosPromise<OpenAIClientManagement> {
            return localVarFp.clientCreate(openAIClientManagementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the basic information of the current authenticated client. This enpoint used by game client to get current client information It contains information about: is_active, current_campaign, main_character, play_campaigns, master_campaigns, owned_characters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCurrentInfoRetrieve(options?: any): AxiosPromise<CurrentClientInfo> {
            return localVarFp.clientCurrentInfoRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.clientDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientList(options?: any): AxiosPromise<Array<OpenAIClientManagement>> {
            return localVarFp.clientList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this client.
         * @param {PatchedOpenAIClientManagementRequest} [patchedOpenAIClientManagementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientPartialUpdate(id: string, patchedOpenAIClientManagementRequest?: PatchedOpenAIClientManagementRequest, options?: any): AxiosPromise<OpenAIClientManagement> {
            return localVarFp.clientPartialUpdate(id, patchedOpenAIClientManagementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegistrationFormRequest} registrationFormRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientRegisterLocalClientCreate(registrationFormRequest: RegistrationFormRequest, options?: any): AxiosPromise<RegistrationForm> {
            return localVarFp.clientRegisterLocalClientCreate(registrationFormRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientRetrieve(id: string, options?: any): AxiosPromise<OpenAIClientManagement> {
            return localVarFp.clientRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this client.
         * @param {OpenAIClientManagementRequest} openAIClientManagementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientUpdate(id: string, openAIClientManagementRequest: OpenAIClientManagementRequest, options?: any): AxiosPromise<OpenAIClientManagement> {
            return localVarFp.clientUpdate(id, openAIClientManagementRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientApi - object-oriented interface
 * @export
 * @class ClientApi
 * @extends {BaseAPI}
 */
export class ClientApi extends BaseAPI {
    /**
     * Get information about the current user\'s account.  This provides users with information about their account before deletion.  Returns:     200: Account information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientAccountAccountInfoRetrieve(options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientAccountAccountInfoRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the authenticated user\'s account and all associated data.  This endpoint permanently deletes: - User account - All associated characters - All associated game data - User preferences and settings  This action is irreversible.  Returns:     204: Account successfully deleted     400: Error during deletion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientAccountDeleteAccountDestroy(options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientAccountDeleteAccountDestroy(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Redeem a link token or a typed code, then log the visitor in.
     * @param {ActivationConfirmRequest} [activationConfirmRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientActivationConfirmCreate(activationConfirmRequest?: ActivationConfirmRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientActivationConfirmCreate(activationConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mail a fresh link. Always answers 200 — see RESEND_ACK.
     * @param {ActivationResendRequest} activationResendRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientActivationResendCreate(activationResendRequest: ActivationResendRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientActivationResendCreate(activationResendRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Google OAuth login endpoint that handles Google ID token verification, user creation/authentication, and JWT token generation with cookie setting.  Accepts either field name for the Google credential: - \"id_token\": the Google ID token (backend canonical name) - \"credential\": alternate name used by Google Identity Services - \"token\": alternate name for convenience  Returns JWT tokens and sets dx_backend_token cookie for seamless integration with existing authentication system.  Account linking: if a user with the same email already exists (e.g. registered with email/password), their account is linked to Google without overwriting the original provider or password. They can continue to log in with either method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientAuthGoogleLoginCreate(options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientAuthGoogleLoginCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the Google OAuth URL for frontend to redirect users to. This is optional - frontend can construct this URL directly.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientAuthGoogleUrlCreate(options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientAuthGoogleUrlCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the current campaign for the client.  Returns the current campaign ID and its details. If no current campaign is set, the current_campaign field will be null.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientCampaignsCurrentCampaignRetrieve(options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientCampaignsCurrentCampaignRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all campaigns for the current client (both as player and as master). Returns only active campaigns.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientCampaignsListCampaignsRetrieve(options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientCampaignsListCampaignsRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set the current campaign for the client.  The campaign must be active and the client must be either a player or a master in the campaign.
     * @param {string} id A UUID string identifying this campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientCampaignsSetCurrentCampaignCreate(id: string, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientCampaignsSetCurrentCampaignCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpenAIClientManagementRequest} openAIClientManagementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientCreate(openAIClientManagementRequest: OpenAIClientManagementRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientCreate(openAIClientManagementRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the basic information of the current authenticated client. This enpoint used by game client to get current client information It contains information about: is_active, current_campaign, main_character, play_campaigns, master_campaigns, owned_characters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientCurrentInfoRetrieve(options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientCurrentInfoRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this client.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientDestroy(id: string, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientList(options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this client.
     * @param {PatchedOpenAIClientManagementRequest} [patchedOpenAIClientManagementRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientPartialUpdate(id: string, patchedOpenAIClientManagementRequest?: PatchedOpenAIClientManagementRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientPartialUpdate(id, patchedOpenAIClientManagementRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegistrationFormRequest} registrationFormRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientRegisterLocalClientCreate(registrationFormRequest: RegistrationFormRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientRegisterLocalClientCreate(registrationFormRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this client.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this client.
     * @param {OpenAIClientManagementRequest} openAIClientManagementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientUpdate(id: string, openAIClientManagementRequest: OpenAIClientManagementRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientUpdate(id, openAIClientManagementRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CoreApi - axios parameter creator
 * @export
 */
export const CoreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreCharacterStatsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/core/character/stats/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Health check endpoint for Docker container monitoring. Checks database connectivity and returns service status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreHealthRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/core/health/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreStatsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/core/stats/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CharacterStatEnum} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreStatsRetrieve: async (id: CharacterStatEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('coreStatsRetrieve', 'id', id)
            const localVarPath = `/api/core/stats/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreViolationsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/core/violations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImpactViolationTypeEnum} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreViolationsRetrieve: async (id: ImpactViolationTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('coreViolationsRetrieve', 'id', id)
            const localVarPath = `/api/core/violations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CoreApi - functional programming interface
 * @export
 */
export const CoreApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CoreApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coreCharacterStatsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CharacterStatDefinition>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coreCharacterStatsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoreApi.coreCharacterStatsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Health check endpoint for Docker container monitoring. Checks database connectivity and returns service status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coreHealthRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coreHealthRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoreApi.coreHealthRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coreStatsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatObject>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coreStatsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoreApi.coreStatsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CharacterStatEnum} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coreStatsRetrieve(id: CharacterStatEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coreStatsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoreApi.coreStatsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coreViolationsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViolationObject>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coreViolationsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoreApi.coreViolationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ImpactViolationTypeEnum} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coreViolationsRetrieve(id: ImpactViolationTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViolationObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coreViolationsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoreApi.coreViolationsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CoreApi - factory interface
 * @export
 */
export const CoreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CoreApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreCharacterStatsList(options?: any): AxiosPromise<Array<CharacterStatDefinition>> {
            return localVarFp.coreCharacterStatsList(options).then((request) => request(axios, basePath));
        },
        /**
         * Health check endpoint for Docker container monitoring. Checks database connectivity and returns service status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreHealthRetrieve(options?: any): AxiosPromise<void> {
            return localVarFp.coreHealthRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreStatsList(options?: any): AxiosPromise<Array<StatObject>> {
            return localVarFp.coreStatsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CharacterStatEnum} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreStatsRetrieve(id: CharacterStatEnum, options?: any): AxiosPromise<StatObject> {
            return localVarFp.coreStatsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreViolationsList(options?: any): AxiosPromise<Array<ViolationObject>> {
            return localVarFp.coreViolationsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ImpactViolationTypeEnum} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreViolationsRetrieve(id: ImpactViolationTypeEnum, options?: any): AxiosPromise<ViolationObject> {
            return localVarFp.coreViolationsRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CoreApi - object-oriented interface
 * @export
 * @class CoreApi
 * @extends {BaseAPI}
 */
export class CoreApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    public coreCharacterStatsList(options?: RawAxiosRequestConfig) {
        return CoreApiFp(this.configuration).coreCharacterStatsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Health check endpoint for Docker container monitoring. Checks database connectivity and returns service status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    public coreHealthRetrieve(options?: RawAxiosRequestConfig) {
        return CoreApiFp(this.configuration).coreHealthRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    public coreStatsList(options?: RawAxiosRequestConfig) {
        return CoreApiFp(this.configuration).coreStatsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CharacterStatEnum} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    public coreStatsRetrieve(id: CharacterStatEnum, options?: RawAxiosRequestConfig) {
        return CoreApiFp(this.configuration).coreStatsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    public coreViolationsList(options?: RawAxiosRequestConfig) {
        return CoreApiFp(this.configuration).coreViolationsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ImpactViolationTypeEnum} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    public coreViolationsRetrieve(id: ImpactViolationTypeEnum, options?: RawAxiosRequestConfig) {
        return CoreApiFp(this.configuration).coreViolationsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CurrencyApi - axios parameter creator
 * @export
 */
export const CurrencyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyCharacterList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/currency/character/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character currency.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyCharacterRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('currencyCharacterRetrieve', 'id', id)
            const localVarPath = `/api/currency/character/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CurrencyTokenRequest} currencyTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyWorldCreate: async (currencyTokenRequest: CurrencyTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currencyTokenRequest' is not null or undefined
            assertParamExists('currencyWorldCreate', 'currencyTokenRequest', currencyTokenRequest)
            const localVarPath = `/api/currency/world/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(currencyTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this currency token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyWorldDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('currencyWorldDestroy', 'id', id)
            const localVarPath = `/api/currency/world/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyWorldList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/currency/world/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this currency token.
         * @param {PatchedCurrencyTokenRequest} [patchedCurrencyTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyWorldPartialUpdate: async (id: string, patchedCurrencyTokenRequest?: PatchedCurrencyTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('currencyWorldPartialUpdate', 'id', id)
            const localVarPath = `/api/currency/world/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCurrencyTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this currency token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyWorldRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('currencyWorldRetrieve', 'id', id)
            const localVarPath = `/api/currency/world/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this currency token.
         * @param {CurrencyTokenRequest} currencyTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyWorldUpdate: async (id: string, currencyTokenRequest: CurrencyTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('currencyWorldUpdate', 'id', id)
            // verify required parameter 'currencyTokenRequest' is not null or undefined
            assertParamExists('currencyWorldUpdate', 'currencyTokenRequest', currencyTokenRequest)
            const localVarPath = `/api/currency/world/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(currencyTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CurrencyApi - functional programming interface
 * @export
 */
export const CurrencyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CurrencyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currencyCharacterList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CharacterCurrency>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currencyCharacterList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrencyApi.currencyCharacterList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character currency.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currencyCharacterRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterCurrency>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currencyCharacterRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrencyApi.currencyCharacterRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CurrencyTokenRequest} currencyTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currencyWorldCreate(currencyTokenRequest: CurrencyTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrencyToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currencyWorldCreate(currencyTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrencyApi.currencyWorldCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this currency token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currencyWorldDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currencyWorldDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrencyApi.currencyWorldDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currencyWorldList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrencyToken>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currencyWorldList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrencyApi.currencyWorldList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this currency token.
         * @param {PatchedCurrencyTokenRequest} [patchedCurrencyTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currencyWorldPartialUpdate(id: string, patchedCurrencyTokenRequest?: PatchedCurrencyTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrencyToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currencyWorldPartialUpdate(id, patchedCurrencyTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrencyApi.currencyWorldPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this currency token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currencyWorldRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrencyToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currencyWorldRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrencyApi.currencyWorldRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this currency token.
         * @param {CurrencyTokenRequest} currencyTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currencyWorldUpdate(id: string, currencyTokenRequest: CurrencyTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrencyToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currencyWorldUpdate(id, currencyTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrencyApi.currencyWorldUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CurrencyApi - factory interface
 * @export
 */
export const CurrencyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CurrencyApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyCharacterList(options?: any): AxiosPromise<Array<CharacterCurrency>> {
            return localVarFp.currencyCharacterList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character currency.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyCharacterRetrieve(id: string, options?: any): AxiosPromise<CharacterCurrency> {
            return localVarFp.currencyCharacterRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CurrencyTokenRequest} currencyTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyWorldCreate(currencyTokenRequest: CurrencyTokenRequest, options?: any): AxiosPromise<CurrencyToken> {
            return localVarFp.currencyWorldCreate(currencyTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this currency token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyWorldDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.currencyWorldDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyWorldList(options?: any): AxiosPromise<Array<CurrencyToken>> {
            return localVarFp.currencyWorldList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this currency token.
         * @param {PatchedCurrencyTokenRequest} [patchedCurrencyTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyWorldPartialUpdate(id: string, patchedCurrencyTokenRequest?: PatchedCurrencyTokenRequest, options?: any): AxiosPromise<CurrencyToken> {
            return localVarFp.currencyWorldPartialUpdate(id, patchedCurrencyTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this currency token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyWorldRetrieve(id: string, options?: any): AxiosPromise<CurrencyToken> {
            return localVarFp.currencyWorldRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this currency token.
         * @param {CurrencyTokenRequest} currencyTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currencyWorldUpdate(id: string, currencyTokenRequest: CurrencyTokenRequest, options?: any): AxiosPromise<CurrencyToken> {
            return localVarFp.currencyWorldUpdate(id, currencyTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CurrencyApi - object-oriented interface
 * @export
 * @class CurrencyApi
 * @extends {BaseAPI}
 */
export class CurrencyApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrencyApi
     */
    public currencyCharacterList(options?: RawAxiosRequestConfig) {
        return CurrencyApiFp(this.configuration).currencyCharacterList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character currency.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrencyApi
     */
    public currencyCharacterRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CurrencyApiFp(this.configuration).currencyCharacterRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CurrencyTokenRequest} currencyTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrencyApi
     */
    public currencyWorldCreate(currencyTokenRequest: CurrencyTokenRequest, options?: RawAxiosRequestConfig) {
        return CurrencyApiFp(this.configuration).currencyWorldCreate(currencyTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this currency token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrencyApi
     */
    public currencyWorldDestroy(id: string, options?: RawAxiosRequestConfig) {
        return CurrencyApiFp(this.configuration).currencyWorldDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrencyApi
     */
    public currencyWorldList(options?: RawAxiosRequestConfig) {
        return CurrencyApiFp(this.configuration).currencyWorldList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this currency token.
     * @param {PatchedCurrencyTokenRequest} [patchedCurrencyTokenRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrencyApi
     */
    public currencyWorldPartialUpdate(id: string, patchedCurrencyTokenRequest?: PatchedCurrencyTokenRequest, options?: RawAxiosRequestConfig) {
        return CurrencyApiFp(this.configuration).currencyWorldPartialUpdate(id, patchedCurrencyTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this currency token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrencyApi
     */
    public currencyWorldRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CurrencyApiFp(this.configuration).currencyWorldRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this currency token.
     * @param {CurrencyTokenRequest} currencyTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrencyApi
     */
    public currencyWorldUpdate(id: string, currencyTokenRequest: CurrencyTokenRequest, options?: RawAxiosRequestConfig) {
        return CurrencyApiFp(this.configuration).currencyWorldUpdate(id, currencyTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DiceApi - axios parameter creator
 * @export
 */
export const DiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diceChallengeList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dice/challenge/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this challenge.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diceChallengeRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('diceChallengeRetrieve', 'id', id)
            const localVarPath = `/api/dice/challenge/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiceApi - functional programming interface
 * @export
 */
export const DiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async diceChallengeList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChallengeGeneric>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.diceChallengeList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiceApi.diceChallengeList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this challenge.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async diceChallengeRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChallengeGeneric>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.diceChallengeRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiceApi.diceChallengeRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiceApi - factory interface
 * @export
 */
export const DiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diceChallengeList(options?: any): AxiosPromise<Array<ChallengeGeneric>> {
            return localVarFp.diceChallengeList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this challenge.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diceChallengeRetrieve(id: string, options?: any): AxiosPromise<ChallengeGeneric> {
            return localVarFp.diceChallengeRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DiceApi - object-oriented interface
 * @export
 * @class DiceApi
 * @extends {BaseAPI}
 */
export class DiceApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiceApi
     */
    public diceChallengeList(options?: RawAxiosRequestConfig) {
        return DiceApiFp(this.configuration).diceChallengeList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this challenge.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiceApi
     */
    public diceChallengeRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return DiceApiFp(this.configuration).diceChallengeRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EffectsApi - axios parameter creator
 * @export
 */
export const EffectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        effectsActiveList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/effects/active/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this active effect.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        effectsActiveRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('effectsActiveRetrieve', 'id', id)
            const localVarPath = `/api/effects/active/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EffectsApi - functional programming interface
 * @export
 */
export const EffectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EffectsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async effectsActiveList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActiveEffect>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.effectsActiveList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EffectsApi.effectsActiveList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this active effect.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async effectsActiveRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveEffect>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.effectsActiveRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EffectsApi.effectsActiveRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EffectsApi - factory interface
 * @export
 */
export const EffectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EffectsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        effectsActiveList(options?: any): AxiosPromise<Array<ActiveEffect>> {
            return localVarFp.effectsActiveList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this active effect.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        effectsActiveRetrieve(id: string, options?: any): AxiosPromise<ActiveEffect> {
            return localVarFp.effectsActiveRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EffectsApi - object-oriented interface
 * @export
 * @class EffectsApi
 * @extends {BaseAPI}
 */
export class EffectsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EffectsApi
     */
    public effectsActiveList(options?: RawAxiosRequestConfig) {
        return EffectsApiFp(this.configuration).effectsActiveList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this active effect.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EffectsApi
     */
    public effectsActiveRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return EffectsApiFp(this.configuration).effectsActiveRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeedbackApi - axios parameter creator
 * @export
 */
export const FeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Write-only: a player sends feedback, and never reads anyone else\'s.
         * @param {FeedbackRequest} feedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackMessagesCreate: async (feedbackRequest: FeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedbackRequest' is not null or undefined
            assertParamExists('feedbackMessagesCreate', 'feedbackRequest', feedbackRequest)
            const localVarPath = `/api/feedback/messages/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeedbackApi - functional programming interface
 * @export
 */
export const FeedbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeedbackApiAxiosParamCreator(configuration)
    return {
        /**
         * Write-only: a player sends feedback, and never reads anyone else\'s.
         * @param {FeedbackRequest} feedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedbackMessagesCreate(feedbackRequest: FeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Feedback>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feedbackMessagesCreate(feedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeedbackApi.feedbackMessagesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeedbackApi - factory interface
 * @export
 */
export const FeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeedbackApiFp(configuration)
    return {
        /**
         * Write-only: a player sends feedback, and never reads anyone else\'s.
         * @param {FeedbackRequest} feedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackMessagesCreate(feedbackRequest: FeedbackRequest, options?: any): AxiosPromise<Feedback> {
            return localVarFp.feedbackMessagesCreate(feedbackRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeedbackApi - object-oriented interface
 * @export
 * @class FeedbackApi
 * @extends {BaseAPI}
 */
export class FeedbackApi extends BaseAPI {
    /**
     * Write-only: a player sends feedback, and never reads anyone else\'s.
     * @param {FeedbackRequest} feedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedbackApi
     */
    public feedbackMessagesCreate(feedbackRequest: FeedbackRequest, options?: RawAxiosRequestConfig) {
        return FeedbackApiFp(this.configuration).feedbackMessagesCreate(feedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FightApi - axios parameter creator
 * @export
 */
export const FightApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Pick an already-existing side while pending this fight.  Refused unless the caller is pending (``ScreenMode.JOIN_FIGHT`` in this fight) and unassigned — see ``FightSideChoiceService._ensure_choosable``.
         * @param {string} id A UUID string identifying this fight.
         * @param {FightChooseSideRequest} fightChooseSideRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightChooseSideCreate: async (id: string, fightChooseSideRequest: FightChooseSideRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fightFightChooseSideCreate', 'id', id)
            // verify required parameter 'fightChooseSideRequest' is not null or undefined
            assertParamExists('fightFightChooseSideCreate', 'fightChooseSideRequest', fightChooseSideRequest)
            const localVarPath = `/api/fight/fight/{id}/choose_side/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fightChooseSideRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new side and pick it, while pending this fight.  Refused past ``MAX_FIGHT_SIDES`` (``FightSideFactory.create``) and unless the caller is pending and unassigned, exactly like ``choose_side``. A name collision gets the numeric-suffix rule ``FightSideFactory`` applies everywhere else.
         * @param {string} id A UUID string identifying this fight.
         * @param {FightCreateSideRequest} [fightCreateSideRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightCreateSideCreate: async (id: string, fightCreateSideRequest?: FightCreateSideRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fightFightCreateSideCreate', 'id', id)
            const localVarPath = `/api/fight/fight/{id}/create_side/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fightCreateSideRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The clock of the fight the requesting character is in.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightCurrentRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fight/fight/current/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * End the requesting character\'s turn in the round and phase it saw.  A 409 means the fight moved on between the client\'s last read and this call. The body is the fight\'s current state, so one round trip both reports the race and resolves it.
         * @param {string} id A UUID string identifying this fight.
         * @param {FightEndTurnRequest} fightEndTurnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightEndTurnCreate: async (id: string, fightEndTurnRequest: FightEndTurnRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fightFightEndTurnCreate', 'id', id)
            // verify required parameter 'fightEndTurnRequest' is not null or undefined
            assertParamExists('fightFightEndTurnCreate', 'fightEndTurnRequest', fightEndTurnRequest)
            const localVarPath = `/api/fight/fight/{id}/end_turn/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fightEndTurnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vote to end the fight, or withdraw a vote with ``agree=false``.  A knockout no longer closes a fight, so this is how one that has run its course actually stops. It passes only when every *standing* participant has voted; a downed participant has no say and is not counted. Votes die with the round they were cast in.
         * @param {string} id A UUID string identifying this fight.
         * @param {FightEndVoteRequest} [fightEndVoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightEndVoteCreate: async (id: string, fightEndVoteRequest?: FightEndVoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fightFightEndVoteCreate', 'id', id)
            const localVarPath = `/api/fight/fight/{id}/end_vote/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fightEndVoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Old route name, kept for client compatibility. See ``surrender``: this puts the caller into a coma on the spot rather than ending their part in the fight.
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightForfeitCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fightFightForfeitCreate', 'id', id)
            const localVarPath = `/api/fight/fight/{id}/forfeit/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Live duel challenges the requesting character sent or received.  Live, not merely ``PENDING``: the service sweeps the ones that ran out their TTL or whose party is already sealed into a fight, so a client never draws an invitation whose answer the server would refuse. The sweep happens here because the background tick that used to be its only home does not run unless ``FIGHT_WORKER_ENABLED`` is on.  Answering one is an ordinary character action (``MAKE``/``ACCEPT``/``REJECT_DUEL_INVITATION`` through ``POST /api/action/``) — this is read-only, for a client or a GM to see what is outstanding.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightInvitationsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fight/fight/invitations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read a fight, read its clock, and move its clock.  ``retrieve`` keeps returning ``FightGenericSerializer`` unchanged — the roster view the client already consumes. The clock is served separately by ``current`` and ``state`` so a fight\'s participant list and its deadline do not have to be fetched or invalidated together.  Every clock route resolves its fight through ``_clock_fight``, which scopes the lookup to the requesting character\'s campaign (NFR-SEC-1) and, for a training, additionally to the one client who owns it — a training is private to its initiator, so campaign membership alone is not enough to read or move its clock. Business logic lives entirely in ``FightClockService``; these methods validate input and delegate.
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fightFightRetrieve', 'id', id)
            const localVarPath = `/api/fight/fight/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read a fight, read its clock, and move its clock.  ``retrieve`` keeps returning ``FightGenericSerializer`` unchanged — the roster view the client already consumes. The clock is served separately by ``current`` and ``state`` so a fight\'s participant list and its deadline do not have to be fetched or invalidated together.  Every clock route resolves its fight through ``_clock_fight``, which scopes the lookup to the requesting character\'s campaign (NFR-SEC-1) and, for a training, additionally to the one client who owns it — a training is private to its initiator, so campaign membership alone is not enough to read or move its clock. Business logic lives entirely in ``FightClockService``; these methods validate input and delegate.
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightStateRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fightFightStateRetrieve', 'id', id)
            const localVarPath = `/api/fight/fight/{id}/state/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Give up. Available in any phase, at any deadline, at 0 AP.  This does not end the caller\'s part in the fight and does not close it — it puts them into a coma on the spot, acked for the round, and leaves them on the board as a body their side has to fight over. See docs/specs/tactical-combat/02-clock-and-ap.md §Ending the fight.
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightSurrenderCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fightFightSurrenderCreate', 'id', id)
            const localVarPath = `/api/fight/fight/{id}/surrender/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [character] Which owned character to read the training of. Omitted means the character the client is currently playing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightTrainingCurrentRetrieve: async (character?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fight/training/current/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (character !== undefined) {
                localVarQueryParameter['character'] = character;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TrainingStartRequestRequest} [trainingStartRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightTrainingEndCreate: async (trainingStartRequestRequest?: TrainingStartRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fight/training/end/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trainingStartRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TrainingStartRequestRequest} [trainingStartRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightTrainingStartCreate: async (trainingStartRequestRequest?: TrainingStartRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fight/training/start/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trainingStartRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FightApi - functional programming interface
 * @export
 */
export const FightApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FightApiAxiosParamCreator(configuration)
    return {
        /**
         * Pick an already-existing side while pending this fight.  Refused unless the caller is pending (``ScreenMode.JOIN_FIGHT`` in this fight) and unassigned — see ``FightSideChoiceService._ensure_choosable``.
         * @param {string} id A UUID string identifying this fight.
         * @param {FightChooseSideRequest} fightChooseSideRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fightFightChooseSideCreate(id: string, fightChooseSideRequest: FightChooseSideRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FightState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fightFightChooseSideCreate(id, fightChooseSideRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FightApi.fightFightChooseSideCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new side and pick it, while pending this fight.  Refused past ``MAX_FIGHT_SIDES`` (``FightSideFactory.create``) and unless the caller is pending and unassigned, exactly like ``choose_side``. A name collision gets the numeric-suffix rule ``FightSideFactory`` applies everywhere else.
         * @param {string} id A UUID string identifying this fight.
         * @param {FightCreateSideRequest} [fightCreateSideRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fightFightCreateSideCreate(id: string, fightCreateSideRequest?: FightCreateSideRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FightState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fightFightCreateSideCreate(id, fightCreateSideRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FightApi.fightFightCreateSideCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The clock of the fight the requesting character is in.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fightFightCurrentRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FightState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fightFightCurrentRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FightApi.fightFightCurrentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * End the requesting character\'s turn in the round and phase it saw.  A 409 means the fight moved on between the client\'s last read and this call. The body is the fight\'s current state, so one round trip both reports the race and resolves it.
         * @param {string} id A UUID string identifying this fight.
         * @param {FightEndTurnRequest} fightEndTurnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fightFightEndTurnCreate(id: string, fightEndTurnRequest: FightEndTurnRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FightTurnResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fightFightEndTurnCreate(id, fightEndTurnRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FightApi.fightFightEndTurnCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vote to end the fight, or withdraw a vote with ``agree=false``.  A knockout no longer closes a fight, so this is how one that has run its course actually stops. It passes only when every *standing* participant has voted; a downed participant has no say and is not counted. Votes die with the round they were cast in.
         * @param {string} id A UUID string identifying this fight.
         * @param {FightEndVoteRequest} [fightEndVoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fightFightEndVoteCreate(id: string, fightEndVoteRequest?: FightEndVoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FightEndVoteResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fightFightEndVoteCreate(id, fightEndVoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FightApi.fightFightEndVoteCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Old route name, kept for client compatibility. See ``surrender``: this puts the caller into a coma on the spot rather than ending their part in the fight.
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fightFightForfeitCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FightState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fightFightForfeitCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FightApi.fightFightForfeitCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Live duel challenges the requesting character sent or received.  Live, not merely ``PENDING``: the service sweeps the ones that ran out their TTL or whose party is already sealed into a fight, so a client never draws an invitation whose answer the server would refuse. The sweep happens here because the background tick that used to be its only home does not run unless ``FIGHT_WORKER_ENABLED`` is on.  Answering one is an ordinary character action (``MAKE``/``ACCEPT``/``REJECT_DUEL_INVITATION`` through ``POST /api/action/``) — this is read-only, for a client or a GM to see what is outstanding.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fightFightInvitationsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FightInvitation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fightFightInvitationsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FightApi.fightFightInvitationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read a fight, read its clock, and move its clock.  ``retrieve`` keeps returning ``FightGenericSerializer`` unchanged — the roster view the client already consumes. The clock is served separately by ``current`` and ``state`` so a fight\'s participant list and its deadline do not have to be fetched or invalidated together.  Every clock route resolves its fight through ``_clock_fight``, which scopes the lookup to the requesting character\'s campaign (NFR-SEC-1) and, for a training, additionally to the one client who owns it — a training is private to its initiator, so campaign membership alone is not enough to read or move its clock. Business logic lives entirely in ``FightClockService``; these methods validate input and delegate.
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fightFightRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FightGeneric>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fightFightRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FightApi.fightFightRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read a fight, read its clock, and move its clock.  ``retrieve`` keeps returning ``FightGenericSerializer`` unchanged — the roster view the client already consumes. The clock is served separately by ``current`` and ``state`` so a fight\'s participant list and its deadline do not have to be fetched or invalidated together.  Every clock route resolves its fight through ``_clock_fight``, which scopes the lookup to the requesting character\'s campaign (NFR-SEC-1) and, for a training, additionally to the one client who owns it — a training is private to its initiator, so campaign membership alone is not enough to read or move its clock. Business logic lives entirely in ``FightClockService``; these methods validate input and delegate.
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fightFightStateRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FightState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fightFightStateRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FightApi.fightFightStateRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Give up. Available in any phase, at any deadline, at 0 AP.  This does not end the caller\'s part in the fight and does not close it — it puts them into a coma on the spot, acked for the round, and leaves them on the board as a body their side has to fight over. See docs/specs/tactical-combat/02-clock-and-ap.md §Ending the fight.
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fightFightSurrenderCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FightState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fightFightSurrenderCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FightApi.fightFightSurrenderCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [character] Which owned character to read the training of. Omitted means the character the client is currently playing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fightTrainingCurrentRetrieve(character?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fightTrainingCurrentRetrieve(character, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FightApi.fightTrainingCurrentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TrainingStartRequestRequest} [trainingStartRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fightTrainingEndCreate(trainingStartRequestRequest?: TrainingStartRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fightTrainingEndCreate(trainingStartRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FightApi.fightTrainingEndCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TrainingStartRequestRequest} [trainingStartRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fightTrainingStartCreate(trainingStartRequestRequest?: TrainingStartRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fightTrainingStartCreate(trainingStartRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FightApi.fightTrainingStartCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FightApi - factory interface
 * @export
 */
export const FightApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FightApiFp(configuration)
    return {
        /**
         * Pick an already-existing side while pending this fight.  Refused unless the caller is pending (``ScreenMode.JOIN_FIGHT`` in this fight) and unassigned — see ``FightSideChoiceService._ensure_choosable``.
         * @param {string} id A UUID string identifying this fight.
         * @param {FightChooseSideRequest} fightChooseSideRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightChooseSideCreate(id: string, fightChooseSideRequest: FightChooseSideRequest, options?: any): AxiosPromise<FightState> {
            return localVarFp.fightFightChooseSideCreate(id, fightChooseSideRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new side and pick it, while pending this fight.  Refused past ``MAX_FIGHT_SIDES`` (``FightSideFactory.create``) and unless the caller is pending and unassigned, exactly like ``choose_side``. A name collision gets the numeric-suffix rule ``FightSideFactory`` applies everywhere else.
         * @param {string} id A UUID string identifying this fight.
         * @param {FightCreateSideRequest} [fightCreateSideRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightCreateSideCreate(id: string, fightCreateSideRequest?: FightCreateSideRequest, options?: any): AxiosPromise<FightState> {
            return localVarFp.fightFightCreateSideCreate(id, fightCreateSideRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The clock of the fight the requesting character is in.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightCurrentRetrieve(options?: any): AxiosPromise<FightState> {
            return localVarFp.fightFightCurrentRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * End the requesting character\'s turn in the round and phase it saw.  A 409 means the fight moved on between the client\'s last read and this call. The body is the fight\'s current state, so one round trip both reports the race and resolves it.
         * @param {string} id A UUID string identifying this fight.
         * @param {FightEndTurnRequest} fightEndTurnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightEndTurnCreate(id: string, fightEndTurnRequest: FightEndTurnRequest, options?: any): AxiosPromise<FightTurnResult> {
            return localVarFp.fightFightEndTurnCreate(id, fightEndTurnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Vote to end the fight, or withdraw a vote with ``agree=false``.  A knockout no longer closes a fight, so this is how one that has run its course actually stops. It passes only when every *standing* participant has voted; a downed participant has no say and is not counted. Votes die with the round they were cast in.
         * @param {string} id A UUID string identifying this fight.
         * @param {FightEndVoteRequest} [fightEndVoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightEndVoteCreate(id: string, fightEndVoteRequest?: FightEndVoteRequest, options?: any): AxiosPromise<FightEndVoteResult> {
            return localVarFp.fightFightEndVoteCreate(id, fightEndVoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Old route name, kept for client compatibility. See ``surrender``: this puts the caller into a coma on the spot rather than ending their part in the fight.
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightForfeitCreate(id: string, options?: any): AxiosPromise<FightState> {
            return localVarFp.fightFightForfeitCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Live duel challenges the requesting character sent or received.  Live, not merely ``PENDING``: the service sweeps the ones that ran out their TTL or whose party is already sealed into a fight, so a client never draws an invitation whose answer the server would refuse. The sweep happens here because the background tick that used to be its only home does not run unless ``FIGHT_WORKER_ENABLED`` is on.  Answering one is an ordinary character action (``MAKE``/``ACCEPT``/``REJECT_DUEL_INVITATION`` through ``POST /api/action/``) — this is read-only, for a client or a GM to see what is outstanding.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightInvitationsList(options?: any): AxiosPromise<Array<FightInvitation>> {
            return localVarFp.fightFightInvitationsList(options).then((request) => request(axios, basePath));
        },
        /**
         * Read a fight, read its clock, and move its clock.  ``retrieve`` keeps returning ``FightGenericSerializer`` unchanged — the roster view the client already consumes. The clock is served separately by ``current`` and ``state`` so a fight\'s participant list and its deadline do not have to be fetched or invalidated together.  Every clock route resolves its fight through ``_clock_fight``, which scopes the lookup to the requesting character\'s campaign (NFR-SEC-1) and, for a training, additionally to the one client who owns it — a training is private to its initiator, so campaign membership alone is not enough to read or move its clock. Business logic lives entirely in ``FightClockService``; these methods validate input and delegate.
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightRetrieve(id: string, options?: any): AxiosPromise<FightGeneric> {
            return localVarFp.fightFightRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Read a fight, read its clock, and move its clock.  ``retrieve`` keeps returning ``FightGenericSerializer`` unchanged — the roster view the client already consumes. The clock is served separately by ``current`` and ``state`` so a fight\'s participant list and its deadline do not have to be fetched or invalidated together.  Every clock route resolves its fight through ``_clock_fight``, which scopes the lookup to the requesting character\'s campaign (NFR-SEC-1) and, for a training, additionally to the one client who owns it — a training is private to its initiator, so campaign membership alone is not enough to read or move its clock. Business logic lives entirely in ``FightClockService``; these methods validate input and delegate.
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightStateRetrieve(id: string, options?: any): AxiosPromise<FightState> {
            return localVarFp.fightFightStateRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Give up. Available in any phase, at any deadline, at 0 AP.  This does not end the caller\'s part in the fight and does not close it — it puts them into a coma on the spot, acked for the round, and leaves them on the board as a body their side has to fight over. See docs/specs/tactical-combat/02-clock-and-ap.md §Ending the fight.
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightFightSurrenderCreate(id: string, options?: any): AxiosPromise<FightState> {
            return localVarFp.fightFightSurrenderCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [character] Which owned character to read the training of. Omitted means the character the client is currently playing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightTrainingCurrentRetrieve(character?: string, options?: any): AxiosPromise<TrainingSession> {
            return localVarFp.fightTrainingCurrentRetrieve(character, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TrainingStartRequestRequest} [trainingStartRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightTrainingEndCreate(trainingStartRequestRequest?: TrainingStartRequestRequest, options?: any): AxiosPromise<void> {
            return localVarFp.fightTrainingEndCreate(trainingStartRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TrainingStartRequestRequest} [trainingStartRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fightTrainingStartCreate(trainingStartRequestRequest?: TrainingStartRequestRequest, options?: any): AxiosPromise<TrainingSession> {
            return localVarFp.fightTrainingStartCreate(trainingStartRequestRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FightApi - object-oriented interface
 * @export
 * @class FightApi
 * @extends {BaseAPI}
 */
export class FightApi extends BaseAPI {
    /**
     * Pick an already-existing side while pending this fight.  Refused unless the caller is pending (``ScreenMode.JOIN_FIGHT`` in this fight) and unassigned — see ``FightSideChoiceService._ensure_choosable``.
     * @param {string} id A UUID string identifying this fight.
     * @param {FightChooseSideRequest} fightChooseSideRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FightApi
     */
    public fightFightChooseSideCreate(id: string, fightChooseSideRequest: FightChooseSideRequest, options?: RawAxiosRequestConfig) {
        return FightApiFp(this.configuration).fightFightChooseSideCreate(id, fightChooseSideRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new side and pick it, while pending this fight.  Refused past ``MAX_FIGHT_SIDES`` (``FightSideFactory.create``) and unless the caller is pending and unassigned, exactly like ``choose_side``. A name collision gets the numeric-suffix rule ``FightSideFactory`` applies everywhere else.
     * @param {string} id A UUID string identifying this fight.
     * @param {FightCreateSideRequest} [fightCreateSideRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FightApi
     */
    public fightFightCreateSideCreate(id: string, fightCreateSideRequest?: FightCreateSideRequest, options?: RawAxiosRequestConfig) {
        return FightApiFp(this.configuration).fightFightCreateSideCreate(id, fightCreateSideRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The clock of the fight the requesting character is in.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FightApi
     */
    public fightFightCurrentRetrieve(options?: RawAxiosRequestConfig) {
        return FightApiFp(this.configuration).fightFightCurrentRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * End the requesting character\'s turn in the round and phase it saw.  A 409 means the fight moved on between the client\'s last read and this call. The body is the fight\'s current state, so one round trip both reports the race and resolves it.
     * @param {string} id A UUID string identifying this fight.
     * @param {FightEndTurnRequest} fightEndTurnRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FightApi
     */
    public fightFightEndTurnCreate(id: string, fightEndTurnRequest: FightEndTurnRequest, options?: RawAxiosRequestConfig) {
        return FightApiFp(this.configuration).fightFightEndTurnCreate(id, fightEndTurnRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vote to end the fight, or withdraw a vote with ``agree=false``.  A knockout no longer closes a fight, so this is how one that has run its course actually stops. It passes only when every *standing* participant has voted; a downed participant has no say and is not counted. Votes die with the round they were cast in.
     * @param {string} id A UUID string identifying this fight.
     * @param {FightEndVoteRequest} [fightEndVoteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FightApi
     */
    public fightFightEndVoteCreate(id: string, fightEndVoteRequest?: FightEndVoteRequest, options?: RawAxiosRequestConfig) {
        return FightApiFp(this.configuration).fightFightEndVoteCreate(id, fightEndVoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Old route name, kept for client compatibility. See ``surrender``: this puts the caller into a coma on the spot rather than ending their part in the fight.
     * @param {string} id A UUID string identifying this fight.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FightApi
     */
    public fightFightForfeitCreate(id: string, options?: RawAxiosRequestConfig) {
        return FightApiFp(this.configuration).fightFightForfeitCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Live duel challenges the requesting character sent or received.  Live, not merely ``PENDING``: the service sweeps the ones that ran out their TTL or whose party is already sealed into a fight, so a client never draws an invitation whose answer the server would refuse. The sweep happens here because the background tick that used to be its only home does not run unless ``FIGHT_WORKER_ENABLED`` is on.  Answering one is an ordinary character action (``MAKE``/``ACCEPT``/``REJECT_DUEL_INVITATION`` through ``POST /api/action/``) — this is read-only, for a client or a GM to see what is outstanding.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FightApi
     */
    public fightFightInvitationsList(options?: RawAxiosRequestConfig) {
        return FightApiFp(this.configuration).fightFightInvitationsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read a fight, read its clock, and move its clock.  ``retrieve`` keeps returning ``FightGenericSerializer`` unchanged — the roster view the client already consumes. The clock is served separately by ``current`` and ``state`` so a fight\'s participant list and its deadline do not have to be fetched or invalidated together.  Every clock route resolves its fight through ``_clock_fight``, which scopes the lookup to the requesting character\'s campaign (NFR-SEC-1) and, for a training, additionally to the one client who owns it — a training is private to its initiator, so campaign membership alone is not enough to read or move its clock. Business logic lives entirely in ``FightClockService``; these methods validate input and delegate.
     * @param {string} id A UUID string identifying this fight.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FightApi
     */
    public fightFightRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return FightApiFp(this.configuration).fightFightRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read a fight, read its clock, and move its clock.  ``retrieve`` keeps returning ``FightGenericSerializer`` unchanged — the roster view the client already consumes. The clock is served separately by ``current`` and ``state`` so a fight\'s participant list and its deadline do not have to be fetched or invalidated together.  Every clock route resolves its fight through ``_clock_fight``, which scopes the lookup to the requesting character\'s campaign (NFR-SEC-1) and, for a training, additionally to the one client who owns it — a training is private to its initiator, so campaign membership alone is not enough to read or move its clock. Business logic lives entirely in ``FightClockService``; these methods validate input and delegate.
     * @param {string} id A UUID string identifying this fight.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FightApi
     */
    public fightFightStateRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return FightApiFp(this.configuration).fightFightStateRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Give up. Available in any phase, at any deadline, at 0 AP.  This does not end the caller\'s part in the fight and does not close it — it puts them into a coma on the spot, acked for the round, and leaves them on the board as a body their side has to fight over. See docs/specs/tactical-combat/02-clock-and-ap.md §Ending the fight.
     * @param {string} id A UUID string identifying this fight.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FightApi
     */
    public fightFightSurrenderCreate(id: string, options?: RawAxiosRequestConfig) {
        return FightApiFp(this.configuration).fightFightSurrenderCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [character] Which owned character to read the training of. Omitted means the character the client is currently playing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FightApi
     */
    public fightTrainingCurrentRetrieve(character?: string, options?: RawAxiosRequestConfig) {
        return FightApiFp(this.configuration).fightTrainingCurrentRetrieve(character, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TrainingStartRequestRequest} [trainingStartRequestRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FightApi
     */
    public fightTrainingEndCreate(trainingStartRequestRequest?: TrainingStartRequestRequest, options?: RawAxiosRequestConfig) {
        return FightApiFp(this.configuration).fightTrainingEndCreate(trainingStartRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TrainingStartRequestRequest} [trainingStartRequestRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FightApi
     */
    public fightTrainingStartCreate(trainingStartRequestRequest?: TrainingStartRequestRequest, options?: RawAxiosRequestConfig) {
        return FightApiFp(this.configuration).fightTrainingStartCreate(trainingStartRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GMWorldEditiorPositionConnectionsApi - axios parameter creator
 * @export
 */
export const GMWorldEditiorPositionConnectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activate a connection
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsActivateCreate: async (id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsActivateCreate', 'id', id)
            // verify required parameter 'gameMasterPositionConnectionRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsActivateCreate', 'gameMasterPositionConnectionRequest', gameMasterPositionConnectionRequest)
            const localVarPath = `/api/gamemaster/world-position-connections/{id}/activate/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterPositionConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Configure a connection with requirements
         * @param {number} id A unique integer value identifying this position connection.
         * @param {PositionRelationConfigurationRequest} [positionRelationConfigurationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsConfigureCreate: async (id: number, positionRelationConfigurationRequest?: PositionRelationConfigurationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsConfigureCreate', 'id', id)
            const localVarPath = `/api/gamemaster/world-position-connections/{id}/configure/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionRelationConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a connection between two positions
         * @param {PositionConnectionCreateRequest} positionConnectionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsConnectCreate: async (positionConnectionCreateRequest: PositionConnectionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionConnectionCreateRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsConnectCreate', 'positionConnectionCreateRequest', positionConnectionCreateRequest)
            const localVarPath = `/api/gamemaster/world-position-connections/connect/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionConnectionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing position connections in the world
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsCreate: async (gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameMasterPositionConnectionRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsCreate', 'gameMasterPositionConnectionRequest', gameMasterPositionConnectionRequest)
            const localVarPath = `/api/gamemaster/world-position-connections/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterPositionConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate a connection
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsDeactivateCreate: async (id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsDeactivateCreate', 'id', id)
            // verify required parameter 'gameMasterPositionConnectionRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsDeactivateCreate', 'gameMasterPositionConnectionRequest', gameMasterPositionConnectionRequest)
            const localVarPath = `/api/gamemaster/world-position-connections/{id}/deactivate/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterPositionConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing position connections in the world
         * @param {number} id A unique integer value identifying this position connection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsDestroy: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsDestroy', 'id', id)
            const localVarPath = `/api/gamemaster/world-position-connections/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing position connections in the world
         * @param {boolean} [isActive] 
         * @param {boolean} [isPublic] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsList: async (isActive?: boolean, isPublic?: boolean, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-position-connections/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (isPublic !== undefined) {
                localVarQueryParameter['is_public'] = isPublic;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lock a connection
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsLockCreate: async (id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsLockCreate', 'id', id)
            // verify required parameter 'gameMasterPositionConnectionRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsLockCreate', 'gameMasterPositionConnectionRequest', gameMasterPositionConnectionRequest)
            const localVarPath = `/api/gamemaster/world-position-connections/{id}/lock/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterPositionConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing position connections in the world
         * @param {number} id A unique integer value identifying this position connection.
         * @param {PatchedGameMasterPositionConnectionRequest} [patchedGameMasterPositionConnectionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsPartialUpdate: async (id: number, patchedGameMasterPositionConnectionRequest?: PatchedGameMasterPositionConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/world-position-connections/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGameMasterPositionConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing position connections in the world
         * @param {number} id A unique integer value identifying this position connection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsRetrieve: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/world-position-connections/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set a connection as private
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsSetPrivateCreate: async (id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsSetPrivateCreate', 'id', id)
            // verify required parameter 'gameMasterPositionConnectionRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsSetPrivateCreate', 'gameMasterPositionConnectionRequest', gameMasterPositionConnectionRequest)
            const localVarPath = `/api/gamemaster/world-position-connections/{id}/setPrivate/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterPositionConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set a connection as public
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsSetPublicCreate: async (id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsSetPublicCreate', 'id', id)
            // verify required parameter 'gameMasterPositionConnectionRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsSetPublicCreate', 'gameMasterPositionConnectionRequest', gameMasterPositionConnectionRequest)
            const localVarPath = `/api/gamemaster/world-position-connections/{id}/setPublic/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterPositionConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unlock a connection
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsUnlockCreate: async (id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsUnlockCreate', 'id', id)
            // verify required parameter 'gameMasterPositionConnectionRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsUnlockCreate', 'gameMasterPositionConnectionRequest', gameMasterPositionConnectionRequest)
            const localVarPath = `/api/gamemaster/world-position-connections/{id}/unlock/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterPositionConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing position connections in the world
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsUpdate: async (id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsUpdate', 'id', id)
            // verify required parameter 'gameMasterPositionConnectionRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionConnectionsUpdate', 'gameMasterPositionConnectionRequest', gameMasterPositionConnectionRequest)
            const localVarPath = `/api/gamemaster/world-position-connections/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterPositionConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GMWorldEditiorPositionConnectionsApi - functional programming interface
 * @export
 */
export const GMWorldEditiorPositionConnectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GMWorldEditiorPositionConnectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Activate a connection
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsActivateCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsActivateCreate(id, gameMasterPositionConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsActivateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Configure a connection with requirements
         * @param {number} id A unique integer value identifying this position connection.
         * @param {PositionRelationConfigurationRequest} [positionRelationConfigurationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsConfigureCreate(id: number, positionRelationConfigurationRequest?: PositionRelationConfigurationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsConfigureCreate(id, positionRelationConfigurationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsConfigureCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a connection between two positions
         * @param {PositionConnectionCreateRequest} positionConnectionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsConnectCreate(positionConnectionCreateRequest: PositionConnectionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsConnectCreate(positionConnectionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsConnectCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing position connections in the world
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsCreate(gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsCreate(gameMasterPositionConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deactivate a connection
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsDeactivateCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsDeactivateCreate(id, gameMasterPositionConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsDeactivateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing position connections in the world
         * @param {number} id A unique integer value identifying this position connection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsDestroy(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing position connections in the world
         * @param {boolean} [isActive] 
         * @param {boolean} [isPublic] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsList(isActive?: boolean, isPublic?: boolean, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterPositionConnection>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsList(isActive, isPublic, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lock a connection
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsLockCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsLockCreate(id, gameMasterPositionConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsLockCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing position connections in the world
         * @param {number} id A unique integer value identifying this position connection.
         * @param {PatchedGameMasterPositionConnectionRequest} [patchedGameMasterPositionConnectionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsPartialUpdate(id: number, patchedGameMasterPositionConnectionRequest?: PatchedGameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsPartialUpdate(id, patchedGameMasterPositionConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing position connections in the world
         * @param {number} id A unique integer value identifying this position connection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsRetrieve(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set a connection as private
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsSetPrivateCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsSetPrivateCreate(id, gameMasterPositionConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsSetPrivateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set a connection as public
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsSetPublicCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsSetPublicCreate(id, gameMasterPositionConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsSetPublicCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unlock a connection
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsUnlockCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsUnlockCreate(id, gameMasterPositionConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsUnlockCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing position connections in the world
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionConnectionsUpdate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionConnectionsUpdate(id, gameMasterPositionConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionConnectionsApi.gamemasterWorldPositionConnectionsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GMWorldEditiorPositionConnectionsApi - factory interface
 * @export
 */
export const GMWorldEditiorPositionConnectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GMWorldEditiorPositionConnectionsApiFp(configuration)
    return {
        /**
         * Activate a connection
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsActivateCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: any): AxiosPromise<GameMasterPositionConnection> {
            return localVarFp.gamemasterWorldPositionConnectionsActivateCreate(id, gameMasterPositionConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Configure a connection with requirements
         * @param {number} id A unique integer value identifying this position connection.
         * @param {PositionRelationConfigurationRequest} [positionRelationConfigurationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsConfigureCreate(id: number, positionRelationConfigurationRequest?: PositionRelationConfigurationRequest, options?: any): AxiosPromise<GameMasterPositionConnection> {
            return localVarFp.gamemasterWorldPositionConnectionsConfigureCreate(id, positionRelationConfigurationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a connection between two positions
         * @param {PositionConnectionCreateRequest} positionConnectionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsConnectCreate(positionConnectionCreateRequest: PositionConnectionCreateRequest, options?: any): AxiosPromise<GameMasterPositionConnection> {
            return localVarFp.gamemasterWorldPositionConnectionsConnectCreate(positionConnectionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing position connections in the world
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsCreate(gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: any): AxiosPromise<GameMasterPositionConnection> {
            return localVarFp.gamemasterWorldPositionConnectionsCreate(gameMasterPositionConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate a connection
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsDeactivateCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: any): AxiosPromise<GameMasterPositionConnection> {
            return localVarFp.gamemasterWorldPositionConnectionsDeactivateCreate(id, gameMasterPositionConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing position connections in the world
         * @param {number} id A unique integer value identifying this position connection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsDestroy(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.gamemasterWorldPositionConnectionsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing position connections in the world
         * @param {boolean} [isActive] 
         * @param {boolean} [isPublic] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsList(isActive?: boolean, isPublic?: boolean, ordering?: string, options?: any): AxiosPromise<Array<GameMasterPositionConnection>> {
            return localVarFp.gamemasterWorldPositionConnectionsList(isActive, isPublic, ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * Lock a connection
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsLockCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: any): AxiosPromise<GameMasterPositionConnection> {
            return localVarFp.gamemasterWorldPositionConnectionsLockCreate(id, gameMasterPositionConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing position connections in the world
         * @param {number} id A unique integer value identifying this position connection.
         * @param {PatchedGameMasterPositionConnectionRequest} [patchedGameMasterPositionConnectionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsPartialUpdate(id: number, patchedGameMasterPositionConnectionRequest?: PatchedGameMasterPositionConnectionRequest, options?: any): AxiosPromise<GameMasterPositionConnection> {
            return localVarFp.gamemasterWorldPositionConnectionsPartialUpdate(id, patchedGameMasterPositionConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing position connections in the world
         * @param {number} id A unique integer value identifying this position connection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsRetrieve(id: number, options?: any): AxiosPromise<GameMasterPositionConnection> {
            return localVarFp.gamemasterWorldPositionConnectionsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Set a connection as private
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsSetPrivateCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: any): AxiosPromise<GameMasterPositionConnection> {
            return localVarFp.gamemasterWorldPositionConnectionsSetPrivateCreate(id, gameMasterPositionConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Set a connection as public
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsSetPublicCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: any): AxiosPromise<GameMasterPositionConnection> {
            return localVarFp.gamemasterWorldPositionConnectionsSetPublicCreate(id, gameMasterPositionConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Unlock a connection
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsUnlockCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: any): AxiosPromise<GameMasterPositionConnection> {
            return localVarFp.gamemasterWorldPositionConnectionsUnlockCreate(id, gameMasterPositionConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing position connections in the world
         * @param {number} id A unique integer value identifying this position connection.
         * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionConnectionsUpdate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: any): AxiosPromise<GameMasterPositionConnection> {
            return localVarFp.gamemasterWorldPositionConnectionsUpdate(id, gameMasterPositionConnectionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GMWorldEditiorPositionConnectionsApi - object-oriented interface
 * @export
 * @class GMWorldEditiorPositionConnectionsApi
 * @extends {BaseAPI}
 */
export class GMWorldEditiorPositionConnectionsApi extends BaseAPI {
    /**
     * Activate a connection
     * @param {number} id A unique integer value identifying this position connection.
     * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsActivateCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsActivateCreate(id, gameMasterPositionConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Configure a connection with requirements
     * @param {number} id A unique integer value identifying this position connection.
     * @param {PositionRelationConfigurationRequest} [positionRelationConfigurationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsConfigureCreate(id: number, positionRelationConfigurationRequest?: PositionRelationConfigurationRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsConfigureCreate(id, positionRelationConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a connection between two positions
     * @param {PositionConnectionCreateRequest} positionConnectionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsConnectCreate(positionConnectionCreateRequest: PositionConnectionCreateRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsConnectCreate(positionConnectionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing position connections in the world
     * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsCreate(gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsCreate(gameMasterPositionConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate a connection
     * @param {number} id A unique integer value identifying this position connection.
     * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsDeactivateCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsDeactivateCreate(id, gameMasterPositionConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing position connections in the world
     * @param {number} id A unique integer value identifying this position connection.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsDestroy(id: number, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing position connections in the world
     * @param {boolean} [isActive] 
     * @param {boolean} [isPublic] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsList(isActive?: boolean, isPublic?: boolean, ordering?: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsList(isActive, isPublic, ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lock a connection
     * @param {number} id A unique integer value identifying this position connection.
     * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsLockCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsLockCreate(id, gameMasterPositionConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing position connections in the world
     * @param {number} id A unique integer value identifying this position connection.
     * @param {PatchedGameMasterPositionConnectionRequest} [patchedGameMasterPositionConnectionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsPartialUpdate(id: number, patchedGameMasterPositionConnectionRequest?: PatchedGameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsPartialUpdate(id, patchedGameMasterPositionConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing position connections in the world
     * @param {number} id A unique integer value identifying this position connection.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsRetrieve(id: number, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set a connection as private
     * @param {number} id A unique integer value identifying this position connection.
     * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsSetPrivateCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsSetPrivateCreate(id, gameMasterPositionConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set a connection as public
     * @param {number} id A unique integer value identifying this position connection.
     * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsSetPublicCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsSetPublicCreate(id, gameMasterPositionConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unlock a connection
     * @param {number} id A unique integer value identifying this position connection.
     * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsUnlockCreate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsUnlockCreate(id, gameMasterPositionConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing position connections in the world
     * @param {number} id A unique integer value identifying this position connection.
     * @param {GameMasterPositionConnectionRequest} gameMasterPositionConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionConnectionsApi
     */
    public gamemasterWorldPositionConnectionsUpdate(id: number, gameMasterPositionConnectionRequest: GameMasterPositionConnectionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionConnectionsApiFp(this.configuration).gamemasterWorldPositionConnectionsUpdate(id, gameMasterPositionConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GMWorldEditiorPositionsApi - axios parameter creator
 * @export
 */
export const GMWorldEditiorPositionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API for managing positions in the world
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsCreate: async (positionRequest: PositionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionsCreate', 'positionRequest', positionRequest)
            const localVarPath = `/api/gamemaster/world-positions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing positions in the world
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionsDestroy', 'id', id)
            const localVarPath = `/api/gamemaster/world-positions/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The predefined labels a game master can pick: room kinds and map markers, each with the icon it draws. Free-text labels are still accepted and are kept as tags.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsLabelCatalogRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-positions/label-catalog/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add one label. A known kind or marker takes over its own slot; anything else is appended as a free tag.
         * @param {string} id A UUID string identifying this position.
         * @param {GameMasterPositionLabelWriteRequest} gameMasterPositionLabelWriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsLabelsAddCreate: async (id: string, gameMasterPositionLabelWriteRequest: GameMasterPositionLabelWriteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionsLabelsAddCreate', 'id', id)
            // verify required parameter 'gameMasterPositionLabelWriteRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionsLabelsAddCreate', 'gameMasterPositionLabelWriteRequest', gameMasterPositionLabelWriteRequest)
            const localVarPath = `/api/gamemaster/world-positions/{id}/labels/add/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterPositionLabelWriteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove one label, leaving the remaining slots in place.
         * @param {string} id A UUID string identifying this position.
         * @param {GameMasterPositionLabelWriteRequest} gameMasterPositionLabelWriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsLabelsRemoveCreate: async (id: string, gameMasterPositionLabelWriteRequest: GameMasterPositionLabelWriteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionsLabelsRemoveCreate', 'id', id)
            // verify required parameter 'gameMasterPositionLabelWriteRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionsLabelsRemoveCreate', 'gameMasterPositionLabelWriteRequest', gameMasterPositionLabelWriteRequest)
            const localVarPath = `/api/gamemaster/world-positions/{id}/labels/remove/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterPositionLabelWriteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read this position\'s labels as their slots - kind, marker, name, tags - together with any conflict between them.
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsLabelsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionsLabelsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/world-positions/{id}/labels/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace every label on a position, slot by slot.
         * @param {string} id A UUID string identifying this position.
         * @param {GameMasterPositionLabelSetRequest} [gameMasterPositionLabelSetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsLabelsSetUpdate: async (id: string, gameMasterPositionLabelSetRequest?: GameMasterPositionLabelSetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionsLabelsSetUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/world-positions/{id}/labels/set/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterPositionLabelSetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing positions in the world
         * @param {number} [gridZ] 
         * @param {boolean} [isSafe] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [subLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsList: async (gridZ?: number, isSafe?: boolean, ordering?: string, subLocation?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-positions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gridZ !== undefined) {
                localVarQueryParameter['grid_z'] = gridZ;
            }

            if (isSafe !== undefined) {
                localVarQueryParameter['is_safe'] = isSafe;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (subLocation !== undefined) {
                localVarQueryParameter['sub_location'] = subLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark a position as dangerous
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsMarkDangerousCreate: async (id: string, positionRequest: PositionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionsMarkDangerousCreate', 'id', id)
            // verify required parameter 'positionRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionsMarkDangerousCreate', 'positionRequest', positionRequest)
            const localVarPath = `/api/gamemaster/world-positions/{id}/markDangerous/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark a position as safe
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsMarkSafeCreate: async (id: string, positionRequest: PositionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionsMarkSafeCreate', 'id', id)
            // verify required parameter 'positionRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionsMarkSafeCreate', 'positionRequest', positionRequest)
            const localVarPath = `/api/gamemaster/world-positions/{id}/markSafe/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move a position to new coordinates
         * @param {string} id A UUID string identifying this position.
         * @param {PositionMoveRequest} positionMoveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsMoveCreate: async (id: string, positionMoveRequest: PositionMoveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionsMoveCreate', 'id', id)
            // verify required parameter 'positionMoveRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionsMoveCreate', 'positionMoveRequest', positionMoveRequest)
            const localVarPath = `/api/gamemaster/world-positions/{id}/move/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionMoveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing positions in the world
         * @param {string} id A UUID string identifying this position.
         * @param {PatchedPositionRequest} [patchedPositionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsPartialUpdate: async (id: string, patchedPositionRequest?: PatchedPositionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionsPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/world-positions/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedPositionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing positions in the world
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/world-positions/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing positions in the world
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsUpdate: async (id: string, positionRequest: PositionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPositionsUpdate', 'id', id)
            // verify required parameter 'positionRequest' is not null or undefined
            assertParamExists('gamemasterWorldPositionsUpdate', 'positionRequest', positionRequest)
            const localVarPath = `/api/gamemaster/world-positions/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GMWorldEditiorPositionsApi - functional programming interface
 * @export
 */
export const GMWorldEditiorPositionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GMWorldEditiorPositionsApiAxiosParamCreator(configuration)
    return {
        /**
         * API for managing positions in the world
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsCreate(positionRequest: PositionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsCreate(positionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing positions in the world
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The predefined labels a game master can pick: room kinds and map markers, each with the icon it draws. Free-text labels are still accepted and are kept as tags.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsLabelCatalogRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionLabelCatalog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsLabelCatalogRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsLabelCatalogRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add one label. A known kind or marker takes over its own slot; anything else is appended as a free tag.
         * @param {string} id A UUID string identifying this position.
         * @param {GameMasterPositionLabelWriteRequest} gameMasterPositionLabelWriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsLabelsAddCreate(id: string, gameMasterPositionLabelWriteRequest: GameMasterPositionLabelWriteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionLabelState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsLabelsAddCreate(id, gameMasterPositionLabelWriteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsLabelsAddCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove one label, leaving the remaining slots in place.
         * @param {string} id A UUID string identifying this position.
         * @param {GameMasterPositionLabelWriteRequest} gameMasterPositionLabelWriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsLabelsRemoveCreate(id: string, gameMasterPositionLabelWriteRequest: GameMasterPositionLabelWriteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionLabelState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsLabelsRemoveCreate(id, gameMasterPositionLabelWriteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsLabelsRemoveCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read this position\'s labels as their slots - kind, marker, name, tags - together with any conflict between them.
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsLabelsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionLabelState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsLabelsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsLabelsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replace every label on a position, slot by slot.
         * @param {string} id A UUID string identifying this position.
         * @param {GameMasterPositionLabelSetRequest} [gameMasterPositionLabelSetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsLabelsSetUpdate(id: string, gameMasterPositionLabelSetRequest?: GameMasterPositionLabelSetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterPositionLabelState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsLabelsSetUpdate(id, gameMasterPositionLabelSetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsLabelsSetUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing positions in the world
         * @param {number} [gridZ] 
         * @param {boolean} [isSafe] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [subLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsList(gridZ?: number, isSafe?: boolean, ordering?: string, subLocation?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Position>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsList(gridZ, isSafe, ordering, subLocation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark a position as dangerous
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsMarkDangerousCreate(id: string, positionRequest: PositionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsMarkDangerousCreate(id, positionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsMarkDangerousCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark a position as safe
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsMarkSafeCreate(id: string, positionRequest: PositionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsMarkSafeCreate(id, positionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsMarkSafeCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Move a position to new coordinates
         * @param {string} id A UUID string identifying this position.
         * @param {PositionMoveRequest} positionMoveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsMoveCreate(id: string, positionMoveRequest: PositionMoveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsMoveCreate(id, positionMoveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsMoveCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing positions in the world
         * @param {string} id A UUID string identifying this position.
         * @param {PatchedPositionRequest} [patchedPositionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsPartialUpdate(id: string, patchedPositionRequest?: PatchedPositionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsPartialUpdate(id, patchedPositionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing positions in the world
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing positions in the world
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPositionsUpdate(id: string, positionRequest: PositionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPositionsUpdate(id, positionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditiorPositionsApi.gamemasterWorldPositionsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GMWorldEditiorPositionsApi - factory interface
 * @export
 */
export const GMWorldEditiorPositionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GMWorldEditiorPositionsApiFp(configuration)
    return {
        /**
         * API for managing positions in the world
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsCreate(positionRequest: PositionRequest, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldPositionsCreate(positionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing positions in the world
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.gamemasterWorldPositionsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The predefined labels a game master can pick: room kinds and map markers, each with the icon it draws. Free-text labels are still accepted and are kept as tags.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsLabelCatalogRetrieve(options?: any): AxiosPromise<GameMasterPositionLabelCatalog> {
            return localVarFp.gamemasterWorldPositionsLabelCatalogRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Add one label. A known kind or marker takes over its own slot; anything else is appended as a free tag.
         * @param {string} id A UUID string identifying this position.
         * @param {GameMasterPositionLabelWriteRequest} gameMasterPositionLabelWriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsLabelsAddCreate(id: string, gameMasterPositionLabelWriteRequest: GameMasterPositionLabelWriteRequest, options?: any): AxiosPromise<GameMasterPositionLabelState> {
            return localVarFp.gamemasterWorldPositionsLabelsAddCreate(id, gameMasterPositionLabelWriteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove one label, leaving the remaining slots in place.
         * @param {string} id A UUID string identifying this position.
         * @param {GameMasterPositionLabelWriteRequest} gameMasterPositionLabelWriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsLabelsRemoveCreate(id: string, gameMasterPositionLabelWriteRequest: GameMasterPositionLabelWriteRequest, options?: any): AxiosPromise<GameMasterPositionLabelState> {
            return localVarFp.gamemasterWorldPositionsLabelsRemoveCreate(id, gameMasterPositionLabelWriteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Read this position\'s labels as their slots - kind, marker, name, tags - together with any conflict between them.
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsLabelsRetrieve(id: string, options?: any): AxiosPromise<GameMasterPositionLabelState> {
            return localVarFp.gamemasterWorldPositionsLabelsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace every label on a position, slot by slot.
         * @param {string} id A UUID string identifying this position.
         * @param {GameMasterPositionLabelSetRequest} [gameMasterPositionLabelSetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsLabelsSetUpdate(id: string, gameMasterPositionLabelSetRequest?: GameMasterPositionLabelSetRequest, options?: any): AxiosPromise<GameMasterPositionLabelState> {
            return localVarFp.gamemasterWorldPositionsLabelsSetUpdate(id, gameMasterPositionLabelSetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing positions in the world
         * @param {number} [gridZ] 
         * @param {boolean} [isSafe] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [subLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsList(gridZ?: number, isSafe?: boolean, ordering?: string, subLocation?: string, options?: any): AxiosPromise<Array<Position>> {
            return localVarFp.gamemasterWorldPositionsList(gridZ, isSafe, ordering, subLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark a position as dangerous
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsMarkDangerousCreate(id: string, positionRequest: PositionRequest, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldPositionsMarkDangerousCreate(id, positionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark a position as safe
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsMarkSafeCreate(id: string, positionRequest: PositionRequest, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldPositionsMarkSafeCreate(id, positionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Move a position to new coordinates
         * @param {string} id A UUID string identifying this position.
         * @param {PositionMoveRequest} positionMoveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsMoveCreate(id: string, positionMoveRequest: PositionMoveRequest, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldPositionsMoveCreate(id, positionMoveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing positions in the world
         * @param {string} id A UUID string identifying this position.
         * @param {PatchedPositionRequest} [patchedPositionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsPartialUpdate(id: string, patchedPositionRequest?: PatchedPositionRequest, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldPositionsPartialUpdate(id, patchedPositionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing positions in the world
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsRetrieve(id: string, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldPositionsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing positions in the world
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPositionsUpdate(id: string, positionRequest: PositionRequest, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldPositionsUpdate(id, positionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GMWorldEditiorPositionsApi - object-oriented interface
 * @export
 * @class GMWorldEditiorPositionsApi
 * @extends {BaseAPI}
 */
export class GMWorldEditiorPositionsApi extends BaseAPI {
    /**
     * API for managing positions in the world
     * @param {PositionRequest} positionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsCreate(positionRequest: PositionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsCreate(positionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing positions in the world
     * @param {string} id A UUID string identifying this position.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The predefined labels a game master can pick: room kinds and map markers, each with the icon it draws. Free-text labels are still accepted and are kept as tags.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsLabelCatalogRetrieve(options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsLabelCatalogRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add one label. A known kind or marker takes over its own slot; anything else is appended as a free tag.
     * @param {string} id A UUID string identifying this position.
     * @param {GameMasterPositionLabelWriteRequest} gameMasterPositionLabelWriteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsLabelsAddCreate(id: string, gameMasterPositionLabelWriteRequest: GameMasterPositionLabelWriteRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsLabelsAddCreate(id, gameMasterPositionLabelWriteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove one label, leaving the remaining slots in place.
     * @param {string} id A UUID string identifying this position.
     * @param {GameMasterPositionLabelWriteRequest} gameMasterPositionLabelWriteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsLabelsRemoveCreate(id: string, gameMasterPositionLabelWriteRequest: GameMasterPositionLabelWriteRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsLabelsRemoveCreate(id, gameMasterPositionLabelWriteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read this position\'s labels as their slots - kind, marker, name, tags - together with any conflict between them.
     * @param {string} id A UUID string identifying this position.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsLabelsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsLabelsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace every label on a position, slot by slot.
     * @param {string} id A UUID string identifying this position.
     * @param {GameMasterPositionLabelSetRequest} [gameMasterPositionLabelSetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsLabelsSetUpdate(id: string, gameMasterPositionLabelSetRequest?: GameMasterPositionLabelSetRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsLabelsSetUpdate(id, gameMasterPositionLabelSetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing positions in the world
     * @param {number} [gridZ] 
     * @param {boolean} [isSafe] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [subLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsList(gridZ?: number, isSafe?: boolean, ordering?: string, subLocation?: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsList(gridZ, isSafe, ordering, subLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark a position as dangerous
     * @param {string} id A UUID string identifying this position.
     * @param {PositionRequest} positionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsMarkDangerousCreate(id: string, positionRequest: PositionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsMarkDangerousCreate(id, positionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark a position as safe
     * @param {string} id A UUID string identifying this position.
     * @param {PositionRequest} positionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsMarkSafeCreate(id: string, positionRequest: PositionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsMarkSafeCreate(id, positionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Move a position to new coordinates
     * @param {string} id A UUID string identifying this position.
     * @param {PositionMoveRequest} positionMoveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsMoveCreate(id: string, positionMoveRequest: PositionMoveRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsMoveCreate(id, positionMoveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing positions in the world
     * @param {string} id A UUID string identifying this position.
     * @param {PatchedPositionRequest} [patchedPositionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsPartialUpdate(id: string, patchedPositionRequest?: PatchedPositionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsPartialUpdate(id, patchedPositionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing positions in the world
     * @param {string} id A UUID string identifying this position.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing positions in the world
     * @param {string} id A UUID string identifying this position.
     * @param {PositionRequest} positionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditiorPositionsApi
     */
    public gamemasterWorldPositionsUpdate(id: string, positionRequest: PositionRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditiorPositionsApiFp(this.configuration).gamemasterWorldPositionsUpdate(id, positionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GMWorldEditorAllSpawnersApi - axios parameter creator
 * @export
 */
export const GMWorldEditorAllSpawnersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersAllActivateCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSpawnersAllActivateCreate', 'id', id)
            const localVarPath = `/api/gamemaster/spawners/all/{id}/activate/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersAllDeactivateCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSpawnersAllDeactivateCreate', 'id', id)
            const localVarPath = `/api/gamemaster/spawners/all/{id}/deactivate/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} [campaign] 
         * @param {number} [dimension] 
         * @param {boolean} [isActive] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersAllList: async (campaign?: string, dimension?: number, isActive?: boolean, position?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/spawners/all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (campaign !== undefined) {
                localVarQueryParameter['campaign'] = campaign;
            }

            if (dimension !== undefined) {
                localVarQueryParameter['dimension'] = dimension;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersAllRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSpawnersAllRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/spawners/all/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GMWorldEditorAllSpawnersApi - functional programming interface
 * @export
 */
export const GMWorldEditorAllSpawnersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GMWorldEditorAllSpawnersApiAxiosParamCreator(configuration)
    return {
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersAllActivateCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericSpawner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersAllActivateCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorAllSpawnersApi.gamemasterSpawnersAllActivateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersAllDeactivateCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericSpawner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersAllDeactivateCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorAllSpawnersApi.gamemasterSpawnersAllDeactivateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} [campaign] 
         * @param {number} [dimension] 
         * @param {boolean} [isActive] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersAllList(campaign?: string, dimension?: number, isActive?: boolean, position?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GenericSpawner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersAllList(campaign, dimension, isActive, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorAllSpawnersApi.gamemasterSpawnersAllList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersAllRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericSpawner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersAllRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorAllSpawnersApi.gamemasterSpawnersAllRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GMWorldEditorAllSpawnersApi - factory interface
 * @export
 */
export const GMWorldEditorAllSpawnersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GMWorldEditorAllSpawnersApiFp(configuration)
    return {
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersAllActivateCreate(id: string, options?: any): AxiosPromise<GenericSpawner> {
            return localVarFp.gamemasterSpawnersAllActivateCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersAllDeactivateCreate(id: string, options?: any): AxiosPromise<GenericSpawner> {
            return localVarFp.gamemasterSpawnersAllDeactivateCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} [campaign] 
         * @param {number} [dimension] 
         * @param {boolean} [isActive] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersAllList(campaign?: string, dimension?: number, isActive?: boolean, position?: string, options?: any): AxiosPromise<Array<GenericSpawner>> {
            return localVarFp.gamemasterSpawnersAllList(campaign, dimension, isActive, position, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersAllRetrieve(id: string, options?: any): AxiosPromise<GenericSpawner> {
            return localVarFp.gamemasterSpawnersAllRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GMWorldEditorAllSpawnersApi - object-oriented interface
 * @export
 * @class GMWorldEditorAllSpawnersApi
 * @extends {BaseAPI}
 */
export class GMWorldEditorAllSpawnersApi extends BaseAPI {
    /**
     * API for managing spawners in DX world editor.
     * @param {string} id A UUID string identifying this spawner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorAllSpawnersApi
     */
    public gamemasterSpawnersAllActivateCreate(id: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorAllSpawnersApiFp(this.configuration).gamemasterSpawnersAllActivateCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing spawners in DX world editor.
     * @param {string} id A UUID string identifying this spawner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorAllSpawnersApi
     */
    public gamemasterSpawnersAllDeactivateCreate(id: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorAllSpawnersApiFp(this.configuration).gamemasterSpawnersAllDeactivateCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing spawners in DX world editor.
     * @param {string} [campaign] 
     * @param {number} [dimension] 
     * @param {boolean} [isActive] 
     * @param {string} [position] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorAllSpawnersApi
     */
    public gamemasterSpawnersAllList(campaign?: string, dimension?: number, isActive?: boolean, position?: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorAllSpawnersApiFp(this.configuration).gamemasterSpawnersAllList(campaign, dimension, isActive, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing spawners in DX world editor.
     * @param {string} id A UUID string identifying this spawner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorAllSpawnersApi
     */
    public gamemasterSpawnersAllRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorAllSpawnersApiFp(this.configuration).gamemasterSpawnersAllRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GMWorldEditorNPCSpawnersApi - axios parameter creator
 * @export
 */
export const GMWorldEditorNPCSpawnersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API for managing spawners in DX world editor.
         * @param {NPCSpawnerCreateRequest} nPCSpawnerCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersNpcCreate: async (nPCSpawnerCreateRequest: NPCSpawnerCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nPCSpawnerCreateRequest' is not null or undefined
            assertParamExists('gamemasterSpawnersNpcCreate', 'nPCSpawnerCreateRequest', nPCSpawnerCreateRequest)
            const localVarPath = `/api/gamemaster/spawners/npc/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nPCSpawnerCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this npc spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersNpcDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSpawnersNpcDestroy', 'id', id)
            const localVarPath = `/api/gamemaster/spawners/npc/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} [campaign] 
         * @param {string} [characterTemplate] 
         * @param {number} [dimension] 
         * @param {boolean} [isActive] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersNpcList: async (campaign?: string, characterTemplate?: string, dimension?: number, isActive?: boolean, position?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/spawners/npc/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (campaign !== undefined) {
                localVarQueryParameter['campaign'] = campaign;
            }

            if (characterTemplate !== undefined) {
                localVarQueryParameter['character_template'] = characterTemplate;
            }

            if (dimension !== undefined) {
                localVarQueryParameter['dimension'] = dimension;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this npc spawner.
         * @param {PatchedNPCGenericSpawnerRequest} [patchedNPCGenericSpawnerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersNpcPartialUpdate: async (id: string, patchedNPCGenericSpawnerRequest?: PatchedNPCGenericSpawnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSpawnersNpcPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/spawners/npc/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedNPCGenericSpawnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this npc spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersNpcRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSpawnersNpcRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/spawners/npc/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this npc spawner.
         * @param {NPCGenericSpawnerRequest} nPCGenericSpawnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersNpcUpdate: async (id: string, nPCGenericSpawnerRequest: NPCGenericSpawnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSpawnersNpcUpdate', 'id', id)
            // verify required parameter 'nPCGenericSpawnerRequest' is not null or undefined
            assertParamExists('gamemasterSpawnersNpcUpdate', 'nPCGenericSpawnerRequest', nPCGenericSpawnerRequest)
            const localVarPath = `/api/gamemaster/spawners/npc/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nPCGenericSpawnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GMWorldEditorNPCSpawnersApi - functional programming interface
 * @export
 */
export const GMWorldEditorNPCSpawnersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GMWorldEditorNPCSpawnersApiAxiosParamCreator(configuration)
    return {
        /**
         * API for managing spawners in DX world editor.
         * @param {NPCSpawnerCreateRequest} nPCSpawnerCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersNpcCreate(nPCSpawnerCreateRequest: NPCSpawnerCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NPCSpawnerCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersNpcCreate(nPCSpawnerCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorNPCSpawnersApi.gamemasterSpawnersNpcCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this npc spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersNpcDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersNpcDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorNPCSpawnersApi.gamemasterSpawnersNpcDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} [campaign] 
         * @param {string} [characterTemplate] 
         * @param {number} [dimension] 
         * @param {boolean} [isActive] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersNpcList(campaign?: string, characterTemplate?: string, dimension?: number, isActive?: boolean, position?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NPCSpawnerList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersNpcList(campaign, characterTemplate, dimension, isActive, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorNPCSpawnersApi.gamemasterSpawnersNpcList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this npc spawner.
         * @param {PatchedNPCGenericSpawnerRequest} [patchedNPCGenericSpawnerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersNpcPartialUpdate(id: string, patchedNPCGenericSpawnerRequest?: PatchedNPCGenericSpawnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NPCGenericSpawner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersNpcPartialUpdate(id, patchedNPCGenericSpawnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorNPCSpawnersApi.gamemasterSpawnersNpcPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this npc spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersNpcRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NPCGenericSpawner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersNpcRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorNPCSpawnersApi.gamemasterSpawnersNpcRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this npc spawner.
         * @param {NPCGenericSpawnerRequest} nPCGenericSpawnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersNpcUpdate(id: string, nPCGenericSpawnerRequest: NPCGenericSpawnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NPCGenericSpawner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersNpcUpdate(id, nPCGenericSpawnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorNPCSpawnersApi.gamemasterSpawnersNpcUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GMWorldEditorNPCSpawnersApi - factory interface
 * @export
 */
export const GMWorldEditorNPCSpawnersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GMWorldEditorNPCSpawnersApiFp(configuration)
    return {
        /**
         * API for managing spawners in DX world editor.
         * @param {NPCSpawnerCreateRequest} nPCSpawnerCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersNpcCreate(nPCSpawnerCreateRequest: NPCSpawnerCreateRequest, options?: any): AxiosPromise<NPCSpawnerCreate> {
            return localVarFp.gamemasterSpawnersNpcCreate(nPCSpawnerCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this npc spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersNpcDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.gamemasterSpawnersNpcDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} [campaign] 
         * @param {string} [characterTemplate] 
         * @param {number} [dimension] 
         * @param {boolean} [isActive] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersNpcList(campaign?: string, characterTemplate?: string, dimension?: number, isActive?: boolean, position?: string, options?: any): AxiosPromise<Array<NPCSpawnerList>> {
            return localVarFp.gamemasterSpawnersNpcList(campaign, characterTemplate, dimension, isActive, position, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this npc spawner.
         * @param {PatchedNPCGenericSpawnerRequest} [patchedNPCGenericSpawnerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersNpcPartialUpdate(id: string, patchedNPCGenericSpawnerRequest?: PatchedNPCGenericSpawnerRequest, options?: any): AxiosPromise<NPCGenericSpawner> {
            return localVarFp.gamemasterSpawnersNpcPartialUpdate(id, patchedNPCGenericSpawnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this npc spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersNpcRetrieve(id: string, options?: any): AxiosPromise<NPCGenericSpawner> {
            return localVarFp.gamemasterSpawnersNpcRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this npc spawner.
         * @param {NPCGenericSpawnerRequest} nPCGenericSpawnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersNpcUpdate(id: string, nPCGenericSpawnerRequest: NPCGenericSpawnerRequest, options?: any): AxiosPromise<NPCGenericSpawner> {
            return localVarFp.gamemasterSpawnersNpcUpdate(id, nPCGenericSpawnerRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GMWorldEditorNPCSpawnersApi - object-oriented interface
 * @export
 * @class GMWorldEditorNPCSpawnersApi
 * @extends {BaseAPI}
 */
export class GMWorldEditorNPCSpawnersApi extends BaseAPI {
    /**
     * API for managing spawners in DX world editor.
     * @param {NPCSpawnerCreateRequest} nPCSpawnerCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorNPCSpawnersApi
     */
    public gamemasterSpawnersNpcCreate(nPCSpawnerCreateRequest: NPCSpawnerCreateRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditorNPCSpawnersApiFp(this.configuration).gamemasterSpawnersNpcCreate(nPCSpawnerCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing spawners in DX world editor.
     * @param {string} id A UUID string identifying this npc spawner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorNPCSpawnersApi
     */
    public gamemasterSpawnersNpcDestroy(id: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorNPCSpawnersApiFp(this.configuration).gamemasterSpawnersNpcDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing spawners in DX world editor.
     * @param {string} [campaign] 
     * @param {string} [characterTemplate] 
     * @param {number} [dimension] 
     * @param {boolean} [isActive] 
     * @param {string} [position] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorNPCSpawnersApi
     */
    public gamemasterSpawnersNpcList(campaign?: string, characterTemplate?: string, dimension?: number, isActive?: boolean, position?: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorNPCSpawnersApiFp(this.configuration).gamemasterSpawnersNpcList(campaign, characterTemplate, dimension, isActive, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing spawners in DX world editor.
     * @param {string} id A UUID string identifying this npc spawner.
     * @param {PatchedNPCGenericSpawnerRequest} [patchedNPCGenericSpawnerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorNPCSpawnersApi
     */
    public gamemasterSpawnersNpcPartialUpdate(id: string, patchedNPCGenericSpawnerRequest?: PatchedNPCGenericSpawnerRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditorNPCSpawnersApiFp(this.configuration).gamemasterSpawnersNpcPartialUpdate(id, patchedNPCGenericSpawnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing spawners in DX world editor.
     * @param {string} id A UUID string identifying this npc spawner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorNPCSpawnersApi
     */
    public gamemasterSpawnersNpcRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorNPCSpawnersApiFp(this.configuration).gamemasterSpawnersNpcRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing spawners in DX world editor.
     * @param {string} id A UUID string identifying this npc spawner.
     * @param {NPCGenericSpawnerRequest} nPCGenericSpawnerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorNPCSpawnersApi
     */
    public gamemasterSpawnersNpcUpdate(id: string, nPCGenericSpawnerRequest: NPCGenericSpawnerRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditorNPCSpawnersApiFp(this.configuration).gamemasterSpawnersNpcUpdate(id, nPCGenericSpawnerRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GMWorldEditorPopulationScaledNPCSpawnersApi - axios parameter creator
 * @export
 */
export const GMWorldEditorPopulationScaledNPCSpawnersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API for managing spawners in DX world editor.
         * @param {PopulationScaledNPCSpawnerCreateRequest} populationScaledNPCSpawnerCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersPopulationScaledNpcCreate: async (populationScaledNPCSpawnerCreateRequest: PopulationScaledNPCSpawnerCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'populationScaledNPCSpawnerCreateRequest' is not null or undefined
            assertParamExists('gamemasterSpawnersPopulationScaledNpcCreate', 'populationScaledNPCSpawnerCreateRequest', populationScaledNPCSpawnerCreateRequest)
            const localVarPath = `/api/gamemaster/spawners/population-scaled-npc/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(populationScaledNPCSpawnerCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this population scaled npc spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersPopulationScaledNpcDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSpawnersPopulationScaledNpcDestroy', 'id', id)
            const localVarPath = `/api/gamemaster/spawners/population-scaled-npc/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} [campaign] 
         * @param {string} [characterTemplate] 
         * @param {number} [dimension] 
         * @param {boolean} [isActive] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersPopulationScaledNpcList: async (campaign?: string, characterTemplate?: string, dimension?: number, isActive?: boolean, position?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/spawners/population-scaled-npc/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (campaign !== undefined) {
                localVarQueryParameter['campaign'] = campaign;
            }

            if (characterTemplate !== undefined) {
                localVarQueryParameter['character_template'] = characterTemplate;
            }

            if (dimension !== undefined) {
                localVarQueryParameter['dimension'] = dimension;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this population scaled npc spawner.
         * @param {PatchedPopulationScaledNPCGenericSpawnerRequest} [patchedPopulationScaledNPCGenericSpawnerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersPopulationScaledNpcPartialUpdate: async (id: string, patchedPopulationScaledNPCGenericSpawnerRequest?: PatchedPopulationScaledNPCGenericSpawnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSpawnersPopulationScaledNpcPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/spawners/population-scaled-npc/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedPopulationScaledNPCGenericSpawnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this population scaled npc spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersPopulationScaledNpcRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSpawnersPopulationScaledNpcRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/spawners/population-scaled-npc/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this population scaled npc spawner.
         * @param {PopulationScaledNPCGenericSpawnerRequest} populationScaledNPCGenericSpawnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersPopulationScaledNpcUpdate: async (id: string, populationScaledNPCGenericSpawnerRequest: PopulationScaledNPCGenericSpawnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSpawnersPopulationScaledNpcUpdate', 'id', id)
            // verify required parameter 'populationScaledNPCGenericSpawnerRequest' is not null or undefined
            assertParamExists('gamemasterSpawnersPopulationScaledNpcUpdate', 'populationScaledNPCGenericSpawnerRequest', populationScaledNPCGenericSpawnerRequest)
            const localVarPath = `/api/gamemaster/spawners/population-scaled-npc/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(populationScaledNPCGenericSpawnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GMWorldEditorPopulationScaledNPCSpawnersApi - functional programming interface
 * @export
 */
export const GMWorldEditorPopulationScaledNPCSpawnersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GMWorldEditorPopulationScaledNPCSpawnersApiAxiosParamCreator(configuration)
    return {
        /**
         * API for managing spawners in DX world editor.
         * @param {PopulationScaledNPCSpawnerCreateRequest} populationScaledNPCSpawnerCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersPopulationScaledNpcCreate(populationScaledNPCSpawnerCreateRequest: PopulationScaledNPCSpawnerCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopulationScaledNPCSpawnerCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersPopulationScaledNpcCreate(populationScaledNPCSpawnerCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorPopulationScaledNPCSpawnersApi.gamemasterSpawnersPopulationScaledNpcCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this population scaled npc spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersPopulationScaledNpcDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersPopulationScaledNpcDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorPopulationScaledNPCSpawnersApi.gamemasterSpawnersPopulationScaledNpcDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} [campaign] 
         * @param {string} [characterTemplate] 
         * @param {number} [dimension] 
         * @param {boolean} [isActive] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersPopulationScaledNpcList(campaign?: string, characterTemplate?: string, dimension?: number, isActive?: boolean, position?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PopulationScaledNPCSpawnerList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersPopulationScaledNpcList(campaign, characterTemplate, dimension, isActive, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorPopulationScaledNPCSpawnersApi.gamemasterSpawnersPopulationScaledNpcList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this population scaled npc spawner.
         * @param {PatchedPopulationScaledNPCGenericSpawnerRequest} [patchedPopulationScaledNPCGenericSpawnerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersPopulationScaledNpcPartialUpdate(id: string, patchedPopulationScaledNPCGenericSpawnerRequest?: PatchedPopulationScaledNPCGenericSpawnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopulationScaledNPCGenericSpawner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersPopulationScaledNpcPartialUpdate(id, patchedPopulationScaledNPCGenericSpawnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorPopulationScaledNPCSpawnersApi.gamemasterSpawnersPopulationScaledNpcPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this population scaled npc spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersPopulationScaledNpcRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopulationScaledNPCGenericSpawner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersPopulationScaledNpcRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorPopulationScaledNPCSpawnersApi.gamemasterSpawnersPopulationScaledNpcRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this population scaled npc spawner.
         * @param {PopulationScaledNPCGenericSpawnerRequest} populationScaledNPCGenericSpawnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSpawnersPopulationScaledNpcUpdate(id: string, populationScaledNPCGenericSpawnerRequest: PopulationScaledNPCGenericSpawnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopulationScaledNPCGenericSpawner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSpawnersPopulationScaledNpcUpdate(id, populationScaledNPCGenericSpawnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorPopulationScaledNPCSpawnersApi.gamemasterSpawnersPopulationScaledNpcUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GMWorldEditorPopulationScaledNPCSpawnersApi - factory interface
 * @export
 */
export const GMWorldEditorPopulationScaledNPCSpawnersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GMWorldEditorPopulationScaledNPCSpawnersApiFp(configuration)
    return {
        /**
         * API for managing spawners in DX world editor.
         * @param {PopulationScaledNPCSpawnerCreateRequest} populationScaledNPCSpawnerCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersPopulationScaledNpcCreate(populationScaledNPCSpawnerCreateRequest: PopulationScaledNPCSpawnerCreateRequest, options?: any): AxiosPromise<PopulationScaledNPCSpawnerCreate> {
            return localVarFp.gamemasterSpawnersPopulationScaledNpcCreate(populationScaledNPCSpawnerCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this population scaled npc spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersPopulationScaledNpcDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.gamemasterSpawnersPopulationScaledNpcDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} [campaign] 
         * @param {string} [characterTemplate] 
         * @param {number} [dimension] 
         * @param {boolean} [isActive] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersPopulationScaledNpcList(campaign?: string, characterTemplate?: string, dimension?: number, isActive?: boolean, position?: string, options?: any): AxiosPromise<Array<PopulationScaledNPCSpawnerList>> {
            return localVarFp.gamemasterSpawnersPopulationScaledNpcList(campaign, characterTemplate, dimension, isActive, position, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this population scaled npc spawner.
         * @param {PatchedPopulationScaledNPCGenericSpawnerRequest} [patchedPopulationScaledNPCGenericSpawnerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersPopulationScaledNpcPartialUpdate(id: string, patchedPopulationScaledNPCGenericSpawnerRequest?: PatchedPopulationScaledNPCGenericSpawnerRequest, options?: any): AxiosPromise<PopulationScaledNPCGenericSpawner> {
            return localVarFp.gamemasterSpawnersPopulationScaledNpcPartialUpdate(id, patchedPopulationScaledNPCGenericSpawnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this population scaled npc spawner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersPopulationScaledNpcRetrieve(id: string, options?: any): AxiosPromise<PopulationScaledNPCGenericSpawner> {
            return localVarFp.gamemasterSpawnersPopulationScaledNpcRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing spawners in DX world editor.
         * @param {string} id A UUID string identifying this population scaled npc spawner.
         * @param {PopulationScaledNPCGenericSpawnerRequest} populationScaledNPCGenericSpawnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSpawnersPopulationScaledNpcUpdate(id: string, populationScaledNPCGenericSpawnerRequest: PopulationScaledNPCGenericSpawnerRequest, options?: any): AxiosPromise<PopulationScaledNPCGenericSpawner> {
            return localVarFp.gamemasterSpawnersPopulationScaledNpcUpdate(id, populationScaledNPCGenericSpawnerRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GMWorldEditorPopulationScaledNPCSpawnersApi - object-oriented interface
 * @export
 * @class GMWorldEditorPopulationScaledNPCSpawnersApi
 * @extends {BaseAPI}
 */
export class GMWorldEditorPopulationScaledNPCSpawnersApi extends BaseAPI {
    /**
     * API for managing spawners in DX world editor.
     * @param {PopulationScaledNPCSpawnerCreateRequest} populationScaledNPCSpawnerCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorPopulationScaledNPCSpawnersApi
     */
    public gamemasterSpawnersPopulationScaledNpcCreate(populationScaledNPCSpawnerCreateRequest: PopulationScaledNPCSpawnerCreateRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditorPopulationScaledNPCSpawnersApiFp(this.configuration).gamemasterSpawnersPopulationScaledNpcCreate(populationScaledNPCSpawnerCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing spawners in DX world editor.
     * @param {string} id A UUID string identifying this population scaled npc spawner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorPopulationScaledNPCSpawnersApi
     */
    public gamemasterSpawnersPopulationScaledNpcDestroy(id: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorPopulationScaledNPCSpawnersApiFp(this.configuration).gamemasterSpawnersPopulationScaledNpcDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing spawners in DX world editor.
     * @param {string} [campaign] 
     * @param {string} [characterTemplate] 
     * @param {number} [dimension] 
     * @param {boolean} [isActive] 
     * @param {string} [position] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorPopulationScaledNPCSpawnersApi
     */
    public gamemasterSpawnersPopulationScaledNpcList(campaign?: string, characterTemplate?: string, dimension?: number, isActive?: boolean, position?: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorPopulationScaledNPCSpawnersApiFp(this.configuration).gamemasterSpawnersPopulationScaledNpcList(campaign, characterTemplate, dimension, isActive, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing spawners in DX world editor.
     * @param {string} id A UUID string identifying this population scaled npc spawner.
     * @param {PatchedPopulationScaledNPCGenericSpawnerRequest} [patchedPopulationScaledNPCGenericSpawnerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorPopulationScaledNPCSpawnersApi
     */
    public gamemasterSpawnersPopulationScaledNpcPartialUpdate(id: string, patchedPopulationScaledNPCGenericSpawnerRequest?: PatchedPopulationScaledNPCGenericSpawnerRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditorPopulationScaledNPCSpawnersApiFp(this.configuration).gamemasterSpawnersPopulationScaledNpcPartialUpdate(id, patchedPopulationScaledNPCGenericSpawnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing spawners in DX world editor.
     * @param {string} id A UUID string identifying this population scaled npc spawner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorPopulationScaledNPCSpawnersApi
     */
    public gamemasterSpawnersPopulationScaledNpcRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorPopulationScaledNPCSpawnersApiFp(this.configuration).gamemasterSpawnersPopulationScaledNpcRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing spawners in DX world editor.
     * @param {string} id A UUID string identifying this population scaled npc spawner.
     * @param {PopulationScaledNPCGenericSpawnerRequest} populationScaledNPCGenericSpawnerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorPopulationScaledNPCSpawnersApi
     */
    public gamemasterSpawnersPopulationScaledNpcUpdate(id: string, populationScaledNPCGenericSpawnerRequest: PopulationScaledNPCGenericSpawnerRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditorPopulationScaledNPCSpawnersApiFp(this.configuration).gamemasterSpawnersPopulationScaledNpcUpdate(id, populationScaledNPCGenericSpawnerRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GMWorldEditorSubLocationsApi - axios parameter creator
 * @export
 */
export const GMWorldEditorSubLocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activate a sub-location
         * @param {string} id A UUID string identifying this sub location.
         * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsActivateCreate: async (id: string, gameMasterSubLocationRequest: GameMasterSubLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldSubLocationsActivateCreate', 'id', id)
            // verify required parameter 'gameMasterSubLocationRequest' is not null or undefined
            assertParamExists('gamemasterWorldSubLocationsActivateCreate', 'gameMasterSubLocationRequest', gameMasterSubLocationRequest)
            const localVarPath = `/api/gamemaster/world-sub-locations/{id}/activate/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterSubLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing sub-locations in the world
         * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsCreate: async (gameMasterSubLocationRequest: GameMasterSubLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameMasterSubLocationRequest' is not null or undefined
            assertParamExists('gamemasterWorldSubLocationsCreate', 'gameMasterSubLocationRequest', gameMasterSubLocationRequest)
            const localVarPath = `/api/gamemaster/world-sub-locations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterSubLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate a sub-location
         * @param {string} id A UUID string identifying this sub location.
         * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsDeactivateCreate: async (id: string, gameMasterSubLocationRequest: GameMasterSubLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldSubLocationsDeactivateCreate', 'id', id)
            // verify required parameter 'gameMasterSubLocationRequest' is not null or undefined
            assertParamExists('gamemasterWorldSubLocationsDeactivateCreate', 'gameMasterSubLocationRequest', gameMasterSubLocationRequest)
            const localVarPath = `/api/gamemaster/world-sub-locations/{id}/deactivate/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterSubLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing sub-locations in the world
         * @param {string} id A UUID string identifying this sub location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldSubLocationsDestroy', 'id', id)
            const localVarPath = `/api/gamemaster/world-sub-locations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing sub-locations in the world
         * @param {boolean} [isActive] 
         * @param {string} [location] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsList: async (isActive?: boolean, location?: string, ordering?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-sub-locations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing sub-locations in the world
         * @param {string} id A UUID string identifying this sub location.
         * @param {PatchedGameMasterSubLocationRequest} [patchedGameMasterSubLocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsPartialUpdate: async (id: string, patchedGameMasterSubLocationRequest?: PatchedGameMasterSubLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldSubLocationsPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/world-sub-locations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGameMasterSubLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all positions within this sub-location
         * @param {string} id A UUID string identifying this sub location.
         * @param {boolean} [isActive] 
         * @param {string} [location] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsPositionsList: async (id: string, isActive?: boolean, location?: string, ordering?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldSubLocationsPositionsList', 'id', id)
            const localVarPath = `/api/gamemaster/world-sub-locations/{id}/positions/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing sub-locations in the world
         * @param {string} id A UUID string identifying this sub location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldSubLocationsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/world-sub-locations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics about this sub-location
         * @param {string} id A UUID string identifying this sub location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsStatsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldSubLocationsStatsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/world-sub-locations/{id}/stats/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for managing sub-locations in the world
         * @param {string} id A UUID string identifying this sub location.
         * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsUpdate: async (id: string, gameMasterSubLocationRequest: GameMasterSubLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldSubLocationsUpdate', 'id', id)
            // verify required parameter 'gameMasterSubLocationRequest' is not null or undefined
            assertParamExists('gamemasterWorldSubLocationsUpdate', 'gameMasterSubLocationRequest', gameMasterSubLocationRequest)
            const localVarPath = `/api/gamemaster/world-sub-locations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterSubLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GMWorldEditorSubLocationsApi - functional programming interface
 * @export
 */
export const GMWorldEditorSubLocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GMWorldEditorSubLocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Activate a sub-location
         * @param {string} id A UUID string identifying this sub location.
         * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldSubLocationsActivateCreate(id: string, gameMasterSubLocationRequest: GameMasterSubLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterSubLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldSubLocationsActivateCreate(id, gameMasterSubLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorSubLocationsApi.gamemasterWorldSubLocationsActivateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing sub-locations in the world
         * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldSubLocationsCreate(gameMasterSubLocationRequest: GameMasterSubLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterSubLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldSubLocationsCreate(gameMasterSubLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorSubLocationsApi.gamemasterWorldSubLocationsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deactivate a sub-location
         * @param {string} id A UUID string identifying this sub location.
         * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldSubLocationsDeactivateCreate(id: string, gameMasterSubLocationRequest: GameMasterSubLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterSubLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldSubLocationsDeactivateCreate(id, gameMasterSubLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorSubLocationsApi.gamemasterWorldSubLocationsDeactivateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing sub-locations in the world
         * @param {string} id A UUID string identifying this sub location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldSubLocationsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldSubLocationsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorSubLocationsApi.gamemasterWorldSubLocationsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing sub-locations in the world
         * @param {boolean} [isActive] 
         * @param {string} [location] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldSubLocationsList(isActive?: boolean, location?: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterSubLocation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldSubLocationsList(isActive, location, ordering, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorSubLocationsApi.gamemasterWorldSubLocationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing sub-locations in the world
         * @param {string} id A UUID string identifying this sub location.
         * @param {PatchedGameMasterSubLocationRequest} [patchedGameMasterSubLocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldSubLocationsPartialUpdate(id: string, patchedGameMasterSubLocationRequest?: PatchedGameMasterSubLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterSubLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldSubLocationsPartialUpdate(id, patchedGameMasterSubLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorSubLocationsApi.gamemasterWorldSubLocationsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all positions within this sub-location
         * @param {string} id A UUID string identifying this sub location.
         * @param {boolean} [isActive] 
         * @param {string} [location] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldSubLocationsPositionsList(id: string, isActive?: boolean, location?: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Position>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldSubLocationsPositionsList(id, isActive, location, ordering, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorSubLocationsApi.gamemasterWorldSubLocationsPositionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing sub-locations in the world
         * @param {string} id A UUID string identifying this sub location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldSubLocationsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterSubLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldSubLocationsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorSubLocationsApi.gamemasterWorldSubLocationsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get statistics about this sub-location
         * @param {string} id A UUID string identifying this sub location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldSubLocationsStatsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldSubLocationsStatsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorSubLocationsApi.gamemasterWorldSubLocationsStatsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for managing sub-locations in the world
         * @param {string} id A UUID string identifying this sub location.
         * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldSubLocationsUpdate(id: string, gameMasterSubLocationRequest: GameMasterSubLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterSubLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldSubLocationsUpdate(id, gameMasterSubLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GMWorldEditorSubLocationsApi.gamemasterWorldSubLocationsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GMWorldEditorSubLocationsApi - factory interface
 * @export
 */
export const GMWorldEditorSubLocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GMWorldEditorSubLocationsApiFp(configuration)
    return {
        /**
         * Activate a sub-location
         * @param {string} id A UUID string identifying this sub location.
         * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsActivateCreate(id: string, gameMasterSubLocationRequest: GameMasterSubLocationRequest, options?: any): AxiosPromise<GameMasterSubLocation> {
            return localVarFp.gamemasterWorldSubLocationsActivateCreate(id, gameMasterSubLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing sub-locations in the world
         * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsCreate(gameMasterSubLocationRequest: GameMasterSubLocationRequest, options?: any): AxiosPromise<GameMasterSubLocation> {
            return localVarFp.gamemasterWorldSubLocationsCreate(gameMasterSubLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate a sub-location
         * @param {string} id A UUID string identifying this sub location.
         * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsDeactivateCreate(id: string, gameMasterSubLocationRequest: GameMasterSubLocationRequest, options?: any): AxiosPromise<GameMasterSubLocation> {
            return localVarFp.gamemasterWorldSubLocationsDeactivateCreate(id, gameMasterSubLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing sub-locations in the world
         * @param {string} id A UUID string identifying this sub location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.gamemasterWorldSubLocationsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing sub-locations in the world
         * @param {boolean} [isActive] 
         * @param {string} [location] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsList(isActive?: boolean, location?: string, ordering?: string, search?: string, options?: any): AxiosPromise<Array<GameMasterSubLocation>> {
            return localVarFp.gamemasterWorldSubLocationsList(isActive, location, ordering, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing sub-locations in the world
         * @param {string} id A UUID string identifying this sub location.
         * @param {PatchedGameMasterSubLocationRequest} [patchedGameMasterSubLocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsPartialUpdate(id: string, patchedGameMasterSubLocationRequest?: PatchedGameMasterSubLocationRequest, options?: any): AxiosPromise<GameMasterSubLocation> {
            return localVarFp.gamemasterWorldSubLocationsPartialUpdate(id, patchedGameMasterSubLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all positions within this sub-location
         * @param {string} id A UUID string identifying this sub location.
         * @param {boolean} [isActive] 
         * @param {string} [location] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsPositionsList(id: string, isActive?: boolean, location?: string, ordering?: string, search?: string, options?: any): AxiosPromise<Array<Position>> {
            return localVarFp.gamemasterWorldSubLocationsPositionsList(id, isActive, location, ordering, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing sub-locations in the world
         * @param {string} id A UUID string identifying this sub location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsRetrieve(id: string, options?: any): AxiosPromise<GameMasterSubLocation> {
            return localVarFp.gamemasterWorldSubLocationsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics about this sub-location
         * @param {string} id A UUID string identifying this sub location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsStatsRetrieve(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.gamemasterWorldSubLocationsStatsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing sub-locations in the world
         * @param {string} id A UUID string identifying this sub location.
         * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldSubLocationsUpdate(id: string, gameMasterSubLocationRequest: GameMasterSubLocationRequest, options?: any): AxiosPromise<GameMasterSubLocation> {
            return localVarFp.gamemasterWorldSubLocationsUpdate(id, gameMasterSubLocationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GMWorldEditorSubLocationsApi - object-oriented interface
 * @export
 * @class GMWorldEditorSubLocationsApi
 * @extends {BaseAPI}
 */
export class GMWorldEditorSubLocationsApi extends BaseAPI {
    /**
     * Activate a sub-location
     * @param {string} id A UUID string identifying this sub location.
     * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorSubLocationsApi
     */
    public gamemasterWorldSubLocationsActivateCreate(id: string, gameMasterSubLocationRequest: GameMasterSubLocationRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditorSubLocationsApiFp(this.configuration).gamemasterWorldSubLocationsActivateCreate(id, gameMasterSubLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing sub-locations in the world
     * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorSubLocationsApi
     */
    public gamemasterWorldSubLocationsCreate(gameMasterSubLocationRequest: GameMasterSubLocationRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditorSubLocationsApiFp(this.configuration).gamemasterWorldSubLocationsCreate(gameMasterSubLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate a sub-location
     * @param {string} id A UUID string identifying this sub location.
     * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorSubLocationsApi
     */
    public gamemasterWorldSubLocationsDeactivateCreate(id: string, gameMasterSubLocationRequest: GameMasterSubLocationRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditorSubLocationsApiFp(this.configuration).gamemasterWorldSubLocationsDeactivateCreate(id, gameMasterSubLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing sub-locations in the world
     * @param {string} id A UUID string identifying this sub location.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorSubLocationsApi
     */
    public gamemasterWorldSubLocationsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorSubLocationsApiFp(this.configuration).gamemasterWorldSubLocationsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing sub-locations in the world
     * @param {boolean} [isActive] 
     * @param {string} [location] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorSubLocationsApi
     */
    public gamemasterWorldSubLocationsList(isActive?: boolean, location?: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorSubLocationsApiFp(this.configuration).gamemasterWorldSubLocationsList(isActive, location, ordering, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing sub-locations in the world
     * @param {string} id A UUID string identifying this sub location.
     * @param {PatchedGameMasterSubLocationRequest} [patchedGameMasterSubLocationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorSubLocationsApi
     */
    public gamemasterWorldSubLocationsPartialUpdate(id: string, patchedGameMasterSubLocationRequest?: PatchedGameMasterSubLocationRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditorSubLocationsApiFp(this.configuration).gamemasterWorldSubLocationsPartialUpdate(id, patchedGameMasterSubLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all positions within this sub-location
     * @param {string} id A UUID string identifying this sub location.
     * @param {boolean} [isActive] 
     * @param {string} [location] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorSubLocationsApi
     */
    public gamemasterWorldSubLocationsPositionsList(id: string, isActive?: boolean, location?: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorSubLocationsApiFp(this.configuration).gamemasterWorldSubLocationsPositionsList(id, isActive, location, ordering, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing sub-locations in the world
     * @param {string} id A UUID string identifying this sub location.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorSubLocationsApi
     */
    public gamemasterWorldSubLocationsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorSubLocationsApiFp(this.configuration).gamemasterWorldSubLocationsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics about this sub-location
     * @param {string} id A UUID string identifying this sub location.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorSubLocationsApi
     */
    public gamemasterWorldSubLocationsStatsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GMWorldEditorSubLocationsApiFp(this.configuration).gamemasterWorldSubLocationsStatsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for managing sub-locations in the world
     * @param {string} id A UUID string identifying this sub location.
     * @param {GameMasterSubLocationRequest} gameMasterSubLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GMWorldEditorSubLocationsApi
     */
    public gamemasterWorldSubLocationsUpdate(id: string, gameMasterSubLocationRequest: GameMasterSubLocationRequest, options?: RawAxiosRequestConfig) {
        return GMWorldEditorSubLocationsApiFp(this.configuration).gamemasterWorldSubLocationsUpdate(id, gameMasterSubLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GalleryApi - axios parameter creator
 * @export
 */
export const GalleryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        galleryWorldList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gallery/world/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this art.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        galleryWorldRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('galleryWorldRetrieve', 'id', id)
            const localVarPath = `/api/gallery/world/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GalleryApi - functional programming interface
 * @export
 */
export const GalleryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GalleryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async galleryWorldList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Art>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.galleryWorldList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GalleryApi.galleryWorldList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this art.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async galleryWorldRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Art>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.galleryWorldRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GalleryApi.galleryWorldRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GalleryApi - factory interface
 * @export
 */
export const GalleryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GalleryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        galleryWorldList(options?: any): AxiosPromise<Array<Art>> {
            return localVarFp.galleryWorldList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this art.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        galleryWorldRetrieve(id: string, options?: any): AxiosPromise<Art> {
            return localVarFp.galleryWorldRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GalleryApi - object-oriented interface
 * @export
 * @class GalleryApi
 * @extends {BaseAPI}
 */
export class GalleryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public galleryWorldList(options?: RawAxiosRequestConfig) {
        return GalleryApiFp(this.configuration).galleryWorldList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this art.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public galleryWorldRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GalleryApiFp(this.configuration).galleryWorldRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GameMasterArchetypesApi - axios parameter creator
 * @export
 */
export const GameMasterArchetypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Every archetype measured at the same grade, with the roster medians beside them. A single build\'s numbers mean nothing alone — \'falls in 1.6 turns\' is alarming or fine depending entirely on what everyone else does.
         * @summary The whole roster at one grade
         * @param {number} [grade] Rank grade, 10 (beginner) down to 0 (master).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterArchetypesBalanceRetrieve: async (grade?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/archetypes/balance/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (grade !== undefined) {
                localVarQueryParameter['grade'] = grade;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Every archetype with its derived metatype, role, school progression and any data problems worth showing on the card. Filterable by metatype, role, path and hybrid status.
         * @summary List archetypes
         * @param {boolean} [isHybrid] 
         * @param {GamemasterArchetypesListMetatypeEnum} [metatype] Attacker, Defender, Healer, Buffer or Debuffer
         * @param {string} [path] 
         * @param {Role266Enum} [role] The coarse stance the metatype belongs to
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterArchetypesList: async (isHybrid?: boolean, metatype?: GamemasterArchetypesListMetatypeEnum, path?: string, role?: Role266Enum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/archetypes/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isHybrid !== undefined) {
                localVarQueryParameter['is_hybrid'] = isHybrid;
            }

            if (metatype !== undefined) {
                localVarQueryParameter['metatype'] = metatype;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Every dial the power calculation turns, with the reasoning behind each. Published so the workbench can explain its own arithmetic rather than presenting numbers to be taken on trust.
         * @summary The rating model\'s coefficients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterArchetypesModelRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/archetypes/model/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The archetype grade by grade: which schools are open, which skills that makes castable, what each is worth per action point, and what the whole build adds up to. Pass `grade` for one grade.
         * @summary Get one archetype\'s build
         * @param {string} id A UUID string identifying this Character Archetype.
         * @param {number} [grade] Rank grade, 10 (beginner) down to 0 (master).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterArchetypesRetrieve: async (id: string, grade?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterArchetypesRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/archetypes/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (grade !== undefined) {
                localVarQueryParameter['grade'] = grade;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * How many archetypes play each role, for the filter bar.
         * @summary Roster distribution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterArchetypesRolesRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/archetypes/roles/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GameMasterArchetypesApi - functional programming interface
 * @export
 */
export const GameMasterArchetypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GameMasterArchetypesApiAxiosParamCreator(configuration)
    return {
        /**
         * Every archetype measured at the same grade, with the roster medians beside them. A single build\'s numbers mean nothing alone — \'falls in 1.6 turns\' is alarming or fine depending entirely on what everyone else does.
         * @summary The whole roster at one grade
         * @param {number} [grade] Rank grade, 10 (beginner) down to 0 (master).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterArchetypesBalanceRetrieve(grade?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BalanceTable>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterArchetypesBalanceRetrieve(grade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterArchetypesApi.gamemasterArchetypesBalanceRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Every archetype with its derived metatype, role, school progression and any data problems worth showing on the card. Filterable by metatype, role, path and hybrid status.
         * @summary List archetypes
         * @param {boolean} [isHybrid] 
         * @param {GamemasterArchetypesListMetatypeEnum} [metatype] Attacker, Defender, Healer, Buffer or Debuffer
         * @param {string} [path] 
         * @param {Role266Enum} [role] The coarse stance the metatype belongs to
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterArchetypesList(isHybrid?: boolean, metatype?: GamemasterArchetypesListMetatypeEnum, path?: string, role?: Role266Enum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ArchetypeSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterArchetypesList(isHybrid, metatype, path, role, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterArchetypesApi.gamemasterArchetypesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Every dial the power calculation turns, with the reasoning behind each. Published so the workbench can explain its own arithmetic rather than presenting numbers to be taken on trust.
         * @summary The rating model\'s coefficients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterArchetypesModelRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BalanceModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterArchetypesModelRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterArchetypesApi.gamemasterArchetypesModelRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The archetype grade by grade: which schools are open, which skills that makes castable, what each is worth per action point, and what the whole build adds up to. Pass `grade` for one grade.
         * @summary Get one archetype\'s build
         * @param {string} id A UUID string identifying this Character Archetype.
         * @param {number} [grade] Rank grade, 10 (beginner) down to 0 (master).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterArchetypesRetrieve(id: string, grade?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArchetypeProfile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterArchetypesRetrieve(id, grade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterArchetypesApi.gamemasterArchetypesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * How many archetypes play each role, for the filter bar.
         * @summary Roster distribution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterArchetypesRolesRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArchetypeRoles>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterArchetypesRolesRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterArchetypesApi.gamemasterArchetypesRolesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GameMasterArchetypesApi - factory interface
 * @export
 */
export const GameMasterArchetypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GameMasterArchetypesApiFp(configuration)
    return {
        /**
         * Every archetype measured at the same grade, with the roster medians beside them. A single build\'s numbers mean nothing alone — \'falls in 1.6 turns\' is alarming or fine depending entirely on what everyone else does.
         * @summary The whole roster at one grade
         * @param {number} [grade] Rank grade, 10 (beginner) down to 0 (master).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterArchetypesBalanceRetrieve(grade?: number, options?: any): AxiosPromise<BalanceTable> {
            return localVarFp.gamemasterArchetypesBalanceRetrieve(grade, options).then((request) => request(axios, basePath));
        },
        /**
         * Every archetype with its derived metatype, role, school progression and any data problems worth showing on the card. Filterable by metatype, role, path and hybrid status.
         * @summary List archetypes
         * @param {boolean} [isHybrid] 
         * @param {GamemasterArchetypesListMetatypeEnum} [metatype] Attacker, Defender, Healer, Buffer or Debuffer
         * @param {string} [path] 
         * @param {Role266Enum} [role] The coarse stance the metatype belongs to
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterArchetypesList(isHybrid?: boolean, metatype?: GamemasterArchetypesListMetatypeEnum, path?: string, role?: Role266Enum, search?: string, options?: any): AxiosPromise<Array<ArchetypeSummary>> {
            return localVarFp.gamemasterArchetypesList(isHybrid, metatype, path, role, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Every dial the power calculation turns, with the reasoning behind each. Published so the workbench can explain its own arithmetic rather than presenting numbers to be taken on trust.
         * @summary The rating model\'s coefficients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterArchetypesModelRetrieve(options?: any): AxiosPromise<BalanceModel> {
            return localVarFp.gamemasterArchetypesModelRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * The archetype grade by grade: which schools are open, which skills that makes castable, what each is worth per action point, and what the whole build adds up to. Pass `grade` for one grade.
         * @summary Get one archetype\'s build
         * @param {string} id A UUID string identifying this Character Archetype.
         * @param {number} [grade] Rank grade, 10 (beginner) down to 0 (master).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterArchetypesRetrieve(id: string, grade?: number, options?: any): AxiosPromise<ArchetypeProfile> {
            return localVarFp.gamemasterArchetypesRetrieve(id, grade, options).then((request) => request(axios, basePath));
        },
        /**
         * How many archetypes play each role, for the filter bar.
         * @summary Roster distribution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterArchetypesRolesRetrieve(options?: any): AxiosPromise<ArchetypeRoles> {
            return localVarFp.gamemasterArchetypesRolesRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GameMasterArchetypesApi - object-oriented interface
 * @export
 * @class GameMasterArchetypesApi
 * @extends {BaseAPI}
 */
export class GameMasterArchetypesApi extends BaseAPI {
    /**
     * Every archetype measured at the same grade, with the roster medians beside them. A single build\'s numbers mean nothing alone — \'falls in 1.6 turns\' is alarming or fine depending entirely on what everyone else does.
     * @summary The whole roster at one grade
     * @param {number} [grade] Rank grade, 10 (beginner) down to 0 (master).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterArchetypesApi
     */
    public gamemasterArchetypesBalanceRetrieve(grade?: number, options?: RawAxiosRequestConfig) {
        return GameMasterArchetypesApiFp(this.configuration).gamemasterArchetypesBalanceRetrieve(grade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Every archetype with its derived metatype, role, school progression and any data problems worth showing on the card. Filterable by metatype, role, path and hybrid status.
     * @summary List archetypes
     * @param {boolean} [isHybrid] 
     * @param {GamemasterArchetypesListMetatypeEnum} [metatype] Attacker, Defender, Healer, Buffer or Debuffer
     * @param {string} [path] 
     * @param {Role266Enum} [role] The coarse stance the metatype belongs to
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterArchetypesApi
     */
    public gamemasterArchetypesList(isHybrid?: boolean, metatype?: GamemasterArchetypesListMetatypeEnum, path?: string, role?: Role266Enum, search?: string, options?: RawAxiosRequestConfig) {
        return GameMasterArchetypesApiFp(this.configuration).gamemasterArchetypesList(isHybrid, metatype, path, role, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Every dial the power calculation turns, with the reasoning behind each. Published so the workbench can explain its own arithmetic rather than presenting numbers to be taken on trust.
     * @summary The rating model\'s coefficients
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterArchetypesApi
     */
    public gamemasterArchetypesModelRetrieve(options?: RawAxiosRequestConfig) {
        return GameMasterArchetypesApiFp(this.configuration).gamemasterArchetypesModelRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The archetype grade by grade: which schools are open, which skills that makes castable, what each is worth per action point, and what the whole build adds up to. Pass `grade` for one grade.
     * @summary Get one archetype\'s build
     * @param {string} id A UUID string identifying this Character Archetype.
     * @param {number} [grade] Rank grade, 10 (beginner) down to 0 (master).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterArchetypesApi
     */
    public gamemasterArchetypesRetrieve(id: string, grade?: number, options?: RawAxiosRequestConfig) {
        return GameMasterArchetypesApiFp(this.configuration).gamemasterArchetypesRetrieve(id, grade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * How many archetypes play each role, for the filter bar.
     * @summary Roster distribution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterArchetypesApi
     */
    public gamemasterArchetypesRolesRetrieve(options?: RawAxiosRequestConfig) {
        return GameMasterArchetypesApiFp(this.configuration).gamemasterArchetypesRolesRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GamemasterArchetypesListMetatypeEnum = {
    Attacker: 'Attacker',
    Buffer: 'Buffer',
    Debuffer: 'Debuffer',
    Defender: 'Defender',
    Healer: 'Healer'
} as const;
export type GamemasterArchetypesListMetatypeEnum = typeof GamemasterArchetypesListMetatypeEnum[keyof typeof GamemasterArchetypesListMetatypeEnum];


/**
 * GameMasterAvatarsApi - axios parameter creator
 * @export
 */
export const GameMasterAvatarsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Upload a generated portrait for a character.
         * @param {string} id A UUID string identifying this character.
         * @param {File} avatar 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersWithoutAvatarAvatarCreate: async (id: string, avatar: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCharactersWithoutAvatarAvatarCreate', 'id', id)
            // verify required parameter 'avatar' is not null or undefined
            assertParamExists('gamemasterCharactersWithoutAvatarAvatarCreate', 'avatar', avatar)
            const localVarPath = `/api/gamemaster/characters-without-avatar/{id}/avatar/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (avatar !== undefined) { 
                localVarFormParams.append('avatar', avatar as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Characters that still carry a placeholder portrait, newest first. Returns name and appearance so an image generator can work through the queue. Spans every campaign; narrow with ?campaign= or ?npc=.
         * @param {string} [campaign] Limit the queue to a single campaign id.
         * @param {boolean} [npc] Keep only NPCs (true) or only player characters (false).
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersWithoutAvatarList: async (campaign?: string, npc?: boolean, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/characters-without-avatar/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (campaign !== undefined) {
                localVarQueryParameter['campaign'] = campaign;
            }

            if (npc !== undefined) {
                localVarQueryParameter['npc'] = npc;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GameMasterAvatarsApi - functional programming interface
 * @export
 */
export const GameMasterAvatarsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GameMasterAvatarsApiAxiosParamCreator(configuration)
    return {
        /**
         * Upload a generated portrait for a character.
         * @param {string} id A UUID string identifying this character.
         * @param {File} avatar 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharactersWithoutAvatarAvatarCreate(id: string, avatar: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterAvatar>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharactersWithoutAvatarAvatarCreate(id, avatar, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterAvatarsApi.gamemasterCharactersWithoutAvatarAvatarCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Characters that still carry a placeholder portrait, newest first. Returns name and appearance so an image generator can work through the queue. Spans every campaign; narrow with ?campaign= or ?npc=.
         * @param {string} [campaign] Limit the queue to a single campaign id.
         * @param {boolean} [npc] Keep only NPCs (true) or only player characters (false).
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharactersWithoutAvatarList(campaign?: string, npc?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCharacterMissingAvatarList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharactersWithoutAvatarList(campaign, npc, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterAvatarsApi.gamemasterCharactersWithoutAvatarList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GameMasterAvatarsApi - factory interface
 * @export
 */
export const GameMasterAvatarsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GameMasterAvatarsApiFp(configuration)
    return {
        /**
         * Upload a generated portrait for a character.
         * @param {string} id A UUID string identifying this character.
         * @param {File} avatar 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersWithoutAvatarAvatarCreate(id: string, avatar: File, options?: any): AxiosPromise<CharacterAvatar> {
            return localVarFp.gamemasterCharactersWithoutAvatarAvatarCreate(id, avatar, options).then((request) => request(axios, basePath));
        },
        /**
         * Characters that still carry a placeholder portrait, newest first. Returns name and appearance so an image generator can work through the queue. Spans every campaign; narrow with ?campaign= or ?npc=.
         * @param {string} [campaign] Limit the queue to a single campaign id.
         * @param {boolean} [npc] Keep only NPCs (true) or only player characters (false).
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersWithoutAvatarList(campaign?: string, npc?: boolean, page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedCharacterMissingAvatarList> {
            return localVarFp.gamemasterCharactersWithoutAvatarList(campaign, npc, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GameMasterAvatarsApi - object-oriented interface
 * @export
 * @class GameMasterAvatarsApi
 * @extends {BaseAPI}
 */
export class GameMasterAvatarsApi extends BaseAPI {
    /**
     * Upload a generated portrait for a character.
     * @param {string} id A UUID string identifying this character.
     * @param {File} avatar 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterAvatarsApi
     */
    public gamemasterCharactersWithoutAvatarAvatarCreate(id: string, avatar: File, options?: RawAxiosRequestConfig) {
        return GameMasterAvatarsApiFp(this.configuration).gamemasterCharactersWithoutAvatarAvatarCreate(id, avatar, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Characters that still carry a placeholder portrait, newest first. Returns name and appearance so an image generator can work through the queue. Spans every campaign; narrow with ?campaign= or ?npc=.
     * @param {string} [campaign] Limit the queue to a single campaign id.
     * @param {boolean} [npc] Keep only NPCs (true) or only player characters (false).
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterAvatarsApi
     */
    public gamemasterCharactersWithoutAvatarList(campaign?: string, npc?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return GameMasterAvatarsApiFp(this.configuration).gamemasterCharactersWithoutAvatarList(campaign, npc, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GameMasterCampaignBuilderApi - axios parameter creator
 * @export
 */
export const GameMasterCampaignBuilderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {File} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsBackgroundImageCreate: async (id: string, image: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsBackgroundImageCreate', 'id', id)
            // verify required parameter 'image' is not null or undefined
            assertParamExists('gamemasterCampaignsBackgroundImageCreate', 'image', image)
            const localVarPath = `/api/gamemaster/campaigns/{id}/background-image/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {PatchedCampaignBuilderStateUpdateRequest} [patchedCampaignBuilderStateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsBuilderStatePartialUpdate: async (id: string, patchedCampaignBuilderStateUpdateRequest?: PatchedCampaignBuilderStateUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsBuilderStatePartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/campaigns/{id}/builder-state/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCampaignBuilderStateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsBuilderStateRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsBuilderStateRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/campaigns/{id}/builder-state/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignDetailRequest} campaignDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsCloneCreate: async (id: string, campaignDetailRequest: CampaignDetailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsCloneCreate', 'id', id)
            // verify required parameter 'campaignDetailRequest' is not null or undefined
            assertParamExists('gamemasterCampaignsCloneCreate', 'campaignDetailRequest', campaignDetailRequest)
            const localVarPath = `/api/gamemaster/campaigns/{id}/clone/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {CampaignCreateRequest} campaignCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsCreate: async (campaignCreateRequest: CampaignCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignCreateRequest' is not null or undefined
            assertParamExists('gamemasterCampaignsCreate', 'campaignCreateRequest', campaignCreateRequest)
            const localVarPath = `/api/gamemaster/campaigns/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/campaigns/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignMemberAddRequest} campaignMemberAddRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsMembersCreate: async (id: string, campaignMemberAddRequest: CampaignMemberAddRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsMembersCreate', 'id', id)
            // verify required parameter 'campaignMemberAddRequest' is not null or undefined
            assertParamExists('gamemasterCampaignsMembersCreate', 'campaignMemberAddRequest', campaignMemberAddRequest)
            const localVarPath = `/api/gamemaster/campaigns/{id}/members/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignMemberAddRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} clientId 
         * @param {string} id A UUID string identifying this campaign.
         * @param {string} role \&#39;master\&#39; or \&#39;player\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsMembersDestroy: async (clientId: string, id: string, role: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('gamemasterCampaignsMembersDestroy', 'clientId', clientId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsMembersDestroy', 'id', id)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('gamemasterCampaignsMembersDestroy', 'role', role)
            const localVarPath = `/api/gamemaster/campaigns/{id}/members/{client_id}/`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsMembersRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsMembersRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/campaigns/{id}/members/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignDetailRequest} campaignDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsNpcsCreate: async (id: string, campaignDetailRequest: CampaignDetailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsNpcsCreate', 'id', id)
            // verify required parameter 'campaignDetailRequest' is not null or undefined
            assertParamExists('gamemasterCampaignsNpcsCreate', 'campaignDetailRequest', campaignDetailRequest)
            const localVarPath = `/api/gamemaster/campaigns/{id}/npcs/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {string} npcId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsNpcsDestroy: async (id: string, npcId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsNpcsDestroy', 'id', id)
            // verify required parameter 'npcId' is not null or undefined
            assertParamExists('gamemasterCampaignsNpcsDestroy', 'npcId', npcId)
            const localVarPath = `/api/gamemaster/campaigns/{id}/npcs/{npc_id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"npc_id"}}`, encodeURIComponent(String(npcId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {string} npcId 
         * @param {PatchedCampaignNPCUpdateRequest} [patchedCampaignNPCUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsNpcsPartialUpdate: async (id: string, npcId: string, patchedCampaignNPCUpdateRequest?: PatchedCampaignNPCUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsNpcsPartialUpdate', 'id', id)
            // verify required parameter 'npcId' is not null or undefined
            assertParamExists('gamemasterCampaignsNpcsPartialUpdate', 'npcId', npcId)
            const localVarPath = `/api/gamemaster/campaigns/{id}/npcs/{npc_id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"npc_id"}}`, encodeURIComponent(String(npcId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCampaignNPCUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {string} npcId 
         * @param {CampaignNPCPlaceRequest} campaignNPCPlaceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsNpcsPlaceCreate: async (id: string, npcId: string, campaignNPCPlaceRequest: CampaignNPCPlaceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsNpcsPlaceCreate', 'id', id)
            // verify required parameter 'npcId' is not null or undefined
            assertParamExists('gamemasterCampaignsNpcsPlaceCreate', 'npcId', npcId)
            // verify required parameter 'campaignNPCPlaceRequest' is not null or undefined
            assertParamExists('gamemasterCampaignsNpcsPlaceCreate', 'campaignNPCPlaceRequest', campaignNPCPlaceRequest)
            const localVarPath = `/api/gamemaster/campaigns/{id}/npcs/{npc_id}/place/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"npc_id"}}`, encodeURIComponent(String(npcId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignNPCPlaceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsNpcsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsNpcsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/campaigns/{id}/npcs/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignDetailRequest} campaignDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsObjectivesCreate: async (id: string, campaignDetailRequest: CampaignDetailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsObjectivesCreate', 'id', id)
            // verify required parameter 'campaignDetailRequest' is not null or undefined
            assertParamExists('gamemasterCampaignsObjectivesCreate', 'campaignDetailRequest', campaignDetailRequest)
            const localVarPath = `/api/gamemaster/campaigns/{id}/objectives/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsObjectivesRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsObjectivesRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/campaigns/{id}/objectives/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {PatchedCampaignBasicsUpdateRequest} [patchedCampaignBasicsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsPartialUpdate: async (id: string, patchedCampaignBasicsUpdateRequest?: PatchedCampaignBasicsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/campaigns/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCampaignBasicsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignPositionCreateRequest} campaignPositionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsPositionsCreate: async (id: string, campaignPositionCreateRequest: CampaignPositionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsPositionsCreate', 'id', id)
            // verify required parameter 'campaignPositionCreateRequest' is not null or undefined
            assertParamExists('gamemasterCampaignsPositionsCreate', 'campaignPositionCreateRequest', campaignPositionCreateRequest)
            const localVarPath = `/api/gamemaster/campaigns/{id}/positions/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignPositionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignDetailRequest} campaignDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsPublishCreate: async (id: string, campaignDetailRequest: CampaignDetailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsPublishCreate', 'id', id)
            // verify required parameter 'campaignDetailRequest' is not null or undefined
            assertParamExists('gamemasterCampaignsPublishCreate', 'campaignDetailRequest', campaignDetailRequest)
            const localVarPath = `/api/gamemaster/campaigns/{id}/publish/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/campaigns/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignStartPositionRequest} campaignStartPositionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsStartPositionCreate: async (id: string, campaignStartPositionRequest: CampaignStartPositionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsStartPositionCreate', 'id', id)
            // verify required parameter 'campaignStartPositionRequest' is not null or undefined
            assertParamExists('gamemasterCampaignsStartPositionCreate', 'campaignStartPositionRequest', campaignStartPositionRequest)
            const localVarPath = `/api/gamemaster/campaigns/{id}/start-position/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignStartPositionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsSummaryRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsSummaryRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/campaigns/{id}/summary/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignTacticalMapAssignRequest} campaignTacticalMapAssignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsTacticalMapCreate: async (id: string, campaignTacticalMapAssignRequest: CampaignTacticalMapAssignRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsTacticalMapCreate', 'id', id)
            // verify required parameter 'campaignTacticalMapAssignRequest' is not null or undefined
            assertParamExists('gamemasterCampaignsTacticalMapCreate', 'campaignTacticalMapAssignRequest', campaignTacticalMapAssignRequest)
            const localVarPath = `/api/gamemaster/campaigns/{id}/tactical-map/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignTacticalMapAssignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsValidateRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsValidateRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/campaigns/{id}/validate/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GameMasterCampaignBuilderApi - functional programming interface
 * @export
 */
export const GameMasterCampaignBuilderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GameMasterCampaignBuilderApiAxiosParamCreator(configuration)
    return {
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {File} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsBackgroundImageCreate(id: string, image: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsBackgroundImageCreate(id, image, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsBackgroundImageCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {PatchedCampaignBuilderStateUpdateRequest} [patchedCampaignBuilderStateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsBuilderStatePartialUpdate(id: string, patchedCampaignBuilderStateUpdateRequest?: PatchedCampaignBuilderStateUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignBuilderState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsBuilderStatePartialUpdate(id, patchedCampaignBuilderStateUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsBuilderStatePartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsBuilderStateRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignBuilderState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsBuilderStateRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsBuilderStateRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignDetailRequest} campaignDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsCloneCreate(id: string, campaignDetailRequest: CampaignDetailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsCloneCreate(id, campaignDetailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsCloneCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {CampaignCreateRequest} campaignCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsCreate(campaignCreateRequest: CampaignCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsCreate(campaignCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CampaignList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignMemberAddRequest} campaignMemberAddRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsMembersCreate(id: string, campaignMemberAddRequest: CampaignMemberAddRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsMembersCreate(id, campaignMemberAddRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsMembersCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} clientId 
         * @param {string} id A UUID string identifying this campaign.
         * @param {string} role \&#39;master\&#39; or \&#39;player\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsMembersDestroy(clientId: string, id: string, role: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsMembersDestroy(clientId, id, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsMembersDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsMembersRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsMembersRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsMembersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignDetailRequest} campaignDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsNpcsCreate(id: string, campaignDetailRequest: CampaignDetailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignNPC>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsNpcsCreate(id, campaignDetailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsNpcsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {string} npcId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsNpcsDestroy(id: string, npcId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignNPC>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsNpcsDestroy(id, npcId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsNpcsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {string} npcId 
         * @param {PatchedCampaignNPCUpdateRequest} [patchedCampaignNPCUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsNpcsPartialUpdate(id: string, npcId: string, patchedCampaignNPCUpdateRequest?: PatchedCampaignNPCUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignNPC>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsNpcsPartialUpdate(id, npcId, patchedCampaignNPCUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsNpcsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {string} npcId 
         * @param {CampaignNPCPlaceRequest} campaignNPCPlaceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsNpcsPlaceCreate(id: string, npcId: string, campaignNPCPlaceRequest: CampaignNPCPlaceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignNPC>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsNpcsPlaceCreate(id, npcId, campaignNPCPlaceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsNpcsPlaceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsNpcsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignNPC>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsNpcsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsNpcsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignDetailRequest} campaignDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsObjectivesCreate(id: string, campaignDetailRequest: CampaignDetailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignObjective>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsObjectivesCreate(id, campaignDetailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsObjectivesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsObjectivesRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignObjective>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsObjectivesRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsObjectivesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {PatchedCampaignBasicsUpdateRequest} [patchedCampaignBasicsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsPartialUpdate(id: string, patchedCampaignBasicsUpdateRequest?: PatchedCampaignBasicsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignBasicsUpdate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsPartialUpdate(id, patchedCampaignBasicsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignPositionCreateRequest} campaignPositionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsPositionsCreate(id: string, campaignPositionCreateRequest: CampaignPositionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsPositionsCreate(id, campaignPositionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsPositionsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignDetailRequest} campaignDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsPublishCreate(id: string, campaignDetailRequest: CampaignDetailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsPublishCreate(id, campaignDetailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsPublishCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignStartPositionRequest} campaignStartPositionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsStartPositionCreate(id: string, campaignStartPositionRequest: CampaignStartPositionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsStartPositionCreate(id, campaignStartPositionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsStartPositionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsSummaryRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsSummaryRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsSummaryRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignTacticalMapAssignRequest} campaignTacticalMapAssignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsTacticalMapCreate(id: string, campaignTacticalMapAssignRequest: CampaignTacticalMapAssignRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TacticalMapResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsTacticalMapCreate(id, campaignTacticalMapAssignRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsTacticalMapCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsValidateRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsValidateRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterCampaignBuilderApi.gamemasterCampaignsValidateRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GameMasterCampaignBuilderApi - factory interface
 * @export
 */
export const GameMasterCampaignBuilderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GameMasterCampaignBuilderApiFp(configuration)
    return {
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {File} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsBackgroundImageCreate(id: string, image: File, options?: any): AxiosPromise<CampaignDetail> {
            return localVarFp.gamemasterCampaignsBackgroundImageCreate(id, image, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {PatchedCampaignBuilderStateUpdateRequest} [patchedCampaignBuilderStateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsBuilderStatePartialUpdate(id: string, patchedCampaignBuilderStateUpdateRequest?: PatchedCampaignBuilderStateUpdateRequest, options?: any): AxiosPromise<CampaignBuilderState> {
            return localVarFp.gamemasterCampaignsBuilderStatePartialUpdate(id, patchedCampaignBuilderStateUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsBuilderStateRetrieve(id: string, options?: any): AxiosPromise<CampaignBuilderState> {
            return localVarFp.gamemasterCampaignsBuilderStateRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignDetailRequest} campaignDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsCloneCreate(id: string, campaignDetailRequest: CampaignDetailRequest, options?: any): AxiosPromise<CampaignDetail> {
            return localVarFp.gamemasterCampaignsCloneCreate(id, campaignDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {CampaignCreateRequest} campaignCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsCreate(campaignCreateRequest: CampaignCreateRequest, options?: any): AxiosPromise<CampaignCreate> {
            return localVarFp.gamemasterCampaignsCreate(campaignCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsList(options?: any): AxiosPromise<Array<CampaignList>> {
            return localVarFp.gamemasterCampaignsList(options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignMemberAddRequest} campaignMemberAddRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsMembersCreate(id: string, campaignMemberAddRequest: CampaignMemberAddRequest, options?: any): AxiosPromise<CampaignDetail> {
            return localVarFp.gamemasterCampaignsMembersCreate(id, campaignMemberAddRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} clientId 
         * @param {string} id A UUID string identifying this campaign.
         * @param {string} role \&#39;master\&#39; or \&#39;player\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsMembersDestroy(clientId: string, id: string, role: string, options?: any): AxiosPromise<void> {
            return localVarFp.gamemasterCampaignsMembersDestroy(clientId, id, role, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsMembersRetrieve(id: string, options?: any): AxiosPromise<CampaignDetail> {
            return localVarFp.gamemasterCampaignsMembersRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignDetailRequest} campaignDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsNpcsCreate(id: string, campaignDetailRequest: CampaignDetailRequest, options?: any): AxiosPromise<CampaignNPC> {
            return localVarFp.gamemasterCampaignsNpcsCreate(id, campaignDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {string} npcId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsNpcsDestroy(id: string, npcId: string, options?: any): AxiosPromise<CampaignNPC> {
            return localVarFp.gamemasterCampaignsNpcsDestroy(id, npcId, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {string} npcId 
         * @param {PatchedCampaignNPCUpdateRequest} [patchedCampaignNPCUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsNpcsPartialUpdate(id: string, npcId: string, patchedCampaignNPCUpdateRequest?: PatchedCampaignNPCUpdateRequest, options?: any): AxiosPromise<CampaignNPC> {
            return localVarFp.gamemasterCampaignsNpcsPartialUpdate(id, npcId, patchedCampaignNPCUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {string} npcId 
         * @param {CampaignNPCPlaceRequest} campaignNPCPlaceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsNpcsPlaceCreate(id: string, npcId: string, campaignNPCPlaceRequest: CampaignNPCPlaceRequest, options?: any): AxiosPromise<CampaignNPC> {
            return localVarFp.gamemasterCampaignsNpcsPlaceCreate(id, npcId, campaignNPCPlaceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsNpcsRetrieve(id: string, options?: any): AxiosPromise<CampaignNPC> {
            return localVarFp.gamemasterCampaignsNpcsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignDetailRequest} campaignDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsObjectivesCreate(id: string, campaignDetailRequest: CampaignDetailRequest, options?: any): AxiosPromise<CampaignObjective> {
            return localVarFp.gamemasterCampaignsObjectivesCreate(id, campaignDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsObjectivesRetrieve(id: string, options?: any): AxiosPromise<CampaignObjective> {
            return localVarFp.gamemasterCampaignsObjectivesRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {PatchedCampaignBasicsUpdateRequest} [patchedCampaignBasicsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsPartialUpdate(id: string, patchedCampaignBasicsUpdateRequest?: PatchedCampaignBasicsUpdateRequest, options?: any): AxiosPromise<CampaignBasicsUpdate> {
            return localVarFp.gamemasterCampaignsPartialUpdate(id, patchedCampaignBasicsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignPositionCreateRequest} campaignPositionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsPositionsCreate(id: string, campaignPositionCreateRequest: CampaignPositionCreateRequest, options?: any): AxiosPromise<PositionBrief> {
            return localVarFp.gamemasterCampaignsPositionsCreate(id, campaignPositionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignDetailRequest} campaignDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsPublishCreate(id: string, campaignDetailRequest: CampaignDetailRequest, options?: any): AxiosPromise<CampaignDetail> {
            return localVarFp.gamemasterCampaignsPublishCreate(id, campaignDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsRetrieve(id: string, options?: any): AxiosPromise<CampaignDetail> {
            return localVarFp.gamemasterCampaignsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignStartPositionRequest} campaignStartPositionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsStartPositionCreate(id: string, campaignStartPositionRequest: CampaignStartPositionRequest, options?: any): AxiosPromise<CampaignDetail> {
            return localVarFp.gamemasterCampaignsStartPositionCreate(id, campaignStartPositionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsSummaryRetrieve(id: string, options?: any): AxiosPromise<CampaignSummary> {
            return localVarFp.gamemasterCampaignsSummaryRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignTacticalMapAssignRequest} campaignTacticalMapAssignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsTacticalMapCreate(id: string, campaignTacticalMapAssignRequest: CampaignTacticalMapAssignRequest, options?: any): AxiosPromise<TacticalMapResult> {
            return localVarFp.gamemasterCampaignsTacticalMapCreate(id, campaignTacticalMapAssignRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsValidateRetrieve(id: string, options?: any): AxiosPromise<PublishReport> {
            return localVarFp.gamemasterCampaignsValidateRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GameMasterCampaignBuilderApi - object-oriented interface
 * @export
 * @class GameMasterCampaignBuilderApi
 * @extends {BaseAPI}
 */
export class GameMasterCampaignBuilderApi extends BaseAPI {
    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {File} image 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsBackgroundImageCreate(id: string, image: File, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsBackgroundImageCreate(id, image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {PatchedCampaignBuilderStateUpdateRequest} [patchedCampaignBuilderStateUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsBuilderStatePartialUpdate(id: string, patchedCampaignBuilderStateUpdateRequest?: PatchedCampaignBuilderStateUpdateRequest, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsBuilderStatePartialUpdate(id, patchedCampaignBuilderStateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsBuilderStateRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsBuilderStateRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {CampaignDetailRequest} campaignDetailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsCloneCreate(id: string, campaignDetailRequest: CampaignDetailRequest, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsCloneCreate(id, campaignDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {CampaignCreateRequest} campaignCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsCreate(campaignCreateRequest: CampaignCreateRequest, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsCreate(campaignCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsList(options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {CampaignMemberAddRequest} campaignMemberAddRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsMembersCreate(id: string, campaignMemberAddRequest: CampaignMemberAddRequest, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsMembersCreate(id, campaignMemberAddRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} clientId 
     * @param {string} id A UUID string identifying this campaign.
     * @param {string} role \&#39;master\&#39; or \&#39;player\&#39;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsMembersDestroy(clientId: string, id: string, role: string, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsMembersDestroy(clientId, id, role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsMembersRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsMembersRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {CampaignDetailRequest} campaignDetailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsNpcsCreate(id: string, campaignDetailRequest: CampaignDetailRequest, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsNpcsCreate(id, campaignDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {string} npcId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsNpcsDestroy(id: string, npcId: string, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsNpcsDestroy(id, npcId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {string} npcId 
     * @param {PatchedCampaignNPCUpdateRequest} [patchedCampaignNPCUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsNpcsPartialUpdate(id: string, npcId: string, patchedCampaignNPCUpdateRequest?: PatchedCampaignNPCUpdateRequest, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsNpcsPartialUpdate(id, npcId, patchedCampaignNPCUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {string} npcId 
     * @param {CampaignNPCPlaceRequest} campaignNPCPlaceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsNpcsPlaceCreate(id: string, npcId: string, campaignNPCPlaceRequest: CampaignNPCPlaceRequest, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsNpcsPlaceCreate(id, npcId, campaignNPCPlaceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsNpcsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsNpcsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {CampaignDetailRequest} campaignDetailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsObjectivesCreate(id: string, campaignDetailRequest: CampaignDetailRequest, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsObjectivesCreate(id, campaignDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsObjectivesRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsObjectivesRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {PatchedCampaignBasicsUpdateRequest} [patchedCampaignBasicsUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsPartialUpdate(id: string, patchedCampaignBasicsUpdateRequest?: PatchedCampaignBasicsUpdateRequest, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsPartialUpdate(id, patchedCampaignBasicsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {CampaignPositionCreateRequest} campaignPositionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsPositionsCreate(id: string, campaignPositionCreateRequest: CampaignPositionCreateRequest, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsPositionsCreate(id, campaignPositionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {CampaignDetailRequest} campaignDetailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsPublishCreate(id: string, campaignDetailRequest: CampaignDetailRequest, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsPublishCreate(id, campaignDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {CampaignStartPositionRequest} campaignStartPositionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsStartPositionCreate(id: string, campaignStartPositionRequest: CampaignStartPositionRequest, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsStartPositionCreate(id, campaignStartPositionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsSummaryRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsSummaryRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {CampaignTacticalMapAssignRequest} campaignTacticalMapAssignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsTacticalMapCreate(id: string, campaignTacticalMapAssignRequest: CampaignTacticalMapAssignRequest, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsTacticalMapCreate(id, campaignTacticalMapAssignRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterCampaignBuilderApi
     */
    public gamemasterCampaignsValidateRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterCampaignBuilderApiFp(this.configuration).gamemasterCampaignsValidateRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GameMasterModerationApi - axios parameter creator
 * @export
 */
export const GameMasterModerationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterPortraitRequestsList: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/portrait-requests/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
         * @param {string} id A UUID string identifying this character portrait request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterPortraitRequestsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterPortraitRequestsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/portrait-requests/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterPublicationRequestsList: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/publication-requests/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
         * @param {string} id A UUID string identifying this character publication request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterPublicationRequestsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterPublicationRequestsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/publication-requests/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GameMasterModerationApi - functional programming interface
 * @export
 */
export const GameMasterModerationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GameMasterModerationApiAxiosParamCreator(configuration)
    return {
        /**
         * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterPortraitRequestsList(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPortraitQueueItemList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterPortraitRequestsList(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterModerationApi.gamemasterPortraitRequestsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
         * @param {string} id A UUID string identifying this character portrait request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterPortraitRequestsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortraitQueueItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterPortraitRequestsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterModerationApi.gamemasterPortraitRequestsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterPublicationRequestsList(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedModerationQueueItemList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterPublicationRequestsList(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterModerationApi.gamemasterPublicationRequestsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
         * @param {string} id A UUID string identifying this character publication request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterPublicationRequestsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModerationQueueItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterPublicationRequestsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterModerationApi.gamemasterPublicationRequestsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GameMasterModerationApi - factory interface
 * @export
 */
export const GameMasterModerationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GameMasterModerationApiFp(configuration)
    return {
        /**
         * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterPortraitRequestsList(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedPortraitQueueItemList> {
            return localVarFp.gamemasterPortraitRequestsList(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
         * @param {string} id A UUID string identifying this character portrait request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterPortraitRequestsRetrieve(id: string, options?: any): AxiosPromise<PortraitQueueItem> {
            return localVarFp.gamemasterPortraitRequestsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterPublicationRequestsList(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedModerationQueueItemList> {
            return localVarFp.gamemasterPublicationRequestsList(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
         * @param {string} id A UUID string identifying this character publication request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterPublicationRequestsRetrieve(id: string, options?: any): AxiosPromise<ModerationQueueItem> {
            return localVarFp.gamemasterPublicationRequestsRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GameMasterModerationApi - object-oriented interface
 * @export
 * @class GameMasterModerationApi
 * @extends {BaseAPI}
 */
export class GameMasterModerationApi extends BaseAPI {
    /**
     * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterModerationApi
     */
    public gamemasterPortraitRequestsList(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return GameMasterModerationApiFp(this.configuration).gamemasterPortraitRequestsList(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
     * @param {string} id A UUID string identifying this character portrait request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterModerationApi
     */
    public gamemasterPortraitRequestsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterModerationApiFp(this.configuration).gamemasterPortraitRequestsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterModerationApi
     */
    public gamemasterPublicationRequestsList(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return GameMasterModerationApiFp(this.configuration).gamemasterPublicationRequestsList(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read-only queue. Approval and rejection are NOT exposed over HTTP — they happen only through Django admin actions, so there is no API surface through which an approval can be forged.
     * @param {string} id A UUID string identifying this character publication request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterModerationApi
     */
    public gamemasterPublicationRequestsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterModerationApiFp(this.configuration).gamemasterPublicationRequestsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GameMasterSkillCalculatorApi - axios parameter creator
 * @export
 */
export const GameMasterSkillCalculatorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *          Analyzes how a skill\'s impacts scale as a primary stat increases from min to max value.          **Purpose:**         This endpoint helps Game Masters understand skill balance by visualizing how damage/healing         scales with stat investment. It generates three curves (minimum/median/maximum) showing         impact values across a stat range.          **Curves:**         - **Minimum Curve**: Primary stat varies, other stats at minimum baseline (default: 10)         - **Median Curve**: Primary stat varies, other stats at median baseline (default: 50)         - **Maximum Curve**: Primary stat varies, other stats at maximum baseline (default: 100)          **Use Cases:**         - Compare scaling rates between different skills         - Identify overpowered or underpowered skills         - Understand how stat distribution affects skill effectiveness         - Balance skill requirements and scaling factors          **Example:**         Analyzing \"Fireball\" skill with Flow Manipulation as primary stat from 0-150 in steps of 5         shows how damage scales when the character has low/medium/high values in other stats         (Flow Resonance, Concentration, etc.).          **Where the numbers come from:**         Every point is resolved through `SkillWorkbenchService`, the same spine the         workbench\'s own scaling sweep uses, so this page and that one cannot         disagree. The request and response shapes are unchanged.         
         * @summary Analyze Skill Impact Progression
         * @param {AnalyzeProgressionRequestRequest} analyzeProgressionRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorAnalyzeProgressionCreate: async (analyzeProgressionRequestRequest: AnalyzeProgressionRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analyzeProgressionRequestRequest' is not null or undefined
            assertParamExists('gamemasterSkillCalculatorAnalyzeProgressionCreate', 'analyzeProgressionRequestRequest', analyzeProgressionRequestRequest)
            const localVarPath = `/api/gamemaster/skill-calculator/analyze-progression/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(analyzeProgressionRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *          Simulates skill impact calculations using provided stat values without requiring         a character instance. This is a pure calculation endpoint for skill balancing and testing.          **Features:**         - Accepts custom stat values for any CharacterStats         - Calculates impacts using the same formula as actual gameplay         - Returns detailed efficiency breakdown for each stat         - Provides warnings about missing requirements         - No database writes - pure calculation          **Formula:**         The impact calculation uses a logarithmic efficiency formula:         - `efficiency = 1 + (log10(1 + ratio) / log10(2) - 1) * (1 + scaling_factor)`         - `ratio = character_stat / required_stat`         - `final_impact = base_value * min(all_efficiencies)`          **Use Cases:**         - Testing new skill designs before implementation         - Balancing skill formulas and requirements         - Understanding how stat scaling affects impact values         - Identifying optimal stat builds for specific skills         
         * @summary Calculate Skill Impacts with Custom Stats
         * @param {CalculateImpactRequestRequest} calculateImpactRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorCalculateImpactCreate: async (calculateImpactRequestRequest: CalculateImpactRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculateImpactRequestRequest' is not null or undefined
            assertParamExists('gamemasterSkillCalculatorCalculateImpactCreate', 'calculateImpactRequestRequest', calculateImpactRequestRequest)
            const localVarPath = `/api/gamemaster/skill-calculator/calculate-impact/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculateImpactRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Resolves every skill in `skill_ids` against **one** subject and returns a row each: the dx-skill-power composite to sort on, then the named figures to judge by — per hit, per cell, per area, area multiple, cost efficiency, the luck band — and the rounds it takes to deliver a fixed pool of health.  The subject is the same shape every other endpoint here takes, and it is resolved once for the whole table. A table whose rows were measured against different casters compares nothing, which is the entire reason this is one request rather than N.  A row carrying more than one impact kind is flagged `mixed_kinds`: its magnitudes are a sum across kinds that are not interchangeable, and sorting it against a single-kind skill is a comparison the reader has to make knowingly.  Every magnitude comes from `SkillWorkbenchService` driving `SkillImpactService` — the class a real cast uses. The rounds column is the deterministic reading of the round simulator with the sampler off.         
         * @summary Several skills side by side against one body
         * @param {CompareRequestRequest} compareRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorCompareCreate: async (compareRequestRequest: CompareRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compareRequestRequest' is not null or undefined
            assertParamExists('gamemasterSkillCalculatorCompareCreate', 'compareRequestRequest', compareRequestRequest)
            const localVarPath = `/api/gamemaster/skill-calculator/compare/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(compareRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Every dial the composite turns, with the reasoning behind each and the formula they sit in. Published so a ranking number can be reproduced from a skill row and a calculator rather than taken on trust — the same reason the archetype rating model publishes its own.  The composite is **additional** to the named power figures. `power_per_cell`, `area_multiple`, `power_per_area`, `luck_min/avg/max` and `cost_efficiency` are unchanged and keep their meaning, because the archetype balance tables and the NPC ability selector read them.         
         * @summary The dx-skill-power model\'s coefficients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorPowerModelRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/skill-calculator/power-model/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Raises one attribute in steps and resolves the whole skill at each value, so a tuner can see where a formula\'s efficiency term flattens rather than reading a single point and guessing.  Every step is resolved through the same workbench spine as every other figure on the page. That is the entire reason this exists as an endpoint rather than as a client-side curve: the old progression page computed its own, from a second copy of the formula that had drifted from the engine by as much as twelvefold.  `stats` defaults to the attributes the skill\'s own formulas require or scale on — the rest would be flat lines.         
         * @summary Sweep an attribute and read the skill at every step
         * @param {ScalingRequestRequest} scalingRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorScalingCreate: async (scalingRequestRequest: ScalingRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scalingRequestRequest' is not null or undefined
            assertParamExists('gamemasterSkillCalculatorScalingCreate', 'scalingRequestRequest', scalingRequestRequest)
            const localVarPath = `/api/gamemaster/skill-calculator/scaling/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scalingRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  There is no cooldown in this game, so a skill\'s cost is its whole repeat-use limiter and \"what does this cost over a hundred rounds\" *is* the balance question.  Each round the caster either **fires** — the costs are affordable, possibly several times over, since a turn\'s action points refill every round and nothing meters what they are spent on — or **accumulates**, giving the round to refilling the energy reservoir the way the Flow Accumulation skill does. Energy is not restored by the clock and health is not restored at all; both facts are the engine\'s, not a model invented here.  Two readings come back. The **deterministic** one fixes the luck multiplier at its mean, so the same inputs always give the same curve and a tuning change is readable as a change. The **Monte Carlo band** rolls the real luck faces under a fixed seed and reports where the spread falls; send `monte_carlo_runs: 0` to skip it.  Every magnitude is resolved once through the workbench, which drives `SkillImpactService` — the class a real cast uses. Nothing here re-prices a skill.         
         * @summary Model a hundred rounds of one skill in one pair of hands
         * @param {SimulateRoundsRequestRequest} simulateRoundsRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorSimulateRoundsCreate: async (simulateRoundsRequestRequest: SimulateRoundsRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulateRoundsRequestRequest' is not null or undefined
            assertParamExists('gamemasterSkillCalculatorSimulateRoundsCreate', 'simulateRoundsRequestRequest', simulateRoundsRequestRequest)
            const localVarPath = `/api/gamemaster/skill-calculator/simulate-rounds/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simulateRoundsRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Writes the tuned fields back to the skill row. Only the fields sent are changed.  The payload is validated the way the model validates it — `full_clean` holds `impact`, `cost` and `effect` to their data-object contracts — so a malformed formula is refused here rather than stored and raised years later halfway through resolving somebody\'s attack.         
         * @summary Save a tuned skill
         * @param {TuneSkillRequestRequest} tuneSkillRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorTuneSkillCreate: async (tuneSkillRequestRequest: TuneSkillRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tuneSkillRequestRequest' is not null or undefined
            assertParamExists('gamemasterSkillCalculatorTuneSkillCreate', 'tuneSkillRequestRequest', tuneSkillRequestRequest)
            const localVarPath = `/api/gamemaster/skill-calculator/tune-skill/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tuneSkillRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Resolves one stored skill against one stat line and reports **every stage the engine applies**, in order: the formula\'s per-stat efficiency terms and which one capped the result, the engine\'s rounding, the full luck band, ward absorption, and the value that finally lands.  It also reports what `calculate-impact` cannot: resource costs against the caster\'s real pools, how many times this body can actually fire the skill and which resource stops it, effect durations and per-cycle impact over a whole duration, the spray pattern\'s cells with a per-cell and board-wide total, and the skill\'s power rating.  The cast counts under `costs.cadence` are the subject\'s own, and separate from the composite\'s `uses_per_turn`, which stays pinned to the reference turn so that two skills remain comparable. `casts_per_turn` divides a turn that refills every round; `reserve_casts` divides energy and health, which no clock restores, and is therefore a whole-fight ceiling rather than a rate.  Send `overrides` to resolve a *modified* skill without saving it — that is what makes this a tuning instrument. Use `tune-skill` to persist.  Send `subject` instead of `caster` to resolve against a **real body**: one of the six etalons, or a character in a campaign you hold. A character\'s health, energy and turn then come from `CharacterService` itself rather than from a re-derivation of its formulas. A character in a campaign you do not hold is refused. The raw `caster` form is unchanged and still supported.  The magnitude is produced by `SkillImpactService`, the same class a real cast uses, so a number here is a number in a fight. A disagreement between the reported breakdown and that class is returned as a warning rather than hidden.         
         * @summary Resolve a skill through the whole impact chain
         * @param {WorkbenchRequestRequest} workbenchRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorWorkbenchCreate: async (workbenchRequestRequest: WorkbenchRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workbenchRequestRequest' is not null or undefined
            assertParamExists('gamemasterSkillCalculatorWorkbenchCreate', 'workbenchRequestRequest', workbenchRequestRequest)
            const localVarPath = `/api/gamemaster/skill-calculator/workbench/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workbenchRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  The six etalons, then the characters in campaigns you hold. `default_subject_id` names the Path of John etalon, which is what a workbench opens on.  The etalons live in an inactive campaign of their own and are visible to every game master — they are the fixed yardstick. Characters are not: a campaign you do not hold contributes nobody.         
         * @summary Every body this game master may tune against
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/skill-subject/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Rebuilds the etalon from the roster definition — stats, rank, path, schools and base skills — through the same service `manage.py create_etalon_characters` drives, so \"pristine\" means exactly what a fresh build produces rather than an approximation of it. The old row is deleted; anything hand-added to it is gone.  Only an etalon may be reset. A real character has no pristine state to return to.         
         * @summary Restore an etalon to its pristine spec
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectResetCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSkillSubjectResetCreate', 'id', id)
            const localVarPath = `/api/gamemaster/skill-subject/{id}/reset/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pick, inspect and configure the subject a skill is tuned against.
         * @summary One subject, with its schools and skills
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSkillSubjectRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/skill-subject/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  `POST` teaches the school, `DELETE` unteaches it. Both go through `CharacterSchoolService`, so the slot count and the Path restriction apply exactly as they do to a player\'s character — a subject holding a school no player could hold would measure a skill nobody can cast.         
         * @summary Add or remove one of the subject\'s schools
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {SubjectSchoolMutationRequest} subjectSchoolMutationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectSchoolsCreate: async (id: string, subjectSchoolMutationRequest: SubjectSchoolMutationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSkillSubjectSchoolsCreate', 'id', id)
            // verify required parameter 'subjectSchoolMutationRequest' is not null or undefined
            assertParamExists('gamemasterSkillSubjectSchoolsCreate', 'subjectSchoolMutationRequest', subjectSchoolMutationRequest)
            const localVarPath = `/api/gamemaster/skill-subject/{id}/schools/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subjectSchoolMutationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  `POST` teaches the school, `DELETE` unteaches it. Both go through `CharacterSchoolService`, so the slot count and the Path restriction apply exactly as they do to a player\'s character — a subject holding a school no player could hold would measure a skill nobody can cast.         
         * @summary Add or remove one of the subject\'s schools
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectSchoolsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSkillSubjectSchoolsDestroy', 'id', id)
            const localVarPath = `/api/gamemaster/skill-subject/{id}/schools/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  `POST` teaches the skill, `DELETE` unteaches it, both through `CharacterSkillsService`.  Note the recorded open question about grade direction: the skill service refuses a skill *stronger* than the rank, the school service teaches everything *weaker* than it. Where the two disagree about the skill being added, this endpoint returns a warning and does not silently pick a side.         
         * @summary Add or remove one of the subject\'s skills
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {SubjectSkillMutationRequest} subjectSkillMutationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectSkillsCreate: async (id: string, subjectSkillMutationRequest: SubjectSkillMutationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSkillSubjectSkillsCreate', 'id', id)
            // verify required parameter 'subjectSkillMutationRequest' is not null or undefined
            assertParamExists('gamemasterSkillSubjectSkillsCreate', 'subjectSkillMutationRequest', subjectSkillMutationRequest)
            const localVarPath = `/api/gamemaster/skill-subject/{id}/skills/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subjectSkillMutationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  `POST` teaches the skill, `DELETE` unteaches it, both through `CharacterSkillsService`.  Note the recorded open question about grade direction: the skill service refuses a skill *stronger* than the rank, the school service teaches everything *weaker* than it. Where the two disagree about the skill being added, this endpoint returns a warning and does not silently pick a side.         
         * @summary Add or remove one of the subject\'s skills
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectSkillsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSkillSubjectSkillsDestroy', 'id', id)
            const localVarPath = `/api/gamemaster/skill-subject/{id}/skills/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GameMasterSkillCalculatorApi - functional programming interface
 * @export
 */
export const GameMasterSkillCalculatorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GameMasterSkillCalculatorApiAxiosParamCreator(configuration)
    return {
        /**
         *          Analyzes how a skill\'s impacts scale as a primary stat increases from min to max value.          **Purpose:**         This endpoint helps Game Masters understand skill balance by visualizing how damage/healing         scales with stat investment. It generates three curves (minimum/median/maximum) showing         impact values across a stat range.          **Curves:**         - **Minimum Curve**: Primary stat varies, other stats at minimum baseline (default: 10)         - **Median Curve**: Primary stat varies, other stats at median baseline (default: 50)         - **Maximum Curve**: Primary stat varies, other stats at maximum baseline (default: 100)          **Use Cases:**         - Compare scaling rates between different skills         - Identify overpowered or underpowered skills         - Understand how stat distribution affects skill effectiveness         - Balance skill requirements and scaling factors          **Example:**         Analyzing \"Fireball\" skill with Flow Manipulation as primary stat from 0-150 in steps of 5         shows how damage scales when the character has low/medium/high values in other stats         (Flow Resonance, Concentration, etc.).          **Where the numbers come from:**         Every point is resolved through `SkillWorkbenchService`, the same spine the         workbench\'s own scaling sweep uses, so this page and that one cannot         disagree. The request and response shapes are unchanged.         
         * @summary Analyze Skill Impact Progression
         * @param {AnalyzeProgressionRequestRequest} analyzeProgressionRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillCalculatorAnalyzeProgressionCreate(analyzeProgressionRequestRequest: AnalyzeProgressionRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyzeProgressionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillCalculatorAnalyzeProgressionCreate(analyzeProgressionRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillCalculatorAnalyzeProgressionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *          Simulates skill impact calculations using provided stat values without requiring         a character instance. This is a pure calculation endpoint for skill balancing and testing.          **Features:**         - Accepts custom stat values for any CharacterStats         - Calculates impacts using the same formula as actual gameplay         - Returns detailed efficiency breakdown for each stat         - Provides warnings about missing requirements         - No database writes - pure calculation          **Formula:**         The impact calculation uses a logarithmic efficiency formula:         - `efficiency = 1 + (log10(1 + ratio) / log10(2) - 1) * (1 + scaling_factor)`         - `ratio = character_stat / required_stat`         - `final_impact = base_value * min(all_efficiencies)`          **Use Cases:**         - Testing new skill designs before implementation         - Balancing skill formulas and requirements         - Understanding how stat scaling affects impact values         - Identifying optimal stat builds for specific skills         
         * @summary Calculate Skill Impacts with Custom Stats
         * @param {CalculateImpactRequestRequest} calculateImpactRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillCalculatorCalculateImpactCreate(calculateImpactRequestRequest: CalculateImpactRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculateImpactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillCalculatorCalculateImpactCreate(calculateImpactRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillCalculatorCalculateImpactCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  Resolves every skill in `skill_ids` against **one** subject and returns a row each: the dx-skill-power composite to sort on, then the named figures to judge by — per hit, per cell, per area, area multiple, cost efficiency, the luck band — and the rounds it takes to deliver a fixed pool of health.  The subject is the same shape every other endpoint here takes, and it is resolved once for the whole table. A table whose rows were measured against different casters compares nothing, which is the entire reason this is one request rather than N.  A row carrying more than one impact kind is flagged `mixed_kinds`: its magnitudes are a sum across kinds that are not interchangeable, and sorting it against a single-kind skill is a comparison the reader has to make knowingly.  Every magnitude comes from `SkillWorkbenchService` driving `SkillImpactService` — the class a real cast uses. The rounds column is the deterministic reading of the round simulator with the sampler off.         
         * @summary Several skills side by side against one body
         * @param {CompareRequestRequest} compareRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillCalculatorCompareCreate(compareRequestRequest: CompareRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillCalculatorCompareCreate(compareRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillCalculatorCompareCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  Every dial the composite turns, with the reasoning behind each and the formula they sit in. Published so a ranking number can be reproduced from a skill row and a calculator rather than taken on trust — the same reason the archetype rating model publishes its own.  The composite is **additional** to the named power figures. `power_per_cell`, `area_multiple`, `power_per_area`, `luck_min/avg/max` and `cost_efficiency` are unchanged and keep their meaning, because the archetype balance tables and the NPC ability selector read them.         
         * @summary The dx-skill-power model\'s coefficients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillCalculatorPowerModelRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PowerModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillCalculatorPowerModelRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillCalculatorPowerModelRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  Raises one attribute in steps and resolves the whole skill at each value, so a tuner can see where a formula\'s efficiency term flattens rather than reading a single point and guessing.  Every step is resolved through the same workbench spine as every other figure on the page. That is the entire reason this exists as an endpoint rather than as a client-side curve: the old progression page computed its own, from a second copy of the formula that had drifted from the engine by as much as twelvefold.  `stats` defaults to the attributes the skill\'s own formulas require or scale on — the rest would be flat lines.         
         * @summary Sweep an attribute and read the skill at every step
         * @param {ScalingRequestRequest} scalingRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillCalculatorScalingCreate(scalingRequestRequest: ScalingRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScalingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillCalculatorScalingCreate(scalingRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillCalculatorScalingCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  There is no cooldown in this game, so a skill\'s cost is its whole repeat-use limiter and \"what does this cost over a hundred rounds\" *is* the balance question.  Each round the caster either **fires** — the costs are affordable, possibly several times over, since a turn\'s action points refill every round and nothing meters what they are spent on — or **accumulates**, giving the round to refilling the energy reservoir the way the Flow Accumulation skill does. Energy is not restored by the clock and health is not restored at all; both facts are the engine\'s, not a model invented here.  Two readings come back. The **deterministic** one fixes the luck multiplier at its mean, so the same inputs always give the same curve and a tuning change is readable as a change. The **Monte Carlo band** rolls the real luck faces under a fixed seed and reports where the spread falls; send `monte_carlo_runs: 0` to skip it.  Every magnitude is resolved once through the workbench, which drives `SkillImpactService` — the class a real cast uses. Nothing here re-prices a skill.         
         * @summary Model a hundred rounds of one skill in one pair of hands
         * @param {SimulateRoundsRequestRequest} simulateRoundsRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillCalculatorSimulateRoundsCreate(simulateRoundsRequestRequest: SimulateRoundsRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulateRoundsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillCalculatorSimulateRoundsCreate(simulateRoundsRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillCalculatorSimulateRoundsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  Writes the tuned fields back to the skill row. Only the fields sent are changed.  The payload is validated the way the model validates it — `full_clean` holds `impact`, `cost` and `effect` to their data-object contracts — so a malformed formula is refused here rather than stored and raised years later halfway through resolving somebody\'s attack.         
         * @summary Save a tuned skill
         * @param {TuneSkillRequestRequest} tuneSkillRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillCalculatorTuneSkillCreate(tuneSkillRequestRequest: TuneSkillRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkbenchSkillFields>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillCalculatorTuneSkillCreate(tuneSkillRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillCalculatorTuneSkillCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  Resolves one stored skill against one stat line and reports **every stage the engine applies**, in order: the formula\'s per-stat efficiency terms and which one capped the result, the engine\'s rounding, the full luck band, ward absorption, and the value that finally lands.  It also reports what `calculate-impact` cannot: resource costs against the caster\'s real pools, how many times this body can actually fire the skill and which resource stops it, effect durations and per-cycle impact over a whole duration, the spray pattern\'s cells with a per-cell and board-wide total, and the skill\'s power rating.  The cast counts under `costs.cadence` are the subject\'s own, and separate from the composite\'s `uses_per_turn`, which stays pinned to the reference turn so that two skills remain comparable. `casts_per_turn` divides a turn that refills every round; `reserve_casts` divides energy and health, which no clock restores, and is therefore a whole-fight ceiling rather than a rate.  Send `overrides` to resolve a *modified* skill without saving it — that is what makes this a tuning instrument. Use `tune-skill` to persist.  Send `subject` instead of `caster` to resolve against a **real body**: one of the six etalons, or a character in a campaign you hold. A character\'s health, energy and turn then come from `CharacterService` itself rather than from a re-derivation of its formulas. A character in a campaign you do not hold is refused. The raw `caster` form is unchanged and still supported.  The magnitude is produced by `SkillImpactService`, the same class a real cast uses, so a number here is a number in a fight. A disagreement between the reported breakdown and that class is returned as a warning rather than hidden.         
         * @summary Resolve a skill through the whole impact chain
         * @param {WorkbenchRequestRequest} workbenchRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillCalculatorWorkbenchCreate(workbenchRequestRequest: WorkbenchRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkbenchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillCalculatorWorkbenchCreate(workbenchRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillCalculatorWorkbenchCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  The six etalons, then the characters in campaigns you hold. `default_subject_id` names the Path of John etalon, which is what a workbench opens on.  The etalons live in an inactive campaign of their own and are visible to every game master — they are the fixed yardstick. Characters are not: a campaign you do not hold contributes nobody.         
         * @summary Every body this game master may tune against
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillSubjectList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubjectRoster>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillSubjectList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillSubjectList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  Rebuilds the etalon from the roster definition — stats, rank, path, schools and base skills — through the same service `manage.py create_etalon_characters` drives, so \"pristine\" means exactly what a fresh build produces rather than an approximation of it. The old row is deleted; anything hand-added to it is gone.  Only an etalon may be reset. A real character has no pristine state to return to.         
         * @summary Restore an etalon to its pristine spec
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillSubjectResetCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubjectDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillSubjectResetCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillSubjectResetCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pick, inspect and configure the subject a skill is tuned against.
         * @summary One subject, with its schools and skills
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillSubjectRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubjectDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillSubjectRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillSubjectRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  `POST` teaches the school, `DELETE` unteaches it. Both go through `CharacterSchoolService`, so the slot count and the Path restriction apply exactly as they do to a player\'s character — a subject holding a school no player could hold would measure a skill nobody can cast.         
         * @summary Add or remove one of the subject\'s schools
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {SubjectSchoolMutationRequest} subjectSchoolMutationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillSubjectSchoolsCreate(id: string, subjectSchoolMutationRequest: SubjectSchoolMutationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubjectDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillSubjectSchoolsCreate(id, subjectSchoolMutationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillSubjectSchoolsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  `POST` teaches the school, `DELETE` unteaches it. Both go through `CharacterSchoolService`, so the slot count and the Path restriction apply exactly as they do to a player\'s character — a subject holding a school no player could hold would measure a skill nobody can cast.         
         * @summary Add or remove one of the subject\'s schools
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillSubjectSchoolsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubjectDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillSubjectSchoolsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillSubjectSchoolsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  `POST` teaches the skill, `DELETE` unteaches it, both through `CharacterSkillsService`.  Note the recorded open question about grade direction: the skill service refuses a skill *stronger* than the rank, the school service teaches everything *weaker* than it. Where the two disagree about the skill being added, this endpoint returns a warning and does not silently pick a side.         
         * @summary Add or remove one of the subject\'s skills
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {SubjectSkillMutationRequest} subjectSkillMutationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillSubjectSkillsCreate(id: string, subjectSkillMutationRequest: SubjectSkillMutationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubjectDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillSubjectSkillsCreate(id, subjectSkillMutationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillSubjectSkillsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  `POST` teaches the skill, `DELETE` unteaches it, both through `CharacterSkillsService`.  Note the recorded open question about grade direction: the skill service refuses a skill *stronger* than the rank, the school service teaches everything *weaker* than it. Where the two disagree about the skill being added, this endpoint returns a warning and does not silently pick a side.         
         * @summary Add or remove one of the subject\'s skills
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillSubjectSkillsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubjectDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillSubjectSkillsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterSkillCalculatorApi.gamemasterSkillSubjectSkillsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GameMasterSkillCalculatorApi - factory interface
 * @export
 */
export const GameMasterSkillCalculatorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GameMasterSkillCalculatorApiFp(configuration)
    return {
        /**
         *          Analyzes how a skill\'s impacts scale as a primary stat increases from min to max value.          **Purpose:**         This endpoint helps Game Masters understand skill balance by visualizing how damage/healing         scales with stat investment. It generates three curves (minimum/median/maximum) showing         impact values across a stat range.          **Curves:**         - **Minimum Curve**: Primary stat varies, other stats at minimum baseline (default: 10)         - **Median Curve**: Primary stat varies, other stats at median baseline (default: 50)         - **Maximum Curve**: Primary stat varies, other stats at maximum baseline (default: 100)          **Use Cases:**         - Compare scaling rates between different skills         - Identify overpowered or underpowered skills         - Understand how stat distribution affects skill effectiveness         - Balance skill requirements and scaling factors          **Example:**         Analyzing \"Fireball\" skill with Flow Manipulation as primary stat from 0-150 in steps of 5         shows how damage scales when the character has low/medium/high values in other stats         (Flow Resonance, Concentration, etc.).          **Where the numbers come from:**         Every point is resolved through `SkillWorkbenchService`, the same spine the         workbench\'s own scaling sweep uses, so this page and that one cannot         disagree. The request and response shapes are unchanged.         
         * @summary Analyze Skill Impact Progression
         * @param {AnalyzeProgressionRequestRequest} analyzeProgressionRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorAnalyzeProgressionCreate(analyzeProgressionRequestRequest: AnalyzeProgressionRequestRequest, options?: any): AxiosPromise<AnalyzeProgressionResponse> {
            return localVarFp.gamemasterSkillCalculatorAnalyzeProgressionCreate(analyzeProgressionRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *          Simulates skill impact calculations using provided stat values without requiring         a character instance. This is a pure calculation endpoint for skill balancing and testing.          **Features:**         - Accepts custom stat values for any CharacterStats         - Calculates impacts using the same formula as actual gameplay         - Returns detailed efficiency breakdown for each stat         - Provides warnings about missing requirements         - No database writes - pure calculation          **Formula:**         The impact calculation uses a logarithmic efficiency formula:         - `efficiency = 1 + (log10(1 + ratio) / log10(2) - 1) * (1 + scaling_factor)`         - `ratio = character_stat / required_stat`         - `final_impact = base_value * min(all_efficiencies)`          **Use Cases:**         - Testing new skill designs before implementation         - Balancing skill formulas and requirements         - Understanding how stat scaling affects impact values         - Identifying optimal stat builds for specific skills         
         * @summary Calculate Skill Impacts with Custom Stats
         * @param {CalculateImpactRequestRequest} calculateImpactRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorCalculateImpactCreate(calculateImpactRequestRequest: CalculateImpactRequestRequest, options?: any): AxiosPromise<CalculateImpactResponse> {
            return localVarFp.gamemasterSkillCalculatorCalculateImpactCreate(calculateImpactRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  Resolves every skill in `skill_ids` against **one** subject and returns a row each: the dx-skill-power composite to sort on, then the named figures to judge by — per hit, per cell, per area, area multiple, cost efficiency, the luck band — and the rounds it takes to deliver a fixed pool of health.  The subject is the same shape every other endpoint here takes, and it is resolved once for the whole table. A table whose rows were measured against different casters compares nothing, which is the entire reason this is one request rather than N.  A row carrying more than one impact kind is flagged `mixed_kinds`: its magnitudes are a sum across kinds that are not interchangeable, and sorting it against a single-kind skill is a comparison the reader has to make knowingly.  Every magnitude comes from `SkillWorkbenchService` driving `SkillImpactService` — the class a real cast uses. The rounds column is the deterministic reading of the round simulator with the sampler off.         
         * @summary Several skills side by side against one body
         * @param {CompareRequestRequest} compareRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorCompareCreate(compareRequestRequest: CompareRequestRequest, options?: any): AxiosPromise<CompareResponse> {
            return localVarFp.gamemasterSkillCalculatorCompareCreate(compareRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  Every dial the composite turns, with the reasoning behind each and the formula they sit in. Published so a ranking number can be reproduced from a skill row and a calculator rather than taken on trust — the same reason the archetype rating model publishes its own.  The composite is **additional** to the named power figures. `power_per_cell`, `area_multiple`, `power_per_area`, `luck_min/avg/max` and `cost_efficiency` are unchanged and keep their meaning, because the archetype balance tables and the NPC ability selector read them.         
         * @summary The dx-skill-power model\'s coefficients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorPowerModelRetrieve(options?: any): AxiosPromise<PowerModel> {
            return localVarFp.gamemasterSkillCalculatorPowerModelRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         *  Raises one attribute in steps and resolves the whole skill at each value, so a tuner can see where a formula\'s efficiency term flattens rather than reading a single point and guessing.  Every step is resolved through the same workbench spine as every other figure on the page. That is the entire reason this exists as an endpoint rather than as a client-side curve: the old progression page computed its own, from a second copy of the formula that had drifted from the engine by as much as twelvefold.  `stats` defaults to the attributes the skill\'s own formulas require or scale on — the rest would be flat lines.         
         * @summary Sweep an attribute and read the skill at every step
         * @param {ScalingRequestRequest} scalingRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorScalingCreate(scalingRequestRequest: ScalingRequestRequest, options?: any): AxiosPromise<ScalingResponse> {
            return localVarFp.gamemasterSkillCalculatorScalingCreate(scalingRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  There is no cooldown in this game, so a skill\'s cost is its whole repeat-use limiter and \"what does this cost over a hundred rounds\" *is* the balance question.  Each round the caster either **fires** — the costs are affordable, possibly several times over, since a turn\'s action points refill every round and nothing meters what they are spent on — or **accumulates**, giving the round to refilling the energy reservoir the way the Flow Accumulation skill does. Energy is not restored by the clock and health is not restored at all; both facts are the engine\'s, not a model invented here.  Two readings come back. The **deterministic** one fixes the luck multiplier at its mean, so the same inputs always give the same curve and a tuning change is readable as a change. The **Monte Carlo band** rolls the real luck faces under a fixed seed and reports where the spread falls; send `monte_carlo_runs: 0` to skip it.  Every magnitude is resolved once through the workbench, which drives `SkillImpactService` — the class a real cast uses. Nothing here re-prices a skill.         
         * @summary Model a hundred rounds of one skill in one pair of hands
         * @param {SimulateRoundsRequestRequest} simulateRoundsRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorSimulateRoundsCreate(simulateRoundsRequestRequest: SimulateRoundsRequestRequest, options?: any): AxiosPromise<SimulateRoundsResponse> {
            return localVarFp.gamemasterSkillCalculatorSimulateRoundsCreate(simulateRoundsRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  Writes the tuned fields back to the skill row. Only the fields sent are changed.  The payload is validated the way the model validates it — `full_clean` holds `impact`, `cost` and `effect` to their data-object contracts — so a malformed formula is refused here rather than stored and raised years later halfway through resolving somebody\'s attack.         
         * @summary Save a tuned skill
         * @param {TuneSkillRequestRequest} tuneSkillRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorTuneSkillCreate(tuneSkillRequestRequest: TuneSkillRequestRequest, options?: any): AxiosPromise<WorkbenchSkillFields> {
            return localVarFp.gamemasterSkillCalculatorTuneSkillCreate(tuneSkillRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  Resolves one stored skill against one stat line and reports **every stage the engine applies**, in order: the formula\'s per-stat efficiency terms and which one capped the result, the engine\'s rounding, the full luck band, ward absorption, and the value that finally lands.  It also reports what `calculate-impact` cannot: resource costs against the caster\'s real pools, how many times this body can actually fire the skill and which resource stops it, effect durations and per-cycle impact over a whole duration, the spray pattern\'s cells with a per-cell and board-wide total, and the skill\'s power rating.  The cast counts under `costs.cadence` are the subject\'s own, and separate from the composite\'s `uses_per_turn`, which stays pinned to the reference turn so that two skills remain comparable. `casts_per_turn` divides a turn that refills every round; `reserve_casts` divides energy and health, which no clock restores, and is therefore a whole-fight ceiling rather than a rate.  Send `overrides` to resolve a *modified* skill without saving it — that is what makes this a tuning instrument. Use `tune-skill` to persist.  Send `subject` instead of `caster` to resolve against a **real body**: one of the six etalons, or a character in a campaign you hold. A character\'s health, energy and turn then come from `CharacterService` itself rather than from a re-derivation of its formulas. A character in a campaign you do not hold is refused. The raw `caster` form is unchanged and still supported.  The magnitude is produced by `SkillImpactService`, the same class a real cast uses, so a number here is a number in a fight. A disagreement between the reported breakdown and that class is returned as a warning rather than hidden.         
         * @summary Resolve a skill through the whole impact chain
         * @param {WorkbenchRequestRequest} workbenchRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillCalculatorWorkbenchCreate(workbenchRequestRequest: WorkbenchRequestRequest, options?: any): AxiosPromise<WorkbenchResponse> {
            return localVarFp.gamemasterSkillCalculatorWorkbenchCreate(workbenchRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  The six etalons, then the characters in campaigns you hold. `default_subject_id` names the Path of John etalon, which is what a workbench opens on.  The etalons live in an inactive campaign of their own and are visible to every game master — they are the fixed yardstick. Characters are not: a campaign you do not hold contributes nobody.         
         * @summary Every body this game master may tune against
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectList(options?: any): AxiosPromise<Array<SubjectRoster>> {
            return localVarFp.gamemasterSkillSubjectList(options).then((request) => request(axios, basePath));
        },
        /**
         *  Rebuilds the etalon from the roster definition — stats, rank, path, schools and base skills — through the same service `manage.py create_etalon_characters` drives, so \"pristine\" means exactly what a fresh build produces rather than an approximation of it. The old row is deleted; anything hand-added to it is gone.  Only an etalon may be reset. A real character has no pristine state to return to.         
         * @summary Restore an etalon to its pristine spec
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectResetCreate(id: string, options?: any): AxiosPromise<SubjectDetail> {
            return localVarFp.gamemasterSkillSubjectResetCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Pick, inspect and configure the subject a skill is tuned against.
         * @summary One subject, with its schools and skills
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectRetrieve(id: string, options?: any): AxiosPromise<SubjectDetail> {
            return localVarFp.gamemasterSkillSubjectRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         *  `POST` teaches the school, `DELETE` unteaches it. Both go through `CharacterSchoolService`, so the slot count and the Path restriction apply exactly as they do to a player\'s character — a subject holding a school no player could hold would measure a skill nobody can cast.         
         * @summary Add or remove one of the subject\'s schools
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {SubjectSchoolMutationRequest} subjectSchoolMutationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectSchoolsCreate(id: string, subjectSchoolMutationRequest: SubjectSchoolMutationRequest, options?: any): AxiosPromise<SubjectDetail> {
            return localVarFp.gamemasterSkillSubjectSchoolsCreate(id, subjectSchoolMutationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  `POST` teaches the school, `DELETE` unteaches it. Both go through `CharacterSchoolService`, so the slot count and the Path restriction apply exactly as they do to a player\'s character — a subject holding a school no player could hold would measure a skill nobody can cast.         
         * @summary Add or remove one of the subject\'s schools
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectSchoolsDestroy(id: string, options?: any): AxiosPromise<SubjectDetail> {
            return localVarFp.gamemasterSkillSubjectSchoolsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         *  `POST` teaches the skill, `DELETE` unteaches it, both through `CharacterSkillsService`.  Note the recorded open question about grade direction: the skill service refuses a skill *stronger* than the rank, the school service teaches everything *weaker* than it. Where the two disagree about the skill being added, this endpoint returns a warning and does not silently pick a side.         
         * @summary Add or remove one of the subject\'s skills
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {SubjectSkillMutationRequest} subjectSkillMutationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectSkillsCreate(id: string, subjectSkillMutationRequest: SubjectSkillMutationRequest, options?: any): AxiosPromise<SubjectDetail> {
            return localVarFp.gamemasterSkillSubjectSkillsCreate(id, subjectSkillMutationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  `POST` teaches the skill, `DELETE` unteaches it, both through `CharacterSkillsService`.  Note the recorded open question about grade direction: the skill service refuses a skill *stronger* than the rank, the school service teaches everything *weaker* than it. Where the two disagree about the skill being added, this endpoint returns a warning and does not silently pick a side.         
         * @summary Add or remove one of the subject\'s skills
         * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillSubjectSkillsDestroy(id: string, options?: any): AxiosPromise<SubjectDetail> {
            return localVarFp.gamemasterSkillSubjectSkillsDestroy(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GameMasterSkillCalculatorApi - object-oriented interface
 * @export
 * @class GameMasterSkillCalculatorApi
 * @extends {BaseAPI}
 */
export class GameMasterSkillCalculatorApi extends BaseAPI {
    /**
     *          Analyzes how a skill\'s impacts scale as a primary stat increases from min to max value.          **Purpose:**         This endpoint helps Game Masters understand skill balance by visualizing how damage/healing         scales with stat investment. It generates three curves (minimum/median/maximum) showing         impact values across a stat range.          **Curves:**         - **Minimum Curve**: Primary stat varies, other stats at minimum baseline (default: 10)         - **Median Curve**: Primary stat varies, other stats at median baseline (default: 50)         - **Maximum Curve**: Primary stat varies, other stats at maximum baseline (default: 100)          **Use Cases:**         - Compare scaling rates between different skills         - Identify overpowered or underpowered skills         - Understand how stat distribution affects skill effectiveness         - Balance skill requirements and scaling factors          **Example:**         Analyzing \"Fireball\" skill with Flow Manipulation as primary stat from 0-150 in steps of 5         shows how damage scales when the character has low/medium/high values in other stats         (Flow Resonance, Concentration, etc.).          **Where the numbers come from:**         Every point is resolved through `SkillWorkbenchService`, the same spine the         workbench\'s own scaling sweep uses, so this page and that one cannot         disagree. The request and response shapes are unchanged.         
     * @summary Analyze Skill Impact Progression
     * @param {AnalyzeProgressionRequestRequest} analyzeProgressionRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillCalculatorAnalyzeProgressionCreate(analyzeProgressionRequestRequest: AnalyzeProgressionRequestRequest, options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillCalculatorAnalyzeProgressionCreate(analyzeProgressionRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *          Simulates skill impact calculations using provided stat values without requiring         a character instance. This is a pure calculation endpoint for skill balancing and testing.          **Features:**         - Accepts custom stat values for any CharacterStats         - Calculates impacts using the same formula as actual gameplay         - Returns detailed efficiency breakdown for each stat         - Provides warnings about missing requirements         - No database writes - pure calculation          **Formula:**         The impact calculation uses a logarithmic efficiency formula:         - `efficiency = 1 + (log10(1 + ratio) / log10(2) - 1) * (1 + scaling_factor)`         - `ratio = character_stat / required_stat`         - `final_impact = base_value * min(all_efficiencies)`          **Use Cases:**         - Testing new skill designs before implementation         - Balancing skill formulas and requirements         - Understanding how stat scaling affects impact values         - Identifying optimal stat builds for specific skills         
     * @summary Calculate Skill Impacts with Custom Stats
     * @param {CalculateImpactRequestRequest} calculateImpactRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillCalculatorCalculateImpactCreate(calculateImpactRequestRequest: CalculateImpactRequestRequest, options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillCalculatorCalculateImpactCreate(calculateImpactRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  Resolves every skill in `skill_ids` against **one** subject and returns a row each: the dx-skill-power composite to sort on, then the named figures to judge by — per hit, per cell, per area, area multiple, cost efficiency, the luck band — and the rounds it takes to deliver a fixed pool of health.  The subject is the same shape every other endpoint here takes, and it is resolved once for the whole table. A table whose rows were measured against different casters compares nothing, which is the entire reason this is one request rather than N.  A row carrying more than one impact kind is flagged `mixed_kinds`: its magnitudes are a sum across kinds that are not interchangeable, and sorting it against a single-kind skill is a comparison the reader has to make knowingly.  Every magnitude comes from `SkillWorkbenchService` driving `SkillImpactService` — the class a real cast uses. The rounds column is the deterministic reading of the round simulator with the sampler off.         
     * @summary Several skills side by side against one body
     * @param {CompareRequestRequest} compareRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillCalculatorCompareCreate(compareRequestRequest: CompareRequestRequest, options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillCalculatorCompareCreate(compareRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  Every dial the composite turns, with the reasoning behind each and the formula they sit in. Published so a ranking number can be reproduced from a skill row and a calculator rather than taken on trust — the same reason the archetype rating model publishes its own.  The composite is **additional** to the named power figures. `power_per_cell`, `area_multiple`, `power_per_area`, `luck_min/avg/max` and `cost_efficiency` are unchanged and keep their meaning, because the archetype balance tables and the NPC ability selector read them.         
     * @summary The dx-skill-power model\'s coefficients
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillCalculatorPowerModelRetrieve(options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillCalculatorPowerModelRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  Raises one attribute in steps and resolves the whole skill at each value, so a tuner can see where a formula\'s efficiency term flattens rather than reading a single point and guessing.  Every step is resolved through the same workbench spine as every other figure on the page. That is the entire reason this exists as an endpoint rather than as a client-side curve: the old progression page computed its own, from a second copy of the formula that had drifted from the engine by as much as twelvefold.  `stats` defaults to the attributes the skill\'s own formulas require or scale on — the rest would be flat lines.         
     * @summary Sweep an attribute and read the skill at every step
     * @param {ScalingRequestRequest} scalingRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillCalculatorScalingCreate(scalingRequestRequest: ScalingRequestRequest, options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillCalculatorScalingCreate(scalingRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  There is no cooldown in this game, so a skill\'s cost is its whole repeat-use limiter and \"what does this cost over a hundred rounds\" *is* the balance question.  Each round the caster either **fires** — the costs are affordable, possibly several times over, since a turn\'s action points refill every round and nothing meters what they are spent on — or **accumulates**, giving the round to refilling the energy reservoir the way the Flow Accumulation skill does. Energy is not restored by the clock and health is not restored at all; both facts are the engine\'s, not a model invented here.  Two readings come back. The **deterministic** one fixes the luck multiplier at its mean, so the same inputs always give the same curve and a tuning change is readable as a change. The **Monte Carlo band** rolls the real luck faces under a fixed seed and reports where the spread falls; send `monte_carlo_runs: 0` to skip it.  Every magnitude is resolved once through the workbench, which drives `SkillImpactService` — the class a real cast uses. Nothing here re-prices a skill.         
     * @summary Model a hundred rounds of one skill in one pair of hands
     * @param {SimulateRoundsRequestRequest} simulateRoundsRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillCalculatorSimulateRoundsCreate(simulateRoundsRequestRequest: SimulateRoundsRequestRequest, options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillCalculatorSimulateRoundsCreate(simulateRoundsRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  Writes the tuned fields back to the skill row. Only the fields sent are changed.  The payload is validated the way the model validates it — `full_clean` holds `impact`, `cost` and `effect` to their data-object contracts — so a malformed formula is refused here rather than stored and raised years later halfway through resolving somebody\'s attack.         
     * @summary Save a tuned skill
     * @param {TuneSkillRequestRequest} tuneSkillRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillCalculatorTuneSkillCreate(tuneSkillRequestRequest: TuneSkillRequestRequest, options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillCalculatorTuneSkillCreate(tuneSkillRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  Resolves one stored skill against one stat line and reports **every stage the engine applies**, in order: the formula\'s per-stat efficiency terms and which one capped the result, the engine\'s rounding, the full luck band, ward absorption, and the value that finally lands.  It also reports what `calculate-impact` cannot: resource costs against the caster\'s real pools, how many times this body can actually fire the skill and which resource stops it, effect durations and per-cycle impact over a whole duration, the spray pattern\'s cells with a per-cell and board-wide total, and the skill\'s power rating.  The cast counts under `costs.cadence` are the subject\'s own, and separate from the composite\'s `uses_per_turn`, which stays pinned to the reference turn so that two skills remain comparable. `casts_per_turn` divides a turn that refills every round; `reserve_casts` divides energy and health, which no clock restores, and is therefore a whole-fight ceiling rather than a rate.  Send `overrides` to resolve a *modified* skill without saving it — that is what makes this a tuning instrument. Use `tune-skill` to persist.  Send `subject` instead of `caster` to resolve against a **real body**: one of the six etalons, or a character in a campaign you hold. A character\'s health, energy and turn then come from `CharacterService` itself rather than from a re-derivation of its formulas. A character in a campaign you do not hold is refused. The raw `caster` form is unchanged and still supported.  The magnitude is produced by `SkillImpactService`, the same class a real cast uses, so a number here is a number in a fight. A disagreement between the reported breakdown and that class is returned as a warning rather than hidden.         
     * @summary Resolve a skill through the whole impact chain
     * @param {WorkbenchRequestRequest} workbenchRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillCalculatorWorkbenchCreate(workbenchRequestRequest: WorkbenchRequestRequest, options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillCalculatorWorkbenchCreate(workbenchRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  The six etalons, then the characters in campaigns you hold. `default_subject_id` names the Path of John etalon, which is what a workbench opens on.  The etalons live in an inactive campaign of their own and are visible to every game master — they are the fixed yardstick. Characters are not: a campaign you do not hold contributes nobody.         
     * @summary Every body this game master may tune against
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillSubjectList(options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillSubjectList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  Rebuilds the etalon from the roster definition — stats, rank, path, schools and base skills — through the same service `manage.py create_etalon_characters` drives, so \"pristine\" means exactly what a fresh build produces rather than an approximation of it. The old row is deleted; anything hand-added to it is gone.  Only an etalon may be reset. A real character has no pristine state to return to.         
     * @summary Restore an etalon to its pristine spec
     * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillSubjectResetCreate(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillSubjectResetCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pick, inspect and configure the subject a skill is tuned against.
     * @summary One subject, with its schools and skills
     * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillSubjectRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillSubjectRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  `POST` teaches the school, `DELETE` unteaches it. Both go through `CharacterSchoolService`, so the slot count and the Path restriction apply exactly as they do to a player\'s character — a subject holding a school no player could hold would measure a skill nobody can cast.         
     * @summary Add or remove one of the subject\'s schools
     * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
     * @param {SubjectSchoolMutationRequest} subjectSchoolMutationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillSubjectSchoolsCreate(id: string, subjectSchoolMutationRequest: SubjectSchoolMutationRequest, options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillSubjectSchoolsCreate(id, subjectSchoolMutationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  `POST` teaches the school, `DELETE` unteaches it. Both go through `CharacterSchoolService`, so the slot count and the Path restriction apply exactly as they do to a player\'s character — a subject holding a school no player could hold would measure a skill nobody can cast.         
     * @summary Add or remove one of the subject\'s schools
     * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillSubjectSchoolsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillSubjectSchoolsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  `POST` teaches the skill, `DELETE` unteaches it, both through `CharacterSkillsService`.  Note the recorded open question about grade direction: the skill service refuses a skill *stronger* than the rank, the school service teaches everything *weaker* than it. Where the two disagree about the skill being added, this endpoint returns a warning and does not silently pick a side.         
     * @summary Add or remove one of the subject\'s skills
     * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
     * @param {SubjectSkillMutationRequest} subjectSkillMutationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillSubjectSkillsCreate(id: string, subjectSkillMutationRequest: SubjectSkillMutationRequest, options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillSubjectSkillsCreate(id, subjectSkillMutationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  `POST` teaches the skill, `DELETE` unteaches it, both through `CharacterSkillsService`.  Note the recorded open question about grade direction: the skill service refuses a skill *stronger* than the rank, the school service teaches everything *weaker* than it. Where the two disagree about the skill being added, this endpoint returns a warning and does not silently pick a side.         
     * @summary Add or remove one of the subject\'s skills
     * @param {string} id The subject\&#39;s character id, or an etalon\&#39;s name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterSkillCalculatorApi
     */
    public gamemasterSkillSubjectSkillsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterSkillCalculatorApiFp(this.configuration).gamemasterSkillSubjectSkillsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GameMasterWorldHierarchyApi - axios parameter creator
 * @export
 */
export const GameMasterWorldHierarchyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldAreaRequest} gameMasterWorldAreaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldAreasCreate: async (gameMasterWorldAreaRequest: GameMasterWorldAreaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameMasterWorldAreaRequest' is not null or undefined
            assertParamExists('gamemasterWorldAreasCreate', 'gameMasterWorldAreaRequest', gameMasterWorldAreaRequest)
            const localVarPath = `/api/gamemaster/world-areas/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterWorldAreaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldAreasList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-areas/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this area.
         * @param {PatchedGameMasterWorldAreaRequest} [patchedGameMasterWorldAreaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldAreasPartialUpdate: async (id: string, patchedGameMasterWorldAreaRequest?: PatchedGameMasterWorldAreaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldAreasPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/world-areas/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGameMasterWorldAreaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldAreasRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldAreasRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/world-areas/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this area.
         * @param {GameMasterWorldAreaRequest} gameMasterWorldAreaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldAreasUpdate: async (id: string, gameMasterWorldAreaRequest: GameMasterWorldAreaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldAreasUpdate', 'id', id)
            // verify required parameter 'gameMasterWorldAreaRequest' is not null or undefined
            assertParamExists('gamemasterWorldAreasUpdate', 'gameMasterWorldAreaRequest', gameMasterWorldAreaRequest)
            const localVarPath = `/api/gamemaster/world-areas/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterWorldAreaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldCityRequest} gameMasterWorldCityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCitiesCreate: async (gameMasterWorldCityRequest: GameMasterWorldCityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameMasterWorldCityRequest' is not null or undefined
            assertParamExists('gamemasterWorldCitiesCreate', 'gameMasterWorldCityRequest', gameMasterWorldCityRequest)
            const localVarPath = `/api/gamemaster/world-cities/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterWorldCityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCitiesList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-cities/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this city.
         * @param {PatchedGameMasterWorldCityRequest} [patchedGameMasterWorldCityRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCitiesPartialUpdate: async (id: string, patchedGameMasterWorldCityRequest?: PatchedGameMasterWorldCityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldCitiesPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/world-cities/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGameMasterWorldCityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this city.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCitiesRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldCitiesRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/world-cities/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this city.
         * @param {GameMasterWorldCityRequest} gameMasterWorldCityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCitiesUpdate: async (id: string, gameMasterWorldCityRequest: GameMasterWorldCityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldCitiesUpdate', 'id', id)
            // verify required parameter 'gameMasterWorldCityRequest' is not null or undefined
            assertParamExists('gamemasterWorldCitiesUpdate', 'gameMasterWorldCityRequest', gameMasterWorldCityRequest)
            const localVarPath = `/api/gamemaster/world-cities/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterWorldCityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldContinentRequest} gameMasterWorldContinentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldContinentsCreate: async (gameMasterWorldContinentRequest: GameMasterWorldContinentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameMasterWorldContinentRequest' is not null or undefined
            assertParamExists('gamemasterWorldContinentsCreate', 'gameMasterWorldContinentRequest', gameMasterWorldContinentRequest)
            const localVarPath = `/api/gamemaster/world-continents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterWorldContinentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldContinentsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-continents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this continent.
         * @param {PatchedGameMasterWorldContinentRequest} [patchedGameMasterWorldContinentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldContinentsPartialUpdate: async (id: string, patchedGameMasterWorldContinentRequest?: PatchedGameMasterWorldContinentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldContinentsPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/world-continents/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGameMasterWorldContinentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this continent.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldContinentsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldContinentsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/world-continents/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this continent.
         * @param {GameMasterWorldContinentRequest} gameMasterWorldContinentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldContinentsUpdate: async (id: string, gameMasterWorldContinentRequest: GameMasterWorldContinentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldContinentsUpdate', 'id', id)
            // verify required parameter 'gameMasterWorldContinentRequest' is not null or undefined
            assertParamExists('gamemasterWorldContinentsUpdate', 'gameMasterWorldContinentRequest', gameMasterWorldContinentRequest)
            const localVarPath = `/api/gamemaster/world-continents/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterWorldContinentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldCountryRequest} gameMasterWorldCountryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCountriesCreate: async (gameMasterWorldCountryRequest: GameMasterWorldCountryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameMasterWorldCountryRequest' is not null or undefined
            assertParamExists('gamemasterWorldCountriesCreate', 'gameMasterWorldCountryRequest', gameMasterWorldCountryRequest)
            const localVarPath = `/api/gamemaster/world-countries/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterWorldCountryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCountriesList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-countries/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this country.
         * @param {PatchedGameMasterWorldCountryRequest} [patchedGameMasterWorldCountryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCountriesPartialUpdate: async (id: string, patchedGameMasterWorldCountryRequest?: PatchedGameMasterWorldCountryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldCountriesPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/world-countries/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGameMasterWorldCountryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this country.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCountriesRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldCountriesRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/world-countries/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this country.
         * @param {GameMasterWorldCountryRequest} gameMasterWorldCountryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCountriesUpdate: async (id: string, gameMasterWorldCountryRequest: GameMasterWorldCountryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldCountriesUpdate', 'id', id)
            // verify required parameter 'gameMasterWorldCountryRequest' is not null or undefined
            assertParamExists('gamemasterWorldCountriesUpdate', 'gameMasterWorldCountryRequest', gameMasterWorldCountryRequest)
            const localVarPath = `/api/gamemaster/world-countries/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterWorldCountryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read-only: `Dimension` is fixture-owned with an integer PK.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldDimensionsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-dimensions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read-only: `Dimension` is fixture-owned with an integer PK.
         * @param {number} id A unique value identifying this dimension.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldDimensionsRetrieve: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldDimensionsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/world-dimensions/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldLocationRequest} gameMasterWorldLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldLocationsCreate: async (gameMasterWorldLocationRequest: GameMasterWorldLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameMasterWorldLocationRequest' is not null or undefined
            assertParamExists('gamemasterWorldLocationsCreate', 'gameMasterWorldLocationRequest', gameMasterWorldLocationRequest)
            const localVarPath = `/api/gamemaster/world-locations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterWorldLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldLocationsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-locations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this location.
         * @param {PatchedGameMasterWorldLocationRequest} [patchedGameMasterWorldLocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldLocationsPartialUpdate: async (id: string, patchedGameMasterWorldLocationRequest?: PatchedGameMasterWorldLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldLocationsPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/world-locations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGameMasterWorldLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldLocationsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldLocationsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/world-locations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this location.
         * @param {GameMasterWorldLocationRequest} gameMasterWorldLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldLocationsUpdate: async (id: string, gameMasterWorldLocationRequest: GameMasterWorldLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldLocationsUpdate', 'id', id)
            // verify required parameter 'gameMasterWorldLocationRequest' is not null or undefined
            assertParamExists('gamemasterWorldLocationsUpdate', 'gameMasterWorldLocationRequest', gameMasterWorldLocationRequest)
            const localVarPath = `/api/gamemaster/world-locations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterWorldLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldPlanetRequest} gameMasterWorldPlanetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPlanetsCreate: async (gameMasterWorldPlanetRequest: GameMasterWorldPlanetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameMasterWorldPlanetRequest' is not null or undefined
            assertParamExists('gamemasterWorldPlanetsCreate', 'gameMasterWorldPlanetRequest', gameMasterWorldPlanetRequest)
            const localVarPath = `/api/gamemaster/world-planets/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterWorldPlanetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPlanetsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-planets/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this planet.
         * @param {PatchedGameMasterWorldPlanetRequest} [patchedGameMasterWorldPlanetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPlanetsPartialUpdate: async (id: string, patchedGameMasterWorldPlanetRequest?: PatchedGameMasterWorldPlanetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPlanetsPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/world-planets/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGameMasterWorldPlanetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this planet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPlanetsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPlanetsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/world-planets/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this planet.
         * @param {GameMasterWorldPlanetRequest} gameMasterWorldPlanetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPlanetsUpdate: async (id: string, gameMasterWorldPlanetRequest: GameMasterWorldPlanetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldPlanetsUpdate', 'id', id)
            // verify required parameter 'gameMasterWorldPlanetRequest' is not null or undefined
            assertParamExists('gamemasterWorldPlanetsUpdate', 'gameMasterWorldPlanetRequest', gameMasterWorldPlanetRequest)
            const localVarPath = `/api/gamemaster/world-planets/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterWorldPlanetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GameMasterWorldHierarchyApi - functional programming interface
 * @export
 */
export const GameMasterWorldHierarchyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GameMasterWorldHierarchyApiAxiosParamCreator(configuration)
    return {
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldAreaRequest} gameMasterWorldAreaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldAreasCreate(gameMasterWorldAreaRequest: GameMasterWorldAreaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldArea>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldAreasCreate(gameMasterWorldAreaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldAreasCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldAreasList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterWorldArea>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldAreasList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldAreasList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this area.
         * @param {PatchedGameMasterWorldAreaRequest} [patchedGameMasterWorldAreaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldAreasPartialUpdate(id: string, patchedGameMasterWorldAreaRequest?: PatchedGameMasterWorldAreaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldArea>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldAreasPartialUpdate(id, patchedGameMasterWorldAreaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldAreasPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldAreasRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldArea>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldAreasRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldAreasRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this area.
         * @param {GameMasterWorldAreaRequest} gameMasterWorldAreaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldAreasUpdate(id: string, gameMasterWorldAreaRequest: GameMasterWorldAreaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldArea>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldAreasUpdate(id, gameMasterWorldAreaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldAreasUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldCityRequest} gameMasterWorldCityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldCitiesCreate(gameMasterWorldCityRequest: GameMasterWorldCityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldCity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldCitiesCreate(gameMasterWorldCityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldCitiesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldCitiesList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterWorldCity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldCitiesList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldCitiesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this city.
         * @param {PatchedGameMasterWorldCityRequest} [patchedGameMasterWorldCityRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldCitiesPartialUpdate(id: string, patchedGameMasterWorldCityRequest?: PatchedGameMasterWorldCityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldCity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldCitiesPartialUpdate(id, patchedGameMasterWorldCityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldCitiesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this city.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldCitiesRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldCity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldCitiesRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldCitiesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this city.
         * @param {GameMasterWorldCityRequest} gameMasterWorldCityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldCitiesUpdate(id: string, gameMasterWorldCityRequest: GameMasterWorldCityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldCity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldCitiesUpdate(id, gameMasterWorldCityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldCitiesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldContinentRequest} gameMasterWorldContinentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldContinentsCreate(gameMasterWorldContinentRequest: GameMasterWorldContinentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldContinent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldContinentsCreate(gameMasterWorldContinentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldContinentsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldContinentsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterWorldContinent>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldContinentsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldContinentsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this continent.
         * @param {PatchedGameMasterWorldContinentRequest} [patchedGameMasterWorldContinentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldContinentsPartialUpdate(id: string, patchedGameMasterWorldContinentRequest?: PatchedGameMasterWorldContinentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldContinent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldContinentsPartialUpdate(id, patchedGameMasterWorldContinentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldContinentsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this continent.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldContinentsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldContinent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldContinentsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldContinentsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this continent.
         * @param {GameMasterWorldContinentRequest} gameMasterWorldContinentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldContinentsUpdate(id: string, gameMasterWorldContinentRequest: GameMasterWorldContinentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldContinent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldContinentsUpdate(id, gameMasterWorldContinentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldContinentsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldCountryRequest} gameMasterWorldCountryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldCountriesCreate(gameMasterWorldCountryRequest: GameMasterWorldCountryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldCountry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldCountriesCreate(gameMasterWorldCountryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldCountriesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldCountriesList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterWorldCountry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldCountriesList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldCountriesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this country.
         * @param {PatchedGameMasterWorldCountryRequest} [patchedGameMasterWorldCountryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldCountriesPartialUpdate(id: string, patchedGameMasterWorldCountryRequest?: PatchedGameMasterWorldCountryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldCountry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldCountriesPartialUpdate(id, patchedGameMasterWorldCountryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldCountriesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this country.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldCountriesRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldCountry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldCountriesRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldCountriesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this country.
         * @param {GameMasterWorldCountryRequest} gameMasterWorldCountryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldCountriesUpdate(id: string, gameMasterWorldCountryRequest: GameMasterWorldCountryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldCountry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldCountriesUpdate(id, gameMasterWorldCountryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldCountriesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read-only: `Dimension` is fixture-owned with an integer PK.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldDimensionsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterWorldDimension>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldDimensionsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldDimensionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read-only: `Dimension` is fixture-owned with an integer PK.
         * @param {number} id A unique value identifying this dimension.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldDimensionsRetrieve(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldDimension>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldDimensionsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldDimensionsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldLocationRequest} gameMasterWorldLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldLocationsCreate(gameMasterWorldLocationRequest: GameMasterWorldLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldLocationsCreate(gameMasterWorldLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldLocationsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldLocationsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterWorldLocation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldLocationsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldLocationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this location.
         * @param {PatchedGameMasterWorldLocationRequest} [patchedGameMasterWorldLocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldLocationsPartialUpdate(id: string, patchedGameMasterWorldLocationRequest?: PatchedGameMasterWorldLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldLocationsPartialUpdate(id, patchedGameMasterWorldLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldLocationsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldLocationsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldLocationsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldLocationsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this location.
         * @param {GameMasterWorldLocationRequest} gameMasterWorldLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldLocationsUpdate(id: string, gameMasterWorldLocationRequest: GameMasterWorldLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldLocationsUpdate(id, gameMasterWorldLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldLocationsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldPlanetRequest} gameMasterWorldPlanetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPlanetsCreate(gameMasterWorldPlanetRequest: GameMasterWorldPlanetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldPlanet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPlanetsCreate(gameMasterWorldPlanetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldPlanetsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPlanetsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterWorldPlanet>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPlanetsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldPlanetsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this planet.
         * @param {PatchedGameMasterWorldPlanetRequest} [patchedGameMasterWorldPlanetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPlanetsPartialUpdate(id: string, patchedGameMasterWorldPlanetRequest?: PatchedGameMasterWorldPlanetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldPlanet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPlanetsPartialUpdate(id, patchedGameMasterWorldPlanetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldPlanetsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this planet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPlanetsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldPlanet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPlanetsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldPlanetsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this planet.
         * @param {GameMasterWorldPlanetRequest} gameMasterWorldPlanetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldPlanetsUpdate(id: string, gameMasterWorldPlanetRequest: GameMasterWorldPlanetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterWorldPlanet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldPlanetsUpdate(id, gameMasterWorldPlanetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameMasterWorldHierarchyApi.gamemasterWorldPlanetsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GameMasterWorldHierarchyApi - factory interface
 * @export
 */
export const GameMasterWorldHierarchyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GameMasterWorldHierarchyApiFp(configuration)
    return {
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldAreaRequest} gameMasterWorldAreaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldAreasCreate(gameMasterWorldAreaRequest: GameMasterWorldAreaRequest, options?: any): AxiosPromise<GameMasterWorldArea> {
            return localVarFp.gamemasterWorldAreasCreate(gameMasterWorldAreaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldAreasList(options?: any): AxiosPromise<Array<GameMasterWorldArea>> {
            return localVarFp.gamemasterWorldAreasList(options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this area.
         * @param {PatchedGameMasterWorldAreaRequest} [patchedGameMasterWorldAreaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldAreasPartialUpdate(id: string, patchedGameMasterWorldAreaRequest?: PatchedGameMasterWorldAreaRequest, options?: any): AxiosPromise<GameMasterWorldArea> {
            return localVarFp.gamemasterWorldAreasPartialUpdate(id, patchedGameMasterWorldAreaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldAreasRetrieve(id: string, options?: any): AxiosPromise<GameMasterWorldArea> {
            return localVarFp.gamemasterWorldAreasRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this area.
         * @param {GameMasterWorldAreaRequest} gameMasterWorldAreaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldAreasUpdate(id: string, gameMasterWorldAreaRequest: GameMasterWorldAreaRequest, options?: any): AxiosPromise<GameMasterWorldArea> {
            return localVarFp.gamemasterWorldAreasUpdate(id, gameMasterWorldAreaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldCityRequest} gameMasterWorldCityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCitiesCreate(gameMasterWorldCityRequest: GameMasterWorldCityRequest, options?: any): AxiosPromise<GameMasterWorldCity> {
            return localVarFp.gamemasterWorldCitiesCreate(gameMasterWorldCityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCitiesList(options?: any): AxiosPromise<Array<GameMasterWorldCity>> {
            return localVarFp.gamemasterWorldCitiesList(options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this city.
         * @param {PatchedGameMasterWorldCityRequest} [patchedGameMasterWorldCityRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCitiesPartialUpdate(id: string, patchedGameMasterWorldCityRequest?: PatchedGameMasterWorldCityRequest, options?: any): AxiosPromise<GameMasterWorldCity> {
            return localVarFp.gamemasterWorldCitiesPartialUpdate(id, patchedGameMasterWorldCityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this city.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCitiesRetrieve(id: string, options?: any): AxiosPromise<GameMasterWorldCity> {
            return localVarFp.gamemasterWorldCitiesRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this city.
         * @param {GameMasterWorldCityRequest} gameMasterWorldCityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCitiesUpdate(id: string, gameMasterWorldCityRequest: GameMasterWorldCityRequest, options?: any): AxiosPromise<GameMasterWorldCity> {
            return localVarFp.gamemasterWorldCitiesUpdate(id, gameMasterWorldCityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldContinentRequest} gameMasterWorldContinentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldContinentsCreate(gameMasterWorldContinentRequest: GameMasterWorldContinentRequest, options?: any): AxiosPromise<GameMasterWorldContinent> {
            return localVarFp.gamemasterWorldContinentsCreate(gameMasterWorldContinentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldContinentsList(options?: any): AxiosPromise<Array<GameMasterWorldContinent>> {
            return localVarFp.gamemasterWorldContinentsList(options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this continent.
         * @param {PatchedGameMasterWorldContinentRequest} [patchedGameMasterWorldContinentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldContinentsPartialUpdate(id: string, patchedGameMasterWorldContinentRequest?: PatchedGameMasterWorldContinentRequest, options?: any): AxiosPromise<GameMasterWorldContinent> {
            return localVarFp.gamemasterWorldContinentsPartialUpdate(id, patchedGameMasterWorldContinentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this continent.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldContinentsRetrieve(id: string, options?: any): AxiosPromise<GameMasterWorldContinent> {
            return localVarFp.gamemasterWorldContinentsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this continent.
         * @param {GameMasterWorldContinentRequest} gameMasterWorldContinentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldContinentsUpdate(id: string, gameMasterWorldContinentRequest: GameMasterWorldContinentRequest, options?: any): AxiosPromise<GameMasterWorldContinent> {
            return localVarFp.gamemasterWorldContinentsUpdate(id, gameMasterWorldContinentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldCountryRequest} gameMasterWorldCountryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCountriesCreate(gameMasterWorldCountryRequest: GameMasterWorldCountryRequest, options?: any): AxiosPromise<GameMasterWorldCountry> {
            return localVarFp.gamemasterWorldCountriesCreate(gameMasterWorldCountryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCountriesList(options?: any): AxiosPromise<Array<GameMasterWorldCountry>> {
            return localVarFp.gamemasterWorldCountriesList(options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this country.
         * @param {PatchedGameMasterWorldCountryRequest} [patchedGameMasterWorldCountryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCountriesPartialUpdate(id: string, patchedGameMasterWorldCountryRequest?: PatchedGameMasterWorldCountryRequest, options?: any): AxiosPromise<GameMasterWorldCountry> {
            return localVarFp.gamemasterWorldCountriesPartialUpdate(id, patchedGameMasterWorldCountryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this country.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCountriesRetrieve(id: string, options?: any): AxiosPromise<GameMasterWorldCountry> {
            return localVarFp.gamemasterWorldCountriesRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this country.
         * @param {GameMasterWorldCountryRequest} gameMasterWorldCountryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldCountriesUpdate(id: string, gameMasterWorldCountryRequest: GameMasterWorldCountryRequest, options?: any): AxiosPromise<GameMasterWorldCountry> {
            return localVarFp.gamemasterWorldCountriesUpdate(id, gameMasterWorldCountryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Read-only: `Dimension` is fixture-owned with an integer PK.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldDimensionsList(options?: any): AxiosPromise<Array<GameMasterWorldDimension>> {
            return localVarFp.gamemasterWorldDimensionsList(options).then((request) => request(axios, basePath));
        },
        /**
         * Read-only: `Dimension` is fixture-owned with an integer PK.
         * @param {number} id A unique value identifying this dimension.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldDimensionsRetrieve(id: number, options?: any): AxiosPromise<GameMasterWorldDimension> {
            return localVarFp.gamemasterWorldDimensionsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldLocationRequest} gameMasterWorldLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldLocationsCreate(gameMasterWorldLocationRequest: GameMasterWorldLocationRequest, options?: any): AxiosPromise<GameMasterWorldLocation> {
            return localVarFp.gamemasterWorldLocationsCreate(gameMasterWorldLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldLocationsList(options?: any): AxiosPromise<Array<GameMasterWorldLocation>> {
            return localVarFp.gamemasterWorldLocationsList(options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this location.
         * @param {PatchedGameMasterWorldLocationRequest} [patchedGameMasterWorldLocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldLocationsPartialUpdate(id: string, patchedGameMasterWorldLocationRequest?: PatchedGameMasterWorldLocationRequest, options?: any): AxiosPromise<GameMasterWorldLocation> {
            return localVarFp.gamemasterWorldLocationsPartialUpdate(id, patchedGameMasterWorldLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldLocationsRetrieve(id: string, options?: any): AxiosPromise<GameMasterWorldLocation> {
            return localVarFp.gamemasterWorldLocationsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this location.
         * @param {GameMasterWorldLocationRequest} gameMasterWorldLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldLocationsUpdate(id: string, gameMasterWorldLocationRequest: GameMasterWorldLocationRequest, options?: any): AxiosPromise<GameMasterWorldLocation> {
            return localVarFp.gamemasterWorldLocationsUpdate(id, gameMasterWorldLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {GameMasterWorldPlanetRequest} gameMasterWorldPlanetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPlanetsCreate(gameMasterWorldPlanetRequest: GameMasterWorldPlanetRequest, options?: any): AxiosPromise<GameMasterWorldPlanet> {
            return localVarFp.gamemasterWorldPlanetsCreate(gameMasterWorldPlanetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPlanetsList(options?: any): AxiosPromise<Array<GameMasterWorldPlanet>> {
            return localVarFp.gamemasterWorldPlanetsList(options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this planet.
         * @param {PatchedGameMasterWorldPlanetRequest} [patchedGameMasterWorldPlanetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPlanetsPartialUpdate(id: string, patchedGameMasterWorldPlanetRequest?: PatchedGameMasterWorldPlanetRequest, options?: any): AxiosPromise<GameMasterWorldPlanet> {
            return localVarFp.gamemasterWorldPlanetsPartialUpdate(id, patchedGameMasterWorldPlanetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this planet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPlanetsRetrieve(id: string, options?: any): AxiosPromise<GameMasterWorldPlanet> {
            return localVarFp.gamemasterWorldPlanetsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
         * @param {string} id A UUID string identifying this planet.
         * @param {GameMasterWorldPlanetRequest} gameMasterWorldPlanetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldPlanetsUpdate(id: string, gameMasterWorldPlanetRequest: GameMasterWorldPlanetRequest, options?: any): AxiosPromise<GameMasterWorldPlanet> {
            return localVarFp.gamemasterWorldPlanetsUpdate(id, gameMasterWorldPlanetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GameMasterWorldHierarchyApi - object-oriented interface
 * @export
 * @class GameMasterWorldHierarchyApi
 * @extends {BaseAPI}
 */
export class GameMasterWorldHierarchyApi extends BaseAPI {
    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {GameMasterWorldAreaRequest} gameMasterWorldAreaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldAreasCreate(gameMasterWorldAreaRequest: GameMasterWorldAreaRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldAreasCreate(gameMasterWorldAreaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldAreasList(options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldAreasList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this area.
     * @param {PatchedGameMasterWorldAreaRequest} [patchedGameMasterWorldAreaRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldAreasPartialUpdate(id: string, patchedGameMasterWorldAreaRequest?: PatchedGameMasterWorldAreaRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldAreasPartialUpdate(id, patchedGameMasterWorldAreaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this area.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldAreasRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldAreasRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this area.
     * @param {GameMasterWorldAreaRequest} gameMasterWorldAreaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldAreasUpdate(id: string, gameMasterWorldAreaRequest: GameMasterWorldAreaRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldAreasUpdate(id, gameMasterWorldAreaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {GameMasterWorldCityRequest} gameMasterWorldCityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldCitiesCreate(gameMasterWorldCityRequest: GameMasterWorldCityRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldCitiesCreate(gameMasterWorldCityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldCitiesList(options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldCitiesList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this city.
     * @param {PatchedGameMasterWorldCityRequest} [patchedGameMasterWorldCityRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldCitiesPartialUpdate(id: string, patchedGameMasterWorldCityRequest?: PatchedGameMasterWorldCityRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldCitiesPartialUpdate(id, patchedGameMasterWorldCityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this city.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldCitiesRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldCitiesRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this city.
     * @param {GameMasterWorldCityRequest} gameMasterWorldCityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldCitiesUpdate(id: string, gameMasterWorldCityRequest: GameMasterWorldCityRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldCitiesUpdate(id, gameMasterWorldCityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {GameMasterWorldContinentRequest} gameMasterWorldContinentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldContinentsCreate(gameMasterWorldContinentRequest: GameMasterWorldContinentRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldContinentsCreate(gameMasterWorldContinentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldContinentsList(options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldContinentsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this continent.
     * @param {PatchedGameMasterWorldContinentRequest} [patchedGameMasterWorldContinentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldContinentsPartialUpdate(id: string, patchedGameMasterWorldContinentRequest?: PatchedGameMasterWorldContinentRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldContinentsPartialUpdate(id, patchedGameMasterWorldContinentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this continent.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldContinentsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldContinentsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this continent.
     * @param {GameMasterWorldContinentRequest} gameMasterWorldContinentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldContinentsUpdate(id: string, gameMasterWorldContinentRequest: GameMasterWorldContinentRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldContinentsUpdate(id, gameMasterWorldContinentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {GameMasterWorldCountryRequest} gameMasterWorldCountryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldCountriesCreate(gameMasterWorldCountryRequest: GameMasterWorldCountryRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldCountriesCreate(gameMasterWorldCountryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldCountriesList(options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldCountriesList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this country.
     * @param {PatchedGameMasterWorldCountryRequest} [patchedGameMasterWorldCountryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldCountriesPartialUpdate(id: string, patchedGameMasterWorldCountryRequest?: PatchedGameMasterWorldCountryRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldCountriesPartialUpdate(id, patchedGameMasterWorldCountryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this country.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldCountriesRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldCountriesRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this country.
     * @param {GameMasterWorldCountryRequest} gameMasterWorldCountryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldCountriesUpdate(id: string, gameMasterWorldCountryRequest: GameMasterWorldCountryRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldCountriesUpdate(id, gameMasterWorldCountryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read-only: `Dimension` is fixture-owned with an integer PK.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldDimensionsList(options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldDimensionsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read-only: `Dimension` is fixture-owned with an integer PK.
     * @param {number} id A unique value identifying this dimension.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldDimensionsRetrieve(id: number, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldDimensionsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {GameMasterWorldLocationRequest} gameMasterWorldLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldLocationsCreate(gameMasterWorldLocationRequest: GameMasterWorldLocationRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldLocationsCreate(gameMasterWorldLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldLocationsList(options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldLocationsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this location.
     * @param {PatchedGameMasterWorldLocationRequest} [patchedGameMasterWorldLocationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldLocationsPartialUpdate(id: string, patchedGameMasterWorldLocationRequest?: PatchedGameMasterWorldLocationRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldLocationsPartialUpdate(id, patchedGameMasterWorldLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this location.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldLocationsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldLocationsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this location.
     * @param {GameMasterWorldLocationRequest} gameMasterWorldLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldLocationsUpdate(id: string, gameMasterWorldLocationRequest: GameMasterWorldLocationRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldLocationsUpdate(id, gameMasterWorldLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {GameMasterWorldPlanetRequest} gameMasterWorldPlanetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldPlanetsCreate(gameMasterWorldPlanetRequest: GameMasterWorldPlanetRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldPlanetsCreate(gameMasterWorldPlanetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldPlanetsList(options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldPlanetsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this planet.
     * @param {PatchedGameMasterWorldPlanetRequest} [patchedGameMasterWorldPlanetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldPlanetsPartialUpdate(id: string, patchedGameMasterWorldPlanetRequest?: PatchedGameMasterWorldPlanetRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldPlanetsPartialUpdate(id, patchedGameMasterWorldPlanetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this planet.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldPlanetsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldPlanetsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Browse + create + update, deliberately no `destroy`. Deleting a node cascades through Position -> TacticalMap and nulls `GameObject.position` in every campaign that uses it; the builder does not attempt that here.
     * @param {string} id A UUID string identifying this planet.
     * @param {GameMasterWorldPlanetRequest} gameMasterWorldPlanetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameMasterWorldHierarchyApi
     */
    public gamemasterWorldPlanetsUpdate(id: string, gameMasterWorldPlanetRequest: GameMasterWorldPlanetRequest, options?: RawAxiosRequestConfig) {
        return GameMasterWorldHierarchyApiFp(this.configuration).gamemasterWorldPlanetsUpdate(id, gameMasterWorldPlanetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GamemasterApi - axios parameter creator
 * @export
 */
export const GamemasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignBasicsUpdateRequest} [campaignBasicsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsUpdate: async (id: string, campaignBasicsUpdateRequest?: CampaignBasicsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCampaignsUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/campaigns/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignBasicsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new challenge for a character
         * @summary Create Challenge
         * @param {GameMasterCreateChallengeRequest} gameMasterCreateChallengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterChallengesCreateCreate: async (gameMasterCreateChallengeRequest: GameMasterCreateChallengeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameMasterCreateChallengeRequest' is not null or undefined
            assertParamExists('gamemasterChallengesCreateCreate', 'gameMasterCreateChallengeRequest', gameMasterCreateChallengeRequest)
            const localVarPath = `/api/gamemaster/challenges/create/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterCreateChallengeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for GameMasters to create and manage challenges for characters.  This viewset provides functionality for GameMasters to: - Create new challenges for characters - View existing challenges - Configure challenge parameters including difficulty, dice, modifiers, and advantage/disadvantage  The challenge creation process includes business logic that automatically adds modifiers based on character state, stats, effects, skills, and items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterChallengesList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/challenges/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for GameMasters to create and manage challenges for characters.  This viewset provides functionality for GameMasters to: - Create new challenges for characters - View existing challenges - Configure challenge parameters including difficulty, dice, modifiers, and advantage/disadvantage  The challenge creation process includes business logic that automatically adds modifiers based on character state, stats, effects, skills, and items.
         * @param {string} id A UUID string identifying this challenge.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterChallengesRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterChallengesRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/challenges/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns list of GM\'s own characters and NPCs at specified or current position. Use position_id query parameter to filter characters by specific position.
         * @summary Get available characters for GM impersonation
         * @param {string} [positionId] Filter characters by position ID. If not provided, returns NPCs at current position and all GM characters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterSwitchAvailableCharactersList: async (positionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/character-switch/available-characters/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (positionId !== undefined) {
                localVarQueryParameter['position_id'] = positionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Switch GM\'s main character to a different character. Updates Client.main_character in database.
         * @param {GMCharacterSwitchRequestRequest} gMCharacterSwitchRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterSwitchSwitchCharacterCreate: async (gMCharacterSwitchRequestRequest: GMCharacterSwitchRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gMCharacterSwitchRequestRequest' is not null or undefined
            assertParamExists('gamemasterCharacterSwitchSwitchCharacterCreate', 'gMCharacterSwitchRequestRequest', gMCharacterSwitchRequestRequest)
            const localVarPath = `/api/gamemaster/character-switch/switch-character/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gMCharacterSwitchRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an NPC from a template.  This action creates a new NPC based on the specified template and position. It requires template_id and position_id parameters.
         * @param {CreateNPCFromTemplateRequest} createNPCFromTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterTemplatesCreateNpcCreate: async (createNPCFromTemplateRequest: CreateNPCFromTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNPCFromTemplateRequest' is not null or undefined
            assertParamExists('gamemasterCharacterTemplatesCreateNpcCreate', 'createNPCFromTemplateRequest', createNPCFromTemplateRequest)
            const localVarPath = `/api/gamemaster/character-templates/create_npc/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNPCFromTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export a character template as JSON. Game Master access only.
         * @summary Export Character Template
         * @param {string} id A UUID string identifying this Character Template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterTemplatesExportTemplateRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCharacterTemplatesExportTemplateRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/character-templates/{id}/export_template/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to view character templates and create NPCs from them.  This viewset provides read-only operations for character templates and an action to create NPCs from templates.
         * @param {BehaviorEnum} [behavior] * &#x60;Passive&#x60; - Passive * &#x60;Aggressive&#x60; - Aggressive * &#x60;Friendly&#x60; - Friendly
         * @param {number} [dimension] 
         * @param {string} [name] 
         * @param {string} [organization] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [path] 
         * @param {string} [rank] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterTemplatesList: async (behavior?: BehaviorEnum, dimension?: number, name?: string, organization?: string, page?: number, pageSize?: number, path?: string, rank?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/character-templates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (behavior !== undefined) {
                localVarQueryParameter['behavior'] = behavior;
            }

            if (dimension !== undefined) {
                localVarQueryParameter['dimension'] = dimension;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (organization !== undefined) {
                localVarQueryParameter['organization'] = organization;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (rank !== undefined) {
                localVarQueryParameter['rank'] = rank;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow to se what NPC will be created from the template.
         * @summary Preview Character Template
         * @param {string} id A UUID string identifying this Character Template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterTemplatesPreviewRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCharacterTemplatesPreviewRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/character-templates/{id}/preview/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to view character templates and create NPCs from them.  This viewset provides read-only operations for character templates and an action to create NPCs from templates.
         * @param {string} id A UUID string identifying this Character Template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterTemplatesRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCharacterTemplatesRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/character-templates/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set how much room a character\'s body takes on the tactical grid
         * @param {string} id A UUID string identifying this character.
         * @param {PatchedCharacterTacticalSizeRequest} [patchedCharacterTacticalSizeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersChangeTacticalSizePartialUpdate: async (id: string, patchedCharacterTacticalSizeRequest?: PatchedCharacterTacticalSizeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCharactersChangeTacticalSizePartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/characters/{id}/change_tactical_size/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCharacterTacticalSizeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get character information for the GameMasterCharacterCard component
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersCharacterCardRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCharactersCharacterCardRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/characters/{id}/character_card/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed information about a character.
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersCharacterInfoRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCharactersCharacterInfoRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/characters/{id}/character_info/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get character stats for the GameMasterCharacterStatsCard component
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersCharacterStatsCardRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCharactersCharacterStatsCardRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/characters/{id}/character_stats_card/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get character stats.
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersCharacterStatsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCharactersCharacterStatsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/characters/{id}/character_stats/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign a character with Flow, or release it. A signed character acts under game master authority and is marked as such on every screen.
         * @param {string} id A UUID string identifying this character.
         * @param {PatchedCharacterGameMasterModeRequest} [patchedCharacterGameMasterModeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersGameMasterModePartialUpdate: async (id: string, patchedCharacterGameMasterModeRequest?: PatchedCharacterGameMasterModeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCharactersGameMasterModePartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/characters/{id}/game-master-mode/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCharacterGameMasterModeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Perform a god intervention on a character.  This action allows game masters to apply a god intervention effect to a character, which can include stat modifications, effects, or other game mechanics.  The request should contain the necessary parameters for the intervention.
         * @param {string} id A UUID string identifying this character.
         * @param {GodInterventionRequest} godInterventionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersGodInterventionCreate: async (id: string, godInterventionRequest: GodInterventionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCharactersGodInterventionCreate', 'id', id)
            // verify required parameter 'godInterventionRequest' is not null or undefined
            assertParamExists('gamemasterCharactersGodInterventionCreate', 'godInterventionRequest', godInterventionRequest)
            const localVarPath = `/api/gamemaster/characters/{id}/god_intervention/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(godInterventionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage characters. This viewset provides full CRUD operations for characters.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersList: async (npc?: boolean, position?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/characters/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (npc !== undefined) {
                localVarQueryParameter['npc'] = npc;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage characters. This viewset provides full CRUD operations for characters.
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterCharactersRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/characters/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Advance the world clock by N phases or N cycles.  Defaults to a single phase, which is the smallest useful step and the one a debugging session wants most of the time.
         * @param {CycleAdvanceRequestRequest} [cycleAdvanceRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCyclesAdvanceCreate: async (cycleAdvanceRequestRequest?: CycleAdvanceRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/cycles/advance/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cycleAdvanceRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Where the world clock stands, and whether anything is driving it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCyclesCurrentRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/cycles/current/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stop all active fights (optionally filtered by position or character)
         * @param {string} id A UUID string identifying this fight.
         * @param {StopAllFightsRequest} [stopAllFightsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsAdvancePhaseCreate: async (id: string, stopAllFightsRequest?: StopAllFightsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterFightsAdvancePhaseCreate', 'id', id)
            const localVarPath = `/api/gamemaster/fights/{id}/advance_phase/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stopAllFightsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for GameMasters to manage fights.  Provides: - List and retrieve fights (with filtering by position_id and character_id) - Custom action to stop fights
         * @param {number} [characterId] 
         * @param {boolean} [duel] 
         * @param {boolean} [open] 
         * @param {number} [positionId] 
         * @param {boolean} [sealed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsList: async (characterId?: number, duel?: boolean, open?: boolean, positionId?: number, sealed?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/fights/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (characterId !== undefined) {
                localVarQueryParameter['character_id'] = characterId;
            }

            if (duel !== undefined) {
                localVarQueryParameter['duel'] = duel;
            }

            if (open !== undefined) {
                localVarQueryParameter['open'] = open;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['position_id'] = positionId;
            }

            if (sealed !== undefined) {
                localVarQueryParameter['sealed'] = sealed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/participants/{character_id}/`` — move a participant to a different side of the same fight.
         * @param {string} fightPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsParticipantsList: async (fightPk: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fightPk' is not null or undefined
            assertParamExists('gamemasterFightsParticipantsList', 'fightPk', fightPk)
            const localVarPath = `/api/gamemaster/fights/{fight_pk}/participants/`
                .replace(`{${"fight_pk"}}`, encodeURIComponent(String(fightPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/participants/{character_id}/`` — move a participant to a different side of the same fight.
         * @param {string} characterId 
         * @param {string} fightPk 
         * @param {PatchedGameMasterFightParticipantMoveRequest} [patchedGameMasterFightParticipantMoveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsParticipantsPartialUpdate: async (characterId: string, fightPk: string, patchedGameMasterFightParticipantMoveRequest?: PatchedGameMasterFightParticipantMoveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'characterId' is not null or undefined
            assertParamExists('gamemasterFightsParticipantsPartialUpdate', 'characterId', characterId)
            // verify required parameter 'fightPk' is not null or undefined
            assertParamExists('gamemasterFightsParticipantsPartialUpdate', 'fightPk', fightPk)
            const localVarPath = `/api/gamemaster/fights/{fight_pk}/participants/{character_id}/`
                .replace(`{${"character_id"}}`, encodeURIComponent(String(characterId)))
                .replace(`{${"fight_pk"}}`, encodeURIComponent(String(fightPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGameMasterFightParticipantMoveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/participants/{character_id}/`` — move a participant to a different side of the same fight.
         * @param {string} characterId 
         * @param {string} fightPk 
         * @param {GameMasterFightParticipantMoveRequest} gameMasterFightParticipantMoveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsParticipantsUpdate: async (characterId: string, fightPk: string, gameMasterFightParticipantMoveRequest: GameMasterFightParticipantMoveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'characterId' is not null or undefined
            assertParamExists('gamemasterFightsParticipantsUpdate', 'characterId', characterId)
            // verify required parameter 'fightPk' is not null or undefined
            assertParamExists('gamemasterFightsParticipantsUpdate', 'fightPk', fightPk)
            // verify required parameter 'gameMasterFightParticipantMoveRequest' is not null or undefined
            assertParamExists('gamemasterFightsParticipantsUpdate', 'gameMasterFightParticipantMoveRequest', gameMasterFightParticipantMoveRequest)
            const localVarPath = `/api/gamemaster/fights/{fight_pk}/participants/{character_id}/`
                .replace(`{${"character_id"}}`, encodeURIComponent(String(characterId)))
                .replace(`{${"fight_pk"}}`, encodeURIComponent(String(fightPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterFightParticipantMoveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for GameMasters to manage fights.  Provides: - List and retrieve fights (with filtering by position_id and character_id) - Custom action to stop fights
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterFightsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/fights/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {GameMasterFightSideRequest} gameMasterFightSideRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsSidesCreate: async (fightPk: string, gameMasterFightSideRequest: GameMasterFightSideRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fightPk' is not null or undefined
            assertParamExists('gamemasterFightsSidesCreate', 'fightPk', fightPk)
            // verify required parameter 'gameMasterFightSideRequest' is not null or undefined
            assertParamExists('gamemasterFightsSidesCreate', 'gameMasterFightSideRequest', gameMasterFightSideRequest)
            const localVarPath = `/api/gamemaster/fights/{fight_pk}/sides/`
                .replace(`{${"fight_pk"}}`, encodeURIComponent(String(fightPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterFightSideRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {string} id A UUID string identifying this fight side.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsSidesDestroy: async (fightPk: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fightPk' is not null or undefined
            assertParamExists('gamemasterFightsSidesDestroy', 'fightPk', fightPk)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterFightsSidesDestroy', 'id', id)
            const localVarPath = `/api/gamemaster/fights/{fight_pk}/sides/{id}/`
                .replace(`{${"fight_pk"}}`, encodeURIComponent(String(fightPk)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsSidesList: async (fightPk: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fightPk' is not null or undefined
            assertParamExists('gamemasterFightsSidesList', 'fightPk', fightPk)
            const localVarPath = `/api/gamemaster/fights/{fight_pk}/sides/`
                .replace(`{${"fight_pk"}}`, encodeURIComponent(String(fightPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {string} id A UUID string identifying this fight side.
         * @param {PatchedGameMasterFightSideRequest} [patchedGameMasterFightSideRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsSidesPartialUpdate: async (fightPk: string, id: string, patchedGameMasterFightSideRequest?: PatchedGameMasterFightSideRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fightPk' is not null or undefined
            assertParamExists('gamemasterFightsSidesPartialUpdate', 'fightPk', fightPk)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterFightsSidesPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/fights/{fight_pk}/sides/{id}/`
                .replace(`{${"fight_pk"}}`, encodeURIComponent(String(fightPk)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGameMasterFightSideRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {string} id A UUID string identifying this fight side.
         * @param {GameMasterFightSideRequest} gameMasterFightSideRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsSidesUpdate: async (fightPk: string, id: string, gameMasterFightSideRequest: GameMasterFightSideRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fightPk' is not null or undefined
            assertParamExists('gamemasterFightsSidesUpdate', 'fightPk', fightPk)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterFightsSidesUpdate', 'id', id)
            // verify required parameter 'gameMasterFightSideRequest' is not null or undefined
            assertParamExists('gamemasterFightsSidesUpdate', 'gameMasterFightSideRequest', gameMasterFightSideRequest)
            const localVarPath = `/api/gamemaster/fights/{fight_pk}/sides/{id}/`
                .replace(`{${"fight_pk"}}`, encodeURIComponent(String(fightPk)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameMasterFightSideRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stop all active fights, optionally filtered by position or character.  This action forces multiple fights to close using the same service layer logic as system-initiated fight closures.  Args:     position_id (optional): Only stop fights at this position     character_id (optional): Only stop fights involving this character     reason (optional): Reason for stopping the fights (default: \"Mass stopped by Game Master\")  Returns:     Summary of stopped fights including counts and IDs
         * @param {StopAllFightsRequest} [stopAllFightsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsStopAllFightsCreate: async (stopAllFightsRequest?: StopAllFightsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/fights/stop_all_fights/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stopAllFightsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stop a fight manually as GameMaster
         * @param {string} id A UUID string identifying this fight.
         * @param {StopFightRequest} [stopFightRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsStopFightCreate: async (id: string, stopFightRequest?: StopFightRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterFightsStopFightCreate', 'id', id)
            const localVarPath = `/api/gamemaster/fights/{id}/stop_fight/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stopFightRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run one pass of the fight worker by hand.  Everything the loop would do on a single tick: expire overdue phase deadlines, end the turns of stragglers, advance fights whose participants have all acked, close fights on inactivity or the round limit, rescue a fight whose clock never started, and expire stale duel invitations — across every sealed fight that is owing one.  For a specific fight that is not yet owing anything, use ``advance_phase`` on it instead.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsTickCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/fights/tick/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clone a game object.
         * @param {string} id A UUID string identifying this game object.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsCloneCreate: async (id: string, gameObjectRequest: GameObjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterGameObjectsCloneCreate', 'id', id)
            // verify required parameter 'gameObjectRequest' is not null or undefined
            assertParamExists('gamemasterGameObjectsCloneCreate', 'gameObjectRequest', gameObjectRequest)
            const localVarPath = `/api/gamemaster/game-objects/{id}/clone/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameObjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsCreate: async (gameObjectRequest: GameObjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameObjectRequest' is not null or undefined
            assertParamExists('gamemasterGameObjectsCreate', 'gameObjectRequest', gameObjectRequest)
            const localVarPath = `/api/gamemaster/game-objects/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameObjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} id A UUID string identifying this game object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterGameObjectsDestroy', 'id', id)
            const localVarPath = `/api/gamemaster/game-objects/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} [campaign] 
         * @param {number} [dimension] 
         * @param {boolean} [isActive] 
         * @param {string} [objectType] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [positionGridZ] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsList: async (campaign?: string, dimension?: number, isActive?: boolean, objectType?: string, ordering?: string, positionGridZ?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/game-objects/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (campaign !== undefined) {
                localVarQueryParameter['campaign'] = campaign;
            }

            if (dimension !== undefined) {
                localVarQueryParameter['dimension'] = dimension;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (objectType !== undefined) {
                localVarQueryParameter['object_type'] = objectType;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (positionGridZ !== undefined) {
                localVarQueryParameter['position_grid_z'] = positionGridZ;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move a game object to a new position.
         * @param {string} id A UUID string identifying this game object.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsMoveCreate: async (id: string, gameObjectRequest: GameObjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterGameObjectsMoveCreate', 'id', id)
            // verify required parameter 'gameObjectRequest' is not null or undefined
            assertParamExists('gamemasterGameObjectsMoveCreate', 'gameObjectRequest', gameObjectRequest)
            const localVarPath = `/api/gamemaster/game-objects/{id}/move/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameObjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} id A UUID string identifying this game object.
         * @param {PatchedGameObjectRequest} [patchedGameObjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsPartialUpdate: async (id: string, patchedGameObjectRequest?: PatchedGameObjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterGameObjectsPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/game-objects/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGameObjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} id A UUID string identifying this game object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterGameObjectsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/game-objects/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle the active status of a game object.
         * @param {string} id A UUID string identifying this game object.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsToggleActiveCreate: async (id: string, gameObjectRequest: GameObjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterGameObjectsToggleActiveCreate', 'id', id)
            // verify required parameter 'gameObjectRequest' is not null or undefined
            assertParamExists('gamemasterGameObjectsToggleActiveCreate', 'gameObjectRequest', gameObjectRequest)
            const localVarPath = `/api/gamemaster/game-objects/{id}/toggle_active/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameObjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} id A UUID string identifying this game object.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsUpdate: async (id: string, gameObjectRequest: GameObjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterGameObjectsUpdate', 'id', id)
            // verify required parameter 'gameObjectRequest' is not null or undefined
            assertParamExists('gamemasterGameObjectsUpdate', 'gameObjectRequest', gameObjectRequest)
            const localVarPath = `/api/gamemaster/game-objects/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gameObjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a login token for a user based on a character ID
         * @param {ImpersonationRequestRequest} impersonationRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterImpersonationImpersonateCreate: async (impersonationRequestRequest: ImpersonationRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'impersonationRequestRequest' is not null or undefined
            assertParamExists('gamemasterImpersonationImpersonateCreate', 'impersonationRequestRequest', impersonationRequestRequest)
            const localVarPath = `/api/gamemaster/impersonation/impersonate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(impersonationRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage items. This viewset provides full CRUD operations for items.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {ItemTypeEnum} [type] * &#x60;weapon&#x60; - weapon * &#x60;armor&#x60; - armor * &#x60;artifact&#x60; - artifact * &#x60;amulet&#x60; - amulet * &#x60;material&#x60; - material * &#x60;quest&#x60; - quest * &#x60;misc&#x60; - misc * &#x60;food&#x60; - food * &#x60;rune&#x60; - rune
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterItemsList: async (ordering?: string, search?: string, type?: ItemTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/items/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage items. This viewset provides full CRUD operations for items.
         * @param {string} id A UUID string identifying this item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterItemsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterItemsRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/items/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change the behavior of an NPC.  This action changes the behavior of the specified NPC. It requires the behavior parameter.
         * @param {string} id A UUID string identifying this character.
         * @param {PatchedNPCBehaviorRequest} [patchedNPCBehaviorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterNpcsChangeBehaviorPartialUpdate: async (id: string, patchedNPCBehaviorRequest?: PatchedNPCBehaviorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterNpcsChangeBehaviorPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/npcs/{id}/change_behavior/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedNPCBehaviorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to create skills dynamically during gameplay. Provides skill factory functionality with comprehensive validation and documentation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/skill/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint allows game masters to create a new skill using the skill factory service. The skill will be created with the provided data and returned in the response.
         * @summary Create a new skill
         * @param {SkillCreateRequest} skillCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillNewSkillCreate: async (skillCreateRequest: SkillCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillCreateRequest' is not null or undefined
            assertParamExists('gamemasterSkillNewSkillCreate', 'skillCreateRequest', skillCreateRequest)
            const localVarPath = `/api/gamemaster/skill/new_skill/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to create skills dynamically during gameplay. Provides skill factory functionality with comprehensive validation and documentation.
         * @param {number} id A unique integer value identifying this skill.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillRetrieve: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterSkillRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/skill/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all position connections, optionally filtered by grid_z.
         * @param {number} [gridZ] Filter by grid_z coordinate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapConnectionsRetrieve: async (gridZ?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-map/connections/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gridZ !== undefined) {
                localVarQueryParameter['grid_z'] = gridZ;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapCreate: async (positionRequest: PositionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionRequest' is not null or undefined
            assertParamExists('gamemasterWorldMapCreate', 'positionRequest', positionRequest)
            const localVarPath = `/api/gamemaster/world-map/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new connection between two positions.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapCreateConnectionCreate: async (positionRequest: PositionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionRequest' is not null or undefined
            assertParamExists('gamemasterWorldMapCreateConnectionCreate', 'positionRequest', positionRequest)
            const localVarPath = `/api/gamemaster/world-map/create_connection/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new position and automatically connect it to nearby positions.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapCreatePositionWithConnectionsCreate: async (positionRequest: PositionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionRequest' is not null or undefined
            assertParamExists('gamemasterWorldMapCreatePositionWithConnectionsCreate', 'positionRequest', positionRequest)
            const localVarPath = `/api/gamemaster/world-map/create_position_with_connections/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a connection between this position and another position.
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapDeleteConnectionDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldMapDeleteConnectionDestroy', 'id', id)
            const localVarPath = `/api/gamemaster/world-map/{id}/delete_connection/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldMapDestroy', 'id', id)
            const localVarPath = `/api/gamemaster/world-map/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {number} [gridZ] 
         * @param {boolean} [isSafe] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [subLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapList: async (gridZ?: number, isSafe?: boolean, ordering?: string, subLocation?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-map/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gridZ !== undefined) {
                localVarQueryParameter['grid_z'] = gridZ;
            }

            if (isSafe !== undefined) {
                localVarQueryParameter['is_safe'] = isSafe;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (subLocation !== undefined) {
                localVarQueryParameter['sub_location'] = subLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a complete map structure with positions and connections filtered by grid_z.
         * @param {number} [gridZ] Filter by grid_z coordinate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapMapRetrieve: async (gridZ?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gamemaster/world-map/map/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gridZ !== undefined) {
                localVarQueryParameter['grid_z'] = gridZ;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {string} id A UUID string identifying this position.
         * @param {PatchedPositionRequest} [patchedPositionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapPartialUpdate: async (id: string, patchedPositionRequest?: PatchedPositionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldMapPartialUpdate', 'id', id)
            const localVarPath = `/api/gamemaster/world-map/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedPositionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldMapRetrieve', 'id', id)
            const localVarPath = `/api/gamemaster/world-map/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lock or unlock a connection between this position and another position.
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapToggleConnectionLockCreate: async (id: string, positionRequest: PositionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldMapToggleConnectionLockCreate', 'id', id)
            // verify required parameter 'positionRequest' is not null or undefined
            assertParamExists('gamemasterWorldMapToggleConnectionLockCreate', 'positionRequest', positionRequest)
            const localVarPath = `/api/gamemaster/world-map/{id}/toggle_connection_lock/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapUpdate: async (id: string, positionRequest: PositionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gamemasterWorldMapUpdate', 'id', id)
            // verify required parameter 'positionRequest' is not null or undefined
            assertParamExists('gamemasterWorldMapUpdate', 'positionRequest', positionRequest)
            const localVarPath = `/api/gamemaster/world-map/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Spawn an item in the game world. Creates a WorldItem instance from the Item and optionally assigns it to a character.
         * @param {string} id A UUID string identifying this item.
         * @param {SpawnItemRequest} [spawnItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spawnItem: async (id: string, spawnItemRequest?: SpawnItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('spawnItem', 'id', id)
            const localVarPath = `/api/gamemaster/items/{id}/spawn_item/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(spawnItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GamemasterApi - functional programming interface
 * @export
 */
export const GamemasterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GamemasterApiAxiosParamCreator(configuration)
    return {
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignBasicsUpdateRequest} [campaignBasicsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCampaignsUpdate(id: string, campaignBasicsUpdateRequest?: CampaignBasicsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignBasicsUpdate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCampaignsUpdate(id, campaignBasicsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCampaignsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new challenge for a character
         * @summary Create Challenge
         * @param {GameMasterCreateChallengeRequest} gameMasterCreateChallengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterChallengesCreateCreate(gameMasterCreateChallengeRequest: GameMasterCreateChallengeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterChallengeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterChallengesCreateCreate(gameMasterCreateChallengeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterChallengesCreateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for GameMasters to create and manage challenges for characters.  This viewset provides functionality for GameMasters to: - Create new challenges for characters - View existing challenges - Configure challenge parameters including difficulty, dice, modifiers, and advantage/disadvantage  The challenge creation process includes business logic that automatically adds modifiers based on character state, stats, effects, skills, and items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterChallengesList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterChallengeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterChallengesList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterChallengesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for GameMasters to create and manage challenges for characters.  This viewset provides functionality for GameMasters to: - Create new challenges for characters - View existing challenges - Configure challenge parameters including difficulty, dice, modifiers, and advantage/disadvantage  The challenge creation process includes business logic that automatically adds modifiers based on character state, stats, effects, skills, and items.
         * @param {string} id A UUID string identifying this challenge.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterChallengesRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterChallengeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterChallengesRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterChallengesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns list of GM\'s own characters and NPCs at specified or current position. Use position_id query parameter to filter characters by specific position.
         * @summary Get available characters for GM impersonation
         * @param {string} [positionId] Filter characters by position ID. If not provided, returns NPCs at current position and all GM characters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharacterSwitchAvailableCharactersList(positionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GMAvailableCharacter>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharacterSwitchAvailableCharactersList(positionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharacterSwitchAvailableCharactersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Switch GM\'s main character to a different character. Updates Client.main_character in database.
         * @param {GMCharacterSwitchRequestRequest} gMCharacterSwitchRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharacterSwitchSwitchCharacterCreate(gMCharacterSwitchRequestRequest: GMCharacterSwitchRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GMCharacterSwitchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharacterSwitchSwitchCharacterCreate(gMCharacterSwitchRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharacterSwitchSwitchCharacterCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create an NPC from a template.  This action creates a new NPC based on the specified template and position. It requires template_id and position_id parameters.
         * @param {CreateNPCFromTemplateRequest} createNPCFromTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharacterTemplatesCreateNpcCreate(createNPCFromTemplateRequest: CreateNPCFromTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateNPCFromTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharacterTemplatesCreateNpcCreate(createNPCFromTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharacterTemplatesCreateNpcCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export a character template as JSON. Game Master access only.
         * @summary Export Character Template
         * @param {string} id A UUID string identifying this Character Template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharacterTemplatesExportTemplateRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterTemplateFull>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharacterTemplatesExportTemplateRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharacterTemplatesExportTemplateRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to view character templates and create NPCs from them.  This viewset provides read-only operations for character templates and an action to create NPCs from templates.
         * @param {BehaviorEnum} [behavior] * &#x60;Passive&#x60; - Passive * &#x60;Aggressive&#x60; - Aggressive * &#x60;Friendly&#x60; - Friendly
         * @param {number} [dimension] 
         * @param {string} [name] 
         * @param {string} [organization] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [path] 
         * @param {string} [rank] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharacterTemplatesList(behavior?: BehaviorEnum, dimension?: number, name?: string, organization?: string, page?: number, pageSize?: number, path?: string, rank?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCharacterTemplateGameMasterList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharacterTemplatesList(behavior, dimension, name, organization, page, pageSize, path, rank, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharacterTemplatesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allow to se what NPC will be created from the template.
         * @summary Preview Character Template
         * @param {string} id A UUID string identifying this Character Template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharacterTemplatesPreviewRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterCharacterInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharacterTemplatesPreviewRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharacterTemplatesPreviewRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to view character templates and create NPCs from them.  This viewset provides read-only operations for character templates and an action to create NPCs from templates.
         * @param {string} id A UUID string identifying this Character Template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharacterTemplatesRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterTemplateGameMaster>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharacterTemplatesRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharacterTemplatesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set how much room a character\'s body takes on the tactical grid
         * @param {string} id A UUID string identifying this character.
         * @param {PatchedCharacterTacticalSizeRequest} [patchedCharacterTacticalSizeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharactersChangeTacticalSizePartialUpdate(id: string, patchedCharacterTacticalSizeRequest?: PatchedCharacterTacticalSizeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterCharacterInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharactersChangeTacticalSizePartialUpdate(id, patchedCharacterTacticalSizeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharactersChangeTacticalSizePartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get character information for the GameMasterCharacterCard component
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharactersCharacterCardRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterCharacterInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharactersCharacterCardRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharactersCharacterCardRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed information about a character.
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharactersCharacterInfoRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharactersCharacterInfoRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharactersCharacterInfoRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get character stats for the GameMasterCharacterStatsCard component
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharactersCharacterStatsCardRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterCharacterStatsCard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharactersCharacterStatsCardRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharactersCharacterStatsCardRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get character stats.
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharactersCharacterStatsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharactersCharacterStatsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharactersCharacterStatsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sign a character with Flow, or release it. A signed character acts under game master authority and is marked as such on every screen.
         * @param {string} id A UUID string identifying this character.
         * @param {PatchedCharacterGameMasterModeRequest} [patchedCharacterGameMasterModeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharactersGameMasterModePartialUpdate(id: string, patchedCharacterGameMasterModeRequest?: PatchedCharacterGameMasterModeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterCharacterInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharactersGameMasterModePartialUpdate(id, patchedCharacterGameMasterModeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharactersGameMasterModePartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Perform a god intervention on a character.  This action allows game masters to apply a god intervention effect to a character, which can include stat modifications, effects, or other game mechanics.  The request should contain the necessary parameters for the intervention.
         * @param {string} id A UUID string identifying this character.
         * @param {GodInterventionRequest} godInterventionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharactersGodInterventionCreate(id: string, godInterventionRequest: GodInterventionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GodIntervention>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharactersGodInterventionCreate(id, godInterventionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharactersGodInterventionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage characters. This viewset provides full CRUD operations for characters.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharactersList(npc?: boolean, position?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CharacterInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharactersList(npc, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharactersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage characters. This viewset provides full CRUD operations for characters.
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCharactersRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCharactersRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCharactersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Advance the world clock by N phases or N cycles.  Defaults to a single phase, which is the smallest useful step and the one a debugging session wants most of the time.
         * @param {CycleAdvanceRequestRequest} [cycleAdvanceRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCyclesAdvanceCreate(cycleAdvanceRequestRequest?: CycleAdvanceRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CycleAdvanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCyclesAdvanceCreate(cycleAdvanceRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCyclesAdvanceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Where the world clock stands, and whether anything is driving it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterCyclesCurrentRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CycleState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterCyclesCurrentRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterCyclesCurrentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stop all active fights (optionally filtered by position or character)
         * @param {string} id A UUID string identifying this fight.
         * @param {StopAllFightsRequest} [stopAllFightsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsAdvancePhaseCreate(id: string, stopAllFightsRequest?: StopAllFightsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StopAllFightsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsAdvancePhaseCreate(id, stopAllFightsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsAdvancePhaseCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for GameMasters to manage fights.  Provides: - List and retrieve fights (with filtering by position_id and character_id) - Custom action to stop fights
         * @param {number} [characterId] 
         * @param {boolean} [duel] 
         * @param {boolean} [open] 
         * @param {number} [positionId] 
         * @param {boolean} [sealed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsList(characterId?: number, duel?: boolean, open?: boolean, positionId?: number, sealed?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterFight>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsList(characterId, duel, open, positionId, sealed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/participants/{character_id}/`` — move a participant to a different side of the same fight.
         * @param {string} fightPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsParticipantsList(fightPk: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterFightParticipantMove>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsParticipantsList(fightPk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsParticipantsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/participants/{character_id}/`` — move a participant to a different side of the same fight.
         * @param {string} characterId 
         * @param {string} fightPk 
         * @param {PatchedGameMasterFightParticipantMoveRequest} [patchedGameMasterFightParticipantMoveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsParticipantsPartialUpdate(characterId: string, fightPk: string, patchedGameMasterFightParticipantMoveRequest?: PatchedGameMasterFightParticipantMoveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterFightParticipantMove>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsParticipantsPartialUpdate(characterId, fightPk, patchedGameMasterFightParticipantMoveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsParticipantsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/participants/{character_id}/`` — move a participant to a different side of the same fight.
         * @param {string} characterId 
         * @param {string} fightPk 
         * @param {GameMasterFightParticipantMoveRequest} gameMasterFightParticipantMoveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsParticipantsUpdate(characterId: string, fightPk: string, gameMasterFightParticipantMoveRequest: GameMasterFightParticipantMoveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterFightParticipantMove>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsParticipantsUpdate(characterId, fightPk, gameMasterFightParticipantMoveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsParticipantsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for GameMasters to manage fights.  Provides: - List and retrieve fights (with filtering by position_id and character_id) - Custom action to stop fights
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterFight>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {GameMasterFightSideRequest} gameMasterFightSideRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsSidesCreate(fightPk: string, gameMasterFightSideRequest: GameMasterFightSideRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterFightSide>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsSidesCreate(fightPk, gameMasterFightSideRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsSidesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {string} id A UUID string identifying this fight side.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsSidesDestroy(fightPk: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsSidesDestroy(fightPk, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsSidesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsSidesList(fightPk: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterFightSide>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsSidesList(fightPk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsSidesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {string} id A UUID string identifying this fight side.
         * @param {PatchedGameMasterFightSideRequest} [patchedGameMasterFightSideRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsSidesPartialUpdate(fightPk: string, id: string, patchedGameMasterFightSideRequest?: PatchedGameMasterFightSideRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterFightSide>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsSidesPartialUpdate(fightPk, id, patchedGameMasterFightSideRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsSidesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {string} id A UUID string identifying this fight side.
         * @param {GameMasterFightSideRequest} gameMasterFightSideRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsSidesUpdate(fightPk: string, id: string, gameMasterFightSideRequest: GameMasterFightSideRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterFightSide>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsSidesUpdate(fightPk, id, gameMasterFightSideRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsSidesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stop all active fights, optionally filtered by position or character.  This action forces multiple fights to close using the same service layer logic as system-initiated fight closures.  Args:     position_id (optional): Only stop fights at this position     character_id (optional): Only stop fights involving this character     reason (optional): Reason for stopping the fights (default: \"Mass stopped by Game Master\")  Returns:     Summary of stopped fights including counts and IDs
         * @param {StopAllFightsRequest} [stopAllFightsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsStopAllFightsCreate(stopAllFightsRequest?: StopAllFightsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StopAllFights>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsStopAllFightsCreate(stopAllFightsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsStopAllFightsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stop a fight manually as GameMaster
         * @param {string} id A UUID string identifying this fight.
         * @param {StopFightRequest} [stopFightRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsStopFightCreate(id: string, stopFightRequest?: StopFightRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StopFightResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsStopFightCreate(id, stopFightRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsStopFightCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Run one pass of the fight worker by hand.  Everything the loop would do on a single tick: expire overdue phase deadlines, end the turns of stragglers, advance fights whose participants have all acked, close fights on inactivity or the round limit, rescue a fight whose clock never started, and expire stale duel invitations — across every sealed fight that is owing one.  For a specific fight that is not yet owing anything, use ``advance_phase`` on it instead.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterFightsTickCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterFightClockResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterFightsTickCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterFightsTickCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clone a game object.
         * @param {string} id A UUID string identifying this game object.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterGameObjectsCloneCreate(id: string, gameObjectRequest: GameObjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterGameObjectsCloneCreate(id, gameObjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterGameObjectsCloneCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterGameObjectsCreate(gameObjectRequest: GameObjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterGameObjectsCreate(gameObjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterGameObjectsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} id A UUID string identifying this game object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterGameObjectsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterGameObjectsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterGameObjectsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} [campaign] 
         * @param {number} [dimension] 
         * @param {boolean} [isActive] 
         * @param {string} [objectType] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [positionGridZ] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterGameObjectsList(campaign?: string, dimension?: number, isActive?: boolean, objectType?: string, ordering?: string, positionGridZ?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameObject>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterGameObjectsList(campaign, dimension, isActive, objectType, ordering, positionGridZ, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterGameObjectsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Move a game object to a new position.
         * @param {string} id A UUID string identifying this game object.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterGameObjectsMoveCreate(id: string, gameObjectRequest: GameObjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterGameObjectsMoveCreate(id, gameObjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterGameObjectsMoveCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} id A UUID string identifying this game object.
         * @param {PatchedGameObjectRequest} [patchedGameObjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterGameObjectsPartialUpdate(id: string, patchedGameObjectRequest?: PatchedGameObjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterGameObjectsPartialUpdate(id, patchedGameObjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterGameObjectsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} id A UUID string identifying this game object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterGameObjectsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterGameObjectsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterGameObjectsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle the active status of a game object.
         * @param {string} id A UUID string identifying this game object.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterGameObjectsToggleActiveCreate(id: string, gameObjectRequest: GameObjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterGameObjectsToggleActiveCreate(id, gameObjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterGameObjectsToggleActiveCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} id A UUID string identifying this game object.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterGameObjectsUpdate(id: string, gameObjectRequest: GameObjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterGameObjectsUpdate(id, gameObjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterGameObjectsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a login token for a user based on a character ID
         * @param {ImpersonationRequestRequest} impersonationRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterImpersonationImpersonateCreate(impersonationRequestRequest: ImpersonationRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImpersonationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterImpersonationImpersonateCreate(impersonationRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterImpersonationImpersonateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage items. This viewset provides full CRUD operations for items.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {ItemTypeEnum} [type] * &#x60;weapon&#x60; - weapon * &#x60;armor&#x60; - armor * &#x60;artifact&#x60; - artifact * &#x60;amulet&#x60; - amulet * &#x60;material&#x60; - material * &#x60;quest&#x60; - quest * &#x60;misc&#x60; - misc * &#x60;food&#x60; - food * &#x60;rune&#x60; - rune
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterItemsList(ordering?: string, search?: string, type?: ItemTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameMasterItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterItemsList(ordering, search, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterItemsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage items. This viewset provides full CRUD operations for items.
         * @param {string} id A UUID string identifying this item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterItemsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterItemsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterItemsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change the behavior of an NPC.  This action changes the behavior of the specified NPC. It requires the behavior parameter.
         * @param {string} id A UUID string identifying this character.
         * @param {PatchedNPCBehaviorRequest} [patchedNPCBehaviorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterNpcsChangeBehaviorPartialUpdate(id: string, patchedNPCBehaviorRequest?: PatchedNPCBehaviorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameMasterCharacterInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterNpcsChangeBehaviorPartialUpdate(id, patchedNPCBehaviorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterNpcsChangeBehaviorPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to create skills dynamically during gameplay. Provides skill factory functionality with comprehensive validation and documentation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Skill>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterSkillList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint allows game masters to create a new skill using the skill factory service. The skill will be created with the provided data and returned in the response.
         * @summary Create a new skill
         * @param {SkillCreateRequest} skillCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillNewSkillCreate(skillCreateRequest: SkillCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Skill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillNewSkillCreate(skillCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterSkillNewSkillCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to create skills dynamically during gameplay. Provides skill factory functionality with comprehensive validation and documentation.
         * @param {number} id A unique integer value identifying this skill.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterSkillRetrieve(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Skill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterSkillRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterSkillRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all position connections, optionally filtered by grid_z.
         * @param {number} [gridZ] Filter by grid_z coordinate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldMapConnectionsRetrieve(gridZ?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldMapConnectionsRetrieve(gridZ, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterWorldMapConnectionsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldMapCreate(positionRequest: PositionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldMapCreate(positionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterWorldMapCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new connection between two positions.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldMapCreateConnectionCreate(positionRequest: PositionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldMapCreateConnectionCreate(positionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterWorldMapCreateConnectionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new position and automatically connect it to nearby positions.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldMapCreatePositionWithConnectionsCreate(positionRequest: PositionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldMapCreatePositionWithConnectionsCreate(positionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterWorldMapCreatePositionWithConnectionsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a connection between this position and another position.
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldMapDeleteConnectionDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldMapDeleteConnectionDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterWorldMapDeleteConnectionDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldMapDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldMapDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterWorldMapDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {number} [gridZ] 
         * @param {boolean} [isSafe] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [subLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldMapList(gridZ?: number, isSafe?: boolean, ordering?: string, subLocation?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Position>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldMapList(gridZ, isSafe, ordering, subLocation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterWorldMapList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a complete map structure with positions and connections filtered by grid_z.
         * @param {number} [gridZ] Filter by grid_z coordinate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldMapMapRetrieve(gridZ?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MapResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldMapMapRetrieve(gridZ, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterWorldMapMapRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {string} id A UUID string identifying this position.
         * @param {PatchedPositionRequest} [patchedPositionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldMapPartialUpdate(id: string, patchedPositionRequest?: PatchedPositionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldMapPartialUpdate(id, patchedPositionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterWorldMapPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldMapRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldMapRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterWorldMapRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lock or unlock a connection between this position and another position.
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldMapToggleConnectionLockCreate(id: string, positionRequest: PositionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldMapToggleConnectionLockCreate(id, positionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterWorldMapToggleConnectionLockCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamemasterWorldMapUpdate(id: string, positionRequest: PositionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamemasterWorldMapUpdate(id, positionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.gamemasterWorldMapUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Spawn an item in the game world. Creates a WorldItem instance from the Item and optionally assigns it to a character.
         * @param {string} id A UUID string identifying this item.
         * @param {SpawnItemRequest} [spawnItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async spawnItem(id: string, spawnItemRequest?: SpawnItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorldItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.spawnItem(id, spawnItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GamemasterApi.spawnItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GamemasterApi - factory interface
 * @export
 */
export const GamemasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GamemasterApiFp(configuration)
    return {
        /**
         * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
         * @param {string} id A UUID string identifying this campaign.
         * @param {CampaignBasicsUpdateRequest} [campaignBasicsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCampaignsUpdate(id: string, campaignBasicsUpdateRequest?: CampaignBasicsUpdateRequest, options?: any): AxiosPromise<CampaignBasicsUpdate> {
            return localVarFp.gamemasterCampaignsUpdate(id, campaignBasicsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new challenge for a character
         * @summary Create Challenge
         * @param {GameMasterCreateChallengeRequest} gameMasterCreateChallengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterChallengesCreateCreate(gameMasterCreateChallengeRequest: GameMasterCreateChallengeRequest, options?: any): AxiosPromise<GameMasterChallengeResponse> {
            return localVarFp.gamemasterChallengesCreateCreate(gameMasterCreateChallengeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for GameMasters to create and manage challenges for characters.  This viewset provides functionality for GameMasters to: - Create new challenges for characters - View existing challenges - Configure challenge parameters including difficulty, dice, modifiers, and advantage/disadvantage  The challenge creation process includes business logic that automatically adds modifiers based on character state, stats, effects, skills, and items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterChallengesList(options?: any): AxiosPromise<Array<GameMasterChallengeResponse>> {
            return localVarFp.gamemasterChallengesList(options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for GameMasters to create and manage challenges for characters.  This viewset provides functionality for GameMasters to: - Create new challenges for characters - View existing challenges - Configure challenge parameters including difficulty, dice, modifiers, and advantage/disadvantage  The challenge creation process includes business logic that automatically adds modifiers based on character state, stats, effects, skills, and items.
         * @param {string} id A UUID string identifying this challenge.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterChallengesRetrieve(id: string, options?: any): AxiosPromise<GameMasterChallengeResponse> {
            return localVarFp.gamemasterChallengesRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns list of GM\'s own characters and NPCs at specified or current position. Use position_id query parameter to filter characters by specific position.
         * @summary Get available characters for GM impersonation
         * @param {string} [positionId] Filter characters by position ID. If not provided, returns NPCs at current position and all GM characters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterSwitchAvailableCharactersList(positionId?: string, options?: any): AxiosPromise<Array<GMAvailableCharacter>> {
            return localVarFp.gamemasterCharacterSwitchAvailableCharactersList(positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Switch GM\'s main character to a different character. Updates Client.main_character in database.
         * @param {GMCharacterSwitchRequestRequest} gMCharacterSwitchRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterSwitchSwitchCharacterCreate(gMCharacterSwitchRequestRequest: GMCharacterSwitchRequestRequest, options?: any): AxiosPromise<GMCharacterSwitchResponse> {
            return localVarFp.gamemasterCharacterSwitchSwitchCharacterCreate(gMCharacterSwitchRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an NPC from a template.  This action creates a new NPC based on the specified template and position. It requires template_id and position_id parameters.
         * @param {CreateNPCFromTemplateRequest} createNPCFromTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterTemplatesCreateNpcCreate(createNPCFromTemplateRequest: CreateNPCFromTemplateRequest, options?: any): AxiosPromise<CreateNPCFromTemplate> {
            return localVarFp.gamemasterCharacterTemplatesCreateNpcCreate(createNPCFromTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Export a character template as JSON. Game Master access only.
         * @summary Export Character Template
         * @param {string} id A UUID string identifying this Character Template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterTemplatesExportTemplateRetrieve(id: string, options?: any): AxiosPromise<CharacterTemplateFull> {
            return localVarFp.gamemasterCharacterTemplatesExportTemplateRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to view character templates and create NPCs from them.  This viewset provides read-only operations for character templates and an action to create NPCs from templates.
         * @param {BehaviorEnum} [behavior] * &#x60;Passive&#x60; - Passive * &#x60;Aggressive&#x60; - Aggressive * &#x60;Friendly&#x60; - Friendly
         * @param {number} [dimension] 
         * @param {string} [name] 
         * @param {string} [organization] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [path] 
         * @param {string} [rank] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterTemplatesList(behavior?: BehaviorEnum, dimension?: number, name?: string, organization?: string, page?: number, pageSize?: number, path?: string, rank?: string, options?: any): AxiosPromise<PaginatedCharacterTemplateGameMasterList> {
            return localVarFp.gamemasterCharacterTemplatesList(behavior, dimension, name, organization, page, pageSize, path, rank, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow to se what NPC will be created from the template.
         * @summary Preview Character Template
         * @param {string} id A UUID string identifying this Character Template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterTemplatesPreviewRetrieve(id: string, options?: any): AxiosPromise<GameMasterCharacterInfo> {
            return localVarFp.gamemasterCharacterTemplatesPreviewRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to view character templates and create NPCs from them.  This viewset provides read-only operations for character templates and an action to create NPCs from templates.
         * @param {string} id A UUID string identifying this Character Template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharacterTemplatesRetrieve(id: string, options?: any): AxiosPromise<CharacterTemplateGameMaster> {
            return localVarFp.gamemasterCharacterTemplatesRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Set how much room a character\'s body takes on the tactical grid
         * @param {string} id A UUID string identifying this character.
         * @param {PatchedCharacterTacticalSizeRequest} [patchedCharacterTacticalSizeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersChangeTacticalSizePartialUpdate(id: string, patchedCharacterTacticalSizeRequest?: PatchedCharacterTacticalSizeRequest, options?: any): AxiosPromise<GameMasterCharacterInfo> {
            return localVarFp.gamemasterCharactersChangeTacticalSizePartialUpdate(id, patchedCharacterTacticalSizeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get character information for the GameMasterCharacterCard component
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersCharacterCardRetrieve(id: string, options?: any): AxiosPromise<GameMasterCharacterInfo> {
            return localVarFp.gamemasterCharactersCharacterCardRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed information about a character.
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersCharacterInfoRetrieve(id: string, options?: any): AxiosPromise<CharacterInfo> {
            return localVarFp.gamemasterCharactersCharacterInfoRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get character stats for the GameMasterCharacterStatsCard component
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersCharacterStatsCardRetrieve(id: string, options?: any): AxiosPromise<GameMasterCharacterStatsCard> {
            return localVarFp.gamemasterCharactersCharacterStatsCardRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get character stats.
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersCharacterStatsRetrieve(id: string, options?: any): AxiosPromise<CharacterStats> {
            return localVarFp.gamemasterCharactersCharacterStatsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Sign a character with Flow, or release it. A signed character acts under game master authority and is marked as such on every screen.
         * @param {string} id A UUID string identifying this character.
         * @param {PatchedCharacterGameMasterModeRequest} [patchedCharacterGameMasterModeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersGameMasterModePartialUpdate(id: string, patchedCharacterGameMasterModeRequest?: PatchedCharacterGameMasterModeRequest, options?: any): AxiosPromise<GameMasterCharacterInfo> {
            return localVarFp.gamemasterCharactersGameMasterModePartialUpdate(id, patchedCharacterGameMasterModeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Perform a god intervention on a character.  This action allows game masters to apply a god intervention effect to a character, which can include stat modifications, effects, or other game mechanics.  The request should contain the necessary parameters for the intervention.
         * @param {string} id A UUID string identifying this character.
         * @param {GodInterventionRequest} godInterventionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersGodInterventionCreate(id: string, godInterventionRequest: GodInterventionRequest, options?: any): AxiosPromise<GodIntervention> {
            return localVarFp.gamemasterCharactersGodInterventionCreate(id, godInterventionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage characters. This viewset provides full CRUD operations for characters.
         * @param {boolean} [npc] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersList(npc?: boolean, position?: string, options?: any): AxiosPromise<Array<CharacterInfo>> {
            return localVarFp.gamemasterCharactersList(npc, position, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage characters. This viewset provides full CRUD operations for characters.
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCharactersRetrieve(id: string, options?: any): AxiosPromise<CharacterInfo> {
            return localVarFp.gamemasterCharactersRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Advance the world clock by N phases or N cycles.  Defaults to a single phase, which is the smallest useful step and the one a debugging session wants most of the time.
         * @param {CycleAdvanceRequestRequest} [cycleAdvanceRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCyclesAdvanceCreate(cycleAdvanceRequestRequest?: CycleAdvanceRequestRequest, options?: any): AxiosPromise<CycleAdvanceResponse> {
            return localVarFp.gamemasterCyclesAdvanceCreate(cycleAdvanceRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Where the world clock stands, and whether anything is driving it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterCyclesCurrentRetrieve(options?: any): AxiosPromise<CycleState> {
            return localVarFp.gamemasterCyclesCurrentRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Stop all active fights (optionally filtered by position or character)
         * @param {string} id A UUID string identifying this fight.
         * @param {StopAllFightsRequest} [stopAllFightsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsAdvancePhaseCreate(id: string, stopAllFightsRequest?: StopAllFightsRequest, options?: any): AxiosPromise<StopAllFightsResponse> {
            return localVarFp.gamemasterFightsAdvancePhaseCreate(id, stopAllFightsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for GameMasters to manage fights.  Provides: - List and retrieve fights (with filtering by position_id and character_id) - Custom action to stop fights
         * @param {number} [characterId] 
         * @param {boolean} [duel] 
         * @param {boolean} [open] 
         * @param {number} [positionId] 
         * @param {boolean} [sealed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsList(characterId?: number, duel?: boolean, open?: boolean, positionId?: number, sealed?: boolean, options?: any): AxiosPromise<Array<GameMasterFight>> {
            return localVarFp.gamemasterFightsList(characterId, duel, open, positionId, sealed, options).then((request) => request(axios, basePath));
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/participants/{character_id}/`` — move a participant to a different side of the same fight.
         * @param {string} fightPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsParticipantsList(fightPk: string, options?: any): AxiosPromise<Array<GameMasterFightParticipantMove>> {
            return localVarFp.gamemasterFightsParticipantsList(fightPk, options).then((request) => request(axios, basePath));
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/participants/{character_id}/`` — move a participant to a different side of the same fight.
         * @param {string} characterId 
         * @param {string} fightPk 
         * @param {PatchedGameMasterFightParticipantMoveRequest} [patchedGameMasterFightParticipantMoveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsParticipantsPartialUpdate(characterId: string, fightPk: string, patchedGameMasterFightParticipantMoveRequest?: PatchedGameMasterFightParticipantMoveRequest, options?: any): AxiosPromise<GameMasterFightParticipantMove> {
            return localVarFp.gamemasterFightsParticipantsPartialUpdate(characterId, fightPk, patchedGameMasterFightParticipantMoveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/participants/{character_id}/`` — move a participant to a different side of the same fight.
         * @param {string} characterId 
         * @param {string} fightPk 
         * @param {GameMasterFightParticipantMoveRequest} gameMasterFightParticipantMoveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsParticipantsUpdate(characterId: string, fightPk: string, gameMasterFightParticipantMoveRequest: GameMasterFightParticipantMoveRequest, options?: any): AxiosPromise<GameMasterFightParticipantMove> {
            return localVarFp.gamemasterFightsParticipantsUpdate(characterId, fightPk, gameMasterFightParticipantMoveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for GameMasters to manage fights.  Provides: - List and retrieve fights (with filtering by position_id and character_id) - Custom action to stop fights
         * @param {string} id A UUID string identifying this fight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsRetrieve(id: string, options?: any): AxiosPromise<GameMasterFight> {
            return localVarFp.gamemasterFightsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {GameMasterFightSideRequest} gameMasterFightSideRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsSidesCreate(fightPk: string, gameMasterFightSideRequest: GameMasterFightSideRequest, options?: any): AxiosPromise<GameMasterFightSide> {
            return localVarFp.gamemasterFightsSidesCreate(fightPk, gameMasterFightSideRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {string} id A UUID string identifying this fight side.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsSidesDestroy(fightPk: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.gamemasterFightsSidesDestroy(fightPk, id, options).then((request) => request(axios, basePath));
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsSidesList(fightPk: string, options?: any): AxiosPromise<Array<GameMasterFightSide>> {
            return localVarFp.gamemasterFightsSidesList(fightPk, options).then((request) => request(axios, basePath));
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {string} id A UUID string identifying this fight side.
         * @param {PatchedGameMasterFightSideRequest} [patchedGameMasterFightSideRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsSidesPartialUpdate(fightPk: string, id: string, patchedGameMasterFightSideRequest?: PatchedGameMasterFightSideRequest, options?: any): AxiosPromise<GameMasterFightSide> {
            return localVarFp.gamemasterFightsSidesPartialUpdate(fightPk, id, patchedGameMasterFightSideRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
         * @param {string} fightPk 
         * @param {string} id A UUID string identifying this fight side.
         * @param {GameMasterFightSideRequest} gameMasterFightSideRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsSidesUpdate(fightPk: string, id: string, gameMasterFightSideRequest: GameMasterFightSideRequest, options?: any): AxiosPromise<GameMasterFightSide> {
            return localVarFp.gamemasterFightsSidesUpdate(fightPk, id, gameMasterFightSideRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Stop all active fights, optionally filtered by position or character.  This action forces multiple fights to close using the same service layer logic as system-initiated fight closures.  Args:     position_id (optional): Only stop fights at this position     character_id (optional): Only stop fights involving this character     reason (optional): Reason for stopping the fights (default: \"Mass stopped by Game Master\")  Returns:     Summary of stopped fights including counts and IDs
         * @param {StopAllFightsRequest} [stopAllFightsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsStopAllFightsCreate(stopAllFightsRequest?: StopAllFightsRequest, options?: any): AxiosPromise<StopAllFights> {
            return localVarFp.gamemasterFightsStopAllFightsCreate(stopAllFightsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Stop a fight manually as GameMaster
         * @param {string} id A UUID string identifying this fight.
         * @param {StopFightRequest} [stopFightRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsStopFightCreate(id: string, stopFightRequest?: StopFightRequest, options?: any): AxiosPromise<StopFightResponse> {
            return localVarFp.gamemasterFightsStopFightCreate(id, stopFightRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Run one pass of the fight worker by hand.  Everything the loop would do on a single tick: expire overdue phase deadlines, end the turns of stragglers, advance fights whose participants have all acked, close fights on inactivity or the round limit, rescue a fight whose clock never started, and expire stale duel invitations — across every sealed fight that is owing one.  For a specific fight that is not yet owing anything, use ``advance_phase`` on it instead.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterFightsTickCreate(options?: any): AxiosPromise<GameMasterFightClockResult> {
            return localVarFp.gamemasterFightsTickCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * Clone a game object.
         * @param {string} id A UUID string identifying this game object.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsCloneCreate(id: string, gameObjectRequest: GameObjectRequest, options?: any): AxiosPromise<GameObject> {
            return localVarFp.gamemasterGameObjectsCloneCreate(id, gameObjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsCreate(gameObjectRequest: GameObjectRequest, options?: any): AxiosPromise<GameObject> {
            return localVarFp.gamemasterGameObjectsCreate(gameObjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} id A UUID string identifying this game object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.gamemasterGameObjectsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} [campaign] 
         * @param {number} [dimension] 
         * @param {boolean} [isActive] 
         * @param {string} [objectType] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [positionGridZ] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsList(campaign?: string, dimension?: number, isActive?: boolean, objectType?: string, ordering?: string, positionGridZ?: number, options?: any): AxiosPromise<Array<GameObject>> {
            return localVarFp.gamemasterGameObjectsList(campaign, dimension, isActive, objectType, ordering, positionGridZ, options).then((request) => request(axios, basePath));
        },
        /**
         * Move a game object to a new position.
         * @param {string} id A UUID string identifying this game object.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsMoveCreate(id: string, gameObjectRequest: GameObjectRequest, options?: any): AxiosPromise<GameObject> {
            return localVarFp.gamemasterGameObjectsMoveCreate(id, gameObjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} id A UUID string identifying this game object.
         * @param {PatchedGameObjectRequest} [patchedGameObjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsPartialUpdate(id: string, patchedGameObjectRequest?: PatchedGameObjectRequest, options?: any): AxiosPromise<GameObject> {
            return localVarFp.gamemasterGameObjectsPartialUpdate(id, patchedGameObjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} id A UUID string identifying this game object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsRetrieve(id: string, options?: any): AxiosPromise<GameObject> {
            return localVarFp.gamemasterGameObjectsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle the active status of a game object.
         * @param {string} id A UUID string identifying this game object.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsToggleActiveCreate(id: string, gameObjectRequest: GameObjectRequest, options?: any): AxiosPromise<GameObject> {
            return localVarFp.gamemasterGameObjectsToggleActiveCreate(id, gameObjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
         * @param {string} id A UUID string identifying this game object.
         * @param {GameObjectRequest} gameObjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterGameObjectsUpdate(id: string, gameObjectRequest: GameObjectRequest, options?: any): AxiosPromise<GameObject> {
            return localVarFp.gamemasterGameObjectsUpdate(id, gameObjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a login token for a user based on a character ID
         * @param {ImpersonationRequestRequest} impersonationRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterImpersonationImpersonateCreate(impersonationRequestRequest: ImpersonationRequestRequest, options?: any): AxiosPromise<ImpersonationResponse> {
            return localVarFp.gamemasterImpersonationImpersonateCreate(impersonationRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage items. This viewset provides full CRUD operations for items.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {ItemTypeEnum} [type] * &#x60;weapon&#x60; - weapon * &#x60;armor&#x60; - armor * &#x60;artifact&#x60; - artifact * &#x60;amulet&#x60; - amulet * &#x60;material&#x60; - material * &#x60;quest&#x60; - quest * &#x60;misc&#x60; - misc * &#x60;food&#x60; - food * &#x60;rune&#x60; - rune
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterItemsList(ordering?: string, search?: string, type?: ItemTypeEnum, options?: any): AxiosPromise<Array<GameMasterItem>> {
            return localVarFp.gamemasterItemsList(ordering, search, type, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage items. This viewset provides full CRUD operations for items.
         * @param {string} id A UUID string identifying this item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterItemsRetrieve(id: string, options?: any): AxiosPromise<GameMasterItem> {
            return localVarFp.gamemasterItemsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Change the behavior of an NPC.  This action changes the behavior of the specified NPC. It requires the behavior parameter.
         * @param {string} id A UUID string identifying this character.
         * @param {PatchedNPCBehaviorRequest} [patchedNPCBehaviorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterNpcsChangeBehaviorPartialUpdate(id: string, patchedNPCBehaviorRequest?: PatchedNPCBehaviorRequest, options?: any): AxiosPromise<GameMasterCharacterInfo> {
            return localVarFp.gamemasterNpcsChangeBehaviorPartialUpdate(id, patchedNPCBehaviorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to create skills dynamically during gameplay. Provides skill factory functionality with comprehensive validation and documentation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillList(options?: any): AxiosPromise<Array<Skill>> {
            return localVarFp.gamemasterSkillList(options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows game masters to create a new skill using the skill factory service. The skill will be created with the provided data and returned in the response.
         * @summary Create a new skill
         * @param {SkillCreateRequest} skillCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillNewSkillCreate(skillCreateRequest: SkillCreateRequest, options?: any): AxiosPromise<Skill> {
            return localVarFp.gamemasterSkillNewSkillCreate(skillCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to create skills dynamically during gameplay. Provides skill factory functionality with comprehensive validation and documentation.
         * @param {number} id A unique integer value identifying this skill.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterSkillRetrieve(id: number, options?: any): AxiosPromise<Skill> {
            return localVarFp.gamemasterSkillRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all position connections, optionally filtered by grid_z.
         * @param {number} [gridZ] Filter by grid_z coordinate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapConnectionsRetrieve(gridZ?: number, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldMapConnectionsRetrieve(gridZ, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapCreate(positionRequest: PositionRequest, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldMapCreate(positionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new connection between two positions.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapCreateConnectionCreate(positionRequest: PositionRequest, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldMapCreateConnectionCreate(positionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new position and automatically connect it to nearby positions.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapCreatePositionWithConnectionsCreate(positionRequest: PositionRequest, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldMapCreatePositionWithConnectionsCreate(positionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a connection between this position and another position.
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapDeleteConnectionDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.gamemasterWorldMapDeleteConnectionDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.gamemasterWorldMapDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {number} [gridZ] 
         * @param {boolean} [isSafe] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [subLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapList(gridZ?: number, isSafe?: boolean, ordering?: string, subLocation?: string, options?: any): AxiosPromise<Array<Position>> {
            return localVarFp.gamemasterWorldMapList(gridZ, isSafe, ordering, subLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a complete map structure with positions and connections filtered by grid_z.
         * @param {number} [gridZ] Filter by grid_z coordinate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapMapRetrieve(gridZ?: number, options?: any): AxiosPromise<MapResponse> {
            return localVarFp.gamemasterWorldMapMapRetrieve(gridZ, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {string} id A UUID string identifying this position.
         * @param {PatchedPositionRequest} [patchedPositionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapPartialUpdate(id: string, patchedPositionRequest?: PatchedPositionRequest, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldMapPartialUpdate(id, patchedPositionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {string} id A UUID string identifying this position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapRetrieve(id: string, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldMapRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lock or unlock a connection between this position and another position.
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapToggleConnectionLockCreate(id: string, positionRequest: PositionRequest, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldMapToggleConnectionLockCreate(id, positionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
         * @param {string} id A UUID string identifying this position.
         * @param {PositionRequest} positionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamemasterWorldMapUpdate(id: string, positionRequest: PositionRequest, options?: any): AxiosPromise<Position> {
            return localVarFp.gamemasterWorldMapUpdate(id, positionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Spawn an item in the game world. Creates a WorldItem instance from the Item and optionally assigns it to a character.
         * @param {string} id A UUID string identifying this item.
         * @param {SpawnItemRequest} [spawnItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spawnItem(id: string, spawnItemRequest?: SpawnItemRequest, options?: any): AxiosPromise<WorldItem> {
            return localVarFp.spawnItem(id, spawnItemRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GamemasterApi - object-oriented interface
 * @export
 * @class GamemasterApi
 * @extends {BaseAPI}
 */
export class GamemasterApi extends BaseAPI {
    /**
     * The Game Master campaign builder API.  Every endpoint resolves its campaign from the URL\'s `pk` via `get_object()` — never from `request.user.current_campaign` — and `IsCampaignMasterOrSuperuser` object-checks that the requesting admin is one of that campaign\'s masters. All business logic is delegated to `apps.game.services.campaign.*`; this view only validates input shape and translates service exceptions into HTTP responses.  Each concern (basics, map, NPCs, objectives, members, publishing) lives in its own mixin module alongside this file; this class only composes them and carries the attributes shared across all of them.
     * @param {string} id A UUID string identifying this campaign.
     * @param {CampaignBasicsUpdateRequest} [campaignBasicsUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCampaignsUpdate(id: string, campaignBasicsUpdateRequest?: CampaignBasicsUpdateRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCampaignsUpdate(id, campaignBasicsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new challenge for a character
     * @summary Create Challenge
     * @param {GameMasterCreateChallengeRequest} gameMasterCreateChallengeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterChallengesCreateCreate(gameMasterCreateChallengeRequest: GameMasterCreateChallengeRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterChallengesCreateCreate(gameMasterCreateChallengeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for GameMasters to create and manage challenges for characters.  This viewset provides functionality for GameMasters to: - Create new challenges for characters - View existing challenges - Configure challenge parameters including difficulty, dice, modifiers, and advantage/disadvantage  The challenge creation process includes business logic that automatically adds modifiers based on character state, stats, effects, skills, and items.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterChallengesList(options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterChallengesList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for GameMasters to create and manage challenges for characters.  This viewset provides functionality for GameMasters to: - Create new challenges for characters - View existing challenges - Configure challenge parameters including difficulty, dice, modifiers, and advantage/disadvantage  The challenge creation process includes business logic that automatically adds modifiers based on character state, stats, effects, skills, and items.
     * @param {string} id A UUID string identifying this challenge.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterChallengesRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterChallengesRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns list of GM\'s own characters and NPCs at specified or current position. Use position_id query parameter to filter characters by specific position.
     * @summary Get available characters for GM impersonation
     * @param {string} [positionId] Filter characters by position ID. If not provided, returns NPCs at current position and all GM characters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharacterSwitchAvailableCharactersList(positionId?: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharacterSwitchAvailableCharactersList(positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Switch GM\'s main character to a different character. Updates Client.main_character in database.
     * @param {GMCharacterSwitchRequestRequest} gMCharacterSwitchRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharacterSwitchSwitchCharacterCreate(gMCharacterSwitchRequestRequest: GMCharacterSwitchRequestRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharacterSwitchSwitchCharacterCreate(gMCharacterSwitchRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an NPC from a template.  This action creates a new NPC based on the specified template and position. It requires template_id and position_id parameters.
     * @param {CreateNPCFromTemplateRequest} createNPCFromTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharacterTemplatesCreateNpcCreate(createNPCFromTemplateRequest: CreateNPCFromTemplateRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharacterTemplatesCreateNpcCreate(createNPCFromTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export a character template as JSON. Game Master access only.
     * @summary Export Character Template
     * @param {string} id A UUID string identifying this Character Template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharacterTemplatesExportTemplateRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharacterTemplatesExportTemplateRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to view character templates and create NPCs from them.  This viewset provides read-only operations for character templates and an action to create NPCs from templates.
     * @param {BehaviorEnum} [behavior] * &#x60;Passive&#x60; - Passive * &#x60;Aggressive&#x60; - Aggressive * &#x60;Friendly&#x60; - Friendly
     * @param {number} [dimension] 
     * @param {string} [name] 
     * @param {string} [organization] 
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [path] 
     * @param {string} [rank] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharacterTemplatesList(behavior?: BehaviorEnum, dimension?: number, name?: string, organization?: string, page?: number, pageSize?: number, path?: string, rank?: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharacterTemplatesList(behavior, dimension, name, organization, page, pageSize, path, rank, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow to se what NPC will be created from the template.
     * @summary Preview Character Template
     * @param {string} id A UUID string identifying this Character Template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharacterTemplatesPreviewRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharacterTemplatesPreviewRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to view character templates and create NPCs from them.  This viewset provides read-only operations for character templates and an action to create NPCs from templates.
     * @param {string} id A UUID string identifying this Character Template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharacterTemplatesRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharacterTemplatesRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set how much room a character\'s body takes on the tactical grid
     * @param {string} id A UUID string identifying this character.
     * @param {PatchedCharacterTacticalSizeRequest} [patchedCharacterTacticalSizeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharactersChangeTacticalSizePartialUpdate(id: string, patchedCharacterTacticalSizeRequest?: PatchedCharacterTacticalSizeRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharactersChangeTacticalSizePartialUpdate(id, patchedCharacterTacticalSizeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get character information for the GameMasterCharacterCard component
     * @param {string} id A UUID string identifying this character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharactersCharacterCardRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharactersCharacterCardRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed information about a character.
     * @param {string} id A UUID string identifying this character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharactersCharacterInfoRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharactersCharacterInfoRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get character stats for the GameMasterCharacterStatsCard component
     * @param {string} id A UUID string identifying this character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharactersCharacterStatsCardRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharactersCharacterStatsCardRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get character stats.
     * @param {string} id A UUID string identifying this character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharactersCharacterStatsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharactersCharacterStatsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign a character with Flow, or release it. A signed character acts under game master authority and is marked as such on every screen.
     * @param {string} id A UUID string identifying this character.
     * @param {PatchedCharacterGameMasterModeRequest} [patchedCharacterGameMasterModeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharactersGameMasterModePartialUpdate(id: string, patchedCharacterGameMasterModeRequest?: PatchedCharacterGameMasterModeRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharactersGameMasterModePartialUpdate(id, patchedCharacterGameMasterModeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Perform a god intervention on a character.  This action allows game masters to apply a god intervention effect to a character, which can include stat modifications, effects, or other game mechanics.  The request should contain the necessary parameters for the intervention.
     * @param {string} id A UUID string identifying this character.
     * @param {GodInterventionRequest} godInterventionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharactersGodInterventionCreate(id: string, godInterventionRequest: GodInterventionRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharactersGodInterventionCreate(id, godInterventionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage characters. This viewset provides full CRUD operations for characters.
     * @param {boolean} [npc] 
     * @param {string} [position] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharactersList(npc?: boolean, position?: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharactersList(npc, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage characters. This viewset provides full CRUD operations for characters.
     * @param {string} id A UUID string identifying this character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCharactersRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCharactersRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Advance the world clock by N phases or N cycles.  Defaults to a single phase, which is the smallest useful step and the one a debugging session wants most of the time.
     * @param {CycleAdvanceRequestRequest} [cycleAdvanceRequestRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCyclesAdvanceCreate(cycleAdvanceRequestRequest?: CycleAdvanceRequestRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCyclesAdvanceCreate(cycleAdvanceRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Where the world clock stands, and whether anything is driving it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterCyclesCurrentRetrieve(options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterCyclesCurrentRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stop all active fights (optionally filtered by position or character)
     * @param {string} id A UUID string identifying this fight.
     * @param {StopAllFightsRequest} [stopAllFightsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsAdvancePhaseCreate(id: string, stopAllFightsRequest?: StopAllFightsRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsAdvancePhaseCreate(id, stopAllFightsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for GameMasters to manage fights.  Provides: - List and retrieve fights (with filtering by position_id and character_id) - Custom action to stop fights
     * @param {number} [characterId] 
     * @param {boolean} [duel] 
     * @param {boolean} [open] 
     * @param {number} [positionId] 
     * @param {boolean} [sealed] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsList(characterId?: number, duel?: boolean, open?: boolean, positionId?: number, sealed?: boolean, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsList(characterId, duel, open, positionId, sealed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ``/gamemaster/fights/{fight_pk}/participants/{character_id}/`` — move a participant to a different side of the same fight.
     * @param {string} fightPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsParticipantsList(fightPk: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsParticipantsList(fightPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ``/gamemaster/fights/{fight_pk}/participants/{character_id}/`` — move a participant to a different side of the same fight.
     * @param {string} characterId 
     * @param {string} fightPk 
     * @param {PatchedGameMasterFightParticipantMoveRequest} [patchedGameMasterFightParticipantMoveRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsParticipantsPartialUpdate(characterId: string, fightPk: string, patchedGameMasterFightParticipantMoveRequest?: PatchedGameMasterFightParticipantMoveRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsParticipantsPartialUpdate(characterId, fightPk, patchedGameMasterFightParticipantMoveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ``/gamemaster/fights/{fight_pk}/participants/{character_id}/`` — move a participant to a different side of the same fight.
     * @param {string} characterId 
     * @param {string} fightPk 
     * @param {GameMasterFightParticipantMoveRequest} gameMasterFightParticipantMoveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsParticipantsUpdate(characterId: string, fightPk: string, gameMasterFightParticipantMoveRequest: GameMasterFightParticipantMoveRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsParticipantsUpdate(characterId, fightPk, gameMasterFightParticipantMoveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for GameMasters to manage fights.  Provides: - List and retrieve fights (with filtering by position_id and character_id) - Custom action to stop fights
     * @param {string} id A UUID string identifying this fight.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
     * @param {string} fightPk 
     * @param {GameMasterFightSideRequest} gameMasterFightSideRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsSidesCreate(fightPk: string, gameMasterFightSideRequest: GameMasterFightSideRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsSidesCreate(fightPk, gameMasterFightSideRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
     * @param {string} fightPk 
     * @param {string} id A UUID string identifying this fight side.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsSidesDestroy(fightPk: string, id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsSidesDestroy(fightPk, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
     * @param {string} fightPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsSidesList(fightPk: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsSidesList(fightPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
     * @param {string} fightPk 
     * @param {string} id A UUID string identifying this fight side.
     * @param {PatchedGameMasterFightSideRequest} [patchedGameMasterFightSideRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsSidesPartialUpdate(fightPk: string, id: string, patchedGameMasterFightSideRequest?: PatchedGameMasterFightSideRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsSidesPartialUpdate(fightPk, id, patchedGameMasterFightSideRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ``/gamemaster/fights/{fight_pk}/sides/`` — create, rename, delete.  Every write is immediate and mid-round safe (docs/specs/tactical-combat/ 01-sides.md §Game Master control): side membership is read only at quorum tally, at close, and at vision computation, never mid-action.
     * @param {string} fightPk 
     * @param {string} id A UUID string identifying this fight side.
     * @param {GameMasterFightSideRequest} gameMasterFightSideRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsSidesUpdate(fightPk: string, id: string, gameMasterFightSideRequest: GameMasterFightSideRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsSidesUpdate(fightPk, id, gameMasterFightSideRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stop all active fights, optionally filtered by position or character.  This action forces multiple fights to close using the same service layer logic as system-initiated fight closures.  Args:     position_id (optional): Only stop fights at this position     character_id (optional): Only stop fights involving this character     reason (optional): Reason for stopping the fights (default: \"Mass stopped by Game Master\")  Returns:     Summary of stopped fights including counts and IDs
     * @param {StopAllFightsRequest} [stopAllFightsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsStopAllFightsCreate(stopAllFightsRequest?: StopAllFightsRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsStopAllFightsCreate(stopAllFightsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stop a fight manually as GameMaster
     * @param {string} id A UUID string identifying this fight.
     * @param {StopFightRequest} [stopFightRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsStopFightCreate(id: string, stopFightRequest?: StopFightRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsStopFightCreate(id, stopFightRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run one pass of the fight worker by hand.  Everything the loop would do on a single tick: expire overdue phase deadlines, end the turns of stragglers, advance fights whose participants have all acked, close fights on inactivity or the round limit, rescue a fight whose clock never started, and expire stale duel invitations — across every sealed fight that is owing one.  For a specific fight that is not yet owing anything, use ``advance_phase`` on it instead.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterFightsTickCreate(options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterFightsTickCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clone a game object.
     * @param {string} id A UUID string identifying this game object.
     * @param {GameObjectRequest} gameObjectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterGameObjectsCloneCreate(id: string, gameObjectRequest: GameObjectRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterGameObjectsCloneCreate(id, gameObjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
     * @param {GameObjectRequest} gameObjectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterGameObjectsCreate(gameObjectRequest: GameObjectRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterGameObjectsCreate(gameObjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
     * @param {string} id A UUID string identifying this game object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterGameObjectsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterGameObjectsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
     * @param {string} [campaign] 
     * @param {number} [dimension] 
     * @param {boolean} [isActive] 
     * @param {string} [objectType] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [positionGridZ] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterGameObjectsList(campaign?: string, dimension?: number, isActive?: boolean, objectType?: string, ordering?: string, positionGridZ?: number, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterGameObjectsList(campaign, dimension, isActive, objectType, ordering, positionGridZ, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Move a game object to a new position.
     * @param {string} id A UUID string identifying this game object.
     * @param {GameObjectRequest} gameObjectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterGameObjectsMoveCreate(id: string, gameObjectRequest: GameObjectRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterGameObjectsMoveCreate(id, gameObjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
     * @param {string} id A UUID string identifying this game object.
     * @param {PatchedGameObjectRequest} [patchedGameObjectRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterGameObjectsPartialUpdate(id: string, patchedGameObjectRequest?: PatchedGameObjectRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterGameObjectsPartialUpdate(id, patchedGameObjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
     * @param {string} id A UUID string identifying this game object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterGameObjectsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterGameObjectsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle the active status of a game object.
     * @param {string} id A UUID string identifying this game object.
     * @param {GameObjectRequest} gameObjectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterGameObjectsToggleActiveCreate(id: string, gameObjectRequest: GameObjectRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterGameObjectsToggleActiveCreate(id, gameObjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage game objects. This viewset provides operations for listing, retrieving, creating, updating, and deleting game objects. It also provides custom actions for moving, cloning, and disabling/enabling game objects.
     * @param {string} id A UUID string identifying this game object.
     * @param {GameObjectRequest} gameObjectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterGameObjectsUpdate(id: string, gameObjectRequest: GameObjectRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterGameObjectsUpdate(id, gameObjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a login token for a user based on a character ID
     * @param {ImpersonationRequestRequest} impersonationRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterImpersonationImpersonateCreate(impersonationRequestRequest: ImpersonationRequestRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterImpersonationImpersonateCreate(impersonationRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage items. This viewset provides full CRUD operations for items.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {ItemTypeEnum} [type] * &#x60;weapon&#x60; - weapon * &#x60;armor&#x60; - armor * &#x60;artifact&#x60; - artifact * &#x60;amulet&#x60; - amulet * &#x60;material&#x60; - material * &#x60;quest&#x60; - quest * &#x60;misc&#x60; - misc * &#x60;food&#x60; - food * &#x60;rune&#x60; - rune
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterItemsList(ordering?: string, search?: string, type?: ItemTypeEnum, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterItemsList(ordering, search, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage items. This viewset provides full CRUD operations for items.
     * @param {string} id A UUID string identifying this item.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterItemsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterItemsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change the behavior of an NPC.  This action changes the behavior of the specified NPC. It requires the behavior parameter.
     * @param {string} id A UUID string identifying this character.
     * @param {PatchedNPCBehaviorRequest} [patchedNPCBehaviorRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterNpcsChangeBehaviorPartialUpdate(id: string, patchedNPCBehaviorRequest?: PatchedNPCBehaviorRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterNpcsChangeBehaviorPartialUpdate(id, patchedNPCBehaviorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to create skills dynamically during gameplay. Provides skill factory functionality with comprehensive validation and documentation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterSkillList(options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterSkillList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint allows game masters to create a new skill using the skill factory service. The skill will be created with the provided data and returned in the response.
     * @summary Create a new skill
     * @param {SkillCreateRequest} skillCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterSkillNewSkillCreate(skillCreateRequest: SkillCreateRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterSkillNewSkillCreate(skillCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to create skills dynamically during gameplay. Provides skill factory functionality with comprehensive validation and documentation.
     * @param {number} id A unique integer value identifying this skill.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterSkillRetrieve(id: number, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterSkillRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all position connections, optionally filtered by grid_z.
     * @param {number} [gridZ] Filter by grid_z coordinate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterWorldMapConnectionsRetrieve(gridZ?: number, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterWorldMapConnectionsRetrieve(gridZ, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
     * @param {PositionRequest} positionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterWorldMapCreate(positionRequest: PositionRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterWorldMapCreate(positionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new connection between two positions.
     * @param {PositionRequest} positionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterWorldMapCreateConnectionCreate(positionRequest: PositionRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterWorldMapCreateConnectionCreate(positionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new position and automatically connect it to nearby positions.
     * @param {PositionRequest} positionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterWorldMapCreatePositionWithConnectionsCreate(positionRequest: PositionRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterWorldMapCreatePositionWithConnectionsCreate(positionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a connection between this position and another position.
     * @param {string} id A UUID string identifying this position.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterWorldMapDeleteConnectionDestroy(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterWorldMapDeleteConnectionDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
     * @param {string} id A UUID string identifying this position.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterWorldMapDestroy(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterWorldMapDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
     * @param {number} [gridZ] 
     * @param {boolean} [isSafe] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [subLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterWorldMapList(gridZ?: number, isSafe?: boolean, ordering?: string, subLocation?: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterWorldMapList(gridZ, isSafe, ordering, subLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a complete map structure with positions and connections filtered by grid_z.
     * @param {number} [gridZ] Filter by grid_z coordinate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterWorldMapMapRetrieve(gridZ?: number, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterWorldMapMapRetrieve(gridZ, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
     * @param {string} id A UUID string identifying this position.
     * @param {PatchedPositionRequest} [patchedPositionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterWorldMapPartialUpdate(id: string, patchedPositionRequest?: PatchedPositionRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterWorldMapPartialUpdate(id, patchedPositionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
     * @param {string} id A UUID string identifying this position.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterWorldMapRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterWorldMapRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lock or unlock a connection between this position and another position.
     * @param {string} id A UUID string identifying this position.
     * @param {PositionRequest} positionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterWorldMapToggleConnectionLockCreate(id: string, positionRequest: PositionRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterWorldMapToggleConnectionLockCreate(id, positionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage the world map.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting positions - Filtering positions by grid_z - Managing position connections - Creating positions with automatic connections to nearby positions - Locking/unlocking connections
     * @param {string} id A UUID string identifying this position.
     * @param {PositionRequest} positionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public gamemasterWorldMapUpdate(id: string, positionRequest: PositionRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).gamemasterWorldMapUpdate(id, positionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Spawn an item in the game world. Creates a WorldItem instance from the Item and optionally assigns it to a character.
     * @param {string} id A UUID string identifying this item.
     * @param {SpawnItemRequest} [spawnItemRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamemasterApi
     */
    public spawnItem(id: string, spawnItemRequest?: SpawnItemRequest, options?: RawAxiosRequestConfig) {
        return GamemasterApiFp(this.configuration).spawnItem(id, spawnItemRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ItemsApi - axios parameter creator
 * @export
 */
export const ItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsCharacterList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/items/character/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsCharacterRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemsCharacterRetrieve', 'id', id)
            const localVarPath = `/api/items/character/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WorldItemRequest} worldItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsWorldCreate: async (worldItemRequest: WorldItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'worldItemRequest' is not null or undefined
            assertParamExists('itemsWorldCreate', 'worldItemRequest', worldItemRequest)
            const localVarPath = `/api/items/world/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(worldItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this world item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsWorldDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemsWorldDestroy', 'id', id)
            const localVarPath = `/api/items/world/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsWorldList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/items/world/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this world item.
         * @param {PatchedWorldItemRequest} [patchedWorldItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsWorldPartialUpdate: async (id: string, patchedWorldItemRequest?: PatchedWorldItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemsWorldPartialUpdate', 'id', id)
            const localVarPath = `/api/items/world/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedWorldItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this world item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsWorldRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemsWorldRetrieve', 'id', id)
            const localVarPath = `/api/items/world/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this world item.
         * @param {WorldItemRequest} worldItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsWorldUpdate: async (id: string, worldItemRequest: WorldItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemsWorldUpdate', 'id', id)
            // verify required parameter 'worldItemRequest' is not null or undefined
            assertParamExists('itemsWorldUpdate', 'worldItemRequest', worldItemRequest)
            const localVarPath = `/api/items/world/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(worldItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Spawn an item in the game world. Creates a WorldItem instance from the Item and optionally assigns it to a character.
         * @param {string} id A UUID string identifying this item.
         * @param {SpawnItemRequest} [spawnItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spawnItem: async (id: string, spawnItemRequest?: SpawnItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('spawnItem', 'id', id)
            const localVarPath = `/api/gamemaster/items/{id}/spawn_item/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(spawnItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ItemsApi - functional programming interface
 * @export
 */
export const ItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemsCharacterList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CharacterItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemsCharacterList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemsApi.itemsCharacterList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemsCharacterRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemsCharacterRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemsApi.itemsCharacterRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WorldItemRequest} worldItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemsWorldCreate(worldItemRequest: WorldItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorldItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemsWorldCreate(worldItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemsApi.itemsWorldCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this world item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemsWorldDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemsWorldDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemsApi.itemsWorldDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemsWorldList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorldItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemsWorldList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemsApi.itemsWorldList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this world item.
         * @param {PatchedWorldItemRequest} [patchedWorldItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemsWorldPartialUpdate(id: string, patchedWorldItemRequest?: PatchedWorldItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorldItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemsWorldPartialUpdate(id, patchedWorldItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemsApi.itemsWorldPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this world item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemsWorldRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorldItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemsWorldRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemsApi.itemsWorldRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this world item.
         * @param {WorldItemRequest} worldItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemsWorldUpdate(id: string, worldItemRequest: WorldItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorldItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemsWorldUpdate(id, worldItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemsApi.itemsWorldUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Spawn an item in the game world. Creates a WorldItem instance from the Item and optionally assigns it to a character.
         * @param {string} id A UUID string identifying this item.
         * @param {SpawnItemRequest} [spawnItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async spawnItem(id: string, spawnItemRequest?: SpawnItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorldItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.spawnItem(id, spawnItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemsApi.spawnItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ItemsApi - factory interface
 * @export
 */
export const ItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ItemsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsCharacterList(options?: any): AxiosPromise<Array<CharacterItem>> {
            return localVarFp.itemsCharacterList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsCharacterRetrieve(id: string, options?: any): AxiosPromise<CharacterItem> {
            return localVarFp.itemsCharacterRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorldItemRequest} worldItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsWorldCreate(worldItemRequest: WorldItemRequest, options?: any): AxiosPromise<WorldItem> {
            return localVarFp.itemsWorldCreate(worldItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this world item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsWorldDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.itemsWorldDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsWorldList(options?: any): AxiosPromise<Array<WorldItem>> {
            return localVarFp.itemsWorldList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this world item.
         * @param {PatchedWorldItemRequest} [patchedWorldItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsWorldPartialUpdate(id: string, patchedWorldItemRequest?: PatchedWorldItemRequest, options?: any): AxiosPromise<WorldItem> {
            return localVarFp.itemsWorldPartialUpdate(id, patchedWorldItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this world item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsWorldRetrieve(id: string, options?: any): AxiosPromise<WorldItem> {
            return localVarFp.itemsWorldRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this world item.
         * @param {WorldItemRequest} worldItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsWorldUpdate(id: string, worldItemRequest: WorldItemRequest, options?: any): AxiosPromise<WorldItem> {
            return localVarFp.itemsWorldUpdate(id, worldItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Spawn an item in the game world. Creates a WorldItem instance from the Item and optionally assigns it to a character.
         * @param {string} id A UUID string identifying this item.
         * @param {SpawnItemRequest} [spawnItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spawnItem(id: string, spawnItemRequest?: SpawnItemRequest, options?: any): AxiosPromise<WorldItem> {
            return localVarFp.spawnItem(id, spawnItemRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ItemsApi - object-oriented interface
 * @export
 * @class ItemsApi
 * @extends {BaseAPI}
 */
export class ItemsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemsApi
     */
    public itemsCharacterList(options?: RawAxiosRequestConfig) {
        return ItemsApiFp(this.configuration).itemsCharacterList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character item.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemsApi
     */
    public itemsCharacterRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return ItemsApiFp(this.configuration).itemsCharacterRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorldItemRequest} worldItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemsApi
     */
    public itemsWorldCreate(worldItemRequest: WorldItemRequest, options?: RawAxiosRequestConfig) {
        return ItemsApiFp(this.configuration).itemsWorldCreate(worldItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this world item.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemsApi
     */
    public itemsWorldDestroy(id: string, options?: RawAxiosRequestConfig) {
        return ItemsApiFp(this.configuration).itemsWorldDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemsApi
     */
    public itemsWorldList(options?: RawAxiosRequestConfig) {
        return ItemsApiFp(this.configuration).itemsWorldList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this world item.
     * @param {PatchedWorldItemRequest} [patchedWorldItemRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemsApi
     */
    public itemsWorldPartialUpdate(id: string, patchedWorldItemRequest?: PatchedWorldItemRequest, options?: RawAxiosRequestConfig) {
        return ItemsApiFp(this.configuration).itemsWorldPartialUpdate(id, patchedWorldItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this world item.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemsApi
     */
    public itemsWorldRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return ItemsApiFp(this.configuration).itemsWorldRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this world item.
     * @param {WorldItemRequest} worldItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemsApi
     */
    public itemsWorldUpdate(id: string, worldItemRequest: WorldItemRequest, options?: RawAxiosRequestConfig) {
        return ItemsApiFp(this.configuration).itemsWorldUpdate(id, worldItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Spawn an item in the game world. Creates a WorldItem instance from the Item and optionally assigns it to a character.
     * @param {string} id A UUID string identifying this item.
     * @param {SpawnItemRequest} [spawnItemRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemsApi
     */
    public spawnItem(id: string, spawnItemRequest?: SpawnItemRequest, options?: RawAxiosRequestConfig) {
        return ItemsApiFp(this.configuration).spawnItem(id, spawnItemRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KnowledgeBaseDocumentsApi - axios parameter creator
 * @export
 */
export const KnowledgeBaseDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new knowledge base document. Requires admin privileges. You can optionally assign categories to the document.
         * @summary Create a new document
         * @param {DocumentRequest} documentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseDocumentsCreate: async (documentRequest: DocumentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentRequest' is not null or undefined
            assertParamExists('knowledgeBaseDocumentsCreate', 'documentRequest', documentRequest)
            const localVarPath = `/api/knowledge-base/documents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a knowledge base document. Requires admin privileges. This will also delete all associated timeline events.
         * @summary Delete a document
         * @param {string} id A UUID string identifying this document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseDocumentsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('knowledgeBaseDocumentsDestroy', 'id', id)
            const localVarPath = `/api/knowledge-base/documents/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all knowledge base documents. Supports filtering by title, content, and categories. Supports searching across title and content fields. Supports ordering by id, title, created_at, and updated_at.
         * @summary List all documents
         * @param {string} [categories] Filter by category name (exact match)
         * @param {string} [content] Filter by content (case-insensitive partial match)
         * @param {string} [ordering] Order results by field (prefix with - for descending)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search across title and content fields
         * @param {string} [title] Filter by title (case-insensitive partial match)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseDocumentsList: async (categories?: string, content?: string, ordering?: string, page?: number, pageSize?: number, search?: string, title?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/knowledge-base/documents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categories !== undefined) {
                localVarQueryParameter['categories'] = categories;
            }

            if (content !== undefined) {
                localVarQueryParameter['content'] = content;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update specific fields of an existing knowledge base document. Requires admin privileges.
         * @summary Partially update a document
         * @param {string} id A UUID string identifying this document.
         * @param {PatchedDocumentRequest} [patchedDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseDocumentsPartialUpdate: async (id: string, patchedDocumentRequest?: PatchedDocumentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('knowledgeBaseDocumentsPartialUpdate', 'id', id)
            const localVarPath = `/api/knowledge-base/documents/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedDocumentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed information about a specific knowledge base document by its ID.
         * @summary Retrieve a document
         * @param {string} id A UUID string identifying this document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseDocumentsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('knowledgeBaseDocumentsRetrieve', 'id', id)
            const localVarPath = `/api/knowledge-base/documents/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update all fields of an existing knowledge base document. Requires admin privileges.
         * @summary Update a document
         * @param {string} id A UUID string identifying this document.
         * @param {DocumentRequest} documentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseDocumentsUpdate: async (id: string, documentRequest: DocumentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('knowledgeBaseDocumentsUpdate', 'id', id)
            // verify required parameter 'documentRequest' is not null or undefined
            assertParamExists('knowledgeBaseDocumentsUpdate', 'documentRequest', documentRequest)
            const localVarPath = `/api/knowledge-base/documents/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KnowledgeBaseDocumentsApi - functional programming interface
 * @export
 */
export const KnowledgeBaseDocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KnowledgeBaseDocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new knowledge base document. Requires admin privileges. You can optionally assign categories to the document.
         * @summary Create a new document
         * @param {DocumentRequest} documentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async knowledgeBaseDocumentsCreate(documentRequest: DocumentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.knowledgeBaseDocumentsCreate(documentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseDocumentsApi.knowledgeBaseDocumentsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a knowledge base document. Requires admin privileges. This will also delete all associated timeline events.
         * @summary Delete a document
         * @param {string} id A UUID string identifying this document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async knowledgeBaseDocumentsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.knowledgeBaseDocumentsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseDocumentsApi.knowledgeBaseDocumentsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all knowledge base documents. Supports filtering by title, content, and categories. Supports searching across title and content fields. Supports ordering by id, title, created_at, and updated_at.
         * @summary List all documents
         * @param {string} [categories] Filter by category name (exact match)
         * @param {string} [content] Filter by content (case-insensitive partial match)
         * @param {string} [ordering] Order results by field (prefix with - for descending)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search across title and content fields
         * @param {string} [title] Filter by title (case-insensitive partial match)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async knowledgeBaseDocumentsList(categories?: string, content?: string, ordering?: string, page?: number, pageSize?: number, search?: string, title?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDocumentList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.knowledgeBaseDocumentsList(categories, content, ordering, page, pageSize, search, title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseDocumentsApi.knowledgeBaseDocumentsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update specific fields of an existing knowledge base document. Requires admin privileges.
         * @summary Partially update a document
         * @param {string} id A UUID string identifying this document.
         * @param {PatchedDocumentRequest} [patchedDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async knowledgeBaseDocumentsPartialUpdate(id: string, patchedDocumentRequest?: PatchedDocumentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.knowledgeBaseDocumentsPartialUpdate(id, patchedDocumentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseDocumentsApi.knowledgeBaseDocumentsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed information about a specific knowledge base document by its ID.
         * @summary Retrieve a document
         * @param {string} id A UUID string identifying this document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async knowledgeBaseDocumentsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.knowledgeBaseDocumentsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseDocumentsApi.knowledgeBaseDocumentsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update all fields of an existing knowledge base document. Requires admin privileges.
         * @summary Update a document
         * @param {string} id A UUID string identifying this document.
         * @param {DocumentRequest} documentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async knowledgeBaseDocumentsUpdate(id: string, documentRequest: DocumentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.knowledgeBaseDocumentsUpdate(id, documentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseDocumentsApi.knowledgeBaseDocumentsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KnowledgeBaseDocumentsApi - factory interface
 * @export
 */
export const KnowledgeBaseDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KnowledgeBaseDocumentsApiFp(configuration)
    return {
        /**
         * Create a new knowledge base document. Requires admin privileges. You can optionally assign categories to the document.
         * @summary Create a new document
         * @param {DocumentRequest} documentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseDocumentsCreate(documentRequest: DocumentRequest, options?: any): AxiosPromise<Document> {
            return localVarFp.knowledgeBaseDocumentsCreate(documentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a knowledge base document. Requires admin privileges. This will also delete all associated timeline events.
         * @summary Delete a document
         * @param {string} id A UUID string identifying this document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseDocumentsDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.knowledgeBaseDocumentsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all knowledge base documents. Supports filtering by title, content, and categories. Supports searching across title and content fields. Supports ordering by id, title, created_at, and updated_at.
         * @summary List all documents
         * @param {string} [categories] Filter by category name (exact match)
         * @param {string} [content] Filter by content (case-insensitive partial match)
         * @param {string} [ordering] Order results by field (prefix with - for descending)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search across title and content fields
         * @param {string} [title] Filter by title (case-insensitive partial match)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseDocumentsList(categories?: string, content?: string, ordering?: string, page?: number, pageSize?: number, search?: string, title?: string, options?: any): AxiosPromise<PaginatedDocumentList> {
            return localVarFp.knowledgeBaseDocumentsList(categories, content, ordering, page, pageSize, search, title, options).then((request) => request(axios, basePath));
        },
        /**
         * Update specific fields of an existing knowledge base document. Requires admin privileges.
         * @summary Partially update a document
         * @param {string} id A UUID string identifying this document.
         * @param {PatchedDocumentRequest} [patchedDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseDocumentsPartialUpdate(id: string, patchedDocumentRequest?: PatchedDocumentRequest, options?: any): AxiosPromise<Document> {
            return localVarFp.knowledgeBaseDocumentsPartialUpdate(id, patchedDocumentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed information about a specific knowledge base document by its ID.
         * @summary Retrieve a document
         * @param {string} id A UUID string identifying this document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseDocumentsRetrieve(id: string, options?: any): AxiosPromise<Document> {
            return localVarFp.knowledgeBaseDocumentsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update all fields of an existing knowledge base document. Requires admin privileges.
         * @summary Update a document
         * @param {string} id A UUID string identifying this document.
         * @param {DocumentRequest} documentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseDocumentsUpdate(id: string, documentRequest: DocumentRequest, options?: any): AxiosPromise<Document> {
            return localVarFp.knowledgeBaseDocumentsUpdate(id, documentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KnowledgeBaseDocumentsApi - object-oriented interface
 * @export
 * @class KnowledgeBaseDocumentsApi
 * @extends {BaseAPI}
 */
export class KnowledgeBaseDocumentsApi extends BaseAPI {
    /**
     * Create a new knowledge base document. Requires admin privileges. You can optionally assign categories to the document.
     * @summary Create a new document
     * @param {DocumentRequest} documentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseDocumentsApi
     */
    public knowledgeBaseDocumentsCreate(documentRequest: DocumentRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseDocumentsApiFp(this.configuration).knowledgeBaseDocumentsCreate(documentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a knowledge base document. Requires admin privileges. This will also delete all associated timeline events.
     * @summary Delete a document
     * @param {string} id A UUID string identifying this document.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseDocumentsApi
     */
    public knowledgeBaseDocumentsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseDocumentsApiFp(this.configuration).knowledgeBaseDocumentsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all knowledge base documents. Supports filtering by title, content, and categories. Supports searching across title and content fields. Supports ordering by id, title, created_at, and updated_at.
     * @summary List all documents
     * @param {string} [categories] Filter by category name (exact match)
     * @param {string} [content] Filter by content (case-insensitive partial match)
     * @param {string} [ordering] Order results by field (prefix with - for descending)
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] Search across title and content fields
     * @param {string} [title] Filter by title (case-insensitive partial match)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseDocumentsApi
     */
    public knowledgeBaseDocumentsList(categories?: string, content?: string, ordering?: string, page?: number, pageSize?: number, search?: string, title?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseDocumentsApiFp(this.configuration).knowledgeBaseDocumentsList(categories, content, ordering, page, pageSize, search, title, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update specific fields of an existing knowledge base document. Requires admin privileges.
     * @summary Partially update a document
     * @param {string} id A UUID string identifying this document.
     * @param {PatchedDocumentRequest} [patchedDocumentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseDocumentsApi
     */
    public knowledgeBaseDocumentsPartialUpdate(id: string, patchedDocumentRequest?: PatchedDocumentRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseDocumentsApiFp(this.configuration).knowledgeBaseDocumentsPartialUpdate(id, patchedDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed information about a specific knowledge base document by its ID.
     * @summary Retrieve a document
     * @param {string} id A UUID string identifying this document.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseDocumentsApi
     */
    public knowledgeBaseDocumentsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseDocumentsApiFp(this.configuration).knowledgeBaseDocumentsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update all fields of an existing knowledge base document. Requires admin privileges.
     * @summary Update a document
     * @param {string} id A UUID string identifying this document.
     * @param {DocumentRequest} documentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseDocumentsApi
     */
    public knowledgeBaseDocumentsUpdate(id: string, documentRequest: DocumentRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseDocumentsApiFp(this.configuration).knowledgeBaseDocumentsUpdate(id, documentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KnowledgeBaseTimelineEventsApi - axios parameter creator
 * @export
 */
export const KnowledgeBaseTimelineEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new timeline event. Requires admin privileges. You must provide existing document_id and date_time_id.
         * @summary Create a new timeline event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/knowledge-base/timeline-events/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a timeline event. Requires admin privileges. Note: This does not delete the associated document or date_time records.
         * @summary Delete a timeline event
         * @param {string} id A UUID string identifying this Timeline Event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('knowledgeBaseTimelineEventsDestroy', 'id', id)
            const localVarPath = `/api/knowledge-base/timeline-events/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import a timeline event with nested Document and DateTimeInfo data. This action will get_or_create Document and DateTimeInfo based on the provided data, then create the TimeLineEvent linking them together. This is useful for bulk imports or migrations. Note: Image loading is not supported in this action.
         * @summary Import timeline event with nested data
         * @param {TimeLineEventImportRequest} timeLineEventImportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsImportEventCreate: async (timeLineEventImportRequest: TimeLineEventImportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeLineEventImportRequest' is not null or undefined
            assertParamExists('knowledgeBaseTimelineEventsImportEventCreate', 'timeLineEventImportRequest', timeLineEventImportRequest)
            const localVarPath = `/api/knowledge-base/timeline-events/import_event/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timeLineEventImportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all timeline events. Supports filtering by document, active_glow, solar_year, and sol. Supports searching across document title and content. Default ordering is by timeline (solar_year, sol).
         * @summary List all timeline events
         * @param {boolean} [activeGlow] Filter by active_glow (true/false)
         * @param {string} [dateTime] Filter by date_time ID
         * @param {string} [document] Filter by document ID
         * @param {string} [ordering] Order results by field (prefix with - for descending)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search across document title and content
         * @param {number} [sol] 
         * @param {number} [solGte] Filter by sol greater than or equal to value
         * @param {number} [solLte] 
         * @param {number} [solarYear] Filter by exact solar year
         * @param {number} [solarYearGte] 
         * @param {number} [solarYearLte] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsList: async (activeGlow?: boolean, dateTime?: string, document?: string, ordering?: string, page?: number, pageSize?: number, search?: string, sol?: number, solGte?: number, solLte?: number, solarYear?: number, solarYearGte?: number, solarYearLte?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/knowledge-base/timeline-events/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (activeGlow !== undefined) {
                localVarQueryParameter['active_glow'] = activeGlow;
            }

            if (dateTime !== undefined) {
                localVarQueryParameter['date_time'] = dateTime;
            }

            if (document !== undefined) {
                localVarQueryParameter['document'] = document;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sol !== undefined) {
                localVarQueryParameter['sol'] = sol;
            }

            if (solGte !== undefined) {
                localVarQueryParameter['sol_gte'] = solGte;
            }

            if (solLte !== undefined) {
                localVarQueryParameter['sol_lte'] = solLte;
            }

            if (solarYear !== undefined) {
                localVarQueryParameter['solar_year'] = solarYear;
            }

            if (solarYearGte !== undefined) {
                localVarQueryParameter['solar_year_gte'] = solarYearGte;
            }

            if (solarYearLte !== undefined) {
                localVarQueryParameter['solar_year_lte'] = solarYearLte;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update specific fields of an existing timeline event. Requires admin privileges.
         * @summary Partially update a timeline event
         * @param {string} id A UUID string identifying this Timeline Event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsPartialUpdate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('knowledgeBaseTimelineEventsPartialUpdate', 'id', id)
            const localVarPath = `/api/knowledge-base/timeline-events/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed information about a specific timeline event by its ID. Includes related document and date_time information.
         * @summary Retrieve a timeline event
         * @param {string} id A UUID string identifying this Timeline Event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('knowledgeBaseTimelineEventsRetrieve', 'id', id)
            const localVarPath = `/api/knowledge-base/timeline-events/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update all fields of an existing timeline event. Requires admin privileges.
         * @summary Update a timeline event
         * @param {string} id A UUID string identifying this Timeline Event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsUpdate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('knowledgeBaseTimelineEventsUpdate', 'id', id)
            const localVarPath = `/api/knowledge-base/timeline-events/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KnowledgeBaseTimelineEventsApi - functional programming interface
 * @export
 */
export const KnowledgeBaseTimelineEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KnowledgeBaseTimelineEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new timeline event. Requires admin privileges. You must provide existing document_id and date_time_id.
         * @summary Create a new timeline event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async knowledgeBaseTimelineEventsCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeLineEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.knowledgeBaseTimelineEventsCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseTimelineEventsApi.knowledgeBaseTimelineEventsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a timeline event. Requires admin privileges. Note: This does not delete the associated document or date_time records.
         * @summary Delete a timeline event
         * @param {string} id A UUID string identifying this Timeline Event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async knowledgeBaseTimelineEventsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.knowledgeBaseTimelineEventsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseTimelineEventsApi.knowledgeBaseTimelineEventsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import a timeline event with nested Document and DateTimeInfo data. This action will get_or_create Document and DateTimeInfo based on the provided data, then create the TimeLineEvent linking them together. This is useful for bulk imports or migrations. Note: Image loading is not supported in this action.
         * @summary Import timeline event with nested data
         * @param {TimeLineEventImportRequest} timeLineEventImportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async knowledgeBaseTimelineEventsImportEventCreate(timeLineEventImportRequest: TimeLineEventImportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeLineEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.knowledgeBaseTimelineEventsImportEventCreate(timeLineEventImportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseTimelineEventsApi.knowledgeBaseTimelineEventsImportEventCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all timeline events. Supports filtering by document, active_glow, solar_year, and sol. Supports searching across document title and content. Default ordering is by timeline (solar_year, sol).
         * @summary List all timeline events
         * @param {boolean} [activeGlow] Filter by active_glow (true/false)
         * @param {string} [dateTime] Filter by date_time ID
         * @param {string} [document] Filter by document ID
         * @param {string} [ordering] Order results by field (prefix with - for descending)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search across document title and content
         * @param {number} [sol] 
         * @param {number} [solGte] Filter by sol greater than or equal to value
         * @param {number} [solLte] 
         * @param {number} [solarYear] Filter by exact solar year
         * @param {number} [solarYearGte] 
         * @param {number} [solarYearLte] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async knowledgeBaseTimelineEventsList(activeGlow?: boolean, dateTime?: string, document?: string, ordering?: string, page?: number, pageSize?: number, search?: string, sol?: number, solGte?: number, solLte?: number, solarYear?: number, solarYearGte?: number, solarYearLte?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTimeLineEventList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.knowledgeBaseTimelineEventsList(activeGlow, dateTime, document, ordering, page, pageSize, search, sol, solGte, solLte, solarYear, solarYearGte, solarYearLte, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseTimelineEventsApi.knowledgeBaseTimelineEventsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update specific fields of an existing timeline event. Requires admin privileges.
         * @summary Partially update a timeline event
         * @param {string} id A UUID string identifying this Timeline Event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async knowledgeBaseTimelineEventsPartialUpdate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeLineEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.knowledgeBaseTimelineEventsPartialUpdate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseTimelineEventsApi.knowledgeBaseTimelineEventsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed information about a specific timeline event by its ID. Includes related document and date_time information.
         * @summary Retrieve a timeline event
         * @param {string} id A UUID string identifying this Timeline Event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async knowledgeBaseTimelineEventsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeLineEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.knowledgeBaseTimelineEventsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseTimelineEventsApi.knowledgeBaseTimelineEventsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update all fields of an existing timeline event. Requires admin privileges.
         * @summary Update a timeline event
         * @param {string} id A UUID string identifying this Timeline Event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async knowledgeBaseTimelineEventsUpdate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeLineEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.knowledgeBaseTimelineEventsUpdate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseTimelineEventsApi.knowledgeBaseTimelineEventsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KnowledgeBaseTimelineEventsApi - factory interface
 * @export
 */
export const KnowledgeBaseTimelineEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KnowledgeBaseTimelineEventsApiFp(configuration)
    return {
        /**
         * Create a new timeline event. Requires admin privileges. You must provide existing document_id and date_time_id.
         * @summary Create a new timeline event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsCreate(options?: any): AxiosPromise<TimeLineEvent> {
            return localVarFp.knowledgeBaseTimelineEventsCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a timeline event. Requires admin privileges. Note: This does not delete the associated document or date_time records.
         * @summary Delete a timeline event
         * @param {string} id A UUID string identifying this Timeline Event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.knowledgeBaseTimelineEventsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Import a timeline event with nested Document and DateTimeInfo data. This action will get_or_create Document and DateTimeInfo based on the provided data, then create the TimeLineEvent linking them together. This is useful for bulk imports or migrations. Note: Image loading is not supported in this action.
         * @summary Import timeline event with nested data
         * @param {TimeLineEventImportRequest} timeLineEventImportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsImportEventCreate(timeLineEventImportRequest: TimeLineEventImportRequest, options?: any): AxiosPromise<TimeLineEvent> {
            return localVarFp.knowledgeBaseTimelineEventsImportEventCreate(timeLineEventImportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all timeline events. Supports filtering by document, active_glow, solar_year, and sol. Supports searching across document title and content. Default ordering is by timeline (solar_year, sol).
         * @summary List all timeline events
         * @param {boolean} [activeGlow] Filter by active_glow (true/false)
         * @param {string} [dateTime] Filter by date_time ID
         * @param {string} [document] Filter by document ID
         * @param {string} [ordering] Order results by field (prefix with - for descending)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search across document title and content
         * @param {number} [sol] 
         * @param {number} [solGte] Filter by sol greater than or equal to value
         * @param {number} [solLte] 
         * @param {number} [solarYear] Filter by exact solar year
         * @param {number} [solarYearGte] 
         * @param {number} [solarYearLte] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsList(activeGlow?: boolean, dateTime?: string, document?: string, ordering?: string, page?: number, pageSize?: number, search?: string, sol?: number, solGte?: number, solLte?: number, solarYear?: number, solarYearGte?: number, solarYearLte?: number, options?: any): AxiosPromise<PaginatedTimeLineEventList> {
            return localVarFp.knowledgeBaseTimelineEventsList(activeGlow, dateTime, document, ordering, page, pageSize, search, sol, solGte, solLte, solarYear, solarYearGte, solarYearLte, options).then((request) => request(axios, basePath));
        },
        /**
         * Update specific fields of an existing timeline event. Requires admin privileges.
         * @summary Partially update a timeline event
         * @param {string} id A UUID string identifying this Timeline Event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsPartialUpdate(id: string, options?: any): AxiosPromise<TimeLineEvent> {
            return localVarFp.knowledgeBaseTimelineEventsPartialUpdate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed information about a specific timeline event by its ID. Includes related document and date_time information.
         * @summary Retrieve a timeline event
         * @param {string} id A UUID string identifying this Timeline Event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsRetrieve(id: string, options?: any): AxiosPromise<TimeLineEvent> {
            return localVarFp.knowledgeBaseTimelineEventsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update all fields of an existing timeline event. Requires admin privileges.
         * @summary Update a timeline event
         * @param {string} id A UUID string identifying this Timeline Event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        knowledgeBaseTimelineEventsUpdate(id: string, options?: any): AxiosPromise<TimeLineEvent> {
            return localVarFp.knowledgeBaseTimelineEventsUpdate(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KnowledgeBaseTimelineEventsApi - object-oriented interface
 * @export
 * @class KnowledgeBaseTimelineEventsApi
 * @extends {BaseAPI}
 */
export class KnowledgeBaseTimelineEventsApi extends BaseAPI {
    /**
     * Create a new timeline event. Requires admin privileges. You must provide existing document_id and date_time_id.
     * @summary Create a new timeline event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseTimelineEventsApi
     */
    public knowledgeBaseTimelineEventsCreate(options?: RawAxiosRequestConfig) {
        return KnowledgeBaseTimelineEventsApiFp(this.configuration).knowledgeBaseTimelineEventsCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a timeline event. Requires admin privileges. Note: This does not delete the associated document or date_time records.
     * @summary Delete a timeline event
     * @param {string} id A UUID string identifying this Timeline Event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseTimelineEventsApi
     */
    public knowledgeBaseTimelineEventsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseTimelineEventsApiFp(this.configuration).knowledgeBaseTimelineEventsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import a timeline event with nested Document and DateTimeInfo data. This action will get_or_create Document and DateTimeInfo based on the provided data, then create the TimeLineEvent linking them together. This is useful for bulk imports or migrations. Note: Image loading is not supported in this action.
     * @summary Import timeline event with nested data
     * @param {TimeLineEventImportRequest} timeLineEventImportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseTimelineEventsApi
     */
    public knowledgeBaseTimelineEventsImportEventCreate(timeLineEventImportRequest: TimeLineEventImportRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseTimelineEventsApiFp(this.configuration).knowledgeBaseTimelineEventsImportEventCreate(timeLineEventImportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all timeline events. Supports filtering by document, active_glow, solar_year, and sol. Supports searching across document title and content. Default ordering is by timeline (solar_year, sol).
     * @summary List all timeline events
     * @param {boolean} [activeGlow] Filter by active_glow (true/false)
     * @param {string} [dateTime] Filter by date_time ID
     * @param {string} [document] Filter by document ID
     * @param {string} [ordering] Order results by field (prefix with - for descending)
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] Search across document title and content
     * @param {number} [sol] 
     * @param {number} [solGte] Filter by sol greater than or equal to value
     * @param {number} [solLte] 
     * @param {number} [solarYear] Filter by exact solar year
     * @param {number} [solarYearGte] 
     * @param {number} [solarYearLte] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseTimelineEventsApi
     */
    public knowledgeBaseTimelineEventsList(activeGlow?: boolean, dateTime?: string, document?: string, ordering?: string, page?: number, pageSize?: number, search?: string, sol?: number, solGte?: number, solLte?: number, solarYear?: number, solarYearGte?: number, solarYearLte?: number, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseTimelineEventsApiFp(this.configuration).knowledgeBaseTimelineEventsList(activeGlow, dateTime, document, ordering, page, pageSize, search, sol, solGte, solLte, solarYear, solarYearGte, solarYearLte, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update specific fields of an existing timeline event. Requires admin privileges.
     * @summary Partially update a timeline event
     * @param {string} id A UUID string identifying this Timeline Event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseTimelineEventsApi
     */
    public knowledgeBaseTimelineEventsPartialUpdate(id: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseTimelineEventsApiFp(this.configuration).knowledgeBaseTimelineEventsPartialUpdate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed information about a specific timeline event by its ID. Includes related document and date_time information.
     * @summary Retrieve a timeline event
     * @param {string} id A UUID string identifying this Timeline Event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseTimelineEventsApi
     */
    public knowledgeBaseTimelineEventsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseTimelineEventsApiFp(this.configuration).knowledgeBaseTimelineEventsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update all fields of an existing timeline event. Requires admin privileges.
     * @summary Update a timeline event
     * @param {string} id A UUID string identifying this Timeline Event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseTimelineEventsApi
     */
    public knowledgeBaseTimelineEventsUpdate(id: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseTimelineEventsApiFp(this.configuration).knowledgeBaseTimelineEventsUpdate(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LongRestApi - axios parameter creator
 * @export
 */
export const LongRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id A UUID string identifying this long rest offer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersCancelCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('longRestOpenOffersCancelCreate', 'id', id)
            const localVarPath = `/api/long_rest/open_offers/{id}/cancel/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this long rest offer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersConfirmCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('longRestOpenOffersConfirmCreate', 'id', id)
            const localVarPath = `/api/long_rest/open_offers/{id}/confirm/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/long_rest/open_offers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersOpenCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/long_rest/open_offers/open/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nested viewset for adding and removing provisions from a long rest offer.
         * @param {string} offerPk 
         * @param {LongRestProvisionRequest} longRestProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersProvisionsCreate: async (offerPk: string, longRestProvisionRequest: LongRestProvisionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerPk' is not null or undefined
            assertParamExists('longRestOpenOffersProvisionsCreate', 'offerPk', offerPk)
            // verify required parameter 'longRestProvisionRequest' is not null or undefined
            assertParamExists('longRestOpenOffersProvisionsCreate', 'longRestProvisionRequest', longRestProvisionRequest)
            const localVarPath = `/api/long_rest/open_offers/{offer_pk}/provisions/`
                .replace(`{${"offer_pk"}}`, encodeURIComponent(String(offerPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(longRestProvisionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nested viewset for adding and removing provisions from a long rest offer.
         * @param {string} offerPk 
         * @param {string} worldItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersProvisionsDestroy: async (offerPk: string, worldItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerPk' is not null or undefined
            assertParamExists('longRestOpenOffersProvisionsDestroy', 'offerPk', offerPk)
            // verify required parameter 'worldItemId' is not null or undefined
            assertParamExists('longRestOpenOffersProvisionsDestroy', 'worldItemId', worldItemId)
            const localVarPath = `/api/long_rest/open_offers/{offer_pk}/provisions/{world_item_id}/`
                .replace(`{${"offer_pk"}}`, encodeURIComponent(String(offerPk)))
                .replace(`{${"world_item_id"}}`, encodeURIComponent(String(worldItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nested viewset for adding and removing provisions from a long rest offer.
         * @param {string} offerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersProvisionsList: async (offerPk: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerPk' is not null or undefined
            assertParamExists('longRestOpenOffersProvisionsList', 'offerPk', offerPk)
            const localVarPath = `/api/long_rest/open_offers/{offer_pk}/provisions/`
                .replace(`{${"offer_pk"}}`, encodeURIComponent(String(offerPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this long rest offer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('longRestOpenOffersRetrieve', 'id', id)
            const localVarPath = `/api/long_rest/open_offers/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LongRestApi - functional programming interface
 * @export
 */
export const LongRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LongRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id A UUID string identifying this long rest offer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async longRestOpenOffersCancelCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LongRestOffer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.longRestOpenOffersCancelCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LongRestApi.longRestOpenOffersCancelCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this long rest offer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async longRestOpenOffersConfirmCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LongRestOffer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.longRestOpenOffersConfirmCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LongRestApi.longRestOpenOffersConfirmCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async longRestOpenOffersList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LongRestOffer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.longRestOpenOffersList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LongRestApi.longRestOpenOffersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async longRestOpenOffersOpenCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LongRestOffer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.longRestOpenOffersOpenCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LongRestApi.longRestOpenOffersOpenCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nested viewset for adding and removing provisions from a long rest offer.
         * @param {string} offerPk 
         * @param {LongRestProvisionRequest} longRestProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async longRestOpenOffersProvisionsCreate(offerPk: string, longRestProvisionRequest: LongRestProvisionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LongRestProvision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.longRestOpenOffersProvisionsCreate(offerPk, longRestProvisionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LongRestApi.longRestOpenOffersProvisionsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nested viewset for adding and removing provisions from a long rest offer.
         * @param {string} offerPk 
         * @param {string} worldItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async longRestOpenOffersProvisionsDestroy(offerPk: string, worldItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.longRestOpenOffersProvisionsDestroy(offerPk, worldItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LongRestApi.longRestOpenOffersProvisionsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nested viewset for adding and removing provisions from a long rest offer.
         * @param {string} offerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async longRestOpenOffersProvisionsList(offerPk: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LongRestProvision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.longRestOpenOffersProvisionsList(offerPk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LongRestApi.longRestOpenOffersProvisionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this long rest offer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async longRestOpenOffersRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailedLongRestOffer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.longRestOpenOffersRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LongRestApi.longRestOpenOffersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LongRestApi - factory interface
 * @export
 */
export const LongRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LongRestApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id A UUID string identifying this long rest offer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersCancelCreate(id: string, options?: any): AxiosPromise<LongRestOffer> {
            return localVarFp.longRestOpenOffersCancelCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this long rest offer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersConfirmCreate(id: string, options?: any): AxiosPromise<LongRestOffer> {
            return localVarFp.longRestOpenOffersConfirmCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersList(options?: any): AxiosPromise<Array<LongRestOffer>> {
            return localVarFp.longRestOpenOffersList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersOpenCreate(options?: any): AxiosPromise<LongRestOffer> {
            return localVarFp.longRestOpenOffersOpenCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * Nested viewset for adding and removing provisions from a long rest offer.
         * @param {string} offerPk 
         * @param {LongRestProvisionRequest} longRestProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersProvisionsCreate(offerPk: string, longRestProvisionRequest: LongRestProvisionRequest, options?: any): AxiosPromise<LongRestProvision> {
            return localVarFp.longRestOpenOffersProvisionsCreate(offerPk, longRestProvisionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Nested viewset for adding and removing provisions from a long rest offer.
         * @param {string} offerPk 
         * @param {string} worldItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersProvisionsDestroy(offerPk: string, worldItemId: string, options?: any): AxiosPromise<void> {
            return localVarFp.longRestOpenOffersProvisionsDestroy(offerPk, worldItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Nested viewset for adding and removing provisions from a long rest offer.
         * @param {string} offerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersProvisionsList(offerPk: string, options?: any): AxiosPromise<Array<LongRestProvision>> {
            return localVarFp.longRestOpenOffersProvisionsList(offerPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this long rest offer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        longRestOpenOffersRetrieve(id: string, options?: any): AxiosPromise<DetailedLongRestOffer> {
            return localVarFp.longRestOpenOffersRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LongRestApi - object-oriented interface
 * @export
 * @class LongRestApi
 * @extends {BaseAPI}
 */
export class LongRestApi extends BaseAPI {
    /**
     * 
     * @param {string} id A UUID string identifying this long rest offer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LongRestApi
     */
    public longRestOpenOffersCancelCreate(id: string, options?: RawAxiosRequestConfig) {
        return LongRestApiFp(this.configuration).longRestOpenOffersCancelCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this long rest offer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LongRestApi
     */
    public longRestOpenOffersConfirmCreate(id: string, options?: RawAxiosRequestConfig) {
        return LongRestApiFp(this.configuration).longRestOpenOffersConfirmCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LongRestApi
     */
    public longRestOpenOffersList(options?: RawAxiosRequestConfig) {
        return LongRestApiFp(this.configuration).longRestOpenOffersList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LongRestApi
     */
    public longRestOpenOffersOpenCreate(options?: RawAxiosRequestConfig) {
        return LongRestApiFp(this.configuration).longRestOpenOffersOpenCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nested viewset for adding and removing provisions from a long rest offer.
     * @param {string} offerPk 
     * @param {LongRestProvisionRequest} longRestProvisionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LongRestApi
     */
    public longRestOpenOffersProvisionsCreate(offerPk: string, longRestProvisionRequest: LongRestProvisionRequest, options?: RawAxiosRequestConfig) {
        return LongRestApiFp(this.configuration).longRestOpenOffersProvisionsCreate(offerPk, longRestProvisionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nested viewset for adding and removing provisions from a long rest offer.
     * @param {string} offerPk 
     * @param {string} worldItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LongRestApi
     */
    public longRestOpenOffersProvisionsDestroy(offerPk: string, worldItemId: string, options?: RawAxiosRequestConfig) {
        return LongRestApiFp(this.configuration).longRestOpenOffersProvisionsDestroy(offerPk, worldItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nested viewset for adding and removing provisions from a long rest offer.
     * @param {string} offerPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LongRestApi
     */
    public longRestOpenOffersProvisionsList(offerPk: string, options?: RawAxiosRequestConfig) {
        return LongRestApiFp(this.configuration).longRestOpenOffersProvisionsList(offerPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this long rest offer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LongRestApi
     */
    public longRestOpenOffersRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return LongRestApiFp(this.configuration).longRestOpenOffersRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ModificatorsApi - axios parameter creator
 * @export
 */
export const ModificatorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsCharacterList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/modificators/character/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character modificator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsCharacterRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('modificatorsCharacterRetrieve', 'id', id)
            const localVarPath = `/api/modificators/character/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ModificatorRequest} modificatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldCreate: async (modificatorRequest: ModificatorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modificatorRequest' is not null or undefined
            assertParamExists('modificatorsWorldCreate', 'modificatorRequest', modificatorRequest)
            const localVarPath = `/api/modificators/world/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modificatorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this modificator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('modificatorsWorldDestroy', 'id', id)
            const localVarPath = `/api/modificators/world/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldGetAllModificatorsRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/modificators/world/get_all_modificators/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/modificators/world/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this modificator.
         * @param {PatchedModificatorRequest} [patchedModificatorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldPartialUpdate: async (id: string, patchedModificatorRequest?: PatchedModificatorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('modificatorsWorldPartialUpdate', 'id', id)
            const localVarPath = `/api/modificators/world/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedModificatorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this modificator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('modificatorsWorldRetrieve', 'id', id)
            const localVarPath = `/api/modificators/world/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this modificator.
         * @param {ModificatorRequest} modificatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldUpdate: async (id: string, modificatorRequest: ModificatorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('modificatorsWorldUpdate', 'id', id)
            // verify required parameter 'modificatorRequest' is not null or undefined
            assertParamExists('modificatorsWorldUpdate', 'modificatorRequest', modificatorRequest)
            const localVarPath = `/api/modificators/world/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modificatorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModificatorsApi - functional programming interface
 * @export
 */
export const ModificatorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModificatorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modificatorsCharacterList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CharacterModificator>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modificatorsCharacterList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModificatorsApi.modificatorsCharacterList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character modificator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modificatorsCharacterRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacterModificator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modificatorsCharacterRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModificatorsApi.modificatorsCharacterRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ModificatorRequest} modificatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modificatorsWorldCreate(modificatorRequest: ModificatorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Modificator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modificatorsWorldCreate(modificatorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModificatorsApi.modificatorsWorldCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this modificator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modificatorsWorldDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modificatorsWorldDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModificatorsApi.modificatorsWorldDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modificatorsWorldGetAllModificatorsRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Modificator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modificatorsWorldGetAllModificatorsRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModificatorsApi.modificatorsWorldGetAllModificatorsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modificatorsWorldList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Modificator>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modificatorsWorldList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModificatorsApi.modificatorsWorldList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this modificator.
         * @param {PatchedModificatorRequest} [patchedModificatorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modificatorsWorldPartialUpdate(id: string, patchedModificatorRequest?: PatchedModificatorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Modificator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modificatorsWorldPartialUpdate(id, patchedModificatorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModificatorsApi.modificatorsWorldPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this modificator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modificatorsWorldRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Modificator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modificatorsWorldRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModificatorsApi.modificatorsWorldRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this modificator.
         * @param {ModificatorRequest} modificatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modificatorsWorldUpdate(id: string, modificatorRequest: ModificatorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Modificator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modificatorsWorldUpdate(id, modificatorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModificatorsApi.modificatorsWorldUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ModificatorsApi - factory interface
 * @export
 */
export const ModificatorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModificatorsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsCharacterList(options?: any): AxiosPromise<Array<CharacterModificator>> {
            return localVarFp.modificatorsCharacterList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character modificator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsCharacterRetrieve(id: string, options?: any): AxiosPromise<CharacterModificator> {
            return localVarFp.modificatorsCharacterRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ModificatorRequest} modificatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldCreate(modificatorRequest: ModificatorRequest, options?: any): AxiosPromise<Modificator> {
            return localVarFp.modificatorsWorldCreate(modificatorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this modificator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.modificatorsWorldDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldGetAllModificatorsRetrieve(options?: any): AxiosPromise<Modificator> {
            return localVarFp.modificatorsWorldGetAllModificatorsRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldList(options?: any): AxiosPromise<Array<Modificator>> {
            return localVarFp.modificatorsWorldList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this modificator.
         * @param {PatchedModificatorRequest} [patchedModificatorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldPartialUpdate(id: string, patchedModificatorRequest?: PatchedModificatorRequest, options?: any): AxiosPromise<Modificator> {
            return localVarFp.modificatorsWorldPartialUpdate(id, patchedModificatorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this modificator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldRetrieve(id: string, options?: any): AxiosPromise<Modificator> {
            return localVarFp.modificatorsWorldRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this modificator.
         * @param {ModificatorRequest} modificatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificatorsWorldUpdate(id: string, modificatorRequest: ModificatorRequest, options?: any): AxiosPromise<Modificator> {
            return localVarFp.modificatorsWorldUpdate(id, modificatorRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModificatorsApi - object-oriented interface
 * @export
 * @class ModificatorsApi
 * @extends {BaseAPI}
 */
export class ModificatorsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModificatorsApi
     */
    public modificatorsCharacterList(options?: RawAxiosRequestConfig) {
        return ModificatorsApiFp(this.configuration).modificatorsCharacterList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character modificator.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModificatorsApi
     */
    public modificatorsCharacterRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return ModificatorsApiFp(this.configuration).modificatorsCharacterRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ModificatorRequest} modificatorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModificatorsApi
     */
    public modificatorsWorldCreate(modificatorRequest: ModificatorRequest, options?: RawAxiosRequestConfig) {
        return ModificatorsApiFp(this.configuration).modificatorsWorldCreate(modificatorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this modificator.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModificatorsApi
     */
    public modificatorsWorldDestroy(id: string, options?: RawAxiosRequestConfig) {
        return ModificatorsApiFp(this.configuration).modificatorsWorldDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModificatorsApi
     */
    public modificatorsWorldGetAllModificatorsRetrieve(options?: RawAxiosRequestConfig) {
        return ModificatorsApiFp(this.configuration).modificatorsWorldGetAllModificatorsRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModificatorsApi
     */
    public modificatorsWorldList(options?: RawAxiosRequestConfig) {
        return ModificatorsApiFp(this.configuration).modificatorsWorldList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this modificator.
     * @param {PatchedModificatorRequest} [patchedModificatorRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModificatorsApi
     */
    public modificatorsWorldPartialUpdate(id: string, patchedModificatorRequest?: PatchedModificatorRequest, options?: RawAxiosRequestConfig) {
        return ModificatorsApiFp(this.configuration).modificatorsWorldPartialUpdate(id, patchedModificatorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this modificator.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModificatorsApi
     */
    public modificatorsWorldRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return ModificatorsApiFp(this.configuration).modificatorsWorldRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this modificator.
     * @param {ModificatorRequest} modificatorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModificatorsApi
     */
    public modificatorsWorldUpdate(id: string, modificatorRequest: ModificatorRequest, options?: RawAxiosRequestConfig) {
        return ModificatorsApiFp(this.configuration).modificatorsWorldUpdate(id, modificatorRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SchoolApi - axios parameter creator
 * @export
 */
export const SchoolApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolPathsGetAllPathsRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/school/paths/get_all_paths/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolPathsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/school/paths/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolPathsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('schoolPathsRetrieve', 'id', id)
            const localVarPath = `/api/school/paths/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this school.
         * @param {OpenaiSkillRequest} openaiSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsCreateSkillCreate: async (id: string, openaiSkillRequest: OpenaiSkillRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('schoolSchoolsCreateSkillCreate', 'id', id)
            // verify required parameter 'openaiSkillRequest' is not null or undefined
            assertParamExists('schoolSchoolsCreateSkillCreate', 'openaiSkillRequest', openaiSkillRequest)
            const localVarPath = `/api/school/schools/{id}/create_skill/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(openaiSkillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsGetAllSchoolsRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/school/schools/get_all_schools/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsGetAllSkillsRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/school/schools/get_all_skills/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/school/schools/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this school.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('schoolSchoolsRetrieve', 'id', id)
            const localVarPath = `/api/school/schools/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} schoolPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsSkillsGetAllSchoolSkillsRetrieve: async (schoolPk: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schoolPk' is not null or undefined
            assertParamExists('schoolSchoolsSkillsGetAllSchoolSkillsRetrieve', 'schoolPk', schoolPk)
            const localVarPath = `/api/school/schools/{school_pk}/skills/get_all_school_skills/`
                .replace(`{${"school_pk"}}`, encodeURIComponent(String(schoolPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} schoolPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsSkillsList: async (schoolPk: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schoolPk' is not null or undefined
            assertParamExists('schoolSchoolsSkillsList', 'schoolPk', schoolPk)
            const localVarPath = `/api/school/schools/{school_pk}/skills/`
                .replace(`{${"school_pk"}}`, encodeURIComponent(String(schoolPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this skill.
         * @param {string} schoolPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsSkillsRetrieve: async (id: number, schoolPk: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('schoolSchoolsSkillsRetrieve', 'id', id)
            // verify required parameter 'schoolPk' is not null or undefined
            assertParamExists('schoolSchoolsSkillsRetrieve', 'schoolPk', schoolPk)
            const localVarPath = `/api/school/schools/{school_pk}/skills/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"school_pk"}}`, encodeURIComponent(String(schoolPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchoolApi - functional programming interface
 * @export
 */
export const SchoolApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchoolApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schoolPathsGetAllPathsRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiPath>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schoolPathsGetAllPathsRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchoolApi.schoolPathsGetAllPathsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schoolPathsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpenaiPath>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schoolPathsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchoolApi.schoolPathsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schoolPathsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiPathWithSchools>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schoolPathsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchoolApi.schoolPathsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this school.
         * @param {OpenaiSkillRequest} openaiSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schoolSchoolsCreateSkillCreate(id: string, openaiSkillRequest: OpenaiSkillRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiSkill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schoolSchoolsCreateSkillCreate(id, openaiSkillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchoolApi.schoolSchoolsCreateSkillCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schoolSchoolsGetAllSchoolsRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiSchool>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schoolSchoolsGetAllSchoolsRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchoolApi.schoolSchoolsGetAllSchoolsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schoolSchoolsGetAllSkillsRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiSchool>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schoolSchoolsGetAllSkillsRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchoolApi.schoolSchoolsGetAllSkillsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schoolSchoolsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpenaiSchool>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schoolSchoolsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchoolApi.schoolSchoolsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this school.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schoolSchoolsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiSchool>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schoolSchoolsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchoolApi.schoolSchoolsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} schoolPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schoolSchoolsSkillsGetAllSchoolSkillsRetrieve(schoolPk: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiSkill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schoolSchoolsSkillsGetAllSchoolSkillsRetrieve(schoolPk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchoolApi.schoolSchoolsSkillsGetAllSchoolSkillsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} schoolPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schoolSchoolsSkillsList(schoolPk: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpenaiSkill>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schoolSchoolsSkillsList(schoolPk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchoolApi.schoolSchoolsSkillsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this skill.
         * @param {string} schoolPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schoolSchoolsSkillsRetrieve(id: number, schoolPk: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenaiSkill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schoolSchoolsSkillsRetrieve(id, schoolPk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchoolApi.schoolSchoolsSkillsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SchoolApi - factory interface
 * @export
 */
export const SchoolApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchoolApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolPathsGetAllPathsRetrieve(options?: any): AxiosPromise<OpenaiPath> {
            return localVarFp.schoolPathsGetAllPathsRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolPathsList(options?: any): AxiosPromise<Array<OpenaiPath>> {
            return localVarFp.schoolPathsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolPathsRetrieve(id: string, options?: any): AxiosPromise<OpenaiPathWithSchools> {
            return localVarFp.schoolPathsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this school.
         * @param {OpenaiSkillRequest} openaiSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsCreateSkillCreate(id: string, openaiSkillRequest: OpenaiSkillRequest, options?: any): AxiosPromise<OpenaiSkill> {
            return localVarFp.schoolSchoolsCreateSkillCreate(id, openaiSkillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsGetAllSchoolsRetrieve(options?: any): AxiosPromise<OpenaiSchool> {
            return localVarFp.schoolSchoolsGetAllSchoolsRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsGetAllSkillsRetrieve(options?: any): AxiosPromise<OpenaiSchool> {
            return localVarFp.schoolSchoolsGetAllSkillsRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsList(options?: any): AxiosPromise<Array<OpenaiSchool>> {
            return localVarFp.schoolSchoolsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this school.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsRetrieve(id: string, options?: any): AxiosPromise<OpenaiSchool> {
            return localVarFp.schoolSchoolsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} schoolPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsSkillsGetAllSchoolSkillsRetrieve(schoolPk: string, options?: any): AxiosPromise<OpenaiSkill> {
            return localVarFp.schoolSchoolsSkillsGetAllSchoolSkillsRetrieve(schoolPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} schoolPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsSkillsList(schoolPk: string, options?: any): AxiosPromise<Array<OpenaiSkill>> {
            return localVarFp.schoolSchoolsSkillsList(schoolPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this skill.
         * @param {string} schoolPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolSchoolsSkillsRetrieve(id: number, schoolPk: string, options?: any): AxiosPromise<OpenaiSkill> {
            return localVarFp.schoolSchoolsSkillsRetrieve(id, schoolPk, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchoolApi - object-oriented interface
 * @export
 * @class SchoolApi
 * @extends {BaseAPI}
 */
export class SchoolApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolApi
     */
    public schoolPathsGetAllPathsRetrieve(options?: RawAxiosRequestConfig) {
        return SchoolApiFp(this.configuration).schoolPathsGetAllPathsRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolApi
     */
    public schoolPathsList(options?: RawAxiosRequestConfig) {
        return SchoolApiFp(this.configuration).schoolPathsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this the path.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolApi
     */
    public schoolPathsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return SchoolApiFp(this.configuration).schoolPathsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this school.
     * @param {OpenaiSkillRequest} openaiSkillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolApi
     */
    public schoolSchoolsCreateSkillCreate(id: string, openaiSkillRequest: OpenaiSkillRequest, options?: RawAxiosRequestConfig) {
        return SchoolApiFp(this.configuration).schoolSchoolsCreateSkillCreate(id, openaiSkillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolApi
     */
    public schoolSchoolsGetAllSchoolsRetrieve(options?: RawAxiosRequestConfig) {
        return SchoolApiFp(this.configuration).schoolSchoolsGetAllSchoolsRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolApi
     */
    public schoolSchoolsGetAllSkillsRetrieve(options?: RawAxiosRequestConfig) {
        return SchoolApiFp(this.configuration).schoolSchoolsGetAllSkillsRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolApi
     */
    public schoolSchoolsList(options?: RawAxiosRequestConfig) {
        return SchoolApiFp(this.configuration).schoolSchoolsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this school.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolApi
     */
    public schoolSchoolsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return SchoolApiFp(this.configuration).schoolSchoolsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} schoolPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolApi
     */
    public schoolSchoolsSkillsGetAllSchoolSkillsRetrieve(schoolPk: string, options?: RawAxiosRequestConfig) {
        return SchoolApiFp(this.configuration).schoolSchoolsSkillsGetAllSchoolSkillsRetrieve(schoolPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} schoolPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolApi
     */
    public schoolSchoolsSkillsList(schoolPk: string, options?: RawAxiosRequestConfig) {
        return SchoolApiFp(this.configuration).schoolSchoolsSkillsList(schoolPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this skill.
     * @param {string} schoolPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolApi
     */
    public schoolSchoolsSkillsRetrieve(id: number, schoolPk: string, options?: RawAxiosRequestConfig) {
        return SchoolApiFp(this.configuration).schoolSchoolsSkillsRetrieve(id, schoolPk, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ShieldsApi - axios parameter creator
 * @export
 */
export const ShieldsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shieldsActiveList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shields/active/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this active shield.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shieldsActiveRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shieldsActiveRetrieve', 'id', id)
            const localVarPath = `/api/shields/active/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shieldsGmActiveList: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shields/gm/active/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShieldsApi - functional programming interface
 * @export
 */
export const ShieldsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShieldsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shieldsActiveList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActiveShield>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shieldsActiveList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShieldsApi.shieldsActiveList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this active shield.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shieldsActiveRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveShield>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shieldsActiveRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShieldsApi.shieldsActiveRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shieldsGmActiveList(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActiveShield>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shieldsGmActiveList(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShieldsApi.shieldsGmActiveList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ShieldsApi - factory interface
 * @export
 */
export const ShieldsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShieldsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shieldsActiveList(options?: any): AxiosPromise<Array<ActiveShield>> {
            return localVarFp.shieldsActiveList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this active shield.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shieldsActiveRetrieve(id: string, options?: any): AxiosPromise<ActiveShield> {
            return localVarFp.shieldsActiveRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shieldsGmActiveList(target?: string, options?: any): AxiosPromise<Array<ActiveShield>> {
            return localVarFp.shieldsGmActiveList(target, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShieldsApi - object-oriented interface
 * @export
 * @class ShieldsApi
 * @extends {BaseAPI}
 */
export class ShieldsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShieldsApi
     */
    public shieldsActiveList(options?: RawAxiosRequestConfig) {
        return ShieldsApiFp(this.configuration).shieldsActiveList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this active shield.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShieldsApi
     */
    public shieldsActiveRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return ShieldsApiFp(this.configuration).shieldsActiveRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShieldsApi
     */
    public shieldsGmActiveList(target?: string, options?: RawAxiosRequestConfig) {
        return ShieldsApiFp(this.configuration).shieldsGmActiveList(target, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SkillsApi - axios parameter creator
 * @export
 */
export const SkillsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [character] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsGmSkillsList: async (character?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/skills/gm/skills/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (character !== undefined) {
                localVarQueryParameter['character'] = character;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned skill.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsGmSkillsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('skillsGmSkillsRetrieve', 'id', id)
            const localVarPath = `/api/skills/gm/skills/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LearnedSchoolRequest} learnedSchoolRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsShoolsCreate: async (learnedSchoolRequest: LearnedSchoolRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'learnedSchoolRequest' is not null or undefined
            assertParamExists('skillsShoolsCreate', 'learnedSchoolRequest', learnedSchoolRequest)
            const localVarPath = `/api/skills/shools/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(learnedSchoolRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned school.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsShoolsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('skillsShoolsDestroy', 'id', id)
            const localVarPath = `/api/skills/shools/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsShoolsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/skills/shools/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned school.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsShoolsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('skillsShoolsRetrieve', 'id', id)
            const localVarPath = `/api/skills/shools/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LearnedSkillRequest} learnedSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsSkillsCreate: async (learnedSkillRequest: LearnedSkillRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'learnedSkillRequest' is not null or undefined
            assertParamExists('skillsSkillsCreate', 'learnedSkillRequest', learnedSkillRequest)
            const localVarPath = `/api/skills/skills/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(learnedSkillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned skill.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsSkillsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('skillsSkillsDestroy', 'id', id)
            const localVarPath = `/api/skills/skills/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsSkillsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/skills/skills/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned skill.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsSkillsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('skillsSkillsRetrieve', 'id', id)
            const localVarPath = `/api/skills/skills/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SkillsApi - functional programming interface
 * @export
 */
export const SkillsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SkillsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [character] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillsGmSkillsList(character?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedLearnedSkillList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillsGmSkillsList(character, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.skillsGmSkillsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned skill.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillsGmSkillsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearnedSkill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillsGmSkillsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.skillsGmSkillsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LearnedSchoolRequest} learnedSchoolRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillsShoolsCreate(learnedSchoolRequest: LearnedSchoolRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearnedSchool>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillsShoolsCreate(learnedSchoolRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.skillsShoolsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned school.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillsShoolsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillsShoolsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.skillsShoolsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillsShoolsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LearnedSchool>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillsShoolsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.skillsShoolsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned school.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillsShoolsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearnedSchool>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillsShoolsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.skillsShoolsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LearnedSkillRequest} learnedSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillsSkillsCreate(learnedSkillRequest: LearnedSkillRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearnedSkill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillsSkillsCreate(learnedSkillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.skillsSkillsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned skill.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillsSkillsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillsSkillsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.skillsSkillsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillsSkillsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LearnedSkill>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillsSkillsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.skillsSkillsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned skill.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillsSkillsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearnedSkill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillsSkillsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.skillsSkillsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SkillsApi - factory interface
 * @export
 */
export const SkillsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SkillsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [character] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsGmSkillsList(character?: string, page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedLearnedSkillList> {
            return localVarFp.skillsGmSkillsList(character, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned skill.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsGmSkillsRetrieve(id: string, options?: any): AxiosPromise<LearnedSkill> {
            return localVarFp.skillsGmSkillsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LearnedSchoolRequest} learnedSchoolRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsShoolsCreate(learnedSchoolRequest: LearnedSchoolRequest, options?: any): AxiosPromise<LearnedSchool> {
            return localVarFp.skillsShoolsCreate(learnedSchoolRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned school.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsShoolsDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.skillsShoolsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsShoolsList(options?: any): AxiosPromise<Array<LearnedSchool>> {
            return localVarFp.skillsShoolsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned school.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsShoolsRetrieve(id: string, options?: any): AxiosPromise<LearnedSchool> {
            return localVarFp.skillsShoolsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LearnedSkillRequest} learnedSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsSkillsCreate(learnedSkillRequest: LearnedSkillRequest, options?: any): AxiosPromise<LearnedSkill> {
            return localVarFp.skillsSkillsCreate(learnedSkillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned skill.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsSkillsDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.skillsSkillsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsSkillsList(options?: any): AxiosPromise<Array<LearnedSkill>> {
            return localVarFp.skillsSkillsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this learned skill.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillsSkillsRetrieve(id: string, options?: any): AxiosPromise<LearnedSkill> {
            return localVarFp.skillsSkillsRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SkillsApi - object-oriented interface
 * @export
 * @class SkillsApi
 * @extends {BaseAPI}
 */
export class SkillsApi extends BaseAPI {
    /**
     * 
     * @param {string} [character] 
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public skillsGmSkillsList(character?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).skillsGmSkillsList(character, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this learned skill.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public skillsGmSkillsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).skillsGmSkillsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LearnedSchoolRequest} learnedSchoolRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public skillsShoolsCreate(learnedSchoolRequest: LearnedSchoolRequest, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).skillsShoolsCreate(learnedSchoolRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this learned school.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public skillsShoolsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).skillsShoolsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public skillsShoolsList(options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).skillsShoolsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this learned school.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public skillsShoolsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).skillsShoolsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LearnedSkillRequest} learnedSkillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public skillsSkillsCreate(learnedSkillRequest: LearnedSkillRequest, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).skillsSkillsCreate(learnedSkillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this learned skill.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public skillsSkillsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).skillsSkillsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public skillsSkillsList(options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).skillsSkillsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this learned skill.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public skillsSkillsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).skillsSkillsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StoryApi - axios parameter creator
 * @export
 */
export const StoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {ChapterRequest} chapterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyChaptersCreate: async (chapterRequest: ChapterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chapterRequest' is not null or undefined
            assertParamExists('storyChaptersCreate', 'chapterRequest', chapterRequest)
            const localVarPath = `/api/story/chapters/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chapterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} id A UUID string identifying this chapter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyChaptersDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyChaptersDestroy', 'id', id)
            const localVarPath = `/api/story/chapters/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [story] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyChaptersList: async (ordering?: string, story?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/story/chapters/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (story !== undefined) {
                localVarQueryParameter['story'] = story;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} id A UUID string identifying this chapter.
         * @param {PatchedChapterRequest} [patchedChapterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyChaptersPartialUpdate: async (id: string, patchedChapterRequest?: PatchedChapterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyChaptersPartialUpdate', 'id', id)
            const localVarPath = `/api/story/chapters/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedChapterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} id A UUID string identifying this chapter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyChaptersRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyChaptersRetrieve', 'id', id)
            const localVarPath = `/api/story/chapters/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} id A UUID string identifying this chapter.
         * @param {ChapterRequest} chapterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyChaptersUpdate: async (id: string, chapterRequest: ChapterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyChaptersUpdate', 'id', id)
            // verify required parameter 'chapterRequest' is not null or undefined
            assertParamExists('storyChaptersUpdate', 'chapterRequest', chapterRequest)
            const localVarPath = `/api/story/chapters/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chapterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {ConditionRequest} [conditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyConditionsCreate: async (conditionRequest?: ConditionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/story/conditions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conditionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {string} id A UUID string identifying this condition.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyConditionsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyConditionsDestroy', 'id', id)
            const localVarPath = `/api/story/conditions/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {ConditionTypeEnum} [type] * &#x60;all&#x60; - All * &#x60;any&#x60; - Any * &#x60;none&#x60; - None
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyConditionsList: async (type?: ConditionTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/story/conditions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {string} id A UUID string identifying this condition.
         * @param {PatchedConditionRequest} [patchedConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyConditionsPartialUpdate: async (id: string, patchedConditionRequest?: PatchedConditionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyConditionsPartialUpdate', 'id', id)
            const localVarPath = `/api/story/conditions/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedConditionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {string} id A UUID string identifying this condition.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyConditionsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyConditionsRetrieve', 'id', id)
            const localVarPath = `/api/story/conditions/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {string} id A UUID string identifying this condition.
         * @param {ConditionRequest} [conditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyConditionsUpdate: async (id: string, conditionRequest?: ConditionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyConditionsUpdate', 'id', id)
            const localVarPath = `/api/story/conditions/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conditionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {EffectRewardRequest} effectRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyEffectRewardsCreate: async (effectRewardRequest: EffectRewardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'effectRewardRequest' is not null or undefined
            assertParamExists('storyEffectRewardsCreate', 'effectRewardRequest', effectRewardRequest)
            const localVarPath = `/api/story/effect-rewards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(effectRewardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {string} id A UUID string identifying this effect reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyEffectRewardsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyEffectRewardsDestroy', 'id', id)
            const localVarPath = `/api/story/effect-rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {EffectEnum} [effect] * &#x60;Knocked out&#x60; - Knocked out * &#x60;Coma&#x60; - Coma * &#x60;None&#x60; - None * &#x60;Burning&#x60; - Burning * &#x60;Poisoned&#x60; - Poisoned * &#x60;Sleeping&#x60; - Sleeping * &#x60;Confused&#x60; - Confused * &#x60;Paralyzed&#x60; - Paralyzed * &#x60;Fear&#x60; - Fear * &#x60;Slowness&#x60; - Slowness * &#x60;Cold&#x60; - Cold * &#x60;Cursed&#x60; - Cursed * &#x60;Blindness&#x60; - Blindness * &#x60;Haste&#x60; - Haste * &#x60;Regeneration&#x60; - Regeneration * &#x60;Blessed&#x60; - Blessed * &#x60;Arcane Surge&#x60; - Arcane Surge * &#x60;Marked&#x60; - Marked * &#x60;Bleeding&#x60; - Bleeding * &#x60;Weakened&#x60; - Weakened * &#x60;Enervated&#x60; - Enervated * &#x60;Dazzled&#x60; - Dazzled * &#x60;Exhausted&#x60; - Exhausted * &#x60;InchFromDeath&#x60; - InchFromDeath * &#x60;ComaShock&#x60; - ComaShock * &#x60;WellRested&#x60; - WellRested
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [reward] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyEffectRewardsList: async (effect?: EffectEnum, ordering?: string, reward?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/story/effect-rewards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (effect !== undefined) {
                localVarQueryParameter['effect'] = effect;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (reward !== undefined) {
                localVarQueryParameter['reward'] = reward;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {string} id A UUID string identifying this effect reward.
         * @param {PatchedEffectRewardRequest} [patchedEffectRewardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyEffectRewardsPartialUpdate: async (id: string, patchedEffectRewardRequest?: PatchedEffectRewardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyEffectRewardsPartialUpdate', 'id', id)
            const localVarPath = `/api/story/effect-rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedEffectRewardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {string} id A UUID string identifying this effect reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyEffectRewardsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyEffectRewardsRetrieve', 'id', id)
            const localVarPath = `/api/story/effect-rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {string} id A UUID string identifying this effect reward.
         * @param {EffectRewardRequest} effectRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyEffectRewardsUpdate: async (id: string, effectRewardRequest: EffectRewardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyEffectRewardsUpdate', 'id', id)
            // verify required parameter 'effectRewardRequest' is not null or undefined
            assertParamExists('storyEffectRewardsUpdate', 'effectRewardRequest', effectRewardRequest)
            const localVarPath = `/api/story/effect-rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(effectRewardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {ItemRewardRequest} itemRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyItemRewardsCreate: async (itemRewardRequest: ItemRewardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemRewardRequest' is not null or undefined
            assertParamExists('storyItemRewardsCreate', 'itemRewardRequest', itemRewardRequest)
            const localVarPath = `/api/story/item-rewards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(itemRewardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} id A UUID string identifying this item reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyItemRewardsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyItemRewardsDestroy', 'id', id)
            const localVarPath = `/api/story/item-rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} [item] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [reward] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyItemRewardsList: async (item?: string, ordering?: string, reward?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/story/item-rewards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (item !== undefined) {
                localVarQueryParameter['item'] = item;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (reward !== undefined) {
                localVarQueryParameter['reward'] = reward;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} id A UUID string identifying this item reward.
         * @param {PatchedItemRewardRequest} [patchedItemRewardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyItemRewardsPartialUpdate: async (id: string, patchedItemRewardRequest?: PatchedItemRewardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyItemRewardsPartialUpdate', 'id', id)
            const localVarPath = `/api/story/item-rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedItemRewardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} id A UUID string identifying this item reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyItemRewardsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyItemRewardsRetrieve', 'id', id)
            const localVarPath = `/api/story/item-rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} id A UUID string identifying this item reward.
         * @param {ItemRewardRequest} itemRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyItemRewardsUpdate: async (id: string, itemRewardRequest: ItemRewardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyItemRewardsUpdate', 'id', id)
            // verify required parameter 'itemRewardRequest' is not null or undefined
            assertParamExists('storyItemRewardsUpdate', 'itemRewardRequest', itemRewardRequest)
            const localVarPath = `/api/story/item-rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(itemRewardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {NoteRequest} noteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyNotesCreate: async (noteRequest: NoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteRequest' is not null or undefined
            assertParamExists('storyNotesCreate', 'noteRequest', noteRequest)
            const localVarPath = `/api/story/notes/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} id A UUID string identifying this note.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyNotesDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyNotesDestroy', 'id', id)
            const localVarPath = `/api/story/notes/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [quest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyNotesList: async (ordering?: string, quest?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/story/notes/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (quest !== undefined) {
                localVarQueryParameter['quest'] = quest;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} id A UUID string identifying this note.
         * @param {PatchedNoteRequest} [patchedNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyNotesPartialUpdate: async (id: string, patchedNoteRequest?: PatchedNoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyNotesPartialUpdate', 'id', id)
            const localVarPath = `/api/story/notes/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} id A UUID string identifying this note.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyNotesRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyNotesRetrieve', 'id', id)
            const localVarPath = `/api/story/notes/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} id A UUID string identifying this note.
         * @param {NoteRequest} noteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyNotesUpdate: async (id: string, noteRequest: NoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyNotesUpdate', 'id', id)
            // verify required parameter 'noteRequest' is not null or undefined
            assertParamExists('storyNotesUpdate', 'noteRequest', noteRequest)
            const localVarPath = `/api/story/notes/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {QuestRequest} questRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyQuestsCreate: async (questRequest: QuestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questRequest' is not null or undefined
            assertParamExists('storyQuestsCreate', 'questRequest', questRequest)
            const localVarPath = `/api/story/quests/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} id A UUID string identifying this quest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyQuestsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyQuestsDestroy', 'id', id)
            const localVarPath = `/api/story/quests/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} [chapter] 
         * @param {string} [chapterStory] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyQuestsList: async (chapter?: string, chapterStory?: string, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/story/quests/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (chapter !== undefined) {
                localVarQueryParameter['chapter'] = chapter;
            }

            if (chapterStory !== undefined) {
                localVarQueryParameter['chapter__story'] = chapterStory;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} id A UUID string identifying this quest.
         * @param {PatchedQuestRequest} [patchedQuestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyQuestsPartialUpdate: async (id: string, patchedQuestRequest?: PatchedQuestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyQuestsPartialUpdate', 'id', id)
            const localVarPath = `/api/story/quests/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedQuestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} id A UUID string identifying this quest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyQuestsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyQuestsRetrieve', 'id', id)
            const localVarPath = `/api/story/quests/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} id A UUID string identifying this quest.
         * @param {QuestRequest} questRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyQuestsUpdate: async (id: string, questRequest: QuestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyQuestsUpdate', 'id', id)
            // verify required parameter 'questRequest' is not null or undefined
            assertParamExists('storyQuestsUpdate', 'questRequest', questRequest)
            const localVarPath = `/api/story/quests/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {RewardRequest} rewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyRewardsCreate: async (rewardRequest: RewardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rewardRequest' is not null or undefined
            assertParamExists('storyRewardsCreate', 'rewardRequest', rewardRequest)
            const localVarPath = `/api/story/rewards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rewardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} id A UUID string identifying this reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyRewardsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyRewardsDestroy', 'id', id)
            const localVarPath = `/api/story/rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyRewardsList: async (ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/story/rewards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} id A UUID string identifying this reward.
         * @param {PatchedRewardRequest} [patchedRewardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyRewardsPartialUpdate: async (id: string, patchedRewardRequest?: PatchedRewardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyRewardsPartialUpdate', 'id', id)
            const localVarPath = `/api/story/rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedRewardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} id A UUID string identifying this reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyRewardsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyRewardsRetrieve', 'id', id)
            const localVarPath = `/api/story/rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} id A UUID string identifying this reward.
         * @param {RewardRequest} rewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyRewardsUpdate: async (id: string, rewardRequest: RewardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyRewardsUpdate', 'id', id)
            // verify required parameter 'rewardRequest' is not null or undefined
            assertParamExists('storyRewardsUpdate', 'rewardRequest', rewardRequest)
            const localVarPath = `/api/story/rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rewardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {StoryRequest} storyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesCreate: async (storyRequest: StoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storyRequest' is not null or undefined
            assertParamExists('storyStoriesCreate', 'storyRequest', storyRequest)
            const localVarPath = `/api/story/stories/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refuse to delete a story a campaign is still built on.  `Campaign.story` is `SET_NULL`, so deleting a story here would quietly detach every campaign using it — taking their objectives with it and leaving no trace of why. The campaign builder creates one story per campaign, so this is reachable by ordinary use, not a corner case.
         * @param {string} id A UUID string identifying this story.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyStoriesDestroy', 'id', id)
            const localVarPath = `/api/story/stories/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {boolean} [canonical] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesList: async (canonical?: boolean, ordering?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/story/stories/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (canonical !== undefined) {
                localVarQueryParameter['canonical'] = canonical;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {string} id A UUID string identifying this story.
         * @param {PatchedStoryRequest} [patchedStoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesPartialUpdate: async (id: string, patchedStoryRequest?: PatchedStoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyStoriesPartialUpdate', 'id', id)
            const localVarPath = `/api/story/stories/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedStoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {string} id A UUID string identifying this story.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyStoriesRetrieve', 'id', id)
            const localVarPath = `/api/story/stories/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set a story as canonical (requires owner review).
         * @param {string} id A UUID string identifying this story.
         * @param {StoryRequest} storyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesSetCanonicalCreate: async (id: string, storyRequest: StoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyStoriesSetCanonicalCreate', 'id', id)
            // verify required parameter 'storyRequest' is not null or undefined
            assertParamExists('storyStoriesSetCanonicalCreate', 'storyRequest', storyRequest)
            const localVarPath = `/api/story/stories/{id}/set_canonical/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove canonical status from a story.
         * @param {string} id A UUID string identifying this story.
         * @param {StoryRequest} storyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesUnsetCanonicalCreate: async (id: string, storyRequest: StoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyStoriesUnsetCanonicalCreate', 'id', id)
            // verify required parameter 'storyRequest' is not null or undefined
            assertParamExists('storyStoriesUnsetCanonicalCreate', 'storyRequest', storyRequest)
            const localVarPath = `/api/story/stories/{id}/unset_canonical/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {string} id A UUID string identifying this story.
         * @param {StoryRequest} storyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesUpdate: async (id: string, storyRequest: StoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyStoriesUpdate', 'id', id)
            // verify required parameter 'storyRequest' is not null or undefined
            assertParamExists('storyStoriesUpdate', 'storyRequest', storyRequest)
            const localVarPath = `/api/story/stories/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {TokenRewardRequest} tokenRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTokenRewardsCreate: async (tokenRewardRequest: TokenRewardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenRewardRequest' is not null or undefined
            assertParamExists('storyTokenRewardsCreate', 'tokenRewardRequest', tokenRewardRequest)
            const localVarPath = `/api/story/token-rewards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRewardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} id A UUID string identifying this token reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTokenRewardsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyTokenRewardsDestroy', 'id', id)
            const localVarPath = `/api/story/token-rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [reward] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTokenRewardsList: async (ordering?: string, reward?: string, token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/story/token-rewards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (reward !== undefined) {
                localVarQueryParameter['reward'] = reward;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} id A UUID string identifying this token reward.
         * @param {PatchedTokenRewardRequest} [patchedTokenRewardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTokenRewardsPartialUpdate: async (id: string, patchedTokenRewardRequest?: PatchedTokenRewardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyTokenRewardsPartialUpdate', 'id', id)
            const localVarPath = `/api/story/token-rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedTokenRewardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} id A UUID string identifying this token reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTokenRewardsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyTokenRewardsRetrieve', 'id', id)
            const localVarPath = `/api/story/token-rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} id A UUID string identifying this token reward.
         * @param {TokenRewardRequest} tokenRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTokenRewardsUpdate: async (id: string, tokenRewardRequest: TokenRewardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyTokenRewardsUpdate', 'id', id)
            // verify required parameter 'tokenRewardRequest' is not null or undefined
            assertParamExists('storyTokenRewardsUpdate', 'tokenRewardRequest', tokenRewardRequest)
            const localVarPath = `/api/story/token-rewards/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRewardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {TriggerRequest} triggerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTriggersCreate: async (triggerRequest: TriggerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'triggerRequest' is not null or undefined
            assertParamExists('storyTriggersCreate', 'triggerRequest', triggerRequest)
            const localVarPath = `/api/story/triggers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(triggerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} id A UUID string identifying this trigger.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTriggersDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyTriggersDestroy', 'id', id)
            const localVarPath = `/api/story/triggers/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} [gameObject] 
         * @param {string} [location] 
         * @param {string} [npc] 
         * @param {string} [position] 
         * @param {string} [search] A search term.
         * @param {TriggerTypeEnum} [type] * &#x60;search&#x60; - search * &#x60;kill&#x60; - kill * &#x60;interaction&#x60; - interaction * &#x60;position&#x60; - position * &#x60;useItem&#x60; - useItem * &#x60;useSkill&#x60; - useSkill * &#x60;custom&#x60; - custom
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTriggersList: async (gameObject?: string, location?: string, npc?: string, position?: string, search?: string, type?: TriggerTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/story/triggers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gameObject !== undefined) {
                localVarQueryParameter['game_object'] = gameObject;
            }

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }

            if (npc !== undefined) {
                localVarQueryParameter['npc'] = npc;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} id A UUID string identifying this trigger.
         * @param {PatchedTriggerRequest} [patchedTriggerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTriggersPartialUpdate: async (id: string, patchedTriggerRequest?: PatchedTriggerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyTriggersPartialUpdate', 'id', id)
            const localVarPath = `/api/story/triggers/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedTriggerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} id A UUID string identifying this trigger.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTriggersRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyTriggersRetrieve', 'id', id)
            const localVarPath = `/api/story/triggers/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} id A UUID string identifying this trigger.
         * @param {TriggerRequest} triggerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTriggersUpdate: async (id: string, triggerRequest: TriggerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storyTriggersUpdate', 'id', id)
            // verify required parameter 'triggerRequest' is not null or undefined
            assertParamExists('storyTriggersUpdate', 'triggerRequest', triggerRequest)
            const localVarPath = `/api/story/triggers/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(triggerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoryApi - functional programming interface
 * @export
 */
export const StoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoryApiAxiosParamCreator(configuration)
    return {
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {ChapterRequest} chapterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyChaptersCreate(chapterRequest: ChapterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Chapter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyChaptersCreate(chapterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyChaptersCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} id A UUID string identifying this chapter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyChaptersDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyChaptersDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyChaptersDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [story] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyChaptersList(ordering?: string, story?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Chapter>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyChaptersList(ordering, story, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyChaptersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} id A UUID string identifying this chapter.
         * @param {PatchedChapterRequest} [patchedChapterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyChaptersPartialUpdate(id: string, patchedChapterRequest?: PatchedChapterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Chapter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyChaptersPartialUpdate(id, patchedChapterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyChaptersPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} id A UUID string identifying this chapter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyChaptersRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Chapter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyChaptersRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyChaptersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} id A UUID string identifying this chapter.
         * @param {ChapterRequest} chapterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyChaptersUpdate(id: string, chapterRequest: ChapterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Chapter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyChaptersUpdate(id, chapterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyChaptersUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {ConditionRequest} [conditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyConditionsCreate(conditionRequest?: ConditionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Condition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyConditionsCreate(conditionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyConditionsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {string} id A UUID string identifying this condition.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyConditionsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyConditionsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyConditionsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {ConditionTypeEnum} [type] * &#x60;all&#x60; - All * &#x60;any&#x60; - Any * &#x60;none&#x60; - None
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyConditionsList(type?: ConditionTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Condition>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyConditionsList(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyConditionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {string} id A UUID string identifying this condition.
         * @param {PatchedConditionRequest} [patchedConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyConditionsPartialUpdate(id: string, patchedConditionRequest?: PatchedConditionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Condition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyConditionsPartialUpdate(id, patchedConditionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyConditionsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {string} id A UUID string identifying this condition.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyConditionsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Condition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyConditionsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyConditionsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {string} id A UUID string identifying this condition.
         * @param {ConditionRequest} [conditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyConditionsUpdate(id: string, conditionRequest?: ConditionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Condition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyConditionsUpdate(id, conditionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyConditionsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {EffectRewardRequest} effectRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyEffectRewardsCreate(effectRewardRequest: EffectRewardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EffectReward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyEffectRewardsCreate(effectRewardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyEffectRewardsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {string} id A UUID string identifying this effect reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyEffectRewardsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyEffectRewardsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyEffectRewardsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {EffectEnum} [effect] * &#x60;Knocked out&#x60; - Knocked out * &#x60;Coma&#x60; - Coma * &#x60;None&#x60; - None * &#x60;Burning&#x60; - Burning * &#x60;Poisoned&#x60; - Poisoned * &#x60;Sleeping&#x60; - Sleeping * &#x60;Confused&#x60; - Confused * &#x60;Paralyzed&#x60; - Paralyzed * &#x60;Fear&#x60; - Fear * &#x60;Slowness&#x60; - Slowness * &#x60;Cold&#x60; - Cold * &#x60;Cursed&#x60; - Cursed * &#x60;Blindness&#x60; - Blindness * &#x60;Haste&#x60; - Haste * &#x60;Regeneration&#x60; - Regeneration * &#x60;Blessed&#x60; - Blessed * &#x60;Arcane Surge&#x60; - Arcane Surge * &#x60;Marked&#x60; - Marked * &#x60;Bleeding&#x60; - Bleeding * &#x60;Weakened&#x60; - Weakened * &#x60;Enervated&#x60; - Enervated * &#x60;Dazzled&#x60; - Dazzled * &#x60;Exhausted&#x60; - Exhausted * &#x60;InchFromDeath&#x60; - InchFromDeath * &#x60;ComaShock&#x60; - ComaShock * &#x60;WellRested&#x60; - WellRested
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [reward] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyEffectRewardsList(effect?: EffectEnum, ordering?: string, reward?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EffectReward>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyEffectRewardsList(effect, ordering, reward, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyEffectRewardsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {string} id A UUID string identifying this effect reward.
         * @param {PatchedEffectRewardRequest} [patchedEffectRewardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyEffectRewardsPartialUpdate(id: string, patchedEffectRewardRequest?: PatchedEffectRewardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EffectReward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyEffectRewardsPartialUpdate(id, patchedEffectRewardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyEffectRewardsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {string} id A UUID string identifying this effect reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyEffectRewardsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EffectReward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyEffectRewardsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyEffectRewardsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {string} id A UUID string identifying this effect reward.
         * @param {EffectRewardRequest} effectRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyEffectRewardsUpdate(id: string, effectRewardRequest: EffectRewardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EffectReward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyEffectRewardsUpdate(id, effectRewardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyEffectRewardsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {ItemRewardRequest} itemRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyItemRewardsCreate(itemRewardRequest: ItemRewardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemReward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyItemRewardsCreate(itemRewardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyItemRewardsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} id A UUID string identifying this item reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyItemRewardsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyItemRewardsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyItemRewardsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} [item] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [reward] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyItemRewardsList(item?: string, ordering?: string, reward?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ItemReward>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyItemRewardsList(item, ordering, reward, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyItemRewardsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} id A UUID string identifying this item reward.
         * @param {PatchedItemRewardRequest} [patchedItemRewardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyItemRewardsPartialUpdate(id: string, patchedItemRewardRequest?: PatchedItemRewardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemReward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyItemRewardsPartialUpdate(id, patchedItemRewardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyItemRewardsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} id A UUID string identifying this item reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyItemRewardsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemReward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyItemRewardsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyItemRewardsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} id A UUID string identifying this item reward.
         * @param {ItemRewardRequest} itemRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyItemRewardsUpdate(id: string, itemRewardRequest: ItemRewardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemReward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyItemRewardsUpdate(id, itemRewardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyItemRewardsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {NoteRequest} noteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyNotesCreate(noteRequest: NoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyNotesCreate(noteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyNotesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} id A UUID string identifying this note.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyNotesDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyNotesDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyNotesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [quest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyNotesList(ordering?: string, quest?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Note>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyNotesList(ordering, quest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyNotesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} id A UUID string identifying this note.
         * @param {PatchedNoteRequest} [patchedNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyNotesPartialUpdate(id: string, patchedNoteRequest?: PatchedNoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyNotesPartialUpdate(id, patchedNoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyNotesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} id A UUID string identifying this note.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyNotesRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyNotesRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyNotesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} id A UUID string identifying this note.
         * @param {NoteRequest} noteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyNotesUpdate(id: string, noteRequest: NoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyNotesUpdate(id, noteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyNotesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {QuestRequest} questRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyQuestsCreate(questRequest: QuestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Quest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyQuestsCreate(questRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyQuestsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} id A UUID string identifying this quest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyQuestsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyQuestsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyQuestsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} [chapter] 
         * @param {string} [chapterStory] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyQuestsList(chapter?: string, chapterStory?: string, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Quest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyQuestsList(chapter, chapterStory, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyQuestsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} id A UUID string identifying this quest.
         * @param {PatchedQuestRequest} [patchedQuestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyQuestsPartialUpdate(id: string, patchedQuestRequest?: PatchedQuestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Quest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyQuestsPartialUpdate(id, patchedQuestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyQuestsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} id A UUID string identifying this quest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyQuestsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Quest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyQuestsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyQuestsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} id A UUID string identifying this quest.
         * @param {QuestRequest} questRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyQuestsUpdate(id: string, questRequest: QuestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Quest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyQuestsUpdate(id, questRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyQuestsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {RewardRequest} rewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyRewardsCreate(rewardRequest: RewardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyRewardsCreate(rewardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyRewardsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} id A UUID string identifying this reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyRewardsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyRewardsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyRewardsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyRewardsList(ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Reward>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyRewardsList(ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyRewardsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} id A UUID string identifying this reward.
         * @param {PatchedRewardRequest} [patchedRewardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyRewardsPartialUpdate(id: string, patchedRewardRequest?: PatchedRewardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyRewardsPartialUpdate(id, patchedRewardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyRewardsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} id A UUID string identifying this reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyRewardsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyRewardsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyRewardsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} id A UUID string identifying this reward.
         * @param {RewardRequest} rewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyRewardsUpdate(id: string, rewardRequest: RewardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyRewardsUpdate(id, rewardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyRewardsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {StoryRequest} storyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyStoriesCreate(storyRequest: StoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Story>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyStoriesCreate(storyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyStoriesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refuse to delete a story a campaign is still built on.  `Campaign.story` is `SET_NULL`, so deleting a story here would quietly detach every campaign using it — taking their objectives with it and leaving no trace of why. The campaign builder creates one story per campaign, so this is reachable by ordinary use, not a corner case.
         * @param {string} id A UUID string identifying this story.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyStoriesDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyStoriesDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyStoriesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {boolean} [canonical] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyStoriesList(canonical?: boolean, ordering?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Story>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyStoriesList(canonical, ordering, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyStoriesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {string} id A UUID string identifying this story.
         * @param {PatchedStoryRequest} [patchedStoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyStoriesPartialUpdate(id: string, patchedStoryRequest?: PatchedStoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Story>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyStoriesPartialUpdate(id, patchedStoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyStoriesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {string} id A UUID string identifying this story.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyStoriesRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoryDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyStoriesRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyStoriesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set a story as canonical (requires owner review).
         * @param {string} id A UUID string identifying this story.
         * @param {StoryRequest} storyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyStoriesSetCanonicalCreate(id: string, storyRequest: StoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Story>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyStoriesSetCanonicalCreate(id, storyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyStoriesSetCanonicalCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove canonical status from a story.
         * @param {string} id A UUID string identifying this story.
         * @param {StoryRequest} storyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyStoriesUnsetCanonicalCreate(id: string, storyRequest: StoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Story>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyStoriesUnsetCanonicalCreate(id, storyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyStoriesUnsetCanonicalCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {string} id A UUID string identifying this story.
         * @param {StoryRequest} storyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyStoriesUpdate(id: string, storyRequest: StoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Story>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyStoriesUpdate(id, storyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyStoriesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {TokenRewardRequest} tokenRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyTokenRewardsCreate(tokenRewardRequest: TokenRewardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenReward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyTokenRewardsCreate(tokenRewardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyTokenRewardsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} id A UUID string identifying this token reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyTokenRewardsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyTokenRewardsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyTokenRewardsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [reward] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyTokenRewardsList(ordering?: string, reward?: string, token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TokenReward>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyTokenRewardsList(ordering, reward, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyTokenRewardsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} id A UUID string identifying this token reward.
         * @param {PatchedTokenRewardRequest} [patchedTokenRewardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyTokenRewardsPartialUpdate(id: string, patchedTokenRewardRequest?: PatchedTokenRewardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenReward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyTokenRewardsPartialUpdate(id, patchedTokenRewardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyTokenRewardsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} id A UUID string identifying this token reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyTokenRewardsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenReward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyTokenRewardsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyTokenRewardsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} id A UUID string identifying this token reward.
         * @param {TokenRewardRequest} tokenRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyTokenRewardsUpdate(id: string, tokenRewardRequest: TokenRewardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenReward>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyTokenRewardsUpdate(id, tokenRewardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyTokenRewardsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {TriggerRequest} triggerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyTriggersCreate(triggerRequest: TriggerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Trigger>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyTriggersCreate(triggerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyTriggersCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} id A UUID string identifying this trigger.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyTriggersDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyTriggersDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyTriggersDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} [gameObject] 
         * @param {string} [location] 
         * @param {string} [npc] 
         * @param {string} [position] 
         * @param {string} [search] A search term.
         * @param {TriggerTypeEnum} [type] * &#x60;search&#x60; - search * &#x60;kill&#x60; - kill * &#x60;interaction&#x60; - interaction * &#x60;position&#x60; - position * &#x60;useItem&#x60; - useItem * &#x60;useSkill&#x60; - useSkill * &#x60;custom&#x60; - custom
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyTriggersList(gameObject?: string, location?: string, npc?: string, position?: string, search?: string, type?: TriggerTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Trigger>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyTriggersList(gameObject, location, npc, position, search, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyTriggersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} id A UUID string identifying this trigger.
         * @param {PatchedTriggerRequest} [patchedTriggerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyTriggersPartialUpdate(id: string, patchedTriggerRequest?: PatchedTriggerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Trigger>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyTriggersPartialUpdate(id, patchedTriggerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyTriggersPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} id A UUID string identifying this trigger.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyTriggersRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Trigger>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyTriggersRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyTriggersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} id A UUID string identifying this trigger.
         * @param {TriggerRequest} triggerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyTriggersUpdate(id: string, triggerRequest: TriggerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Trigger>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyTriggersUpdate(id, triggerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoryApi.storyTriggersUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StoryApi - factory interface
 * @export
 */
export const StoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoryApiFp(configuration)
    return {
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {ChapterRequest} chapterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyChaptersCreate(chapterRequest: ChapterRequest, options?: any): AxiosPromise<Chapter> {
            return localVarFp.storyChaptersCreate(chapterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} id A UUID string identifying this chapter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyChaptersDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.storyChaptersDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [story] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyChaptersList(ordering?: string, story?: string, options?: any): AxiosPromise<Array<Chapter>> {
            return localVarFp.storyChaptersList(ordering, story, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} id A UUID string identifying this chapter.
         * @param {PatchedChapterRequest} [patchedChapterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyChaptersPartialUpdate(id: string, patchedChapterRequest?: PatchedChapterRequest, options?: any): AxiosPromise<Chapter> {
            return localVarFp.storyChaptersPartialUpdate(id, patchedChapterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} id A UUID string identifying this chapter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyChaptersRetrieve(id: string, options?: any): AxiosPromise<Chapter> {
            return localVarFp.storyChaptersRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage chapters within stories.
         * @param {string} id A UUID string identifying this chapter.
         * @param {ChapterRequest} chapterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyChaptersUpdate(id: string, chapterRequest: ChapterRequest, options?: any): AxiosPromise<Chapter> {
            return localVarFp.storyChaptersUpdate(id, chapterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {ConditionRequest} [conditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyConditionsCreate(conditionRequest?: ConditionRequest, options?: any): AxiosPromise<Condition> {
            return localVarFp.storyConditionsCreate(conditionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {string} id A UUID string identifying this condition.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyConditionsDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.storyConditionsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {ConditionTypeEnum} [type] * &#x60;all&#x60; - All * &#x60;any&#x60; - Any * &#x60;none&#x60; - None
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyConditionsList(type?: ConditionTypeEnum, options?: any): AxiosPromise<Array<Condition>> {
            return localVarFp.storyConditionsList(type, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {string} id A UUID string identifying this condition.
         * @param {PatchedConditionRequest} [patchedConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyConditionsPartialUpdate(id: string, patchedConditionRequest?: PatchedConditionRequest, options?: any): AxiosPromise<Condition> {
            return localVarFp.storyConditionsPartialUpdate(id, patchedConditionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {string} id A UUID string identifying this condition.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyConditionsRetrieve(id: string, options?: any): AxiosPromise<Condition> {
            return localVarFp.storyConditionsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage conditions for quest starters and objectives.
         * @param {string} id A UUID string identifying this condition.
         * @param {ConditionRequest} [conditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyConditionsUpdate(id: string, conditionRequest?: ConditionRequest, options?: any): AxiosPromise<Condition> {
            return localVarFp.storyConditionsUpdate(id, conditionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {EffectRewardRequest} effectRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyEffectRewardsCreate(effectRewardRequest: EffectRewardRequest, options?: any): AxiosPromise<EffectReward> {
            return localVarFp.storyEffectRewardsCreate(effectRewardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {string} id A UUID string identifying this effect reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyEffectRewardsDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.storyEffectRewardsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {EffectEnum} [effect] * &#x60;Knocked out&#x60; - Knocked out * &#x60;Coma&#x60; - Coma * &#x60;None&#x60; - None * &#x60;Burning&#x60; - Burning * &#x60;Poisoned&#x60; - Poisoned * &#x60;Sleeping&#x60; - Sleeping * &#x60;Confused&#x60; - Confused * &#x60;Paralyzed&#x60; - Paralyzed * &#x60;Fear&#x60; - Fear * &#x60;Slowness&#x60; - Slowness * &#x60;Cold&#x60; - Cold * &#x60;Cursed&#x60; - Cursed * &#x60;Blindness&#x60; - Blindness * &#x60;Haste&#x60; - Haste * &#x60;Regeneration&#x60; - Regeneration * &#x60;Blessed&#x60; - Blessed * &#x60;Arcane Surge&#x60; - Arcane Surge * &#x60;Marked&#x60; - Marked * &#x60;Bleeding&#x60; - Bleeding * &#x60;Weakened&#x60; - Weakened * &#x60;Enervated&#x60; - Enervated * &#x60;Dazzled&#x60; - Dazzled * &#x60;Exhausted&#x60; - Exhausted * &#x60;InchFromDeath&#x60; - InchFromDeath * &#x60;ComaShock&#x60; - ComaShock * &#x60;WellRested&#x60; - WellRested
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [reward] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyEffectRewardsList(effect?: EffectEnum, ordering?: string, reward?: string, options?: any): AxiosPromise<Array<EffectReward>> {
            return localVarFp.storyEffectRewardsList(effect, ordering, reward, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {string} id A UUID string identifying this effect reward.
         * @param {PatchedEffectRewardRequest} [patchedEffectRewardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyEffectRewardsPartialUpdate(id: string, patchedEffectRewardRequest?: PatchedEffectRewardRequest, options?: any): AxiosPromise<EffectReward> {
            return localVarFp.storyEffectRewardsPartialUpdate(id, patchedEffectRewardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {string} id A UUID string identifying this effect reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyEffectRewardsRetrieve(id: string, options?: any): AxiosPromise<EffectReward> {
            return localVarFp.storyEffectRewardsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage effect rewards.
         * @param {string} id A UUID string identifying this effect reward.
         * @param {EffectRewardRequest} effectRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyEffectRewardsUpdate(id: string, effectRewardRequest: EffectRewardRequest, options?: any): AxiosPromise<EffectReward> {
            return localVarFp.storyEffectRewardsUpdate(id, effectRewardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {ItemRewardRequest} itemRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyItemRewardsCreate(itemRewardRequest: ItemRewardRequest, options?: any): AxiosPromise<ItemReward> {
            return localVarFp.storyItemRewardsCreate(itemRewardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} id A UUID string identifying this item reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyItemRewardsDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.storyItemRewardsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} [item] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [reward] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyItemRewardsList(item?: string, ordering?: string, reward?: string, options?: any): AxiosPromise<Array<ItemReward>> {
            return localVarFp.storyItemRewardsList(item, ordering, reward, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} id A UUID string identifying this item reward.
         * @param {PatchedItemRewardRequest} [patchedItemRewardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyItemRewardsPartialUpdate(id: string, patchedItemRewardRequest?: PatchedItemRewardRequest, options?: any): AxiosPromise<ItemReward> {
            return localVarFp.storyItemRewardsPartialUpdate(id, patchedItemRewardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} id A UUID string identifying this item reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyItemRewardsRetrieve(id: string, options?: any): AxiosPromise<ItemReward> {
            return localVarFp.storyItemRewardsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage item rewards.
         * @param {string} id A UUID string identifying this item reward.
         * @param {ItemRewardRequest} itemRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyItemRewardsUpdate(id: string, itemRewardRequest: ItemRewardRequest, options?: any): AxiosPromise<ItemReward> {
            return localVarFp.storyItemRewardsUpdate(id, itemRewardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {NoteRequest} noteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyNotesCreate(noteRequest: NoteRequest, options?: any): AxiosPromise<Note> {
            return localVarFp.storyNotesCreate(noteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} id A UUID string identifying this note.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyNotesDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.storyNotesDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [quest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyNotesList(ordering?: string, quest?: string, options?: any): AxiosPromise<Array<Note>> {
            return localVarFp.storyNotesList(ordering, quest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} id A UUID string identifying this note.
         * @param {PatchedNoteRequest} [patchedNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyNotesPartialUpdate(id: string, patchedNoteRequest?: PatchedNoteRequest, options?: any): AxiosPromise<Note> {
            return localVarFp.storyNotesPartialUpdate(id, patchedNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} id A UUID string identifying this note.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyNotesRetrieve(id: string, options?: any): AxiosPromise<Note> {
            return localVarFp.storyNotesRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage quest notes.
         * @param {string} id A UUID string identifying this note.
         * @param {NoteRequest} noteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyNotesUpdate(id: string, noteRequest: NoteRequest, options?: any): AxiosPromise<Note> {
            return localVarFp.storyNotesUpdate(id, noteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {QuestRequest} questRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyQuestsCreate(questRequest: QuestRequest, options?: any): AxiosPromise<Quest> {
            return localVarFp.storyQuestsCreate(questRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} id A UUID string identifying this quest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyQuestsDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.storyQuestsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} [chapter] 
         * @param {string} [chapterStory] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyQuestsList(chapter?: string, chapterStory?: string, ordering?: string, options?: any): AxiosPromise<Array<Quest>> {
            return localVarFp.storyQuestsList(chapter, chapterStory, ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} id A UUID string identifying this quest.
         * @param {PatchedQuestRequest} [patchedQuestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyQuestsPartialUpdate(id: string, patchedQuestRequest?: PatchedQuestRequest, options?: any): AxiosPromise<Quest> {
            return localVarFp.storyQuestsPartialUpdate(id, patchedQuestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} id A UUID string identifying this quest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyQuestsRetrieve(id: string, options?: any): AxiosPromise<Quest> {
            return localVarFp.storyQuestsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage quests within chapters.
         * @param {string} id A UUID string identifying this quest.
         * @param {QuestRequest} questRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyQuestsUpdate(id: string, questRequest: QuestRequest, options?: any): AxiosPromise<Quest> {
            return localVarFp.storyQuestsUpdate(id, questRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {RewardRequest} rewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyRewardsCreate(rewardRequest: RewardRequest, options?: any): AxiosPromise<Reward> {
            return localVarFp.storyRewardsCreate(rewardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} id A UUID string identifying this reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyRewardsDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.storyRewardsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyRewardsList(ordering?: string, options?: any): AxiosPromise<Array<Reward>> {
            return localVarFp.storyRewardsList(ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} id A UUID string identifying this reward.
         * @param {PatchedRewardRequest} [patchedRewardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyRewardsPartialUpdate(id: string, patchedRewardRequest?: PatchedRewardRequest, options?: any): AxiosPromise<Reward> {
            return localVarFp.storyRewardsPartialUpdate(id, patchedRewardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} id A UUID string identifying this reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyRewardsRetrieve(id: string, options?: any): AxiosPromise<Reward> {
            return localVarFp.storyRewardsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage rewards for quest success/failure.
         * @param {string} id A UUID string identifying this reward.
         * @param {RewardRequest} rewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyRewardsUpdate(id: string, rewardRequest: RewardRequest, options?: any): AxiosPromise<Reward> {
            return localVarFp.storyRewardsUpdate(id, rewardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {StoryRequest} storyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesCreate(storyRequest: StoryRequest, options?: any): AxiosPromise<Story> {
            return localVarFp.storyStoriesCreate(storyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Refuse to delete a story a campaign is still built on.  `Campaign.story` is `SET_NULL`, so deleting a story here would quietly detach every campaign using it — taking their objectives with it and leaving no trace of why. The campaign builder creates one story per campaign, so this is reachable by ordinary use, not a corner case.
         * @param {string} id A UUID string identifying this story.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.storyStoriesDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {boolean} [canonical] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesList(canonical?: boolean, ordering?: string, search?: string, options?: any): AxiosPromise<Array<Story>> {
            return localVarFp.storyStoriesList(canonical, ordering, search, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {string} id A UUID string identifying this story.
         * @param {PatchedStoryRequest} [patchedStoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesPartialUpdate(id: string, patchedStoryRequest?: PatchedStoryRequest, options?: any): AxiosPromise<Story> {
            return localVarFp.storyStoriesPartialUpdate(id, patchedStoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {string} id A UUID string identifying this story.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesRetrieve(id: string, options?: any): AxiosPromise<StoryDetail> {
            return localVarFp.storyStoriesRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Set a story as canonical (requires owner review).
         * @param {string} id A UUID string identifying this story.
         * @param {StoryRequest} storyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesSetCanonicalCreate(id: string, storyRequest: StoryRequest, options?: any): AxiosPromise<Story> {
            return localVarFp.storyStoriesSetCanonicalCreate(id, storyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove canonical status from a story.
         * @param {string} id A UUID string identifying this story.
         * @param {StoryRequest} storyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesUnsetCanonicalCreate(id: string, storyRequest: StoryRequest, options?: any): AxiosPromise<Story> {
            return localVarFp.storyStoriesUnsetCanonicalCreate(id, storyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
         * @param {string} id A UUID string identifying this story.
         * @param {StoryRequest} storyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyStoriesUpdate(id: string, storyRequest: StoryRequest, options?: any): AxiosPromise<Story> {
            return localVarFp.storyStoriesUpdate(id, storyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {TokenRewardRequest} tokenRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTokenRewardsCreate(tokenRewardRequest: TokenRewardRequest, options?: any): AxiosPromise<TokenReward> {
            return localVarFp.storyTokenRewardsCreate(tokenRewardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} id A UUID string identifying this token reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTokenRewardsDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.storyTokenRewardsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [reward] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTokenRewardsList(ordering?: string, reward?: string, token?: string, options?: any): AxiosPromise<Array<TokenReward>> {
            return localVarFp.storyTokenRewardsList(ordering, reward, token, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} id A UUID string identifying this token reward.
         * @param {PatchedTokenRewardRequest} [patchedTokenRewardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTokenRewardsPartialUpdate(id: string, patchedTokenRewardRequest?: PatchedTokenRewardRequest, options?: any): AxiosPromise<TokenReward> {
            return localVarFp.storyTokenRewardsPartialUpdate(id, patchedTokenRewardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} id A UUID string identifying this token reward.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTokenRewardsRetrieve(id: string, options?: any): AxiosPromise<TokenReward> {
            return localVarFp.storyTokenRewardsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage token rewards.
         * @param {string} id A UUID string identifying this token reward.
         * @param {TokenRewardRequest} tokenRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTokenRewardsUpdate(id: string, tokenRewardRequest: TokenRewardRequest, options?: any): AxiosPromise<TokenReward> {
            return localVarFp.storyTokenRewardsUpdate(id, tokenRewardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {TriggerRequest} triggerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTriggersCreate(triggerRequest: TriggerRequest, options?: any): AxiosPromise<Trigger> {
            return localVarFp.storyTriggersCreate(triggerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} id A UUID string identifying this trigger.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTriggersDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.storyTriggersDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} [gameObject] 
         * @param {string} [location] 
         * @param {string} [npc] 
         * @param {string} [position] 
         * @param {string} [search] A search term.
         * @param {TriggerTypeEnum} [type] * &#x60;search&#x60; - search * &#x60;kill&#x60; - kill * &#x60;interaction&#x60; - interaction * &#x60;position&#x60; - position * &#x60;useItem&#x60; - useItem * &#x60;useSkill&#x60; - useSkill * &#x60;custom&#x60; - custom
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTriggersList(gameObject?: string, location?: string, npc?: string, position?: string, search?: string, type?: TriggerTypeEnum, options?: any): AxiosPromise<Array<Trigger>> {
            return localVarFp.storyTriggersList(gameObject, location, npc, position, search, type, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} id A UUID string identifying this trigger.
         * @param {PatchedTriggerRequest} [patchedTriggerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTriggersPartialUpdate(id: string, patchedTriggerRequest?: PatchedTriggerRequest, options?: any): AxiosPromise<Trigger> {
            return localVarFp.storyTriggersPartialUpdate(id, patchedTriggerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} id A UUID string identifying this trigger.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTriggersRetrieve(id: string, options?: any): AxiosPromise<Trigger> {
            return localVarFp.storyTriggersRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for game masters to manage triggers for quest conditions.
         * @param {string} id A UUID string identifying this trigger.
         * @param {TriggerRequest} triggerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyTriggersUpdate(id: string, triggerRequest: TriggerRequest, options?: any): AxiosPromise<Trigger> {
            return localVarFp.storyTriggersUpdate(id, triggerRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StoryApi - object-oriented interface
 * @export
 * @class StoryApi
 * @extends {BaseAPI}
 */
export class StoryApi extends BaseAPI {
    /**
     * ViewSet for game masters to manage chapters within stories.
     * @param {ChapterRequest} chapterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyChaptersCreate(chapterRequest: ChapterRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyChaptersCreate(chapterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage chapters within stories.
     * @param {string} id A UUID string identifying this chapter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyChaptersDestroy(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyChaptersDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage chapters within stories.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [story] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyChaptersList(ordering?: string, story?: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyChaptersList(ordering, story, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage chapters within stories.
     * @param {string} id A UUID string identifying this chapter.
     * @param {PatchedChapterRequest} [patchedChapterRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyChaptersPartialUpdate(id: string, patchedChapterRequest?: PatchedChapterRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyChaptersPartialUpdate(id, patchedChapterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage chapters within stories.
     * @param {string} id A UUID string identifying this chapter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyChaptersRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyChaptersRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage chapters within stories.
     * @param {string} id A UUID string identifying this chapter.
     * @param {ChapterRequest} chapterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyChaptersUpdate(id: string, chapterRequest: ChapterRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyChaptersUpdate(id, chapterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage conditions for quest starters and objectives.
     * @param {ConditionRequest} [conditionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyConditionsCreate(conditionRequest?: ConditionRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyConditionsCreate(conditionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage conditions for quest starters and objectives.
     * @param {string} id A UUID string identifying this condition.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyConditionsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyConditionsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage conditions for quest starters and objectives.
     * @param {ConditionTypeEnum} [type] * &#x60;all&#x60; - All * &#x60;any&#x60; - Any * &#x60;none&#x60; - None
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyConditionsList(type?: ConditionTypeEnum, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyConditionsList(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage conditions for quest starters and objectives.
     * @param {string} id A UUID string identifying this condition.
     * @param {PatchedConditionRequest} [patchedConditionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyConditionsPartialUpdate(id: string, patchedConditionRequest?: PatchedConditionRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyConditionsPartialUpdate(id, patchedConditionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage conditions for quest starters and objectives.
     * @param {string} id A UUID string identifying this condition.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyConditionsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyConditionsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage conditions for quest starters and objectives.
     * @param {string} id A UUID string identifying this condition.
     * @param {ConditionRequest} [conditionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyConditionsUpdate(id: string, conditionRequest?: ConditionRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyConditionsUpdate(id, conditionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage effect rewards.
     * @param {EffectRewardRequest} effectRewardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyEffectRewardsCreate(effectRewardRequest: EffectRewardRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyEffectRewardsCreate(effectRewardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage effect rewards.
     * @param {string} id A UUID string identifying this effect reward.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyEffectRewardsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyEffectRewardsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage effect rewards.
     * @param {EffectEnum} [effect] * &#x60;Knocked out&#x60; - Knocked out * &#x60;Coma&#x60; - Coma * &#x60;None&#x60; - None * &#x60;Burning&#x60; - Burning * &#x60;Poisoned&#x60; - Poisoned * &#x60;Sleeping&#x60; - Sleeping * &#x60;Confused&#x60; - Confused * &#x60;Paralyzed&#x60; - Paralyzed * &#x60;Fear&#x60; - Fear * &#x60;Slowness&#x60; - Slowness * &#x60;Cold&#x60; - Cold * &#x60;Cursed&#x60; - Cursed * &#x60;Blindness&#x60; - Blindness * &#x60;Haste&#x60; - Haste * &#x60;Regeneration&#x60; - Regeneration * &#x60;Blessed&#x60; - Blessed * &#x60;Arcane Surge&#x60; - Arcane Surge * &#x60;Marked&#x60; - Marked * &#x60;Bleeding&#x60; - Bleeding * &#x60;Weakened&#x60; - Weakened * &#x60;Enervated&#x60; - Enervated * &#x60;Dazzled&#x60; - Dazzled * &#x60;Exhausted&#x60; - Exhausted * &#x60;InchFromDeath&#x60; - InchFromDeath * &#x60;ComaShock&#x60; - ComaShock * &#x60;WellRested&#x60; - WellRested
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [reward] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyEffectRewardsList(effect?: EffectEnum, ordering?: string, reward?: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyEffectRewardsList(effect, ordering, reward, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage effect rewards.
     * @param {string} id A UUID string identifying this effect reward.
     * @param {PatchedEffectRewardRequest} [patchedEffectRewardRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyEffectRewardsPartialUpdate(id: string, patchedEffectRewardRequest?: PatchedEffectRewardRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyEffectRewardsPartialUpdate(id, patchedEffectRewardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage effect rewards.
     * @param {string} id A UUID string identifying this effect reward.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyEffectRewardsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyEffectRewardsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage effect rewards.
     * @param {string} id A UUID string identifying this effect reward.
     * @param {EffectRewardRequest} effectRewardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyEffectRewardsUpdate(id: string, effectRewardRequest: EffectRewardRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyEffectRewardsUpdate(id, effectRewardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage item rewards.
     * @param {ItemRewardRequest} itemRewardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyItemRewardsCreate(itemRewardRequest: ItemRewardRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyItemRewardsCreate(itemRewardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage item rewards.
     * @param {string} id A UUID string identifying this item reward.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyItemRewardsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyItemRewardsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage item rewards.
     * @param {string} [item] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [reward] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyItemRewardsList(item?: string, ordering?: string, reward?: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyItemRewardsList(item, ordering, reward, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage item rewards.
     * @param {string} id A UUID string identifying this item reward.
     * @param {PatchedItemRewardRequest} [patchedItemRewardRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyItemRewardsPartialUpdate(id: string, patchedItemRewardRequest?: PatchedItemRewardRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyItemRewardsPartialUpdate(id, patchedItemRewardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage item rewards.
     * @param {string} id A UUID string identifying this item reward.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyItemRewardsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyItemRewardsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage item rewards.
     * @param {string} id A UUID string identifying this item reward.
     * @param {ItemRewardRequest} itemRewardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyItemRewardsUpdate(id: string, itemRewardRequest: ItemRewardRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyItemRewardsUpdate(id, itemRewardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage quest notes.
     * @param {NoteRequest} noteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyNotesCreate(noteRequest: NoteRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyNotesCreate(noteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage quest notes.
     * @param {string} id A UUID string identifying this note.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyNotesDestroy(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyNotesDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage quest notes.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [quest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyNotesList(ordering?: string, quest?: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyNotesList(ordering, quest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage quest notes.
     * @param {string} id A UUID string identifying this note.
     * @param {PatchedNoteRequest} [patchedNoteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyNotesPartialUpdate(id: string, patchedNoteRequest?: PatchedNoteRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyNotesPartialUpdate(id, patchedNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage quest notes.
     * @param {string} id A UUID string identifying this note.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyNotesRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyNotesRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage quest notes.
     * @param {string} id A UUID string identifying this note.
     * @param {NoteRequest} noteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyNotesUpdate(id: string, noteRequest: NoteRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyNotesUpdate(id, noteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage quests within chapters.
     * @param {QuestRequest} questRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyQuestsCreate(questRequest: QuestRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyQuestsCreate(questRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage quests within chapters.
     * @param {string} id A UUID string identifying this quest.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyQuestsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyQuestsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage quests within chapters.
     * @param {string} [chapter] 
     * @param {string} [chapterStory] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyQuestsList(chapter?: string, chapterStory?: string, ordering?: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyQuestsList(chapter, chapterStory, ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage quests within chapters.
     * @param {string} id A UUID string identifying this quest.
     * @param {PatchedQuestRequest} [patchedQuestRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyQuestsPartialUpdate(id: string, patchedQuestRequest?: PatchedQuestRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyQuestsPartialUpdate(id, patchedQuestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage quests within chapters.
     * @param {string} id A UUID string identifying this quest.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyQuestsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyQuestsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage quests within chapters.
     * @param {string} id A UUID string identifying this quest.
     * @param {QuestRequest} questRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyQuestsUpdate(id: string, questRequest: QuestRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyQuestsUpdate(id, questRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage rewards for quest success/failure.
     * @param {RewardRequest} rewardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyRewardsCreate(rewardRequest: RewardRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyRewardsCreate(rewardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage rewards for quest success/failure.
     * @param {string} id A UUID string identifying this reward.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyRewardsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyRewardsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage rewards for quest success/failure.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyRewardsList(ordering?: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyRewardsList(ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage rewards for quest success/failure.
     * @param {string} id A UUID string identifying this reward.
     * @param {PatchedRewardRequest} [patchedRewardRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyRewardsPartialUpdate(id: string, patchedRewardRequest?: PatchedRewardRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyRewardsPartialUpdate(id, patchedRewardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage rewards for quest success/failure.
     * @param {string} id A UUID string identifying this reward.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyRewardsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyRewardsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage rewards for quest success/failure.
     * @param {string} id A UUID string identifying this reward.
     * @param {RewardRequest} rewardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyRewardsUpdate(id: string, rewardRequest: RewardRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyRewardsUpdate(id, rewardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
     * @param {StoryRequest} storyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyStoriesCreate(storyRequest: StoryRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyStoriesCreate(storyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refuse to delete a story a campaign is still built on.  `Campaign.story` is `SET_NULL`, so deleting a story here would quietly detach every campaign using it — taking their objectives with it and leaving no trace of why. The campaign builder creates one story per campaign, so this is reachable by ordinary use, not a corner case.
     * @param {string} id A UUID string identifying this story.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyStoriesDestroy(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyStoriesDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
     * @param {boolean} [canonical] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyStoriesList(canonical?: boolean, ordering?: string, search?: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyStoriesList(canonical, ordering, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
     * @param {string} id A UUID string identifying this story.
     * @param {PatchedStoryRequest} [patchedStoryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyStoriesPartialUpdate(id: string, patchedStoryRequest?: PatchedStoryRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyStoriesPartialUpdate(id, patchedStoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
     * @param {string} id A UUID string identifying this story.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyStoriesRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyStoriesRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set a story as canonical (requires owner review).
     * @param {string} id A UUID string identifying this story.
     * @param {StoryRequest} storyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyStoriesSetCanonicalCreate(id: string, storyRequest: StoryRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyStoriesSetCanonicalCreate(id, storyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove canonical status from a story.
     * @param {string} id A UUID string identifying this story.
     * @param {StoryRequest} storyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyStoriesUnsetCanonicalCreate(id: string, storyRequest: StoryRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyStoriesUnsetCanonicalCreate(id, storyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage stories.  This viewset provides operations for: - Listing, retrieving, creating, updating, and deleting stories - Managing story canonical status - Filtering stories by tags and canonical status
     * @param {string} id A UUID string identifying this story.
     * @param {StoryRequest} storyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyStoriesUpdate(id: string, storyRequest: StoryRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyStoriesUpdate(id, storyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage token rewards.
     * @param {TokenRewardRequest} tokenRewardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyTokenRewardsCreate(tokenRewardRequest: TokenRewardRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyTokenRewardsCreate(tokenRewardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage token rewards.
     * @param {string} id A UUID string identifying this token reward.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyTokenRewardsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyTokenRewardsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage token rewards.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [reward] 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyTokenRewardsList(ordering?: string, reward?: string, token?: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyTokenRewardsList(ordering, reward, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage token rewards.
     * @param {string} id A UUID string identifying this token reward.
     * @param {PatchedTokenRewardRequest} [patchedTokenRewardRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyTokenRewardsPartialUpdate(id: string, patchedTokenRewardRequest?: PatchedTokenRewardRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyTokenRewardsPartialUpdate(id, patchedTokenRewardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage token rewards.
     * @param {string} id A UUID string identifying this token reward.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyTokenRewardsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyTokenRewardsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage token rewards.
     * @param {string} id A UUID string identifying this token reward.
     * @param {TokenRewardRequest} tokenRewardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyTokenRewardsUpdate(id: string, tokenRewardRequest: TokenRewardRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyTokenRewardsUpdate(id, tokenRewardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage triggers for quest conditions.
     * @param {TriggerRequest} triggerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyTriggersCreate(triggerRequest: TriggerRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyTriggersCreate(triggerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage triggers for quest conditions.
     * @param {string} id A UUID string identifying this trigger.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyTriggersDestroy(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyTriggersDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage triggers for quest conditions.
     * @param {string} [gameObject] 
     * @param {string} [location] 
     * @param {string} [npc] 
     * @param {string} [position] 
     * @param {string} [search] A search term.
     * @param {TriggerTypeEnum} [type] * &#x60;search&#x60; - search * &#x60;kill&#x60; - kill * &#x60;interaction&#x60; - interaction * &#x60;position&#x60; - position * &#x60;useItem&#x60; - useItem * &#x60;useSkill&#x60; - useSkill * &#x60;custom&#x60; - custom
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyTriggersList(gameObject?: string, location?: string, npc?: string, position?: string, search?: string, type?: TriggerTypeEnum, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyTriggersList(gameObject, location, npc, position, search, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage triggers for quest conditions.
     * @param {string} id A UUID string identifying this trigger.
     * @param {PatchedTriggerRequest} [patchedTriggerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyTriggersPartialUpdate(id: string, patchedTriggerRequest?: PatchedTriggerRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyTriggersPartialUpdate(id, patchedTriggerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage triggers for quest conditions.
     * @param {string} id A UUID string identifying this trigger.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyTriggersRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyTriggersRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for game masters to manage triggers for quest conditions.
     * @param {string} id A UUID string identifying this trigger.
     * @param {TriggerRequest} triggerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoryApi
     */
    public storyTriggersUpdate(id: string, triggerRequest: TriggerRequest, options?: RawAxiosRequestConfig) {
        return StoryApiFp(this.configuration).storyTriggersUpdate(id, triggerRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TacticalMapTemplatesApi - axios parameter creator
 * @export
 */
export const TacticalMapTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create new template via JSON. Use import_png for PNG uploads.
         * @summary Create tactical map template
         * @param {TacticalMapTemplateCreateRequest} tacticalMapTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesCreate: async (tacticalMapTemplateCreateRequest: TacticalMapTemplateCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tacticalMapTemplateCreateRequest' is not null or undefined
            assertParamExists('tacticalmapTemplatesCreate', 'tacticalMapTemplateCreateRequest', tacticalMapTemplateCreateRequest)
            const localVarPath = `/api/tacticalmap/templates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tacticalMapTemplateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete template (admin only)
         * @summary Delete template
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('tacticalmapTemplatesDestroy', 'id', id)
            const localVarPath = `/api/tacticalmap/templates/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export tactical map template as PNG with embedded metadata. Returns PNG file with map data in tEXt chunk.
         * @summary Export template as PNG
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesExportPngRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('tacticalmapTemplatesExportPngRetrieve', 'id', id)
            const localVarPath = `/api/tacticalmap/templates/{id}/export_png/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import a tactical map from PNG file with embedded JSON metadata. PNG must contain map data in tEXt chunk. Returns created template on success.
         * @summary Import PNG with metadata
         * @param {File} [file] 
         * @param {string | null} [overrideName] 
         * @param {boolean} [overridePublished] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesImportPngCreate: async (file?: File, overrideName?: string | null, overridePublished?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tacticalmap/templates/import_png/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (overrideName !== undefined) { 
                localVarFormParams.append('override_name', overrideName as any);
            }
    
            if (overridePublished !== undefined) { 
                localVarFormParams.append('override_published', String(overridePublished) as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve paginated list of tactical map templates with filtering
         * @summary List tactical map templates
         * @param {boolean} [canonical] 
         * @param {CategoryEnum} [category] Map category for organization  * &#x60;dungeon&#x60; - Dungeon * &#x60;wilderness&#x60; - Wilderness * &#x60;urban&#x60; - Urban * &#x60;indoor&#x60; - Indoor * &#x60;arena&#x60; - Arena * &#x60;ship&#x60; - Ship/Vehicle * &#x60;planar&#x60; - Planar/Dimensional * &#x60;custom&#x60; - Custom
         * @param {DifficultyRatingEnum} [difficultyRating] Challenge rating / difficulty level  * &#x60;easy&#x60; - Easy (CR 1-5) * &#x60;medium&#x60; - Medium (CR 6-10) * &#x60;hard&#x60; - Hard (CR 11-15) * &#x60;deadly&#x60; - Deadly (CR 16+) * &#x60;custom&#x60; - Custom
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {boolean} [published] 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesList: async (canonical?: boolean, category?: CategoryEnum, difficultyRating?: DifficultyRatingEnum, ordering?: string, published?: boolean, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tacticalmap/templates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (canonical !== undefined) {
                localVarQueryParameter['canonical'] = canonical;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (difficultyRating !== undefined) {
                localVarQueryParameter['difficulty_rating'] = difficultyRating;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (published !== undefined) {
                localVarQueryParameter['published'] = published;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update specific fields of template
         * @summary Partially update template
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {PatchedTacticalMapTemplateCreateRequest} [patchedTacticalMapTemplateCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesPartialUpdate: async (id: string, patchedTacticalMapTemplateCreateRequest?: PatchedTacticalMapTemplateCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('tacticalmapTemplatesPartialUpdate', 'id', id)
            const localVarPath = `/api/tacticalmap/templates/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedTacticalMapTemplateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed information about a specific template including full map_data
         * @summary Get tactical map template details
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('tacticalmapTemplatesRetrieve', 'id', id)
            const localVarPath = `/api/tacticalmap/templates/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * v3 scene keys plus compact per-cell elevation/material/overlays. Cached by ETag (template id + template_version).
         * @summary Get 3D scene for template
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesSceneRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('tacticalmapTemplatesSceneRetrieve', 'id', id)
            const localVarPath = `/api/tacticalmap/templates/{id}/scene/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update all fields of existing template
         * @summary Update tactical map template
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {TacticalMapTemplateCreateRequest} tacticalMapTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesUpdate: async (id: string, tacticalMapTemplateCreateRequest: TacticalMapTemplateCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('tacticalmapTemplatesUpdate', 'id', id)
            // verify required parameter 'tacticalMapTemplateCreateRequest' is not null or undefined
            assertParamExists('tacticalmapTemplatesUpdate', 'tacticalMapTemplateCreateRequest', tacticalMapTemplateCreateRequest)
            const localVarPath = `/api/tacticalmap/templates/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tacticalMapTemplateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate PNG file metadata without creating template. Useful for checking file before import.
         * @summary Validate PNG metadata
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesValidatePngCreate: async (file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tacticalmap/templates/validate_png/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TacticalMapTemplatesApi - functional programming interface
 * @export
 */
export const TacticalMapTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TacticalMapTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create new template via JSON. Use import_png for PNG uploads.
         * @summary Create tactical map template
         * @param {TacticalMapTemplateCreateRequest} tacticalMapTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapTemplatesCreate(tacticalMapTemplateCreateRequest: TacticalMapTemplateCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TacticalMapTemplateCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapTemplatesCreate(tacticalMapTemplateCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalMapTemplatesApi.tacticalmapTemplatesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete template (admin only)
         * @summary Delete template
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapTemplatesDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapTemplatesDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalMapTemplatesApi.tacticalmapTemplatesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export tactical map template as PNG with embedded metadata. Returns PNG file with map data in tEXt chunk.
         * @summary Export template as PNG
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapTemplatesExportPngRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapTemplatesExportPngRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalMapTemplatesApi.tacticalmapTemplatesExportPngRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import a tactical map from PNG file with embedded JSON metadata. PNG must contain map data in tEXt chunk. Returns created template on success.
         * @summary Import PNG with metadata
         * @param {File} [file] 
         * @param {string | null} [overrideName] 
         * @param {boolean} [overridePublished] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapTemplatesImportPngCreate(file?: File, overrideName?: string | null, overridePublished?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TacticalMapTemplateDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapTemplatesImportPngCreate(file, overrideName, overridePublished, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalMapTemplatesApi.tacticalmapTemplatesImportPngCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve paginated list of tactical map templates with filtering
         * @summary List tactical map templates
         * @param {boolean} [canonical] 
         * @param {CategoryEnum} [category] Map category for organization  * &#x60;dungeon&#x60; - Dungeon * &#x60;wilderness&#x60; - Wilderness * &#x60;urban&#x60; - Urban * &#x60;indoor&#x60; - Indoor * &#x60;arena&#x60; - Arena * &#x60;ship&#x60; - Ship/Vehicle * &#x60;planar&#x60; - Planar/Dimensional * &#x60;custom&#x60; - Custom
         * @param {DifficultyRatingEnum} [difficultyRating] Challenge rating / difficulty level  * &#x60;easy&#x60; - Easy (CR 1-5) * &#x60;medium&#x60; - Medium (CR 6-10) * &#x60;hard&#x60; - Hard (CR 11-15) * &#x60;deadly&#x60; - Deadly (CR 16+) * &#x60;custom&#x60; - Custom
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {boolean} [published] 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapTemplatesList(canonical?: boolean, category?: CategoryEnum, difficultyRating?: DifficultyRatingEnum, ordering?: string, published?: boolean, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TacticalMapTemplateList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapTemplatesList(canonical, category, difficultyRating, ordering, published, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalMapTemplatesApi.tacticalmapTemplatesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update specific fields of template
         * @summary Partially update template
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {PatchedTacticalMapTemplateCreateRequest} [patchedTacticalMapTemplateCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapTemplatesPartialUpdate(id: string, patchedTacticalMapTemplateCreateRequest?: PatchedTacticalMapTemplateCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TacticalMapTemplateCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapTemplatesPartialUpdate(id, patchedTacticalMapTemplateCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalMapTemplatesApi.tacticalmapTemplatesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed information about a specific template including full map_data
         * @summary Get tactical map template details
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapTemplatesRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TacticalMapTemplateDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapTemplatesRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalMapTemplatesApi.tacticalmapTemplatesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * v3 scene keys plus compact per-cell elevation/material/overlays. Cached by ETag (template id + template_version).
         * @summary Get 3D scene for template
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapTemplatesSceneRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TacticalScene3D>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapTemplatesSceneRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalMapTemplatesApi.tacticalmapTemplatesSceneRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update all fields of existing template
         * @summary Update tactical map template
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {TacticalMapTemplateCreateRequest} tacticalMapTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapTemplatesUpdate(id: string, tacticalMapTemplateCreateRequest: TacticalMapTemplateCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TacticalMapTemplateCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapTemplatesUpdate(id, tacticalMapTemplateCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalMapTemplatesApi.tacticalmapTemplatesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate PNG file metadata without creating template. Useful for checking file before import.
         * @summary Validate PNG metadata
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapTemplatesValidatePngCreate(file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapTemplatesValidatePngCreate(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalMapTemplatesApi.tacticalmapTemplatesValidatePngCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TacticalMapTemplatesApi - factory interface
 * @export
 */
export const TacticalMapTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TacticalMapTemplatesApiFp(configuration)
    return {
        /**
         * Create new template via JSON. Use import_png for PNG uploads.
         * @summary Create tactical map template
         * @param {TacticalMapTemplateCreateRequest} tacticalMapTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesCreate(tacticalMapTemplateCreateRequest: TacticalMapTemplateCreateRequest, options?: any): AxiosPromise<TacticalMapTemplateCreate> {
            return localVarFp.tacticalmapTemplatesCreate(tacticalMapTemplateCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete template (admin only)
         * @summary Delete template
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesDestroy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.tacticalmapTemplatesDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Export tactical map template as PNG with embedded metadata. Returns PNG file with map data in tEXt chunk.
         * @summary Export template as PNG
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesExportPngRetrieve(id: string, options?: any): AxiosPromise<File> {
            return localVarFp.tacticalmapTemplatesExportPngRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Import a tactical map from PNG file with embedded JSON metadata. PNG must contain map data in tEXt chunk. Returns created template on success.
         * @summary Import PNG with metadata
         * @param {File} [file] 
         * @param {string | null} [overrideName] 
         * @param {boolean} [overridePublished] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesImportPngCreate(file?: File, overrideName?: string | null, overridePublished?: boolean, options?: any): AxiosPromise<TacticalMapTemplateDetail> {
            return localVarFp.tacticalmapTemplatesImportPngCreate(file, overrideName, overridePublished, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve paginated list of tactical map templates with filtering
         * @summary List tactical map templates
         * @param {boolean} [canonical] 
         * @param {CategoryEnum} [category] Map category for organization  * &#x60;dungeon&#x60; - Dungeon * &#x60;wilderness&#x60; - Wilderness * &#x60;urban&#x60; - Urban * &#x60;indoor&#x60; - Indoor * &#x60;arena&#x60; - Arena * &#x60;ship&#x60; - Ship/Vehicle * &#x60;planar&#x60; - Planar/Dimensional * &#x60;custom&#x60; - Custom
         * @param {DifficultyRatingEnum} [difficultyRating] Challenge rating / difficulty level  * &#x60;easy&#x60; - Easy (CR 1-5) * &#x60;medium&#x60; - Medium (CR 6-10) * &#x60;hard&#x60; - Hard (CR 11-15) * &#x60;deadly&#x60; - Deadly (CR 16+) * &#x60;custom&#x60; - Custom
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {boolean} [published] 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesList(canonical?: boolean, category?: CategoryEnum, difficultyRating?: DifficultyRatingEnum, ordering?: string, published?: boolean, search?: string, options?: any): AxiosPromise<Array<TacticalMapTemplateList>> {
            return localVarFp.tacticalmapTemplatesList(canonical, category, difficultyRating, ordering, published, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Update specific fields of template
         * @summary Partially update template
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {PatchedTacticalMapTemplateCreateRequest} [patchedTacticalMapTemplateCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesPartialUpdate(id: string, patchedTacticalMapTemplateCreateRequest?: PatchedTacticalMapTemplateCreateRequest, options?: any): AxiosPromise<TacticalMapTemplateCreate> {
            return localVarFp.tacticalmapTemplatesPartialUpdate(id, patchedTacticalMapTemplateCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed information about a specific template including full map_data
         * @summary Get tactical map template details
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesRetrieve(id: string, options?: any): AxiosPromise<TacticalMapTemplateDetail> {
            return localVarFp.tacticalmapTemplatesRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * v3 scene keys plus compact per-cell elevation/material/overlays. Cached by ETag (template id + template_version).
         * @summary Get 3D scene for template
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesSceneRetrieve(id: string, options?: any): AxiosPromise<TacticalScene3D> {
            return localVarFp.tacticalmapTemplatesSceneRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update all fields of existing template
         * @summary Update tactical map template
         * @param {string} id A UUID string identifying this tactical map template.
         * @param {TacticalMapTemplateCreateRequest} tacticalMapTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesUpdate(id: string, tacticalMapTemplateCreateRequest: TacticalMapTemplateCreateRequest, options?: any): AxiosPromise<TacticalMapTemplateCreate> {
            return localVarFp.tacticalmapTemplatesUpdate(id, tacticalMapTemplateCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate PNG file metadata without creating template. Useful for checking file before import.
         * @summary Validate PNG metadata
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapTemplatesValidatePngCreate(file?: File, options?: any): AxiosPromise<any> {
            return localVarFp.tacticalmapTemplatesValidatePngCreate(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TacticalMapTemplatesApi - object-oriented interface
 * @export
 * @class TacticalMapTemplatesApi
 * @extends {BaseAPI}
 */
export class TacticalMapTemplatesApi extends BaseAPI {
    /**
     * Create new template via JSON. Use import_png for PNG uploads.
     * @summary Create tactical map template
     * @param {TacticalMapTemplateCreateRequest} tacticalMapTemplateCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalMapTemplatesApi
     */
    public tacticalmapTemplatesCreate(tacticalMapTemplateCreateRequest: TacticalMapTemplateCreateRequest, options?: RawAxiosRequestConfig) {
        return TacticalMapTemplatesApiFp(this.configuration).tacticalmapTemplatesCreate(tacticalMapTemplateCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete template (admin only)
     * @summary Delete template
     * @param {string} id A UUID string identifying this tactical map template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalMapTemplatesApi
     */
    public tacticalmapTemplatesDestroy(id: string, options?: RawAxiosRequestConfig) {
        return TacticalMapTemplatesApiFp(this.configuration).tacticalmapTemplatesDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export tactical map template as PNG with embedded metadata. Returns PNG file with map data in tEXt chunk.
     * @summary Export template as PNG
     * @param {string} id A UUID string identifying this tactical map template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalMapTemplatesApi
     */
    public tacticalmapTemplatesExportPngRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return TacticalMapTemplatesApiFp(this.configuration).tacticalmapTemplatesExportPngRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import a tactical map from PNG file with embedded JSON metadata. PNG must contain map data in tEXt chunk. Returns created template on success.
     * @summary Import PNG with metadata
     * @param {File} [file] 
     * @param {string | null} [overrideName] 
     * @param {boolean} [overridePublished] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalMapTemplatesApi
     */
    public tacticalmapTemplatesImportPngCreate(file?: File, overrideName?: string | null, overridePublished?: boolean, options?: RawAxiosRequestConfig) {
        return TacticalMapTemplatesApiFp(this.configuration).tacticalmapTemplatesImportPngCreate(file, overrideName, overridePublished, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve paginated list of tactical map templates with filtering
     * @summary List tactical map templates
     * @param {boolean} [canonical] 
     * @param {CategoryEnum} [category] Map category for organization  * &#x60;dungeon&#x60; - Dungeon * &#x60;wilderness&#x60; - Wilderness * &#x60;urban&#x60; - Urban * &#x60;indoor&#x60; - Indoor * &#x60;arena&#x60; - Arena * &#x60;ship&#x60; - Ship/Vehicle * &#x60;planar&#x60; - Planar/Dimensional * &#x60;custom&#x60; - Custom
     * @param {DifficultyRatingEnum} [difficultyRating] Challenge rating / difficulty level  * &#x60;easy&#x60; - Easy (CR 1-5) * &#x60;medium&#x60; - Medium (CR 6-10) * &#x60;hard&#x60; - Hard (CR 11-15) * &#x60;deadly&#x60; - Deadly (CR 16+) * &#x60;custom&#x60; - Custom
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {boolean} [published] 
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalMapTemplatesApi
     */
    public tacticalmapTemplatesList(canonical?: boolean, category?: CategoryEnum, difficultyRating?: DifficultyRatingEnum, ordering?: string, published?: boolean, search?: string, options?: RawAxiosRequestConfig) {
        return TacticalMapTemplatesApiFp(this.configuration).tacticalmapTemplatesList(canonical, category, difficultyRating, ordering, published, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update specific fields of template
     * @summary Partially update template
     * @param {string} id A UUID string identifying this tactical map template.
     * @param {PatchedTacticalMapTemplateCreateRequest} [patchedTacticalMapTemplateCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalMapTemplatesApi
     */
    public tacticalmapTemplatesPartialUpdate(id: string, patchedTacticalMapTemplateCreateRequest?: PatchedTacticalMapTemplateCreateRequest, options?: RawAxiosRequestConfig) {
        return TacticalMapTemplatesApiFp(this.configuration).tacticalmapTemplatesPartialUpdate(id, patchedTacticalMapTemplateCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed information about a specific template including full map_data
     * @summary Get tactical map template details
     * @param {string} id A UUID string identifying this tactical map template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalMapTemplatesApi
     */
    public tacticalmapTemplatesRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return TacticalMapTemplatesApiFp(this.configuration).tacticalmapTemplatesRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * v3 scene keys plus compact per-cell elevation/material/overlays. Cached by ETag (template id + template_version).
     * @summary Get 3D scene for template
     * @param {string} id A UUID string identifying this tactical map template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalMapTemplatesApi
     */
    public tacticalmapTemplatesSceneRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return TacticalMapTemplatesApiFp(this.configuration).tacticalmapTemplatesSceneRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update all fields of existing template
     * @summary Update tactical map template
     * @param {string} id A UUID string identifying this tactical map template.
     * @param {TacticalMapTemplateCreateRequest} tacticalMapTemplateCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalMapTemplatesApi
     */
    public tacticalmapTemplatesUpdate(id: string, tacticalMapTemplateCreateRequest: TacticalMapTemplateCreateRequest, options?: RawAxiosRequestConfig) {
        return TacticalMapTemplatesApiFp(this.configuration).tacticalmapTemplatesUpdate(id, tacticalMapTemplateCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate PNG file metadata without creating template. Useful for checking file before import.
     * @summary Validate PNG metadata
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalMapTemplatesApi
     */
    public tacticalmapTemplatesValidatePngCreate(file?: File, options?: RawAxiosRequestConfig) {
        return TacticalMapTemplatesApiFp(this.configuration).tacticalmapTemplatesValidatePngCreate(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TacticalmapApi - axios parameter creator
 * @export
 */
export const TacticalmapApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *          Auto-detects the current character from request.user.main_character         and returns the tactical map where that character is currently located.          Filters based on fog of war - only shows GameObjects standing on cells the         character\'s party can see. Sight is base 5 cells + FLOW_RESONANCE / 12,         adjusted by active effects, and is shared with every living ally of the same         organization on the map. Sight limits what is shown only: a character can         move and attack beyond it, and a blinded one still acts normally.          Filters out GM-specific data like spawners and GM notes.          Response includes:         - Background image URL         - Grid settings (dimensions, cell sizes)         - Spawned game objects grouped by tactical position (FOW filtered)         - Movement edges between grid cells         - Vision block: own sight radius, blindness flag, every ally sight source,           and the cells the party can currently see          Error Codes:         - 400: User has no main character         - 404: Character not on tactical map or no map found at position         
         * @summary Get current tactical map for player\'s character
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapPlayerCurrentRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tacticalmap/player/current/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Player-focused tactical map endpoints.  Provides filtered views with fog of war based on character vision. Automatically detects the current character from request.user.main_character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapPlayerList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tacticalmap/player/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Player-focused tactical map endpoints.  Provides filtered views with fog of war based on character vision. Automatically detects the current character from request.user.main_character.
         * @param {string} id A UUID string identifying this tactical map.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapPlayerRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('tacticalmapPlayerRetrieve', 'id', id)
            const localVarPath = `/api/tacticalmap/player/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *          Auto-detects the current character from request.user.main_character         and returns their tactical combat information.          Response includes:         - Character ID         - Movement range (max AP / 2 - 1)         - Movement remaining (current AP / 2 - 1)         - Vision range for fog of war         - Current X, Y position on tactical grid          Error Codes:         - 400: User has no main character         - 404: Character has no tactical position         
         * @summary Get tactical info for player\'s character
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapPlayerTacticalInfoRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tacticalmap/player/tactical-info/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TacticalmapApi - functional programming interface
 * @export
 */
export const TacticalmapApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TacticalmapApiAxiosParamCreator(configuration)
    return {
        /**
         *          Auto-detects the current character from request.user.main_character         and returns the tactical map where that character is currently located.          Filters based on fog of war - only shows GameObjects standing on cells the         character\'s party can see. Sight is base 5 cells + FLOW_RESONANCE / 12,         adjusted by active effects, and is shared with every living ally of the same         organization on the map. Sight limits what is shown only: a character can         move and attack beyond it, and a blinded one still acts normally.          Filters out GM-specific data like spawners and GM notes.          Response includes:         - Background image URL         - Grid settings (dimensions, cell sizes)         - Spawned game objects grouped by tactical position (FOW filtered)         - Movement edges between grid cells         - Vision block: own sight radius, blindness flag, every ally sight source,           and the cells the party can currently see          Error Codes:         - 400: User has no main character         - 404: Character not on tactical map or no map found at position         
         * @summary Get current tactical map for player\'s character
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapPlayerCurrentRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlayerTacticalMap>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapPlayerCurrentRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalmapApi.tacticalmapPlayerCurrentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Player-focused tactical map endpoints.  Provides filtered views with fog of war based on character vision. Automatically detects the current character from request.user.main_character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapPlayerList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlayerTacticalMap>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapPlayerList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalmapApi.tacticalmapPlayerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Player-focused tactical map endpoints.  Provides filtered views with fog of war based on character vision. Automatically detects the current character from request.user.main_character.
         * @param {string} id A UUID string identifying this tactical map.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapPlayerRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlayerTacticalMap>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapPlayerRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalmapApi.tacticalmapPlayerRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *          Auto-detects the current character from request.user.main_character         and returns their tactical combat information.          Response includes:         - Character ID         - Movement range (max AP / 2 - 1)         - Movement remaining (current AP / 2 - 1)         - Vision range for fog of war         - Current X, Y position on tactical grid          Error Codes:         - 400: User has no main character         - 404: Character has no tactical position         
         * @summary Get tactical info for player\'s character
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tacticalmapPlayerTacticalInfoRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TacticalCharacterInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tacticalmapPlayerTacticalInfoRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TacticalmapApi.tacticalmapPlayerTacticalInfoRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TacticalmapApi - factory interface
 * @export
 */
export const TacticalmapApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TacticalmapApiFp(configuration)
    return {
        /**
         *          Auto-detects the current character from request.user.main_character         and returns the tactical map where that character is currently located.          Filters based on fog of war - only shows GameObjects standing on cells the         character\'s party can see. Sight is base 5 cells + FLOW_RESONANCE / 12,         adjusted by active effects, and is shared with every living ally of the same         organization on the map. Sight limits what is shown only: a character can         move and attack beyond it, and a blinded one still acts normally.          Filters out GM-specific data like spawners and GM notes.          Response includes:         - Background image URL         - Grid settings (dimensions, cell sizes)         - Spawned game objects grouped by tactical position (FOW filtered)         - Movement edges between grid cells         - Vision block: own sight radius, blindness flag, every ally sight source,           and the cells the party can currently see          Error Codes:         - 400: User has no main character         - 404: Character not on tactical map or no map found at position         
         * @summary Get current tactical map for player\'s character
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapPlayerCurrentRetrieve(options?: any): AxiosPromise<PlayerTacticalMap> {
            return localVarFp.tacticalmapPlayerCurrentRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Player-focused tactical map endpoints.  Provides filtered views with fog of war based on character vision. Automatically detects the current character from request.user.main_character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapPlayerList(options?: any): AxiosPromise<Array<PlayerTacticalMap>> {
            return localVarFp.tacticalmapPlayerList(options).then((request) => request(axios, basePath));
        },
        /**
         * Player-focused tactical map endpoints.  Provides filtered views with fog of war based on character vision. Automatically detects the current character from request.user.main_character.
         * @param {string} id A UUID string identifying this tactical map.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapPlayerRetrieve(id: string, options?: any): AxiosPromise<PlayerTacticalMap> {
            return localVarFp.tacticalmapPlayerRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         *          Auto-detects the current character from request.user.main_character         and returns their tactical combat information.          Response includes:         - Character ID         - Movement range (max AP / 2 - 1)         - Movement remaining (current AP / 2 - 1)         - Vision range for fog of war         - Current X, Y position on tactical grid          Error Codes:         - 400: User has no main character         - 404: Character has no tactical position         
         * @summary Get tactical info for player\'s character
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tacticalmapPlayerTacticalInfoRetrieve(options?: any): AxiosPromise<TacticalCharacterInfo> {
            return localVarFp.tacticalmapPlayerTacticalInfoRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TacticalmapApi - object-oriented interface
 * @export
 * @class TacticalmapApi
 * @extends {BaseAPI}
 */
export class TacticalmapApi extends BaseAPI {
    /**
     *          Auto-detects the current character from request.user.main_character         and returns the tactical map where that character is currently located.          Filters based on fog of war - only shows GameObjects standing on cells the         character\'s party can see. Sight is base 5 cells + FLOW_RESONANCE / 12,         adjusted by active effects, and is shared with every living ally of the same         organization on the map. Sight limits what is shown only: a character can         move and attack beyond it, and a blinded one still acts normally.          Filters out GM-specific data like spawners and GM notes.          Response includes:         - Background image URL         - Grid settings (dimensions, cell sizes)         - Spawned game objects grouped by tactical position (FOW filtered)         - Movement edges between grid cells         - Vision block: own sight radius, blindness flag, every ally sight source,           and the cells the party can currently see          Error Codes:         - 400: User has no main character         - 404: Character not on tactical map or no map found at position         
     * @summary Get current tactical map for player\'s character
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalmapApi
     */
    public tacticalmapPlayerCurrentRetrieve(options?: RawAxiosRequestConfig) {
        return TacticalmapApiFp(this.configuration).tacticalmapPlayerCurrentRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Player-focused tactical map endpoints.  Provides filtered views with fog of war based on character vision. Automatically detects the current character from request.user.main_character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalmapApi
     */
    public tacticalmapPlayerList(options?: RawAxiosRequestConfig) {
        return TacticalmapApiFp(this.configuration).tacticalmapPlayerList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Player-focused tactical map endpoints.  Provides filtered views with fog of war based on character vision. Automatically detects the current character from request.user.main_character.
     * @param {string} id A UUID string identifying this tactical map.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalmapApi
     */
    public tacticalmapPlayerRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return TacticalmapApiFp(this.configuration).tacticalmapPlayerRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *          Auto-detects the current character from request.user.main_character         and returns their tactical combat information.          Response includes:         - Character ID         - Movement range (max AP / 2 - 1)         - Movement remaining (current AP / 2 - 1)         - Vision range for fog of war         - Current X, Y position on tactical grid          Error Codes:         - 400: User has no main character         - 404: Character has no tactical position         
     * @summary Get tactical info for player\'s character
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TacticalmapApi
     */
    public tacticalmapPlayerTacticalInfoRetrieve(options?: RawAxiosRequestConfig) {
        return TacticalmapApiFp(this.configuration).tacticalmapPlayerTacticalInfoRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorldApi - axios parameter creator
 * @export
 */
export const WorldApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldAreasCurrentRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/areas/current/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldAreasList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/areas/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldAreasRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('worldAreasRetrieve', 'id', id)
            const localVarPath = `/api/world/areas/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldCitiesCurrentRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/cities/current/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldCitiesList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/cities/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this city.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldCitiesRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('worldCitiesRetrieve', 'id', id)
            const localVarPath = `/api/world/cities/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldDimensionsCurrentRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/dimensions/current/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldDimensionsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/dimensions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique value identifying this dimension.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldDimensionsRetrieve: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('worldDimensionsRetrieve', 'id', id)
            const localVarPath = `/api/world/dimensions/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldLocationsChangeCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('worldLocationsChangeCreate', 'id', id)
            const localVarPath = `/api/world/locations/{id}/change/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldLocationsCurrentRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/locations/current/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldLocationsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/locations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldLocationsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('worldLocationsRetrieve', 'id', id)
            const localVarPath = `/api/world/locations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMappedPositionList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/mapped-position/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NewCoordinatesRequest} newCoordinatesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMappedPositionMapPositionCreate: async (newCoordinatesRequest: NewCoordinatesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newCoordinatesRequest' is not null or undefined
            assertParamExists('worldMappedPositionMapPositionCreate', 'newCoordinatesRequest', newCoordinatesRequest)
            const localVarPath = `/api/world/mapped-position/map_position/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newCoordinatesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this map position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMappedPositionRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('worldMappedPositionRetrieve', 'id', id)
            const localVarPath = `/api/world/mapped-position/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the mini map of the current organization.  Requires an equipped Cartograph artifact, like every other map endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMapsMiniMapRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/maps/mini_map/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NewCoordinatesRequest} newCoordinatesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMapsPositionAddCreate: async (newCoordinatesRequest: NewCoordinatesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newCoordinatesRequest' is not null or undefined
            assertParamExists('worldMapsPositionAddCreate', 'newCoordinatesRequest', newCoordinatesRequest)
            const localVarPath = `/api/world/maps/position_add/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newCoordinatesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenericPositionIdRequest} genericPositionIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMapsPositionRemoveCreate: async (genericPositionIdRequest: GenericPositionIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'genericPositionIdRequest' is not null or undefined
            assertParamExists('worldMapsPositionRemoveCreate', 'genericPositionIdRequest', genericPositionIdRequest)
            const localVarPath = `/api/world/maps/position_remove/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(genericPositionIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MapPositionMutableRequest} mapPositionMutableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMapsPositionUpdateCreate: async (mapPositionMutableRequest: MapPositionMutableRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mapPositionMutableRequest' is not null or undefined
            assertParamExists('worldMapsPositionUpdateCreate', 'mapPositionMutableRequest', mapPositionMutableRequest)
            const localVarPath = `/api/world/maps/position_update/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mapPositionMutableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the world map of the current organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMapsWorldMapRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/maps/world_map/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the current position of the character and possible movements.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldPositionCurrentRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/position/current/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldPositionInfoRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('worldPositionInfoRetrieve', 'id', id)
            const localVarPath = `/api/world/position/{id}/info/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the map of the current location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldPositionMapRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/position/map/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldPositionMoveToPositionCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('worldPositionMoveToPositionCreate', 'id', id)
            const localVarPath = `/api/world/position/{id}/move_to_position/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {TeleportCoordinatesRequest} teleportCoordinatesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldPositionTeleportToCoordinatesCreate: async (id: string, teleportCoordinatesRequest: TeleportCoordinatesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('worldPositionTeleportToCoordinatesCreate', 'id', id)
            // verify required parameter 'teleportCoordinatesRequest' is not null or undefined
            assertParamExists('worldPositionTeleportToCoordinatesCreate', 'teleportCoordinatesRequest', teleportCoordinatesRequest)
            const localVarPath = `/api/world/position/{id}/teleport_to_coordinates/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teleportCoordinatesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {TeleportPositionRequest} teleportPositionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldPositionTeleportToPositionCreate: async (id: string, teleportPositionRequest: TeleportPositionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('worldPositionTeleportToPositionCreate', 'id', id)
            // verify required parameter 'teleportPositionRequest' is not null or undefined
            assertParamExists('worldPositionTeleportToPositionCreate', 'teleportPositionRequest', teleportPositionRequest)
            const localVarPath = `/api/world/position/{id}/teleport_to_position/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teleportPositionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the transition set for wherever the character currently stands.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldTransitionImagesCurrentList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/world/transition-images/current/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorldApi - functional programming interface
 * @export
 */
export const WorldApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorldApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldAreasCurrentRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Area>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldAreasCurrentRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldAreasCurrentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldAreasList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Area>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldAreasList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldAreasList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldAreasRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Area>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldAreasRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldAreasRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldCitiesCurrentRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<City>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldCitiesCurrentRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldCitiesCurrentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldCitiesList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<City>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldCitiesList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldCitiesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this city.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldCitiesRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<City>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldCitiesRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldCitiesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldDimensionsCurrentRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dimension>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldDimensionsCurrentRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldDimensionsCurrentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldDimensionsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Dimension>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldDimensionsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldDimensionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id A unique value identifying this dimension.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldDimensionsRetrieve(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dimension>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldDimensionsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldDimensionsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldLocationsChangeCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldLocationsChangeCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldLocationsChangeCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldLocationsCurrentRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldLocationsCurrentRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldLocationsCurrentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldLocationsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Location>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldLocationsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldLocationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldLocationsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldLocationsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldLocationsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldMappedPositionList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MapPosition>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldMappedPositionList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldMappedPositionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NewCoordinatesRequest} newCoordinatesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldMappedPositionMapPositionCreate(newCoordinatesRequest: NewCoordinatesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MapPosition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldMappedPositionMapPositionCreate(newCoordinatesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldMappedPositionMapPositionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this map position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldMappedPositionRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MapPosition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldMappedPositionRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldMappedPositionRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the mini map of the current organization.  Requires an equipped Cartograph artifact, like every other map endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldMapsMiniMapRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MiniMap>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldMapsMiniMapRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldMapsMiniMapRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NewCoordinatesRequest} newCoordinatesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldMapsPositionAddCreate(newCoordinatesRequest: NewCoordinatesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MapPosition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldMapsPositionAddCreate(newCoordinatesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldMapsPositionAddCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GenericPositionIdRequest} genericPositionIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldMapsPositionRemoveCreate(genericPositionIdRequest: GenericPositionIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericPositionId>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldMapsPositionRemoveCreate(genericPositionIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldMapsPositionRemoveCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MapPositionMutableRequest} mapPositionMutableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldMapsPositionUpdateCreate(mapPositionMutableRequest: MapPositionMutableRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldMapsPositionUpdateCreate(mapPositionMutableRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldMapsPositionUpdateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the world map of the current organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldMapsWorldMapRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldMapsWorldMapRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldMapsWorldMapRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the current position of the character and possible movements.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldPositionCurrentRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorldPosition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldPositionCurrentRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldPositionCurrentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldPositionInfoRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorldPosition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldPositionInfoRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldPositionInfoRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the map of the current location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldPositionMapRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorldPosition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldPositionMapRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldPositionMapRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldPositionMoveToPositionCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldPositionMoveToPositionCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldPositionMoveToPositionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {TeleportCoordinatesRequest} teleportCoordinatesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldPositionTeleportToCoordinatesCreate(id: string, teleportCoordinatesRequest: TeleportCoordinatesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeleportCoordinates>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldPositionTeleportToCoordinatesCreate(id, teleportCoordinatesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldPositionTeleportToCoordinatesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {TeleportPositionRequest} teleportPositionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldPositionTeleportToPositionCreate(id: string, teleportPositionRequest: TeleportPositionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeleportPosition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldPositionTeleportToPositionCreate(id, teleportPositionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldPositionTeleportToPositionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the transition set for wherever the character currently stands.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async worldTransitionImagesCurrentList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransitionImage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.worldTransitionImagesCurrentList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorldApi.worldTransitionImagesCurrentList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorldApi - factory interface
 * @export
 */
export const WorldApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorldApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldAreasCurrentRetrieve(options?: any): AxiosPromise<Area> {
            return localVarFp.worldAreasCurrentRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldAreasList(options?: any): AxiosPromise<Array<Area>> {
            return localVarFp.worldAreasList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldAreasRetrieve(id: string, options?: any): AxiosPromise<Area> {
            return localVarFp.worldAreasRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldCitiesCurrentRetrieve(options?: any): AxiosPromise<City> {
            return localVarFp.worldCitiesCurrentRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldCitiesList(options?: any): AxiosPromise<Array<City>> {
            return localVarFp.worldCitiesList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this city.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldCitiesRetrieve(id: string, options?: any): AxiosPromise<City> {
            return localVarFp.worldCitiesRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldDimensionsCurrentRetrieve(options?: any): AxiosPromise<Dimension> {
            return localVarFp.worldDimensionsCurrentRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldDimensionsList(options?: any): AxiosPromise<Array<Dimension>> {
            return localVarFp.worldDimensionsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique value identifying this dimension.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldDimensionsRetrieve(id: number, options?: any): AxiosPromise<Dimension> {
            return localVarFp.worldDimensionsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldLocationsChangeCreate(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.worldLocationsChangeCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldLocationsCurrentRetrieve(options?: any): AxiosPromise<Location> {
            return localVarFp.worldLocationsCurrentRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldLocationsList(options?: any): AxiosPromise<Array<Location>> {
            return localVarFp.worldLocationsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldLocationsRetrieve(id: string, options?: any): AxiosPromise<Location> {
            return localVarFp.worldLocationsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMappedPositionList(options?: any): AxiosPromise<Array<MapPosition>> {
            return localVarFp.worldMappedPositionList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NewCoordinatesRequest} newCoordinatesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMappedPositionMapPositionCreate(newCoordinatesRequest: NewCoordinatesRequest, options?: any): AxiosPromise<MapPosition> {
            return localVarFp.worldMappedPositionMapPositionCreate(newCoordinatesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this map position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMappedPositionRetrieve(id: string, options?: any): AxiosPromise<MapPosition> {
            return localVarFp.worldMappedPositionRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the mini map of the current organization.  Requires an equipped Cartograph artifact, like every other map endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMapsMiniMapRetrieve(options?: any): AxiosPromise<MiniMap> {
            return localVarFp.worldMapsMiniMapRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NewCoordinatesRequest} newCoordinatesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMapsPositionAddCreate(newCoordinatesRequest: NewCoordinatesRequest, options?: any): AxiosPromise<MapPosition> {
            return localVarFp.worldMapsPositionAddCreate(newCoordinatesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GenericPositionIdRequest} genericPositionIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMapsPositionRemoveCreate(genericPositionIdRequest: GenericPositionIdRequest, options?: any): AxiosPromise<GenericPositionId> {
            return localVarFp.worldMapsPositionRemoveCreate(genericPositionIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MapPositionMutableRequest} mapPositionMutableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMapsPositionUpdateCreate(mapPositionMutableRequest: MapPositionMutableRequest, options?: any): AxiosPromise<any> {
            return localVarFp.worldMapsPositionUpdateCreate(mapPositionMutableRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the world map of the current organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldMapsWorldMapRetrieve(options?: any): AxiosPromise<any> {
            return localVarFp.worldMapsWorldMapRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Return the current position of the character and possible movements.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldPositionCurrentRetrieve(options?: any): AxiosPromise<WorldPosition> {
            return localVarFp.worldPositionCurrentRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldPositionInfoRetrieve(id: string, options?: any): AxiosPromise<WorldPosition> {
            return localVarFp.worldPositionInfoRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the map of the current location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldPositionMapRetrieve(options?: any): AxiosPromise<WorldPosition> {
            return localVarFp.worldPositionMapRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldPositionMoveToPositionCreate(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.worldPositionMoveToPositionCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {TeleportCoordinatesRequest} teleportCoordinatesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldPositionTeleportToCoordinatesCreate(id: string, teleportCoordinatesRequest: TeleportCoordinatesRequest, options?: any): AxiosPromise<TeleportCoordinates> {
            return localVarFp.worldPositionTeleportToCoordinatesCreate(id, teleportCoordinatesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this character.
         * @param {TeleportPositionRequest} teleportPositionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldPositionTeleportToPositionCreate(id: string, teleportPositionRequest: TeleportPositionRequest, options?: any): AxiosPromise<TeleportPosition> {
            return localVarFp.worldPositionTeleportToPositionCreate(id, teleportPositionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the transition set for wherever the character currently stands.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        worldTransitionImagesCurrentList(options?: any): AxiosPromise<Array<TransitionImage>> {
            return localVarFp.worldTransitionImagesCurrentList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorldApi - object-oriented interface
 * @export
 * @class WorldApi
 * @extends {BaseAPI}
 */
export class WorldApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldAreasCurrentRetrieve(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldAreasCurrentRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldAreasList(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldAreasList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this area.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldAreasRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldAreasRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldCitiesCurrentRetrieve(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldCitiesCurrentRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldCitiesList(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldCitiesList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this city.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldCitiesRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldCitiesRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldDimensionsCurrentRetrieve(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldDimensionsCurrentRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldDimensionsList(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldDimensionsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique value identifying this dimension.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldDimensionsRetrieve(id: number, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldDimensionsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this location.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldLocationsChangeCreate(id: string, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldLocationsChangeCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldLocationsCurrentRetrieve(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldLocationsCurrentRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldLocationsList(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldLocationsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this location.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldLocationsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldLocationsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldMappedPositionList(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldMappedPositionList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NewCoordinatesRequest} newCoordinatesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldMappedPositionMapPositionCreate(newCoordinatesRequest: NewCoordinatesRequest, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldMappedPositionMapPositionCreate(newCoordinatesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this map position.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldMappedPositionRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldMappedPositionRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the mini map of the current organization.  Requires an equipped Cartograph artifact, like every other map endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldMapsMiniMapRetrieve(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldMapsMiniMapRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NewCoordinatesRequest} newCoordinatesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldMapsPositionAddCreate(newCoordinatesRequest: NewCoordinatesRequest, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldMapsPositionAddCreate(newCoordinatesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GenericPositionIdRequest} genericPositionIdRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldMapsPositionRemoveCreate(genericPositionIdRequest: GenericPositionIdRequest, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldMapsPositionRemoveCreate(genericPositionIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MapPositionMutableRequest} mapPositionMutableRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldMapsPositionUpdateCreate(mapPositionMutableRequest: MapPositionMutableRequest, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldMapsPositionUpdateCreate(mapPositionMutableRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the world map of the current organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldMapsWorldMapRetrieve(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldMapsWorldMapRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the current position of the character and possible movements.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldPositionCurrentRetrieve(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldPositionCurrentRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldPositionInfoRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldPositionInfoRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the map of the current location.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldPositionMapRetrieve(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldPositionMapRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldPositionMoveToPositionCreate(id: string, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldPositionMoveToPositionCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character.
     * @param {TeleportCoordinatesRequest} teleportCoordinatesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldPositionTeleportToCoordinatesCreate(id: string, teleportCoordinatesRequest: TeleportCoordinatesRequest, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldPositionTeleportToCoordinatesCreate(id, teleportCoordinatesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this character.
     * @param {TeleportPositionRequest} teleportPositionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldPositionTeleportToPositionCreate(id: string, teleportPositionRequest: TeleportPositionRequest, options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldPositionTeleportToPositionCreate(id, teleportPositionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the transition set for wherever the character currently stands.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorldApi
     */
    public worldTransitionImagesCurrentList(options?: RawAxiosRequestConfig) {
        return WorldApiFp(this.configuration).worldTransitionImagesCurrentList(options).then((request) => request(this.axios, this.basePath));
    }
}



